! function(t) {
    function e(r) { if (n[r]) return n[r].exports; var i = n[r] = { exports: {}, id: r, loaded: !1 }; return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports }
    var n = {};
    return e.m = t, e.c = n, e.p = "", e(0)
}([function(t, e, n) { t.exports = n(124) }, function(t, e, n) {
    var r = n(7),
        i = n(23),
        o = n(19),
        c = n(14),
        u = n(17),
        a = "prototype",
        s = function(t, e, n) {
            var f, l, h, p, v = t & s.F,
                d = t & s.G,
                g = t & s.S,
                y = t & s.P,
                m = t & s.B,
                b = d ? r : g ? r[e] || (r[e] = {}) : (r[e] || {})[a],
                A = d ? i : i[e] || (i[e] = {}),
                S = A[a] || (A[a] = {});
            d && (n = e);
            for (f in n) l = !v && b && f in b, h = (l ? b : n)[f], p = m && l ? u(h, r) : y && "function" == typeof h ? u(Function.call, h) : h, b && !l && c(b, f, h), A[f] != h && o(A, f, p), y && S[f] != h && (S[f] = h)
        };
    r.core = i, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, t.exports = s
}, , function(t, e) {
    var n = Object;
    t.exports = { create: n.create, getProto: n.getPrototypeOf, isEnum: {}.propertyIsEnumerable, getDesc: n.getOwnPropertyDescriptor, setDesc: n.defineProperty, setDescs: n.defineProperties, getKeys: n.keys, getNames: n.getOwnPropertyNames, getSymbols: n.getOwnPropertySymbols, each: [].forEach }
}, function(t, e) { t.exports = function(t) { return "object" == typeof t ? null !== t : "function" == typeof t } }, function(t, e, n) {
    var r = n(4);
    t.exports = function(t) { if (!r(t)) throw TypeError(t + " is not an object!"); return t }
}, function(t, e, n) {
    var r = n(112)("wks"),
        i = n(29),
        o = n(7).Symbol;
    t.exports = function(t) { return r[t] || (r[t] = o && o[t] || (o || i)("Symbol." + t)) }
}, function(t, e) { var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(); "number" == typeof __g && (__g = n) }, , function(t, e) { t.exports = function(t) { try { return !!t() } catch (e) { return !0 } } }, function(t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function(t, e) { return n.call(t, e) }
}, function(t, e, n) {
    var r = n(42),
        i = Math.min;
    t.exports = function(t) { return t > 0 ? i(r(t), 9007199254740991) : 0 }
}, function(t, e, n) { t.exports = !n(9)(function() { return 7 != Object.defineProperty({}, "a", { get: function() { return 7 } }).a }) }, function(t, e, n) {
    var r = n(1),
        i = n(23),
        o = n(9);
    t.exports = function(t, e) {
        var n = (i.Object || {})[t] || Object[t],
            c = {};
        c[t] = e(n), r(r.S + r.F * o(function() { n(1) }), "Object", c)
    }
}, function(t, e, n) {
    var r = n(7),
        i = n(19),
        o = n(29)("src"),
        c = "toString",
        u = Function[c],
        a = ("" + u).split(c);
    n(23).inspectSource = function(t) { return u.call(t) }, (t.exports = function(t, e, n, c) { "function" == typeof n && (n.hasOwnProperty(o) || i(n, o, t[e] ? "" + t[e] : a.join(String(e))), n.hasOwnProperty("name") || i(n, "name", e)), t === r ? t[e] = n : (c || delete t[e], i(t, e, n)) })(Function.prototype, c, function() { return "function" == typeof this && this[o] || u.call(this) })
}, function(t, e, n) {
    var r = n(52),
        i = n(18);
    t.exports = function(t) { return r(i(t)) }
}, , function(t, e, n) {
    var r = n(27);
    t.exports = function(t, e, n) {
        if (r(t), void 0 === e) return t;
        switch (n) {
            case 1:
                return function(n) { return t.call(e, n) };
            case 2:
                return function(n, r) { return t.call(e, n, r) };
            case 3:
                return function(n, r, i) { return t.call(e, n, r, i) }
        }
        return function() { return t.apply(e, arguments) }
    }
}, function(t, e) { t.exports = function(t) { if (void 0 == t) throw TypeError("Can't call method on  " + t); return t } }, function(t, e, n) {
    var r = n(3),
        i = n(25);
    t.exports = n(12) ? function(t, e, n) { return r.setDesc(t, e, i(1, n)) } : function(t, e, n) { return t[e] = n, t }
}, , , function(t, e) {
    var n = {}.toString;
    t.exports = function(t) { return n.call(t).slice(8, -1) }
}, function(t, e) { var n = t.exports = { version: "1.2.6" }; "number" == typeof __e && (__e = n) }, function(t, e, n) {
    var r = n(18);
    t.exports = function(t) { return Object(r(t)) }
}, function(t, e) { t.exports = function(t, e) { return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e } } }, , function(t, e) { t.exports = function(t) { if ("function" != typeof t) throw TypeError(t + " is not a function!"); return t } }, function(t, e, n) {
    var r = n(6)("unscopables"),
        i = Array.prototype;
    void 0 == i[r] && n(19)(i, r, {}), t.exports = function(t) { i[r][t] = !0 }
}, function(t, e) {
    var n = 0,
        r = Math.random();
    t.exports = function(t) { return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36)) }
}, , , , , , , , , function(t, e, n) {
    var r = n(17),
        i = n(105),
        o = n(102),
        c = n(5),
        u = n(11),
        a = n(116);
    t.exports = function(t, e, n, s) {
        var f, l, h, p = a(t),
            v = r(n, s, e ? 2 : 1),
            d = 0;
        if ("function" != typeof p) throw TypeError(t + " is not iterable!");
        if (o(p))
            for (f = u(t.length); f > d; d++) e ? v(c(l = t[d])[0], l[1]) : v(t[d]);
        else
            for (h = p.call(t); !(l = h.next()).done;) i(h, v, l.value, e)
    }
}, function(t, e) { t.exports = {} }, function(t, e, n) {
    var r = n(3).setDesc,
        i = n(10),
        o = n(6)("toStringTag");
    t.exports = function(t, e, n) { t && !i(t = n ? t : t.prototype, o) && r(t, o, { configurable: !0, value: e }) }
}, function(t, e, n) {
    var r = n(42),
        i = Math.max,
        o = Math.min;
    t.exports = function(t, e) { return t = r(t), t < 0 ? i(t + e, 0) : o(t, e) }
}, function(t, e) {
    var n = Math.ceil,
        r = Math.floor;
    t.exports = function(t) { return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t) }
}, , , , , function(t, e, n) {
    var r = n(17),
        i = n(52),
        o = n(24),
        c = n(11),
        u = n(173);
    t.exports = function(t) {
        var e = 1 == t,
            n = 2 == t,
            a = 3 == t,
            s = 4 == t,
            f = 6 == t,
            l = 5 == t || f;
        return function(h, p, v) {
            for (var d, g, y = o(h), m = i(y), b = r(p, v, 3), A = c(m.length), S = 0, w = e ? u(h, A) : n ? u(h, 0) : void 0; A > S; S++)
                if ((l || S in m) && (d = m[S], g = b(d, S, y), t))
                    if (e) w[S] = g;
                    else if (g) switch (t) {
                case 3:
                    return !0;
                case 5:
                    return d;
                case 6:
                    return S;
                case 2:
                    w.push(d)
            } else if (s) return !1;
            return f ? -1 : a || s ? s : w
        }
    }
}, function(t, e, n) {
    var r = n(22),
        i = n(6)("toStringTag"),
        o = "Arguments" == r(function() { return arguments }());
    t.exports = function(t) { var e, n, c; return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof(n = (e = Object(t))[i]) ? n : o ? r(e) : "Object" == (c = r(e)) && "function" == typeof e.callee ? "Arguments" : c }
}, function(t, e, n) {
    "use strict";
    var r = n(7),
        i = n(1),
        o = n(14),
        c = n(53),
        u = n(38),
        a = n(55),
        s = n(4),
        f = n(9),
        l = n(81),
        h = n(40);
    t.exports = function(t, e, n, p, v, d) {
        var g = r[t],
            y = g,
            m = v ? "set" : "add",
            b = y && y.prototype,
            A = {},
            S = function(t) {
                var e = b[t];
                o(b, t, "delete" == t ? function(t) { return !(d && !s(t)) && e.call(this, 0 === t ? 0 : t) } : "has" == t ? function(t) { return !(d && !s(t)) && e.call(this, 0 === t ? 0 : t) } : "get" == t ? function(t) { return d && !s(t) ? void 0 : e.call(this, 0 === t ? 0 : t) } : "add" == t ? function(t) { return e.call(this, 0 === t ? 0 : t), this } : function(t, n) { return e.call(this, 0 === t ? 0 : t, n), this })
            };
        if ("function" == typeof y && (d || b.forEach && !f(function() {
                (new y).entries().next()
            }))) {
            var w, x = new y,
                E = x[m](d ? {} : -0, 1) != x,
                _ = f(function() { x.has(1) }),
                z = l(function(t) { new y(t) });
            z || (y = e(function(e, n) { a(e, y, t); var r = new g; return void 0 != n && u(n, v, r[m], r), r }), y.prototype = b, b.constructor = y), d || x.forEach(function(t, e) { w = 1 / e === -(1 / 0) }), (_ || w) && (S("delete"), S("has"), v && S("get")), (w || E) && S(m), d && b.clear && delete b.clear
        } else y = p.getConstructor(e, t, v, m), c(y.prototype, n);
        return h(y, t), A[t] = y, i(i.G + i.W + i.F * (y != g), A), d || p.setStrong(y, t, v), y
    }
}, function(t, e, n) {
    "use strict";
    var r = n(19),
        i = n(14),
        o = n(9),
        c = n(18),
        u = n(6);
    t.exports = function(t, e, n) {
        var a = u(t),
            s = "" [t];
        o(function() { var e = {}; return e[a] = function() { return 7 }, 7 != "" [t](e) }) && (i(String.prototype, t, n(c, a, s)), r(RegExp.prototype, a, 2 == e ? function(t, e) { return s.call(t, this, e) } : function(t) { return s.call(t, this) }))
    }
}, function(t, e) {
    t.exports = function(t, e, n) {
        var r = void 0 === n;
        switch (e.length) {
            case 0:
                return r ? t() : t.call(n);
            case 1:
                return r ? t(e[0]) : t.call(n, e[0]);
            case 2:
                return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);
            case 3:
                return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);
            case 4:
                return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3])
        }
        return t.apply(n, e)
    }
}, function(t, e, n) {
    var r = n(22);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) { return "String" == r(t) ? t.split("") : Object(t) }
}, function(t, e, n) {
    var r = n(14);
    t.exports = function(t, e) { for (var n in e) r(t, n, e[n]); return t }
}, function(t, e, n) {
    "use strict";
    var r = n(7),
        i = n(3),
        o = n(12),
        c = n(6)("species");
    t.exports = function(t) {
        var e = r[t];
        o && e && !e[c] && i.setDesc(e, c, { configurable: !0, get: function() { return this } })
    }
}, function(t, e) { t.exports = function(t, e, n) { if (!(t instanceof e)) throw TypeError(n + ": use the 'new' operator!"); return t } }, function(t, e, n) {
    var r = n(1),
        i = n(18),
        o = n(9),
        c = "\t\n\x0B\f\r   ᠎             　\u2028\u2029\ufeff",
        u = "[" + c + "]",
        a = "​",
        s = RegExp("^" + u + u + "*"),
        f = RegExp(u + u + "*$"),
        l = function(t, e) {
            var n = {};
            n[t] = e(h), r(r.P + r.F * o(function() { return !!c[t]() || a[t]() != a }), "String", n)
        },
        h = l.trim = function(t, e) { return t = String(i(t)), 1 & e && (t = t.replace(s, "")), 2 & e && (t = t.replace(f, "")), t };
    t.exports = l
}, , , , , , , , , , , , , , , , , , , , , , function(t, e, n) {
    var r = n(6)("match");
    t.exports = function(t) { var e = /./; try { "/./" [t](e) } catch (n) { try { return e[r] = !1, !"/./" [t](e) } catch (i) {} } return !0 }
}, function(t, e, n) {
    var r = n(22);
    t.exports = Array.isArray || function(t) { return "Array" == r(t) }
}, function(t, e, n) {
    "use strict";
    var r = n(82),
        i = n(1),
        o = n(14),
        c = n(19),
        u = n(10),
        a = n(39),
        s = n(106),
        f = n(40),
        l = n(3).getProto,
        h = n(6)("iterator"),
        p = !([].keys && "next" in [].keys()),
        v = "@@iterator",
        d = "keys",
        g = "values",
        y = function() { return this };
    t.exports = function(t, e, n, m, b, A, S) {
        s(n, e, m);
        var w, x, E = function(t) {
                if (!p && t in P) return P[t];
                switch (t) {
                    case d:
                        return function() { return new n(this, t) };
                    case g:
                        return function() { return new n(this, t) }
                }
                return function() { return new n(this, t) }
            },
            _ = e + " Iterator",
            z = b == g,
            M = !1,
            P = t.prototype,
            O = P[h] || P[v] || b && P[b],
            C = O || E(b);
        if (O) {
            var N = l(C.call(new t));
            f(N, _, !0), !r && u(P, v) && c(N, h, y), z && O.name !== g && (M = !0, C = function() { return O.call(this) })
        }
        if (r && !S || !p && !M && P[h] || c(P, h, C), a[e] = C, a[_] = y, b)
            if (w = { values: z ? C : E(g), keys: A ? C : E(d), entries: z ? E("entries") : C }, S)
                for (x in w) x in P || o(P, x, w[x]);
            else i(i.P + i.F * (p || M), e, w);
        return w
    }
}, function(t, e, n) {
    var r = n(6)("iterator"),
        i = !1;
    try {
        var o = [7][r]();
        o.return = function() { i = !0 }, Array.from(o, function() { throw 2 })
    } catch (c) {} t.exports = function(t, e) {
        if (!e && !i) return !1;
        var n = !1;
        try {
            var o = [7],
                c = o[r]();
            c.next = function() { return { done: n = !0 } }, o[r] = function() { return c }, t(o)
        } catch (u) {}
        return n
    }
}, function(t, e) { t.exports = !1 }, function(t, e) { t.exports = Math.expm1 || function(t) { return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1 } }, function(t, e) { t.exports = Math.sign || function(t) { return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1 } }, function(t, e, n) {
    var r = n(3).getDesc,
        i = n(4),
        o = n(5),
        c = function(t, e) { if (o(t), !i(e) && null !== e) throw TypeError(e + ": can't set as prototype!") };
    t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, e, i) { try { i = n(17)(Function.call, r(Object.prototype, "__proto__").set, 2), i(t, []), e = !(t instanceof Array) } catch (o) { e = !0 } return function(t, n) { return c(t, n), e ? t.__proto__ = n : i(t, n), t } }({}, !1) : void 0), check: c }
}, function(t, e, n) {
    var r = n(42),
        i = n(18);
    t.exports = function(t) {
        return function(e, n) {
            var o, c, u = String(i(e)),
                a = r(n),
                s = u.length;
            return a < 0 || a >= s ? t ? "" : void 0 : (o = u.charCodeAt(a), o < 55296 || o > 56319 || a + 1 === s || (c = u.charCodeAt(a + 1)) < 56320 || c > 57343 ? t ? u.charAt(a) : o : t ? u.slice(a, a + 2) : (o - 55296 << 10) + (c - 56320) + 65536)
        }
    }
}, function(t, e, n) {
    var r = n(104),
        i = n(18);
    t.exports = function(t, e, n) { if (r(e)) throw TypeError("String#" + n + " doesn't accept regex!"); return String(i(t)) }
}, , , , , , , function(t, e, n) {
    var r = n(15),
        i = n(11),
        o = n(41);
    t.exports = function(t) {
        return function(e, n, c) {
            var u, a = r(e),
                s = i(a.length),
                f = o(c, s);
            if (t && n != n) {
                for (; s > f;)
                    if (u = a[f++], u != u) return !0
            } else
                for (; s > f; f++)
                    if ((t || f in a) && a[f] === n) return t || f;
            return !t && -1
        }
    }
}, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(19),
        o = n(53),
        c = n(17),
        u = n(55),
        a = n(18),
        s = n(38),
        f = n(80),
        l = n(107),
        h = n(29)("id"),
        p = n(10),
        v = n(4),
        d = n(54),
        g = n(12),
        y = Object.isExtensible || v,
        m = g ? "_s" : "size",
        b = 0,
        A = function(t, e) {
            if (!v(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
            if (!p(t, h)) {
                if (!y(t)) return "F";
                if (!e) return "E";
                i(t, h, ++b)
            }
            return "O" + t[h]
        },
        S = function(t, e) {
            var n, r = A(e);
            if ("F" !== r) return t._i[r];
            for (n = t._f; n; n = n.n)
                if (n.k == e) return n
        };
    t.exports = {
        getConstructor: function(t, e, n, i) {
            var f = t(function(t, o) { u(t, f, e), t._i = r.create(null), t._f = void 0, t._l = void 0, t[m] = 0, void 0 != o && s(o, n, t[i], t) });
            return o(f.prototype, {
                clear: function() {
                    for (var t = this, e = t._i, n = t._f; n; n = n.n) n.r = !0, n.p && (n.p = n.p.n = void 0), delete e[n.i];
                    t._f = t._l = void 0, t[m] = 0
                },
                "delete": function(t) {
                    var e = this,
                        n = S(e, t);
                    if (n) {
                        var r = n.n,
                            i = n.p;
                        delete e._i[n.i], n.r = !0, i && (i.n = r), r && (r.p = i), e._f == n && (e._f = r), e._l == n && (e._l = i), e[m]--
                    }
                    return !!n
                },
                forEach: function(t) {
                    for (var e, n = c(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.n : this._f;)
                        for (n(e.v, e.k, this); e && e.r;) e = e.p
                },
                has: function(t) { return !!S(this, t) }
            }), g && r.setDesc(f.prototype, "size", { get: function() { return a(this[m]) } }), f
        },
        def: function(t, e, n) { var r, i, o = S(t, e); return o ? o.v = n : (t._l = o = { i: i = A(e, !0), k: e, v: n, p: r = t._l, n: void 0, r: !1 }, t._f || (t._f = o), r && (r.n = o), t[m]++, "F" !== i && (t._i[i] = o)), t },
        getEntry: S,
        setStrong: function(t, e, n) { f(t, e, function(t, e) { this._t = t, this._k = e, this._l = void 0 }, function() { for (var t = this, e = t._k, n = t._l; n && n.r;) n = n.p; return t._t && (t._l = n = n ? n.n : t._t._f) ? "keys" == e ? l(0, n.k) : "values" == e ? l(0, n.v) : l(0, [n.k, n.v]) : (t._t = void 0, l(1)) }, n ? "entries" : "values", !n, !0), d(e) }
    }
}, function(t, e, n) {
    var r = n(38),
        i = n(48);
    t.exports = function(t) { return function() { if (i(this) != t) throw TypeError(t + "#toJSON isn't generic"); var e = []; return r(this, !1, e.push, e), e } }
}, function(t, e, n) {
    "use strict";
    var r = n(19),
        i = n(53),
        o = n(5),
        c = n(4),
        u = n(55),
        a = n(38),
        s = n(47),
        f = n(10),
        l = n(29)("weak"),
        h = Object.isExtensible || c,
        p = s(5),
        v = s(6),
        d = 0,
        g = function(t) { return t._l || (t._l = new y) },
        y = function() { this.a = [] },
        m = function(t, e) { return p(t.a, function(t) { return t[0] === e }) };
    y.prototype = {
        get: function(t) { var e = m(this, t); if (e) return e[1] },
        has: function(t) { return !!m(this, t) },
        set: function(t, e) {
            var n = m(this, t);
            n ? n[1] = e : this.a.push([t, e])
        },
        "delete": function(t) { var e = v(this.a, function(e) { return e[0] === t }); return ~e && this.a.splice(e, 1), !!~e }
    }, t.exports = { getConstructor: function(t, e, n, r) { var o = t(function(t, i) { u(t, o, e), t._i = d++, t._l = void 0, void 0 != i && a(i, n, t[r], t) }); return i(o.prototype, { "delete": function(t) { return !!c(t) && (h(t) ? f(t, l) && f(t[l], this._i) && delete t[l][this._i] : g(this).delete(t)) }, has: function(t) { return !!c(t) && (h(t) ? f(t, l) && f(t[l], this._i) : g(this).has(t)) } }), o }, def: function(t, e, n) { return h(o(e)) ? (f(e, l) || r(e, l, {}), e[l][t._i] = n) : g(t).set(e, n), t }, frozenStore: g, WEAK: l }
}, function(t, e, n) {
    var r = n(4),
        i = n(7).document,
        o = r(i) && r(i.createElement);
    t.exports = function(t) { return o ? i.createElement(t) : {} }
}, function(t, e, n) {
    "use strict";
    var r = n(5);
    t.exports = function() {
        var t = r(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
}, function(t, e, n) {
    var r = n(15),
        i = n(3).getNames,
        o = {}.toString,
        c = "object" == typeof window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        u = function(t) { try { return i(t) } catch (e) { return c.slice() } };
    t.exports.get = function(t) { return c && "[object Window]" == o.call(t) ? u(t) : i(r(t)) }
}, function(t, e, n) { t.exports = n(7).document && document.documentElement }, function(t, e, n) {
    var r = n(39),
        i = n(6)("iterator"),
        o = Array.prototype;
    t.exports = function(t) { return void 0 !== t && (r.Array === t || o[i] === t) }
}, function(t, e, n) {
    var r = n(4),
        i = Math.floor;
    t.exports = function(t) { return !r(t) && isFinite(t) && i(t) === t }
}, function(t, e, n) {
    var r = n(4),
        i = n(22),
        o = n(6)("match");
    t.exports = function(t) { var e; return r(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == i(t)) }
}, function(t, e, n) {
    var r = n(5);
    t.exports = function(t, e, n, i) { try { return i ? e(r(n)[0], n[1]) : e(n) } catch (o) { var c = t.return; throw void 0 !== c && r(c.call(t)), o } }
}, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(25),
        o = n(40),
        c = {};
    n(19)(c, n(6)("iterator"), function() { return this }), t.exports = function(t, e, n) { t.prototype = r.create(c, { next: i(1, n) }), o(t, e + " Iterator") }
}, function(t, e) { t.exports = function(t, e) { return { value: e, done: !!t } } }, function(t, e) { t.exports = Math.log1p || function(t) { return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t) } }, function(t, e, n) {
    var r = n(3),
        i = n(15),
        o = r.isEnum;
    t.exports = function(t) { return function(e) { for (var n, c = i(e), u = r.getKeys(c), a = u.length, s = 0, f = []; a > s;) o.call(c, n = u[s++]) && f.push(t ? [n, c[n]] : c[n]); return f } }
}, function(t, e, n) {
    var r = n(3),
        i = n(5),
        o = n(7).Reflect;
    t.exports = o && o.ownKeys || function(t) {
        var e = r.getNames(i(t)),
            n = r.getSymbols;
        return n ? e.concat(n(t)) : e
    }
}, function(t, e) { t.exports = Object.is || function(t, e) { return t === e ? 0 !== t || 1 / t === 1 / e : t != t && e != e } }, function(t, e, n) {
    var r = n(7),
        i = "__core-js_shared__",
        o = r[i] || (r[i] = {});
    t.exports = function(t) { return o[t] || (o[t] = {}) }
}, function(t, e, n) {
    var r = n(11),
        i = n(114),
        o = n(18);
    t.exports = function(t, e, n, c) {
        var u = String(o(t)),
            a = u.length,
            s = void 0 === n ? " " : String(n),
            f = r(e);
        if (f <= a) return u;
        "" == s && (s = " ");
        var l = f - a,
            h = i.call(s, Math.ceil(l / s.length));
        return h.length > l && (h = h.slice(0, l)), c ? h + u : u + h
    }
}, function(t, e, n) {
    "use strict";
    var r = n(42),
        i = n(18);
    t.exports = function(t) {
        var e = String(i(this)),
            n = "",
            o = r(t);
        if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");
        for (; o > 0;
            (o >>>= 1) && (e += e)) 1 & o && (n += e);
        return n
    }
}, function(t, e, n) {
    var r, i, o, c = n(17),
        u = n(51),
        a = n(101),
        s = n(98),
        f = n(7),
        l = f.process,
        h = f.setImmediate,
        p = f.clearImmediate,
        v = f.MessageChannel,
        d = 0,
        g = {},
        y = "onreadystatechange",
        m = function() {
            var t = +this;
            if (g.hasOwnProperty(t)) {
                var e = g[t];
                delete g[t], e()
            }
        },
        b = function(t) { m.call(t.data) };
    h && p || (h = function(t) { for (var e = [], n = 1; arguments.length > n;) e.push(arguments[n++]); return g[++d] = function() { u("function" == typeof t ? t : Function(t), e) }, r(d), d }, p = function(t) { delete g[t] }, "process" == n(22)(l) ? r = function(t) { l.nextTick(c(m, t, 1)) } : v ? (i = new v, o = i.port2, i.port1.onmessage = b, r = c(o.postMessage, o, 1)) : f.addEventListener && "function" == typeof postMessage && !f.importScripts ? (r = function(t) { f.postMessage(t + "", "*") }, f.addEventListener("message", b, !1)) : r = y in s("script") ? function(t) { a.appendChild(s("script"))[y] = function() { a.removeChild(this), m.call(t) } } : function(t) { setTimeout(c(m, t, 1), 0) }), t.exports = { set: h, clear: p }
}, function(t, e, n) {
    var r = n(48),
        i = n(6)("iterator"),
        o = n(39);
    t.exports = n(23).getIteratorMethod = function(t) { if (void 0 != t) return t[i] || t["@@iterator"] || o[r(t)] }
}, function(t, e, n) {
    "use strict";
    var r = n(28),
        i = n(107),
        o = n(39),
        c = n(15);
    t.exports = n(80)(Array, "Array", function(t, e) { this._t = c(t), this._i = 0, this._k = e }, function() {
        var t = this._t,
            e = this._k,
            n = this._i++;
        return !t || n >= t.length ? (this._t = void 0, i(1)) : "keys" == e ? i(0, n) : "values" == e ? i(0, t[n]) : i(0, [n, t[n]])
    }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries")
}, , , , , , , function(t, e, n) {
    "use strict";
    n(159), n(304), n(293), n(292)
}, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , function(t, e, n) {
    (function(t) {
        "use strict";
        if (n(285), n(160), t._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");
        t._babelPolyfill = !0
    }).call(e, function() { return this }())
}, function(t, e, n) {
    (function(e, n) {
        ! function(e) {
            "use strict";

            function r(t, e, n, r) {
                var i = Object.create((e || o).prototype),
                    c = new v(r || []);
                return i._invoke = l(t, n, c), i
            }

            function i(t, e, n) { try { return { type: "normal", arg: t.call(e, n) } } catch (r) { return { type: "throw", arg: r } } }

            function o() {}

            function c() {}

            function u() {}

            function a(t) {
                ["next", "throw", "return"].forEach(function(e) { t[e] = function(t) { return this._invoke(e, t) } })
            }

            function s(t) { this.arg = t }

            function f(t) {
                function e(e, n) {
                    var r = t[e](n),
                        i = r.value;
                    return i instanceof s ? Promise.resolve(i.arg).then(o, c) : Promise.resolve(i).then(function(t) { return r.value = t, r })
                }

                function r(t, n) {
                    function r() { return e(t, n) }
                    return i = i ? i.then(r, r) : new Promise(function(t) { t(r()) })
                }
                "object" == typeof n && n.domain && (e = n.domain.bind(e));
                var i, o = e.bind(t, "next"),
                    c = e.bind(t, "throw");
                e.bind(t, "return");
                this._invoke = r
            }

            function l(t, e, n) {
                var r = w;
                return function(o, c) {
                    if (r === E) throw new Error("Generator is already running");
                    if (r === _) { if ("throw" === o) throw c; return g() }
                    for (;;) {
                        var u = n.delegate;
                        if (u) {
                            if ("return" === o || "throw" === o && u.iterator[o] === y) { n.delegate = null; var a = u.iterator.return; if (a) { var s = i(a, u.iterator, c); if ("throw" === s.type) { o = "throw", c = s.arg; continue } } if ("return" === o) continue }
                            var s = i(u.iterator[o], u.iterator, c);
                            if ("throw" === s.type) { n.delegate = null, o = "throw", c = s.arg; continue } o = "next", c = y;
                            var f = s.arg;
                            if (!f.done) return r = x, f;
                            n[u.resultName] = f.value, n.next = u.nextLoc, n.delegate = null
                        }
                        if ("next" === o) n._sent = c, r === x ? n.sent = c : n.sent = y;
                        else if ("throw" === o) {
                            if (r === w) throw r = _, c;
                            n.dispatchException(c) && (o = "next", c = y)
                        } else "return" === o && n.abrupt("return", c);
                        r = E;
                        var s = i(t, e, n);
                        if ("normal" === s.type) {
                            r = n.done ? _ : x;
                            var f = { value: s.arg, done: n.done };
                            if (s.arg !== z) return f;
                            n.delegate && "next" === o && (c = y)
                        } else "throw" === s.type && (r = _, o = "throw", c = s.arg)
                    }
                }
            }

            function h(t) {
                var e = { tryLoc: t[0] };
                1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
            }

            function p(t) {
                var e = t.completion || {};
                e.type = "normal", delete e.arg, t.completion = e
            }

            function v(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(h, this), this.reset(!0) }

            function d(t) {
                if (t) {
                    var e = t[b];
                    if (e) return e.call(t);
                    if ("function" == typeof t.next) return t;
                    if (!isNaN(t.length)) {
                        var n = -1,
                            r = function i() {
                                for (; ++n < t.length;)
                                    if (m.call(t, n)) return i.value = t[n], i.done = !1, i;
                                return i.value = y, i.done = !0, i
                            };
                        return r.next = r
                    }
                }
                return { next: g }
            }

            function g() { return { value: y, done: !0 } }
            var y, m = Object.prototype.hasOwnProperty,
                b = "function" == typeof Symbol && Symbol.iterator || "@@iterator",
                A = "object" == typeof t,
                S = e.regeneratorRuntime;
            if (S) return void(A && (t.exports = S));
            S = e.regeneratorRuntime = A ? t.exports : {}, S.wrap = r;
            var w = "suspendedStart",
                x = "suspendedYield",
                E = "executing",
                _ = "completed",
                z = {},
                M = u.prototype = o.prototype;
            c.prototype = M.constructor = u, u.constructor = c, c.displayName = "GeneratorFunction", S.isGeneratorFunction = function(t) { var e = "function" == typeof t && t.constructor; return !!e && (e === c || "GeneratorFunction" === (e.displayName || e.name)) }, S.mark = function(t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, u) : t.__proto__ = u, t.prototype = Object.create(M), t }, S.awrap = function(t) { return new s(t) }, a(f.prototype), S.async = function(t, e, n, i) { var o = new f(r(t, e, n, i)); return S.isGeneratorFunction(e) ? o : o.next().then(function(t) { return t.done ? t.value : o.next() }) }, a(M), M[b] = function() { return this }, M.toString = function() { return "[object Generator]" }, S.keys = function(t) {
                var e = [];
                for (var n in t) e.push(n);
                return e.reverse(),
                    function r() { for (; e.length;) { var n = e.pop(); if (n in t) return r.value = n, r.done = !1, r } return r.done = !0, r }
            }, S.values = d, v.prototype = {
                constructor: v,
                reset: function(t) {
                    if (this.prev = 0, this.next = 0, this.sent = y, this.done = !1, this.delegate = null, this.tryEntries.forEach(p), !t)
                        for (var e in this) "t" === e.charAt(0) && m.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = y)
                },
                stop: function() {
                    this.done = !0;
                    var t = this.tryEntries[0],
                        e = t.completion;
                    if ("throw" === e.type) throw e.arg;
                    return this.rval
                },
                dispatchException: function(t) {
                    function e(e, r) { return o.type = "throw", o.arg = t, n.next = e, !!r }
                    if (this.done) throw t;
                    for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
                        var i = this.tryEntries[r],
                            o = i.completion;
                        if ("root" === i.tryLoc) return e("end");
                        if (i.tryLoc <= this.prev) {
                            var c = m.call(i, "catchLoc"),
                                u = m.call(i, "finallyLoc");
                            if (c && u) { if (this.prev < i.catchLoc) return e(i.catchLoc, !0); if (this.prev < i.finallyLoc) return e(i.finallyLoc) } else if (c) { if (this.prev < i.catchLoc) return e(i.catchLoc, !0) } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return e(i.finallyLoc) }
                        }
                    }
                },
                abrupt: function(t, e) { for (var n = this.tryEntries.length - 1; n >= 0; --n) { var r = this.tryEntries[n]; if (r.tryLoc <= this.prev && m.call(r, "finallyLoc") && this.prev < r.finallyLoc) { var i = r; break } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var o = i ? i.completion : {}; return o.type = t, o.arg = e, i ? this.next = i.finallyLoc : this.complete(o), z },
                complete: function(t, e) { if ("throw" === t.type) throw t.arg; "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = t.arg, this.next = "end") : "normal" === t.type && e && (this.next = e) },
                finish: function(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), p(n), z } },
                "catch": function(t) {
                    for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                        var n = this.tryEntries[e];
                        if (n.tryLoc === t) {
                            var r = n.completion;
                            if ("throw" === r.type) {
                                var i = r.arg;
                                p(n)
                            }
                            return i
                        }
                    }
                    throw new Error("illegal catch attempt")
                },
                delegateYield: function(t, e, n) { return this.delegate = { iterator: d(t), resultName: e, nextLoc: n }, z }
            }
        }("object" == typeof e ? e : "object" == typeof window ? window : "object" == typeof self ? self : this)
    }).call(e, function() { return this }(), n(295))
}, , , , , , , , , , , function(t, e, n) {
    "use strict";
    var r = n(24),
        i = n(41),
        o = n(11);
    t.exports = [].copyWithin || function(t, e) {
        var n = r(this),
            c = o(n.length),
            u = i(t, c),
            a = i(e, c),
            s = arguments,
            f = s.length > 2 ? s[2] : void 0,
            l = Math.min((void 0 === f ? c : i(f, c)) - a, c - u),
            h = 1;
        for (a < u && u < a + l && (h = -1, a += l - 1, u += l - 1); l-- > 0;) a in n ? n[u] = n[a] : delete n[u], u += h, a += h;
        return n
    }
}, function(t, e, n) {
    "use strict";
    var r = n(24),
        i = n(41),
        o = n(11);
    t.exports = [].fill || function(t) { for (var e = r(this), n = o(e.length), c = arguments, u = c.length, a = i(u > 1 ? c[1] : void 0, n), s = u > 2 ? c[2] : void 0, f = void 0 === s ? n : i(s, n); f > a;) e[a++] = t; return e }
}, function(t, e, n) {
    var r = n(4),
        i = n(79),
        o = n(6)("species");
    t.exports = function(t, e) { var n; return i(t) && (n = t.constructor, "function" != typeof n || n !== Array && !i(n.prototype) || (n = void 0), r(n) && (n = n[o], null === n && (n = void 0))), new(void 0 === n ? Array : n)(e) }
}, function(t, e, n) {
    var r = n(3);
    t.exports = function(t) {
        var e = r.getKeys(t),
            n = r.getSymbols;
        if (n)
            for (var i, o = n(t), c = r.isEnum, u = 0; o.length > u;) c.call(t, i = o[u++]) && e.push(i);
        return e
    }
}, function(t, e, n) {
    var r = n(3),
        i = n(15);
    t.exports = function(t, e) {
        for (var n, o = i(t), c = r.getKeys(o), u = c.length, a = 0; u > a;)
            if (o[n = c[a++]] === e) return n
    }
}, function(t, e, n) {
    var r, i, o, c = n(7),
        u = n(115).set,
        a = c.MutationObserver || c.WebKitMutationObserver,
        s = c.process,
        f = c.Promise,
        l = "process" == n(22)(s),
        h = function() {
            var t, e, n;
            for (l && (t = s.domain) && (s.domain = null, t.exit()); r;) e = r.domain, n = r.fn, e && e.enter(), n(), e && e.exit(), r = r.next;
            i = void 0, t && t.enter()
        };
    if (l) o = function() { s.nextTick(h) };
    else if (a) {
        var p = 1,
            v = document.createTextNode("");
        new a(h).observe(v, { characterData: !0 }), o = function() { v.data = p = -p }
    } else o = f && f.resolve ? function() { f.resolve().then(h) } : function() { u.call(c, h) };
    t.exports = function(t) {
        var e = { fn: t, next: void 0, domain: l && s.domain };
        i && (i.next = e), r || (r = e, o()), i = e
    }
}, function(t, e, n) {
    var r = n(3),
        i = n(24),
        o = n(52);
    t.exports = n(9)(function() {
        var t = Object.assign,
            e = {},
            n = {},
            r = Symbol(),
            i = "abcdefghijklmnopqrst";
        return e[r] = 7, i.split("").forEach(function(t) { n[t] = t }), 7 != t({}, e)[r] || Object.keys(t({}, n)).join("") != i
    }) ? function(t, e) {
        for (var n = i(t), c = arguments, u = c.length, a = 1, s = r.getKeys, f = r.getSymbols, l = r.isEnum; u > a;)
            for (var h, p = o(c[a++]), v = f ? s(p).concat(f(p)) : s(p), d = v.length, g = 0; d > g;) l.call(p, h = v[g++]) && (n[h] = p[h]);
        return n
    } : Object.assign
}, function(t, e, n) {
    "use strict";
    var r = n(179),
        i = n(51),
        o = n(27);
    t.exports = function() {
        for (var t = o(this), e = arguments.length, n = Array(e), c = 0, u = r._, a = !1; e > c;)(n[c] = arguments[c++]) === u && (a = !0);
        return function() {
            var r, o = this,
                c = arguments,
                s = c.length,
                f = 0,
                l = 0;
            if (!a && !s) return i(t, n, o);
            if (r = n.slice(), a)
                for (; e > f; f++) r[f] === u && (r[f] = c[l++]);
            for (; s > l;) r.push(c[l++]);
            return i(t, r, o)
        }
    }
}, function(t, e, n) { t.exports = n(7) }, function(t, e) { t.exports = function(t, e) { var n = e === Object(e) ? function(t) { return e[t] } : e; return function(e) { return String(e).replace(t, n) } } }, function(t, e, n) {
    var r = n(5),
        i = n(27),
        o = n(6)("species");
    t.exports = function(t, e) { var n, c = r(t).constructor; return void 0 === c || void 0 == (n = r(c)[o]) ? e : i(n) }
}, function(t, e, n) {
    var r = n(4);
    t.exports = function(t, e) { if (!r(t)) return t; var n, i; if (e && "function" == typeof(n = t.toString) && !r(i = n.call(t))) return i; if ("function" == typeof(n = t.valueOf) && !r(i = n.call(t))) return i; if (!e && "function" == typeof(n = t.toString) && !r(i = n.call(t))) return i; throw TypeError("Can't convert object to primitive value") }
}, function(t, e, n) {
    "use strict";
    var r, i = n(3),
        o = n(1),
        c = n(12),
        u = n(25),
        a = n(101),
        s = n(98),
        f = n(10),
        l = n(22),
        h = n(51),
        p = n(9),
        v = n(5),
        d = n(27),
        g = n(4),
        y = n(24),
        m = n(15),
        b = n(42),
        A = n(41),
        S = n(11),
        w = n(52),
        x = n(29)("__proto__"),
        E = n(47),
        _ = n(94)(!1),
        z = Object.prototype,
        M = Array.prototype,
        P = M.slice,
        O = M.join,
        C = i.setDesc,
        N = i.getDesc,
        T = i.setDescs,
        j = {};
    c || (r = !p(function() { return 7 != C(s("div"), "a", { get: function() { return 7 } }).a }), i.setDesc = function(t, e, n) {
        if (r) try { return C(t, e, n) } catch (i) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (v(t)[e] = n.value), t
    }, i.getDesc = function(t, e) {
        if (r) try { return N(t, e) } catch (n) {}
        if (f(t, e)) return u(!z.propertyIsEnumerable.call(t, e), t[e])
    }, i.setDescs = T = function(t, e) { v(t); for (var n, r = i.getKeys(e), o = r.length, c = 0; o > c;) i.setDesc(t, n = r[c++], e[n]); return t }), o(o.S + o.F * !c, "Object", { getOwnPropertyDescriptor: i.getDesc, defineProperty: i.setDesc, defineProperties: T });
    var F = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
        L = F.concat("length", "prototype"),
        R = F.length,
        D = function() {
            var t, e = s("iframe"),
                n = R,
                r = ">";
            for (e.style.display = "none", a.appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object</script" + r), t.close(), D = t.F; n--;) delete D.prototype[F[n]];
            return D()
        },
        k = function(t, e) {
            return function(n) {
                var r, i = m(n),
                    o = 0,
                    c = [];
                for (r in i) r != x && f(i, r) && c.push(r);
                for (; e > o;) f(i, r = t[o++]) && (~_(c, r) || c.push(r));
                return c
            }
        },
        I = function() {};
    o(o.S, "Object", { getPrototypeOf: i.getProto = i.getProto || function(t) { return t = y(t), f(t, x) ? t[x] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? z : null }, getOwnPropertyNames: i.getNames = i.getNames || k(L, L.length, !0), create: i.create = i.create || function(t, e) { var n; return null !== t ? (I.prototype = v(t), n = new I, I.prototype = null, n[x] = t) : n = D(), void 0 === e ? n : T(n, e) }, keys: i.getKeys = i.getKeys || k(F, R, !1) });
    var W = function(t, e, n) {
        if (!(e in j)) {
            for (var r = [], i = 0; i < e; i++) r[i] = "a[" + i + "]";
            j[e] = Function("F,a", "return new F(" + r.join(",") + ")")
        }
        return j[e](t, n)
    };
    o(o.P, "Function", {
        bind: function(t) {
            var e = d(this),
                n = P.call(arguments, 1),
                r = function() { var i = n.concat(P.call(arguments)); return this instanceof r ? W(e, i.length, i) : h(e, i, t) };
            return g(e.prototype) && (r.prototype = e.prototype), r
        }
    }), o(o.P + o.F * p(function() { a && P.call(a) }), "Array", {
        slice: function(t, e) {
            var n = S(this.length),
                r = l(this);
            if (e = void 0 === e ? n : e, "Array" == r) return P.call(this, t, e);
            for (var i = A(t, n), o = A(e, n), c = S(o - i), u = Array(c), a = 0; a < c; a++) u[a] = "String" == r ? this.charAt(i + a) : this[i + a];
            return u
        }
    }), o(o.P + o.F * (w != Object), "Array", { join: function(t) { return O.call(w(this), void 0 === t ? "," : t) } }), o(o.S, "Array", { isArray: n(79) });
    var B = function(t) {
            return function(e, n) {
                d(e);
                var r = w(this),
                    i = S(r.length),
                    o = t ? i - 1 : 0,
                    c = t ? -1 : 1;
                if (arguments.length < 2)
                    for (;;) { if (o in r) { n = r[o], o += c; break } if (o += c, t ? o < 0 : i <= o) throw TypeError("Reduce of empty array with no initial value") }
                for (; t ? o >= 0 : i > o; o += c) o in r && (n = e(n, r[o], o, this));
                return n
            }
        },
        G = function(t) { return function(e) { return t(this, e, arguments[1]) } };
    o(o.P, "Array", {
        forEach: i.each = i.each || G(E(0)),
        map: G(E(1)),
        filter: G(E(2)),
        some: G(E(3)),
        every: G(E(4)),
        reduce: B(!1),
        reduceRight: B(!0),
        indexOf: G(_),
        lastIndexOf: function(t, e) {
            var n = m(this),
                r = S(n.length),
                i = r - 1;
            for (arguments.length > 1 && (i = Math.min(i, b(e))), i < 0 && (i = S(r + i)); i >= 0; i--)
                if (i in n && n[i] === t) return i;
            return -1
        }
    }), o(o.S, "Date", { now: function() { return +new Date } });
    var $ = function(t) { return t > 9 ? t : "0" + t };
    o(o.P + o.F * (p(function() { return "0385-07-25T07:06:39.999Z" != new Date(-5e13 - 1).toISOString() }) || !p(function() { new Date(NaN).toISOString() })), "Date", {
        toISOString: function() {
            if (!isFinite(this)) throw RangeError("Invalid time value");
            var t = this,
                e = t.getUTCFullYear(),
                n = t.getUTCMilliseconds(),
                r = e < 0 ? "-" : e > 9999 ? "+" : "";
            return r + ("00000" + Math.abs(e)).slice(r ? -6 : -4) + "-" + $(t.getUTCMonth() + 1) + "-" + $(t.getUTCDate()) + "T" + $(t.getUTCHours()) + ":" + $(t.getUTCMinutes()) + ":" + $(t.getUTCSeconds()) + "." + (n > 99 ? n : "0" + $(n)) + "Z"
        }
    })
}, function(t, e, n) {
    var r = n(1);
    r(r.P, "Array", { copyWithin: n(171) }), n(28)("copyWithin")
}, function(t, e, n) {
    var r = n(1);
    r(r.P, "Array", { fill: n(172) }), n(28)("fill")
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(47)(6),
        o = "findIndex",
        c = !0;
    o in [] && Array(1)[o](function() { c = !1 }), r(r.P + r.F * c, "Array", { findIndex: function(t) { return i(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(28)(o)
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(47)(5),
        o = "find",
        c = !0;
    o in [] && Array(1)[o](function() { c = !1 }), r(r.P + r.F * c, "Array", { find: function(t) { return i(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(28)(o)
}, function(t, e, n) {
    "use strict";
    var r = n(17),
        i = n(1),
        o = n(24),
        c = n(105),
        u = n(102),
        a = n(11),
        s = n(116);
    i(i.S + i.F * !n(81)(function(t) { Array.from(t) }), "Array", {
        from: function(t) {
            var e, n, i, f, l = o(t),
                h = "function" == typeof this ? this : Array,
                p = arguments,
                v = p.length,
                d = v > 1 ? p[1] : void 0,
                g = void 0 !== d,
                y = 0,
                m = s(l);
            if (g && (d = r(d, v > 2 ? p[2] : void 0, 2)), void 0 == m || h == Array && u(m))
                for (e = a(l.length), n = new h(e); e > y; y++) n[y] = g ? d(l[y], y) : l[y];
            else
                for (f = m.call(l), n = new h; !(i = f.next()).done; y++) n[y] = g ? c(f, d, [i.value, y], !0) : i.value;
            return n.length = y, n
        }
    })
}, function(t, e, n) {
    "use strict";
    var r = n(1);
    r(r.S + r.F * n(9)(function() {
        function t() {}
        return !(Array.of.call(t) instanceof t)
    }), "Array", { of: function() { for (var t = 0, e = arguments, n = e.length, r = new("function" == typeof this ? this : Array)(n); n > t;) r[t] = e[t++]; return r.length = n, r } })
}, function(t, e, n) { n(54)("Array") }, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(4),
        o = n(6)("hasInstance"),
        c = Function.prototype;
    o in c || r.setDesc(c, o, {
        value: function(t) {
            if ("function" != typeof this || !i(t)) return !1;
            if (!i(this.prototype)) return t instanceof this;
            for (; t = r.getProto(t);)
                if (this.prototype === t) return !0;
            return !1
        }
    })
}, function(t, e, n) {
    var r = n(3).setDesc,
        i = n(25),
        o = n(10),
        c = Function.prototype,
        u = /^\s*function ([^ (]*)/,
        a = "name";
    a in c || n(12) && r(c, a, {
        configurable: !0,
        get: function() {
            var t = ("" + this).match(u),
                e = t ? t[1] : "";
            return o(this, a) || r(this, a, i(5, e)), e
        }
    })
}, function(t, e, n) {
    "use strict";
    var r = n(95);
    n(49)("Map", function(t) { return function() { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { get: function(t) { var e = r.getEntry(this, t); return e && e.v }, set: function(t, e) { return r.def(this, 0 === t ? 0 : t, e) } }, r, !0)
}, function(t, e, n) {
    var r = n(1),
        i = n(108),
        o = Math.sqrt,
        c = Math.acosh;
    r(r.S + r.F * !(c && 710 == Math.floor(c(Number.MAX_VALUE))), "Math", { acosh: function(t) { return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1)) } })
}, function(t, e, n) {
    function r(t) { return isFinite(t = +t) && 0 != t ? t < 0 ? -r(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t }
    var i = n(1);
    i(i.S, "Math", { asinh: r })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { atanh: function(t) { return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2 } })
}, function(t, e, n) {
    var r = n(1),
        i = n(84);
    r(r.S, "Math", { cbrt: function(t) { return i(t = +t) * Math.pow(Math.abs(t), 1 / 3) } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { clz32: function(t) { return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32 } })
}, function(t, e, n) {
    var r = n(1),
        i = Math.exp;
    r(r.S, "Math", { cosh: function(t) { return (i(t = +t) + i(-t)) / 2 } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { expm1: n(83) })
}, function(t, e, n) {
    var r = n(1),
        i = n(84),
        o = Math.pow,
        c = o(2, -52),
        u = o(2, -23),
        a = o(2, 127) * (2 - u),
        s = o(2, -126),
        f = function(t) { return t + 1 / c - 1 / c };
    r(r.S, "Math", {
        fround: function(t) {
            var e, n, r = Math.abs(t),
                o = i(t);
            return r < s ? o * f(r / s / u) * s * u : (e = (1 + u / c) * r, n = e - (e - r), n > a || n != n ? o * (1 / 0) : o * n)
        }
    })
}, function(t, e, n) {
    var r = n(1),
        i = Math.abs;
    r(r.S, "Math", { hypot: function(t, e) { for (var n, r, o = 0, c = 0, u = arguments, a = u.length, s = 0; c < a;) n = i(u[c++]), s < n ? (r = s / n, o = o * r * r + 1, s = n) : n > 0 ? (r = n / s, o += r * r) : o += n; return s === 1 / 0 ? 1 / 0 : s * Math.sqrt(o) } })
}, function(t, e, n) {
    var r = n(1),
        i = Math.imul;
    r(r.S + r.F * n(9)(function() { return i(4294967295, 5) != -5 || 2 != i.length }), "Math", {
        imul: function(t, e) {
            var n = 65535,
                r = +t,
                i = +e,
                o = n & r,
                c = n & i;
            return 0 | o * c + ((n & r >>> 16) * c + o * (n & i >>> 16) << 16 >>> 0)
        }
    })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { log10: function(t) { return Math.log(t) / Math.LN10 } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { log1p: n(108) })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { log2: function(t) { return Math.log(t) / Math.LN2 } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { sign: n(84) })
}, function(t, e, n) {
    var r = n(1),
        i = n(83),
        o = Math.exp;
    r(r.S + r.F * n(9)(function() { return !Math.sinh(-2e-17) != -2e-17 }), "Math", { sinh: function(t) { return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2) } })
}, function(t, e, n) {
    var r = n(1),
        i = n(83),
        o = Math.exp;
    r(r.S, "Math", {
        tanh: function(t) {
            var e = i(t = +t),
                n = i(-t);
            return e == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (e - n) / (o(t) + o(-t))
        }
    })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Math", { trunc: function(t) { return (t > 0 ? Math.floor : Math.ceil)(t) } })
}, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(7),
        o = n(10),
        c = n(22),
        u = n(182),
        a = n(9),
        s = n(56).trim,
        f = "Number",
        l = i[f],
        h = l,
        p = l.prototype,
        v = c(r.create(p)) == f,
        d = "trim" in String.prototype,
        g = function(t) {
            var e = u(t, !1);
            if ("string" == typeof e && e.length > 2) {
                e = d ? e.trim() : s(e, 3);
                var n, r, i, o = e.charCodeAt(0);
                if (43 === o || 45 === o) { if (n = e.charCodeAt(2), 88 === n || 120 === n) return NaN } else if (48 === o) {
                    switch (e.charCodeAt(1)) {
                        case 66:
                        case 98:
                            r = 2, i = 49;
                            break;
                        case 79:
                        case 111:
                            r = 8, i = 55;
                            break;
                        default:
                            return +e
                    }
                    for (var c, a = e.slice(2), f = 0, l = a.length; f < l; f++)
                        if (c = a.charCodeAt(f), c < 48 || c > i) return NaN;
                    return parseInt(a, r)
                }
            }
            return +e
        };
    l(" 0o1") && l("0b1") && !l("+0x1") || (l = function(t) {
        var e = arguments.length < 1 ? 0 : t,
            n = this;
        return n instanceof l && (v ? a(function() { p.valueOf.call(n) }) : c(n) != f) ? new h(g(e)) : g(e)
    }, r.each.call(n(12) ? r.getNames(h) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), function(t) { o(h, t) && !o(l, t) && r.setDesc(l, t, r.getDesc(h, t)) }), l.prototype = p, p.constructor = l, n(14)(i, f, l))
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { EPSILON: Math.pow(2, -52) })
}, function(t, e, n) {
    var r = n(1),
        i = n(7).isFinite;
    r(r.S, "Number", { isFinite: function(t) { return "number" == typeof t && i(t) } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { isInteger: n(103) })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { isNaN: function(t) { return t != t } })
}, function(t, e, n) {
    var r = n(1),
        i = n(103),
        o = Math.abs;
    r(r.S, "Number", { isSafeInteger: function(t) { return i(t) && o(t) <= 9007199254740991 } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { parseFloat: parseFloat })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Number", { parseInt: parseInt })
}, function(t, e, n) {
    var r = n(1);
    r(r.S + r.F, "Object", { assign: n(177) })
}, function(t, e, n) {
    var r = n(4);
    n(13)("freeze", function(t) { return function(e) { return t && r(e) ? t(e) : e } })
}, function(t, e, n) {
    var r = n(15);
    n(13)("getOwnPropertyDescriptor", function(t) { return function(e, n) { return t(r(e), n) } })
}, function(t, e, n) { n(13)("getOwnPropertyNames", function() { return n(100).get }) }, function(t, e, n) {
    var r = n(24);
    n(13)("getPrototypeOf", function(t) { return function(e) { return t(r(e)) } })
}, function(t, e, n) {
    var r = n(4);
    n(13)("isExtensible", function(t) { return function(e) { return !!r(e) && (!t || t(e)) } })
}, function(t, e, n) {
    var r = n(4);
    n(13)("isFrozen", function(t) { return function(e) { return !r(e) || !!t && t(e) } })
}, function(t, e, n) {
    var r = n(4);
    n(13)("isSealed", function(t) { return function(e) { return !r(e) || !!t && t(e) } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Object", { is: n(111) })
}, function(t, e, n) {
    var r = n(24);
    n(13)("keys", function(t) { return function(e) { return t(r(e)) } })
}, function(t, e, n) {
    var r = n(4);
    n(13)("preventExtensions", function(t) { return function(e) { return t && r(e) ? t(e) : e } })
}, function(t, e, n) {
    var r = n(4);
    n(13)("seal", function(t) { return function(e) { return t && r(e) ? t(e) : e } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Object", { setPrototypeOf: n(85).set })
}, function(t, e, n) {
    "use strict";
    var r = n(48),
        i = {};
    i[n(6)("toStringTag")] = "z", i + "" != "[object z]" && n(14)(Object.prototype, "toString", function() { return "[object " + r(this) + "]" }, !0)
}, function(t, e, n) {
    "use strict";
    var r, i = n(3),
        o = n(82),
        c = n(7),
        u = n(17),
        a = n(48),
        s = n(1),
        f = n(4),
        l = n(5),
        h = n(27),
        p = n(55),
        v = n(38),
        d = n(85).set,
        g = n(111),
        y = n(6)("species"),
        m = n(181),
        b = n(176),
        A = "Promise",
        S = c.process,
        w = "process" == a(S),
        x = c[A],
        E = function() {},
        _ = function(t) { var e, n = new x(E); return t && (n.constructor = function(t) { t(E, E) }), (e = x.resolve(n)).catch(E), e === n },
        z = function() {
            function t(e) { var n = new x(e); return d(n, t.prototype), n }
            var e = !1;
            try {
                if (e = x && x.resolve && _(), d(t, x), t.prototype = i.create(x.prototype, { constructor: { value: t } }), t.resolve(5).then(function() {}) instanceof t || (e = !1), e && n(12)) {
                    var r = !1;
                    x.resolve(i.setDesc({}, "then", { get: function() { r = !0 } })), e = r
                }
            } catch (o) { e = !1 }
            return e
        }(),
        M = function(t, e) { return !(!o || t !== x || e !== r) || g(t, e) },
        P = function(t) { var e = l(t)[y]; return void 0 != e ? e : t },
        O = function(t) { var e; return !(!f(t) || "function" != typeof(e = t.then)) && e },
        C = function(t) {
            var e, n;
            this.promise = new t(function(t, r) {
                if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
                e = t, n = r
            }), this.resolve = h(e), this.reject = h(n)
        },
        N = function(t) { try { t() } catch (e) { return { error: e } } },
        T = function(t, e) {
            if (!t.n) {
                t.n = !0;
                var n = t.c;
                b(function() {
                    for (var r = t.v, i = 1 == t.s, o = 0, u = function(e) {
                            var n, o, c = i ? e.ok : e.fail,
                                u = e.resolve,
                                a = e.reject;
                            try { c ? (i || (t.h = !0), n = c === !0 ? r : c(r), n === e.promise ? a(TypeError("Promise-chain cycle")) : (o = O(n)) ? o.call(n, u, a) : u(n)) : a(r) } catch (s) { a(s) }
                        }; n.length > o;) u(n[o++]);
                    n.length = 0, t.n = !1, e && setTimeout(function() {
                        var e, n, i = t.p;
                        j(i) && (w ? S.emit("unhandledRejection", r, i) : (e = c.onunhandledrejection) ? e({ promise: i, reason: r }) : (n = c.console) && n.error && n.error("Unhandled promise rejection", r)), t.a = void 0
                    }, 1)
                })
            }
        },
        j = function(t) {
            var e, n = t._d,
                r = n.a || n.c,
                i = 0;
            if (n.h) return !1;
            for (; r.length > i;)
                if (e = r[i++], e.fail || !j(e.promise)) return !1;
            return !0
        },
        F = function(t) {
            var e = this;
            e.d || (e.d = !0, e = e.r || e, e.v = t, e.s = 2, e.a = e.c.slice(), T(e, !0))
        },
        L = function(t) {
            var e, n = this;
            if (!n.d) {
                n.d = !0, n = n.r || n;
                try {
                    if (n.p === t) throw TypeError("Promise can't be resolved itself");
                    (e = O(t)) ? b(function() { var r = { r: n, d: !1 }; try { e.call(t, u(L, r, 1), u(F, r, 1)) } catch (i) { F.call(r, i) } }): (n.v = t, n.s = 1, T(n, !1))
                } catch (r) { F.call({ r: n, d: !1 }, r) }
            }
        };
    z || (x = function(t) { h(t); var e = this._d = { p: p(this, x, A), c: [], a: void 0, s: 0, d: !1, v: void 0, h: !1, n: !1 }; try { t(u(L, e, 1), u(F, e, 1)) } catch (n) { F.call(e, n) } }, n(53)(x.prototype, {
        then: function(t, e) {
            var n = new C(m(this, x)),
                r = n.promise,
                i = this._d;
            return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, i.c.push(n), i.a && i.a.push(n), i.s && T(i, !1), r
        },
        "catch": function(t) { return this.then(void 0, t) }
    })), s(s.G + s.W + s.F * !z, { Promise: x }), n(40)(x, A), n(54)(A), r = n(23)[A], s(s.S + s.F * !z, A, {
        reject: function(t) {
            var e = new C(this),
                n = e.reject;
            return n(t), e.promise
        }
    }), s(s.S + s.F * (!z || _(!0)), A, {
        resolve: function(t) {
            if (t instanceof x && M(t.constructor, this)) return t;
            var e = new C(this),
                n = e.resolve;
            return n(t), e.promise
        }
    }), s(s.S + s.F * !(z && n(81)(function(t) { x.all(t).catch(function() {}) })), A, {
        all: function(t) {
            var e = P(this),
                n = new C(e),
                r = n.resolve,
                o = n.reject,
                c = [],
                u = N(function() {
                    v(t, !1, c.push, c);
                    var n = c.length,
                        u = Array(n);
                    n ? i.each.call(c, function(t, i) {
                        var c = !1;
                        e.resolve(t).then(function(t) { c || (c = !0, u[i] = t, --n || r(u)) }, o)
                    }) : r(u)
                });
            return u && o(u.error), n.promise
        },
        race: function(t) {
            var e = P(this),
                n = new C(e),
                r = n.reject,
                i = N(function() { v(t, !1, function(t) { e.resolve(t).then(n.resolve, r) }) });
            return i && r(i.error), n.promise
        }
    })
}, function(t, e, n) {
    var r = n(1),
        i = Function.apply,
        o = n(5);
    r(r.S, "Reflect", { apply: function(t, e, n) { return i.call(t, e, o(n)) } })
}, function(t, e, n) {
    var r = n(3),
        i = n(1),
        o = n(27),
        c = n(5),
        u = n(4),
        a = Function.bind || n(23).Function.prototype.bind;
    i(i.S + i.F * n(9)(function() {
        function t() {}
        return !(Reflect.construct(function() {}, [], t) instanceof t)
    }), "Reflect", {
        construct: function(t, e) {
            o(t), c(e);
            var n = arguments.length < 3 ? t : o(arguments[2]);
            if (t == n) {
                switch (e.length) {
                    case 0:
                        return new t;
                    case 1:
                        return new t(e[0]);
                    case 2:
                        return new t(e[0], e[1]);
                    case 3:
                        return new t(e[0], e[1], e[2]);
                    case 4:
                        return new t(e[0], e[1], e[2], e[3])
                }
                var i = [null];
                return i.push.apply(i, e), new(a.apply(t, i))
            }
            var s = n.prototype,
                f = r.create(u(s) ? s : Object.prototype),
                l = Function.apply.call(t, f, e);
            return u(l) ? l : f
        }
    })
}, function(t, e, n) {
    var r = n(3),
        i = n(1),
        o = n(5);
    i(i.S + i.F * n(9)(function() { Reflect.defineProperty(r.setDesc({}, 1, { value: 1 }), 1, { value: 2 }) }), "Reflect", { defineProperty: function(t, e, n) { o(t); try { return r.setDesc(t, e, n), !0 } catch (i) { return !1 } } })
}, function(t, e, n) {
    var r = n(1),
        i = n(3).getDesc,
        o = n(5);
    r(r.S, "Reflect", { deleteProperty: function(t, e) { var n = i(o(t), e); return !(n && !n.configurable) && delete t[e] } })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(5),
        o = function(t) { this._t = i(t), this._i = 0; var e, n = this._k = []; for (e in t) n.push(e) };
    n(106)(o, "Object", function() {
        var t, e = this,
            n = e._k;
        do
            if (e._i >= n.length) return { value: void 0, done: !0 }; while (!((t = n[e._i++]) in e._t));
        return { value: t, done: !1 }
    }), r(r.S, "Reflect", { enumerate: function(t) { return new o(t) } })
}, function(t, e, n) {
    var r = n(3),
        i = n(1),
        o = n(5);
    i(i.S, "Reflect", { getOwnPropertyDescriptor: function(t, e) { return r.getDesc(o(t), e) } })
}, function(t, e, n) {
    var r = n(1),
        i = n(3).getProto,
        o = n(5);
    r(r.S, "Reflect", { getPrototypeOf: function(t) { return i(o(t)) } })
}, function(t, e, n) {
    function r(t, e) { var n, c, s = arguments.length < 3 ? t : arguments[2]; return a(t) === s ? t[e] : (n = i.getDesc(t, e)) ? o(n, "value") ? n.value : void 0 !== n.get ? n.get.call(s) : void 0 : u(c = i.getProto(t)) ? r(c, e, s) : void 0 }
    var i = n(3),
        o = n(10),
        c = n(1),
        u = n(4),
        a = n(5);
    c(c.S, "Reflect", { get: r })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Reflect", { has: function(t, e) { return e in t } })
}, function(t, e, n) {
    var r = n(1),
        i = n(5),
        o = Object.isExtensible;
    r(r.S, "Reflect", { isExtensible: function(t) { return i(t), !o || o(t) } })
}, function(t, e, n) {
    var r = n(1);
    r(r.S, "Reflect", { ownKeys: n(110) })
}, function(t, e, n) {
    var r = n(1),
        i = n(5),
        o = Object.preventExtensions;
    r(r.S, "Reflect", { preventExtensions: function(t) { i(t); try { return o && o(t), !0 } catch (e) { return !1 } } })
}, function(t, e, n) {
    var r = n(1),
        i = n(85);
    i && r(r.S, "Reflect", { setPrototypeOf: function(t, e) { i.check(t, e); try { return i.set(t, e), !0 } catch (n) { return !1 } } })
}, function(t, e, n) {
    function r(t, e, n) {
        var c, f, l = arguments.length < 4 ? t : arguments[3],
            h = i.getDesc(a(t), e);
        if (!h) {
            if (s(f = i.getProto(t))) return r(f, e, n, l);
            h = u(0)
        }
        return o(h, "value") ? !(h.writable === !1 || !s(l)) && (c = i.getDesc(l, e) || u(0), c.value = n, i.setDesc(l, e, c), !0) : void 0 !== h.set && (h.set.call(l, n), !0)
    }
    var i = n(3),
        o = n(10),
        c = n(1),
        u = n(25),
        a = n(5),
        s = n(4);
    c(c.S, "Reflect", { set: r })
}, function(t, e, n) {
    var r = n(3),
        i = n(7),
        o = n(104),
        c = n(99),
        u = i.RegExp,
        a = u,
        s = u.prototype,
        f = /a/g,
        l = /a/g,
        h = new u(f) !== f;
    !n(12) || h && !n(9)(function() { return l[n(6)("match")] = !1, u(f) != f || u(l) == l || "/a/i" != u(f, "i") }) || (u = function(t, e) {
        var n = o(t),
            r = void 0 === e;
        return this instanceof u || !n || t.constructor !== u || !r ? h ? new a(n && !r ? t.source : t, e) : a((n = t instanceof u) ? t.source : t, n && r ? c.call(t) : e) : t
    }, r.each.call(r.getNames(a), function(t) { t in u || r.setDesc(u, t, { configurable: !0, get: function() { return a[t] }, set: function(e) { a[t] = e } }) }), s.constructor = u, u.prototype = s, n(14)(i, "RegExp", u)), n(54)("RegExp")
}, function(t, e, n) {
    var r = n(3);
    n(12) && "g" != /./g.flags && r.setDesc(RegExp.prototype, "flags", { configurable: !0, get: n(99) })
}, function(t, e, n) {
    n(50)("match", 1, function(t, e) {
        return function(n) {
            "use strict";
            var r = t(this),
                i = void 0 == n ? void 0 : n[e];
            return void 0 !== i ? i.call(n, r) : new RegExp(n)[e](String(r))
        }
    })
}, function(t, e, n) {
    n(50)("replace", 2, function(t, e, n) {
        return function(r, i) {
            "use strict";
            var o = t(this),
                c = void 0 == r ? void 0 : r[e];
            return void 0 !== c ? c.call(r, o, i) : n.call(String(o), r, i)
        }
    })
}, function(t, e, n) {
    n(50)("search", 1, function(t, e) {
        return function(n) {
            "use strict";
            var r = t(this),
                i = void 0 == n ? void 0 : n[e];
            return void 0 !== i ? i.call(n, r) : new RegExp(n)[e](String(r))
        }
    })
}, function(t, e, n) {
    n(50)("split", 2, function(t, e, n) {
        return function(r, i) {
            "use strict";
            var o = t(this),
                c = void 0 == r ? void 0 : r[e];
            return void 0 !== c ? c.call(r, o, i) : n.call(String(o), r, i)
        }
    })
}, function(t, e, n) {
    "use strict";
    var r = n(95);
    n(49)("Set", function(t) { return function() { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { add: function(t) { return r.def(this, t = 0 === t ? 0 : t, t) } }, r)
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(86)(!1);
    r(r.P, "String", { codePointAt: function(t) { return i(this, t) } })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(11),
        o = n(87),
        c = "endsWith",
        u = "" [c];
    r(r.P + r.F * n(78)(c), "String", {
        endsWith: function(t) {
            var e = o(this, t, c),
                n = arguments,
                r = n.length > 1 ? n[1] : void 0,
                a = i(e.length),
                s = void 0 === r ? a : Math.min(i(r), a),
                f = String(t);
            return u ? u.call(e, f, s) : e.slice(s - f.length, s) === f
        }
    })
}, function(t, e, n) {
    var r = n(1),
        i = n(41),
        o = String.fromCharCode,
        c = String.fromCodePoint;
    r(r.S + r.F * (!!c && 1 != c.length), "String", {
        fromCodePoint: function(t) {
            for (var e, n = [], r = arguments, c = r.length, u = 0; c > u;) {
                if (e = +r[u++], i(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
                n.push(e < 65536 ? o(e) : o(((e -= 65536) >> 10) + 55296, e % 1024 + 56320))
            }
            return n.join("")
        }
    })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(87),
        o = "includes";
    r(r.P + r.F * n(78)(o), "String", { includes: function(t) { return !!~i(this, t, o).indexOf(t, arguments.length > 1 ? arguments[1] : void 0) } })
}, function(t, e, n) {
    "use strict";
    var r = n(86)(!0);
    n(80)(String, "String", function(t) { this._t = String(t), this._i = 0 }, function() {
        var t, e = this._t,
            n = this._i;
        return n >= e.length ? { value: void 0, done: !0 } : (t = r(e, n), this._i += t.length, { value: t, done: !1 })
    })
}, function(t, e, n) {
    var r = n(1),
        i = n(15),
        o = n(11);
    r(r.S, "String", { raw: function(t) { for (var e = i(t.raw), n = o(e.length), r = arguments, c = r.length, u = [], a = 0; n > a;) u.push(String(e[a++])), a < c && u.push(String(r[a])); return u.join("") } })
}, function(t, e, n) {
    var r = n(1);
    r(r.P, "String", { repeat: n(114) })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(11),
        o = n(87),
        c = "startsWith",
        u = "" [c];
    r(r.P + r.F * n(78)(c), "String", {
        startsWith: function(t) {
            var e = o(this, t, c),
                n = arguments,
                r = i(Math.min(n.length > 1 ? n[1] : void 0, e.length)),
                a = String(t);
            return u ? u.call(e, a, r) : e.slice(r, r + a.length) === a
        }
    })
}, function(t, e, n) {
    "use strict";
    n(56)("trim", function(t) { return function() { return t(this, 3) } })
}, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(7),
        o = n(10),
        c = n(12),
        u = n(1),
        a = n(14),
        s = n(9),
        f = n(112),
        l = n(40),
        h = n(29),
        p = n(6),
        v = n(175),
        d = n(100),
        g = n(174),
        y = n(79),
        m = n(5),
        b = n(15),
        A = n(25),
        S = r.getDesc,
        w = r.setDesc,
        x = r.create,
        E = d.get,
        _ = i.Symbol,
        z = i.JSON,
        M = z && z.stringify,
        P = !1,
        O = p("_hidden"),
        C = r.isEnum,
        N = f("symbol-registry"),
        T = f("symbols"),
        j = "function" == typeof _,
        F = Object.prototype,
        L = c && s(function() { return 7 != x(w({}, "a", { get: function() { return w(this, "a", { value: 7 }).a } })).a }) ? function(t, e, n) {
            var r = S(F, e);
            r && delete F[e], w(t, e, n), r && t !== F && w(F, e, r)
        } : w,
        R = function(t) { var e = T[t] = x(_.prototype); return e._k = t, c && P && L(F, t, { configurable: !0, set: function(e) { o(this, O) && o(this[O], t) && (this[O][t] = !1), L(this, t, A(1, e)) } }), e },
        D = function(t) { return "symbol" == typeof t },
        k = function(t, e, n) { return n && o(T, e) ? (n.enumerable ? (o(t, O) && t[O][e] && (t[O][e] = !1), n = x(n, { enumerable: A(0, !1) })) : (o(t, O) || w(t, O, A(1, {})), t[O][e] = !0), L(t, e, n)) : w(t, e, n) },
        I = function(t, e) { m(t); for (var n, r = g(e = b(e)), i = 0, o = r.length; o > i;) k(t, n = r[i++], e[n]); return t },
        W = function(t, e) { return void 0 === e ? x(t) : I(x(t), e) },
        B = function(t) { var e = C.call(this, t); return !(e || !o(this, t) || !o(T, t) || o(this, O) && this[O][t]) || e },
        G = function(t, e) { var n = S(t = b(t), e); return !n || !o(T, e) || o(t, O) && t[O][e] || (n.enumerable = !0), n },
        $ = function(t) { for (var e, n = E(b(t)), r = [], i = 0; n.length > i;) o(T, e = n[i++]) || e == O || r.push(e); return r },
        U = function(t) { for (var e, n = E(b(t)), r = [], i = 0; n.length > i;) o(T, e = n[i++]) && r.push(T[e]); return r },
        H = function(t) { if (void 0 !== t && !D(t)) { for (var e, n, r = [t], i = 1, o = arguments; o.length > i;) r.push(o[i++]); return e = r[1], "function" == typeof e && (n = e), !n && y(e) || (e = function(t, e) { if (n && (e = n.call(this, t, e)), !D(e)) return e }), r[1] = e, M.apply(z, r) } },
        K = s(function() { var t = _(); return "[null]" != M([t]) || "{}" != M({ a: t }) || "{}" != M(Object(t)) });
    j || (_ = function() { if (D(this)) throw TypeError("Symbol is not a constructor"); return R(h(arguments.length > 0 ? arguments[0] : void 0)) }, a(_.prototype, "toString", function() { return this._k }), D = function(t) { return t instanceof _ }, r.create = W, r.isEnum = B, r.getDesc = G, r.setDesc = k, r.setDescs = I, r.getNames = d.get = $, r.getSymbols = U, c && !n(82) && a(F, "propertyIsEnumerable", B, !0));
    var q = { "for": function(t) { return o(N, t += "") ? N[t] : N[t] = _(t) }, keyFor: function(t) { return v(N, t) }, useSetter: function() { P = !0 }, useSimple: function() { P = !1 } };
    r.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), function(t) {
        var e = p(t);
        q[t] = j ? e : R(e)
    }), P = !0, u(u.G + u.W, { Symbol: _ }), u(u.S, "Symbol", q), u(u.S + u.F * !j, "Object", { create: W, defineProperty: k, defineProperties: I, getOwnPropertyDescriptor: G, getOwnPropertyNames: $, getOwnPropertySymbols: U }), z && u(u.S + u.F * (!j || K), "JSON", { stringify: H }), l(_, "Symbol"), l(Math, "Math", !0), l(i.JSON, "JSON", !0)
}, function(t, e, n) {
    "use strict";
    var r = n(3),
        i = n(14),
        o = n(97),
        c = n(4),
        u = n(10),
        a = o.frozenStore,
        s = o.WEAK,
        f = Object.isExtensible || c,
        l = {},
        h = n(49)("WeakMap", function(t) { return function() { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { get: function(t) { if (c(t)) { if (!f(t)) return a(this).get(t); if (u(t, s)) return t[s][this._i] } }, set: function(t, e) { return o.def(this, t, e) } }, o, !0, !0);
    7 != (new h).set((Object.freeze || Object)(l), 7).get(l) && r.each.call(["delete", "has", "get", "set"], function(t) {
        var e = h.prototype,
            n = e[t];
        i(e, t, function(e, r) { if (c(e) && !f(e)) { var i = a(this)[t](e, r); return "set" == t ? this : i } return n.call(this, e, r) })
    })
}, function(t, e, n) {
    "use strict";
    var r = n(97);
    n(49)("WeakSet", function(t) { return function() { return t(this, arguments.length > 0 ? arguments[0] : void 0) } }, { add: function(t) { return r.def(this, t, !0) } }, r, !1, !0)
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(94)(!0);
    r(r.P, "Array", { includes: function(t) { return i(this, t, arguments.length > 1 ? arguments[1] : void 0) } }), n(28)("includes")
}, function(t, e, n) {
    var r = n(1);
    r(r.P, "Map", { toJSON: n(96)("Map") })
}, function(t, e, n) {
    var r = n(1),
        i = n(109)(!0);
    r(r.S, "Object", { entries: function(t) { return i(t) } })
}, function(t, e, n) {
    var r = n(3),
        i = n(1),
        o = n(110),
        c = n(15),
        u = n(25);
    i(i.S, "Object", { getOwnPropertyDescriptors: function(t) { for (var e, n, i = c(t), a = r.setDesc, s = r.getDesc, f = o(i), l = {}, h = 0; f.length > h;) n = s(i, e = f[h++]), e in l ? a(l, e, u(0, n)) : l[e] = n; return l } })
}, function(t, e, n) {
    var r = n(1),
        i = n(109)(!1);
    r(r.S, "Object", { values: function(t) { return i(t) } })
}, function(t, e, n) {
    var r = n(1),
        i = n(180)(/[\\^$*+?.()|[\]{}]/g, "\\$&");
    r(r.S, "RegExp", { escape: function(t) { return i(t) } })
}, function(t, e, n) {
    var r = n(1);
    r(r.P, "Set", { toJSON: n(96)("Set") })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(86)(!0);
    r(r.P, "String", { at: function(t) { return i(this, t) } })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(113);
    r(r.P, "String", { padLeft: function(t) { return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !0) } })
}, function(t, e, n) {
    "use strict";
    var r = n(1),
        i = n(113);
    r(r.P, "String", { padRight: function(t) { return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !1) } })
}, function(t, e, n) {
    "use strict";
    n(56)("trimLeft", function(t) { return function() { return t(this, 1) } })
}, function(t, e, n) {
    "use strict";
    n(56)("trimRight", function(t) { return function() { return t(this, 2) } })
}, function(t, e, n) {
    var r = n(3),
        i = n(1),
        o = n(17),
        c = n(23).Array || Array,
        u = {},
        a = function(t, e) { r.each.call(t.split(","), function(t) { void 0 == e && t in c ? u[t] = c[t] : t in [] && (u[t] = o(Function.call, [][t], e)) }) };
    a("pop,reverse,shift,keys,values,entries", 1), a("indexOf,every,some,forEach,map,filter,find,findIndex,includes", 3), a("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"), i(i.S, "Array", u)
}, function(t, e, n) {
    n(117);
    var r = n(7),
        i = n(19),
        o = n(39),
        c = n(6)("iterator"),
        u = r.NodeList,
        a = r.HTMLCollection,
        s = u && u.prototype,
        f = a && a.prototype,
        l = o.NodeList = o.HTMLCollection = o.Array;
    s && !s[c] && i(s, c, l), f && !f[c] && i(f, c, l)
}, function(t, e, n) {
    var r = n(1),
        i = n(115);
    r(r.G + r.B, { setImmediate: i.set, clearImmediate: i.clear })
}, function(t, e, n) {
    var r = n(7),
        i = n(1),
        o = n(51),
        c = n(178),
        u = r.navigator,
        a = !!u && /MSIE .\./.test(u.userAgent),
        s = function(t) { return a ? function(e, n) { return t(o(c, [].slice.call(arguments, 2), "function" == typeof e ? e : Function(e)), n) } : t };
    i(i.G + i.B + i.F * a, { setTimeout: s(r.setTimeout), setInterval: s(r.setInterval) })
}, function(t, e, n) { n(183), n(266), n(221), n(229), n(233), n(234), n(222), n(232), n(231), n(227), n(228), n(226), n(223), n(225), n(230), n(224), n(192), n(191), n(211), n(212), n(213), n(214), n(215), n(216), n(217), n(218), n(219), n(220), n(194), n(195), n(196), n(197), n(198), n(199), n(200), n(201), n(202), n(203), n(204), n(205), n(206), n(207), n(208), n(209), n(210), n(259), n(262), n(265), n(261), n(257), n(258), n(260), n(263), n(264), n(188), n(189), n(117), n(190), n(184), n(185), n(187), n(186), n(250), n(251), n(252), n(253), n(254), n(255), n(235), n(193), n(256), n(267), n(268), n(236), n(237), n(238), n(239), n(240), n(243), n(241), n(242), n(244), n(245), n(246), n(247), n(249), n(248), n(269), n(276), n(277), n(278), n(279), n(280), n(274), n(272), n(273), n(271), n(270), n(275), n(281), n(284), n(283), n(282), t.exports = n(23) }, , , , , , , function(t, e, n) {
    var r, i;
    ! function(o, c) {
        var u = c(o, o.document);
        o.lazySizes = u, "object" == typeof t && t.exports ? t.exports = u : n(300) && (r = u, i = "function" == typeof r ? r.call(e, n, e, t) : r, !(void 0 !== i && (t.exports = i)))
    }(window, function(t, e) {
        "use strict";
        if (e.getElementsByClassName) {
            var n, r = e.documentElement,
                i = t.HTMLPictureElement && "sizes" in e.createElement("img"),
                o = "addEventListener",
                c = "getAttribute",
                u = t[o],
                a = t.setTimeout,
                s = t.requestAnimationFrame || a,
                f = /^picture$/i,
                l = ["load", "error", "lazyincluded", "_lazyloaded"],
                h = {},
                p = Array.prototype.forEach,
                v = function(t, e) { return h[e] || (h[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), h[e].test(t[c]("class") || "") && h[e] },
                d = function(t, e) { v(t, e) || t.setAttribute("class", (t[c]("class") || "").trim() + " " + e) },
                g = function(t, e) {
                    var n;
                    (n = v(t, e)) && t.setAttribute("class", (t[c]("class") || "").replace(n, " "))
                },
                y = function(t, e, n) {
                    var r = n ? o : "removeEventListener";
                    n && y(t, e), l.forEach(function(n) { t[r](n, e) })
                },
                m = function(t, n, r, i, o) { var c = e.createEvent("CustomEvent"); return c.initCustomEvent(n, !i, !o, r || {}), t.dispatchEvent(c), c },
                b = function(e, r) { var o;!i && (o = t.picturefill || n.pf) ? o({ reevaluate: !0, elements: [e] }) : r && r.src && (e.src = r.src) },
                A = function(t, e) { return (getComputedStyle(t, null) || {})[e] },
                S = function(t, e, r) { for (r = r || t.offsetWidth; r < n.minSize && e && !t._lazysizesWidth;) r = e.offsetWidth, e = e.parentNode; return r },
                w = function(e) {
                    var n, r = 0,
                        i = t.Date,
                        o = function() { n = !1, r = i.now(), e() },
                        c = function() { a(o) },
                        u = function() { s(c) };
                    return function() {
                        if (!n) {
                            var t = 125 - (i.now() - r);
                            n = !0, 6 > t && (t = 6), a(u, t)
                        }
                    }
                },
                x = function() {
                    var i, l, h, S, x, _, z, M, P, O, C, N, T, j, F, L = /^img$/i,
                        R = /^iframe$/i,
                        D = "onscroll" in t && !/glebot/.test(navigator.userAgent),
                        k = 0,
                        I = 0,
                        W = 0,
                        B = 0,
                        G = function(t) { W--, t && t.target && y(t.target, G), (!t || 0 > W || !t.target) && (W = 0) },
                        $ = function(t, n) {
                            var i, o = t,
                                c = "hidden" == A(e.body, "visibility") || "hidden" != A(t, "visibility");
                            for (P -= n, N += n, O -= n, C += n; c && (o = o.offsetParent) && o != e.body && o != r;) c = (A(o, "opacity") || 1) > 0, c && "visible" != A(o, "overflow") && (i = o.getBoundingClientRect(), c = C > i.left && O < i.right && N > i.top - 1 && P < i.bottom + 1);
                            return c
                        },
                        U = function() {
                            var t, e, o, u, a, s, f, p, v;
                            if ((x = n.loadMode) && 8 > W && (t = i.length)) {
                                e = 0, B++, null == j && ("expand" in n || (n.expand = r.clientHeight > 600 ? r.clientWidth > 860 ? 500 : 410 : 359), T = n.expand, j = T * n.expFactor), j > I && 1 > W && B > 3 && x > 2 ? (I = j, B = 0) : I = x > 1 && B > 2 && 6 > W ? T : k;
                                for (; t > e; e++)
                                    if (i[e] && !i[e]._lazyRace)
                                        if (D)
                                            if ((p = i[e][c]("data-expand")) && (s = 1 * p) || (s = I), v !== s && (z = innerWidth + s * F, M = innerHeight + s, f = -1 * s, v = s), o = i[e].getBoundingClientRect(), (N = o.bottom) >= f && (P = o.top) <= M && (C = o.right) >= f * F && (O = o.left) <= z && (N || C || O || P) && (h && 3 > W && !p && (3 > x || 4 > B) || $(i[e], s))) { if (J(i[e]), a = !0, W > 9) break } else !a && h && !u && 4 > W && 4 > B && x > 2 && (l[0] || n.preloadAfterLoad) && (l[0] || !p && (N || C || O || P || "auto" != i[e][c](n.sizesAttr))) && (u = l[0] || i[e]);
                                else J(i[e]);
                                u && !a && J(u)
                            }
                        },
                        H = w(U),
                        K = function(t) { d(t.target, n.loadedClass), g(t.target, n.loadingClass), y(t.target, K) },
                        q = function(t, e) { try { t.contentWindow.location.replace(e) } catch (n) { t.src = e } },
                        Q = function(t) {
                            var e, r, i = t[c](n.srcsetAttr);
                            (e = n.customMedia[t[c]("data-media") || t[c]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i), e && (r = t.parentNode, r.insertBefore(t.cloneNode(), t), r.removeChild(t))
                        },
                        V = function() {
                            var t, e = [],
                                n = function() {
                                    for (; e.length;) e.shift()();
                                    t = !1
                                };
                            return function(r) { e.push(r), t || (t = !0, s(n)) }
                        }(),
                        J = function(t) {
                            var e, r, i, o, u, s, l, A = L.test(t.nodeName),
                                w = A && (t[c](n.sizesAttr) || t[c]("sizes")),
                                x = "auto" == w;
                            (!x && h || !A || !t.src && !t.srcset || t.complete || v(t, n.errorClass)) && (x && (l = t.offsetWidth), t._lazyRace = !0, W++, V(function() { t._lazyRace && delete t._lazyRace, (u = m(t, "lazybeforeunveil")).defaultPrevented || (w && (x ? (E.updateElem(t, !0, l), d(t, n.autosizesClass)) : t.setAttribute("sizes", w)), r = t[c](n.srcsetAttr), e = t[c](n.srcAttr), A && (i = t.parentNode, o = i && f.test(i.nodeName || "")), s = u.detail.firesLoad || "src" in t && (r || e || o), u = { target: t }, s && (y(t, G, !0), clearTimeout(S), S = a(G, 2500), d(t, n.loadingClass), y(t, K, !0)), o && p.call(i.getElementsByTagName("source"), Q), r ? t.setAttribute("srcset", r) : e && !o && (R.test(t.nodeName) ? q(t, e) : t.src = e), (r || o) && b(t, { src: e })), g(t, n.lazyClass), (!s || t.complete) && (s ? G(u) : W--, K(u)) }))
                        },
                        X = function() {
                            if (!h) {
                                if (Date.now() - _ < 999) return void a(X, 999);
                                var t, e = function() { n.loadMode = 3, H() };
                                h = !0, n.loadMode = 3, W || (B ? H() : a(U)), u("scroll", function() { 3 == n.loadMode && (n.loadMode = 2), clearTimeout(t), t = a(e, 99) }, !0)
                            }
                        };
                    return { _: function() { _ = Date.now(), i = e.getElementsByClassName(n.lazyClass), l = e.getElementsByClassName(n.lazyClass + " " + n.preloadClass), F = n.hFac, u("scroll", H, !0), u("resize", H, !0), t.MutationObserver ? new MutationObserver(H).observe(r, { childList: !0, subtree: !0, attributes: !0 }) : (r[o]("DOMNodeInserted", H, !0), r[o]("DOMAttrModified", H, !0), setInterval(H, 999)), u("hashchange", H, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) { e[o](t, H, !0) }), /d$|^c/.test(e.readyState) ? X() : (u("load", X), e[o]("DOMContentLoaded", H), a(X, 2e4)), H(i.length > 0) }, checkElems: H, unveil: J }
                }(),
                E = function() {
                    var t, r = function(t, e, n) {
                            var r, i, o, c, u = t.parentNode;
                            if (u && (n = S(t, u, n), c = m(t, "lazybeforesizes", { width: n, dataAttr: !!e }), !c.defaultPrevented && (n = c.detail.width, n && n !== t._lazysizesWidth))) {
                                if (t._lazysizesWidth = n, n += "px", t.setAttribute("sizes", n), f.test(u.nodeName || ""))
                                    for (r = u.getElementsByTagName("source"), i = 0, o = r.length; o > i; i++) r[i].setAttribute("sizes", n);
                                c.detail.dataAttr || b(t, c.detail)
                            }
                        },
                        i = function() {
                            var e, n = t.length;
                            if (n)
                                for (e = 0; n > e; e++) r(t[e])
                        },
                        o = w(i);
                    return { _: function() { t = e.getElementsByClassName(n.autosizesClass), u("resize", o) }, checkElems: o, updateElem: r }
                }(),
                _ = function() { _.i || (_.i = !0, E._(), x._()) };
            return function() {
                var e, r = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.7, hFac: .8, loadMode: 2 };
                n = t.lazySizesConfig || t.lazysizesConfig || {};
                for (e in r) e in n || (n[e] = r[e]);
                t.lazySizesConfig = n, a(function() { n.init && _() })
            }(), { cfg: n, autoSizer: E, loader: x, init: _, uP: b, aC: d, rC: g, hC: v, fire: m, gW: S }
        }
    })
}, function(t, e) {
    ! function() {
        "use strict";
        if (window.addEventListener) {
            var t = /\s+/g,
                e = /\s*\|\s+|\s+\|\s*/g,
                n = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                r = { contain: 1, cover: 1 },
                i = window.requestAnimationFrame || setTimeout,
                o = function(t) { var e = lazySizes.gW(t, t.parentNode); return (!t._lazysizesWidth || e > t._lazysizesWidth) && (t._lazysizesWidth = e), t._lazysizesWidth },
                c = function(i, o, c) {
                    var u = document.createElement("picture"),
                        a = o.getAttribute(lazySizesConfig.sizesAttr),
                        s = o.getAttribute("data-ratio"),
                        f = o.getAttribute("data-optimumx"),
                        l = (getComputedStyle(o) || { getPropertyValue: function() {} }).getPropertyValue("background-size");
                    !r[l] && r[o.style.backgroundSize] && (l = o.style.backgroundSize), !r[l] || "auto" != a && a || (c.setAttribute("data-parent-fit", l), a = "auto"), o._lazybgset && o._lazybgset.parentNode == o && o.removeChild(o._lazybgset), Object.defineProperty(c, "_lazybgset", { value: o, writable: !0 }), Object.defineProperty(o, "_lazybgset", { value: u, writable: !0 }), i = i.replace(t, " ").split(e), u.style.display = "none", c.className = lazySizesConfig.lazyClass, 1 != i.length || a || (a = "auto"), i.forEach(function(t) {
                        var e = document.createElement("source");
                        a && "auto" != a && e.setAttribute("sizes", a), t.match(n) && (e.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && e.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)), u.appendChild(e)
                    }), a && (c.setAttribute(lazySizesConfig.sizesAttr, a), o.removeAttribute(lazySizesConfig.sizesAttr), o.removeAttribute("sizes")), f && c.setAttribute("data-optimumx", f), s && c.setAttribute("data-ratio", s), u.appendChild(c), o.appendChild(u)
                },
                u = function(t) {
                    if (t.target._lazybgset) {
                        var e = t.target,
                            n = e._lazybgset,
                            r = e.currentSrc || e.src;
                        r && (n.style.backgroundImage = "url(" + r + ")"), e._lazybgsetLoading && (lazySizes.fire(n, "_lazyloaded", {}, !1, !0), delete e._lazybgsetLoading)
                    }
                };
            addEventListener("lazybeforeunveil", function(t) { var e, n, r;!t.defaultPrevented && (e = t.target.getAttribute("data-bgset")) && (r = t.target, n = document.createElement("img"), n.alt = "", n._lazybgsetLoading = !0, t.detail.firesLoad = !0, c(e, r, n), setTimeout(function() { lazySizes.loader.unveil(n), i(function() { lazySizes.fire(n, "_lazyloaded", {}, !0, !0), n.complete && u({ target: n }) }) })) }), document.addEventListener("load", u, !0), document.documentElement.addEventListener("lazybeforesizes", function(t) {!t.defaultPrevented && t.target._lazybgset && (t.detail.width = o(t.target._lazybgset)) })
        }
    }()
}, function(t, e, n) {
    var r;
    ! function(t) {
        var e = navigator.userAgent;
        t.HTMLPictureElement && /ecko/.test(e) && e.match(/rv\:(\d+)/) && RegExp.$1 < 45 && addEventListener("resize", function() {
            var e, n = document.createElement("source"),
                r = function(t) { var e, r, i = t.parentNode; "PICTURE" === i.nodeName.toUpperCase() ? (e = n.cloneNode(), i.insertBefore(e, i.firstElementChild), setTimeout(function() { i.removeChild(e) })) : (!t._pfLastSize || t.offsetWidth > t._pfLastSize) && (t._pfLastSize = t.offsetWidth, r = t.sizes, t.sizes += ",100vw", setTimeout(function() { t.sizes = r })) },
                i = function() { var t, e = document.querySelectorAll("picture > img, img[srcset][sizes]"); for (t = 0; t < e.length; t++) r(e[t]) },
                o = function() { clearTimeout(e), e = setTimeout(i, 99) },
                c = t.matchMedia && matchMedia("(orientation: landscape)"),
                u = function() { o(), c && c.addListener && c.addListener(o) };
            return n.srcset = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", /^[c|i]|d$/.test(document.readyState || "") ? u() : document.addEventListener("DOMContentLoaded", u), o
        }())
    }(window),
    function(i, o, c) {
        "use strict";

        function u(t) { return " " === t || "\t" === t || "\n" === t || "\f" === t || "\r" === t }

        function a(t, e) { var n = new i.Image; return n.onerror = function() { C[t] = !1, ot() }, n.onload = function() { C[t] = 1 === n.width, ot() }, n.src = e, "pending" }

        function s() { G = !1, H = i.devicePixelRatio, $ = {}, U = {}, w.DPR = H || 1, K.width = Math.max(i.innerWidth || 0, O.clientWidth), K.height = Math.max(i.innerHeight || 0, O.clientHeight), K.vw = K.width / 100, K.vh = K.height / 100, S = [K.height, K.width, H].join("-"), K.em = w.getEmValue(), K.rem = K.em; }

        function f(t, e, n, r) { var i, o, c, u; return "saveData" === N.algorithm ? t > 2.7 ? u = n + 1 : (o = e - n, i = Math.pow(t - .6, 1.5), c = o * i, r && (c += .1 * i), u = t + c) : u = n > 1 ? Math.sqrt(t * e) : t, u > n }

        function l(t) {
            var e, n = w.getSet(t),
                r = !1;
            "pending" !== n && (r = S, n && (e = w.setRes(n), w.applySetCandidate(e, t))), t[w.ns].evaled = r
        }

        function h(t, e) { return t.res - e.res }

        function p(t, e, n) { var r; return !n && e && (n = t[w.ns].sets, n = n && n[n.length - 1]), r = v(e, n), r && (e = w.makeUrl(e), t[w.ns].curSrc = e, t[w.ns].curCan = r, r.res || it(r, r.set.sizes)), r }

        function v(t, e) {
            var n, r, i;
            if (t && e)
                for (i = w.parseSet(e), t = w.makeUrl(t), n = 0; n < i.length; n++)
                    if (t === w.makeUrl(i[n].url)) { r = i[n]; break } return r
        }

        function d(t, e) { var n, r, i, o, c = t.getElementsByTagName("source"); for (n = 0, r = c.length; n < r; n++) i = c[n], i[w.ns] = !0, o = i.getAttribute("srcset"), o && e.push({ srcset: o, media: i.getAttribute("media"), type: i.getAttribute("type"), sizes: i.getAttribute("sizes") }) }

        function g(t, e) {
            function n(e) { var n, r = e.exec(t.substring(h)); if (r) return n = r[0], h += n.length, n }

            function r() {
                var t, n, r, i, u, a, s, f, l, h = !1,
                    v = {};
                for (i = 0; i < c.length; i++) u = c[i], a = u[u.length - 1], s = u.substring(0, u.length - 1), f = parseInt(s, 10), l = parseFloat(s), Z.test(s) && "w" === a ? ((t || n) && (h = !0), 0 === f ? h = !0 : t = f) : tt.test(s) && "x" === a ? ((t || n || r) && (h = !0), l < 0 ? h = !0 : n = l) : Z.test(s) && "h" === a ? ((r || n) && (h = !0), 0 === f ? h = !0 : r = f) : h = !0;
                h || (v.url = o, t && (v.w = t), n && (v.d = n), r && (v.h = r), r || n || t || (v.d = 1), 1 === v.d && (e.has1x = !0), v.set = e, p.push(v))
            }

            function i() {
                for (n(V), a = "", s = "in descriptor";;) {
                    if (f = t.charAt(h), "in descriptor" === s)
                        if (u(f)) a && (c.push(a), a = "", s = "after descriptor");
                        else {
                            if ("," === f) return h += 1, a && c.push(a), void r();
                            if ("(" === f) a += f, s = "in parens";
                            else {
                                if ("" === f) return a && c.push(a), void r();
                                a += f
                            }
                        }
                    else if ("in parens" === s)
                        if (")" === f) a += f, s = "in descriptor";
                        else {
                            if ("" === f) return c.push(a), void r();
                            a += f
                        }
                    else if ("after descriptor" === s)
                        if (u(f));
                        else {
                            if ("" === f) return void r();
                            s = "in descriptor", h -= 1
                        } h += 1
                }
            }
            for (var o, c, a, s, f, l = t.length, h = 0, p = [];;) {
                if (n(J), h >= l) return p;
                o = n(X), c = [], "," === o.slice(-1) ? (o = o.replace(Y, ""), r()) : i()
            }
        }

        function y(t) {
            function e(t) {
                function e() { i && (o.push(i), i = "") }

                function n() { o[0] && (c.push(o), o = []) }
                for (var r, i = "", o = [], c = [], a = 0, s = 0, f = !1;;) {
                    if (r = t.charAt(s), "" === r) return e(), n(), c;
                    if (f) { if ("*" === r && "/" === t[s + 1]) { f = !1, s += 2, e(); continue } s += 1 } else {
                        if (u(r)) { if (t.charAt(s - 1) && u(t.charAt(s - 1)) || !i) { s += 1; continue } if (0 === a) { e(), s += 1; continue } r = " " } else if ("(" === r) a += 1;
                        else if (")" === r) a -= 1;
                        else { if ("," === r) { e(), n(), s += 1; continue } if ("/" === r && "*" === t.charAt(s + 1)) { f = !0, s += 2; continue } } i += r, s += 1
                    }
                }
            }

            function n(t) { return !!(f.test(t) && parseFloat(t) >= 0) || (!!l.test(t) || ("0" === t || "-0" === t || "+0" === t)) }
            var r, i, o, c, a, s, f = /^(?:[+-]?[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?(?:ch|cm|em|ex|in|mm|pc|pt|px|rem|vh|vmin|vmax|vw)$/i,
                l = /^calc\((?:[0-9a-z \.\+\-\*\/\(\)]+)\)$/i;
            for (i = e(t), o = i.length, r = 0; r < o; r++)
                if (c = i[r], a = c[c.length - 1], n(a)) { if (s = a, c.pop(), 0 === c.length) return s; if (c = c.join(" "), w.matchesMedia(c)) return s } return "100vw"
        }
        o.createElement("picture");
        var m, b, A, S, w = {},
            x = !1,
            E = function() {},
            _ = o.createElement("img"),
            z = _.getAttribute,
            M = _.setAttribute,
            P = _.removeAttribute,
            O = o.documentElement,
            C = {},
            N = { algorithm: "" },
            T = "data-pfsrc",
            j = T + "set",
            F = navigator.userAgent,
            L = /rident/.test(F) || /ecko/.test(F) && F.match(/rv\:(\d+)/) && RegExp.$1 > 35,
            R = "currentSrc",
            D = /\s+\+?\d+(e\d+)?w/,
            k = /(\([^)]+\))?\s*(.+)/,
            I = i.picturefillCFG,
            W = "position:absolute;left:0;visibility:hidden;display:block;padding:0;border:none;font-size:1em;width:1em;overflow:hidden;clip:rect(0px, 0px, 0px, 0px)",
            B = "font-size:100%!important;",
            G = !0,
            $ = {},
            U = {},
            H = i.devicePixelRatio,
            K = { px: 1, "in": 96 },
            q = o.createElement("a"),
            Q = !1,
            V = /^[ \t\n\r\u000c]+/,
            J = /^[, \t\n\r\u000c]+/,
            X = /^[^ \t\n\r\u000c]+/,
            Y = /[,]+$/,
            Z = /^\d+$/,
            tt = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,
            et = function(t, e, n, r) { t.addEventListener ? t.addEventListener(e, n, r || !1) : t.attachEvent && t.attachEvent("on" + e, n) },
            nt = function(t) { var e = {}; return function(n) { return n in e || (e[n] = t(n)), e[n] } },
            rt = function() {
                var t = /^([\d\.]+)(em|vw|px)$/,
                    e = function() { for (var t = arguments, e = 0, n = t[0]; ++e in t;) n = n.replace(t[e], t[++e]); return n },
                    n = nt(function(t) { return "return " + e((t || "").toLowerCase(), /\band\b/g, "&&", /,/g, "||", /min-([a-z-\s]+):/g, "e.$1>=", /max-([a-z-\s]+):/g, "e.$1<=", /calc([^)]+)/g, "($1)", /(\d+[\.]*[\d]*)([a-z]+)/g, "($1 * e.$2)", /^(?!(e.[a-z]|[0-9\.&=|><\+\-\*\(\)\/])).*/gi, "") + ";" });
                return function(e, r) {
                    var i;
                    if (!(e in $))
                        if ($[e] = !1, r && (i = e.match(t))) $[e] = i[1] * K[i[2]];
                        else try { $[e] = new Function("e", n(e))(K) } catch (o) {}
                    return $[e]
                }
            }(),
            it = function(t, e) { return t.w ? (t.cWidth = w.calcListLength(e || "100vw"), t.res = t.w / t.cWidth) : t.res = t.d, t },
            ot = function(t) {
                if (x) {
                    var e, n, r, i = t || {};
                    if (i.elements && 1 === i.elements.nodeType && ("IMG" === i.elements.nodeName.toUpperCase() ? i.elements = [i.elements] : (i.context = i.elements, i.elements = null)), e = i.elements || w.qsa(i.context || o, i.reevaluate || i.reselect ? w.sel : w.selShort), r = e.length) {
                        for (w.setupRun(i), Q = !0, n = 0; n < r; n++) w.fillImg(e[n], i);
                        w.teardownRun(i)
                    }
                }
            };
        m = i.console && console.warn ? function(t) {} : E, R in _ || (R = "src"), C["image/jpeg"] = !0, C["image/gif"] = !0, C["image/png"] = !0, C["image/svg+xml"] = o.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"), w.ns = ("pf" + (new Date).getTime()).substr(0, 9), w.supSrcset = "srcset" in _, w.supSizes = "sizes" in _, w.supPicture = !!i.HTMLPictureElement, w.supSrcset && w.supPicture && !w.supSizes && ! function(t) { _.srcset = "data:,a", t.src = "data:,a", w.supSrcset = _.complete === t.complete, w.supPicture = w.supSrcset && w.supPicture }(o.createElement("img")), w.supSrcset && !w.supSizes ? ! function() {
            var t = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==",
                e = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                n = o.createElement("img"),
                r = function() {
                    var t = n.width;
                    2 === t && (w.supSizes = !0), A = w.supSrcset && !w.supSizes, x = !0, setTimeout(ot)
                };
            n.onload = r, n.onerror = r, n.setAttribute("sizes", "9px"), n.srcset = e + " 1w," + t + " 9w", n.src = e
        }() : x = !0, w.selShort = "picture>img,img[srcset]", w.sel = w.selShort, w.cfg = N, w.DPR = H || 1, w.u = K, w.types = C, w.setSize = E, w.makeUrl = nt(function(t) { return q.href = t, q.href }), w.qsa = function(t, e) { return "querySelector" in t ? t.querySelectorAll(e) : [] }, w.matchesMedia = function() { return i.matchMedia && (matchMedia("(min-width: 0.1em)") || {}).matches ? w.matchesMedia = function(t) { return !t || matchMedia(t).matches } : w.matchesMedia = w.mMQ, w.matchesMedia.apply(this, arguments) }, w.mMQ = function(t) { return !t || rt(t) }, w.calcLength = function(t) { var e = rt(t, !0) || !1; return e < 0 && (e = !1), e }, w.supportsType = function(t) { return !t || C[t] }, w.parseSize = nt(function(t) { var e = (t || "").match(k); return { media: e && e[1], length: e && e[2] } }), w.parseSet = function(t) { return t.cands || (t.cands = g(t.srcset, t)), t.cands }, w.getEmValue = function() {
            var t;
            if (!b && (t = o.body)) {
                var e = o.createElement("div"),
                    n = O.style.cssText,
                    r = t.style.cssText;
                e.style.cssText = W, O.style.cssText = B, t.style.cssText = B, t.appendChild(e), b = e.offsetWidth, t.removeChild(e), b = parseFloat(b, 10), O.style.cssText = n, t.style.cssText = r
            }
            return b || 16
        }, w.calcListLength = function(t) {
            if (!(t in U) || N.uT) {
                var e = w.calcLength(y(t));
                U[t] = e ? e : K.width
            }
            return U[t]
        }, w.setRes = function(t) { var e; if (t) { e = w.parseSet(t); for (var n = 0, r = e.length; n < r; n++) it(e[n], t.sizes) } return e }, w.setRes.res = it, w.applySetCandidate = function(t, e) {
            if (t.length) {
                var n, r, i, o, c, u, a, s, l, v = e[w.ns],
                    d = w.DPR;
                if (u = v.curSrc || e[R], a = v.curCan || p(e, u, t[0].set), a && a.set === t[0].set && (l = L && !e.complete && a.res - .1 > d, l || (a.cached = !0, a.res >= d && (c = a))), !c)
                    for (t.sort(h), o = t.length, c = t[o - 1], r = 0; r < o; r++)
                        if (n = t[r], n.res >= d) { i = r - 1, c = t[i] && (l || u !== w.makeUrl(n.url)) && f(t[i].res, n.res, d, t[i].cached) ? t[i] : n; break } c && (s = w.makeUrl(c.url), v.curSrc = s, v.curCan = c, s !== u && w.setSrc(e, c), w.setSize(e))
            }
        }, w.setSrc = function(t, e) {
            var n;
            t.src = e.url, "image/svg+xml" === e.set.type && (n = t.style.width, t.style.width = t.offsetWidth + 1 + "px", t.offsetWidth + 1 && (t.style.width = n))
        }, w.getSet = function(t) {
            var e, n, r, i = !1,
                o = t[w.ns].sets;
            for (e = 0; e < o.length && !i; e++)
                if (n = o[e], n.srcset && w.matchesMedia(n.media) && (r = w.supportsType(n.type))) { "pending" === r && (n = r), i = n; break } return i
        }, w.parseSets = function(t, e, n) {
            var r, i, o, u, a = e && "PICTURE" === e.nodeName.toUpperCase(),
                s = t[w.ns];
            (s.src === c || n.src) && (s.src = z.call(t, "src"), s.src ? M.call(t, T, s.src) : P.call(t, T)), (s.srcset === c || n.srcset || !w.supSrcset || t.srcset) && (r = z.call(t, "srcset"), s.srcset = r, u = !0), s.sets = [], a && (s.pic = !0, d(e, s.sets)), s.srcset ? (i = { srcset: s.srcset, sizes: z.call(t, "sizes") }, s.sets.push(i), o = (A || s.src) && D.test(s.srcset || ""), o || !s.src || v(s.src, i) || i.has1x || (i.srcset += ", " + s.src, i.cands.push({ url: s.src, d: 1, set: i }))) : s.src && s.sets.push({ srcset: s.src, sizes: null }), s.curCan = null, s.curSrc = c, s.supported = !(a || i && !w.supSrcset || o && !w.supSizes), u && w.supSrcset && !s.supported && (r ? (M.call(t, j, r), t.srcset = "") : P.call(t, j)), s.supported && !s.srcset && (!s.src && t.src || t.src !== w.makeUrl(s.src)) && (null === s.src ? t.removeAttribute("src") : t.src = s.src), s.parsed = !0
        }, w.fillImg = function(t, e) {
            var n, r = e.reselect || e.reevaluate;
            t[w.ns] || (t[w.ns] = {}), n = t[w.ns], (r || n.evaled !== S) && (n.parsed && !e.reevaluate || w.parseSets(t, t.parentNode, e), n.supported ? n.evaled = S : l(t))
        }, w.setupRun = function() { Q && !G && H === i.devicePixelRatio || s() }, w.supPicture ? (ot = E, w.fillImg = E) : ! function() {
            var t, e = i.attachEvent ? /d$|^c/ : /d$|^c|^i/,
                n = function() {
                    var i = o.readyState || "";
                    r = setTimeout(n, "loading" === i ? 200 : 999), o.body && (w.fillImgs(), t = t || e.test(i), t && clearTimeout(r))
                },
                r = setTimeout(n, o.body ? 9 : 99),
                c = function(t, e) {
                    var n, r, i = function() {
                        var o = new Date - r;
                        o < e ? n = setTimeout(i, e - o) : (n = null, t())
                    };
                    return function() { r = new Date, n || (n = setTimeout(i, e)) }
                },
                u = O.clientHeight,
                a = function() { G = Math.max(i.innerWidth || 0, O.clientWidth) !== K.width || O.clientHeight !== u, u = O.clientHeight, G && w.fillImgs() };
            et(i, "resize", c(a, 99)), et(o, "readystatechange", n)
        }(), w.picturefill = ot, w.fillImgs = ot, w.teardownRun = E, ot._ = w, i.picturefillCFG = { pf: w, push: function(t) { var e = t.shift(); "function" == typeof w[e] ? w[e].apply(w, t) : (N[e] = t[0], Q && w.fillImgs({ reselect: !0 })) } };
        for (; I && I.length;) i.picturefillCFG.push(I.shift());
        i.picturefill = ot, "object" == typeof t && "object" == typeof t.exports ? t.exports = ot : (r = function() { return ot }.call(e, n, e, t), !(r !== c && (t.exports = r))), w.supPicture || (C["image/webp"] = a("image/webp", "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA=="))
    }(window, document)
}, function(t, e) {
    function n() { throw new Error("setTimeout has not been defined") }

    function r() { throw new Error("clearTimeout has not been defined") }

    function i(t) { if (f === setTimeout) return setTimeout(t, 0); if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(t, 0); try { return f(t, 0) } catch (e) { try { return f.call(null, t, 0) } catch (e) { return f.call(this, t, 0) } } }

    function o(t) { if (l === clearTimeout) return clearTimeout(t); if ((l === r || !l) && clearTimeout) return l = clearTimeout, clearTimeout(t); try { return l(t) } catch (e) { try { return l.call(null, t) } catch (e) { return l.call(this, t) } } }

    function c() { d && p && (d = !1, p.length ? v = p.concat(v) : g = -1, v.length && u()) }

    function u() {
        if (!d) {
            var t = i(c);
            d = !0;
            for (var e = v.length; e;) {
                for (p = v, v = []; ++g < e;) p && p[g].run();
                g = -1, e = v.length
            }
            p = null, d = !1, o(t)
        }
    }

    function a(t, e) { this.fun = t, this.array = e }

    function s() {}
    var f, l, h = t.exports = {};
    ! function() { try { f = "function" == typeof setTimeout ? setTimeout : n } catch (t) { f = n } try { l = "function" == typeof clearTimeout ? clearTimeout : r } catch (t) { l = r } }();
    var p, v = [],
        d = !1,
        g = -1;
    h.nextTick = function(t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1)
            for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        v.push(new a(t, e)), 1 !== v.length || d || i(u)
    }, a.prototype.run = function() { this.fun.apply(null, this.array) }, h.title = "browser", h.browser = !0, h.env = {}, h.argv = [], h.version = "", h.versions = {}, h.on = s, h.addListener = s, h.once = s, h.off = s, h.removeListener = s, h.removeAllListeners = s, h.emit = s, h.prependListener = s, h.prependOnceListener = s, h.listeners = function(t) { return [] }, h.binding = function(t) { throw new Error("process.binding is not supported") }, h.cwd = function() { return "/" }, h.chdir = function(t) { throw new Error("process.chdir is not supported") }, h.umask = function() { return 0 }
}, , , , , function(t, e) {
    (function(e) { t.exports = e }).call(e, {})
}, , , , function(t, e, n) { t.exports = n(294) }]);
/*! jQuery v1.12.4 | (c) jQuery Foundation | jquery.org/license */
! function(a, b) { "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function(a) { if (!a.document) throw new Error("jQuery requires a window with a document"); return b(a) } : b(a) }("undefined" != typeof window ? window : this, function(a, b) {
    var c = [],
        d = a.document,
        e = c.slice,
        f = c.concat,
        g = c.push,
        h = c.indexOf,
        i = {},
        j = i.toString,
        k = i.hasOwnProperty,
        l = {},
        m = "1.12.4",
        n = function(a, b) { return new n.fn.init(a, b) },
        o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        p = /^-ms-/,
        q = /-([\da-z])/gi,
        r = function(a, b) { return b.toUpperCase() };
    n.fn = n.prototype = {
        jquery: m,
        constructor: n,
        selector: "",
        length: 0,
        toArray: function() { return e.call(this) },
        get: function(a) { return null != a ? 0 > a ? this[a + this.length] : this[a] : e.call(this) },
        pushStack: function(a) { var b = n.merge(this.constructor(), a); return b.prevObject = this, b.context = this.context, b },
        each: function(a) { return n.each(this, a) },
        map: function(a) { return this.pushStack(n.map(this, function(b, c) { return a.call(b, c, b) })) },
        slice: function() { return this.pushStack(e.apply(this, arguments)) },
        first: function() { return this.eq(0) },
        last: function() { return this.eq(-1) },
        eq: function(a) {
            var b = this.length,
                c = +a + (0 > a ? b : 0);
            return this.pushStack(c >= 0 && b > c ? [this[c]] : [])
        },
        end: function() { return this.prevObject || this.constructor() },
        push: g,
        sort: c.sort,
        splice: c.splice
    }, n.extend = n.fn.extend = function() {
        var a, b, c, d, e, f, g = arguments[0] || {},
            h = 1,
            i = arguments.length,
            j = !1;
        for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == typeof g || n.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++)
            if (null != (e = arguments[h]))
                for (d in e) a = g[d], c = e[d], g !== c && (j && c && (n.isPlainObject(c) || (b = n.isArray(c))) ? (b ? (b = !1, f = a && n.isArray(a) ? a : []) : f = a && n.isPlainObject(a) ? a : {}, g[d] = n.extend(j, f, c)) : void 0 !== c && (g[d] = c));
        return g
    }, n.extend({
        expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(a) { throw new Error(a) },
        noop: function() {},
        isFunction: function(a) { return "function" === n.type(a) },
        isArray: Array.isArray || function(a) { return "array" === n.type(a) },
        isWindow: function(a) { return null != a && a == a.window },
        isNumeric: function(a) { var b = a && a.toString(); return !n.isArray(a) && b - parseFloat(b) + 1 >= 0 },
        isEmptyObject: function(a) { var b; for (b in a) return !1; return !0 },
        isPlainObject: function(a) {
            var b;
            if (!a || "object" !== n.type(a) || a.nodeType || n.isWindow(a)) return !1;
            try { if (a.constructor && !k.call(a, "constructor") && !k.call(a.constructor.prototype, "isPrototypeOf")) return !1 } catch (c) { return !1 }
            if (!l.ownFirst)
                for (b in a) return k.call(a, b);
            for (b in a);
            return void 0 === b || k.call(a, b)
        },
        type: function(a) { return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? i[j.call(a)] || "object" : typeof a },
        globalEval: function(b) { b && n.trim(b) && (a.execScript || function(b) { a.eval.call(a, b) })(b) },
        camelCase: function(a) { return a.replace(p, "ms-").replace(q, r) },
        nodeName: function(a, b) { return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase() },
        each: function(a, b) {
            var c, d = 0;
            if (s(a)) {
                for (c = a.length; c > d; d++)
                    if (b.call(a[d], d, a[d]) === !1) break
            } else
                for (d in a)
                    if (b.call(a[d], d, a[d]) === !1) break;
            return a
        },
        trim: function(a) { return null == a ? "" : (a + "").replace(o, "") },
        makeArray: function(a, b) { var c = b || []; return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [a] : a) : g.call(c, a)), c },
        inArray: function(a, b, c) {
            var d;
            if (b) {
                if (h) return h.call(b, a, c);
                for (d = b.length, c = c ? 0 > c ? Math.max(0, d + c) : c : 0; d > c; c++)
                    if (c in b && b[c] === a) return c
            }
            return -1
        },
        merge: function(a, b) {
            var c = +b.length,
                d = 0,
                e = a.length;
            while (c > d) a[e++] = b[d++];
            if (c !== c)
                while (void 0 !== b[d]) a[e++] = b[d++];
            return a.length = e, a
        },
        grep: function(a, b, c) { for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) d = !b(a[f], f), d !== h && e.push(a[f]); return e },
        map: function(a, b, c) {
            var d, e, g = 0,
                h = [];
            if (s(a))
                for (d = a.length; d > g; g++) e = b(a[g], g, c), null != e && h.push(e);
            else
                for (g in a) e = b(a[g], g, c), null != e && h.push(e);
            return f.apply([], h)
        },
        guid: 1,
        proxy: function(a, b) { var c, d, f; return "string" == typeof b && (f = a[b], b = a, a = f), n.isFunction(a) ? (c = e.call(arguments, 2), d = function() { return a.apply(b || this, c.concat(e.call(arguments))) }, d.guid = a.guid = a.guid || n.guid++, d) : void 0 },
        now: function() { return +new Date },
        support: l
    }), "function" == typeof Symbol && (n.fn[Symbol.iterator] = c[Symbol.iterator]), n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(a, b) { i["[object " + b + "]"] = b.toLowerCase() });

    function s(a) {
        var b = !!a && "length" in a && a.length,
            c = n.type(a);
        return "function" === c || n.isWindow(a) ? !1 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a
    }
    var t = function(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u = "sizzle" + 1 * new Date,
            v = a.document,
            w = 0,
            x = 0,
            y = ga(),
            z = ga(),
            A = ga(),
            B = function(a, b) { return a === b && (l = !0), 0 },
            C = 1 << 31,
            D = {}.hasOwnProperty,
            E = [],
            F = E.pop,
            G = E.push,
            H = E.push,
            I = E.slice,
            J = function(a, b) {
                for (var c = 0, d = a.length; d > c; c++)
                    if (a[c] === b) return c;
                return -1
            },
            K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            L = "[\\x20\\t\\r\\n\\f]",
            M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            N = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + M + "))|)" + L + "*\\]",
            O = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + N + ")*)|.*)\\)|)",
            P = new RegExp(L + "+", "g"),
            Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
            R = new RegExp("^" + L + "*," + L + "*"),
            S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
            T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
            U = new RegExp(O),
            V = new RegExp("^" + M + "$"),
            W = { ID: new RegExp("^#(" + M + ")"), CLASS: new RegExp("^\\.(" + M + ")"), TAG: new RegExp("^(" + M + "|[*])"), ATTR: new RegExp("^" + N), PSEUDO: new RegExp("^" + O), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"), bool: new RegExp("^(?:" + K + ")$", "i"), needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i") },
            X = /^(?:input|select|textarea|button)$/i,
            Y = /^h\d$/i,
            Z = /^[^{]+\{\s*\[native \w/,
            $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            _ = /[+~]/,
            aa = /'|\\/g,
            ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
            ca = function(a, b, c) { var d = "0x" + b - 65536; return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320) },
            da = function() { m() };
        try { H.apply(E = I.call(v.childNodes), v.childNodes), E[v.childNodes.length].nodeType } catch (ea) {
            H = {
                apply: E.length ? function(a, b) { G.apply(a, I.call(b)) } : function(a, b) {
                    var c = a.length,
                        d = 0;
                    while (a[c++] = b[d++]);
                    a.length = c - 1
                }
            }
        }

        function fa(a, b, d, e) {
            var f, h, j, k, l, o, r, s, w = b && b.ownerDocument,
                x = b ? b.nodeType : 9;
            if (d = d || [], "string" != typeof a || !a || 1 !== x && 9 !== x && 11 !== x) return d;
            if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, p)) {
                if (11 !== x && (o = $.exec(a)))
                    if (f = o[1]) { if (9 === x) { if (!(j = b.getElementById(f))) return d; if (j.id === f) return d.push(j), d } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f) return d.push(j), d } else { if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d; if ((f = o[3]) && c.getElementsByClassName && b.getElementsByClassName) return H.apply(d, b.getElementsByClassName(f)), d } if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
                    if (1 !== x) w = b, s = a;
                    else if ("object" !== b.nodeName.toLowerCase()) {
                        (k = b.getAttribute("id")) ? k = k.replace(aa, "\\$&"): b.setAttribute("id", k = u), r = g(a), h = r.length, l = V.test(k) ? "#" + k : "[id='" + k + "']";
                        while (h--) r[h] = l + " " + qa(r[h]);
                        s = r.join(","), w = _.test(a) && oa(b.parentNode) || b
                    }
                    if (s) try { return H.apply(d, w.querySelectorAll(s)), d } catch (y) {} finally { k === u && b.removeAttribute("id") }
                }
            }
            return i(a.replace(Q, "$1"), b, d, e)
        }

        function ga() {
            var a = [];

            function b(c, e) { return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e }
            return b
        }

        function ha(a) { return a[u] = !0, a }

        function ia(a) { var b = n.createElement("div"); try { return !!a(b) } catch (c) { return !1 } finally { b.parentNode && b.parentNode.removeChild(b), b = null } }

        function ja(a, b) {
            var c = a.split("|"),
                e = c.length;
            while (e--) d.attrHandle[c[e]] = b
        }

        function ka(a, b) {
            var c = b && a,
                d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);
            if (d) return d;
            if (c)
                while (c = c.nextSibling)
                    if (c === b) return -1;
            return a ? 1 : -1
        }

        function la(a) { return function(b) { var c = b.nodeName.toLowerCase(); return "input" === c && b.type === a } }

        function ma(a) { return function(b) { var c = b.nodeName.toLowerCase(); return ("input" === c || "button" === c) && b.type === a } }

        function na(a) {
            return ha(function(b) {
                return b = +b, ha(function(c, d) {
                    var e, f = a([], c.length, b),
                        g = f.length;
                    while (g--) c[e = f[g]] && (c[e] = !(d[e] = c[e]))
                })
            })
        }

        function oa(a) { return a && "undefined" != typeof a.getElementsByTagName && a } c = fa.support = {}, f = fa.isXML = function(a) { var b = a && (a.ownerDocument || a).documentElement; return b ? "HTML" !== b.nodeName : !1 }, m = fa.setDocument = function(a) {
            var b, e, g = a ? a.ownerDocument || a : v;
            return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = n.documentElement, p = !f(n), (e = n.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", da, !1) : e.attachEvent && e.attachEvent("onunload", da)), c.attributes = ia(function(a) { return a.className = "i", !a.getAttribute("className") }), c.getElementsByTagName = ia(function(a) { return a.appendChild(n.createComment("")), !a.getElementsByTagName("*").length }), c.getElementsByClassName = Z.test(n.getElementsByClassName), c.getById = ia(function(a) { return o.appendChild(a).id = u, !n.getElementsByName || !n.getElementsByName(u).length }), c.getById ? (d.find.ID = function(a, b) { if ("undefined" != typeof b.getElementById && p) { var c = b.getElementById(a); return c ? [c] : [] } }, d.filter.ID = function(a) { var b = a.replace(ba, ca); return function(a) { return a.getAttribute("id") === b } }) : (delete d.find.ID, d.filter.ID = function(a) { var b = a.replace(ba, ca); return function(a) { var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id"); return c && c.value === b } }), d.find.TAG = c.getElementsByTagName ? function(a, b) { return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0 } : function(a, b) {
                var c, d = [],
                    e = 0,
                    f = b.getElementsByTagName(a);
                if ("*" === a) { while (c = f[e++]) 1 === c.nodeType && d.push(c); return d }
                return f
            }, d.find.CLASS = c.getElementsByClassName && function(a, b) { return "undefined" != typeof b.getElementsByClassName && p ? b.getElementsByClassName(a) : void 0 }, r = [], q = [], (c.qsa = Z.test(n.querySelectorAll)) && (ia(function(a) { o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]") }), ia(function(a) {
                var b = n.createElement("input");
                b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:")
            })), (c.matchesSelector = Z.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ia(function(a) { c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", O) }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = Z.test(o.compareDocumentPosition), t = b || Z.test(o.contains) ? function(a, b) {
                var c = 9 === a.nodeType ? a.documentElement : a,
                    d = b && b.parentNode;
                return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)))
            } : function(a, b) {
                if (b)
                    while (b = b.parentNode)
                        if (b === a) return !0;
                return !1
            }, B = b ? function(a, b) { if (a === b) return l = !0, 0; var d = !a.compareDocumentPosition - !b.compareDocumentPosition; return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === n || a.ownerDocument === v && t(v, a) ? -1 : b === n || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1) } : function(a, b) {
                if (a === b) return l = !0, 0;
                var c, d = 0,
                    e = a.parentNode,
                    f = b.parentNode,
                    g = [a],
                    h = [b];
                if (!e || !f) return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;
                if (e === f) return ka(a, b);
                c = a;
                while (c = c.parentNode) g.unshift(c);
                c = b;
                while (c = c.parentNode) h.unshift(c);
                while (g[d] === h[d]) d++;
                return d ? ka(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0
            }, n) : n
        }, fa.matches = function(a, b) { return fa(a, null, null, b) }, fa.matchesSelector = function(a, b) {
            if ((a.ownerDocument || a) !== n && m(a), b = b.replace(T, "='$1']"), c.matchesSelector && p && !A[b + " "] && (!r || !r.test(b)) && (!q || !q.test(b))) try { var d = s.call(a, b); if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d } catch (e) {}
            return fa(b, n, null, [a]).length > 0
        }, fa.contains = function(a, b) { return (a.ownerDocument || a) !== n && m(a), t(a, b) }, fa.attr = function(a, b) {
            (a.ownerDocument || a) !== n && m(a);
            var e = d.attrHandle[b.toLowerCase()],
                f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
            return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null
        }, fa.error = function(a) { throw new Error("Syntax error, unrecognized expression: " + a) }, fa.uniqueSort = function(a) {
            var b, d = [],
                e = 0,
                f = 0;
            if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) { while (b = a[f++]) b === a[f] && (e = d.push(f)); while (e--) a.splice(d[e], 1) }
            return k = null, a
        }, e = fa.getText = function(a) {
            var b, c = "",
                d = 0,
                f = a.nodeType;
            if (f) { if (1 === f || 9 === f || 11 === f) { if ("string" == typeof a.textContent) return a.textContent; for (a = a.firstChild; a; a = a.nextSibling) c += e(a) } else if (3 === f || 4 === f) return a.nodeValue } else
                while (b = a[d++]) c += e(b);
            return c
        }, d = fa.selectors = {
            cacheLength: 50,
            createPseudo: ha,
            match: W,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: { ATTR: function(a) { return a[1] = a[1].replace(ba, ca), a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4) }, CHILD: function(a) { return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || fa.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && fa.error(a[0]), a }, PSEUDO: function(a) { var b, c = !a[6] && a[2]; return W.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && U.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3)) } },
            filter: {
                TAG: function(a) { var b = a.replace(ba, ca).toLowerCase(); return "*" === a ? function() { return !0 } : function(a) { return a.nodeName && a.nodeName.toLowerCase() === b } },
                CLASS: function(a) { var b = y[a + " "]; return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) && y(a, function(a) { return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "") }) },
                ATTR: function(a, b, c) { return function(d) { var e = fa.attr(d, a); return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0 } },
                CHILD: function(a, b, c, d, e) {
                    var f = "nth" !== a.slice(0, 3),
                        g = "last" !== a.slice(-4),
                        h = "of-type" === b;
                    return 1 === d && 0 === e ? function(a) { return !!a.parentNode } : function(b, c, i) {
                        var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling",
                            q = b.parentNode,
                            r = h && b.nodeName.toLowerCase(),
                            s = !i && !h,
                            t = !1;
                        if (q) {
                            if (f) {
                                while (p) {
                                    m = b;
                                    while (m = m[p])
                                        if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
                                    o = p = "only" === a && !o && "nextSibling"
                                }
                                return !0
                            }
                            if (o = [g ? q.firstChild : q.lastChild], g && s) {
                                m = q, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n && j[2], m = n && q.childNodes[n];
                                while (m = ++n && m && m[p] || (t = n = 0) || o.pop())
                                    if (1 === m.nodeType && ++t && m === b) { k[a] = [w, n, t]; break }
                            } else if (s && (m = b, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n), t === !1)
                                while (m = ++n && m && m[p] || (t = n = 0) || o.pop())
                                    if ((h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) && ++t && (s && (l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [w, t]), m === b)) break;
                            return t -= e, t === d || t % d === 0 && t / d >= 0
                        }
                    }
                },
                PSEUDO: function(a, b) {
                    var c, e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || fa.error("unsupported pseudo: " + a);
                    return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ha(function(a, c) {
                        var d, f = e(a, b),
                            g = f.length;
                        while (g--) d = J(a, f[g]), a[d] = !(c[d] = f[g])
                    }) : function(a) { return e(a, 0, c) }) : e
                }
            },
            pseudos: {
                not: ha(function(a) {
                    var b = [],
                        c = [],
                        d = h(a.replace(Q, "$1"));
                    return d[u] ? ha(function(a, b, c, e) {
                        var f, g = d(a, null, e, []),
                            h = a.length;
                        while (h--)(f = g[h]) && (a[h] = !(b[h] = f))
                    }) : function(a, e, f) { return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop() }
                }),
                has: ha(function(a) { return function(b) { return fa(a, b).length > 0 } }),
                contains: ha(function(a) {
                    return a = a.replace(ba, ca),
                        function(b) { return (b.textContent || b.innerText || e(b)).indexOf(a) > -1 }
                }),
                lang: ha(function(a) {
                    return V.test(a || "") || fa.error("unsupported lang: " + a), a = a.replace(ba, ca).toLowerCase(),
                        function(b) {
                            var c;
                            do
                                if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-"); while ((b = b.parentNode) && 1 === b.nodeType);
                            return !1
                        }
                }),
                target: function(b) { var c = a.location && a.location.hash; return c && c.slice(1) === b.id },
                root: function(a) { return a === o },
                focus: function(a) { return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex) },
                enabled: function(a) { return a.disabled === !1 },
                disabled: function(a) { return a.disabled === !0 },
                checked: function(a) { var b = a.nodeName.toLowerCase(); return "input" === b && !!a.checked || "option" === b && !!a.selected },
                selected: function(a) { return a.parentNode && a.parentNode.selectedIndex, a.selected === !0 },
                empty: function(a) {
                    for (a = a.firstChild; a; a = a.nextSibling)
                        if (a.nodeType < 6) return !1;
                    return !0
                },
                parent: function(a) { return !d.pseudos.empty(a) },
                header: function(a) { return Y.test(a.nodeName) },
                input: function(a) { return X.test(a.nodeName) },
                button: function(a) { var b = a.nodeName.toLowerCase(); return "input" === b && "button" === a.type || "button" === b },
                text: function(a) { var b; return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase()) },
                first: na(function() { return [0] }),
                last: na(function(a, b) { return [b - 1] }),
                eq: na(function(a, b, c) { return [0 > c ? c + b : c] }),
                even: na(function(a, b) { for (var c = 0; b > c; c += 2) a.push(c); return a }),
                odd: na(function(a, b) { for (var c = 1; b > c; c += 2) a.push(c); return a }),
                lt: na(function(a, b, c) { for (var d = 0 > c ? c + b : c; --d >= 0;) a.push(d); return a }),
                gt: na(function(a, b, c) { for (var d = 0 > c ? c + b : c; ++d < b;) a.push(d); return a })
            }
        }, d.pseudos.nth = d.pseudos.eq;
        for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) d.pseudos[b] = la(b);
        for (b in { submit: !0, reset: !0 }) d.pseudos[b] = ma(b);

        function pa() {} pa.prototype = d.filters = d.pseudos, d.setFilters = new pa, g = fa.tokenize = function(a, b) {
            var c, e, f, g, h, i, j, k = z[a + " "];
            if (k) return b ? 0 : k.slice(0);
            h = a, i = [], j = d.preFilter;
            while (h) { c && !(e = R.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = S.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(Q, " ") }), h = h.slice(c.length)); for (g in d.filter) !(e = W[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length)); if (!c) break }
            return b ? h.length : h ? fa.error(a) : z(a, i).slice(0)
        };

        function qa(a) { for (var b = 0, c = a.length, d = ""; c > b; b++) d += a[b].value; return d }

        function ra(a, b, c) {
            var d = b.dir,
                e = c && "parentNode" === d,
                f = x++;
            return b.first ? function(b, c, f) {
                while (b = b[d])
                    if (1 === b.nodeType || e) return a(b, c, f)
            } : function(b, c, g) {
                var h, i, j, k = [w, f];
                if (g) {
                    while (b = b[d])
                        if ((1 === b.nodeType || e) && a(b, c, g)) return !0
                } else
                    while (b = b[d])
                        if (1 === b.nodeType || e) { if (j = b[u] || (b[u] = {}), i = j[b.uniqueID] || (j[b.uniqueID] = {}), (h = i[d]) && h[0] === w && h[1] === f) return k[2] = h[2]; if (i[d] = k, k[2] = a(b, c, g)) return !0 }
            }
        }

        function sa(a) {
            return a.length > 1 ? function(b, c, d) {
                var e = a.length;
                while (e--)
                    if (!a[e](b, c, d)) return !1;
                return !0
            } : a[0]
        }

        function ta(a, b, c) { for (var d = 0, e = b.length; e > d; d++) fa(a, b[d], c); return c }

        function ua(a, b, c, d, e) { for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)(f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h))); return g }

        function va(a, b, c, d, e, f) {
            return d && !d[u] && (d = va(d)), e && !e[u] && (e = va(e, f)), ha(function(f, g, h, i) {
                var j, k, l, m = [],
                    n = [],
                    o = g.length,
                    p = f || ta(b || "*", h.nodeType ? [h] : h, []),
                    q = !a || !f && b ? p : ua(p, m, a, h, i),
                    r = c ? e || (f ? a : o || d) ? [] : g : q;
                if (c && c(q, r, h, i), d) { j = ua(r, n), d(j, [], h, i), k = j.length; while (k--)(l = j[k]) && (r[n[k]] = !(q[n[k]] = l)) }
                if (f) {
                    if (e || a) {
                        if (e) {
                            j = [], k = r.length;
                            while (k--)(l = r[k]) && j.push(q[k] = l);
                            e(null, r = [], j, i)
                        }
                        k = r.length;
                        while (k--)(l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l))
                    }
                } else r = ua(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : H.apply(g, r)
            })
        }

        function wa(a) {
            for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = ra(function(a) { return a === b }, h, !0), l = ra(function(a) { return J(b, a) > -1 }, h, !0), m = [function(a, c, d) { var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d)); return b = null, e }]; f > i; i++)
                if (c = d.relative[a[i].type]) m = [ra(sa(m), c)];
                else {
                    if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
                        for (e = ++i; f > e; e++)
                            if (d.relative[a[e].type]) break;
                        return va(i > 1 && sa(m), i > 1 && qa(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(Q, "$1"), c, e > i && wa(a.slice(i, e)), f > e && wa(a = a.slice(e)), f > e && qa(a))
                    }
                    m.push(c)
                } return sa(m)
        }

        function xa(a, b) {
            var c = b.length > 0,
                e = a.length > 0,
                f = function(f, g, h, i, k) {
                    var l, o, q, r = 0,
                        s = "0",
                        t = f && [],
                        u = [],
                        v = j,
                        x = f || e && d.find.TAG("*", k),
                        y = w += null == v ? 1 : Math.random() || .1,
                        z = x.length;
                    for (k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++) {
                        if (e && l) {
                            o = 0, g || l.ownerDocument === n || (m(l), h = !p);
                            while (q = a[o++])
                                if (q(l, g || n, h)) { i.push(l); break } k && (w = y)
                        }
                        c && ((l = !q && l) && r--, f && t.push(l))
                    }
                    if (r += s, c && s !== r) {
                        o = 0;
                        while (q = b[o++]) q(t, u, g, h);
                        if (f) {
                            if (r > 0)
                                while (s--) t[s] || u[s] || (u[s] = F.call(i));
                            u = ua(u)
                        }
                        H.apply(i, u), k && !f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i)
                    }
                    return k && (w = y, j = v), t
                };
            return c ? ha(f) : f
        }
        return h = fa.compile = function(a, b) {
            var c, d = [],
                e = [],
                f = A[a + " "];
            if (!f) {
                b || (b = g(a)), c = b.length;
                while (c--) f = wa(b[c]), f[u] ? d.push(f) : e.push(f);
                f = A(a, xa(e, d)), f.selector = a
            }
            return f
        }, i = fa.select = function(a, b, e, f) {
            var i, j, k, l, m, n = "function" == typeof a && a,
                o = !f && g(a = n.selector || a);
            if (e = e || [], 1 === o.length) {
                if (j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
                    if (b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0], !b) return e;
                    n && (b = b.parentNode), a = a.slice(j.shift().value.length)
                }
                i = W.needsContext.test(a) ? 0 : j.length;
                while (i--) { if (k = j[i], d.relative[l = k.type]) break; if ((m = d.find[l]) && (f = m(k.matches[0].replace(ba, ca), _.test(j[0].type) && oa(b.parentNode) || b))) { if (j.splice(i, 1), a = f.length && qa(j), !a) return H.apply(e, f), e; break } }
            }
            return (n || h(a, o))(f, b, !p, e, !b || _.test(a) && oa(b.parentNode) || b), e
        }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ia(function(a) { return 1 & a.compareDocumentPosition(n.createElement("div")) }), ia(function(a) { return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href") }) || ja("type|href|height|width", function(a, b, c) { return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2) }), c.attributes && ia(function(a) { return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value") }) || ja("value", function(a, b, c) { return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue }), ia(function(a) { return null == a.getAttribute("disabled") }) || ja(K, function(a, b, c) { var d; return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null }), fa
    }(a);
    n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.uniqueSort = n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;
    var u = function(a, b, c) {
            var d = [],
                e = void 0 !== c;
            while ((a = a[b]) && 9 !== a.nodeType)
                if (1 === a.nodeType) {
                    if (e && n(a).is(c)) break;
                    d.push(a)
                } return d
        },
        v = function(a, b) { for (var c = []; a; a = a.nextSibling) 1 === a.nodeType && a !== b && c.push(a); return c },
        w = n.expr.match.needsContext,
        x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        y = /^.[^:#\[\.,]*$/;

    function z(a, b, c) {
        if (n.isFunction(b)) return n.grep(a, function(a, d) { return !!b.call(a, d, a) !== c });
        if (b.nodeType) return n.grep(a, function(a) { return a === b !== c });
        if ("string" == typeof b) {
            if (y.test(b)) return n.filter(b, a, c);
            b = n.filter(b, a)
        }
        return n.grep(a, function(a) { return n.inArray(a, b) > -1 !== c })
    }
    n.filter = function(a, b, c) { var d = b[0]; return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [d] : [] : n.find.matches(a, n.grep(b, function(a) { return 1 === a.nodeType })) }, n.fn.extend({
        find: function(a) {
            var b, c = [],
                d = this,
                e = d.length;
            if ("string" != typeof a) return this.pushStack(n(a).filter(function() {
                for (b = 0; e > b; b++)
                    if (n.contains(d[b], this)) return !0
            }));
            for (b = 0; e > b; b++) n.find(a, d[b], c);
            return c = this.pushStack(e > 1 ? n.unique(c) : c), c.selector = this.selector ? this.selector + " " + a : a, c
        },
        filter: function(a) { return this.pushStack(z(this, a || [], !1)) },
        not: function(a) { return this.pushStack(z(this, a || [], !0)) },
        is: function(a) { return !!z(this, "string" == typeof a && w.test(a) ? n(a) : a || [], !1).length }
    });
    var A, B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
        C = n.fn.init = function(a, b, c) {
            var e, f;
            if (!a) return this;
            if (c = c || A, "string" == typeof a) {
                if (e = "<" === a.charAt(0) && ">" === a.charAt(a.length - 1) && a.length >= 3 ? [null, a, null] : B.exec(a), !e || !e[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);
                if (e[1]) {
                    if (b = b instanceof n ? b[0] : b, n.merge(this, n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)), x.test(e[1]) && n.isPlainObject(b))
                        for (e in b) n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
                    return this
                }
                if (f = d.getElementById(e[2]), f && f.parentNode) {
                    if (f.id !== e[2]) return A.find(a);
                    this.length = 1, this[0] = f
                }
                return this.context = d, this.selector = a, this
            }
            return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : n.isFunction(a) ? "undefined" != typeof c.ready ? c.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), n.makeArray(a, this))
        };
    C.prototype = n.fn, A = n(d);
    var D = /^(?:parents|prev(?:Until|All))/,
        E = { children: !0, contents: !0, next: !0, prev: !0 };
    n.fn.extend({
        has: function(a) {
            var b, c = n(a, this),
                d = c.length;
            return this.filter(function() {
                for (b = 0; d > b; b++)
                    if (n.contains(this, c[b])) return !0
            })
        },
        closest: function(a, b) {
            for (var c, d = 0, e = this.length, f = [], g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++)
                for (c = this[d]; c && c !== b; c = c.parentNode)
                    if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) { f.push(c); break } return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f)
        },
        index: function(a) { return a ? "string" == typeof a ? n.inArray(this[0], n(a)) : n.inArray(a.jquery ? a[0] : a, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1 },
        add: function(a, b) { return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b)))) },
        addBack: function(a) { return this.add(null == a ? this.prevObject : this.prevObject.filter(a)) }
    });

    function F(a, b) { do a = a[b]; while (a && 1 !== a.nodeType); return a } n.each({ parent: function(a) { var b = a.parentNode; return b && 11 !== b.nodeType ? b : null }, parents: function(a) { return u(a, "parentNode") }, parentsUntil: function(a, b, c) { return u(a, "parentNode", c) }, next: function(a) { return F(a, "nextSibling") }, prev: function(a) { return F(a, "previousSibling") }, nextAll: function(a) { return u(a, "nextSibling") }, prevAll: function(a) { return u(a, "previousSibling") }, nextUntil: function(a, b, c) { return u(a, "nextSibling", c) }, prevUntil: function(a, b, c) { return u(a, "previousSibling", c) }, siblings: function(a) { return v((a.parentNode || {}).firstChild, a) }, children: function(a) { return v(a.firstChild) }, contents: function(a) { return n.nodeName(a, "iframe") ? a.contentDocument || a.contentWindow.document : n.merge([], a.childNodes) } }, function(a, b) { n.fn[a] = function(c, d) { var e = n.map(this, b, c); return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = n.filter(d, e)), this.length > 1 && (E[a] || (e = n.uniqueSort(e)), D.test(a) && (e = e.reverse())), this.pushStack(e) } });
    var G = /\S+/g;

    function H(a) { var b = {}; return n.each(a.match(G) || [], function(a, c) { b[c] = !0 }), b } n.Callbacks = function(a) {
        a = "string" == typeof a ? H(a) : n.extend({}, a);
        var b, c, d, e, f = [],
            g = [],
            h = -1,
            i = function() { for (e = a.once, d = b = !0; g.length; h = -1) { c = g.shift(); while (++h < f.length) f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && (h = f.length, c = !1) } a.memory || (c = !1), b = !1, e && (f = c ? [] : "") },
            j = { add: function() { return f && (c && !b && (h = f.length - 1, g.push(c)), function d(b) { n.each(b, function(b, c) { n.isFunction(c) ? a.unique && j.has(c) || f.push(c) : c && c.length && "string" !== n.type(c) && d(c) }) }(arguments), c && !b && i()), this }, remove: function() { return n.each(arguments, function(a, b) { var c; while ((c = n.inArray(b, f, c)) > -1) f.splice(c, 1), h >= c && h-- }), this }, has: function(a) { return a ? n.inArray(a, f) > -1 : f.length > 0 }, empty: function() { return f && (f = []), this }, disable: function() { return e = g = [], f = c = "", this }, disabled: function() { return !f }, lock: function() { return e = !0, c || j.disable(), this }, locked: function() { return !!e }, fireWith: function(a, c) { return e || (c = c || [], c = [a, c.slice ? c.slice() : c], g.push(c), b || i()), this }, fire: function() { return j.fireWith(this, arguments), this }, fired: function() { return !!d } };
        return j
    }, n.extend({
        Deferred: function(a) {
            var b = [
                    ["resolve", "done", n.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", n.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", n.Callbacks("memory")]
                ],
                c = "pending",
                d = {
                    state: function() { return c },
                    always: function() { return e.done(arguments).fail(arguments), this },
                    then: function() {
                        var a = arguments;
                        return n.Deferred(function(c) {
                            n.each(b, function(b, f) {
                                var g = n.isFunction(a[b]) && a[b];
                                e[f[1]](function() {
                                    var a = g && g.apply(this, arguments);
                                    a && n.isFunction(a.promise) ? a.promise().progress(c.notify).done(c.resolve).fail(c.reject) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments)
                                })
                            }), a = null
                        }).promise()
                    },
                    promise: function(a) { return null != a ? n.extend(a, d) : d }
                },
                e = {};
            return d.pipe = d.then, n.each(b, function(a, f) {
                var g = f[2],
                    h = f[3];
                d[f[1]] = g.add, h && g.add(function() { c = h }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function() { return e[f[0] + "With"](this === e ? d : this, arguments), this }, e[f[0] + "With"] = g.fireWith
            }), d.promise(e), a && a.call(e, e), e
        },
        when: function(a) {
            var b = 0,
                c = e.call(arguments),
                d = c.length,
                f = 1 !== d || a && n.isFunction(a.promise) ? d : 0,
                g = 1 === f ? a : n.Deferred(),
                h = function(a, b, c) { return function(d) { b[a] = this, c[a] = arguments.length > 1 ? e.call(arguments) : d, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c) } },
                i, j, k;
            if (d > 1)
                for (i = new Array(d), j = new Array(d), k = new Array(d); d > b; b++) c[b] && n.isFunction(c[b].promise) ? c[b].promise().progress(h(b, j, i)).done(h(b, k, c)).fail(g.reject) : --f;
            return f || g.resolveWith(k, c), g.promise()
        }
    });
    var I;
    n.fn.ready = function(a) { return n.ready.promise().done(a), this }, n.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(a) { a ? n.readyWait++ : n.ready(!0) },
        ready: function(a) {
            (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a !== !0 && --n.readyWait > 0 || (I.resolveWith(d, [n]), n.fn.triggerHandler && (n(d).triggerHandler("ready"), n(d).off("ready"))))
        }
    });

    function J() { d.addEventListener ? (d.removeEventListener("DOMContentLoaded", K), a.removeEventListener("load", K)) : (d.detachEvent("onreadystatechange", K), a.detachEvent("onload", K)) }

    function K() {
        (d.addEventListener || "load" === a.event.type || "complete" === d.readyState) && (J(), n.ready())
    }
    n.ready.promise = function(b) {
        if (!I)
            if (I = n.Deferred(), "complete" === d.readyState || "loading" !== d.readyState && !d.documentElement.doScroll) a.setTimeout(n.ready);
            else if (d.addEventListener) d.addEventListener("DOMContentLoaded", K), a.addEventListener("load", K);
        else { d.attachEvent("onreadystatechange", K), a.attachEvent("onload", K); var c = !1; try { c = null == a.frameElement && d.documentElement } catch (e) {} c && c.doScroll && ! function f() { if (!n.isReady) { try { c.doScroll("left") } catch (b) { return a.setTimeout(f, 50) } J(), n.ready() } }() }
        return I.promise(b)
    }, n.ready.promise();
    var L;
    for (L in n(l)) break;
    l.ownFirst = "0" === L, l.inlineBlockNeedsLayout = !1, n(function() {
            var a, b, c, e;
            c = d.getElementsByTagName("body")[0], c && c.style && (b = d.createElement("div"), e = d.createElement("div"), e.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c.appendChild(e).appendChild(b), "undefined" != typeof b.style.zoom && (b.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", l.inlineBlockNeedsLayout = a = 3 === b.offsetWidth, a && (c.style.zoom = 1)), c.removeChild(e))
        }),
        function() {
            var a = d.createElement("div");
            l.deleteExpando = !0;
            try { delete a.test } catch (b) { l.deleteExpando = !1 } a = null
        }();
    var M = function(a) {
            var b = n.noData[(a.nodeName + " ").toLowerCase()],
                c = +a.nodeType || 1;
            return 1 !== c && 9 !== c ? !1 : !b || b !== !0 && a.getAttribute("classid") === b
        },
        N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        O = /([A-Z])/g;

    function P(a, b, c) {
        if (void 0 === c && 1 === a.nodeType) {
            var d = "data-" + b.replace(O, "-$1").toLowerCase();
            if (c = a.getAttribute(d), "string" == typeof c) { try { c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : N.test(c) ? n.parseJSON(c) : c } catch (e) {} n.data(a, b, c) } else c = void 0;
        }
        return c
    }

    function Q(a) {
        var b;
        for (b in a)
            if (("data" !== b || !n.isEmptyObject(a[b])) && "toJSON" !== b) return !1;
        return !0
    }

    function R(a, b, d, e) {
        if (M(a)) {
            var f, g, h = n.expando,
                i = a.nodeType,
                j = i ? n.cache : a,
                k = i ? a[h] : a[h] && h;
            if (k && j[k] && (e || j[k].data) || void 0 !== d || "string" != typeof b) return k || (k = i ? a[h] = c.pop() || n.guid++ : h), j[k] || (j[k] = i ? {} : { toJSON: n.noop }), "object" != typeof b && "function" != typeof b || (e ? j[k] = n.extend(j[k], b) : j[k].data = n.extend(j[k].data, b)), g = j[k], e || (g.data || (g.data = {}), g = g.data), void 0 !== d && (g[n.camelCase(b)] = d), "string" == typeof b ? (f = g[b], null == f && (f = g[n.camelCase(b)])) : f = g, f
        }
    }

    function S(a, b, c) {
        if (M(a)) {
            var d, e, f = a.nodeType,
                g = f ? n.cache : a,
                h = f ? a[n.expando] : n.expando;
            if (g[h]) { if (b && (d = c ? g[h] : g[h].data)) { n.isArray(b) ? b = b.concat(n.map(b, n.camelCase)) : b in d ? b = [b] : (b = n.camelCase(b), b = b in d ? [b] : b.split(" ")), e = b.length; while (e--) delete d[b[e]]; if (c ? !Q(d) : !n.isEmptyObject(d)) return }(c || (delete g[h].data, Q(g[h]))) && (f ? n.cleanData([a], !0) : l.deleteExpando || g != g.window ? delete g[h] : g[h] = void 0) }
        }
    }
    n.extend({ cache: {}, noData: { "applet ": !0, "embed ": !0, "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" }, hasData: function(a) { return a = a.nodeType ? n.cache[a[n.expando]] : a[n.expando], !!a && !Q(a) }, data: function(a, b, c) { return R(a, b, c) }, removeData: function(a, b) { return S(a, b) }, _data: function(a, b, c) { return R(a, b, c, !0) }, _removeData: function(a, b) { return S(a, b, !0) } }), n.fn.extend({
            data: function(a, b) {
                var c, d, e, f = this[0],
                    g = f && f.attributes;
                if (void 0 === a) {
                    if (this.length && (e = n.data(f), 1 === f.nodeType && !n._data(f, "parsedAttrs"))) {
                        c = g.length;
                        while (c--) g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)), P(f, d, e[d])));
                        n._data(f, "parsedAttrs", !0)
                    }
                    return e
                }
                return "object" == typeof a ? this.each(function() { n.data(this, a) }) : arguments.length > 1 ? this.each(function() { n.data(this, a, b) }) : f ? P(f, a, n.data(f, a)) : void 0
            },
            removeData: function(a) { return this.each(function() { n.removeData(this, a) }) }
        }), n.extend({
            queue: function(a, b, c) { var d; return a ? (b = (b || "fx") + "queue", d = n._data(a, b), c && (!d || n.isArray(c) ? d = n._data(a, b, n.makeArray(c)) : d.push(c)), d || []) : void 0 },
            dequeue: function(a, b) {
                b = b || "fx";
                var c = n.queue(a, b),
                    d = c.length,
                    e = c.shift(),
                    f = n._queueHooks(a, b),
                    g = function() { n.dequeue(a, b) };
                "inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire()
            },
            _queueHooks: function(a, b) { var c = b + "queueHooks"; return n._data(a, c) || n._data(a, c, { empty: n.Callbacks("once memory").add(function() { n._removeData(a, b + "queue"), n._removeData(a, c) }) }) }
        }), n.fn.extend({
            queue: function(a, b) {
                var c = 2;
                return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function() {
                    var c = n.queue(this, a, b);
                    n._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a)
                })
            },
            dequeue: function(a) { return this.each(function() { n.dequeue(this, a) }) },
            clearQueue: function(a) { return this.queue(a || "fx", []) },
            promise: function(a, b) {
                var c, d = 1,
                    e = n.Deferred(),
                    f = this,
                    g = this.length,
                    h = function() {--d || e.resolveWith(f, [f]) };
                "string" != typeof a && (b = a, a = void 0), a = a || "fx";
                while (g--) c = n._data(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
                return h(), e.promise(b)
            }
        }),
        function() {
            var a;
            l.shrinkWrapBlocks = function() {
                if (null != a) return a;
                a = !1;
                var b, c, e;
                return c = d.getElementsByTagName("body")[0], c && c.style ? (b = d.createElement("div"), e = d.createElement("div"), e.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c.appendChild(e).appendChild(b), "undefined" != typeof b.style.zoom && (b.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", b.appendChild(d.createElement("div")).style.width = "5px", a = 3 !== b.offsetWidth), c.removeChild(e), a) : void 0
            }
        }();
    var T = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        U = new RegExp("^(?:([+-])=|)(" + T + ")([a-z%]*)$", "i"),
        V = ["Top", "Right", "Bottom", "Left"],
        W = function(a, b) { return a = b || a, "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a) };

    function X(a, b, c, d) {
        var e, f = 1,
            g = 20,
            h = d ? function() { return d.cur() } : function() { return n.css(a, b, "") },
            i = h(),
            j = c && c[3] || (n.cssNumber[b] ? "" : "px"),
            k = (n.cssNumber[b] || "px" !== j && +i) && U.exec(n.css(a, b));
        if (k && k[3] !== j) {
            j = j || k[3], c = c || [], k = +i || 1;
            do f = f || ".5", k /= f, n.style(a, b, k + j); while (f !== (f = h() / i) && 1 !== f && --g)
        }
        return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e
    }
    var Y = function(a, b, c, d, e, f, g) {
            var h = 0,
                i = a.length,
                j = null == c;
            if ("object" === n.type(c)) { e = !0; for (h in c) Y(a, b, h, c[h], !0, f, g) } else if (void 0 !== d && (e = !0, n.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function(a, b, c) { return j.call(n(a), c) })), b))
                for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
            return e ? a : j ? b.call(a) : i ? b(a[0], c) : f
        },
        Z = /^(?:checkbox|radio)$/i,
        $ = /<([\w:-]+)/,
        _ = /^$|\/(?:java|ecma)script/i,
        aa = /^\s+/,
        ba = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";

    function ca(a) {
        var b = ba.split("|"),
            c = a.createDocumentFragment();
        if (c.createElement)
            while (b.length) c.createElement(b.pop());
        return c
    }! function() {
        var a = d.createElement("div"),
            b = d.createDocumentFragment(),
            c = d.createElement("input");
        a.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", l.leadingWhitespace = 3 === a.firstChild.nodeType, l.tbody = !a.getElementsByTagName("tbody").length, l.htmlSerialize = !!a.getElementsByTagName("link").length, l.html5Clone = "<:nav></:nav>" !== d.createElement("nav").cloneNode(!0).outerHTML, c.type = "checkbox", c.checked = !0, b.appendChild(c), l.appendChecked = c.checked, a.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!a.cloneNode(!0).lastChild.defaultValue, b.appendChild(a), c = d.createElement("input"), c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), a.appendChild(c), l.checkClone = a.cloneNode(!0).cloneNode(!0).lastChild.checked, l.noCloneEvent = !!a.addEventListener, a[n.expando] = 1, l.attributes = !a.getAttribute(n.expando)
    }();
    var da = { option: [1, "<select multiple='multiple'>", "</select>"], legend: [1, "<fieldset>", "</fieldset>"], area: [1, "<map>", "</map>"], param: [1, "<object>", "</object>"], thead: [1, "<table>", "</table>"], tr: [2, "<table><tbody>", "</tbody></table>"], col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"] };
    da.optgroup = da.option, da.tbody = da.tfoot = da.colgroup = da.caption = da.thead, da.th = da.td;

    function ea(a, b) {
        var c, d, e = 0,
            f = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : void 0;
        if (!f)
            for (f = [], c = a.childNodes || a; null != (d = c[e]); e++) !b || n.nodeName(d, b) ? f.push(d) : n.merge(f, ea(d, b));
        return void 0 === b || b && n.nodeName(a, b) ? n.merge([a], f) : f
    }

    function fa(a, b) { for (var c, d = 0; null != (c = a[d]); d++) n._data(c, "globalEval", !b || n._data(b[d], "globalEval")) }
    var ga = /<|&#?\w+;/,
        ha = /<tbody/i;

    function ia(a) { Z.test(a.type) && (a.defaultChecked = a.checked) }

    function ja(a, b, c, d, e) {
        for (var f, g, h, i, j, k, m, o = a.length, p = ca(b), q = [], r = 0; o > r; r++)
            if (g = a[r], g || 0 === g)
                if ("object" === n.type(g)) n.merge(q, g.nodeType ? [g] : g);
                else if (ga.test(g)) {
            i = i || p.appendChild(b.createElement("div")), j = ($.exec(g) || ["", ""])[1].toLowerCase(), m = da[j] || da._default, i.innerHTML = m[1] + n.htmlPrefilter(g) + m[2], f = m[0];
            while (f--) i = i.lastChild;
            if (!l.leadingWhitespace && aa.test(g) && q.push(b.createTextNode(aa.exec(g)[0])), !l.tbody) { g = "table" !== j || ha.test(g) ? "<table>" !== m[1] || ha.test(g) ? 0 : i : i.firstChild, f = g && g.childNodes.length; while (f--) n.nodeName(k = g.childNodes[f], "tbody") && !k.childNodes.length && g.removeChild(k) } n.merge(q, i.childNodes), i.textContent = "";
            while (i.firstChild) i.removeChild(i.firstChild);
            i = p.lastChild
        } else q.push(b.createTextNode(g));
        i && p.removeChild(i), l.appendChecked || n.grep(ea(q, "input"), ia), r = 0;
        while (g = q[r++])
            if (d && n.inArray(g, d) > -1) e && e.push(g);
            else if (h = n.contains(g.ownerDocument, g), i = ea(p.appendChild(g), "script"), h && fa(i), c) { f = 0; while (g = i[f++]) _.test(g.type || "") && c.push(g) }
        return i = null, p
    }! function() {
        var b, c, e = d.createElement("div");
        for (b in { submit: !0, change: !0, focusin: !0 }) c = "on" + b, (l[b] = c in a) || (e.setAttribute(c, "t"), l[b] = e.attributes[c].expando === !1);
        e = null
    }();
    var ka = /^(?:input|select|textarea)$/i,
        la = /^key/,
        ma = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        na = /^(?:focusinfocus|focusoutblur)$/,
        oa = /^([^.]*)(?:\.(.+)|)/;

    function pa() { return !0 }

    function qa() { return !1 }

    function ra() { try { return d.activeElement } catch (a) {} }

    function sa(a, b, c, d, e, f) {
        var g, h;
        if ("object" == typeof b) { "string" != typeof c && (d = d || c, c = void 0); for (h in b) sa(a, h, c, d, b[h], f); return a }
        if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = qa;
        else if (!e) return a;
        return 1 === f && (g = e, e = function(a) { return n().off(a), g.apply(this, arguments) }, e.guid = g.guid || (g.guid = n.guid++)), a.each(function() { n.event.add(this, b, e, d, c) })
    }
    n.event = {
        global: {},
        add: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = n._data(a);
            if (r) {
                c.handler && (i = c, c = i.handler, e = i.selector), c.guid || (c.guid = n.guid++), (g = r.events) || (g = r.events = {}), (k = r.handle) || (k = r.handle = function(a) { return "undefined" == typeof n || a && n.event.triggered === a.type ? void 0 : n.event.dispatch.apply(k.elem, arguments) }, k.elem = a), b = (b || "").match(G) || [""], h = b.length;
                while (h--) f = oa.exec(b[h]) || [], o = q = f[1], p = (f[2] || "").split(".").sort(), o && (j = n.event.special[o] || {}, o = (e ? j.delegateType : j.bindType) || o, j = n.event.special[o] || {}, l = n.extend({ type: o, origType: q, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && n.expr.match.needsContext.test(e), namespace: p.join(".") }, i), (m = g[o]) || (m = g[o] = [], m.delegateCount = 0, j.setup && j.setup.call(a, d, p, k) !== !1 || (a.addEventListener ? a.addEventListener(o, k, !1) : a.attachEvent && a.attachEvent("on" + o, k))), j.add && (j.add.call(a, l), l.handler.guid || (l.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, l) : m.push(l), n.event.global[o] = !0);
                a = null
            }
        },
        remove: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = n.hasData(a) && n._data(a);
            if (r && (k = r.events)) {
                b = (b || "").match(G) || [""], j = b.length;
                while (j--)
                    if (h = oa.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o) {
                        l = n.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, m = k[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), i = f = m.length;
                        while (f--) g = m[f], !e && q !== g.origType || c && c.guid !== g.guid || h && !h.test(g.namespace) || d && d !== g.selector && ("**" !== d || !g.selector) || (m.splice(f, 1), g.selector && m.delegateCount--, l.remove && l.remove.call(a, g));
                        i && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle), delete k[o])
                    } else
                        for (o in k) n.event.remove(a, o + b[j], c, d, !0);
                n.isEmptyObject(k) && (delete r.handle, n._removeData(a, "events"))
            }
        },
        trigger: function(b, c, e, f) {
            var g, h, i, j, l, m, o, p = [e || d],
                q = k.call(b, "type") ? b.type : b,
                r = k.call(b, "namespace") ? b.namespace.split(".") : [];
            if (i = m = e = e || d, 3 !== e.nodeType && 8 !== e.nodeType && !na.test(q + n.event.triggered) && (q.indexOf(".") > -1 && (r = q.split("."), q = r.shift(), r.sort()), h = q.indexOf(":") < 0 && "on" + q, b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b), b.isTrigger = f ? 2 : 3, b.namespace = r.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = e), c = null == c ? [b] : n.makeArray(c, [b]), l = n.event.special[q] || {}, f || !l.trigger || l.trigger.apply(e, c) !== !1)) {
                if (!f && !l.noBubble && !n.isWindow(e)) {
                    for (j = l.delegateType || q, na.test(j + q) || (i = i.parentNode); i; i = i.parentNode) p.push(i), m = i;
                    m === (e.ownerDocument || d) && p.push(m.defaultView || m.parentWindow || a)
                }
                o = 0;
                while ((i = p[o++]) && !b.isPropagationStopped()) b.type = o > 1 ? j : l.bindType || q, g = (n._data(i, "events") || {})[b.type] && n._data(i, "handle"), g && g.apply(i, c), g = h && i[h], g && g.apply && M(i) && (b.result = g.apply(i, c), b.result === !1 && b.preventDefault());
                if (b.type = q, !f && !b.isDefaultPrevented() && (!l._default || l._default.apply(p.pop(), c) === !1) && M(e) && h && e[q] && !n.isWindow(e)) { m = e[h], m && (e[h] = null), n.event.triggered = q; try { e[q]() } catch (s) {} n.event.triggered = void 0, m && (e[h] = m) }
                return b.result
            }
        },
        dispatch: function(a) {
            a = n.event.fix(a);
            var b, c, d, f, g, h = [],
                i = e.call(arguments),
                j = (n._data(this, "events") || {})[a.type] || [],
                k = n.event.special[a.type] || {};
            if (i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1) { h = n.event.handlers.call(this, a, j), b = 0; while ((f = h[b++]) && !a.isPropagationStopped()) { a.currentTarget = f.elem, c = 0; while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped()) a.rnamespace && !a.rnamespace.test(g.namespace) || (a.handleObj = g, a.data = g.data, d = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== d && (a.result = d) === !1 && (a.preventDefault(), a.stopPropagation())) } return k.postDispatch && k.postDispatch.call(this, a), a.result }
        },
        handlers: function(a, b) {
            var c, d, e, f, g = [],
                h = b.delegateCount,
                i = a.target;
            if (h && i.nodeType && ("click" !== a.type || isNaN(a.button) || a.button < 1))
                for (; i != this; i = i.parentNode || this)
                    if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
                        for (d = [], c = 0; h > c; c++) f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) > -1 : n.find(e, this, null, [i]).length), d[e] && d.push(f);
                        d.length && g.push({ elem: i, handlers: d })
                    } return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g
        },
        fix: function(a) {
            if (a[n.expando]) return a;
            var b, c, e, f = a.type,
                g = a,
                h = this.fixHooks[f];
            h || (this.fixHooks[f] = h = ma.test(f) ? this.mouseHooks : la.test(f) ? this.keyHooks : {}), e = h.props ? this.props.concat(h.props) : this.props, a = new n.Event(g), b = e.length;
            while (b--) c = e[b], a[c] = g[c];
            return a.target || (a.target = g.srcElement || d), 3 === a.target.nodeType && (a.target = a.target.parentNode), a.metaKey = !!a.metaKey, h.filter ? h.filter(a, g) : a
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: { props: "char charCode key keyCode".split(" "), filter: function(a, b) { return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a } },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(a, b) {
                var c, e, f, g = b.button,
                    h = b.fromElement;
                return null == a.pageX && null != b.clientX && (e = a.target.ownerDocument || d, f = e.documentElement, c = e.body, a.pageX = b.clientX + (f && f.scrollLeft || c && c.scrollLeft || 0) - (f && f.clientLeft || c && c.clientLeft || 0), a.pageY = b.clientY + (f && f.scrollTop || c && c.scrollTop || 0) - (f && f.clientTop || c && c.clientTop || 0)), !a.relatedTarget && h && (a.relatedTarget = h === a.target ? b.toElement : h), a.which || void 0 === g || (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0), a
            }
        },
        special: { load: { noBubble: !0 }, focus: { trigger: function() { if (this !== ra() && this.focus) try { return this.focus(), !1 } catch (a) {} }, delegateType: "focusin" }, blur: { trigger: function() { return this === ra() && this.blur ? (this.blur(), !1) : void 0 }, delegateType: "focusout" }, click: { trigger: function() { return n.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0 }, _default: function(a) { return n.nodeName(a.target, "a") } }, beforeunload: { postDispatch: function(a) { void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result) } } },
        simulate: function(a, b, c) {
            var d = n.extend(new n.Event, c, { type: a, isSimulated: !0 });
            n.event.trigger(d, null, b), d.isDefaultPrevented() && c.preventDefault()
        }
    }, n.removeEvent = d.removeEventListener ? function(a, b, c) { a.removeEventListener && a.removeEventListener(b, c) } : function(a, b, c) {
        var d = "on" + b;
        a.detachEvent && ("undefined" == typeof a[d] && (a[d] = null), a.detachEvent(d, c))
    }, n.Event = function(a, b) { return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? pa : qa) : this.type = a, b && n.extend(this, b), this.timeStamp = a && a.timeStamp || n.now(), void(this[n.expando] = !0)) : new n.Event(a, b) }, n.Event.prototype = {
        constructor: n.Event,
        isDefaultPrevented: qa,
        isPropagationStopped: qa,
        isImmediatePropagationStopped: qa,
        preventDefault: function() {
            var a = this.originalEvent;
           // this.isDefaultPrevented = pa, a && (a.preventDefault ? a.preventDefault() : a.returnValue = !1)
        },
        stopPropagation: function() {
            var a = this.originalEvent;
            this.isPropagationStopped = pa, a && !this.isSimulated && (a.stopPropagation && a.stopPropagation(), a.cancelBubble = !0)
        },
        stopImmediatePropagation: function() {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = pa, a && a.stopImmediatePropagation && a.stopImmediatePropagation(), this.stopPropagation()
        }
    }, n.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(a, b) {
        n.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function(a) {
                var c, d = this,
                    e = a.relatedTarget,
                    f = a.handleObj;
                return e && (e === d || n.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c
            }
        }
    }), l.submit || (n.event.special.submit = {
        setup: function() {
            return n.nodeName(this, "form") ? !1 : void n.event.add(this, "click._submit keypress._submit", function(a) {
                var b = a.target,
                    c = n.nodeName(b, "input") || n.nodeName(b, "button") ? n.prop(b, "form") : void 0;
                c && !n._data(c, "submit") && (n.event.add(c, "submit._submit", function(a) { a._submitBubble = !0 }), n._data(c, "submit", !0))
            })
        },
        postDispatch: function(a) { a._submitBubble && (delete a._submitBubble, this.parentNode && !a.isTrigger && n.event.simulate("submit", this.parentNode, a)) },
        teardown: function() { return n.nodeName(this, "form") ? !1 : void n.event.remove(this, "._submit") }
    }), l.change || (n.event.special.change = {
        setup: function() {
            return ka.test(this.nodeName) ? ("checkbox" !== this.type && "radio" !== this.type || (n.event.add(this, "propertychange._change", function(a) { "checked" === a.originalEvent.propertyName && (this._justChanged = !0) }), n.event.add(this, "click._change", function(a) { this._justChanged && !a.isTrigger && (this._justChanged = !1), n.event.simulate("change", this, a) })), !1) : void n.event.add(this, "beforeactivate._change", function(a) {
                var b = a.target;
                ka.test(b.nodeName) && !n._data(b, "change") && (n.event.add(b, "change._change", function(a) {!this.parentNode || a.isSimulated || a.isTrigger || n.event.simulate("change", this.parentNode, a) }), n._data(b, "change", !0))
            })
        },
        handle: function(a) { var b = a.target; return this !== b || a.isSimulated || a.isTrigger || "radio" !== b.type && "checkbox" !== b.type ? a.handleObj.handler.apply(this, arguments) : void 0 },
        teardown: function() { return n.event.remove(this, "._change"), !ka.test(this.nodeName) }
    }), l.focusin || n.each({ focus: "focusin", blur: "focusout" }, function(a, b) {
        var c = function(a) { n.event.simulate(b, a.target, n.event.fix(a)) };
        n.event.special[b] = {
            setup: function() {
                var d = this.ownerDocument || this,
                    e = n._data(d, b);
                e || d.addEventListener(a, c, !0), n._data(d, b, (e || 0) + 1)
            },
            teardown: function() {
                var d = this.ownerDocument || this,
                    e = n._data(d, b) - 1;
                e ? n._data(d, b, e) : (d.removeEventListener(a, c, !0), n._removeData(d, b))
            }
        }
    }), n.fn.extend({ on: function(a, b, c, d) { return sa(this, a, b, c, d) }, one: function(a, b, c, d) { return sa(this, a, b, c, d, 1) }, off: function(a, b, c) { var d, e; if (a && a.preventDefault && a.handleObj) return d = a.handleObj, n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this; if ("object" == typeof a) { for (e in a) this.off(e, b, a[e]); return this } return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = qa), this.each(function() { n.event.remove(this, a, c, b) }) }, trigger: function(a, b) { return this.each(function() { n.event.trigger(a, b, this) }) }, triggerHandler: function(a, b) { var c = this[0]; return c ? n.event.trigger(a, b, c, !0) : void 0 } });
    var ta = / jQuery\d+="(?:null|\d+)"/g,
        ua = new RegExp("<(?:" + ba + ")[\\s/>]", "i"),
        va = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        wa = /<script|<style|<link/i,
        xa = /checked\s*(?:[^=]|=\s*.checked.)/i,
        ya = /^true\/(.*)/,
        za = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
        Aa = ca(d),
        Ba = Aa.appendChild(d.createElement("div"));

    function Ca(a, b) { return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a }

    function Da(a) { return a.type = (null !== n.find.attr(a, "type")) + "/" + a.type, a }

    function Ea(a) { var b = ya.exec(a.type); return b ? a.type = b[1] : a.removeAttribute("type"), a }

    function Fa(a, b) {
        if (1 === b.nodeType && n.hasData(a)) {
            var c, d, e, f = n._data(a),
                g = n._data(b, f),
                h = f.events;
            if (h) {
                delete g.handle, g.events = {};
                for (c in h)
                    for (d = 0, e = h[c].length; e > d; d++) n.event.add(b, c, h[c][d])
            }
            g.data && (g.data = n.extend({}, g.data))
        }
    }

    function Ga(a, b) {
        var c, d, e;
        if (1 === b.nodeType) {
            if (c = b.nodeName.toLowerCase(), !l.noCloneEvent && b[n.expando]) {
                e = n._data(b);
                for (d in e.events) n.removeEvent(b, d, e.handle);
                b.removeAttribute(n.expando)
            }
            "script" === c && b.text !== a.text ? (Da(b).text = a.text, Ea(b)) : "object" === c ? (b.parentNode && (b.outerHTML = a.outerHTML), l.html5Clone && a.innerHTML && !n.trim(b.innerHTML) && (b.innerHTML = a.innerHTML)) : "input" === c && Z.test(a.type) ? (b.defaultChecked = b.checked = a.checked, b.value !== a.value && (b.value = a.value)) : "option" === c ? b.defaultSelected = b.selected = a.defaultSelected : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue)
        }
    }

    function Ha(a, b, c, d) {
        b = f.apply([], b);
        var e, g, h, i, j, k, m = 0,
            o = a.length,
            p = o - 1,
            q = b[0],
            r = n.isFunction(q);
        if (r || o > 1 && "string" == typeof q && !l.checkClone && xa.test(q)) return a.each(function(e) {
            var f = a.eq(e);
            r && (b[0] = q.call(this, e, f.html())), Ha(f, b, c, d)
        });
        if (o && (k = ja(b, a[0].ownerDocument, !1, a, d), e = k.firstChild, 1 === k.childNodes.length && (k = e), e || d)) {
            for (i = n.map(ea(k, "script"), Da), h = i.length; o > m; m++) g = k, m !== p && (g = n.clone(g, !0, !0), h && n.merge(i, ea(g, "script"))), c.call(a[m], g, m);
            if (h)
                for (j = i[i.length - 1].ownerDocument, n.map(i, Ea), m = 0; h > m; m++) g = i[m], _.test(g.type || "") && !n._data(g, "globalEval") && n.contains(j, g) && (g.src ? n._evalUrl && n._evalUrl(g.src) : n.globalEval((g.text || g.textContent || g.innerHTML || "").replace(za, "")));
            k = e = null
        }
        return a
    }

    function Ia(a, b, c) { for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++) c || 1 !== d.nodeType || n.cleanData(ea(d)), d.parentNode && (c && n.contains(d.ownerDocument, d) && fa(ea(d, "script")), d.parentNode.removeChild(d)); return a } n.extend({
        htmlPrefilter: function(a) { return a.replace(va, "<$1></$2>") },
        clone: function(a, b, c) {
            var d, e, f, g, h, i = n.contains(a.ownerDocument, a);
            if (l.html5Clone || n.isXMLDoc(a) || !ua.test("<" + a.nodeName + ">") ? f = a.cloneNode(!0) : (Ba.innerHTML = a.outerHTML, Ba.removeChild(f = Ba.firstChild)), !(l.noCloneEvent && l.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a)))
                for (d = ea(f), h = ea(a), g = 0; null != (e = h[g]); ++g) d[g] && Ga(e, d[g]);
            if (b)
                if (c)
                    for (h = h || ea(a), d = d || ea(f), g = 0; null != (e = h[g]); g++) Fa(e, d[g]);
                else Fa(a, f);
            return d = ea(f, "script"), d.length > 0 && fa(d, !i && ea(a, "script")), d = h = e = null, f
        },
        cleanData: function(a, b) {
            for (var d, e, f, g, h = 0, i = n.expando, j = n.cache, k = l.attributes, m = n.event.special; null != (d = a[h]); h++)
                if ((b || M(d)) && (f = d[i], g = f && j[f])) {
                    if (g.events)
                        for (e in g.events) m[e] ? n.event.remove(d, e) : n.removeEvent(d, e, g.handle);
                    j[f] && (delete j[f], k || "undefined" == typeof d.removeAttribute ? d[i] = void 0 : d.removeAttribute(i), c.push(f))
                }
        }
    }), n.fn.extend({
        domManip: Ha,
        detach: function(a) { return Ia(this, a, !0) },
        remove: function(a) { return Ia(this, a) },
        text: function(a) { return Y(this, function(a) { return void 0 === a ? n.text(this) : this.empty().append((this[0] && this[0].ownerDocument || d).createTextNode(a)) }, null, a, arguments.length) },
        append: function() {
            return Ha(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = Ca(this, a);
                    b.appendChild(a)
                }
            })
        },
        prepend: function() {
            return Ha(this, arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = Ca(this, a);
                    b.insertBefore(a, b.firstChild)
                }
            })
        },
        before: function() { return Ha(this, arguments, function(a) { this.parentNode && this.parentNode.insertBefore(a, this) }) },
        after: function() { return Ha(this, arguments, function(a) { this.parentNode && this.parentNode.insertBefore(a, this.nextSibling) }) },
        empty: function() {
            for (var a, b = 0; null != (a = this[b]); b++) {
                1 === a.nodeType && n.cleanData(ea(a, !1));
                while (a.firstChild) a.removeChild(a.firstChild);
                a.options && n.nodeName(a, "select") && (a.options.length = 0)
            }
            return this
        },
        clone: function(a, b) { return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function() { return n.clone(this, a, b) }) },
        html: function(a) {
            return Y(this, function(a) {
                var b = this[0] || {},
                    c = 0,
                    d = this.length;
                if (void 0 === a) return 1 === b.nodeType ? b.innerHTML.replace(ta, "") : void 0;
                if ("string" == typeof a && !wa.test(a) && (l.htmlSerialize || !ua.test(a)) && (l.leadingWhitespace || !aa.test(a)) && !da[($.exec(a) || ["", ""])[1].toLowerCase()]) {
                    a = n.htmlPrefilter(a);
                    try {
                        for (; d > c; c++) b = this[c] || {}, 1 === b.nodeType && (n.cleanData(ea(b, !1)), b.innerHTML = a);
                        b = 0
                    } catch (e) {}
                }
                b && this.empty().append(a)
            }, null, a, arguments.length)
        },
        replaceWith: function() {
            var a = [];
            return Ha(this, arguments, function(b) {
                var c = this.parentNode;
                n.inArray(this, a) < 0 && (n.cleanData(ea(this)), c && c.replaceChild(b, this))
            }, a)
        }
    }), n.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(a, b) { n.fn[a] = function(a) { for (var c, d = 0, e = [], f = n(a), h = f.length - 1; h >= d; d++) c = d === h ? this : this.clone(!0), n(f[d])[b](c), g.apply(e, c.get()); return this.pushStack(e) } });
    var Ja, Ka = { HTML: "block", BODY: "block" };

    function La(a, b) {
        var c = n(b.createElement(a)).appendTo(b.body),
            d = n.css(c[0], "display");
        return c.detach(), d
    }

    function Ma(a) {
        var b = d,
            c = Ka[a];
        return c || (c = La(a, b), "none" !== c && c || (Ja = (Ja || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = (Ja[0].contentWindow || Ja[0].contentDocument).document, b.write(), b.close(), c = La(a, b), Ja.detach()), Ka[a] = c), c
    }
    var Na = /^margin/,
        Oa = new RegExp("^(" + T + ")(?!px)[a-z%]+$", "i"),
        Pa = function(a, b, c, d) {
            var e, f, g = {};
            for (f in b) g[f] = a.style[f], a.style[f] = b[f];
            e = c.apply(a, d || []);
            for (f in b) a.style[f] = g[f];
            return e
        },
        Qa = d.documentElement;
    ! function() {
        var b, c, e, f, g, h, i = d.createElement("div"),
            j = d.createElement("div");
        if (j.style) {
            j.style.cssText = "float:left;opacity:.5", l.opacity = "0.5" === j.style.opacity, l.cssFloat = !!j.style.cssFloat, j.style.backgroundClip = "content-box", j.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = "content-box" === j.style.backgroundClip, i = d.createElement("div"), i.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", j.innerHTML = "", i.appendChild(j), l.boxSizing = "" === j.style.boxSizing || "" === j.style.MozBoxSizing || "" === j.style.WebkitBoxSizing, n.extend(l, { reliableHiddenOffsets: function() { return null == b && k(), f }, boxSizingReliable: function() { return null == b && k(), e }, pixelMarginRight: function() { return null == b && k(), c }, pixelPosition: function() { return null == b && k(), b }, reliableMarginRight: function() { return null == b && k(), g }, reliableMarginLeft: function() { return null == b && k(), h } });

            function k() {
                var k, l, m = d.documentElement;
                m.appendChild(i), j.style.cssText = "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", b = e = h = !1, c = g = !0, a.getComputedStyle && (l = a.getComputedStyle(j), b = "1%" !== (l || {}).top, h = "2px" === (l || {}).marginLeft, e = "4px" === (l || { width: "4px" }).width, j.style.marginRight = "50%", c = "4px" === (l || { marginRight: "4px" }).marginRight, k = j.appendChild(d.createElement("div")), k.style.cssText = j.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", k.style.marginRight = k.style.width = "0", j.style.width = "1px", g = !parseFloat((a.getComputedStyle(k) || {}).marginRight), j.removeChild(k)), j.style.display = "none", f = 0 === j.getClientRects().length, f && (j.style.display = "", j.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", j.childNodes[0].style.borderCollapse = "separate", k = j.getElementsByTagName("td"), k[0].style.cssText = "margin:0;border:0;padding:0;display:none", f = 0 === k[0].offsetHeight, f && (k[0].style.display = "", k[1].style.display = "none", f = 0 === k[0].offsetHeight)), m.removeChild(i)
            }
        }
    }();
    var Ra, Sa, Ta = /^(top|right|bottom|left)$/;
    a.getComputedStyle ? (Ra = function(b) { var c = b.ownerDocument.defaultView; return c && c.opener || (c = a), c.getComputedStyle(b) }, Sa = function(a, b, c) { var d, e, f, g, h = a.style; return c = c || Ra(a), g = c ? c.getPropertyValue(b) || c[b] : void 0, "" !== g && void 0 !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)), c && !l.pixelMarginRight() && Oa.test(g) && Na.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f), void 0 === g ? g : g + "" }) : Qa.currentStyle && (Ra = function(a) { return a.currentStyle }, Sa = function(a, b, c) { var d, e, f, g, h = a.style; return c = c || Ra(a), g = c ? c[b] : void 0, null == g && h && h[b] && (g = h[b]), Oa.test(g) && !Ta.test(b) && (d = h.left, e = a.runtimeStyle, f = e && e.left, f && (e.left = a.currentStyle.left), h.left = "fontSize" === b ? "1em" : g, g = h.pixelLeft + "px", h.left = d, f && (e.left = f)), void 0 === g ? g : g + "" || "auto" });

    function Ua(a, b) { return { get: function() { return a() ? void delete this.get : (this.get = b).apply(this, arguments) } } }
    var Va = /alpha\([^)]*\)/i,
        Wa = /opacity\s*=\s*([^)]*)/i,
        Xa = /^(none|table(?!-c[ea]).+)/,
        Ya = new RegExp("^(" + T + ")(.*)$", "i"),
        Za = { position: "absolute", visibility: "hidden", display: "block" },
        $a = { letterSpacing: "0", fontWeight: "400" },
        _a = ["Webkit", "O", "Moz", "ms"],
        ab = d.createElement("div").style;

    function bb(a) {
        if (a in ab) return a;
        var b = a.charAt(0).toUpperCase() + a.slice(1),
            c = _a.length;
        while (c--)
            if (a = _a[c] + b, a in ab) return a
    }

    function cb(a, b) { for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) d = a[g], d.style && (f[g] = n._data(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && W(d) && (f[g] = n._data(d, "olddisplay", Ma(d.nodeName)))) : (e = W(d), (c && "none" !== c || !e) && n._data(d, "olddisplay", e ? c : n.css(d, "display")))); for (g = 0; h > g; g++) d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none")); return a }

    function db(a, b, c) { var d = Ya.exec(b); return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b }

    function eb(a, b, c, d, e) { for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) "margin" === c && (g += n.css(a, c + V[f], !0, e)), d ? ("content" === c && (g -= n.css(a, "padding" + V[f], !0, e)), "margin" !== c && (g -= n.css(a, "border" + V[f] + "Width", !0, e))) : (g += n.css(a, "padding" + V[f], !0, e), "padding" !== c && (g += n.css(a, "border" + V[f] + "Width", !0, e))); return g }

    function fb(a, b, c) {
        var d = !0,
            e = "width" === b ? a.offsetWidth : a.offsetHeight,
            f = Ra(a),
            g = l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, f);
        if (0 >= e || null == e) {
            if (e = Sa(a, b, f), (0 > e || null == e) && (e = a.style[b]), Oa.test(e)) return e;
            d = g && (l.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0
        }
        return e + eb(a, b, c || (g ? "border" : "content"), d, f) + "px"
    }
    n.extend({
        cssHooks: { opacity: { get: function(a, b) { if (b) { var c = Sa(a, "opacity"); return "" === c ? "1" : c } } } },
        cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
        cssProps: { "float": l.cssFloat ? "cssFloat" : "styleFloat" },
        style: function(a, b, c, d) {
            if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
                var e, f, g, h = n.camelCase(b),
                    i = a.style;
                if (b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h), g = n.cssHooks[b] || n.cssHooks[h], void 0 === c) return g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b];
                if (f = typeof c, "string" === f && (e = U.exec(c)) && e[1] && (c = X(a, b, e), f = "number"), null != c && c === c && ("number" === f && (c += e && e[3] || (n.cssNumber[h] ? "" : "px")), l.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), !(g && "set" in g && void 0 === (c = g.set(a, c, d))))) try { i[b] = c } catch (j) {}
            }
        },
        css: function(a, b, c, d) { var e, f, g, h = n.camelCase(b); return b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h), g = n.cssHooks[b] || n.cssHooks[h], g && "get" in g && (f = g.get(a, !0, c)), void 0 === f && (f = Sa(a, b, d)), "normal" === f && b in $a && (f = $a[b]), "" === c || c ? (e = parseFloat(f), c === !0 || isFinite(e) ? e || 0 : f) : f }
    }), n.each(["height", "width"], function(a, b) { n.cssHooks[b] = { get: function(a, c, d) { return c ? Xa.test(n.css(a, "display")) && 0 === a.offsetWidth ? Pa(a, Za, function() { return fb(a, b, d) }) : fb(a, b, d) : void 0 }, set: function(a, c, d) { var e = d && Ra(a); return db(a, c, d ? eb(a, b, d, l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, e), e) : 0) } } }), l.opacity || (n.cssHooks.opacity = {
        get: function(a, b) { return Wa.test((b && a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : b ? "1" : "" },
        set: function(a, b) {
            var c = a.style,
                d = a.currentStyle,
                e = n.isNumeric(b) ? "alpha(opacity=" + 100 * b + ")" : "",
                f = d && d.filter || c.filter || "";
            c.zoom = 1, (b >= 1 || "" === b) && "" === n.trim(f.replace(Va, "")) && c.removeAttribute && (c.removeAttribute("filter"), "" === b || d && !d.filter) || (c.filter = Va.test(f) ? f.replace(Va, e) : f + " " + e)
        }
    }), n.cssHooks.marginRight = Ua(l.reliableMarginRight, function(a, b) { return b ? Pa(a, { display: "inline-block" }, Sa, [a, "marginRight"]) : void 0 }), n.cssHooks.marginLeft = Ua(l.reliableMarginLeft, function(a, b) {
        return b ? (parseFloat(Sa(a, "marginLeft")) || (n.contains(a.ownerDocument, a) ? a.getBoundingClientRect().left - Pa(a, {
            marginLeft: 0
        }, function() { return a.getBoundingClientRect().left }) : 0)) + "px" : void 0
    }), n.each({ margin: "", padding: "", border: "Width" }, function(a, b) { n.cssHooks[a + b] = { expand: function(c) { for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) e[a + V[d] + b] = f[d] || f[d - 2] || f[0]; return e } }, Na.test(a) || (n.cssHooks[a + b].set = db) }), n.fn.extend({
        css: function(a, b) {
            return Y(this, function(a, b, c) {
                var d, e, f = {},
                    g = 0;
                if (n.isArray(b)) { for (d = Ra(a), e = b.length; e > g; g++) f[b[g]] = n.css(a, b[g], !1, d); return f }
                return void 0 !== c ? n.style(a, b, c) : n.css(a, b)
            }, a, b, arguments.length > 1)
        },
        show: function() { return cb(this, !0) },
        hide: function() { return cb(this) },
        toggle: function(a) { return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function() { W(this) ? n(this).show() : n(this).hide() }) }
    });

    function gb(a, b, c, d, e) { return new gb.prototype.init(a, b, c, d, e) } n.Tween = gb, gb.prototype = { constructor: gb, init: function(a, b, c, d, e, f) { this.elem = a, this.prop = c, this.easing = e || n.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (n.cssNumber[c] ? "" : "px") }, cur: function() { var a = gb.propHooks[this.prop]; return a && a.get ? a.get(this) : gb.propHooks._default.get(this) }, run: function(a) { var b, c = gb.propHooks[this.prop]; return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : gb.propHooks._default.set(this), this } }, gb.prototype.init.prototype = gb.prototype, gb.propHooks = { _default: { get: function(a) { var b; return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = n.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0) }, set: function(a) { n.fx.step[a.prop] ? n.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop] ? a.elem[a.prop] = a.now : n.style(a.elem, a.prop, a.now + a.unit) } } }, gb.propHooks.scrollTop = gb.propHooks.scrollLeft = { set: function(a) { a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now) } }, n.easing = { linear: function(a) { return a }, swing: function(a) { return .5 - Math.cos(a * Math.PI) / 2 }, _default: "swing" }, n.fx = gb.prototype.init, n.fx.step = {};
    var hb, ib, jb = /^(?:toggle|show|hide)$/,
        kb = /queueHooks$/;

    function lb() { return a.setTimeout(function() { hb = void 0 }), hb = n.now() }

    function mb(a, b) {
        var c, d = { height: a },
            e = 0;
        for (b = b ? 1 : 0; 4 > e; e += 2 - b) c = V[e], d["margin" + c] = d["padding" + c] = a;
        return b && (d.opacity = d.width = a), d
    }

    function nb(a, b, c) {
        for (var d, e = (qb.tweeners[b] || []).concat(qb.tweeners["*"]), f = 0, g = e.length; g > f; f++)
            if (d = e[f].call(c, b, a)) return d
    }

    function ob(a, b, c) {
        var d, e, f, g, h, i, j, k, m = this,
            o = {},
            p = a.style,
            q = a.nodeType && W(a),
            r = n._data(a, "fxshow");
        c.queue || (h = n._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function() { h.unqueued || i() }), h.unqueued++, m.always(function() { m.always(function() { h.unqueued--, n.queue(a, "fx").length || h.empty.fire() }) })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [p.overflow, p.overflowX, p.overflowY], j = n.css(a, "display"), k = "none" === j ? n._data(a, "olddisplay") || Ma(a.nodeName) : j, "inline" === k && "none" === n.css(a, "float") && (l.inlineBlockNeedsLayout && "inline" !== Ma(a.nodeName) ? p.zoom = 1 : p.display = "inline-block")), c.overflow && (p.overflow = "hidden", l.shrinkWrapBlocks() || m.always(function() { p.overflow = c.overflow[0], p.overflowX = c.overflow[1], p.overflowY = c.overflow[2] }));
        for (d in b)
            if (e = b[d], jb.exec(e)) {
                if (delete b[d], f = f || "toggle" === e, e === (q ? "hide" : "show")) {
                    if ("show" !== e || !r || void 0 === r[d]) continue;
                    q = !0
                }
                o[d] = r && r[d] || n.style(a, d)
            } else j = void 0;
        if (n.isEmptyObject(o)) "inline" === ("none" === j ? Ma(a.nodeName) : j) && (p.display = j);
        else {
            r ? "hidden" in r && (q = r.hidden) : r = n._data(a, "fxshow", {}), f && (r.hidden = !q), q ? n(a).show() : m.done(function() { n(a).hide() }), m.done(function() {
                var b;
                n._removeData(a, "fxshow");
                for (b in o) n.style(a, b, o[b])
            });
            for (d in o) g = nb(q ? r[d] : 0, d, m), d in r || (r[d] = g.start, q && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0))
        }
    }

    function pb(a, b) {
        var c, d, e, f, g;
        for (c in a)
            if (d = n.camelCase(c), e = b[d], f = a[c], n.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = n.cssHooks[d], g && "expand" in g) { f = g.expand(f), delete a[d]; for (c in f) c in a || (a[c] = f[c], b[c] = e) } else b[d] = e
    }

    function qb(a, b, c) {
        var d, e, f = 0,
            g = qb.prefilters.length,
            h = n.Deferred().always(function() { delete i.elem }),
            i = function() { if (e) return !1; for (var b = hb || lb(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) j.tweens[g].run(f); return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1) },
            j = h.promise({
                elem: a,
                props: n.extend({}, b),
                opts: n.extend(!0, { specialEasing: {}, easing: n.easing._default }, c),
                originalProperties: b,
                originalOptions: c,
                startTime: hb || lb(),
                duration: c.duration,
                tweens: [],
                createTween: function(b, c) { var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing); return j.tweens.push(d), d },
                stop: function(b) {
                    var c = 0,
                        d = b ? j.tweens.length : 0;
                    if (e) return this;
                    for (e = !0; d > c; c++) j.tweens[c].run(1);
                    return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this
                }
            }),
            k = j.props;
        for (pb(k, j.opts.specialEasing); g > f; f++)
            if (d = qb.prefilters[f].call(j, a, k, j.opts)) return n.isFunction(d.stop) && (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)), d;
        return n.map(k, nb, j), n.isFunction(j.opts.start) && j.opts.start.call(a, j), n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always)
    }
    n.Animation = n.extend(qb, { tweeners: { "*": [function(a, b) { var c = this.createTween(a, b); return X(c.elem, a, U.exec(b), c), c }] }, tweener: function(a, b) { n.isFunction(a) ? (b = a, a = ["*"]) : a = a.match(G); for (var c, d = 0, e = a.length; e > d; d++) c = a[d], qb.tweeners[c] = qb.tweeners[c] || [], qb.tweeners[c].unshift(b) }, prefilters: [ob], prefilter: function(a, b) { b ? qb.prefilters.unshift(a) : qb.prefilters.push(a) } }), n.speed = function(a, b, c) { var d = a && "object" == typeof a ? n.extend({}, a) : { complete: c || !c && b || n.isFunction(a) && a, duration: a, easing: c && b || b && !n.isFunction(b) && b }; return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default, null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function() { n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue) }, d }, n.fn.extend({
            fadeTo: function(a, b, c, d) { return this.filter(W).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d) },
            animate: function(a, b, c, d) {
                var e = n.isEmptyObject(a),
                    f = n.speed(b, c, d),
                    g = function() {
                        var b = qb(this, n.extend({}, a), f);
                        (e || n._data(this, "finish")) && b.stop(!0)
                    };
                return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
            },
            stop: function(a, b, c) {
                var d = function(a) {
                    var b = a.stop;
                    delete a.stop, b(c)
                };
                return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function() {
                    var b = !0,
                        e = null != a && a + "queueHooks",
                        f = n.timers,
                        g = n._data(this);
                    if (e) g[e] && g[e].stop && d(g[e]);
                    else
                        for (e in g) g[e] && g[e].stop && kb.test(e) && d(g[e]);
                    for (e = f.length; e--;) f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
                    !b && c || n.dequeue(this, a)
                })
            },
            finish: function(a) {
                return a !== !1 && (a = a || "fx"), this.each(function() {
                    var b, c = n._data(this),
                        d = c[a + "queue"],
                        e = c[a + "queueHooks"],
                        f = n.timers,
                        g = d ? d.length : 0;
                    for (c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
                    for (b = 0; g > b; b++) d[b] && d[b].finish && d[b].finish.call(this);
                    delete c.finish
                })
            }
        }), n.each(["toggle", "show", "hide"], function(a, b) {
            var c = n.fn[b];
            n.fn[b] = function(a, d, e) { return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(mb(b, !0), a, d, e) }
        }), n.each({ slideDown: mb("show"), slideUp: mb("hide"), slideToggle: mb("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(a, b) { n.fn[a] = function(a, c, d) { return this.animate(b, a, c, d) } }), n.timers = [], n.fx.tick = function() {
            var a, b = n.timers,
                c = 0;
            for (hb = n.now(); c < b.length; c++) a = b[c], a() || b[c] !== a || b.splice(c--, 1);
            b.length || n.fx.stop(), hb = void 0
        }, n.fx.timer = function(a) { n.timers.push(a), a() ? n.fx.start() : n.timers.pop() }, n.fx.interval = 13, n.fx.start = function() { ib || (ib = a.setInterval(n.fx.tick, n.fx.interval)) }, n.fx.stop = function() { a.clearInterval(ib), ib = null }, n.fx.speeds = { slow: 600, fast: 200, _default: 400 }, n.fn.delay = function(b, c) {
            return b = n.fx ? n.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function(c, d) {
                var e = a.setTimeout(c, b);
                d.stop = function() { a.clearTimeout(e) }
            })
        },
        function() {
            var a, b = d.createElement("input"),
                c = d.createElement("div"),
                e = d.createElement("select"),
                f = e.appendChild(d.createElement("option"));
            c = d.createElement("div"), c.setAttribute("className", "t"), c.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", a = c.getElementsByTagName("a")[0], b.setAttribute("type", "checkbox"), c.appendChild(b), a = c.getElementsByTagName("a")[0], a.style.cssText = "top:1px", l.getSetAttribute = "t" !== c.className, l.style = /top/.test(a.getAttribute("style")), l.hrefNormalized = "/a" === a.getAttribute("href"), l.checkOn = !!b.value, l.optSelected = f.selected, l.enctype = !!d.createElement("form").enctype, e.disabled = !0, l.optDisabled = !f.disabled, b = d.createElement("input"), b.setAttribute("value", ""), l.input = "" === b.getAttribute("value"), b.value = "t", b.setAttribute("type", "radio"), l.radioValue = "t" === b.value
        }();
    var rb = /\r/g,
        sb = /[\x20\t\r\n\f]+/g;
    n.fn.extend({
        val: function(a) {
            var b, c, d, e = this[0]; {
                if (arguments.length) return d = n.isFunction(a), this.each(function(c) {
                    var e;
                    1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function(a) { return null == a ? "" : a + "" })), b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e))
                });
                if (e) return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(rb, "") : null == c ? "" : c)
            }
        }
    }), n.extend({
        valHooks: {
            option: { get: function(a) { var b = n.find.attr(a, "value"); return null != b ? b : n.trim(n.text(a)).replace(sb, " ") } },
            select: {
                get: function(a) {
                    for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++)
                        if (c = d[i], (c.selected || i === e) && (l.optDisabled ? !c.disabled : null === c.getAttribute("disabled")) && (!c.parentNode.disabled || !n.nodeName(c.parentNode, "optgroup"))) {
                            if (b = n(c).val(), f) return b;
                            g.push(b)
                        } return g
                },
                set: function(a, b) {
                    var c, d, e = a.options,
                        f = n.makeArray(b),
                        g = e.length;
                    while (g--)
                        if (d = e[g], n.inArray(n.valHooks.option.get(d), f) > -1) try { d.selected = c = !0 } catch (h) { d.scrollHeight } else d.selected = !1;
                    return c || (a.selectedIndex = -1), e
                }
            }
        }
    }), n.each(["radio", "checkbox"], function() { n.valHooks[this] = { set: function(a, b) { return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) > -1 : void 0 } }, l.checkOn || (n.valHooks[this].get = function(a) { return null === a.getAttribute("value") ? "on" : a.value }) });
    var tb, ub, vb = n.expr.attrHandle,
        wb = /^(?:checked|selected)$/i,
        xb = l.getSetAttribute,
        yb = l.input;
    n.fn.extend({ attr: function(a, b) { return Y(this, n.attr, a, b, arguments.length > 1) }, removeAttr: function(a) { return this.each(function() { n.removeAttr(this, a) }) } }), n.extend({
        attr: function(a, b, c) { var d, e, f = a.nodeType; if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(), e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? ub : tb)), void 0 !== c ? null === c ? void n.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = n.find.attr(a, b), null == d ? void 0 : d)) },
        attrHooks: { type: { set: function(a, b) { if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) { var c = a.value; return a.setAttribute("type", b), c && (a.value = c), b } } } },
        removeAttr: function(a, b) {
            var c, d, e = 0,
                f = b && b.match(G);
            if (f && 1 === a.nodeType)
                while (c = f[e++]) d = n.propFix[c] || c, n.expr.match.bool.test(c) ? yb && xb || !wb.test(c) ? a[d] = !1 : a[n.camelCase("default-" + c)] = a[d] = !1 : n.attr(a, c, ""), a.removeAttribute(xb ? c : d)
        }
    }), ub = { set: function(a, b, c) { return b === !1 ? n.removeAttr(a, c) : yb && xb || !wb.test(c) ? a.setAttribute(!xb && n.propFix[c] || c, c) : a[n.camelCase("default-" + c)] = a[c] = !0, c } }, n.each(n.expr.match.bool.source.match(/\w+/g), function(a, b) {
        var c = vb[b] || n.find.attr;
        yb && xb || !wb.test(b) ? vb[b] = function(a, b, d) { var e, f; return d || (f = vb[b], vb[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, vb[b] = f), e } : vb[b] = function(a, b, c) { return c ? void 0 : a[n.camelCase("default-" + b)] ? b.toLowerCase() : null }
    }), yb && xb || (n.attrHooks.value = { set: function(a, b, c) { return n.nodeName(a, "input") ? void(a.defaultValue = b) : tb && tb.set(a, b, c) } }), xb || (tb = { set: function(a, b, c) { var d = a.getAttributeNode(c); return d || a.setAttributeNode(d = a.ownerDocument.createAttribute(c)), d.value = b += "", "value" === c || b === a.getAttribute(c) ? b : void 0 } }, vb.id = vb.name = vb.coords = function(a, b, c) { var d; return c ? void 0 : (d = a.getAttributeNode(b)) && "" !== d.value ? d.value : null }, n.valHooks.button = { get: function(a, b) { var c = a.getAttributeNode(b); return c && c.specified ? c.value : void 0 }, set: tb.set }, n.attrHooks.contenteditable = { set: function(a, b, c) { tb.set(a, "" === b ? !1 : b, c) } }, n.each(["width", "height"], function(a, b) { n.attrHooks[b] = { set: function(a, c) { return "" === c ? (a.setAttribute(b, "auto"), c) : void 0 } } })), l.style || (n.attrHooks.style = { get: function(a) { return a.style.cssText || void 0 }, set: function(a, b) { return a.style.cssText = b + "" } });
    var zb = /^(?:input|select|textarea|button|object)$/i,
        Ab = /^(?:a|area)$/i;
    n.fn.extend({ prop: function(a, b) { return Y(this, n.prop, a, b, arguments.length > 1) }, removeProp: function(a) { return a = n.propFix[a] || a, this.each(function() { try { this[a] = void 0, delete this[a] } catch (b) {} }) } }), n.extend({ prop: function(a, b, c) { var d, e, f = a.nodeType; if (3 !== f && 8 !== f && 2 !== f) return 1 === f && n.isXMLDoc(a) || (b = n.propFix[b] || b, e = n.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b] }, propHooks: { tabIndex: { get: function(a) { var b = n.find.attr(a, "tabindex"); return b ? parseInt(b, 10) : zb.test(a.nodeName) || Ab.test(a.nodeName) && a.href ? 0 : -1 } } }, propFix: { "for": "htmlFor", "class": "className" } }), l.hrefNormalized || n.each(["href", "src"], function(a, b) { n.propHooks[b] = { get: function(a) { return a.getAttribute(b, 4) } } }), l.optSelected || (n.propHooks.selected = {
        get: function(a) { var b = a.parentNode; return b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex), null },
        set: function(a) {
            var b = a.parentNode;
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex)
        }
    }), n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() { n.propFix[this.toLowerCase()] = this }), l.enctype || (n.propFix.enctype = "encoding");
    var Bb = /[\t\r\n\f]/g;

    function Cb(a) { return n.attr(a, "class") || "" } n.fn.extend({
        addClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (n.isFunction(a)) return this.each(function(b) { n(this).addClass(a.call(this, b, Cb(this))) });
            if ("string" == typeof a && a) {
                b = a.match(G) || [];
                while (c = this[i++])
                    if (e = Cb(c), d = 1 === c.nodeType && (" " + e + " ").replace(Bb, " ")) {
                        g = 0;
                        while (f = b[g++]) d.indexOf(" " + f + " ") < 0 && (d += f + " ");
                        h = n.trim(d), e !== h && n.attr(c, "class", h)
                    }
            }
            return this
        },
        removeClass: function(a) {
            var b, c, d, e, f, g, h, i = 0;
            if (n.isFunction(a)) return this.each(function(b) { n(this).removeClass(a.call(this, b, Cb(this))) });
            if (!arguments.length) return this.attr("class", "");
            if ("string" == typeof a && a) {
                b = a.match(G) || [];
                while (c = this[i++])
                    if (e = Cb(c), d = 1 === c.nodeType && (" " + e + " ").replace(Bb, " ")) {
                        g = 0;
                        while (f = b[g++])
                            while (d.indexOf(" " + f + " ") > -1) d = d.replace(" " + f + " ", " ");
                        h = n.trim(d), e !== h && n.attr(c, "class", h)
                    }
            }
            return this
        },
        toggleClass: function(a, b) { var c = typeof a; return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : n.isFunction(a) ? this.each(function(c) { n(this).toggleClass(a.call(this, c, Cb(this), b), b) }) : this.each(function() { var b, d, e, f; if ("string" === c) { d = 0, e = n(this), f = a.match(G) || []; while (b = f[d++]) e.hasClass(b) ? e.removeClass(b) : e.addClass(b) } else void 0 !== a && "boolean" !== c || (b = Cb(this), b && n._data(this, "__className__", b), n.attr(this, "class", b || a === !1 ? "" : n._data(this, "__className__") || "")) }) },
        hasClass: function(a) {
            var b, c, d = 0;
            b = " " + a + " ";
            while (c = this[d++])
                if (1 === c.nodeType && (" " + Cb(c) + " ").replace(Bb, " ").indexOf(b) > -1) return !0;
            return !1
        }
    }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(a, b) { n.fn[b] = function(a, c) { return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b) } }), n.fn.extend({ hover: function(a, b) { return this.mouseenter(a).mouseleave(b || a) } });
    var Db = a.location,
        Eb = n.now(),
        Fb = /\?/,
        Gb = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    n.parseJSON = function(b) {
        if (a.JSON && a.JSON.parse) return a.JSON.parse(b + "");
        var c, d = null,
            e = n.trim(b + "");
        return e && !n.trim(e.replace(Gb, function(a, b, e, f) { return c && b && (d = 0), 0 === d ? a : (c = e || b, d += !f - !e, "") })) ? Function("return " + e)() : n.error("Invalid JSON: " + b)
    }, n.parseXML = function(b) { var c, d; if (!b || "string" != typeof b) return null; try { a.DOMParser ? (d = new a.DOMParser, c = d.parseFromString(b, "text/xml")) : (c = new a.ActiveXObject("Microsoft.XMLDOM"), c.async = "false", c.loadXML(b)) } catch (e) { c = void 0 } return c && c.documentElement && !c.getElementsByTagName("parsererror").length || n.error("Invalid XML: " + b), c };
    var Hb = /#.*$/,
        Ib = /([?&])_=[^&]*/,
        Jb = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
        Kb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        Lb = /^(?:GET|HEAD)$/,
        Mb = /^\/\//,
        Nb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
        Ob = {},
        Pb = {},
        Qb = "*/".concat("*"),
        Rb = Db.href,
        Sb = Nb.exec(Rb.toLowerCase()) || [];

    function Tb(a) {
        return function(b, c) {
            "string" != typeof b && (c = b, b = "*");
            var d, e = 0,
                f = b.toLowerCase().match(G) || [];
            if (n.isFunction(c))
                while (d = f[e++]) "+" === d.charAt(0) ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
        }
    }

    function Ub(a, b, c, d) {
        var e = {},
            f = a === Pb;

        function g(h) { var i; return e[h] = !0, n.each(a[h] || [], function(a, h) { var j = h(b, c, d); return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1) }), i }
        return g(b.dataTypes[0]) || !e["*"] && g("*")
    }

    function Vb(a, b) { var c, d, e = n.ajaxSettings.flatOptions || {}; for (d in b) void 0 !== b[d] && ((e[d] ? a : c || (c = {}))[d] = b[d]); return c && n.extend(!0, a, c), a }

    function Wb(a, b, c) {
        var d, e, f, g, h = a.contents,
            i = a.dataTypes;
        while ("*" === i[0]) i.shift(), void 0 === e && (e = a.mimeType || b.getResponseHeader("Content-Type"));
        if (e)
            for (g in h)
                if (h[g] && h[g].test(e)) { i.unshift(g); break } if (i[0] in c) f = i[0];
        else { for (g in c) { if (!i[0] || a.converters[g + " " + i[0]]) { f = g; break } d || (d = g) } f = f || d }
        return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0
    }

    function Xb(a, b, c, d) {
        var e, f, g, h, i, j = {},
            k = a.dataTypes.slice();
        if (k[1])
            for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
        f = k.shift();
        while (f)
            if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift())
                if ("*" === f) f = i;
                else if ("*" !== i && i !== f) {
            if (g = j[i + " " + f] || j["* " + f], !g)
                for (e in j)
                    if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) { g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1])); break } if (g !== !0)
                if (g && a["throws"]) b = g(b);
                else try { b = g(b) } catch (l) { return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f } }
        }
        return { state: "success", data: b }
    }
    n.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: { url: Rb, type: "GET", isLocal: Kb.test(Sb[1]), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Qb, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": n.parseJSON, "text xml": n.parseXML }, flatOptions: { url: !0, context: !0 } },
        ajaxSetup: function(a, b) { return b ? Vb(Vb(a, n.ajaxSettings), b) : Vb(n.ajaxSettings, a) },
        ajaxPrefilter: Tb(Ob),
        ajaxTransport: Tb(Pb),
        ajax: function(b, c) {
            "object" == typeof b && (c = b, b = void 0), c = c || {};
            var d, e, f, g, h, i, j, k, l = n.ajaxSetup({}, c),
                m = l.context || l,
                o = l.context && (m.nodeType || m.jquery) ? n(m) : n.event,
                p = n.Deferred(),
                q = n.Callbacks("once memory"),
                r = l.statusCode || {},
                s = {},
                t = {},
                u = 0,
                v = "canceled",
                w = {
                    readyState: 0,
                    getResponseHeader: function(a) { var b; if (2 === u) { if (!k) { k = {}; while (b = Jb.exec(g)) k[b[1].toLowerCase()] = b[2] } b = k[a.toLowerCase()] } return null == b ? null : b },
                    getAllResponseHeaders: function() { return 2 === u ? g : null },
                    setRequestHeader: function(a, b) { var c = a.toLowerCase(); return u || (a = t[c] = t[c] || a, s[a] = b), this },
                    overrideMimeType: function(a) { return u || (l.mimeType = a), this },
                    statusCode: function(a) {
                        var b;
                        if (a)
                            if (2 > u)
                                for (b in a) r[b] = [r[b], a[b]];
                            else w.always(a[w.status]);
                        return this
                    },
                    abort: function(a) { var b = a || v; return j && j.abort(b), y(0, b), this }
                };
            if (p.promise(w).complete = q.add, w.success = w.done, w.error = w.fail, l.url = ((b || l.url || Rb) + "").replace(Hb, "").replace(Mb, Sb[1] + "//"), l.type = c.method || c.type || l.method || l.type, l.dataTypes = n.trim(l.dataType || "*").toLowerCase().match(G) || [""], null == l.crossDomain && (d = Nb.exec(l.url.toLowerCase()), l.crossDomain = !(!d || d[1] === Sb[1] && d[2] === Sb[2] && (d[3] || ("http:" === d[1] ? "80" : "443")) === (Sb[3] || ("http:" === Sb[1] ? "80" : "443")))), l.data && l.processData && "string" != typeof l.data && (l.data = n.param(l.data, l.traditional)), Ub(Ob, l, c, w), 2 === u) return w;
            i = n.event && l.global, i && 0 === n.active++ && n.event.trigger("ajaxStart"), l.type = l.type.toUpperCase(), l.hasContent = !Lb.test(l.type), f = l.url, l.hasContent || (l.data && (f = l.url += (Fb.test(f) ? "&" : "?") + l.data, delete l.data), l.cache === !1 && (l.url = Ib.test(f) ? f.replace(Ib, "$1_=" + Eb++) : f + (Fb.test(f) ? "&" : "?") + "_=" + Eb++)), l.ifModified && (n.lastModified[f] && w.setRequestHeader("If-Modified-Since", n.lastModified[f]), n.etag[f] && w.setRequestHeader("If-None-Match", n.etag[f])), (l.data && l.hasContent && l.contentType !== !1 || c.contentType) && w.setRequestHeader("Content-Type", l.contentType), w.setRequestHeader("Accept", l.dataTypes[0] && l.accepts[l.dataTypes[0]] ? l.accepts[l.dataTypes[0]] + ("*" !== l.dataTypes[0] ? ", " + Qb + "; q=0.01" : "") : l.accepts["*"]);
            for (e in l.headers) w.setRequestHeader(e, l.headers[e]);
            if (l.beforeSend && (l.beforeSend.call(m, w, l) === !1 || 2 === u)) return w.abort();
            v = "abort";
            for (e in { success: 1, error: 1, complete: 1 }) w[e](l[e]);
            if (j = Ub(Pb, l, c, w)) {
                if (w.readyState = 1, i && o.trigger("ajaxSend", [w, l]), 2 === u) return w;
                l.async && l.timeout > 0 && (h = a.setTimeout(function() { w.abort("timeout") }, l.timeout));
                try { u = 1, j.send(s, y) } catch (x) {
                    if (!(2 > u)) throw x;
                    y(-1, x)
                }
            } else y(-1, "No Transport");

            function y(b, c, d, e) {
                var k, s, t, v, x, y = c;
                2 !== u && (u = 2, h && a.clearTimeout(h), j = void 0, g = e || "", w.readyState = b > 0 ? 4 : 0, k = b >= 200 && 300 > b || 304 === b, d && (v = Wb(l, w, d)), v = Xb(l, v, w, k), k ? (l.ifModified && (x = w.getResponseHeader("Last-Modified"), x && (n.lastModified[f] = x), x = w.getResponseHeader("etag"), x && (n.etag[f] = x)), 204 === b || "HEAD" === l.type ? y = "nocontent" : 304 === b ? y = "notmodified" : (y = v.state, s = v.data, t = v.error, k = !t)) : (t = y, !b && y || (y = "error", 0 > b && (b = 0))), w.status = b, w.statusText = (c || y) + "", k ? p.resolveWith(m, [s, y, w]) : p.rejectWith(m, [w, y, t]), w.statusCode(r), r = void 0, i && o.trigger(k ? "ajaxSuccess" : "ajaxError", [w, l, k ? s : t]), q.fireWith(m, [w, y]), i && (o.trigger("ajaxComplete", [w, l]), --n.active || n.event.trigger("ajaxStop")))
            }
            return w
        },
        getJSON: function(a, b, c) { return n.get(a, b, c, "json") },
        getScript: function(a, b) { return n.get(a, void 0, b, "script") }
    }), n.each(["get", "post"], function(a, b) { n[b] = function(a, c, d, e) { return n.isFunction(c) && (e = e || d, d = c, c = void 0), n.ajax(n.extend({ url: a, type: b, dataType: e, data: c, success: d }, n.isPlainObject(a) && a)) } }), n._evalUrl = function(a) { return n.ajax({ url: a, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, "throws": !0 }) }, n.fn.extend({
        wrapAll: function(a) {
            if (n.isFunction(a)) return this.each(function(b) { n(this).wrapAll(a.call(this, b)) });
            if (this[0]) {
                var b = n(a, this[0].ownerDocument).eq(0).clone(!0);
                this[0].parentNode && b.insertBefore(this[0]), b.map(function() { var a = this; while (a.firstChild && 1 === a.firstChild.nodeType) a = a.firstChild; return a }).append(this)
            }
            return this
        },
        wrapInner: function(a) {
            return n.isFunction(a) ? this.each(function(b) { n(this).wrapInner(a.call(this, b)) }) : this.each(function() {
                var b = n(this),
                    c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a)
            })
        },
        wrap: function(a) { var b = n.isFunction(a); return this.each(function(c) { n(this).wrapAll(b ? a.call(this, c) : a) }) },
        unwrap: function() { return this.parent().each(function() { n.nodeName(this, "body") || n(this).replaceWith(this.childNodes) }).end() }
    });

    function Yb(a) { return a.style && a.style.display || n.css(a, "display") }

    function Zb(a) {
        if (!n.contains(a.ownerDocument || d, a)) return !0;
        while (a && 1 === a.nodeType) {
            if ("none" === Yb(a) || "hidden" === a.type) return !0;
            a = a.parentNode
        }
        return !1
    }
    n.expr.filters.hidden = function(a) { return l.reliableHiddenOffsets() ? a.offsetWidth <= 0 && a.offsetHeight <= 0 && !a.getClientRects().length : Zb(a) }, n.expr.filters.visible = function(a) { return !n.expr.filters.hidden(a) };
    var $b = /%20/g,
        _b = /\[\]$/,
        ac = /\r?\n/g,
        bc = /^(?:submit|button|image|reset|file)$/i,
        cc = /^(?:input|select|textarea|keygen)/i;

    function dc(a, b, c, d) {
        var e;
        if (n.isArray(b)) n.each(b, function(b, e) { c || _b.test(a) ? d(a, e) : dc(a + "[" + ("object" == typeof e && null != e ? b : "") + "]", e, c, d) });
        else if (c || "object" !== n.type(b)) d(a, b);
        else
            for (e in b) dc(a + "[" + e + "]", b[e], c, d)
    }
    n.param = function(a, b) {
        var c, d = [],
            e = function(a, b) { b = n.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b) };
        if (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a) || a.jquery && !n.isPlainObject(a)) n.each(a, function() { e(this.name, this.value) });
        else
            for (c in a) dc(c, a[c], b, e);
        return d.join("&").replace($b, "+")
    }, n.fn.extend({ serialize: function() { return n.param(this.serializeArray()) }, serializeArray: function() { return this.map(function() { var a = n.prop(this, "elements"); return a ? n.makeArray(a) : this }).filter(function() { var a = this.type; return this.name && !n(this).is(":disabled") && cc.test(this.nodeName) && !bc.test(a) && (this.checked || !Z.test(a)) }).map(function(a, b) { var c = n(this).val(); return null == c ? null : n.isArray(c) ? n.map(c, function(a) { return { name: b.name, value: a.replace(ac, "\r\n") } }) : { name: b.name, value: c.replace(ac, "\r\n") } }).get() } }), n.ajaxSettings.xhr = void 0 !== a.ActiveXObject ? function() { return this.isLocal ? ic() : d.documentMode > 8 ? hc() : /^(get|post|head|put|delete|options)$/i.test(this.type) && hc() || ic() } : hc;
    var ec = 0,
        fc = {},
        gc = n.ajaxSettings.xhr();
    a.attachEvent && a.attachEvent("onunload", function() { for (var a in fc) fc[a](void 0, !0) }), l.cors = !!gc && "withCredentials" in gc, gc = l.ajax = !!gc, gc && n.ajaxTransport(function(b) {
        if (!b.crossDomain || l.cors) {
            var c;
            return {
                send: function(d, e) {
                    var f, g = b.xhr(),
                        h = ++ec;
                    if (g.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields)
                        for (f in b.xhrFields) g[f] = b.xhrFields[f];
                    b.mimeType && g.overrideMimeType && g.overrideMimeType(b.mimeType), b.crossDomain || d["X-Requested-With"] || (d["X-Requested-With"] = "XMLHttpRequest");
                    for (f in d) void 0 !== d[f] && g.setRequestHeader(f, d[f] + "");
                    g.send(b.hasContent && b.data || null), c = function(a, d) {
                        var f, i, j;
                        if (c && (d || 4 === g.readyState))
                            if (delete fc[h], c = void 0, g.onreadystatechange = n.noop, d) 4 !== g.readyState && g.abort();
                            else { j = {}, f = g.status, "string" == typeof g.responseText && (j.text = g.responseText); try { i = g.statusText } catch (k) { i = "" } f || !b.isLocal || b.crossDomain ? 1223 === f && (f = 204) : f = j.text ? 200 : 404 } j && e(f, i, j, g.getAllResponseHeaders())
                    }, b.async ? 4 === g.readyState ? a.setTimeout(c) : g.onreadystatechange = fc[h] = c : c()
                },
                abort: function() { c && c(void 0, !0) }
            }
        }
    });

    function hc() { try { return new a.XMLHttpRequest } catch (b) {} }

    function ic() { try { return new a.ActiveXObject("Microsoft.XMLHTTP") } catch (b) {} } n.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function(a) { return n.globalEval(a), a } } }), n.ajaxPrefilter("script", function(a) { void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET", a.global = !1) }), n.ajaxTransport("script", function(a) {
        if (a.crossDomain) {
            var b, c = d.head || n("head")[0] || d.documentElement;
            return {
                send: function(e, f) {
                    b = d.createElement("script"), b.async = !0, a.scriptCharset && (b.charset = a.scriptCharset), b.src = a.url, b.onload = b.onreadystatechange = function(a, c) {
                        (c || !b.readyState || /loaded|complete/.test(b.readyState)) && (b.onload = b.onreadystatechange = null, b.parentNode && b.parentNode.removeChild(b), b = null, c || f(200, "success"))
                    }, c.insertBefore(b, c.firstChild)
                },
                abort: function() { b && b.onload(void 0, !0) }
            }
        }
    });
    var jc = [],
        kc = /(=)\?(?=&|$)|\?\?/;
    n.ajaxSetup({ jsonp: "callback", jsonpCallback: function() { var a = jc.pop() || n.expando + "_" + Eb++; return this[a] = !0, a } }), n.ajaxPrefilter("json jsonp", function(b, c, d) { var e, f, g, h = b.jsonp !== !1 && (kc.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && kc.test(b.data) && "data"); return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(kc, "$1" + e) : b.jsonp !== !1 && (b.url += (Fb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function() { return g || n.error(e + " was not called"), g[0] }, b.dataTypes[0] = "json", f = a[e], a[e] = function() { g = arguments }, d.always(function() { void 0 === f ? n(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, jc.push(e)), g && n.isFunction(f) && f(g[0]), g = f = void 0 }), "script") : void 0 }), n.parseHTML = function(a, b, c) {
        if (!a || "string" != typeof a) return null;
        "boolean" == typeof b && (c = b, b = !1), b = b || d;
        var e = x.exec(a),
            f = !c && [];
        return e ? [b.createElement(e[1])] : (e = ja([a], b, f), f && f.length && n(f).remove(), n.merge([], e.childNodes))
    };
    var lc = n.fn.load;
    n.fn.load = function(a, b, c) {
        if ("string" != typeof a && lc) return lc.apply(this, arguments);
        var d, e, f, g = this,
            h = a.indexOf(" ");
        return h > -1 && (d = n.trim(a.slice(h, a.length)), a = a.slice(0, h)), n.isFunction(b) ? (c = b, b = void 0) : b && "object" == typeof b && (e = "POST"), g.length > 0 && n.ajax({ url: a, type: e || "GET", dataType: "html", data: b }).done(function(a) { f = arguments, g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a) }).always(c && function(a, b) { g.each(function() { c.apply(this, f || [a.responseText, b, a]) }) }), this
    }, n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(a, b) { n.fn[b] = function(a) { return this.on(b, a) } }), n.expr.filters.animated = function(a) { return n.grep(n.timers, function(b) { return a === b.elem }).length };

    function mc(a) { return n.isWindow(a) ? a : 9 === a.nodeType ? a.defaultView || a.parentWindow : !1 } n.offset = {
        setOffset: function(a, b, c) {
            var d, e, f, g, h, i, j, k = n.css(a, "position"),
                l = n(a),
                m = {};
            "static" === k && (a.style.position = "relative"), h = l.offset(), f = n.css(a, "top"), i = n.css(a, "left"), j = ("absolute" === k || "fixed" === k) && n.inArray("auto", [f, i]) > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m)
        }
    }, n.fn.extend({
        offset: function(a) {
            if (arguments.length) return void 0 === a ? this : this.each(function(b) { n.offset.setOffset(this, a, b) });
            var b, c, d = { top: 0, left: 0 },
                e = this[0],
                f = e && e.ownerDocument;
            if (f) return b = f.documentElement, n.contains(b, e) ? ("undefined" != typeof e.getBoundingClientRect && (d = e.getBoundingClientRect()), c = mc(f), { top: d.top + (c.pageYOffset || b.scrollTop) - (b.clientTop || 0), left: d.left + (c.pageXOffset || b.scrollLeft) - (b.clientLeft || 0) }) : d
        },
        position: function() {
            if (this[0]) {
                var a, b, c = { top: 0, left: 0 },
                    d = this[0];
                return "fixed" === n.css(d, "position") ? b = d.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), n.nodeName(a[0], "html") || (c = a.offset()), c.top += n.css(a[0], "borderTopWidth", !0), c.left += n.css(a[0], "borderLeftWidth", !0)), { top: b.top - c.top - n.css(d, "marginTop", !0), left: b.left - c.left - n.css(d, "marginLeft", !0) }
            }
        },
        offsetParent: function() { return this.map(function() { var a = this.offsetParent; while (a && !n.nodeName(a, "html") && "static" === n.css(a, "position")) a = a.offsetParent; return a || Qa }) }
    }), n.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(a, b) {
        var c = /Y/.test(b);
        n.fn[a] = function(d) { return Y(this, function(a, d, e) { var f = mc(a); return void 0 === e ? f ? b in f ? f[b] : f.document.documentElement[d] : a[d] : void(f ? f.scrollTo(c ? n(f).scrollLeft() : e, c ? e : n(f).scrollTop()) : a[d] = e) }, a, d, arguments.length, null) }
    }), n.each(["top", "left"], function(a, b) { n.cssHooks[b] = Ua(l.pixelPosition, function(a, c) { return c ? (c = Sa(a, b), Oa.test(c) ? n(a).position()[b] + "px" : c) : void 0 }) }), n.each({ Height: "height", Width: "width" }, function(a, b) {
        n.each({
            padding: "inner" + a,
            content: b,
            "": "outer" + a
        }, function(c, d) {
            n.fn[d] = function(d, e) {
                var f = arguments.length && (c || "boolean" != typeof d),
                    g = c || (d === !0 || e === !0 ? "margin" : "border");
                return Y(this, function(b, c, d) { var e; return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g) }, b, f ? d : void 0, f, null)
            }
        })
    }), n.fn.extend({ bind: function(a, b, c) { return this.on(a, null, b, c) }, unbind: function(a, b) { return this.off(a, null, b) }, delegate: function(a, b, c, d) { return this.on(b, a, c, d) }, undelegate: function(a, b, c) { return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c) } }), n.fn.size = function() { return this.length }, n.fn.andSelf = n.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function() { return n });
    var nc = a.jQuery,
        oc = a.$;
    return n.noConflict = function(b) { return a.$ === n && (a.$ = oc), b && a.jQuery === n && (a.jQuery = nc), n }, b || (a.jQuery = a.$ = n), n
});
jQuery.noConflict();
/*! jQuery Migrate v1.4.1 | (c) jQuery Foundation and other contributors | jquery.org/license */
"undefined" == typeof jQuery.migrateMute && (jQuery.migrateMute = !0),
    function(a, b, c) {
        function d(c) {
            var d = b.console;
            f[c] || (f[c] = !0, a.migrateWarnings.push(c), d && d.warn && !a.migrateMute && (d.warn("JQMIGRATE: " + c), a.migrateTrace && d.trace && d.trace()))
        }

        function e(b, c, e, f) { if (Object.defineProperty) try { return void Object.defineProperty(b, c, { configurable: !0, enumerable: !0, get: function() { return d(f), e }, set: function(a) { d(f), e = a } }) } catch (g) {} a._definePropertyBroken = !0, b[c] = e } a.migrateVersion = "1.4.1";
        var f = {};
        a.migrateWarnings = [], b.console && b.console.log && b.console.log("JQMIGRATE: Migrate is installed" + (a.migrateMute ? "" : " with logging active") + ", version " + a.migrateVersion), a.migrateTrace === c && (a.migrateTrace = !0), a.migrateReset = function() { f = {}, a.migrateWarnings.length = 0 }, "BackCompat" === document.compatMode && d("jQuery is not compatible with Quirks Mode");
        var g = a("<input/>", { size: 1 }).attr("size") && a.attrFn,
            h = a.attr,
            i = a.attrHooks.value && a.attrHooks.value.get || function() { return null },
            j = a.attrHooks.value && a.attrHooks.value.set || function() { return c },
            k = /^(?:input|button)$/i,
            l = /^[238]$/,
            m = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
            n = /^(?:checked|selected)$/i;
        e(a, "attrFn", g || {}, "jQuery.attrFn is deprecated"), a.attr = function(b, e, f, i) {
            var j = e.toLowerCase(),
                o = b && b.nodeType;
            return i && (h.length < 4 && d("jQuery.fn.attr( props, pass ) is deprecated"), b && !l.test(o) && (g ? e in g : a.isFunction(a.fn[e]))) ? a(b)[e](f) : ("type" === e && f !== c && k.test(b.nodeName) && b.parentNode && d("Can't change the 'type' of an input or button in IE 6/7/8"), !a.attrHooks[j] && m.test(j) && (a.attrHooks[j] = { get: function(b, d) { var e, f = a.prop(b, d); return f === !0 || "boolean" != typeof f && (e = b.getAttributeNode(d)) && e.nodeValue !== !1 ? d.toLowerCase() : c }, set: function(b, c, d) { var e; return c === !1 ? a.removeAttr(b, d) : (e = a.propFix[d] || d, e in b && (b[e] = !0), b.setAttribute(d, d.toLowerCase())), d } }, n.test(j) && d("jQuery.fn.attr('" + j + "') might use property instead of attribute")), h.call(a, b, e, f))
        }, a.attrHooks.value = { get: function(a, b) { var c = (a.nodeName || "").toLowerCase(); return "button" === c ? i.apply(this, arguments) : ("input" !== c && "option" !== c && d("jQuery.fn.attr('value') no longer gets properties"), b in a ? a.value : null) }, set: function(a, b) { var c = (a.nodeName || "").toLowerCase(); return "button" === c ? j.apply(this, arguments) : ("input" !== c && "option" !== c && d("jQuery.fn.attr('value', val) no longer sets properties"), void(a.value = b)) } };
        var o, p, q = a.fn.init,
            r = a.find,
            s = a.parseJSON,
            t = /^\s*</,
            u = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
            v = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g,
            w = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
        a.fn.init = function(b, e, f) { var g, h; return b && "string" == typeof b && !a.isPlainObject(e) && (g = w.exec(a.trim(b))) && g[0] && (t.test(b) || d("$(html) HTML strings must start with '<' character"), g[3] && d("$(html) HTML text after last tag is ignored"), "#" === g[0].charAt(0) && (d("HTML string cannot start with a '#' character"), a.error("JQMIGRATE: Invalid selector string (XSS)")), e && e.context && e.context.nodeType && (e = e.context), a.parseHTML) ? q.call(this, a.parseHTML(g[2], e && e.ownerDocument || e || document, !0), e, f) : (h = q.apply(this, arguments), b && b.selector !== c ? (h.selector = b.selector, h.context = b.context) : (h.selector = "string" == typeof b ? b : "", b && (h.context = b.nodeType ? b : e || document)), h) }, a.fn.init.prototype = a.fn, a.find = function(a) {
            var b = Array.prototype.slice.call(arguments);
            if ("string" == typeof a && u.test(a)) try { document.querySelector(a) } catch (c) { a = a.replace(v, function(a, b, c, d) { return "[" + b + c + '"' + d + '"]' }); try { document.querySelector(a), d("Attribute selector with '#' must be quoted: " + b[0]), b[0] = a } catch (e) { d("Attribute selector with '#' was not fixed: " + b[0]) } }
            return r.apply(this, b)
        };
        var x;
        for (x in r) Object.prototype.hasOwnProperty.call(r, x) && (a.find[x] = r[x]);
        a.parseJSON = function(a) { return a ? s.apply(this, arguments) : (d("jQuery.parseJSON requires a valid JSON string"), null) }, a.uaMatch = function(a) { a = a.toLowerCase(); var b = /(chrome)[ \/]([\w.]+)/.exec(a) || /(webkit)[ \/]([\w.]+)/.exec(a) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) || /(msie) ([\w.]+)/.exec(a) || a.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a) || []; return { browser: b[1] || "", version: b[2] || "0" } }, a.browser || (o = a.uaMatch(navigator.userAgent), p = {}, o.browser && (p[o.browser] = !0, p.version = o.version), p.chrome ? p.webkit = !0 : p.webkit && (p.safari = !0), a.browser = p), e(a, "browser", a.browser, "jQuery.browser is deprecated"), a.boxModel = a.support.boxModel = "CSS1Compat" === document.compatMode, e(a, "boxModel", a.boxModel, "jQuery.boxModel is deprecated"), e(a.support, "boxModel", a.support.boxModel, "jQuery.support.boxModel is deprecated"), a.sub = function() {
            function b(a, c) { return new b.fn.init(a, c) } a.extend(!0, b, this), b.superclass = this, b.fn = b.prototype = this(), b.fn.constructor = b, b.sub = this.sub, b.fn.init = function(d, e) { var f = a.fn.init.call(this, d, e, c); return f instanceof b ? f : b(f) }, b.fn.init.prototype = b.fn;
            var c = b(document);
            return d("jQuery.sub() is deprecated"), b
        }, a.fn.size = function() { return d("jQuery.fn.size() is deprecated; use the .length property"), this.length };
        var y = !1;
        a.swap && a.each(["height", "width", "reliableMarginRight"], function(b, c) {
            var d = a.cssHooks[c] && a.cssHooks[c].get;
            d && (a.cssHooks[c].get = function() { var a; return y = !0, a = d.apply(this, arguments), y = !1, a })
        }), a.swap = function(a, b, c, e) {
            var f, g, h = {};
            y || d("jQuery.swap() is undocumented and deprecated");
            for (g in b) h[g] = a.style[g], a.style[g] = b[g];
            f = c.apply(a, e || []);
            for (g in b) a.style[g] = h[g];
            return f
        }, a.ajaxSetup({ converters: { "text json": a.parseJSON } });
        var z = a.fn.data;
        a.fn.data = function(b) { var e, f, g = this[0]; return !g || "events" !== b || 1 !== arguments.length || (e = a.data(g, b), f = a._data(g, b), e !== c && e !== f || f === c) ? z.apply(this, arguments) : (d("Use of jQuery.fn.data('events') is deprecated"), f) };
        var A = /\/(java|ecma)script/i;
        a.clean || (a.clean = function(b, c, e, f) {
            c = c || document, c = !c.nodeType && c[0] || c, c = c.ownerDocument || c, d("jQuery.clean() is deprecated");
            var g, h, i, j, k = [];
            if (a.merge(k, a.buildFragment(b, c).childNodes), e)
                for (i = function(a) { return !a.type || A.test(a.type) ? f ? f.push(a.parentNode ? a.parentNode.removeChild(a) : a) : e.appendChild(a) : void 0 }, g = 0; null != (h = k[g]); g++) a.nodeName(h, "script") && i(h) || (e.appendChild(h), "undefined" != typeof h.getElementsByTagName && (j = a.grep(a.merge([], h.getElementsByTagName("script")), i), k.splice.apply(k, [g + 1, 0].concat(j)), g += j.length));
            return k
        });
        var B = a.event.add,
            C = a.event.remove,
            D = a.event.trigger,
            E = a.fn.toggle,
            F = a.fn.live,
            G = a.fn.die,
            H = a.fn.load,
            I = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess",
            J = new RegExp("\\b(?:" + I + ")\\b"),
            K = /(?:^|\s)hover(\.\S+|)\b/,
            L = function(b) { return "string" != typeof b || a.event.special.hover ? b : (K.test(b) && d("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"), b && b.replace(K, "mouseenter$1 mouseleave$1")) };
        a.event.props && "attrChange" !== a.event.props[0] && a.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement"), a.event.dispatch && e(a.event, "handle", a.event.dispatch, "jQuery.event.handle is undocumented and deprecated"), a.event.add = function(a, b, c, e, f) { a !== document && J.test(b) && d("AJAX events should be attached to document: " + b), B.call(this, a, L(b || ""), c, e, f) }, a.event.remove = function(a, b, c, d, e) { C.call(this, a, L(b) || "", c, d, e) }, a.each(["load", "unload", "error"], function(b, c) { a.fn[c] = function() { var a = Array.prototype.slice.call(arguments, 0); return "load" === c && "string" == typeof a[0] ? H.apply(this, a) : (d("jQuery.fn." + c + "() is deprecated"), a.splice(0, 0, c), arguments.length ? this.bind.apply(this, a) : (this.triggerHandler.apply(this, a), this)) } }), a.fn.toggle = function(b, c) {
            if (!a.isFunction(b) || !a.isFunction(c)) return E.apply(this, arguments);
            d("jQuery.fn.toggle(handler, handler...) is deprecated");
            var e = arguments,
                f = b.guid || a.guid++,
                g = 0,
                h = function(c) { var d = (a._data(this, "lastToggle" + b.guid) || 0) % g; return a._data(this, "lastToggle" + b.guid, d + 1), c.preventDefault(), e[d].apply(this, arguments) || !1 };
            for (h.guid = f; g < e.length;) e[g++].guid = f;
            return this.click(h)
        }, a.fn.live = function(b, c, e) { return d("jQuery.fn.live() is deprecated"), F ? F.apply(this, arguments) : (a(this.context).on(b, this.selector, c, e), this) }, a.fn.die = function(b, c) { return d("jQuery.fn.die() is deprecated"), G ? G.apply(this, arguments) : (a(this.context).off(b, this.selector || "**", c), this) }, a.event.trigger = function(a, b, c, e) { return c || J.test(a) || d("Global events are undocumented and deprecated"), D.call(this, a, b, c || document, e) }, a.each(I.split("|"), function(b, c) { a.event.special[c] = { setup: function() { var b = this; return b !== document && (a.event.add(document, c + "." + a.guid, function() { a.event.trigger(c, Array.prototype.slice.call(arguments, 1), b, !0) }), a._data(this, c, a.guid++)), !1 }, teardown: function() { return this !== document && a.event.remove(document, c + "." + a._data(this, c)), !1 } } }), a.event.special.ready = { setup: function() { this === document && d("'ready' event is deprecated") } };
        var M = a.fn.andSelf || a.fn.addBack,
            N = a.fn.find;
        if (a.fn.andSelf = function() { return d("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"), M.apply(this, arguments) }, a.fn.find = function(a) { var b = N.apply(this, arguments); return b.context = this.context, b.selector = this.selector ? this.selector + " " + a : a, b }, a.Callbacks) {
            var O = a.Deferred,
                P = [
                    ["resolve", "done", a.Callbacks("once memory"), a.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", a.Callbacks("once memory"), a.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", a.Callbacks("memory"), a.Callbacks("memory")]
                ];
            a.Deferred = function(b) {
                var c = O(),
                    e = c.promise();
                return c.pipe = e.pipe = function() {
                    var b = arguments;
                    return d("deferred.pipe() is deprecated"), a.Deferred(function(d) {
                        a.each(P, function(f, g) {
                            var h = a.isFunction(b[f]) && b[f];
                            c[g[1]](function() {
                                var b = h && h.apply(this, arguments);
                                b && a.isFunction(b.promise) ? b.promise().done(d.resolve).fail(d.reject).progress(d.notify) : d[g[0] + "With"](this === e ? d.promise() : this, h ? [b] : arguments)
                            })
                        }), b = null
                    }).promise()
                }, c.isResolved = function() { return d("deferred.isResolved is deprecated"), "resolved" === c.state() }, c.isRejected = function() { return d("deferred.isRejected is deprecated"), "rejected" === c.state() }, b && b.call(c, c), c
            }
        }
    }(jQuery, window);
! function(t) {
    function e(i) { if (n[i]) return n[i].exports; var r = n[i] = { exports: {}, id: i, loaded: !1 }; return t[i].call(r.exports, r, r.exports, e), r.loaded = !0, r.exports }
    var n = {};
    return e.m = t, e.c = n, e.p = "", e(0)
}([function(t, e, n) { t.exports = n(127) }, , function(t, e) { t.exports = window.jQuery }, , , , , , function(t, e) {
    var n = Object;
    t.exports = { create: n.create, getProto: n.getPrototypeOf, isEnum: {}.propertyIsEnumerable, getDesc: n.getOwnPropertyDescriptor, setDesc: n.defineProperty, setDescs: n.defineProperties, getKeys: n.keys, getNames: n.getOwnPropertyNames, getSymbols: n.getOwnPropertySymbols, each: [].forEach }
}, , , , , , , , function(t, e) { var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(); "number" == typeof __g && (__g = n) }, , , , function(t, e) { var n = t.exports = { version: "1.2.6" }; "number" == typeof __e && (__e = n) }, function(t, e, n) {
    var i = n(70),
        r = n(45);
    t.exports = function(t) { return i(r(t)) }
}, , , , , function(t, e) { t.exports = function(t) { try { return !!t() } catch (e) { return !0 } } }, , , , function(t, e, n) {
    (function(t) {
        "use strict";

        function n() { return "ontouchstart" in window || navigator.maxTouchPoints }

        function i() { n() ? t("body").addClass("touch-device") : t("body").removeClass("touch-device") } Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n, i(), t(window).on("resize", function() { i() })
    }).call(e, n(2))
}, function(t, e) {
    var n = {}.toString;
    t.exports = function(t) { return n.call(t).slice(8, -1) }
}, function(t, e, n) { t.exports = !n(26)(function() { return 7 != Object.defineProperty({}, "a", { get: function() { return 7 } }).a }) }, function(t, e) {
    var n = {}.hasOwnProperty;
    t.exports = function(t, e) { return n.call(t, e) }
}, function(t, e) { t.exports = function(t, e) { return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e } } }, function(t, e, n) {
    var i = n(16),
        r = "__core-js_shared__",
        o = i[r] || (i[r] = {});
    t.exports = function(t) { return o[t] || (o[t] = {}) }
}, function(t, e) {
    var n = 0,
        i = Math.random();
    t.exports = function(t) { return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36)) }
}, function(t, e, n) {
    var i = n(35)("wks"),
        r = n(36),
        o = n(16).Symbol;
    t.exports = function(t) { return i[t] || (i[t] = o && o[t] || (o || r)("Symbol." + t)) }
}, , , , , , function(t, e, n) { t.exports = n(306) }, function(t, e, n) {
    "use strict";
    var i = n(60).default;
    e.default = function(t) { return t && t.constructor === i ? "symbol" : typeof t }, e.__esModule = !0
}, function(t, e) { t.exports = function(t) { if (void 0 == t) throw TypeError("Can't call method on  " + t); return t } }, function(t, e, n) {
    var i = n(16),
        r = n(20),
        o = n(66),
        a = "prototype",
        s = function(t, e, n) {
            var l, u, c, d = t & s.F,
                h = t & s.G,
                f = t & s.S,
                p = t & s.P,
                g = t & s.B,
                v = t & s.W,
                m = h ? r : r[e] || (r[e] = {}),
                y = h ? i : f ? i[e] : (i[e] || {})[a];
            h && (n = e);
            for (l in n) u = !d && y && l in y, u && l in m || (c = u ? y[l] : n[l], m[l] = h && "function" != typeof y[l] ? n[l] : g && u ? o(c, i) : v && y[l] == c ? function(t) { var e = function(e) { return this instanceof t ? new t(e) : t(e) }; return e[a] = t[a], e }(c) : p && "function" == typeof c ? o(Function.call, c) : c, p && ((m[a] || (m[a] = {}))[l] = c))
        };
    s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, t.exports = s
}, , , , , , , , , , , function(t, e, n) {
    (function(t) {
        "use strict";

        function i() {
            var e = t("[data-animate]");
            e.each(function(e, n) {
                t(n).waypoint({
                    handler: function(e) {
                        if ("down" === e) {
                            if (!t(n).hasClass("in-view")) {
                                var i = t(n).find("[data-chart]");
                                if (i.length) {
                                    var o = i.data("chart"),
                                        a = t(n).find("canvas").attr("id");
                                    switch (o) {
                                        case "injury":
                                            (0, r.initInjuryChart)(a);
                                            break;
                                        case "incidents":
                                            (0, r.initIncidentsChart)(a)
                                    }
                                }
                            }
                            t(n).addClass("in-view")
                        }
                    },
                    offset: "80%"
                })
            })
        }
        Object.defineProperty(e, "__esModule", { value: !0 }), e.default = i, n(119);
        var r = n(92);
        0 === t(".hero").length ? i() : window.innerWidth > 768 ? t(window).scrollTop() > 0 && 0 !== t(".hero").length && i() : i(), t(window).on("resize", function() { window.innerWidth > 769 && i() })
    }).call(e, n(2))
}, function(t, e, n) { t.exports = { "default": n(61), __esModule: !0 } }, function(t, e, n) { t.exports = { "default": n(62), __esModule: !0 } }, function(t, e, n) { t.exports = { "default": n(63), __esModule: !0 } }, function(t, e, n) {
    var i = n(8);
    t.exports = function(t, e) { return i.create(t, e) }
}, function(t, e, n) {
    var i = n(8);
    t.exports = function(t, e, n) { return i.setDesc(t, e, n) }
}, function(t, e, n) { n(78), n(77), t.exports = n(20).Symbol }, function(t, e) { t.exports = function(t) { if ("function" != typeof t) throw TypeError(t + " is not a function!"); return t } }, function(t, e, n) {
    var i = n(72);
    t.exports = function(t) { if (!i(t)) throw TypeError(t + " is not an object!"); return t }
}, function(t, e, n) {
    var i = n(64);
    t.exports = function(t, e, n) {
        if (i(t), void 0 === e) return t;
        switch (n) {
            case 1:
                return function(n) { return t.call(e, n) };
            case 2:
                return function(n, i) { return t.call(e, n, i) };
            case 3:
                return function(n, i, r) { return t.call(e, n, i, r) }
        }
        return function() { return t.apply(e, arguments) }
    }
}, function(t, e, n) {
    var i = n(8);
    t.exports = function(t) {
        var e = i.getKeys(t),
            n = i.getSymbols;
        if (n)
            for (var r, o = n(t), a = i.isEnum, s = 0; o.length > s;) a.call(t, r = o[s++]) && e.push(r);
        return e
    }
}, function(t, e, n) {
    var i = n(21),
        r = n(8).getNames,
        o = {}.toString,
        a = "object" == typeof window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        s = function(t) { try { return r(t) } catch (e) { return a.slice() } };
    t.exports.get = function(t) { return a && "[object Window]" == o.call(t) ? s(t) : r(i(t)) }
}, function(t, e, n) {
    var i = n(8),
        r = n(34);
    t.exports = n(32) ? function(t, e, n) { return i.setDesc(t, e, r(1, n)) } : function(t, e, n) { return t[e] = n, t }
}, function(t, e, n) {
    var i = n(31);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) { return "String" == i(t) ? t.split("") : Object(t) }
}, function(t, e, n) {
    var i = n(31);
    t.exports = Array.isArray || function(t) { return "Array" == i(t) }
}, function(t, e) { t.exports = function(t) { return "object" == typeof t ? null !== t : "function" == typeof t } }, function(t, e, n) {
    var i = n(8),
        r = n(21);
    t.exports = function(t, e) {
        for (var n, o = r(t), a = i.getKeys(o), s = a.length, l = 0; s > l;)
            if (o[n = a[l++]] === e) return n
    }
}, function(t, e) { t.exports = !0 }, function(t, e, n) { t.exports = n(69) }, function(t, e, n) {
    var i = n(8).setDesc,
        r = n(33),
        o = n(37)("toStringTag");
    t.exports = function(t, e, n) { t && !r(t = n ? t : t.prototype, o) && i(t, o, { configurable: !0, value: e }) }
}, function(t, e) {}, function(t, e, n) {
    "use strict";
    var i = n(8),
        r = n(16),
        o = n(33),
        a = n(32),
        s = n(46),
        l = n(75),
        u = n(26),
        c = n(35),
        d = n(76),
        h = n(36),
        f = n(37),
        p = n(73),
        g = n(68),
        v = n(67),
        m = n(71),
        y = n(65),
        b = n(21),
        x = n(34),
        w = i.getDesc,
        k = i.setDesc,
        S = i.create,
        _ = g.get,
        T = r.Symbol,
        C = r.JSON,
        M = C && C.stringify,
        A = !1,
        E = f("_hidden"),
        P = i.isEnum,
        I = c("symbol-registry"),
        z = c("symbols"),
        D = "function" == typeof T,
        O = Object.prototype,
        L = a && u(function() { return 7 != S(k({}, "a", { get: function() { return k(this, "a", { value: 7 }).a } })).a }) ? function(t, e, n) {
            var i = w(O, e);
            i && delete O[e], k(t, e, n), i && t !== O && k(O, e, i)
        } : k,
        $ = function(t) { var e = z[t] = S(T.prototype); return e._k = t, a && A && L(O, t, { configurable: !0, set: function(e) { o(this, E) && o(this[E], t) && (this[E][t] = !1), L(this, t, x(1, e)) } }), e },
        N = function(t) { return "symbol" == typeof t },
        R = function(t, e, n) { return n && o(z, e) ? (n.enumerable ? (o(t, E) && t[E][e] && (t[E][e] = !1), n = S(n, { enumerable: x(0, !1) })) : (o(t, E) || k(t, E, x(1, {})), t[E][e] = !0), L(t, e, n)) : k(t, e, n) },
        q = function(t, e) { y(t); for (var n, i = v(e = b(e)), r = 0, o = i.length; o > r;) R(t, n = i[r++], e[n]); return t },
        F = function(t, e) { return void 0 === e ? S(t) : q(S(t), e) },
        H = function(t) { var e = P.call(this, t); return !(e || !o(this, t) || !o(z, t) || o(this, E) && this[E][t]) || e },
        B = function(t, e) { var n = w(t = b(t), e); return !n || !o(z, e) || o(t, E) && t[E][e] || (n.enumerable = !0), n },
        W = function(t) { for (var e, n = _(b(t)), i = [], r = 0; n.length > r;) o(z, e = n[r++]) || e == E || i.push(e); return i },
        j = function(t) { for (var e, n = _(b(t)), i = [], r = 0; n.length > r;) o(z, e = n[r++]) && i.push(z[e]); return i },
        Y = function(t) { if (void 0 !== t && !N(t)) { for (var e, n, i = [t], r = 1, o = arguments; o.length > r;) i.push(o[r++]); return e = i[1], "function" == typeof e && (n = e), !n && m(e) || (e = function(t, e) { if (n && (e = n.call(this, t, e)), !N(e)) return e }), i[1] = e, M.apply(C, i) } },
        U = u(function() { var t = T(); return "[null]" != M([t]) || "{}" != M({ a: t }) || "{}" != M(Object(t)) });
    D || (T = function() { if (N(this)) throw TypeError("Symbol is not a constructor"); return $(h(arguments.length > 0 ? arguments[0] : void 0)) }, l(T.prototype, "toString", function() { return this._k }), N = function(t) { return t instanceof T }, i.create = F, i.isEnum = H, i.getDesc = B, i.setDesc = R, i.setDescs = q, i.getNames = g.get = W, i.getSymbols = j, a && !n(74) && l(O, "propertyIsEnumerable", H, !0));
    var V = { "for": function(t) { return o(I, t += "") ? I[t] : I[t] = T(t) }, keyFor: function(t) { return p(I, t) }, useSetter: function() { A = !0 }, useSimple: function() { A = !1 } };
    i.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), function(t) {
        var e = f(t);
        V[t] = D ? e : $(e)
    }), A = !0, s(s.G + s.W, { Symbol: T }), s(s.S, "Symbol", V), s(s.S + s.F * !D, "Object", { create: F, defineProperty: R, defineProperties: q, getOwnPropertyDescriptor: B, getOwnPropertyNames: W, getOwnPropertySymbols: j }), C && s(s.S + s.F * (!D || U), "JSON", { stringify: Y }), d(T, "Symbol"), d(Math, "Math", !0), d(r.JSON, "JSON", !0)
}, , , , , , , , , , , function(t, e, n) { t.exports = n(294) }, function(t, e) {
    "use strict";
    ! function(t) {
        function e(e, n, i, r) {
            var o = e.text(),
                a = o.split(n),
                s = "";
            a.length && (t(a).each(function(t, e) { e = " " === e ? "&nbsp;" : e, s += '<span class="' + i + (t + 1) + '" aria-hidden="true">' + e + "</span>" + r }), e.attr("aria-label", o).empty().append(s))
        }
        var n = {
            init: function() { return this.each(function() { e(t(this), "", "char", "") }) },
            words: function() { return this.each(function() { e(t(this), " ", "word", " ") }) },
            lines: function() {
                return this.each(function() {
                    var n = "eefec303079ad17405c889e092e105b0";
                    e(t(this).children("br").replaceWith(n).end(), n, "line", "")
                })
            }
        };
        t.fn.lettering = function(e) { return e && n[e] ? n[e].apply(this, [].slice.call(arguments, 1)) : "letters" !== e && e ? (t.error("Method " + e + " does not exist on jQuery.lettering"), this) : n.init.apply(this, [].slice.call(arguments, 0)) }
    }(jQuery)
}, function(t, e, n) {
    function i(t) { return t && t.__esModule ? t : { "default": t } }
    var r, o, a, s = n(44),
        l = i(s);
    ! function(i) { o = [n(2)], r = i, a = "function" == typeof r ? r.apply(e, o) : r, !(void 0 !== a && (t.exports = a)) }(function(t) {
        "use strict";
        var e = !1,
            n = !1,
            i = 0,
            r = 2e3,
            o = 0,
            a = t,
            s = document,
            u = window,
            c = a(u),
            d = [],
            h = u.requestAnimationFrame || u.webkitRequestAnimationFrame || u.mozRequestAnimationFrame || !1,
            f = u.cancelAnimationFrame || u.webkitCancelAnimationFrame || u.mozCancelAnimationFrame || !1;
        if (h) u.cancelAnimationFrame || (f = function(t) {});
        else {
            var p = 0;
            h = function(t, e) {
                var n = (new Date).getTime(),
                    i = Math.max(0, 16 - (n - p)),
                    r = u.setTimeout(function() { t(n + i) }, i);
                return p = n + i, r
            }, f = function(t) { u.clearTimeout(t) }
        }
        var g = u.MutationObserver || u.WebKitMutationObserver || !1,
            v = Date.now || function() { return (new Date).getTime() },
            m = {
                zindex: "auto",
                cursoropacitymin: 0,
                cursoropacitymax: 1,
                cursorcolor: "#424242",
                cursorwidth: "6px",
                cursorborder: "1px solid #fff",
                cursorborderradius: "5px",
                scrollspeed: 40,
                mousescrollstep: 27,
                touchbehavior: !1,
                emulatetouch: !1,
                hwacceleration: !0,
                usetransition: !0,
                boxzoom: !1,
                dblclickzoom: !0,
                gesturezoom: !0,
                grabcursorenabled: !0,
                autohidemode: !0,
                background: "",
                iframeautoresize: !0,
                cursorminheight: 32,
                preservenativescrolling: !0,
                railoffset: !1,
                railhoffset: !1,
                bouncescroll: !0,
                spacebarenabled: !0,
                railpadding: { top: 0, right: 0, left: 0, bottom: 0 },
                disableoutline: !0,
                horizrailenabled: !0,
                railalign: "right",
                railvalign: "bottom",
                enabletranslate3d: !0,
                enablemousewheel: !0,
                enablekeyboard: !0,
                smoothscroll: !0,
                sensitiverail: !0,
                enablemouselockapi: !0,
                cursorfixedheight: !1,
                directionlockdeadzone: 6,
                hidecursordelay: 400,
                nativeparentscrolling: !0,
                enablescrollonselection: !0,
                overflowx: !0,
                overflowy: !0,
                cursordragspeed: .3,
                rtlmode: "auto",
                cursordragontouch: !1,
                oneaxismousemode: "auto",
                scriptpath: function() {
                    var t = s.currentScript || function() { var t = s.getElementsByTagName("script"); return !!t.length && t[t.length - 1] }(),
                        e = t ? t.src.split("?")[0] : "";
                    return e.split("/").length > 0 ? e.split("/").slice(0, -1).join("/") + "/" : ""
                }(),
                preventmultitouchscrolling: !0,
                disablemutationobserver: !1,
                enableobserver: !0,
                scrollbarid: !1
            },
            y = !1,
            b = function() {
                if (y) return y;
                var t = s.createElement("DIV"),
                    e = t.style,
                    n = navigator.userAgent,
                    i = navigator.platform,
                    r = {};
                return r.haspointerlock = "pointerLockElement" in s || "webkitPointerLockElement" in s || "mozPointerLockElement" in s, r.isopera = "opera" in u, r.isopera12 = r.isopera && "getUserMedia" in navigator, r.isoperamini = "[object OperaMini]" === Object.prototype.toString.call(u.operamini), r.isie = "all" in s && "attachEvent" in t && !r.isopera, r.isieold = r.isie && !("msInterpolationMode" in e), r.isie7 = r.isie && !r.isieold && (!("documentMode" in s) || 7 === s.documentMode), r.isie8 = r.isie && "documentMode" in s && 8 === s.documentMode, r.isie9 = r.isie && "performance" in u && 9 === s.documentMode, r.isie10 = r.isie && "performance" in u && 10 === s.documentMode, r.isie11 = "msRequestFullscreen" in t && s.documentMode >= 11, r.ismsedge = "msCredentials" in u, r.ismozilla = "MozAppearance" in e, r.iswebkit = !r.ismsedge && "WebkitAppearance" in e, r.ischrome = r.iswebkit && "chrome" in u, r.ischrome38 = r.ischrome && "touchAction" in e, r.ischrome22 = !r.ischrome38 && r.ischrome && r.haspointerlock, r.ischrome26 = !r.ischrome38 && r.ischrome && "transition" in e, r.cantouch = "ontouchstart" in s.documentElement || "ontouchstart" in u, r.hasw3ctouch = (u.PointerEvent || !1) && (navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0), r.hasmstouch = !r.hasw3ctouch && (u.MSPointerEvent || !1), r.ismac = /^mac$/i.test(i), r.isios = r.cantouch && /iphone|ipad|ipod/i.test(i), r.isios4 = r.isios && !("seal" in Object), r.isios7 = r.isios && "webkitHidden" in s, r.isios8 = r.isios && "hidden" in s, r.isios10 = r.isios && u.Proxy, r.isandroid = /android/i.test(n), r.haseventlistener = "addEventListener" in t, r.trstyle = !1, r.hastransform = !1, r.hastranslate3d = !1, r.transitionstyle = !1, r.hastransition = !1, r.transitionend = !1, r.trstyle = "transform", r.hastransform = "transform" in e || function() {
                    for (var t = ["msTransform", "webkitTransform", "MozTransform", "OTransform"], n = 0, i = t.length; n < i; n++)
                        if (void 0 !== e[t[n]]) { r.trstyle = t[n]; break } r.hastransform = !!r.trstyle
                }(), r.hastransform && (e[r.trstyle] = "translate3d(1px,2px,3px)", r.hastranslate3d = /translate3d/.test(e[r.trstyle])), r.transitionstyle = "transition", r.prefixstyle = "", r.transitionend = "transitionend", r.hastransition = "transition" in e || function() {
                    r.transitionend = !1;
                    for (var t = ["webkitTransition", "msTransition", "MozTransition", "OTransition", "OTransition", "KhtmlTransition"], n = ["-webkit-", "-ms-", "-moz-", "-o-", "-o", "-khtml-"], i = ["webkitTransitionEnd", "msTransitionEnd", "transitionend", "otransitionend", "oTransitionEnd", "KhtmlTransitionEnd"], o = 0, a = t.length; o < a; o++)
                        if (t[o] in e) { r.transitionstyle = t[o], r.prefixstyle = n[o], r.transitionend = i[o]; break } r.ischrome26 && (r.prefixstyle = n[1]), r.hastransition = r.transitionstyle
                }(), r.cursorgrabvalue = function() {
                    var t = ["grab", "-webkit-grab", "-moz-grab"];
                    (r.ischrome && !r.ischrome38 || r.isie) && (t = []);
                    for (var n = 0, i = t.length; n < i; n++) { var o = t[n]; if (e.cursor = o, e.cursor == o) return o }
                    return "url(https://cdnjs.cloudflare.com/ajax/libs/slider-pro/1.3.0/css/images/openhand.cur),n-resize"
                }(), r.hasmousecapture = "setCapture" in t, r.hasMutationObserver = !1 !== g, t = null, y = r, r
            },
            x = function T(t, l) {
                function p() { var t = _.doc.css(I.trstyle); return !(!t || "matrix" != t.substr(0, 6)) && t.replace(/^.*\((.*)\)$/g, "$1").replace(/px/g, "").split(/, +/) }

                function T() {
                    var t = _.win;
                    if ("zIndex" in t) return t.zIndex();
                    for (; t.length > 0;) {
                        if (9 == t[0].nodeType) return !1;
                        var e = t.css("zIndex");
                        if (!isNaN(e) && 0 !== e) return parseInt(e);
                        t = t.parent()
                    }
                    return !1
                }

                function y(t, e, n) {
                    var i = t.css(e),
                        r = parseFloat(i);
                    if (isNaN(r)) { var o = 3 == (r = O[i] || 0) ? n ? _.win.outerHeight() - _.win.innerHeight() : _.win.outerWidth() - _.win.innerWidth() : 1; return _.isie8 && r && (r += 1), o ? r : 0 }
                    return r
                }

                function x(t, e, n, i) { _._bind(t, e, function(i) { var r = { original: i = i || u.event, target: i.target || i.srcElement, type: "wheel", deltaMode: "MozMousePixelScroll" == i.type ? 0 : 1, deltaX: 0, deltaZ: 0, preventDefault: function() { return i.preventDefault ? i.preventDefault() : i.returnValue = !1, !1 }, stopImmediatePropagation: function() { i.stopImmediatePropagation ? i.stopImmediatePropagation() : i.cancelBubble = !0 } }; return "mousewheel" == e ? (i.wheelDeltaX && (r.deltaX = -.025 * i.wheelDeltaX), i.wheelDeltaY && (r.deltaY = -.025 * i.wheelDeltaY), !r.deltaY && !r.deltaX && (r.deltaY = -.025 * i.wheelDelta)) : r.deltaY = i.detail, n.call(t, r) }, i) }

                function k(t, e, n, i) {
                    _.scrollrunning || (_.newscrolly = _.getScrollTop(), _.newscrollx = _.getScrollLeft(), F = v());
                    var r = v() - F;
                    if (F = v(), r > 350 ? H = 1 : H += (2 - H) / 10, t = t * H | 0, e = e * H | 0, t) {
                        if (i)
                            if (t < 0) { if (_.getScrollLeft() >= _.page.maxw) return !0 } else if (_.getScrollLeft() <= 0) return !0;
                        var o = t > 0 ? 1 : -1;
                        q !== o && (_.scrollmom && _.scrollmom.stop(), _.newscrollx = _.getScrollLeft(), q = o), _.lastdeltax -= t
                    }
                    if (e) {
                        if (function() { var t = _.getScrollTop(); if (e < 0) { if (t >= _.page.maxh) return !0 } else if (t <= 0) return !0 }()) {
                            if (M.nativeparentscrolling && n && !_.ispage && !_.zoomactive) return !0;
                            var a = _.view.h >> 1;
                            _.newscrolly < -a ? (_.newscrolly = -a, e = -1) : _.newscrolly > _.page.maxh + a ? (_.newscrolly = _.page.maxh + a, e = 1) : e = 0
                        }
                        var s = e > 0 ? 1 : -1;
                        R !== s && (_.scrollmom && _.scrollmom.stop(), _.newscrolly = _.getScrollTop(), R = s), _.lastdeltay -= e
                    }(e || t) && _.synched("relativexy", function() {
                        var t = _.lastdeltay + _.newscrolly;
                        _.lastdeltay = 0;
                        var e = _.lastdeltax + _.newscrollx;
                        _.lastdeltax = 0, _.rail.drag || _.doScrollPos(e, t)
                    })
                }

                function S(t, e, n) { var i, r; return !(n || !B) || (0 === t.deltaMode ? (i = -t.deltaX * (M.mousescrollstep / 54) | 0, r = -t.deltaY * (M.mousescrollstep / 54) | 0) : 1 === t.deltaMode && (i = -t.deltaX * M.mousescrollstep * 50 / 80 | 0, r = -t.deltaY * M.mousescrollstep * 50 / 80 | 0), e && M.oneaxismousemode && 0 === i && r && (i = r, r = 0, n && (i < 0 ? _.getScrollLeft() >= _.page.maxw : _.getScrollLeft() <= 0) && (r = i, i = 0)), _.isrtlmode && (i = -i), k(i, r, n, !0) ? void(n && (B = !0)) : (B = !1, t.stopImmediatePropagation(), t.preventDefault())) }
                var _ = this;
                this.version = "3.7.6", this.name = "nicescroll", this.me = l;
                var C = a("body"),
                    M = this.opt = { doc: C, win: !1 };
                if (a.extend(M, m), M.snapbackspeed = 80, t)
                    for (var A in M) void 0 !== t[A] && (M[A] = t[A]);
                if (M.disablemutationobserver && (g = !1), this.doc = M.doc, this.iddoc = this.doc && this.doc[0] ? this.doc[0].id || "" : "", this.ispage = /^BODY|HTML/.test(M.win ? M.win[0].nodeName : this.doc[0].nodeName), this.haswrapper = !1 !== M.win, this.win = M.win || (this.ispage ? c : this.doc), this.docscroll = this.ispage && !this.haswrapper ? c : this.win, this.body = C, this.viewport = !1, this.isfixed = !1, this.iframe = !1, this.isiframe = "IFRAME" == this.doc[0].nodeName && "IFRAME" == this.win[0].nodeName, this.istextarea = "TEXTAREA" == this.win[0].nodeName, this.forcescreen = !1, this.canshowonmouseevent = "scroll" != M.autohidemode, this.onmousedown = !1, this.onmouseup = !1, this.onmousemove = !1, this.onmousewheel = !1, this.onkeypress = !1, this.ongesturezoom = !1, this.onclick = !1, this.onscrollstart = !1, this.onscrollend = !1, this.onscrollcancel = !1, this.onzoomin = !1, this.onzoomout = !1, this.view = !1, this.page = !1, this.scroll = { x: 0, y: 0 }, this.scrollratio = { x: 0, y: 0 }, this.cursorheight = 20, this.scrollvaluemax = 0, "auto" == M.rtlmode) {
                    var E = this.win[0] == u ? this.body : this.win,
                        P = E.css("writing-mode") || E.css("-webkit-writing-mode") || E.css("-ms-writing-mode") || E.css("-moz-writing-mode");
                    "horizontal-tb" == P || "lr-tb" == P || "" === P ? (this.isrtlmode = "rtl" == E.css("direction"), this.isvertical = !1) : (this.isrtlmode = "vertical-rl" == P || "tb" == P || "tb-rl" == P || "rl-tb" == P, this.isvertical = "vertical-rl" == P || "tb" == P || "tb-rl" == P)
                } else this.isrtlmode = !0 === M.rtlmode, this.isvertical = !1;
                if (this.scrollrunning = !1, this.scrollmom = !1, this.observer = !1, this.observerremover = !1, this.observerbody = !1, !1 !== M.scrollbarid) this.id = M.scrollbarid;
                else
                    do this.id = "ascrail" + r++; while (s.getElementById(this.id));
                this.rail = !1, this.cursor = !1, this.cursorfreezed = !1, this.selectiondrag = !1, this.zoom = !1, this.zoomactive = !1, this.hasfocus = !1, this.hasmousefocus = !1, this.railslocked = !1, this.locked = !1, this.hidden = !1, this.cursoractive = !0, this.wheelprevented = !1, this.overflowx = M.overflowx, this.overflowy = M.overflowy, this.nativescrollingarea = !1, this.checkarea = 0, this.events = [], this.saved = {}, this.delaylist = {}, this.synclist = {}, this.lastdeltax = 0, this.lastdeltay = 0, this.detected = b();
                var I = a.extend({}, this.detected);
                this.canhwscroll = I.hastransform && M.hwacceleration, this.ishwscroll = this.canhwscroll && _.haswrapper, this.isrtlmode ? this.isvertical ? this.hasreversehr = !(I.iswebkit || I.isie || I.isie11) : this.hasreversehr = !(I.iswebkit || I.isie && !I.isie10 && !I.isie11) : this.hasreversehr = !1, this.istouchcapable = !1, I.cantouch || !I.hasw3ctouch && !I.hasmstouch ? !I.cantouch || I.isios || I.isandroid || !I.iswebkit && !I.ismozilla || (this.istouchcapable = !0) : this.istouchcapable = !0, M.enablemouselockapi || (I.hasmousecapture = !1, I.haspointerlock = !1), this.debounced = function(t, e, n) { _ && (_.delaylist[t] || !1 || (_.delaylist[t] = { h: h(function() { _.delaylist[t].fn.call(_), _.delaylist[t] = !1 }, n) }, e.call(_)), _.delaylist[t].fn = e) }, this.synched = function(t, e) { _.synclist[t] ? _.synclist[t] = e : (_.synclist[t] = e, h(function() { _ && (_.synclist[t] && _.synclist[t].call(_), _.synclist[t] = null) })) }, this.unsynched = function(t) { _.synclist[t] && (_.synclist[t] = !1) }, this.css = function(t, e) { for (var n in e) _.saved.css.push([t, n, t.css(n)]), t.css(n, e[n]) }, this.scrollTop = function(t) { return void 0 === t ? _.getScrollTop() : _.setScrollTop(t) }, this.scrollLeft = function(t) { return void 0 === t ? _.getScrollLeft() : _.setScrollLeft(t) };
                var z = function(t, e, n, i, r, o, a) { this.st = t, this.ed = e, this.spd = n, this.p1 = i || 0, this.p2 = r || 1, this.p3 = o || 0, this.p4 = a || 1, this.ts = v(), this.df = e - t };
                if (z.prototype = {
                        B2: function(t) { return 3 * (1 - t) * (1 - t) * t },
                        B3: function(t) { return 3 * (1 - t) * t * t },
                        B4: function(t) { return t * t * t },
                        getPos: function() { return (v() - this.ts) / this.spd },
                        getNow: function() {
                            var t = (v() - this.ts) / this.spd,
                                e = this.B2(t) + this.B3(t) + this.B4(t);
                            return t >= 1 ? this.ed : this.st + this.df * e | 0
                        },
                        update: function(t, e) { return this.st = this.getNow(), this.ed = t, this.spd = e, this.ts = v(), this.df = this.ed - this.st, this }
                    }, this.ishwscroll) {
                    this.doc.translate = { x: 0, y: 0, tx: "0px", ty: "0px" }, I.hastranslate3d && I.isios && this.doc.css("-webkit-backface-visibility", "hidden"), this.getScrollTop = function(t) { if (!t) { var e = p(); if (e) return 16 == e.length ? -e[13] : -e[5]; if (_.timerscroll && _.timerscroll.bz) return _.timerscroll.bz.getNow() } return _.doc.translate.y }, this.getScrollLeft = function(t) { if (!t) { var e = p(); if (e) return 16 == e.length ? -e[12] : -e[4]; if (_.timerscroll && _.timerscroll.bh) return _.timerscroll.bh.getNow() } return _.doc.translate.x }, this.notifyScrollEvent = function(t) {
                        var e = s.createEvent("UIEvents");
                        e.initUIEvent("scroll", !1, !1, u, 1), e.niceevent = !0, t.dispatchEvent(e)
                    };
                    var D = this.isrtlmode ? 1 : -1;
                    I.hastranslate3d && M.enabletranslate3d ? (this.setScrollTop = function(t, e) { _.doc.translate.y = t, _.doc.translate.ty = -1 * t + "px", _.doc.css(I.trstyle, "translate3d(" + _.doc.translate.tx + "," + _.doc.translate.ty + ",0)"), e || _.notifyScrollEvent(_.win[0]) }, this.setScrollLeft = function(t, e) { _.doc.translate.x = t, _.doc.translate.tx = t * D + "px", _.doc.css(I.trstyle, "translate3d(" + _.doc.translate.tx + "," + _.doc.translate.ty + ",0)"), e || _.notifyScrollEvent(_.win[0]) }) : (this.setScrollTop = function(t, e) { _.doc.translate.y = t, _.doc.translate.ty = -1 * t + "px", _.doc.css(I.trstyle, "translate(" + _.doc.translate.tx + "," + _.doc.translate.ty + ")"), e || _.notifyScrollEvent(_.win[0]) }, this.setScrollLeft = function(t, e) { _.doc.translate.x = t, _.doc.translate.tx = t * D + "px", _.doc.css(I.trstyle, "translate(" + _.doc.translate.tx + "," + _.doc.translate.ty + ")"), e || _.notifyScrollEvent(_.win[0]) })
                } else this.getScrollTop = function() { return _.docscroll.scrollTop() }, this.setScrollTop = function(t) { _.docscroll.scrollTop(t) }, this.getScrollLeft = function() { return _.hasreversehr ? _.detected.ismozilla ? _.page.maxw - Math.abs(_.docscroll.scrollLeft()) : _.page.maxw - _.docscroll.scrollLeft() : _.docscroll.scrollLeft() }, this.setScrollLeft = function(t) { return setTimeout(function() { if (_) return _.hasreversehr && (t = _.detected.ismozilla ? -(_.page.maxw - t) : _.page.maxw - t), _.docscroll.scrollLeft(t) }, 1) };
                this.getTarget = function(t) { return !!t && (t.target ? t.target : !!t.srcElement && t.srcElement) }, this.hasParent = function(t, e) { if (!t) return !1; for (var n = t.target || t.srcElement || t || !1; n && n.id != e;) n = n.parentNode || !1; return !1 !== n };
                var O = { thin: 1, medium: 3, thick: 5 };
                this.getDocumentScrollOffset = function() { return { top: u.pageYOffset || s.documentElement.scrollTop, left: u.pageXOffset || s.documentElement.scrollLeft } }, this.getOffset = function() {
                    if (_.isfixed) {
                        var t = _.win.offset(),
                            e = _.getDocumentScrollOffset();
                        return t.top -= e.top, t.left -= e.left, t
                    }
                    var n = _.win.offset();
                    if (!_.viewport) return n;
                    var i = _.viewport.offset();
                    return { top: n.top - i.top, left: n.left - i.left }
                }, this.updateScrollBar = function(t) {
                    var e, n;
                    if (_.ishwscroll) _.rail.css({ height: _.win.innerHeight() - (M.railpadding.top + M.railpadding.bottom) }), _.railh && _.railh.css({ width: _.win.innerWidth() - (M.railpadding.left + M.railpadding.right) });
                    else {
                        var i = _.getOffset();
                        if (e = { top: i.top, left: i.left - (M.railpadding.left + M.railpadding.right) }, e.top += y(_.win, "border-top-width", !0), e.left += _.rail.align ? _.win.outerWidth() - y(_.win, "border-right-width") - _.rail.width : y(_.win, "border-left-width"), (n = M.railoffset) && (n.top && (e.top += n.top), n.left && (e.left += n.left)), _.railslocked || _.rail.css({ top: e.top, left: e.left, height: (t ? t.h : _.win.innerHeight()) - (M.railpadding.top + M.railpadding.bottom) }), _.zoom && _.zoom.css({ top: e.top + 1, left: 1 == _.rail.align ? e.left - 20 : e.left + _.rail.width + 4 }), _.railh && !_.railslocked) {
                            e = { top: i.top, left: i.left }, (n = M.railhoffset) && (n.top && (e.top += n.top), n.left && (e.left += n.left));
                            var r = _.railh.align ? e.top + y(_.win, "border-top-width", !0) + _.win.innerHeight() - _.railh.height : e.top + y(_.win, "border-top-width", !0),
                                o = e.left + y(_.win, "border-left-width");
                            _.railh.css({ top: r - (M.railpadding.top + M.railpadding.bottom), left: o, width: _.railh.width })
                        }
                    }
                }, this.doRailClick = function(t, e, n) {
                    var i, r, o, a;
                    _.railslocked || (_.cancelEvent(t), "pageY" in t || (t.pageX = t.clientX + s.documentElement.scrollLeft, t.pageY = t.clientY + s.documentElement.scrollTop), e ? (i = n ? _.doScrollLeft : _.doScrollTop, o = n ? (t.pageX - _.railh.offset().left - _.cursorwidth / 2) * _.scrollratio.x : (t.pageY - _.rail.offset().top - _.cursorheight / 2) * _.scrollratio.y, _.unsynched("relativexy"), i(0 | o)) : (i = n ? _.doScrollLeftBy : _.doScrollBy, o = n ? _.scroll.x : _.scroll.y, a = n ? t.pageX - _.railh.offset().left : t.pageY - _.rail.offset().top, r = n ? _.view.w : _.view.h, i(o >= a ? r : -r)))
                }, _.newscrolly = _.newscrollx = 0, _.hasanimationframe = "requestAnimationFrame" in u, _.hascancelanimationframe = "cancelAnimationFrame" in u, _.hasborderbox = !1, this.init = function() {
                    if (_.saved.css = [], I.isoperamini) return !0;
                    if (I.isandroid && !("hidden" in s)) return !0;
                    M.emulatetouch = M.emulatetouch || M.touchbehavior, _.hasborderbox = u.getComputedStyle && "border-box" === u.getComputedStyle(s.body)["box-sizing"];
                    var t = { "overflow-y": "hidden" };
                    if ((I.isie11 || I.isie10) && (t["-ms-overflow-style"] = "none"), _.ishwscroll && (this.doc.css(I.transitionstyle, I.prefixstyle + "transform 0ms ease-out"), I.transitionend && _.bind(_.doc, I.transitionend, _.onScrollTransitionEnd, !1)), _.zindex = "auto", _.ispage || "auto" != M.zindex ? _.zindex = M.zindex : _.zindex = T() || "auto", !_.ispage && "auto" != _.zindex && _.zindex > o && (o = _.zindex), _.isie && 0 === _.zindex && "auto" == M.zindex && (_.zindex = "auto"), !_.ispage || !I.isieold) {
                        var r = _.docscroll;
                        _.ispage && (r = _.haswrapper ? _.win : _.doc), _.css(r, t), _.ispage && (I.isie11 || I.isie) && _.css(a("html"), t), !I.isios || _.ispage || _.haswrapper || _.css(C, { "-webkit-overflow-scrolling": "touch" });
                        var l = a(s.createElement("div"));
                        l.css({ position: "relative", top: 0, "float": "right", width: M.cursorwidth, height: 0, "background-color": M.cursorcolor, border: M.cursorborder, "background-clip": "padding-box", "-webkit-border-radius": M.cursorborderradius, "-moz-border-radius": M.cursorborderradius, "border-radius": M.cursorborderradius }), l.addClass("nicescroll-cursors"), _.cursor = l;
                        var d = a(s.createElement("div"));
                        d.attr("id", _.id), d.addClass("nicescroll-rails nicescroll-rails-vr");
                        var h, f, p = ["left", "right", "top", "bottom"];
                        for (var v in p) f = p[v], (h = M.railpadding[f] || 0) && d.css("padding-" + f, h + "px");
                        d.append(l), d.width = Math.max(parseFloat(M.cursorwidth), l.outerWidth()), d.css({ width: d.width + "px", zIndex: _.zindex, background: M.background, cursor: "default" }), d.visibility = !0, d.scrollable = !0, d.align = "left" == M.railalign ? 0 : 1, _.rail = d, _.rail.drag = !1;
                        var m = !1;
                        !M.boxzoom || _.ispage || I.isieold || (m = s.createElement("div"), _.bind(m, "click", _.doZoom), _.bind(m, "mouseenter", function() { _.zoom.css("opacity", M.cursoropacitymax) }), _.bind(m, "mouseleave", function() { _.zoom.css("opacity", M.cursoropacitymin) }), _.zoom = a(m), _.zoom.css({ cursor: "pointer", zIndex: _.zindex, backgroundImage: "url(" + M.scriptpath + "zoomico.png)", height: 18, width: 18, backgroundPosition: "0 0" }), M.dblclickzoom && _.bind(_.win, "dblclick", _.doZoom), I.cantouch && M.gesturezoom && (_.ongesturezoom = function(t) { return t.scale > 1.5 && _.doZoomIn(t), t.scale < .8 && _.doZoomOut(t), _.cancelEvent(t) }, _.bind(_.win, "gestureend", _.ongesturezoom))), _.railh = !1;
                        var y;
                        if (M.horizrailenabled && (_.css(r, { overflowX: "hidden" }), (l = a(s.createElement("div"))).css({ position: "absolute", top: 0, height: M.cursorwidth, width: 0, backgroundColor: M.cursorcolor, border: M.cursorborder, backgroundClip: "padding-box", "-webkit-border-radius": M.cursorborderradius, "-moz-border-radius": M.cursorborderradius, "border-radius": M.cursorborderradius }), I.isieold && l.css("overflow", "hidden"), l.addClass("nicescroll-cursors"), _.cursorh = l, (y = a(s.createElement("div"))).attr("id", _.id + "-hr"), y.addClass("nicescroll-rails nicescroll-rails-hr"), y.height = Math.max(parseFloat(M.cursorwidth), l.outerHeight()), y.css({ height: y.height + "px", zIndex: _.zindex, background: M.background }), y.append(l), y.visibility = !0, y.scrollable = !0, y.align = "top" == M.railvalign ? 0 : 1, _.railh = y, _.railh.drag = !1), _.ispage) d.css({ position: "fixed", top: 0, height: "100%" }), d.css(d.align ? { right: 0 } : { left: 0 }), _.body.append(d), _.railh && (y.css({ position: "fixed", left: 0, width: "100%" }), y.css(y.align ? { bottom: 0 } : { top: 0 }), _.body.append(y));
                        else {
                            if (_.ishwscroll) {
                                "static" == _.win.css("position") && _.css(_.win, { position: "relative" });
                                var b = "HTML" == _.win[0].nodeName ? _.body : _.win;
                                a(b).scrollTop(0).scrollLeft(0), _.zoom && (_.zoom.css({ position: "absolute", top: 1, right: 0, "margin-right": d.width + 4 }), b.append(_.zoom)), d.css({ position: "absolute", top: 0 }), d.css(d.align ? { right: 0 } : { left: 0 }), b.append(d), y && (y.css({ position: "absolute", left: 0, bottom: 0 }), y.css(y.align ? { bottom: 0 } : { top: 0 }), b.append(y))
                            } else {
                                _.isfixed = "fixed" == _.win.css("position");
                                var x = _.isfixed ? "fixed" : "absolute";
                                _.isfixed || (_.viewport = _.getViewport(_.win[0])), _.viewport && (_.body = _.viewport, /fixed|absolute/.test(_.viewport.css("position")) || _.css(_.viewport, { position: "relative" })), d.css({ position: x }), _.zoom && _.zoom.css({ position: x }), _.updateScrollBar(), _.body.append(d), _.zoom && _.body.append(_.zoom), _.railh && (y.css({ position: x }), _.body.append(y))
                            }
                            I.isios && _.css(_.win, { "-webkit-tap-highlight-color": "rgba(0,0,0,0)", "-webkit-touch-callout": "none" }), M.disableoutline && (I.isie && _.win.attr("hideFocus", "true"), I.iswebkit && _.win.css("outline", "none"))
                        }
                        if (!1 === M.autohidemode ? (_.autohidedom = !1, _.rail.css({ opacity: M.cursoropacitymax }), _.railh && _.railh.css({ opacity: M.cursoropacitymax })) : !0 === M.autohidemode || "leave" === M.autohidemode ? (_.autohidedom = a().add(_.rail), I.isie8 && (_.autohidedom = _.autohidedom.add(_.cursor)), _.railh && (_.autohidedom = _.autohidedom.add(_.railh)), _.railh && I.isie8 && (_.autohidedom = _.autohidedom.add(_.cursorh))) : "scroll" == M.autohidemode ? (_.autohidedom = a().add(_.rail), _.railh && (_.autohidedom = _.autohidedom.add(_.railh))) : "cursor" == M.autohidemode ? (_.autohidedom = a().add(_.cursor), _.railh && (_.autohidedom = _.autohidedom.add(_.cursorh))) : "hidden" == M.autohidemode && (_.autohidedom = !1, _.hide(), _.railslocked = !1), I.cantouch || _.istouchcapable || M.emulatetouch || I.hasmstouch) {
                            _.scrollmom = new w(_), _.ontouchstart = function(t) {
                                if (_.locked) return !1;
                                if (t.pointerType && ("mouse" === t.pointerType || t.pointerType === t.MSPOINTER_TYPE_MOUSE)) return !1;
                                if (_.hasmoving = !1, _.scrollmom.timer && (_.triggerScrollEnd(), _.scrollmom.stop()), !_.railslocked) {
                                    var e = _.getTarget(t);
                                    if (e && /INPUT/i.test(e.nodeName) && /range/i.test(e.type)) return _.stopPropagation(t);
                                    var n = "mousedown" === t.type;
                                    if (!("clientX" in t) && "changedTouches" in t && (t.clientX = t.changedTouches[0].clientX, t.clientY = t.changedTouches[0].clientY), _.forcescreen) {
                                        var i = t;
                                        (t = { original: t.original ? t.original : t }).clientX = i.screenX, t.clientY = i.screenY
                                    }
                                    if (_.rail.drag = { x: t.clientX, y: t.clientY, sx: _.scroll.x, sy: _.scroll.y, st: _.getScrollTop(), sl: _.getScrollLeft(), pt: 2, dl: !1, tg: e }, _.ispage || !M.directionlockdeadzone) _.rail.drag.dl = "f";
                                    else {
                                        var r = { w: c.width(), h: c.height() },
                                            o = _.getContentSize(),
                                            s = o.h - r.h,
                                            l = o.w - r.w;
                                        _.rail.scrollable && !_.railh.scrollable ? _.rail.drag.ck = s > 0 && "v" : !_.rail.scrollable && _.railh.scrollable ? _.rail.drag.ck = l > 0 && "h" : _.rail.drag.ck = !1
                                    }
                                    if (M.emulatetouch && _.isiframe && I.isie) {
                                        var u = _.win.position();
                                        _.rail.drag.x += u.left, _.rail.drag.y += u.top
                                    }
                                    if (_.hasmoving = !1, _.lastmouseup = !1, _.scrollmom.reset(t.clientX, t.clientY), e && n) { if (!/INPUT|SELECT|BUTTON|TEXTAREA/i.test(e.nodeName)) return I.hasmousecapture && e.setCapture(), M.emulatetouch ? (e.onclick && !e._onclick && (e._onclick = e.onclick, e.onclick = function(t) { return !_.hasmoving && void e._onclick.call(this, t) }), _.cancelEvent(t)) : _.stopPropagation(t); /SUBMIT|CANCEL|BUTTON/i.test(a(e).attr("type")) && (_.preventclick = { tg: e, click: !1 }) }
                                }
                            }, _.ontouchend = function(t) {
                                if (!_.rail.drag) return !0;
                                if (2 == _.rail.drag.pt) {
                                    if (t.pointerType && ("mouse" === t.pointerType || t.pointerType === t.MSPOINTER_TYPE_MOUSE)) return !1;
                                    _.rail.drag = !1;
                                    var e = "mouseup" === t.type;
                                    if (_.hasmoving && (_.scrollmom.doMomentum(), _.lastmouseup = !0, _.hideCursor(), I.hasmousecapture && s.releaseCapture(), e)) return _.cancelEvent(t)
                                } else if (1 == _.rail.drag.pt) return _.onmouseup(t)
                            };
                            var k = M.emulatetouch && _.isiframe && !I.hasmousecapture,
                                S = .3 * M.directionlockdeadzone | 0;
                            _.ontouchmove = function(t, e) {
                                if (!_.rail.drag) return !0;
                                if (t.targetTouches && M.preventmultitouchscrolling && t.targetTouches.length > 1) return !0;
                                if (t.pointerType && ("mouse" === t.pointerType || t.pointerType === t.MSPOINTER_TYPE_MOUSE)) return !0;
                                if (2 == _.rail.drag.pt) {
                                    "changedTouches" in t && (t.clientX = t.changedTouches[0].clientX, t.clientY = t.changedTouches[0].clientY);
                                    var n, i;
                                    if (i = n = 0, k && !e) {
                                        var r = _.win.position();
                                        i = -r.left, n = -r.top
                                    }
                                    var o = t.clientY + n,
                                        a = o - _.rail.drag.y,
                                        l = t.clientX + i,
                                        u = l - _.rail.drag.x,
                                        c = _.rail.drag.st - a;
                                    if (_.ishwscroll && M.bouncescroll) c < 0 ? c = Math.round(c / 2) : c > _.page.maxh && (c = _.page.maxh + Math.round((c - _.page.maxh) / 2));
                                    else if (c < 0 ? (c = 0, o = 0) : c > _.page.maxh && (c = _.page.maxh, o = 0), 0 === o && !_.hasmoving) return _.ispage || (_.rail.drag = !1), !0;
                                    var d = _.getScrollLeft();
                                    if (_.railh && _.railh.scrollable && (d = _.isrtlmode ? u - _.rail.drag.sl : _.rail.drag.sl - u, _.ishwscroll && M.bouncescroll ? d < 0 ? d = Math.round(d / 2) : d > _.page.maxw && (d = _.page.maxw + Math.round((d - _.page.maxw) / 2)) : (d < 0 && (d = 0, l = 0), d > _.page.maxw && (d = _.page.maxw, l = 0))), !_.hasmoving) {
                                        if (_.rail.drag.y === t.clientY && _.rail.drag.x === t.clientX) return _.cancelEvent(t);
                                        var h = Math.abs(a),
                                            f = Math.abs(u),
                                            p = M.directionlockdeadzone;
                                        if (_.rail.drag.ck ? "v" == _.rail.drag.ck ? f > p && h <= S ? _.rail.drag = !1 : h > p && (_.rail.drag.dl = "v") : "h" == _.rail.drag.ck && (h > p && f <= S ? _.rail.drag = !1 : f > p && (_.rail.drag.dl = "h")) : h > p && f > p ? _.rail.drag.dl = "f" : h > p ? _.rail.drag.dl = f > S ? "f" : "v" : f > p && (_.rail.drag.dl = h > S ? "f" : "h"), !_.rail.drag.dl) return _.cancelEvent(t);
                                        _.triggerScrollStart(t.clientX, t.clientY, 0, 0, 0), _.hasmoving = !0
                                    }
                                    return _.preventclick && !_.preventclick.click && (_.preventclick.click = _.preventclick.tg.onclick || !1, _.preventclick.tg.onclick = _.onpreventclick), _.rail.drag.dl && ("v" == _.rail.drag.dl ? d = _.rail.drag.sl : "h" == _.rail.drag.dl && (c = _.rail.drag.st)), _.synched("touchmove", function() { _.rail.drag && 2 == _.rail.drag.pt && (_.prepareTransition && _.resetTransition(), _.rail.scrollable && _.setScrollTop(c), _.scrollmom.update(l, o), _.railh && _.railh.scrollable ? (_.setScrollLeft(d), _.showCursor(c, d)) : _.showCursor(c), I.isie10 && s.selection.clear()) }), _.cancelEvent(t)
                                }
                                return 1 == _.rail.drag.pt ? _.onmousemove(t) : void 0
                            }, _.ontouchstartCursor = function(t, e) {
                                if (!_.rail.drag || 3 == _.rail.drag.pt) {
                                    if (_.locked) return _.cancelEvent(t);
                                    _.cancelScroll(), _.rail.drag = { x: t.touches[0].clientX, y: t.touches[0].clientY, sx: _.scroll.x, sy: _.scroll.y, pt: 3, hr: !!e };
                                    var n = _.getTarget(t);
                                    return !_.ispage && I.hasmousecapture && n.setCapture(), _.isiframe && !I.hasmousecapture && (_.saved.csspointerevents = _.doc.css("pointer-events"), _.css(_.doc, { "pointer-events": "none" })), _.cancelEvent(t)
                                }
                            }, _.ontouchendCursor = function(t) { if (_.rail.drag) { if (I.hasmousecapture && s.releaseCapture(), _.isiframe && !I.hasmousecapture && _.doc.css("pointer-events", _.saved.csspointerevents), 3 != _.rail.drag.pt) return; return _.rail.drag = !1, _.cancelEvent(t) } }, _.ontouchmoveCursor = function(t) {
                                if (_.rail.drag) {
                                    if (3 != _.rail.drag.pt) return;
                                    if (_.cursorfreezed = !0, _.rail.drag.hr) {
                                        _.scroll.x = _.rail.drag.sx + (t.touches[0].clientX - _.rail.drag.x), _.scroll.x < 0 && (_.scroll.x = 0);
                                        var e = _.scrollvaluemaxw;
                                        _.scroll.x > e && (_.scroll.x = e)
                                    } else {
                                        _.scroll.y = _.rail.drag.sy + (t.touches[0].clientY - _.rail.drag.y), _.scroll.y < 0 && (_.scroll.y = 0);
                                        var n = _.scrollvaluemax;
                                        _.scroll.y > n && (_.scroll.y = n)
                                    }
                                    return _.synched("touchmove", function() { _.rail.drag && 3 == _.rail.drag.pt && (_.showCursor(), _.rail.drag.hr ? _.doScrollLeft(Math.round(_.scroll.x * _.scrollratio.x), M.cursordragspeed) : _.doScrollTop(Math.round(_.scroll.y * _.scrollratio.y), M.cursordragspeed)) }), _.cancelEvent(t)
                                }
                            }
                        }
                        if (_.onmousedown = function(t, e) {
                                if (!_.rail.drag || 1 == _.rail.drag.pt) {
                                    if (_.railslocked) return _.cancelEvent(t);
                                    _.cancelScroll(), _.rail.drag = { x: t.clientX, y: t.clientY, sx: _.scroll.x, sy: _.scroll.y, pt: 1, hr: e || !1 };
                                    var n = _.getTarget(t);
                                    return I.hasmousecapture && n.setCapture(), _.isiframe && !I.hasmousecapture && (_.saved.csspointerevents = _.doc.css("pointer-events"), _.css(_.doc, { "pointer-events": "none" })), _.hasmoving = !1, _.cancelEvent(t)
                                }
                            }, _.onmouseup = function(t) { if (_.rail.drag) return 1 != _.rail.drag.pt || (I.hasmousecapture && s.releaseCapture(), _.isiframe && !I.hasmousecapture && _.doc.css("pointer-events", _.saved.csspointerevents), _.rail.drag = !1, _.cursorfreezed = !1, _.hasmoving && _.triggerScrollEnd(), _.cancelEvent(t)) }, _.onmousemove = function(t) {
                                if (_.rail.drag) {
                                    if (1 !== _.rail.drag.pt) return;
                                    if (I.ischrome && 0 === t.which) return _.onmouseup(t);
                                    if (_.cursorfreezed = !0, _.hasmoving || _.triggerScrollStart(t.clientX, t.clientY, 0, 0, 0), _.hasmoving = !0, _.rail.drag.hr) {
                                        _.scroll.x = _.rail.drag.sx + (t.clientX - _.rail.drag.x), _.scroll.x < 0 && (_.scroll.x = 0);
                                        var e = _.scrollvaluemaxw;
                                        _.scroll.x > e && (_.scroll.x = e)
                                    } else {
                                        _.scroll.y = _.rail.drag.sy + (t.clientY - _.rail.drag.y), _.scroll.y < 0 && (_.scroll.y = 0);
                                        var n = _.scrollvaluemax;
                                        _.scroll.y > n && (_.scroll.y = n)
                                    }
                                    return _.synched("mousemove", function() { _.cursorfreezed && (_.showCursor(), _.rail.drag.hr ? _.scrollLeft(Math.round(_.scroll.x * _.scrollratio.x)) : _.scrollTop(Math.round(_.scroll.y * _.scrollratio.y))) }), _.cancelEvent(t)
                                }
                                _.checkarea = 0
                            }, I.cantouch || M.emulatetouch) _.onpreventclick = function(t) { if (_.preventclick) return _.preventclick.tg.onclick = _.preventclick.click, _.preventclick = !1, _.cancelEvent(t) }, _.onclick = !I.isios && function(t) { return !_.lastmouseup || (_.lastmouseup = !1, _.cancelEvent(t)) }, M.grabcursorenabled && I.cursorgrabvalue && (_.css(_.ispage ? _.doc : _.win, { cursor: I.cursorgrabvalue }), _.css(_.rail, { cursor: I.cursorgrabvalue }));
                        else {
                            var A = function O(t) {
                                if (_.selectiondrag) {
                                    if (t) {
                                        var e = _.win.outerHeight(),
                                            n = t.pageY - _.selectiondrag.top;
                                        n > 0 && n < e && (n = 0), n >= e && (n -= e), _.selectiondrag.df = n
                                    }
                                    if (0 !== _.selectiondrag.df) {
                                        var i = -2 * _.selectiondrag.df / 6 | 0;
                                        _.doScrollBy(i), _.debounced("doselectionscroll", function() { O() }, 50)
                                    }
                                }
                            };
                            _.hasTextSelected = "getSelection" in s ? function() { return s.getSelection().rangeCount > 0 } : "selection" in s ? function() { return "None" != s.selection.type } : function() { return !1 }, _.onselectionstart = function(t) { _.ispage || (_.selectiondrag = _.win.offset()) }, _.onselectionend = function(t) { _.selectiondrag = !1 }, _.onselectiondrag = function(t) { _.selectiondrag && _.hasTextSelected() && _.debounced("selectionscroll", function() { A(t) }, 250) }
                        }
                        if (I.hasw3ctouch ? (_.css(_.ispage ? a("html") : _.win, { "touch-action": "none" }), _.css(_.rail, { "touch-action": "none" }), _.css(_.cursor, { "touch-action": "none" }), _.bind(_.win, "pointerdown", _.ontouchstart), _.bind(s, "pointerup", _.ontouchend), _.delegate(s, "pointermove", _.ontouchmove)) : I.hasmstouch ? (_.css(_.ispage ? a("html") : _.win, { "-ms-touch-action": "none" }), _.css(_.rail, { "-ms-touch-action": "none" }), _.css(_.cursor, { "-ms-touch-action": "none" }), _.bind(_.win, "MSPointerDown", _.ontouchstart), _.bind(s, "MSPointerUp", _.ontouchend), _.delegate(s, "MSPointerMove", _.ontouchmove), _.bind(_.cursor, "MSGestureHold", function(t) { t.preventDefault() }), _.bind(_.cursor, "contextmenu", function(t) { t.preventDefault() })) : I.cantouch && (_.bind(_.win, "touchstart", _.ontouchstart, !1, !0), _.bind(s, "touchend", _.ontouchend, !1, !0), _.bind(s, "touchcancel", _.ontouchend, !1, !0), _.delegate(s, "touchmove", _.ontouchmove, !1, !0)), M.emulatetouch && (_.bind(_.win, "mousedown", _.ontouchstart, !1, !0), _.bind(s, "mouseup", _.ontouchend, !1, !0), _.bind(s, "mousemove", _.ontouchmove, !1, !0)), (M.cursordragontouch || !I.cantouch && !M.emulatetouch) && (_.rail.css({ cursor: "default" }), _.railh && _.railh.css({ cursor: "default" }), _.jqbind(_.rail, "mouseenter", function() { return !(!_.ispage && !_.win.is(":visible")) && (_.canshowonmouseevent && _.showCursor(), void(_.rail.active = !0)) }), _.jqbind(_.rail, "mouseleave", function() { _.rail.active = !1, _.rail.drag || _.hideCursor() }), M.sensitiverail && (_.bind(_.rail, "click", function(t) { _.doRailClick(t, !1, !1) }), _.bind(_.rail, "dblclick", function(t) { _.doRailClick(t, !0, !1) }), _.bind(_.cursor, "click", function(t) { _.cancelEvent(t) }), _.bind(_.cursor, "dblclick", function(t) { _.cancelEvent(t) })), _.railh && (_.jqbind(_.railh, "mouseenter", function() { return !(!_.ispage && !_.win.is(":visible")) && (_.canshowonmouseevent && _.showCursor(), void(_.rail.active = !0)) }), _.jqbind(_.railh, "mouseleave", function() { _.rail.active = !1, _.rail.drag || _.hideCursor() }), M.sensitiverail && (_.bind(_.railh, "click", function(t) { _.doRailClick(t, !1, !0) }), _.bind(_.railh, "dblclick", function(t) { _.doRailClick(t, !0, !0) }), _.bind(_.cursorh, "click", function(t) { _.cancelEvent(t) }), _.bind(_.cursorh, "dblclick", function(t) { _.cancelEvent(t) })))), M.cursordragontouch && (this.istouchcapable || I.cantouch) && (_.bind(_.cursor, "touchstart", _.ontouchstartCursor), _.bind(_.cursor, "touchmove", _.ontouchmoveCursor), _.bind(_.cursor, "touchend", _.ontouchendCursor), _.cursorh && _.bind(_.cursorh, "touchstart", function(t) { _.ontouchstartCursor(t, !0) }), _.cursorh && _.bind(_.cursorh, "touchmove", _.ontouchmoveCursor), _.cursorh && _.bind(_.cursorh, "touchend", _.ontouchendCursor)), M.emulatetouch || I.isandroid || I.isios ? (_.bind(I.hasmousecapture ? _.win : s, "mouseup", _.ontouchend), _.onclick && _.bind(s, "click", _.onclick), M.cursordragontouch ? (_.bind(_.cursor, "mousedown", _.onmousedown), _.bind(_.cursor, "mouseup", _.onmouseup), _.cursorh && _.bind(_.cursorh, "mousedown", function(t) { _.onmousedown(t, !0) }), _.cursorh && _.bind(_.cursorh, "mouseup", _.onmouseup)) : (_.bind(_.rail, "mousedown", function(t) { t.preventDefault() }), _.railh && _.bind(_.railh, "mousedown", function(t) { t.preventDefault() }))) : (_.bind(I.hasmousecapture ? _.win : s, "mouseup", _.onmouseup), _.bind(s, "mousemove", _.onmousemove), _.onclick && _.bind(s, "click", _.onclick), _.bind(_.cursor, "mousedown", _.onmousedown), _.bind(_.cursor, "mouseup", _.onmouseup), _.railh && (_.bind(_.cursorh, "mousedown", function(t) { _.onmousedown(t, !0) }), _.bind(_.cursorh, "mouseup", _.onmouseup)), !_.ispage && M.enablescrollonselection && (_.bind(_.win[0], "mousedown", _.onselectionstart), _.bind(s, "mouseup", _.onselectionend), _.bind(_.cursor, "mouseup", _.onselectionend), _.cursorh && _.bind(_.cursorh, "mouseup", _.onselectionend), _.bind(s, "mousemove", _.onselectiondrag)), _.zoom && (_.jqbind(_.zoom, "mouseenter", function() { _.canshowonmouseevent && _.showCursor(), _.rail.active = !0 }), _.jqbind(_.zoom, "mouseleave", function() { _.rail.active = !1, _.rail.drag || _.hideCursor() }))), M.enablemousewheel && (_.isiframe || _.mousewheel(I.isie && _.ispage ? s : _.win, _.onmousewheel), _.mousewheel(_.rail, _.onmousewheel), _.railh && _.mousewheel(_.railh, _.onmousewheelhr)), _.ispage || I.cantouch || /HTML|^BODY/.test(_.win[0].nodeName) || (_.win.attr("tabindex") || _.win.attr({ tabindex: ++i }), _.bind(_.win, "focus", function(t) { e = _.getTarget(t).id || _.getTarget(t) || !1, _.hasfocus = !0, _.canshowonmouseevent && _.noticeCursor() }), _.bind(_.win, "blur", function(t) { e = !1, _.hasfocus = !1 }), _.bind(_.win, "mouseenter", function(t) { n = _.getTarget(t).id || _.getTarget(t) || !1, _.hasmousefocus = !0, _.canshowonmouseevent && _.noticeCursor() }), _.bind(_.win, "mouseleave", function(t) { n = !1, _.hasmousefocus = !1, _.rail.drag || _.hideCursor() })), _.onkeypress = function(t) {
                                if (_.railslocked && 0 === _.page.maxh) return !0;
                                t = t || u.event;
                                var i = _.getTarget(t);
                                if (i && /INPUT|TEXTAREA|SELECT|OPTION/.test(i.nodeName) && (!i.getAttribute("type") && !i.type || !/submit|button|cancel/i.tp)) return !0;
                                if (a(i).attr("contenteditable")) return !0;
                                if (_.hasfocus || _.hasmousefocus && !e || _.ispage && !e && !n) {
                                    var r = t.keyCode;
                                    if (_.railslocked && 27 != r) return _.cancelEvent(t);
                                    var o = t.ctrlKey || !1,
                                        s = t.shiftKey || !1,
                                        l = !1;
                                    switch (r) {
                                        case 38:
                                        case 63233:
                                            _.doScrollBy(72), l = !0;
                                            break;
                                        case 40:
                                        case 63235:
                                            _.doScrollBy(-72), l = !0;
                                            break;
                                        case 37:
                                        case 63232:
                                            _.railh && (o ? _.doScrollLeft(0) : _.doScrollLeftBy(72), l = !0);
                                            break;
                                        case 39:
                                        case 63234:
                                            _.railh && (o ? _.doScrollLeft(_.page.maxw) : _.doScrollLeftBy(-72), l = !0);
                                            break;
                                        case 33:
                                        case 63276:
                                            _.doScrollBy(_.view.h), l = !0;
                                            break;
                                        case 34:
                                        case 63277:
                                            _.doScrollBy(-_.view.h), l = !0;
                                            break;
                                        case 36:
                                        case 63273:
                                            _.railh && o ? _.doScrollPos(0, 0) : _.doScrollTo(0), l = !0;
                                            break;
                                        case 35:
                                        case 63275:
                                            _.railh && o ? _.doScrollPos(_.page.maxw, _.page.maxh) : _.doScrollTo(_.page.maxh), l = !0;
                                            break;
                                        case 32:
                                            M.spacebarenabled && (s ? _.doScrollBy(_.view.h) : _.doScrollBy(-_.view.h), l = !0);
                                            break;
                                        case 27:
                                            _.zoomactive && (_.doZoom(), l = !0)
                                    }
                                    if (l) return _.cancelEvent(t)
                                }
                            }, M.enablekeyboard && _.bind(s, I.isopera && !I.isopera12 ? "keypress" : "keydown", _.onkeypress), _.bind(s, "keydown", function(t) {
                                (t.ctrlKey || !1) && (_.wheelprevented = !0)
                            }), _.bind(s, "keyup", function(t) { t.ctrlKey || !1 || (_.wheelprevented = !1) }), _.bind(u, "blur", function(t) { _.wheelprevented = !1 }), _.bind(u, "resize", _.onscreenresize), _.bind(u, "orientationchange", _.onscreenresize), _.bind(u, "load", _.lazyResize), I.ischrome && !_.ispage && !_.haswrapper) {
                            var E = _.win.attr("style"),
                                P = parseFloat(_.win.css("width")) + 1;
                            _.win.css("width", P), _.synched("chromefix", function() { _.win.attr("style", E) })
                        }
                        if (_.onAttributeChange = function(t) { _.lazyResize(_.isieold ? 250 : 30) }, M.enableobserver && (_.isie11 || !1 === g || (_.observerbody = new g(function(t) { if (t.forEach(function(t) { if ("attributes" == t.type) return C.hasClass("modal-open") && C.hasClass("modal-dialog") && !a.contains(a(".modal-dialog")[0], _.doc[0]) ? _.hide() : _.show() }), _.me.clientWidth != _.page.width || _.me.clientHeight != _.page.height) return _.lazyResize(30) }), _.observerbody.observe(s.body, { childList: !0, subtree: !0, characterData: !1, attributes: !0, attributeFilter: ["class"] })), !_.ispage && !_.haswrapper)) {
                            var z = _.win[0];
                            !1 !== g ? (_.observer = new g(function(t) { t.forEach(_.onAttributeChange) }), _.observer.observe(z, { childList: !0, characterData: !1, attributes: !0, subtree: !1 }), _.observerremover = new g(function(t) {
                                t.forEach(function(t) {
                                    if (t.removedNodes.length > 0)
                                        for (var e in t.removedNodes)
                                            if (_ && t.removedNodes[e] === z) return _.remove()
                                })
                            }), _.observerremover.observe(z.parentNode, { childList: !0, characterData: !1, attributes: !1, subtree: !1 })) : (_.bind(z, I.isie && !I.isie9 ? "propertychange" : "DOMAttrModified", _.onAttributeChange), I.isie9 && z.attachEvent("onpropertychange", _.onAttributeChange), _.bind(z, "DOMNodeRemoved", function(t) { t.target === z && _.remove() }))
                        }!_.ispage && M.boxzoom && _.bind(u, "resize", _.resizeZoom), _.istextarea && (_.bind(_.win, "keydown", _.lazyResize), _.bind(_.win, "mouseup", _.lazyResize)), _.lazyResize(30)
                    }
                    if ("IFRAME" == this.doc[0].nodeName) {
                        var D = function() {
                            _.iframexd = !1;
                            var t;
                            try {
                                (t = "contentDocument" in this ? this.contentDocument : this.contentWindow._doc).domain
                            } catch (e) { _.iframexd = !0, t = !1 }
                            if (_.iframexd) return !0;
                            if (_.forcescreen = !0, _.isiframe && (_.iframe = { doc: a(t), html: _.doc.contents().find("html")[0], body: _.doc.contents().find("body")[0] }, _.getContentSize = function() { return { w: Math.max(_.iframe.html.scrollWidth, _.iframe.body.scrollWidth), h: Math.max(_.iframe.html.scrollHeight, _.iframe.body.scrollHeight) } }, _.docscroll = a(_.iframe.body)), !I.isios && M.iframeautoresize && !_.isiframe) {
                                _.win.scrollTop(0), _.doc.height("");
                                var n = Math.max(t.getElementsByTagName("html")[0].scrollHeight, t.body.scrollHeight);
                                _.doc.height(n)
                            }
                            _.lazyResize(30), _.css(a(_.iframe.body), e), I.isios && _.haswrapper && _.css(a(t.body), { "-webkit-transform": "translate3d(0,0,0)" }), "contentWindow" in this ? _.bind(this.contentWindow, "scroll", _.onscroll) : _.bind(t, "scroll", _.onscroll), M.enablemousewheel && _.mousewheel(t, _.onmousewheel), M.enablekeyboard && _.bind(t, I.isopera ? "keypress" : "keydown", _.onkeypress), I.cantouch ? (_.bind(t, "touchstart", _.ontouchstart), _.bind(t, "touchmove", _.ontouchmove)) : M.emulatetouch && (_.bind(t, "mousedown", _.ontouchstart), _.bind(t, "mousemove", function(t) { return _.ontouchmove(t, !0) }), M.grabcursorenabled && I.cursorgrabvalue && _.css(a(t.body), { cursor: I.cursorgrabvalue })), _.bind(t, "mouseup", _.ontouchend), _.zoom && (M.dblclickzoom && _.bind(t, "dblclick", _.doZoom), _.ongesturezoom && _.bind(t, "gestureend", _.ongesturezoom))
                        };
                        this.doc[0].readyState && "complete" === this.doc[0].readyState && setTimeout(function() { D.call(_.doc[0], !1) }, 500), _.bind(this.doc, "load", D)
                    }
                }, this.showCursor = function(t, e) {
                    if (_.cursortimeout && (clearTimeout(_.cursortimeout), _.cursortimeout = 0), _.rail) {
                        if (_.autohidedom && (_.autohidedom.stop().css({ opacity: M.cursoropacitymax }), _.cursoractive = !0), _.rail.drag && 1 == _.rail.drag.pt || (void 0 !== t && !1 !== t && (_.scroll.y = t / _.scrollratio.y | 0), void 0 !== e && (_.scroll.x = e / _.scrollratio.x | 0)), _.cursor.css({ height: _.cursorheight, top: _.scroll.y }), _.cursorh) {
                            var n = _.hasreversehr ? _.scrollvaluemaxw - _.scroll.x : _.scroll.x;
                            _.cursorh.css({ width: _.cursorwidth, left: !_.rail.align && _.rail.visibility ? n + _.rail.width : n }), _.cursoractive = !0
                        }
                        _.zoom && _.zoom.stop().css({ opacity: M.cursoropacitymax })
                    }
                }, this.hideCursor = function(t) { _.cursortimeout || _.rail && _.autohidedom && (_.hasmousefocus && "leave" === M.autohidemode || (_.cursortimeout = setTimeout(function() { _.rail.active && _.showonmouseevent || (_.autohidedom.stop().animate({ opacity: M.cursoropacitymin }), _.zoom && _.zoom.stop().animate({ opacity: M.cursoropacitymin }), _.cursoractive = !1), _.cursortimeout = 0 }, t || M.hidecursordelay))) }, this.noticeCursor = function(t, e, n) { _.showCursor(e, n), _.rail.active || _.hideCursor(t) }, this.getContentSize = _.ispage ? function() { return { w: Math.max(s.body.scrollWidth, s.documentElement.scrollWidth), h: Math.max(s.body.scrollHeight, s.documentElement.scrollHeight) } } : _.haswrapper ? function() { return { w: _.doc[0].offsetWidth, h: _.doc[0].offsetHeight } } : function() { return { w: _.docscroll[0].scrollWidth, h: _.docscroll[0].scrollHeight } }, this.onResize = function(t, e) {
                    if (!_ || !_.win) return !1;
                    var n = _.page.maxh,
                        i = _.page.maxw,
                        r = _.view.h,
                        o = _.view.w;
                    if (_.view = { w: _.ispage ? _.win.width() : _.win[0].clientWidth, h: _.ispage ? _.win.height() : _.win[0].clientHeight }, _.page = e || _.getContentSize(), _.page.maxh = Math.max(0, _.page.h - _.view.h), _.page.maxw = Math.max(0, _.page.w - _.view.w), _.page.maxh == n && _.page.maxw == i && _.view.w == o && _.view.h == r) { if (_.ispage) return _; var a = _.win.offset(); if (_.lastposition) { var s = _.lastposition; if (s.top == a.top && s.left == a.left) return _ } _.lastposition = a }
                    return 0 === _.page.maxh ? (_.hideRail(), _.scrollvaluemax = 0, _.scroll.y = 0, _.scrollratio.y = 0, _.cursorheight = 0, _.setScrollTop(0), _.rail && (_.rail.scrollable = !1)) : (_.page.maxh -= M.railpadding.top + M.railpadding.bottom, _.rail.scrollable = !0), 0 === _.page.maxw ? (_.hideRailHr(), _.scrollvaluemaxw = 0, _.scroll.x = 0, _.scrollratio.x = 0, _.cursorwidth = 0, _.setScrollLeft(0), _.railh && (_.railh.scrollable = !1)) : (_.page.maxw -= M.railpadding.left + M.railpadding.right, _.railh && (_.railh.scrollable = M.horizrailenabled)), _.railslocked = _.locked || 0 === _.page.maxh && 0 === _.page.maxw, _.railslocked ? (_.ispage || _.updateScrollBar(_.view), !1) : (_.hidden || (_.rail.visibility || _.showRail(), _.railh && !_.railh.visibility && _.showRailHr()), _.istextarea && _.win.css("resize") && "none" != _.win.css("resize") && (_.view.h -= 20), _.cursorheight = Math.min(_.view.h, Math.round(_.view.h * (_.view.h / _.page.h))), _.cursorheight = M.cursorfixedheight ? M.cursorfixedheight : Math.max(M.cursorminheight, _.cursorheight), _.cursorwidth = Math.min(_.view.w, Math.round(_.view.w * (_.view.w / _.page.w))), _.cursorwidth = M.cursorfixedheight ? M.cursorfixedheight : Math.max(M.cursorminheight, _.cursorwidth), _.scrollvaluemax = _.view.h - _.cursorheight - (M.railpadding.top + M.railpadding.bottom), _.hasborderbox || (_.scrollvaluemax -= _.cursor[0].offsetHeight - _.cursor[0].clientHeight), _.railh && (_.railh.width = _.page.maxh > 0 ? _.view.w - _.rail.width : _.view.w, _.scrollvaluemaxw = _.railh.width - _.cursorwidth - (M.railpadding.left + M.railpadding.right)), _.ispage || _.updateScrollBar(_.view), _.scrollratio = { x: _.page.maxw / _.scrollvaluemaxw, y: _.page.maxh / _.scrollvaluemax }, _.getScrollTop() > _.page.maxh ? _.doScrollTop(_.page.maxh) : (_.scroll.y = _.getScrollTop() / _.scrollratio.y | 0, _.scroll.x = _.getScrollLeft() / _.scrollratio.x | 0, _.cursoractive && _.noticeCursor()), _.scroll.y && 0 === _.getScrollTop() && _.doScrollTo(_.scroll.y * _.scrollratio.y | 0), _)
                }, this.resize = _.onResize;
                var L = 0;
                this.onscreenresize = function(t) {
                    clearTimeout(L);
                    var e = !_.ispage && !_.haswrapper;
                    e && _.hideRails(), L = setTimeout(function() { _ && (e && _.showRails(), _.resize()), L = 0 }, 120)
                }, this.lazyResize = function(t) { return clearTimeout(L), t = isNaN(t) ? 240 : t, L = setTimeout(function() { _ && _.resize(), L = 0 }, t), _ }, this.jqbind = function(t, e, n) { _.events.push({ e: t, n: e, f: n, q: !0 }), a(t).on(e, n) }, this.mousewheel = function(t, e, n) {
                    var i = "jquery" in t ? t[0] : t;
                    if ("onwheel" in s.createElement("div")) _._bind(i, "wheel", e, n || !1);
                    else {
                        var r = void 0 !== s.onmousewheel ? "mousewheel" : "DOMMouseScroll";
                        x(i, r, e, n || !1), "DOMMouseScroll" == r && x(i, "MozMousePixelScroll", e, n || !1)
                    }
                };
                var $ = !1;
                if (I.haseventlistener) {
                    try {
                        var N = Object.defineProperty({}, "passive", { get: function() { $ = !0 } });
                        u.addEventListener("test", null, N)
                    } catch (t) {} this.stopPropagation = function(t) { return !!t && ((t = t.original ? t.original : t).stopPropagation(), !1) }, this.cancelEvent = function(t) { return t.cancelable && t.preventDefault(), t.stopImmediatePropagation(), t.preventManipulation && t.preventManipulation(), !1 }
                } else Event.prototype.preventDefault = function() { this.returnValue = !1 }, Event.prototype.stopPropagation = function() { this.cancelBubble = !0 }, u.constructor.prototype.addEventListener = s.constructor.prototype.addEventListener = Element.prototype.addEventListener = function(t, e, n) { this.attachEvent("on" + t, e) }, u.constructor.prototype.removeEventListener = s.constructor.prototype.removeEventListener = Element.prototype.removeEventListener = function(t, e, n) { this.detachEvent("on" + t, e) }, this.cancelEvent = function(t) { return (t = t || u.event) && (t.cancelBubble = !0, t.cancel = !0, t.returnValue = !1), !1 }, this.stopPropagation = function(t) { return (t = t || u.event) && (t.cancelBubble = !0), !1 };
                this.delegate = function(t, e, n, i, r) {
                    var o = d[e] || !1;
                    o || (o = {
                        a: [],
                        l: [],
                        f: function(t) {
                            for (var e = o.l, n = !1, i = e.length - 1; i >= 0; i--)
                                if (!1 === (n = e[i].call(t.target, t))) return !1;
                            return n
                        }
                    }, _.bind(t, e, o.f, i, r), d[e] = o), _.ispage ? (o.a = [_.id].concat(o.a), o.l = [n].concat(o.l)) : (o.a.push(_.id), o.l.push(n))
                }, this.undelegate = function(t, e, n, i, r) {
                    var o = d[e] || !1;
                    if (o && o.l)
                        for (var a = 0, s = o.l.length; a < s; a++) o.a[a] === _.id && (o.a.splice(a), o.l.splice(a), 0 === o.a.length && (_._unbind(t, e, o.l.f), d[e] = null))
                }, this.bind = function(t, e, n, i, r) {
                    var o = "jquery" in t ? t[0] : t;
                    _._bind(o, e, n, i || !1, r || !1)
                }, this._bind = function(t, e, n, i, r) { _.events.push({ e: t, n: e, f: n, b: i, q: !1 }), $ && r ? t.addEventListener(e, n, { passive: !1, capture: i }) : t.addEventListener(e, n, i || !1) }, this._unbind = function(t, e, n, i) { d[e] ? _.undelegate(t, e, n, i) : t.removeEventListener(e, n, i) }, this.unbindAll = function() {
                    for (var t = 0; t < _.events.length; t++) {
                        var e = _.events[t];
                        e.q ? e.e.unbind(e.n, e.f) : _._unbind(e.e, e.n, e.f, e.b)
                    }
                }, this.showRails = function() { return _.showRail().showRailHr() }, this.showRail = function() { return 0 === _.page.maxh || !_.ispage && "none" == _.win.css("display") || (_.rail.visibility = !0, _.rail.css("display", "block")), _ }, this.showRailHr = function() { return _.railh && (0 === _.page.maxw || !_.ispage && "none" == _.win.css("display") || (_.railh.visibility = !0, _.railh.css("display", "block"))), _ }, this.hideRails = function() { return _.hideRail().hideRailHr() }, this.hideRail = function() { return _.rail.visibility = !1, _.rail.css("display", "none"), _ }, this.hideRailHr = function() { return _.railh && (_.railh.visibility = !1, _.railh.css("display", "none")), _ }, this.show = function() { return _.hidden = !1, _.railslocked = !1, _.showRails() }, this.hide = function() { return _.hidden = !0, _.railslocked = !0, _.hideRails() }, this.toggle = function() { return _.hidden ? _.show() : _.hide() }, this.remove = function() {
                    _.stop(), _.cursortimeout && clearTimeout(_.cursortimeout);
                    for (var t in _.delaylist) _.delaylist[t] && f(_.delaylist[t].h);
                    _.doZoomOut(), _.unbindAll(), I.isie9 && _.win[0].detachEvent("onpropertychange", _.onAttributeChange), !1 !== _.observer && _.observer.disconnect(), !1 !== _.observerremover && _.observerremover.disconnect(), !1 !== _.observerbody && _.observerbody.disconnect(), _.events = null, _.cursor && _.cursor.remove(), _.cursorh && _.cursorh.remove(), _.rail && _.rail.remove(), _.railh && _.railh.remove(), _.zoom && _.zoom.remove();
                    for (var e = 0; e < _.saved.css.length; e++) {
                        var n = _.saved.css[e];
                        n[0].css(n[1], void 0 === n[2] ? "" : n[2])
                    }
                    _.saved = !1, _.me.data("__nicescroll", "");
                    var i = a.nicescroll;
                    i.each(function(t) { if (this && this.id === _.id) { delete i[t]; for (var e = ++t; e < i.length; e++, t++) i[t] = i[e];--i.length && delete i[i.length] } });
                    for (var r in _) _[r] = null, delete _[r];
                    _ = null
                }, this.scrollstart = function(t) { return this.onscrollstart = t, _ }, this.scrollend = function(t) { return this.onscrollend = t, _ }, this.scrollcancel = function(t) { return this.onscrollcancel = t, _ }, this.zoomin = function(t) { return this.onzoomin = t, _ }, this.zoomout = function(t) { return this.onzoomout = t, _ }, this.isScrollable = function(t) {
                    var e = t.target ? t.target : t;
                    if ("OPTION" == e.nodeName) return !0;
                    for (; e && 1 == e.nodeType && e !== this.me[0] && !/^BODY|HTML/.test(e.nodeName);) {
                        var n = a(e),
                            i = n.css("overflowY") || n.css("overflowX") || n.css("overflow") || "";
                        if (/scroll|auto/.test(i)) return e.clientHeight != e.scrollHeight;
                        e = !!e.parentNode && e.parentNode
                    }
                    return !1
                }, this.getViewport = function(t) {
                    for (var e = !(!t || !t.parentNode) && t.parentNode; e && 1 == e.nodeType && !/^BODY|HTML/.test(e.nodeName);) {
                        var n = a(e);
                        if (/fixed|absolute/.test(n.css("position"))) return n;
                        var i = n.css("overflowY") || n.css("overflowX") || n.css("overflow") || "";
                        if (/scroll|auto/.test(i) && e.clientHeight != e.scrollHeight) return n;
                        if (n.getNiceScroll().length > 0) return n;
                        e = !!e.parentNode && e.parentNode
                    }
                    return !1
                }, this.triggerScrollStart = function(t, e, n, i, r) {
                    if (_.onscrollstart) {
                        var o = { type: "scrollstart", current: { x: t, y: e }, request: { x: n, y: i }, end: { x: _.newscrollx, y: _.newscrolly }, speed: r };
                        _.onscrollstart.call(_, o)
                    }
                }, this.triggerScrollEnd = function() {
                    if (_.onscrollend) {
                        var t = _.getScrollLeft(),
                            e = _.getScrollTop(),
                            n = { type: "scrollend", current: { x: t, y: e }, end: { x: t, y: e } };
                        _.onscrollend.call(_, n)
                    }
                };
                var R = 0,
                    q = 0,
                    F = 0,
                    H = 1,
                    B = !1;
                if (this.onmousewheel = function(t) {
                        if (_.wheelprevented || _.locked) return !1;
                        if (_.railslocked) return _.debounced("checkunlock", _.resize, 250), !1;
                        if (_.rail.drag) return _.cancelEvent(t);
                        if ("auto" === M.oneaxismousemode && 0 !== t.deltaX && (M.oneaxismousemode = !1), M.oneaxismousemode && 0 === t.deltaX && !_.rail.scrollable) return !_.railh || !_.railh.scrollable || _.onmousewheelhr(t);
                        var e = v(),
                            n = !1;
                        if (M.preservenativescrolling && _.checkarea + 600 < e && (_.nativescrollingarea = _.isScrollable(t), n = !0), _.checkarea = e, _.nativescrollingarea) return !0;
                        var i = S(t, !1, n);
                        return i && (_.checkarea = 0), i
                    }, this.onmousewheelhr = function(t) {
                        if (!_.wheelprevented) {
                            if (_.railslocked || !_.railh.scrollable) return !0;
                            if (_.rail.drag) return _.cancelEvent(t);
                            var e = v(),
                                n = !1;
                            return M.preservenativescrolling && _.checkarea + 600 < e && (_.nativescrollingarea = _.isScrollable(t), n = !0), _.checkarea = e, !!_.nativescrollingarea || (_.railslocked ? _.cancelEvent(t) : S(t, !0, n))
                        }
                    }, this.stop = function() { return _.cancelScroll(), _.scrollmon && _.scrollmon.stop(), _.cursorfreezed = !1, _.scroll.y = Math.round(_.getScrollTop() * (1 / _.scrollratio.y)), _.noticeCursor(), _ }, this.getTransitionSpeed = function(t) { return 80 + t / 72 * M.scrollspeed | 0 }, M.smoothscroll)
                    if (_.ishwscroll && I.hastransition && M.usetransition && M.smoothscroll) {
                        var W = "";
                        this.resetTransition = function() { W = "", _.doc.css(I.prefixstyle + "transition-duration", "0ms") }, this.prepareTransition = function(t, e) {
                            var n = e ? t : _.getTransitionSpeed(t),
                                i = n + "ms";
                            return W !== i && (W = i, _.doc.css(I.prefixstyle + "transition-duration", i)), n
                        }, this.doScrollLeft = function(t, e) {
                            var n = _.scrollrunning ? _.newscrolly : _.getScrollTop();
                            _.doScrollPos(t, n, e)
                        }, this.doScrollTop = function(t, e) {
                            var n = _.scrollrunning ? _.newscrollx : _.getScrollLeft();
                            _.doScrollPos(n, t, e)
                        }, this.cursorupdate = {
                            running: !1,
                            start: function() {
                                var t = this;
                                if (!t.running) {
                                    t.running = !0;
                                    var e = function n() { t.running && h(n), _.showCursor(_.getScrollTop(), _.getScrollLeft()), _.notifyScrollEvent(_.win[0]) };
                                    h(e)
                                }
                            },
                            stop: function() { this.running = !1 }
                        }, this.doScrollPos = function(t, e, n) {
                            var i = _.getScrollTop(),
                                r = _.getScrollLeft();
                            if (((_.newscrolly - i) * (e - i) < 0 || (_.newscrollx - r) * (t - r) < 0) && _.cancelScroll(), M.bouncescroll ? (e < 0 ? e = e / 2 | 0 : e > _.page.maxh && (e = _.page.maxh + (e - _.page.maxh) / 2 | 0), t < 0 ? t = t / 2 | 0 : t > _.page.maxw && (t = _.page.maxw + (t - _.page.maxw) / 2 | 0)) : (e < 0 ? e = 0 : e > _.page.maxh && (e = _.page.maxh), t < 0 ? t = 0 : t > _.page.maxw && (t = _.page.maxw)), _.scrollrunning && t == _.newscrollx && e == _.newscrolly) return !1;
                            _.newscrolly = e, _.newscrollx = t;
                            var o = _.getScrollTop(),
                                a = _.getScrollLeft(),
                                s = {};
                            s.x = t - a, s.y = e - o;
                            var l = 0 | Math.sqrt(s.x * s.x + s.y * s.y),
                                u = _.prepareTransition(l);
                            _.scrollrunning || (_.scrollrunning = !0, _.triggerScrollStart(a, o, t, e, u), _.cursorupdate.start()), _.scrollendtrapped = !0, I.transitionend || (_.scrollendtrapped && clearTimeout(_.scrollendtrapped), _.scrollendtrapped = setTimeout(_.onScrollTransitionEnd, u)), _.setScrollTop(_.newscrolly), _.setScrollLeft(_.newscrollx)
                        }, this.cancelScroll = function() {
                            if (!_.scrollendtrapped) return !0;
                            var t = _.getScrollTop(),
                                e = _.getScrollLeft();
                            return _.scrollrunning = !1, I.transitionend || clearTimeout(I.transitionend), _.scrollendtrapped = !1, _.resetTransition(), _.setScrollTop(t), _.railh && _.setScrollLeft(e), _.timerscroll && _.timerscroll.tm && clearInterval(_.timerscroll.tm), _.timerscroll = !1, _.cursorfreezed = !1, _.cursorupdate.stop(), _.showCursor(t, e), _
                        }, this.onScrollTransitionEnd = function() {
                            if (_.scrollendtrapped) {
                                var t = _.getScrollTop(),
                                    e = _.getScrollLeft();
                                if (t < 0 ? t = 0 : t > _.page.maxh && (t = _.page.maxh), e < 0 ? e = 0 : e > _.page.maxw && (e = _.page.maxw), t != _.newscrolly || e != _.newscrollx) return _.doScrollPos(e, t, M.snapbackspeed);
                                _.scrollrunning && _.triggerScrollEnd(), _.scrollrunning = !1, _.scrollendtrapped = !1, _.resetTransition(), _.timerscroll = !1, _.setScrollTop(t), _.railh && _.setScrollLeft(e), _.cursorupdate.stop(), _.noticeCursor(!1, t, e), _.cursorfreezed = !1
                            }
                        }
                    } else this.doScrollLeft = function(t, e) {
                        var n = _.scrollrunning ? _.newscrolly : _.getScrollTop();
                        _.doScrollPos(t, n, e)
                    }, this.doScrollTop = function(t, e) {
                        var n = _.scrollrunning ? _.newscrollx : _.getScrollLeft();
                        _.doScrollPos(n, t, e)
                    }, this.doScrollPos = function(t, e, n) {
                        var i = _.getScrollTop(),
                            r = _.getScrollLeft();
                        ((_.newscrolly - i) * (e - i) < 0 || (_.newscrollx - r) * (t - r) < 0) && _.cancelScroll();
                        var o = !1;
                        if (_.bouncescroll && _.rail.visibility || (e < 0 ? (e = 0, o = !0) : e > _.page.maxh && (e = _.page.maxh, o = !0)), _.bouncescroll && _.railh.visibility || (t < 0 ? (t = 0, o = !0) : t > _.page.maxw && (t = _.page.maxw, o = !0)), _.scrollrunning && _.newscrolly === e && _.newscrollx === t) return !0;
                        _.newscrolly = e, _.newscrollx = t, _.dst = {}, _.dst.x = t - r, _.dst.y = e - i, _.dst.px = r, _.dst.py = i;
                        var a = 0 | Math.sqrt(_.dst.x * _.dst.x + _.dst.y * _.dst.y),
                            s = _.getTransitionSpeed(a);
                        _.bzscroll = {};
                        var l = o ? 1 : .58;
                        _.bzscroll.x = new z(r, _.newscrollx, s, 0, 0, l, 1), _.bzscroll.y = new z(i, _.newscrolly, s, 0, 0, l, 1), v();
                        var u = function c() {
                            if (_.scrollrunning) {
                                var t = _.bzscroll.y.getPos();
                                _.setScrollLeft(_.bzscroll.x.getNow()), _.setScrollTop(_.bzscroll.y.getNow()), t <= 1 ? _.timer = h(c) : (_.scrollrunning = !1, _.timer = 0, _.triggerScrollEnd())
                            }
                        };
                        _.scrollrunning || (_.triggerScrollStart(r, i, t, e, s), _.scrollrunning = !0, _.timer = h(u))
                    }, this.cancelScroll = function() { return _.timer && f(_.timer), _.timer = 0, _.bzscroll = !1, _.scrollrunning = !1, _ };
                else this.doScrollLeft = function(t, e) {
                    var n = _.getScrollTop();
                    _.doScrollPos(t, n, e)
                }, this.doScrollTop = function(t, e) {
                    var n = _.getScrollLeft();
                    _.doScrollPos(n, t, e)
                }, this.doScrollPos = function(t, e, n) {
                    var i = t > _.page.maxw ? _.page.maxw : t;
                    i < 0 && (i = 0);
                    var r = e > _.page.maxh ? _.page.maxh : e;
                    r < 0 && (r = 0), _.synched("scroll", function() { _.setScrollTop(r), _.setScrollLeft(i) })
                }, this.cancelScroll = function() {};
                this.doScrollBy = function(t, e) { k(0, t) }, this.doScrollLeftBy = function(t, e) { k(t, 0) }, this.doScrollTo = function(t, e) {
                    var n = e ? Math.round(t * _.scrollratio.y) : t;
                    n < 0 ? n = 0 : n > _.page.maxh && (n = _.page.maxh), _.cursorfreezed = !1, _.doScrollTop(t)
                }, this.checkContentSize = function() {
                    var t = _.getContentSize();
                    t.h == _.page.h && t.w == _.page.w || _.resize(!1, t)
                }, _.onscroll = function(t) { _.rail.drag || _.cursorfreezed || _.synched("scroll", function() { _.scroll.y = Math.round(_.getScrollTop() / _.scrollratio.y), _.railh && (_.scroll.x = Math.round(_.getScrollLeft() / _.scrollratio.x)), _.noticeCursor() }) }, _.bind(_.docscroll, "scroll", _.onscroll), this.doZoomIn = function(t) {
                    if (!_.zoomactive) {
                        _.zoomactive = !0, _.zoomrestore = { style: {} };
                        var e = ["position", "top", "left", "zIndex", "backgroundColor", "marginTop", "marginBottom", "marginLeft", "marginRight"],
                            n = _.win[0].style;
                        for (var i in e) {
                            var r = e[i];
                            _.zoomrestore.style[r] = void 0 !== n[r] ? n[r] : ""
                        }
                        _.zoomrestore.style.width = _.win.css("width"), _.zoomrestore.style.height = _.win.css("height"), _.zoomrestore.padding = { w: _.win.outerWidth() - _.win.width(), h: _.win.outerHeight() - _.win.height() }, I.isios4 && (_.zoomrestore.scrollTop = c.scrollTop(), c.scrollTop(0)), _.win.css({ position: I.isios4 ? "absolute" : "fixed", top: 0, left: 0, zIndex: o + 100, margin: 0 });
                        var a = _.win.css("backgroundColor");
                        return ("" === a || /transparent|rgba\(0, 0, 0, 0\)|rgba\(0,0,0,0\)/.test(a)) && _.win.css("backgroundColor", "#fff"), _.rail.css({ zIndex: o + 101 }), _.zoom.css({ zIndex: o + 102 }), _.zoom.css("backgroundPosition", "0 -18px"), _.resizeZoom(), _.onzoomin && _.onzoomin.call(_), _.cancelEvent(t)
                    }
                }, this.doZoomOut = function(t) { if (_.zoomactive) return _.zoomactive = !1, _.win.css("margin", ""), _.win.css(_.zoomrestore.style), I.isios4 && c.scrollTop(_.zoomrestore.scrollTop), _.rail.css({ "z-index": _.zindex }), _.zoom.css({ "z-index": _.zindex }), _.zoomrestore = !1, _.zoom.css("backgroundPosition", "0 0"), _.onResize(), _.onzoomout && _.onzoomout.call(_), _.cancelEvent(t) }, this.doZoom = function(t) { return _.zoomactive ? _.doZoomOut(t) : _.doZoomIn(t) }, this.resizeZoom = function() {
                    if (_.zoomactive) {
                        var t = _.getScrollTop();
                        _.win.css({ width: c.width() - _.zoomrestore.padding.w + "px", height: c.height() - _.zoomrestore.padding.h + "px" }), _.onResize(), _.setScrollTop(Math.min(_.page.maxh, t))
                    }
                }, this.init(), a.nicescroll.push(this)
            },
            w = function(t) {
                var e = this;
                this.nc = t, this.lastx = 0, this.lasty = 0, this.speedx = 0, this.speedy = 0, this.lasttime = 0, this.steptime = 0, this.snapx = !1, this.snapy = !1, this.demulx = 0, this.demuly = 0, this.lastscrollx = -1, this.lastscrolly = -1, this.chkx = 0, this.chky = 0, this.timer = 0, this.reset = function(t, n) { e.stop(), e.steptime = 0, e.lasttime = v(), e.speedx = 0, e.speedy = 0, e.lastx = t, e.lasty = n, e.lastscrollx = -1, e.lastscrolly = -1 }, this.update = function(t, n) {
                    var i = v();
                    e.steptime = i - e.lasttime, e.lasttime = i;
                    var r = n - e.lasty,
                        o = t - e.lastx,
                        a = e.nc.getScrollTop() + r,
                        s = e.nc.getScrollLeft() + o;
                    e.snapx = s < 0 || s > e.nc.page.maxw, e.snapy = a < 0 || a > e.nc.page.maxh, e.speedx = o, e.speedy = r, e.lastx = t, e.lasty = n
                }, this.stop = function() { e.nc.unsynched("domomentum2d"), e.timer && clearTimeout(e.timer), e.timer = 0, e.lastscrollx = -1, e.lastscrolly = -1 }, this.doSnapy = function(t, n) {
                    var i = !1;
                    n < 0 ? (n = 0, i = !0) : n > e.nc.page.maxh && (n = e.nc.page.maxh, i = !0), t < 0 ? (t = 0, i = !0) : t > e.nc.page.maxw && (t = e.nc.page.maxw, i = !0), i ? e.nc.doScrollPos(t, n, e.nc.opt.snapbackspeed) : e.nc.triggerScrollEnd()
                }, this.doMomentum = function(t) {
                    var n = v(),
                        i = t ? n + t : e.lasttime,
                        r = e.nc.getScrollLeft(),
                        o = e.nc.getScrollTop(),
                        a = e.nc.page.maxh,
                        s = e.nc.page.maxw;
                    e.speedx = s > 0 ? Math.min(60, e.speedx) : 0, e.speedy = a > 0 ? Math.min(60, e.speedy) : 0;
                    var l = i && n - i <= 60;
                    (o < 0 || o > a || r < 0 || r > s) && (l = !1);
                    var u = !(!e.speedy || !l) && e.speedy,
                        c = !(!e.speedx || !l) && e.speedx;
                    if (u || c) {
                        var d = Math.max(16, e.steptime);
                        if (d > 50) {
                            var h = d / 50;
                            e.speedx *= h, e.speedy *= h, d = 50
                        }
                        e.demulxy = 0, e.lastscrollx = e.nc.getScrollLeft(), e.chkx = e.lastscrollx, e.lastscrolly = e.nc.getScrollTop(), e.chky = e.lastscrolly;
                        var f = e.lastscrollx,
                            p = e.lastscrolly,
                            g = function m() {
                                var t = v() - n > 600 ? .04 : .02;
                                e.speedx && (f = Math.floor(e.lastscrollx - e.speedx * (1 - e.demulxy)), e.lastscrollx = f, (f < 0 || f > s) && (t = .1)), e.speedy && (p = Math.floor(e.lastscrolly - e.speedy * (1 - e.demulxy)), e.lastscrolly = p, (p < 0 || p > a) && (t = .1)), e.demulxy = Math.min(1, e.demulxy + t), e.nc.synched("domomentum2d", function() { e.speedx && (e.nc.getScrollLeft(), e.chkx = f, e.nc.setScrollLeft(f)), e.speedy && (e.nc.getScrollTop(), e.chky = p, e.nc.setScrollTop(p)), e.timer || (e.nc.hideCursor(), e.doSnapy(f, p)) }), e.demulxy < 1 ? e.timer = setTimeout(m, d) : (e.stop(), e.nc.hideCursor(), e.doSnapy(f, p))
                            };
                        g()
                    } else e.doSnapy(e.nc.getScrollLeft(), e.nc.getScrollTop())
                }
            },
            k = t.fn.scrollTop;
        t.cssHooks.pageYOffset = { get: function(t, e, n) { var i = a.data(t, "__nicescroll") || !1; return i && i.ishwscroll ? i.getScrollTop() : k.call(t) }, set: function(t, e) { var n = a.data(t, "__nicescroll") || !1; return n && n.ishwscroll ? n.setScrollTop(parseInt(e)) : k.call(t, e), this } }, t.fn.scrollTop = function(t) {
            if (void 0 === t) { var e = !!this[0] && (a.data(this[0], "__nicescroll") || !1); return e && e.ishwscroll ? e.getScrollTop() : k.call(this) }
            return this.each(function() {
                var e = a.data(this, "__nicescroll") || !1;
                e && e.ishwscroll ? e.setScrollTop(parseInt(t)) : k.call(a(this), t)
            })
        };
        var S = t.fn.scrollLeft;
        a.cssHooks.pageXOffset = { get: function(t, e, n) { var i = a.data(t, "__nicescroll") || !1; return i && i.ishwscroll ? i.getScrollLeft() : S.call(t) }, set: function(t, e) { var n = a.data(t, "__nicescroll") || !1; return n && n.ishwscroll ? n.setScrollLeft(parseInt(e)) : S.call(t, e), this } }, t.fn.scrollLeft = function(t) {
            if (void 0 === t) { var e = !!this[0] && (a.data(this[0], "__nicescroll") || !1); return e && e.ishwscroll ? e.getScrollLeft() : S.call(this) }
            return this.each(function() {
                var e = a.data(this, "__nicescroll") || !1;
                e && e.ishwscroll ? e.setScrollLeft(parseInt(t)) : S.call(a(this), t)
            })
        };
        var _ = function(t) {
            var e = this;
            if (this.length = 0, this.name = "nicescrollarray", this.each = function(t) { return a.each(e, t), e }, this.push = function(t) { e[e.length] = t, e.length++ }, this.eq = function(t) { return e[t] }, t)
                for (var n = 0; n < t.length; n++) {
                    var i = a.data(t[n], "__nicescroll") || !1;
                    i && (this[this.length] = i, this.length++)
                }
            return this
        };
        ! function(t, e, n) { for (var i = 0, r = e.length; i < r; i++) n(t, e[i]) }(_.prototype, ["show", "hide", "toggle", "onResize", "resize", "remove", "stop", "doScrollPos"], function(t, e) { t[e] = function() { var t = arguments; return this.each(function() { this[e].apply(this, t) }) } }), t.fn.getNiceScroll = function(t) { return void 0 === t ? new _(this) : this[t] && a.data(this[t], "__nicescroll") || !1 }, (t.expr.pseudos || t.expr[":"]).nicescroll = function(t) { return void 0 !== a.data(t, "__nicescroll") }, a.fn.niceScroll = function(t, e) {
            void 0 !== e || "object" != ("undefined" == typeof t ? "undefined" : (0, l.default)(t)) || "jquery" in t || (e = t, t = !1);
            var n = new _;
            return this.each(function() {
                var i = a(this),
                    r = a.extend({}, e);
                if (t) {
                    var o = a(t);
                    r.doc = o.length > 1 ? a(t, i) : o, r.win = i
                }!("doc" in r) || "win" in r || (r.win = i);
                var s = i.data("__nicescroll") || !1;
                s || (r.doc = r.doc || i, s = new x(r, i), i.data("__nicescroll", s)), n.push(s)
            }), 1 === n.length ? n[0] : n
        }, u.NiceScroll = { getjQuery: function() { return t } }, a.nicescroll || (a.nicescroll = new _, a.nicescroll.options = m)
    })
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function i(t) { return t && t.__esModule ? t : { "default": t } }

        function r(e) {
            var n = document.getElementById(e);
            if (null !== n) {
                var i = t(n).parents(".container-small").find('[data-chart="injury"] > div');
                if (i) {
                    var r = [],
                        o = [];
                    i.each(function(e, n) {
                        var i = t(n).data("year"),
                            a = t(n).data("number");
                        r.push(i), o.push(a)
                    });
                    var a = n.getContext("2d"),
                        l = { labels: r, datasets: [{ label: !1, data: o, backgroundColor: "rgba(102,163,217,0.33)", borderColor: "rgba(102,163,217,0.8)", borderWidth: 1, hoverBackgroundColor: "rgba(102,163,217,0.33)" }] },
                        u = {
                            legend: !1,
                            scales: { yAxes: [{ stacked: !0, ticks: { fontColor: "#666666" } }], xAxes: [{ gridLines: { display: !1 }, ticks: { fontColor: "#666666" } }] },
                            tooltips: { enabled: !1 },
                            hover: { animationDuration: 0 },
                            animation: {
                                onComplete: function() {
                                    var t = this.chart,
                                        e = t.ctx;
                                    e.font = s.default.helpers.fontString(s.default.defaults.global.defaultFontSize, s.default.defaults.global.defaultFontStyle, s.default.defaults.global.defaultFontFamily), e.textAlign = "center", e.textBaseline = "bottom", e.fillStyle = "#13aec9", this.data.datasets.forEach(function(n, i) {
                                        var r = t.controller.getDatasetMeta(i);
                                        r.data.forEach(function(t, i) {
                                            var r = n.data[i];
                                            e.fillText(r, t._model.x, t._model.y - 5)
                                        })
                                    })
                                }
                            },
                            layout: { padding: { top: 40, left: 0, right: 0, bottom: 0 } }
                        };
                    window.myBarChart = new s.default(a, { type: "bar", data: l, options: u })
                }
            }
        }

        function o(e) {
            var n = document.getElementById(e);
            if (null !== n) {
                var i = t(n).parents(".container-small").find('[data-chart="incidents"] > div');
                if (i) {
                    var r = [],
                        o = [];
                    i.each(function(e, n) {
                        var i = t(n).data("year"),
                            a = t(n).data("number");
                        r.push(i), o.push(a)
                    });
                    var a = n.getContext("2d"),
                        l = {
                            legend: !1,
                            scales: { yAxes: [{ stacked: !0, ticks: { fontColor: "#666666" } }], xAxes: [{ gridLines: { display: !1 }, ticks: { fontColor: "#666666" } }] },
                            tooltips: { enabled: !1 },
                            hover: { animationDuration: 0 },
                            animation: {
                                onComplete: function() {
                                    var t = this.chart,
                                        e = t.ctx;
                                    e.font = s.default.helpers.fontString(s.default.defaults.global.defaultFontSize, s.default.defaults.global.defaultFontStyle, s.default.defaults.global.defaultFontFamily), e.textAlign = "center", e.textBaseline = "bottom", e.fillStyle = "#13aec9", this.data.datasets.forEach(function(n, i) {
                                        var r = t.controller.getDatasetMeta(i);
                                        r.data.forEach(function(t, i) {
                                            var r = n.data[i];
                                            e.fillText(r, t._model.x, t._model.y - 5)
                                        })
                                    })
                                }
                            },
                            layout: { padding: { top: 40, left: 0, right: 0, bottom: 0 } }
                        };
                    window.myLineChart = new s.default(a, { type: "line", data: { labels: r, datasets: [{ label: "", data: o, lineTension: 0, fill: !1, borderColor: "rgba(102,163,217,0.8)", backgroundColor: "transparent", pointBorderColor: "rgba(102,163,217,0.8)", pointBackgroundColor: "rgba(102,163,217,0.33)", pointRadius: 5, pointHoverRadius: 5, pointHitRadius: 30, pointBorderWidth: 2, pointStyle: "circle" }] }, options: l })
                }
            }
        }
        Object.defineProperty(e, "__esModule", { value: !0 }), e.initInjuryChart = r, e.initIncidentsChart = o;
        var a = n(308),
            s = i(a)
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function i() {
            var e = t(".simple-text img");
            e.length && e.each(function(e, n) { t(n).waypoint({ handler: function(e) { "down" === e && t(n).addClass("in-view") }, offset: "80%" }) })
        }
        Object.defineProperty(e, "__esModule", { value: !0 }), e.default = i, n(119), 0 === t(".hero").length ? i() : window.innerWidth > 768 ? t(window).scrollTop() > 0 && 0 !== t(".hero").length && i() : i()
    }).call(e, n(2))
}, , , , , , , , , , , , , , , , , , , , , , , , , , function(t, e, n) { t.exports = n(297) }, function(t, e) {
    "function" != typeof Object.create && (Object.create = function(t) {
            function e() {}
            return e.prototype = t, new e
        }),
        function(t, e, n) {
            var i = function(t) {
                    var i = n.createElement("script"),
                        o = n.getElementsByTagName("head")[0];
                    "file://" == e.location.origin ? i.src = "http://www.youtube.com/iframe_api" : i.src = "//www.youtube.com/iframe_api", o.appendChild(i), o = null, i = null, r(t)
                },
                r = function(n) { "undefined" == typeof YT && "undefined" == typeof e.loadingPlayer ? (e.loadingPlayer = !0, e.dfd = t.Deferred(), e.onYouTubeIframeAPIReady = function() { e.onYouTubeIframeAPIReady = null, e.dfd.resolve("done"), n() }) : "object" == typeof YT ? n() : e.dfd.done(function(t) { n() }) };
            YTPlayer = {
                player: null,
                defaults: { ratio: 16 / 9, videoId: "LSmgKRx5pBo", mute: !0, repeat: !0, width: t(e).width(), playButtonClass: "YTPlayer-play", pauseButtonClass: "YTPlayer-pause", muteButtonClass: "YTPlayer-mute", volumeUpClass: "YTPlayer-volume-up", volumeDownClass: "YTPlayer-volume-down", start: 0, pauseOnScroll: !1, fitToBackground: !0, playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 1, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0 }, events: null },
                init: function(n, r) { var o = this; return o.userOptions = r, o.$body = t("body"), o.$node = t(n), o.$window = t(e), o.defaults.events = { onReady: function(t) { o.onPlayerReady(t), o.options.pauseOnScroll && o.pauseOnScroll(), "function" == typeof o.options.callback && o.options.callback.call(this) }, onStateChange: function(t) { 1 === t.data ? (o.$node.find("img").fadeOut(400), o.$node.addClass("loaded")) : 0 === t.data && o.options.repeat && o.player.seekTo(o.options.start) } }, o.options = t.extend(!0, {}, o.defaults, o.userOptions), o.options.height = Math.ceil(o.options.width / o.options.ratio), o.ID = (new Date).getTime(), o.holderID = "YTPlayer-ID-" + o.ID, o.options.fitToBackground ? o.createBackgroundVideo() : o.createContainerVideo(), o.$window.on("resize.YTplayer" + o.ID, function() { o.resize(o) }), i(o.onYouTubeIframeAPIReady.bind(o)), o.resize(o), o },
                pauseOnScroll: function() {
                    var t = this;
                    t.$window.on("scroll.YTplayer" + t.ID, function() {
                        var e = t.player.getPlayerState();
                        1 === e && t.player.pauseVideo()
                    }), t.$window.scrollStopped(function() {
                        var e = t.player.getPlayerState();
                        2 === e && t.player.playVideo()
                    })
                },
                createContainerVideo: function() {
                    var e = this,
                        n = t('<div id="ytplayer-container' + e.ID + '" >\t                                    <div id="' + e.holderID + '" class="ytplayer-player-inline"></div> \t                                    </div> \t                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');
                    e.$node.append(n), e.$YTPlayerString = n, n = null
                },
                createBackgroundVideo: function() {
                    var e = this,
                        n = t('<div id="ytplayer-container' + e.ID + '" class="ytplayer-container background">\t                                    <div id="' + e.holderID + '" class="ytplayer-player"></div>\t                                    </div>\t                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');
                    e.$node.append(n), e.$YTPlayerString = n, n = null
                },
                resize: function(n) {
                    var i = t(e);
                    n.options.fitToBackground || (i = n.$node);
                    var r, o, a = i.width(),
                        s = i.height(),
                        l = t("#" + n.holderID);
                    a / n.options.ratio < s ? (r = Math.ceil(s * n.options.ratio), l.width(r).height(s).css({ left: (a - r) / 2, top: 0 })) : (o = Math.ceil(a / n.options.ratio), l.width(a).height(o).css({ left: 0, top: (s - o) / 2 })), l = null, i = null
                },
                onYouTubeIframeAPIReady: function() {
                    var t = this;
                    t.player = new e.YT.Player(t.holderID, t.options)
                },
                onPlayerReady: function(t) { this.options.mute && t.target.mute(), t.target.playVideo() },
                getPlayer: function() { return this.player },
                destroy: function() {
                    var n = this;
                    n.$node.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"), n.$YTPlayerString.remove(), t(e).off("resize.YTplayer" + n.ID), t(e).off("scroll.YTplayer" + n.ID), n.$body = null, n.$node = null, n.$YTPlayerString = null, n.player.destroy(), n.player = null
                }
            }, t.fn.scrollStopped = function(e) {
                var n = t(this),
                    i = this;
                n.scroll(function() { n.data("scrollTimeout") && clearTimeout(n.data("scrollTimeout")), n.data("scrollTimeout", setTimeout(e, 250, i)) })
            }, t.fn.YTPlayer = function(e) {
                return this.each(function() {
                    var n = this;
                    t(n).data("yt-init", !0);
                    var i = Object.create(YTPlayer);
                    i.init(n, e), t.data(n, "ytPlayer", i)
                })
            }
        }(jQuery, window, document)
}, function(t, e, n) {
    function i(t) { return t && t.__esModule ? t : { "default": t } }
    var r, o, a = n(44),
        s = i(a),
        l = n(167),
        u = i(l),
        c = n(58),
        d = i(c),
        h = n(59),
        f = i(h);
    ! function() {
        function i(t) { return t && (t.ownerDocument || t.document || t).documentElement }

        function a(t) { return t && (t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView) }

        function l(t, e) { return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN }

        function c(t) { return null === t ? NaN : +t }

        function h(t) { return !isNaN(t) }

        function p(t) {
            return {
                left: function(e, n, i, r) {
                    for (arguments.length < 3 && (i = 0), arguments.length < 4 && (r = e.length); i < r;) {
                        var o = i + r >>> 1;
                        t(e[o], n) < 0 ? i = o + 1 : r = o
                    }
                    return i
                },
                right: function(e, n, i, r) {
                    for (arguments.length < 3 && (i = 0), arguments.length < 4 && (r = e.length); i < r;) {
                        var o = i + r >>> 1;
                        t(e[o], n) > 0 ? r = o : i = o + 1
                    }
                    return i
                }
            }
        }

        function g(t) { return t.length }

        function v(t) { for (var e = 1; t * e % 1;) e *= 10; return e }

        function m(t, e) { for (var n in e)(0, f.default)(t.prototype, n, { value: e[n], enumerable: !1 }) }

        function y() { this._ = (0, d.default)(null) }

        function b(t) { return (t += "") === Pa || t[0] === Ia ? Ia + t : t }

        function x(t) { return (t += "")[0] === Ia ? t.slice(1) : t }

        function w(t) { return b(t) in this._ }

        function k(t) { return (t = b(t)) in this._ && delete this._[t] }

        function S() { var t = []; for (var e in this._) t.push(x(e)); return t }

        function _() { var t = 0; for (var e in this._) ++t; return t }

        function T() { for (var t in this._) return !1; return !0 }

        function C() { this._ = (0, d.default)(null) }

        function M(t) { return t }

        function A(t, e, n) { return function() { var i = n.apply(e, arguments); return i === e ? t : i } }

        function E(t, e) {
            if (e in t) return e;
            e = e.charAt(0).toUpperCase() + e.slice(1);
            for (var n = 0, i = za.length; n < i; ++n) { var r = za[n] + e; if (r in t) return r }
        }

        function P() {}

        function I() {}

        function z(t) {
            function e() { for (var e, i = n, r = -1, o = i.length; ++r < o;)(e = i[r].on) && e.apply(this, arguments); return t }
            var n = [],
                i = new y;
            return e.on = function(e, r) { var o, a = i.get(e); return arguments.length < 2 ? a && a.on : (a && (a.on = null, n = n.slice(0, o = n.indexOf(a)).concat(n.slice(o + 1)), i.remove(e)), r && n.push(i.set(e, { on: r })), t) }, e
        }

        function D() { ma.event.preventDefault() }

        function O() { for (var t, e = ma.event; t = e.sourceEvent;) e = t; return e }

        function L(t) {
            for (var e = new I, n = 0, i = arguments.length; ++n < i;) e[arguments[n]] = z(e);
            return e.of = function(n, i) {
                return function(r) {
                    try {
                        var o = r.sourceEvent = ma.event;
                        r.target = t, ma.event = r, e[r.type].apply(n, i)
                    } finally { ma.event = o }
                }
            }, e
        }

        function $(t) { return Oa(t, Ra), t }

        function N(t) { return "function" == typeof t ? t : function() { return La(t, this) } }

        function R(t) { return "function" == typeof t ? t : function() { return $a(t, this) } }

        function q(t, e) {
            function n() { this.removeAttribute(t) }

            function i() { this.removeAttributeNS(t.space, t.local) }

            function r() { this.setAttribute(t, e) }

            function o() { this.setAttributeNS(t.space, t.local, e) }

            function a() {
                var n = e.apply(this, arguments);
                null == n ? this.removeAttribute(t) : this.setAttribute(t, n)
            }

            function s() {
                var n = e.apply(this, arguments);
                null == n ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n)
            }
            return t = ma.ns.qualify(t), null == e ? t.local ? i : n : "function" == typeof e ? t.local ? s : a : t.local ? o : r
        }

        function F(t) { return t.trim().replace(/\s+/g, " ") }

        function H(t) { return new RegExp("(?:^|\\s+)" + ma.requote(t) + "(?:\\s+|$)", "g") }

        function B(t) { return (t + "").trim().split(/^|\s+/) }

        function W(t, e) {
            function n() { for (var n = -1; ++n < r;) t[n](this, e) }

            function i() { for (var n = -1, i = e.apply(this, arguments); ++n < r;) t[n](this, i) } t = B(t).map(j);
            var r = t.length;
            return "function" == typeof e ? i : n
        }

        function j(t) {
            var e = H(t);
            return function(n, i) {
                if (r = n.classList) return i ? r.add(t) : r.remove(t);
                var r = n.getAttribute("class") || "";
                i ? (e.lastIndex = 0, e.test(r) || n.setAttribute("class", F(r + " " + t))) : n.setAttribute("class", F(r.replace(e, " ")))
            }
        }

        function Y(t, e, n) {
            function i() { this.style.removeProperty(t) }

            function r() { this.style.setProperty(t, e, n) }

            function o() {
                var i = e.apply(this, arguments);
                null == i ? this.style.removeProperty(t) : this.style.setProperty(t, i, n)
            }
            return null == e ? i : "function" == typeof e ? o : r
        }

        function U(t, e) {
            function n() { delete this[t] }

            function i() { this[t] = e }

            function r() {
                var n = e.apply(this, arguments);
                null == n ? delete this[t] : this[t] = n
            }
            return null == e ? n : "function" == typeof e ? r : i
        }

        function V(t) {
            function e() {
                var e = this.ownerDocument,
                    n = this.namespaceURI;
                return n === qa && e.documentElement.namespaceURI === qa ? e.createElement(t) : e.createElementNS(n, t)
            }

            function n() { return this.ownerDocument.createElementNS(t.space, t.local) }
            return "function" == typeof t ? t : (t = ma.ns.qualify(t)).local ? n : e
        }

        function X() {
            var t = this.parentNode;
            t && t.removeChild(this)
        }

        function Z(t) { return { __data__: t } }

        function K(t) { return function() { return Na(this, t) } }

        function G(t) {
            return arguments.length || (t = l),
                function(e, n) { return e && n ? t(e.__data__, n.__data__) : !e - !n }
        }

        function J(t, e) {
            for (var n = 0, i = t.length; n < i; n++)
                for (var r, o = t[n], a = 0, s = o.length; a < s; a++)(r = o[a]) && e(r, a, n);
            return t
        }

        function Q(t) { return Oa(t, Ha), t }

        function tt(t) {
            var e, n;
            return function(i, r, o) {
                var a, s = t[o].update,
                    l = s.length;
                for (o != n && (n = o, e = 0), r >= e && (e = r + 1); !(a = s[e]) && ++e < l;);
                return a
            }
        }

        function et(t, e, n) {
            function i() {
                var e = this[a];
                e && (this.removeEventListener(t, e, e.$), delete this[a])
            }

            function r() {
                var r = l(e, ba(arguments));
                i.call(this), this.addEventListener(t, this[a] = r, r.$ = n), r._ = e
            }

            function o() {
                var e, n = new RegExp("^__on([^.]+)" + ma.requote(t) + "$");
                for (var i in this)
                    if (e = i.match(n)) {
                        var r = this[i];
                        this.removeEventListener(e[1], r, r.$), delete this[i]
                    }
            }
            var a = "__on" + t,
                s = t.indexOf("."),
                l = nt;
            s > 0 && (t = t.slice(0, s));
            var u = Ba.get(t);
            return u && (t = u, l = it), s ? e ? r : i : e ? P : o
        }

        function nt(t, e) {
            return function(n) {
                var i = ma.event;
                ma.event = n, e[0] = this.__data__;
                try { t.apply(this, e) } finally { ma.event = i }
            }
        }

        function it(t, e) {
            var n = nt(t, e);
            return function(t) {
                var e = this,
                    i = t.relatedTarget;
                i && (i === e || 8 & i.compareDocumentPosition(e)) || n.call(e, t)
            }
        }

        function rt(t) {
            var e = ".dragsuppress-" + ++ja,
                n = "click" + e,
                r = ma.select(a(t)).on("touchmove" + e, D).on("dragstart" + e, D).on("selectstart" + e, D);
            if (null == Wa && (Wa = !("onselectstart" in t) && E(t.style, "userSelect")), Wa) {
                var o = i(t).style,
                    s = o[Wa];
                o[Wa] = "none"
            }
            return function(t) {
                if (r.on(e, null), Wa && (o[Wa] = s), t) {
                    var i = function() { r.on(n, null) };
                    r.on(n, function() { D(), i() }, !0), setTimeout(i, 0)
                }
            }
        }

        function ot(t, e) {
            e.changedTouches && (e = e.changedTouches[0]);
            var n = t.ownerSVGElement || t;
            if (n.createSVGPoint) {
                var i = n.createSVGPoint();
                if (Ya < 0) {
                    var r = a(t);
                    if (r.scrollX || r.scrollY) {
                        n = ma.select("body").append("svg").style({ position: "absolute", top: 0, left: 0, margin: 0, padding: 0, border: "none" }, "important");
                        var o = n[0][0].getScreenCTM();
                        Ya = !(o.f || o.e), n.remove()
                    }
                }
                return Ya ? (i.x = e.pageX, i.y = e.pageY) : (i.x = e.clientX, i.y = e.clientY), i = i.matrixTransform(t.getScreenCTM().inverse()), [i.x, i.y]
            }
            var s = t.getBoundingClientRect();
            return [e.clientX - s.left - t.clientLeft, e.clientY - s.top - t.clientTop]
        }

        function at() { return ma.event.changedTouches[0].identifier }

        function st(t) { return t > 0 ? 1 : t < 0 ? -1 : 0 }

        function lt(t, e, n) { return (e[0] - t[0]) * (n[1] - t[1]) - (e[1] - t[1]) * (n[0] - t[0]) }

        function ut(t) { return t > 1 ? 0 : t < -1 ? Xa : Math.acos(t) }

        function ct(t) { return t > 1 ? Ga : t < -1 ? -Ga : Math.asin(t) }

        function dt(t) { return ((t = Math.exp(t)) - 1 / t) / 2 }

        function ht(t) { return ((t = Math.exp(t)) + 1 / t) / 2 }

        function ft(t) { return ((t = Math.exp(2 * t)) - 1) / (t + 1) }

        function pt(t) { return (t = Math.sin(t / 2)) * t }

        function gt() {}

        function vt(t, e, n) { return this instanceof vt ? (this.h = +t, this.s = +e, void(this.l = +n)) : arguments.length < 2 ? t instanceof vt ? new vt(t.h, t.s, t.l) : Pt("" + t, It, vt) : new vt(t, e, n) }

        function mt(t, e, n) {
            function i(t) { return t > 360 ? t -= 360 : t < 0 && (t += 360), t < 60 ? o + (a - o) * t / 60 : t < 180 ? a : t < 240 ? o + (a - o) * (240 - t) / 60 : o }

            function r(t) { return Math.round(255 * i(t)) }
            var o, a;
            return t = isNaN(t) ? 0 : (t %= 360) < 0 ? t + 360 : t, e = isNaN(e) ? 0 : e < 0 ? 0 : e > 1 ? 1 : e, n = n < 0 ? 0 : n > 1 ? 1 : n, a = n <= .5 ? n * (1 + e) : n + e - n * e, o = 2 * n - a, new Ct(r(t + 120), r(t), r(t - 120))
        }

        function yt(t, e, n) { return this instanceof yt ? (this.h = +t, this.c = +e, void(this.l = +n)) : arguments.length < 2 ? t instanceof yt ? new yt(t.h, t.c, t.l) : t instanceof xt ? kt(t.l, t.a, t.b) : kt((t = zt((t = ma.rgb(t)).r, t.g, t.b)).l, t.a, t.b) : new yt(t, e, n) }

        function bt(t, e, n) { return isNaN(t) && (t = 0), isNaN(e) && (e = 0), new xt(n, Math.cos(t *= Ja) * e, Math.sin(t) * e) }

        function xt(t, e, n) { return this instanceof xt ? (this.l = +t, this.a = +e, void(this.b = +n)) : arguments.length < 2 ? t instanceof xt ? new xt(t.l, t.a, t.b) : t instanceof yt ? bt(t.h, t.c, t.l) : zt((t = Ct(t)).r, t.g, t.b) : new xt(t, e, n) }

        function wt(t, e, n) {
            var i = (t + 16) / 116,
                r = i + e / 500,
                o = i - n / 200;
            return r = St(r) * us, i = St(i) * cs, o = St(o) * ds, new Ct(Tt(3.2404542 * r - 1.5371385 * i - .4985314 * o), Tt(-.969266 * r + 1.8760108 * i + .041556 * o), Tt(.0556434 * r - .2040259 * i + 1.0572252 * o))
        }

        function kt(t, e, n) { return t > 0 ? new yt(Math.atan2(n, e) * Qa, Math.sqrt(e * e + n * n), t) : new yt(NaN, NaN, t) }

        function St(t) { return t > .206893034 ? t * t * t : (t - 4 / 29) / 7.787037 }

        function _t(t) { return t > .008856 ? Math.pow(t, 1 / 3) : 7.787037 * t + 4 / 29 }

        function Tt(t) { return Math.round(255 * (t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055)) }

        function Ct(t, e, n) { return this instanceof Ct ? (this.r = ~~t, this.g = ~~e, void(this.b = ~~n)) : arguments.length < 2 ? t instanceof Ct ? new Ct(t.r, t.g, t.b) : Pt("" + t, Ct, mt) : new Ct(t, e, n) }

        function Mt(t) { return new Ct(t >> 16, t >> 8 & 255, 255 & t) }

        function At(t) { return Mt(t) + "" }

        function Et(t) { return t < 16 ? "0" + Math.max(0, t).toString(16) : Math.min(255, t).toString(16) }

        function Pt(t, e, n) {
            var i, r, o, a = 0,
                s = 0,
                l = 0;
            if (i = /([a-z]+)\((.*)\)/.exec(t = t.toLowerCase())) switch (r = i[2].split(","), i[1]) {
                case "hsl":
                    return n(parseFloat(r[0]), parseFloat(r[1]) / 100, parseFloat(r[2]) / 100);
                case "rgb":
                    return e(Ot(r[0]), Ot(r[1]), Ot(r[2]))
            }
            return (o = ps.get(t)) ? e(o.r, o.g, o.b) : (null == t || "#" !== t.charAt(0) || isNaN(o = parseInt(t.slice(1), 16)) || (4 === t.length ? (a = (3840 & o) >> 4, a = a >> 4 | a, s = 240 & o, s = s >> 4 | s, l = 15 & o, l = l << 4 | l) : 7 === t.length && (a = (16711680 & o) >> 16, s = (65280 & o) >> 8, l = 255 & o)), e(a, s, l))
        }

        function It(t, e, n) {
            var i, r, o = Math.min(t /= 255, e /= 255, n /= 255),
                a = Math.max(t, e, n),
                s = a - o,
                l = (a + o) / 2;
            return s ? (r = l < .5 ? s / (a + o) : s / (2 - a - o), i = t == a ? (e - n) / s + (e < n ? 6 : 0) : e == a ? (n - t) / s + 2 : (t - e) / s + 4, i *= 60) : (i = NaN, r = l > 0 && l < 1 ? 0 : i), new vt(i, r, l)
        }

        function zt(t, e, n) {
            t = Dt(t), e = Dt(e), n = Dt(n);
            var i = _t((.4124564 * t + .3575761 * e + .1804375 * n) / us),
                r = _t((.2126729 * t + .7151522 * e + .072175 * n) / cs),
                o = _t((.0193339 * t + .119192 * e + .9503041 * n) / ds);
            return xt(116 * r - 16, 500 * (i - r), 200 * (r - o))
        }

        function Dt(t) { return (t /= 255) <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4) }

        function Ot(t) { var e = parseFloat(t); return "%" === t.charAt(t.length - 1) ? Math.round(2.55 * e) : e }

        function Lt(t) { return "function" == typeof t ? t : function() { return t } }

        function $t(t) { return function(e, n, i) { return 2 === arguments.length && "function" == typeof n && (i = n, n = null), Nt(e, n, t, i) } }

        function Nt(t, e, n, i) {
            function r() { var t, e = l.status; if (!e && qt(l) || e >= 200 && e < 300 || 304 === e) { try { t = n.call(o, l) } catch (i) { return void a.error.call(o, i) } a.load.call(o, t) } else a.error.call(o, l) }
            var o = {},
                a = ma.dispatch("beforesend", "progress", "load", "error"),
                s = {},
                l = new XMLHttpRequest,
                u = null;
            return !this.XDomainRequest || "withCredentials" in l || !/^(http(s)?:)?\/\//.test(t) || (l = new XDomainRequest), "onload" in l ? l.onload = l.onerror = r : l.onreadystatechange = function() { l.readyState > 3 && r() }, l.onprogress = function(t) {
                var e = ma.event;
                ma.event = t;
                try { a.progress.call(o, l) } finally { ma.event = e }
            }, o.header = function(t, e) { return t = (t + "").toLowerCase(), arguments.length < 2 ? s[t] : (null == e ? delete s[t] : s[t] = e + "", o) }, o.mimeType = function(t) { return arguments.length ? (e = null == t ? null : t + "", o) : e }, o.responseType = function(t) { return arguments.length ? (u = t, o) : u }, o.response = function(t) { return n = t, o }, ["get", "post"].forEach(function(t) { o[t] = function() { return o.send.apply(o, [t].concat(ba(arguments))) } }), o.send = function(n, i, r) {
                if (2 === arguments.length && "function" == typeof i && (r = i, i = null), l.open(n, t, !0), null == e || "accept" in s || (s.accept = e + ",*/*"), l.setRequestHeader)
                    for (var c in s) l.setRequestHeader(c, s[c]);
                return null != e && l.overrideMimeType && l.overrideMimeType(e), null != u && (l.responseType = u), null != r && o.on("error", r).on("load", function(t) { r(null, t) }), a.beforesend.call(o, l), l.send(null == i ? null : i), o
            }, o.abort = function() { return l.abort(), o }, ma.rebind(o, a, "on"), null == i ? o : o.get(Rt(i))
        }

        function Rt(t) { return 1 === t.length ? function(e, n) { t(null == e ? n : null) } : t }

        function qt(t) { var e = t.responseType; return e && "text" !== e ? t.response : t.responseText }

        function Ft(t, e, n) {
            var i = arguments.length;
            i < 2 && (e = 0), i < 3 && (n = Date.now());
            var r = n + e,
                o = { c: t, t: r, n: null };
            return vs ? vs.n = o : gs = o, vs = o, ms || (ys = clearTimeout(ys), ms = 1, bs(Ht)), o
        }

        function Ht() {
            var t = Bt(),
                e = Wt() - t;
            e > 24 ? (isFinite(e) && (clearTimeout(ys), ys = setTimeout(Ht, e)), ms = 0) : (ms = 1, bs(Ht))
        }

        function Bt() { for (var t = Date.now(), e = gs; e;) t >= e.t && e.c(t - e.t) && (e.c = null), e = e.n; return t }

        function Wt() { for (var t, e = gs, n = 1 / 0; e;) e.c ? (e.t < n && (n = e.t), e = (t = e).n) : e = t ? t.n = e.n : gs = e.n; return vs = t, n }

        function jt(t, e) { return e - (t ? Math.ceil(Math.log(t) / Math.LN10) : 1) }

        function Yt(t, e) { var n = Math.pow(10, 3 * Ea(8 - e)); return { scale: e > 8 ? function(t) { return t / n } : function(t) { return t * n }, symbol: t } }

        function Ut(t) {
            var e = t.decimal,
                n = t.thousands,
                i = t.grouping,
                r = t.currency,
                o = i && n ? function(t, e) { for (var r = t.length, o = [], a = 0, s = i[0], l = 0; r > 0 && s > 0 && (l + s + 1 > e && (s = Math.max(1, e - l)), o.push(t.substring(r -= s, r + s)), !((l += s + 1) > e));) s = i[a = (a + 1) % i.length]; return o.reverse().join(n) } : M;
            return function(t) {
                var n = ws.exec(t),
                    i = n[1] || " ",
                    a = n[2] || ">",
                    s = n[3] || "-",
                    l = n[4] || "",
                    u = n[5],
                    c = +n[6],
                    d = n[7],
                    h = n[8],
                    f = n[9],
                    p = 1,
                    g = "",
                    v = "",
                    m = !1,
                    y = !0;
                switch (h && (h = +h.substring(1)), (u || "0" === i && "=" === a) && (u = i = "0", a = "="), f) {
                    case "n":
                        d = !0, f = "g";
                        break;
                    case "%":
                        p = 100, v = "%", f = "f";
                        break;
                    case "p":
                        p = 100, v = "%", f = "r";
                        break;
                    case "b":
                    case "o":
                    case "x":
                    case "X":
                        "#" === l && (g = "0" + f.toLowerCase());
                    case "c":
                        y = !1;
                    case "d":
                        m = !0, h = 0;
                        break;
                    case "s":
                        p = -1, f = "r"
                }
                "$" === l && (g = r[0], v = r[1]), "r" != f || h || (f = "g"), null != h && ("g" == f ? h = Math.max(1, Math.min(21, h)) : "e" != f && "f" != f || (h = Math.max(0, Math.min(20, h)))), f = ks.get(f) || Vt;
                var b = u && d;
                return function(t) {
                    var n = v;
                    if (m && t % 1) return "";
                    var r = t < 0 || 0 === t && 1 / t < 0 ? (t = -t, "-") : "-" === s ? "" : s;
                    if (p < 0) {
                        var l = ma.formatPrefix(t, h);
                        t = l.scale(t), n = l.symbol + v
                    } else t *= p;
                    t = f(t, h);
                    var x, w, k = t.lastIndexOf(".");
                    if (k < 0) {
                        var S = y ? t.lastIndexOf("e") : -1;
                        S < 0 ? (x = t, w = "") : (x = t.substring(0, S), w = t.substring(S))
                    } else x = t.substring(0, k), w = e + t.substring(k + 1);
                    !u && d && (x = o(x, 1 / 0));
                    var _ = g.length + x.length + w.length + (b ? 0 : r.length),
                        T = _ < c ? new Array(_ = c - _ + 1).join(i) : "";
                    return b && (x = o(T + x, T.length ? c - w.length : 1 / 0)), r += g, t = x + w, ("<" === a ? r + t + T : ">" === a ? T + r + t : "^" === a ? T.substring(0, _ >>= 1) + r + t + T.substring(_) : r + (b ? t : T + t)) + n
                }
            }
        }

        function Vt(t) { return t + "" }

        function Xt() { this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]) }

        function Zt(t, e, n) {
            function i(e) {
                var n = t(e),
                    i = o(n, 1);
                return e - n < i - e ? n : i
            }

            function r(n) { return e(n = t(new _s(n - 1)), 1), n }

            function o(t, n) { return e(t = new _s((+t)), n), t }

            function a(t, i, o) {
                var a = r(t),
                    s = [];
                if (o > 1)
                    for (; a < i;) n(a) % o || s.push(new Date((+a))), e(a, 1);
                else
                    for (; a < i;) s.push(new Date((+a))), e(a, 1);
                return s
            }

            function s(t, e, n) { try { _s = Xt; var i = new Xt; return i._ = t, a(i, e, n) } finally { _s = Date } } t.floor = t, t.round = i, t.ceil = r, t.offset = o, t.range = a;
            var l = t.utc = Kt(t);
            return l.floor = l, l.round = Kt(i), l.ceil = Kt(r), l.offset = Kt(o), l.range = s, t
        }

        function Kt(t) { return function(e, n) { try { _s = Xt; var i = new Xt; return i._ = e, t(i, n)._ } finally { _s = Date } } }

        function Gt(t) {
            function e(t) {
                function e(e) { for (var n, r, o, a = [], s = -1, l = 0; ++s < i;) 37 === t.charCodeAt(s) && (a.push(t.slice(l, s)), null != (r = Cs[n = t.charAt(++s)]) && (n = t.charAt(++s)), (o = A[n]) && (n = o(e, null == r ? "e" === n ? " " : "0" : r)), a.push(n), l = s + 1); return a.push(t.slice(l, s)), a.join("") }
                var i = t.length;
                return e.parse = function(e) {
                    var i = { y: 1900, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0, Z: null },
                        r = n(i, t, e, 0);
                    if (r != e.length) return null;
                    "p" in i && (i.H = i.H % 12 + 12 * i.p);
                    var o = null != i.Z && _s !== Xt,
                        a = new(o ? Xt : _s);
                    return "j" in i ? a.setFullYear(i.y, 0, i.j) : "W" in i || "U" in i ? ("w" in i || (i.w = "W" in i ? 1 : 0), a.setFullYear(i.y, 0, 1), a.setFullYear(i.y, 0, "W" in i ? (i.w + 6) % 7 + 7 * i.W - (a.getDay() + 5) % 7 : i.w + 7 * i.U - (a.getDay() + 6) % 7)) : a.setFullYear(i.y, i.m, i.d), a.setHours(i.H + (i.Z / 100 | 0), i.M + i.Z % 100, i.S, i.L), o ? a._ : a
                }, e.toString = function() { return t }, e
            }

            function n(t, e, n, i) { for (var r, o, a, s = 0, l = e.length, u = n.length; s < l;) { if (i >= u) return -1; if (r = e.charCodeAt(s++), 37 === r) { if (a = e.charAt(s++), o = E[a in Cs ? e.charAt(s++) : a], !o || (i = o(t, n, i)) < 0) return -1 } else if (r != n.charCodeAt(i++)) return -1 } return i }

            function i(t, e, n) { k.lastIndex = 0; var i = k.exec(e.slice(n)); return i ? (t.w = S.get(i[0].toLowerCase()), n + i[0].length) : -1 }

            function r(t, e, n) { x.lastIndex = 0; var i = x.exec(e.slice(n)); return i ? (t.w = w.get(i[0].toLowerCase()), n + i[0].length) : -1 }

            function o(t, e, n) { C.lastIndex = 0; var i = C.exec(e.slice(n)); return i ? (t.m = M.get(i[0].toLowerCase()), n + i[0].length) : -1 }

            function a(t, e, n) { _.lastIndex = 0; var i = _.exec(e.slice(n)); return i ? (t.m = T.get(i[0].toLowerCase()), n + i[0].length) : -1 }

            function s(t, e, i) { return n(t, A.c.toString(), e, i) }

            function l(t, e, i) { return n(t, A.x.toString(), e, i) }

            function u(t, e, i) { return n(t, A.X.toString(), e, i) }

            function c(t, e, n) { var i = b.get(e.slice(n, n += 2).toLowerCase()); return null == i ? -1 : (t.p = i, n) }
            var d = t.dateTime,
                h = t.date,
                f = t.time,
                p = t.periods,
                g = t.days,
                v = t.shortDays,
                m = t.months,
                y = t.shortMonths;
            e.utc = function(t) {
                function n(t) { try { _s = Xt; var e = new _s; return e._ = t, i(e) } finally { _s = Date } }
                var i = e(t);
                return n.parse = function(t) { try { _s = Xt; var e = i.parse(t); return e && e._ } finally { _s = Date } }, n.toString = i.toString, n
            }, e.multi = e.utc.multi = me;
            var b = ma.map(),
                x = Qt(g),
                w = te(g),
                k = Qt(v),
                S = te(v),
                _ = Qt(m),
                T = te(m),
                C = Qt(y),
                M = te(y);
            p.forEach(function(t, e) { b.set(t.toLowerCase(), e) });
            var A = { a: function(t) { return v[t.getDay()] }, A: function(t) { return g[t.getDay()] }, b: function(t) { return y[t.getMonth()] }, B: function(t) { return m[t.getMonth()] }, c: e(d), d: function(t, e) { return Jt(t.getDate(), e, 2) }, e: function(t, e) { return Jt(t.getDate(), e, 2) }, H: function(t, e) { return Jt(t.getHours(), e, 2) }, I: function(t, e) { return Jt(t.getHours() % 12 || 12, e, 2) }, j: function(t, e) { return Jt(1 + Ss.dayOfYear(t), e, 3) }, L: function(t, e) { return Jt(t.getMilliseconds(), e, 3) }, m: function(t, e) { return Jt(t.getMonth() + 1, e, 2) }, M: function(t, e) { return Jt(t.getMinutes(), e, 2) }, p: function(t) { return p[+(t.getHours() >= 12)] }, S: function(t, e) { return Jt(t.getSeconds(), e, 2) }, U: function(t, e) { return Jt(Ss.sundayOfYear(t), e, 2) }, w: function(t) { return t.getDay() }, W: function(t, e) { return Jt(Ss.mondayOfYear(t), e, 2) }, x: e(h), X: e(f), y: function(t, e) { return Jt(t.getFullYear() % 100, e, 2) }, Y: function(t, e) { return Jt(t.getFullYear() % 1e4, e, 4) }, Z: ge, "%": function() { return "%" } },
                E = { a: i, A: r, b: o, B: a, c: s, d: ue, e: ue, H: de, I: de, j: ce, L: pe, m: le, M: he, p: c, S: fe, U: ne, w: ee, W: ie, x: l, X: u, y: oe, Y: re, Z: ae, "%": ve };
            return e
        }

        function Jt(t, e, n) {
            var i = t < 0 ? "-" : "",
                r = (i ? -t : t) + "",
                o = r.length;
            return i + (o < n ? new Array(n - o + 1).join(e) + r : r)
        }

        function Qt(t) { return new RegExp("^(?:" + t.map(ma.requote).join("|") + ")", "i") }

        function te(t) { for (var e = new y, n = -1, i = t.length; ++n < i;) e.set(t[n].toLowerCase(), n); return e }

        function ee(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 1)); return i ? (t.w = +i[0], n + i[0].length) : -1 }

        function ne(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n)); return i ? (t.U = +i[0], n + i[0].length) : -1 }

        function ie(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n)); return i ? (t.W = +i[0], n + i[0].length) : -1 }

        function re(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 4)); return i ? (t.y = +i[0], n + i[0].length) : -1 }

        function oe(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.y = se(+i[0]), n + i[0].length) : -1 }

        function ae(t, e, n) { return /^[+-]\d{4}$/.test(e = e.slice(n, n + 5)) ? (t.Z = -e, n + 5) : -1 }

        function se(t) { return t + (t > 68 ? 1900 : 2e3) }

        function le(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.m = i[0] - 1, n + i[0].length) : -1 }

        function ue(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.d = +i[0], n + i[0].length) : -1 }

        function ce(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 3)); return i ? (t.j = +i[0], n + i[0].length) : -1 }

        function de(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.H = +i[0], n + i[0].length) : -1 }

        function he(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.M = +i[0], n + i[0].length) : -1 }

        function fe(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 2)); return i ? (t.S = +i[0], n + i[0].length) : -1 }

        function pe(t, e, n) { Ms.lastIndex = 0; var i = Ms.exec(e.slice(n, n + 3)); return i ? (t.L = +i[0], n + i[0].length) : -1 }

        function ge(t) {
            var e = t.getTimezoneOffset(),
                n = e > 0 ? "-" : "+",
                i = Ea(e) / 60 | 0,
                r = Ea(e) % 60;
            return n + Jt(i, "0", 2) + Jt(r, "0", 2)
        }

        function ve(t, e, n) { As.lastIndex = 0; var i = As.exec(e.slice(n, n + 1)); return i ? n + i[0].length : -1 }

        function me(t) { for (var e = t.length, n = -1; ++n < e;) t[n][0] = this(t[n][0]); return function(e) { for (var n = 0, i = t[n]; !i[1](e);) i = t[++n]; return i[0](e) } }

        function ye() {}

        function be(t, e, n) {
            var i = n.s = t + e,
                r = i - t,
                o = i - r;
            n.t = t - o + (e - r)
        }

        function xe(t, e) { t && zs.hasOwnProperty(t.type) && zs[t.type](t, e) }

        function we(t, e, n) {
            var i, r = -1,
                o = t.length - n;
            for (e.lineStart(); ++r < o;) i = t[r], e.point(i[0], i[1], i[2]);
            e.lineEnd()
        }

        function ke(t, e) {
            var n = -1,
                i = t.length;
            for (e.polygonStart(); ++n < i;) we(t[n], e, 1);
            e.polygonEnd()
        }

        function Se() {
            function t(t, e) {
                t *= Ja, e = e * Ja / 2 + Xa / 4;
                var n = t - i,
                    a = n >= 0 ? 1 : -1,
                    s = a * n,
                    l = Math.cos(e),
                    u = Math.sin(e),
                    c = o * u,
                    d = r * l + c * Math.cos(s),
                    h = c * a * Math.sin(s);
                Os.add(Math.atan2(h, d)), i = t, r = l, o = u
            }
            var e, n, i, r, o;
            Ls.point = function(a, s) { Ls.point = t, i = (e = a) * Ja, r = Math.cos(s = (n = s) * Ja / 2 + Xa / 4), o = Math.sin(s) }, Ls.lineEnd = function() { t(e, n) }
        }

        function _e(t) {
            var e = t[0],
                n = t[1],
                i = Math.cos(n);
            return [i * Math.cos(e), i * Math.sin(e), Math.sin(n)]
        }

        function Te(t, e) { return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] }

        function Ce(t, e) { return [t[1] * e[2] - t[2] * e[1], t[2] * e[0] - t[0] * e[2], t[0] * e[1] - t[1] * e[0]] }

        function Me(t, e) { t[0] += e[0], t[1] += e[1], t[2] += e[2] }

        function Ae(t, e) { return [t[0] * e, t[1] * e, t[2] * e] }

        function Ee(t) {
            var e = Math.sqrt(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
            t[0] /= e, t[1] /= e, t[2] /= e
        }

        function Pe(t) { return [Math.atan2(t[1], t[0]), ct(t[2])] }

        function Ie(t, e) { return Ea(t[0] - e[0]) < Ua && Ea(t[1] - e[1]) < Ua }

        function ze(t, e) {
            t *= Ja;
            var n = Math.cos(e *= Ja);
            De(n * Math.cos(t), n * Math.sin(t), Math.sin(e))
        }

        function De(t, e, n) {++$s, Rs += (t - Rs) / $s, qs += (e - qs) / $s, Fs += (n - Fs) / $s }

        function Oe() {
            function t(t, r) {
                t *= Ja;
                var o = Math.cos(r *= Ja),
                    a = o * Math.cos(t),
                    s = o * Math.sin(t),
                    l = Math.sin(r),
                    u = Math.atan2(Math.sqrt((u = n * l - i * s) * u + (u = i * a - e * l) * u + (u = e * s - n * a) * u), e * a + n * s + i * l);
                Ns += u, Hs += u * (e + (e = a)), Bs += u * (n + (n = s)), Ws += u * (i + (i = l)), De(e, n, i)
            }
            var e, n, i;
            Vs.point = function(r, o) {
                r *= Ja;
                var a = Math.cos(o *= Ja);
                e = a * Math.cos(r), n = a * Math.sin(r), i = Math.sin(o), Vs.point = t, De(e, n, i)
            }
        }

        function Le() { Vs.point = ze }

        function $e() {
            function t(t, e) {
                t *= Ja;
                var n = Math.cos(e *= Ja),
                    a = n * Math.cos(t),
                    s = n * Math.sin(t),
                    l = Math.sin(e),
                    u = r * l - o * s,
                    c = o * a - i * l,
                    d = i * s - r * a,
                    h = Math.sqrt(u * u + c * c + d * d),
                    f = i * a + r * s + o * l,
                    p = h && -ut(f) / h,
                    g = Math.atan2(h, f);
                js += p * u, Ys += p * c, Us += p * d, Ns += g, Hs += g * (i + (i = a)), Bs += g * (r + (r = s)), Ws += g * (o + (o = l)), De(i, r, o)
            }
            var e, n, i, r, o;
            Vs.point = function(a, s) {
                e = a, n = s, Vs.point = t, a *= Ja;
                var l = Math.cos(s *= Ja);
                i = l * Math.cos(a), r = l * Math.sin(a), o = Math.sin(s), De(i, r, o)
            }, Vs.lineEnd = function() { t(e, n), Vs.lineEnd = Le, Vs.point = ze }
        }

        function Ne(t, e) {
            function n(n, i) { return n = t(n, i), e(n[0], n[1]) }
            return t.invert && e.invert && (n.invert = function(n, i) { return n = e.invert(n, i), n && t.invert(n[0], n[1]) }), n
        }

        function Re() { return !0 }

        function qe(t, e, n, i, r) {
            var o = [],
                a = [];
            if (t.forEach(function(t) {
                    if (!((e = t.length - 1) <= 0)) {
                        var e, n = t[0],
                            i = t[e];
                        if (Ie(n, i)) { r.lineStart(); for (var s = 0; s < e; ++s) r.point((n = t[s])[0], n[1]); return void r.lineEnd() }
                        var l = new He(n, t, null, (!0)),
                            u = new He(n, null, l, (!1));
                        l.o = u, o.push(l), a.push(u), l = new He(i, t, null, (!1)), u = new He(i, null, l, (!0)), l.o = u, o.push(l), a.push(u)
                    }
                }), a.sort(e), Fe(o), Fe(a), o.length) {
                for (var s = 0, l = n, u = a.length; s < u; ++s) a[s].e = l = !l;
                for (var c, d, h = o[0];;) {
                    for (var f = h, p = !0; f.v;)
                        if ((f = f.n) === h) return;
                    c = f.z, r.lineStart();
                    do {
                        if (f.v = f.o.v = !0, f.e) {
                            if (p)
                                for (var s = 0, u = c.length; s < u; ++s) r.point((d = c[s])[0], d[1]);
                            else i(f.x, f.n.x, 1, r);
                            f = f.n
                        } else {
                            if (p) { c = f.p.z; for (var s = c.length - 1; s >= 0; --s) r.point((d = c[s])[0], d[1]) } else i(f.x, f.p.x, -1, r);
                            f = f.p
                        }
                        f = f.o, c = f.z, p = !p
                    } while (!f.v);
                    r.lineEnd()
                }
            }
        }

        function Fe(t) {
            if (e = t.length) {
                for (var e, n, i = 0, r = t[0]; ++i < e;) r.n = n = t[i], n.p = r, r = n;
                r.n = n = t[0], n.p = r
            }
        }

        function He(t, e, n, i) { this.x = t, this.z = e, this.o = n, this.e = i, this.v = !1, this.n = this.p = null }

        function Be(t, e, n, i) {
            return function(r, o) {
                function a(e, n) {
                    var i = r(e, n);
                    t(e = i[0], n = i[1]) && o.point(e, n)
                }

                function s(t, e) {
                    var n = r(t, e);
                    v.point(n[0], n[1])
                }

                function l() { y.point = s, v.lineStart() }

                function u() { y.point = a, v.lineEnd() }

                function c(t, e) {
                    g.push([t, e]);
                    var n = r(t, e);
                    x.point(n[0], n[1])
                }

                function d() { x.lineStart(), g = [] }

                function h() {
                    c(g[0][0], g[0][1]), x.lineEnd();
                    var t, e = x.clean(),
                        n = b.buffer(),
                        i = n.length;
                    if (g.pop(), p.push(g), g = null, i)
                        if (1 & e) {
                            t = n[0];
                            var r, i = t.length - 1,
                                a = -1;
                            if (i > 0) {
                                for (w || (o.polygonStart(), w = !0), o.lineStart(); ++a < i;) o.point((r = t[a])[0], r[1]);
                                o.lineEnd()
                            }
                        } else i > 1 && 2 & e && n.push(n.pop().concat(n.shift())), f.push(n.filter(We))
                }
                var f, p, g, v = e(o),
                    m = r.invert(i[0], i[1]),
                    y = {
                        point: a,
                        lineStart: l,
                        lineEnd: u,
                        polygonStart: function() { y.point = c, y.lineStart = d, y.lineEnd = h, f = [], p = [] },
                        polygonEnd: function() {
                            y.point = a, y.lineStart = l, y.lineEnd = u, f = ma.merge(f);
                            var t = Ze(m, p);
                            f.length ? (w || (o.polygonStart(), w = !0), qe(f, Ye, t, n, o)) : t && (w || (o.polygonStart(), w = !0), o.lineStart(), n(null, null, 1, o), o.lineEnd()), w && (o.polygonEnd(), w = !1), f = p = null
                        },
                        sphere: function() { o.polygonStart(), o.lineStart(), n(null, null, 1, o), o.lineEnd(), o.polygonEnd() }
                    },
                    b = je(),
                    x = e(b),
                    w = !1;
                return y
            }
        }

        function We(t) { return t.length > 1 }

        function je() { var t, e = []; return { lineStart: function() { e.push(t = []) }, point: function(e, n) { t.push([e, n]) }, lineEnd: P, buffer: function n() { var n = e; return e = [], t = null, n }, rejoin: function() { e.length > 1 && e.push(e.pop().concat(e.shift())) } } }

        function Ye(t, e) { return ((t = t.x)[0] < 0 ? t[1] - Ga - Ua : Ga - t[1]) - ((e = e.x)[0] < 0 ? e[1] - Ga - Ua : Ga - e[1]) }

        function Ue(t) {
            var e, n = NaN,
                i = NaN,
                r = NaN;
            return {
                lineStart: function() { t.lineStart(), e = 1 },
                point: function(o, a) {
                    var s = o > 0 ? Xa : -Xa,
                        l = Ea(o - n);
                    Ea(l - Xa) < Ua ? (t.point(n, i = (i + a) / 2 > 0 ? Ga : -Ga), t.point(r, i), t.lineEnd(), t.lineStart(), t.point(s, i), t.point(o, i), e = 0) : r !== s && l >= Xa && (Ea(n - r) < Ua && (n -= r * Ua), Ea(o - s) < Ua && (o -= s * Ua), i = Ve(n, i, o, a), t.point(r, i), t.lineEnd(), t.lineStart(), t.point(s, i), e = 0), t.point(n = o, i = a), r = s
                },
                lineEnd: function() { t.lineEnd(), n = i = NaN },
                clean: function() { return 2 - e }
            }
        }

        function Ve(t, e, n, i) { var r, o, a = Math.sin(t - n); return Ea(a) > Ua ? Math.atan((Math.sin(e) * (o = Math.cos(i)) * Math.sin(n) - Math.sin(i) * (r = Math.cos(e)) * Math.sin(t)) / (r * o * a)) : (e + i) / 2 }

        function Xe(t, e, n, i) {
            var r;
            if (null == t) r = n * Ga, i.point(-Xa, r), i.point(0, r), i.point(Xa, r), i.point(Xa, 0), i.point(Xa, -r), i.point(0, -r), i.point(-Xa, -r), i.point(-Xa, 0), i.point(-Xa, r);
            else if (Ea(t[0] - e[0]) > Ua) {
                var o = t[0] < e[0] ? Xa : -Xa;
                r = n * o / 2, i.point(-o, r), i.point(0, r), i.point(o, r)
            } else i.point(e[0], e[1])
        }

        function Ze(t, e) {
            var n = t[0],
                i = t[1],
                r = [Math.sin(n), -Math.cos(n), 0],
                o = 0,
                a = 0;
            Os.reset();
            for (var s = 0, l = e.length; s < l; ++s) {
                var u = e[s],
                    c = u.length;
                if (c)
                    for (var d = u[0], h = d[0], f = d[1] / 2 + Xa / 4, p = Math.sin(f), g = Math.cos(f), v = 1;;) {
                        v === c && (v = 0), t = u[v];
                        var m = t[0],
                            y = t[1] / 2 + Xa / 4,
                            b = Math.sin(y),
                            x = Math.cos(y),
                            w = m - h,
                            k = w >= 0 ? 1 : -1,
                            S = k * w,
                            _ = S > Xa,
                            T = p * b;
                        if (Os.add(Math.atan2(T * k * Math.sin(S), g * x + T * Math.cos(S))), o += _ ? w + k * Za : w, _ ^ h >= n ^ m >= n) {
                            var C = Ce(_e(d), _e(t));
                            Ee(C);
                            var M = Ce(r, C);
                            Ee(M);
                            var A = (_ ^ w >= 0 ? -1 : 1) * ct(M[2]);
                            (i > A || i === A && (C[0] || C[1])) && (a += _ ^ w >= 0 ? 1 : -1)
                        }
                        if (!v++) break;
                        h = m, p = b, g = x, d = t
                    }
            }
            return (o < -Ua || o < Ua && Os < -Ua) ^ 1 & a
        }

        function Ke(t) {
            function e(t, e) { return Math.cos(t) * Math.cos(e) > o }

            function n(t) {
                var n, o, l, u, c;
                return {
                    lineStart: function() { u = l = !1, c = 1 },
                    point: function(d, h) {
                        var f, p = [d, h],
                            g = e(d, h),
                            v = a ? g ? 0 : r(d, h) : g ? r(d + (d < 0 ? Xa : -Xa), h) : 0;
                        if (!n && (u = l = g) && t.lineStart(), g !== l && (f = i(n, p), (Ie(n, f) || Ie(p, f)) && (p[0] += Ua, p[1] += Ua, g = e(p[0], p[1]))), g !== l) c = 0, g ? (t.lineStart(), f = i(p, n), t.point(f[0], f[1])) : (f = i(n, p), t.point(f[0], f[1]), t.lineEnd()), n = f;
                        else if (s && n && a ^ g) {
                            var m;
                            v & o || !(m = i(p, n, !0)) || (c = 0, a ? (t.lineStart(), t.point(m[0][0], m[0][1]), t.point(m[1][0], m[1][1]), t.lineEnd()) : (t.point(m[1][0], m[1][1]), t.lineEnd(), t.lineStart(), t.point(m[0][0], m[0][1])))
                        }!g || n && Ie(n, p) || t.point(p[0], p[1]), n = p, l = g, o = v
                    },
                    lineEnd: function() { l && t.lineEnd(), n = null },
                    clean: function() { return c | (u && l) << 1 }
                }
            }

            function i(t, e, n) {
                var i = _e(t),
                    r = _e(e),
                    a = [1, 0, 0],
                    s = Ce(i, r),
                    l = Te(s, s),
                    u = s[0],
                    c = l - u * u;
                if (!c) return !n && t;
                var d = o * l / c,
                    h = -o * u / c,
                    f = Ce(a, s),
                    p = Ae(a, d),
                    g = Ae(s, h);
                Me(p, g);
                var v = f,
                    m = Te(p, v),
                    y = Te(v, v),
                    b = m * m - y * (Te(p, p) - 1);
                if (!(b < 0)) {
                    var x = Math.sqrt(b),
                        w = Ae(v, (-m - x) / y);
                    if (Me(w, p), w = Pe(w), !n) return w;
                    var k, S = t[0],
                        _ = e[0],
                        T = t[1],
                        C = e[1];
                    _ < S && (k = S, S = _, _ = k);
                    var M = _ - S,
                        A = Ea(M - Xa) < Ua,
                        E = A || M < Ua;
                    if (!A && C < T && (k = T, T = C, C = k), E ? A ? T + C > 0 ^ w[1] < (Ea(w[0] - S) < Ua ? T : C) : T <= w[1] && w[1] <= C : M > Xa ^ (S <= w[0] && w[0] <= _)) { var P = Ae(v, (-m + x) / y); return Me(P, p), [w, Pe(P)] }
                }
            }

            function r(e, n) {
                var i = a ? t : Xa - t,
                    r = 0;
                return e < -i ? r |= 1 : e > i && (r |= 2), n < -i ? r |= 4 : n > i && (r |= 8), r
            }
            var o = Math.cos(t),
                a = o > 0,
                s = Ea(o) > Ua,
                l = _n(t, 6 * Ja);
            return Be(e, n, l, a ? [0, -t] : [-Xa, t - Xa])
        }

        function Ge(t, e, n, i) {
            return function(r) {
                var o, a = r.a,
                    s = r.b,
                    l = a.x,
                    u = a.y,
                    c = s.x,
                    d = s.y,
                    h = 0,
                    f = 1,
                    p = c - l,
                    g = d - u;
                if (o = t - l, p || !(o > 0)) {
                    if (o /= p, p < 0) {
                        if (o < h) return;
                        o < f && (f = o)
                    } else if (p > 0) {
                        if (o > f) return;
                        o > h && (h = o)
                    }
                    if (o = n - l, p || !(o < 0)) {
                        if (o /= p, p < 0) {
                            if (o > f) return;
                            o > h && (h = o)
                        } else if (p > 0) {
                            if (o < h) return;
                            o < f && (f = o)
                        }
                        if (o = e - u, g || !(o > 0)) {
                            if (o /= g, g < 0) {
                                if (o < h) return;
                                o < f && (f = o)
                            } else if (g > 0) {
                                if (o > f) return;
                                o > h && (h = o)
                            }
                            if (o = i - u, g || !(o < 0)) {
                                if (o /= g, g < 0) {
                                    if (o > f) return;
                                    o > h && (h = o)
                                } else if (g > 0) {
                                    if (o < h) return;
                                    o < f && (f = o)
                                }
                                return h > 0 && (r.a = { x: l + h * p, y: u + h * g }), f < 1 && (r.b = { x: l + f * p, y: u + f * g }), r
                            }
                        }
                    }
                }
            }
        }

        function Je(t, e, n, i) {
            function r(i, r) { return Ea(i[0] - t) < Ua ? r > 0 ? 0 : 3 : Ea(i[0] - n) < Ua ? r > 0 ? 2 : 1 : Ea(i[1] - e) < Ua ? r > 0 ? 1 : 0 : r > 0 ? 3 : 2 }

            function o(t, e) { return a(t.x, e.x) }

            function a(t, e) {
                var n = r(t, 1),
                    i = r(e, 1);
                return n !== i ? n - i : 0 === n ? e[1] - t[1] : 1 === n ? t[0] - e[0] : 2 === n ? t[1] - e[1] : e[0] - t[0]
            }
            return function(s) {
                function l(t) {
                    for (var e = 0, n = v.length, i = t[1], r = 0; r < n; ++r)
                        for (var o, a = 1, s = v[r], l = s.length, u = s[0]; a < l; ++a) o = s[a], u[1] <= i ? o[1] > i && lt(u, o, t) > 0 && ++e : o[1] <= i && lt(u, o, t) < 0 && --e, u = o;
                    return 0 !== e
                }

                function u(o, s, l, u) {
                    var c = 0,
                        d = 0;
                    if (null == o || (c = r(o, l)) !== (d = r(s, l)) || a(o, s) < 0 ^ l > 0) { do u.point(0 === c || 3 === c ? t : n, c > 1 ? i : e); while ((c = (c + l + 4) % 4) !== d) } else u.point(s[0], s[1])
                }

                function c(r, o) { return t <= r && r <= n && e <= o && o <= i }

                function d(t, e) { c(t, e) && s.point(t, e) }

                function h() { E.point = p, v && v.push(m = []), _ = !0, S = !1, w = k = NaN }

                function f() { g && (p(y, b), x && S && M.rejoin(), g.push(M.buffer())), E.point = d, S && s.lineEnd() }

                function p(t, e) {
                    t = Math.max(-Zs, Math.min(Zs, t)), e = Math.max(-Zs, Math.min(Zs, e));
                    var n = c(t, e);
                    if (v && m.push([t, e]), _) y = t, b = e, x = n, _ = !1, n && (s.lineStart(), s.point(t, e));
                    else if (n && S) s.point(t, e);
                    else {
                        var i = { a: { x: w, y: k }, b: { x: t, y: e } };
                        A(i) ? (S || (s.lineStart(), s.point(i.a.x, i.a.y)), s.point(i.b.x, i.b.y), n || s.lineEnd(), T = !1) : n && (s.lineStart(), s.point(t, e), T = !1)
                    }
                    w = t, k = e, S = n
                }
                var g, v, m, y, b, x, w, k, S, _, T, C = s,
                    M = je(),
                    A = Ge(t, e, n, i),
                    E = {
                        point: d,
                        lineStart: h,
                        lineEnd: f,
                        polygonStart: function() { s = M, g = [], v = [], T = !0 },
                        polygonEnd: function() {
                            s = C, g = ma.merge(g);
                            var e = l([t, i]),
                                n = T && e,
                                r = g.length;
                            (n || r) && (s.polygonStart(), n && (s.lineStart(), u(null, null, 1, s), s.lineEnd()), r && qe(g, o, e, u, s), s.polygonEnd()), g = v = m = null
                        }
                    };
                return E
            }
        }

        function Qe(t) {
            var e = 0,
                n = Xa / 3,
                i = vn(t),
                r = i(e, n);
            return r.parallels = function(t) { return arguments.length ? i(e = t[0] * Xa / 180, n = t[1] * Xa / 180) : [e / Xa * 180, n / Xa * 180] }, r
        }

        function tn(t, e) {
            function n(t, e) { var n = Math.sqrt(o - 2 * r * Math.sin(e)) / r; return [n * Math.sin(t *= r), a - n * Math.cos(t)] }
            var i = Math.sin(t),
                r = (i + Math.sin(e)) / 2,
                o = 1 + i * (2 * r - i),
                a = Math.sqrt(o) / r;
            return n.invert = function(t, e) { var n = a - e; return [Math.atan2(t, n) / r, ct((o - (t * t + n * n) * r * r) / (2 * r))] }, n
        }

        function en() {
            function t(t, e) { Gs += r * t - i * e, i = t, r = e }
            var e, n, i, r;
            nl.point = function(o, a) { nl.point = t, e = i = o, n = r = a }, nl.lineEnd = function() { t(e, n) }
        }

        function nn(t, e) { t < Js && (Js = t), t > tl && (tl = t), e < Qs && (Qs = e), e > el && (el = e) }

        function rn() {
            function t(t, e) { a.push("M", t, ",", e, o) }

            function e(t, e) { a.push("M", t, ",", e), s.point = n }

            function n(t, e) { a.push("L", t, ",", e) }

            function i() { s.point = t }

            function r() { a.push("Z") }
            var o = on(4.5),
                a = [],
                s = { point: t, lineStart: function() { s.point = e }, lineEnd: i, polygonStart: function() { s.lineEnd = r }, polygonEnd: function() { s.lineEnd = i, s.point = t }, pointRadius: function(t) { return o = on(t), s }, result: function l() { if (a.length) { var l = a.join(""); return a = [], l } } };
            return s
        }

        function on(t) { return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z" }

        function an(t, e) { Rs += t, qs += e, ++Fs }

        function sn() {
            function t(t, i) {
                var r = t - e,
                    o = i - n,
                    a = Math.sqrt(r * r + o * o);
                Hs += a * (e + t) / 2, Bs += a * (n + i) / 2, Ws += a, an(e = t, n = i)
            }
            var e, n;
            rl.point = function(i, r) { rl.point = t, an(e = i, n = r) }
        }

        function ln() { rl.point = an }

        function un() {
            function t(t, e) {
                var n = t - i,
                    o = e - r,
                    a = Math.sqrt(n * n + o * o);
                Hs += a * (i + t) / 2, Bs += a * (r + e) / 2, Ws += a, a = r * t - i * e, js += a * (i + t), Ys += a * (r + e), Us += 3 * a, an(i = t, r = e)
            }
            var e, n, i, r;
            rl.point = function(o, a) { rl.point = t, an(e = i = o, n = r = a) }, rl.lineEnd = function() { t(e, n) }
        }

        function cn(t) {
            function e(e, n) { t.moveTo(e + a, n), t.arc(e, n, a, 0, Za) }

            function n(e, n) { t.moveTo(e, n), s.point = i }

            function i(e, n) { t.lineTo(e, n) }

            function r() { s.point = e }

            function o() { t.closePath() }
            var a = 4.5,
                s = { point: e, lineStart: function() { s.point = n }, lineEnd: r, polygonStart: function() { s.lineEnd = o }, polygonEnd: function() { s.lineEnd = r, s.point = e }, pointRadius: function(t) { return a = t, s }, result: P };
            return s
        }

        function dn(t) {
            function e(t) { return (s ? i : n)(t) }

            function n(e) { return pn(e, function(n, i) { n = t(n, i), e.point(n[0], n[1]) }) }

            function i(e) {
                function n(n, i) { n = t(n, i), e.point(n[0], n[1]) }

                function i() { b = NaN, _.point = o, e.lineStart() }

                function o(n, i) {
                    var o = _e([n, i]),
                        a = t(n, i);
                    r(b, x, y, w, k, S, b = a[0], x = a[1], y = n, w = o[0], k = o[1], S = o[2], s, e), e.point(b, x)
                }

                function a() { _.point = n, e.lineEnd() }

                function l() { i(), _.point = u, _.lineEnd = c }

                function u(t, e) { o(d = t, h = e), f = b, p = x, g = w, v = k, m = S, _.point = o }

                function c() { r(b, x, y, w, k, S, f, p, d, g, v, m, s, e), _.lineEnd = a, a() }
                var d, h, f, p, g, v, m, y, b, x, w, k, S, _ = { point: n, lineStart: i, lineEnd: a, polygonStart: function() { e.polygonStart(), _.lineStart = l }, polygonEnd: function() { e.polygonEnd(), _.lineStart = i } };
                return _
            }

            function r(e, n, i, s, l, u, c, d, h, f, p, g, v, m) {
                var y = c - e,
                    b = d - n,
                    x = y * y + b * b;
                if (x > 4 * o && v--) {
                    var w = s + f,
                        k = l + p,
                        S = u + g,
                        _ = Math.sqrt(w * w + k * k + S * S),
                        T = Math.asin(S /= _),
                        C = Ea(Ea(S) - 1) < Ua || Ea(i - h) < Ua ? (i + h) / 2 : Math.atan2(k, w),
                        M = t(C, T),
                        A = M[0],
                        E = M[1],
                        P = A - e,
                        I = E - n,
                        z = b * P - y * I;
                    (z * z / x > o || Ea((y * P + b * I) / x - .5) > .3 || s * f + l * p + u * g < a) && (r(e, n, i, s, l, u, A, E, C, w /= _, k /= _, S, v, m), m.point(A, E), r(A, E, C, w, k, S, c, d, h, f, p, g, v, m))
                }
            }
            var o = .5,
                a = Math.cos(30 * Ja),
                s = 16;
            return e.precision = function(t) { return arguments.length ? (s = (o = t * t) > 0 && 16, e) : Math.sqrt(o) }, e
        }

        function hn(t) { var e = dn(function(e, n) { return t([e * Qa, n * Qa]) }); return function(t) { return mn(e(t)) } }

        function fn(t) { this.stream = t }

        function pn(t, e) { return { point: e, sphere: function() { t.sphere() }, lineStart: function() { t.lineStart() }, lineEnd: function() { t.lineEnd() }, polygonStart: function() { t.polygonStart() }, polygonEnd: function() { t.polygonEnd() } } }

        function gn(t) { return vn(function() { return t })() }

        function vn(t) {
            function e(t) { return t = s(t[0] * Ja, t[1] * Ja), [t[0] * h + l, u - t[1] * h] }

            function n(t) { return t = s.invert((t[0] - l) / h, (u - t[1]) / h), t && [t[0] * Qa, t[1] * Qa] }

            function i() { s = Ne(a = xn(m, y, b), o); var t = o(g, v); return l = f - t[0] * h, u = p + t[1] * h, r() }

            function r() { return c && (c.valid = !1, c = null), e }
            var o, a, s, l, u, c, d = dn(function(t, e) { return t = o(t, e), [t[0] * h + l, u - t[1] * h] }),
                h = 150,
                f = 480,
                p = 250,
                g = 0,
                v = 0,
                m = 0,
                y = 0,
                b = 0,
                x = Xs,
                w = M,
                k = null,
                S = null;
            return e.stream = function(t) { return c && (c.valid = !1), c = mn(x(a, d(w(t)))), c.valid = !0, c }, e.clipAngle = function(t) { return arguments.length ? (x = null == t ? (k = t, Xs) : Ke((k = +t) * Ja), r()) : k }, e.clipExtent = function(t) { return arguments.length ? (S = t, w = t ? Je(t[0][0], t[0][1], t[1][0], t[1][1]) : M, r()) : S }, e.scale = function(t) { return arguments.length ? (h = +t, i()) : h }, e.translate = function(t) { return arguments.length ? (f = +t[0], p = +t[1], i()) : [f, p] }, e.center = function(t) { return arguments.length ? (g = t[0] % 360 * Ja, v = t[1] % 360 * Ja, i()) : [g * Qa, v * Qa] }, e.rotate = function(t) { return arguments.length ? (m = t[0] % 360 * Ja, y = t[1] % 360 * Ja, b = t.length > 2 ? t[2] % 360 * Ja : 0, i()) : [m * Qa, y * Qa, b * Qa] }, ma.rebind(e, d, "precision"),
                function() { return o = t.apply(this, arguments), e.invert = o.invert && n, i() }
        }

        function mn(t) { return pn(t, function(e, n) { t.point(e * Ja, n * Ja) }) }

        function yn(t, e) { return [t, e] }

        function bn(t, e) { return [t > Xa ? t - Za : t < -Xa ? t + Za : t, e] }

        function xn(t, e, n) { return t ? e || n ? Ne(kn(t), Sn(e, n)) : kn(t) : e || n ? Sn(e, n) : bn }

        function wn(t) { return function(e, n) { return e += t, [e > Xa ? e - Za : e < -Xa ? e + Za : e, n] } }

        function kn(t) { var e = wn(t); return e.invert = wn(-t), e }

        function Sn(t, e) {
            function n(t, e) {
                var n = Math.cos(e),
                    s = Math.cos(t) * n,
                    l = Math.sin(t) * n,
                    u = Math.sin(e),
                    c = u * i + s * r;
                return [Math.atan2(l * o - c * a, s * i - u * r), ct(c * o + l * a)]
            }
            var i = Math.cos(t),
                r = Math.sin(t),
                o = Math.cos(e),
                a = Math.sin(e);
            return n.invert = function(t, e) {
                var n = Math.cos(e),
                    s = Math.cos(t) * n,
                    l = Math.sin(t) * n,
                    u = Math.sin(e),
                    c = u * o - l * a;
                return [Math.atan2(l * o + u * a, s * i + c * r), ct(c * i - s * r)]
            }, n
        }

        function _n(t, e) {
            var n = Math.cos(t),
                i = Math.sin(t);
            return function(r, o, a, s) {
                var l = a * e;
                null != r ? (r = Tn(n, r), o = Tn(n, o), (a > 0 ? r < o : r > o) && (r += a * Za)) : (r = t + a * Za, o = t - .5 * l);
                for (var u, c = r; a > 0 ? c > o : c < o; c -= l) s.point((u = Pe([n, -i * Math.cos(c), -i * Math.sin(c)]))[0], u[1])
            }
        }

        function Tn(t, e) {
            var n = _e(e);
            n[0] -= t, Ee(n);
            var i = ut(-n[1]);
            return ((-n[2] < 0 ? -i : i) + 2 * Math.PI - Ua) % (2 * Math.PI)
        }

        function Cn(t, e, n) { var i = ma.range(t, e - Ua, n).concat(e); return function(t) { return i.map(function(e) { return [t, e] }) } }

        function Mn(t, e, n) { var i = ma.range(t, e - Ua, n).concat(e); return function(t) { return i.map(function(e) { return [e, t] }) } }

        function An(t) { return t.source }

        function En(t) { return t.target }

        function Pn(t, e, n, i) {
            var r = Math.cos(e),
                o = Math.sin(e),
                a = Math.cos(i),
                s = Math.sin(i),
                l = r * Math.cos(t),
                u = r * Math.sin(t),
                c = a * Math.cos(n),
                d = a * Math.sin(n),
                h = 2 * Math.asin(Math.sqrt(pt(i - e) + r * a * pt(n - t))),
                f = 1 / Math.sin(h),
                p = h ? function(t) {
                    var e = Math.sin(t *= h) * f,
                        n = Math.sin(h - t) * f,
                        i = n * l + e * c,
                        r = n * u + e * d,
                        a = n * o + e * s;
                    return [Math.atan2(r, i) * Qa, Math.atan2(a, Math.sqrt(i * i + r * r)) * Qa]
                } : function() { return [t * Qa, e * Qa] };
            return p.distance = h, p
        }

        function In() {
            function t(t, r) {
                var o = Math.sin(r *= Ja),
                    a = Math.cos(r),
                    s = Ea((t *= Ja) - e),
                    l = Math.cos(s);
                ol += Math.atan2(Math.sqrt((s = a * Math.sin(s)) * s + (s = i * o - n * a * l) * s), n * o + i * a * l), e = t, n = o, i = a
            }
            var e, n, i;
            al.point = function(r, o) { e = r * Ja, n = Math.sin(o *= Ja), i = Math.cos(o), al.point = t }, al.lineEnd = function() { al.point = al.lineEnd = P }
        }

        function zn(t, e) {
            function n(e, n) {
                var i = Math.cos(e),
                    r = Math.cos(n),
                    o = t(i * r);
                return [o * r * Math.sin(e), o * Math.sin(n)]
            }
            return n.invert = function(t, n) {
                var i = Math.sqrt(t * t + n * n),
                    r = e(i),
                    o = Math.sin(r),
                    a = Math.cos(r);
                return [Math.atan2(t * o, i * a), Math.asin(i && n * o / i)]
            }, n
        }

        function Dn(t, e) {
            function n(t, e) { a > 0 ? e < -Ga + Ua && (e = -Ga + Ua) : e > Ga - Ua && (e = Ga - Ua); var n = a / Math.pow(r(e), o); return [n * Math.sin(o * t), a - n * Math.cos(o * t)] }
            var i = Math.cos(t),
                r = function(t) { return Math.tan(Xa / 4 + t / 2) },
                o = t === e ? Math.sin(t) : Math.log(i / Math.cos(e)) / Math.log(r(e) / r(t)),
                a = i * Math.pow(r(t), o) / o;
            return o ? (n.invert = function(t, e) {
                var n = a - e,
                    i = st(o) * Math.sqrt(t * t + n * n);
                return [Math.atan2(t, n) / o, 2 * Math.atan(Math.pow(a / i, 1 / o)) - Ga]
            }, n) : Ln
        }

        function On(t, e) {
            function n(t, e) { var n = o - e; return [n * Math.sin(r * t), o - n * Math.cos(r * t)] }
            var i = Math.cos(t),
                r = t === e ? Math.sin(t) : (i - Math.cos(e)) / (e - t),
                o = i / r + t;
            return Ea(r) < Ua ? yn : (n.invert = function(t, e) { var n = o - e; return [Math.atan2(t, n) / r, o - st(r) * Math.sqrt(t * t + n * n)] }, n)
        }

        function Ln(t, e) { return [t, Math.log(Math.tan(Xa / 4 + e / 2))] }

        function $n(t) {
            var e, n = gn(t),
                i = n.scale,
                r = n.translate,
                o = n.clipExtent;
            return n.scale = function() { var t = i.apply(n, arguments); return t === n ? e ? n.clipExtent(null) : n : t }, n.translate = function() { var t = r.apply(n, arguments); return t === n ? e ? n.clipExtent(null) : n : t }, n.clipExtent = function(t) {
                var a = o.apply(n, arguments);
                if (a === n) {
                    if (e = null == t) {
                        var s = Xa * i(),
                            l = r();
                        o([
                            [l[0] - s, l[1] - s],
                            [l[0] + s, l[1] + s]
                        ])
                    }
                } else e && (a = null);
                return a
            }, n.clipExtent(null)
        }

        function Nn(t, e) { return [Math.log(Math.tan(Xa / 4 + e / 2)), -t] }

        function Rn(t) { return t[0] }

        function qn(t) { return t[1] }

        function Fn(t) {
            for (var e = t.length, n = [0, 1], i = 2, r = 2; r < e; r++) {
                for (; i > 1 && lt(t[n[i - 2]], t[n[i - 1]], t[r]) <= 0;) --i;
                n[i++] = r
            }
            return n.slice(0, i)
        }

        function Hn(t, e) { return t[0] - e[0] || t[1] - e[1] }

        function Bn(t, e, n) { return (n[0] - e[0]) * (t[1] - e[1]) < (n[1] - e[1]) * (t[0] - e[0]) }

        function Wn(t, e, n, i) {
            var r = t[0],
                o = n[0],
                a = e[0] - r,
                s = i[0] - o,
                l = t[1],
                u = n[1],
                c = e[1] - l,
                d = i[1] - u,
                h = (s * (l - u) - d * (r - o)) / (d * a - s * c);
            return [r + h * a, l + h * c]
        }

        function jn(t) {
            var e = t[0],
                n = t[t.length - 1];
            return !(e[0] - n[0] || e[1] - n[1])
        }

        function Yn() { hi(this), this.edge = this.site = this.circle = null }

        function Un(t) { var e = yl.pop() || new Yn; return e.site = t, e }

        function Vn(t) { ii(t), gl.remove(t), yl.push(t), hi(t) }

        function Xn(t) {
            var e = t.circle,
                n = e.x,
                i = e.cy,
                r = { x: n, y: i },
                o = t.P,
                a = t.N,
                s = [t];
            Vn(t);
            for (var l = o; l.circle && Ea(n - l.circle.x) < Ua && Ea(i - l.circle.cy) < Ua;) o = l.P, s.unshift(l), Vn(l), l = o;
            s.unshift(l), ii(l);
            for (var u = a; u.circle && Ea(n - u.circle.x) < Ua && Ea(i - u.circle.cy) < Ua;) a = u.N, s.push(u), Vn(u), u = a;
            s.push(u), ii(u);
            var c, d = s.length;
            for (c = 1; c < d; ++c) u = s[c], l = s[c - 1], ui(u.edge, l.site, u.site, r);
            l = s[0], u = s[d - 1], u.edge = si(l.site, u.site, null, r), ni(l), ni(u)
        }

        function Zn(t) {
            for (var e, n, i, r, o = t.x, a = t.y, s = gl._; s;)
                if (i = Kn(s, a) - o, i > Ua) s = s.L;
                else { if (r = o - Gn(s, a), !(r > Ua)) { i > -Ua ? (e = s.P, n = s) : r > -Ua ? (e = s, n = s.N) : e = n = s; break } if (!s.R) { e = s; break } s = s.R } var l = Un(t);
            if (gl.insert(e, l), e || n) {
                if (e === n) return ii(e), n = Un(e.site), gl.insert(l, n), l.edge = n.edge = si(e.site, l.site), ni(e), void ni(n);
                if (!n) return void(l.edge = si(e.site, l.site));
                ii(e), ii(n);
                var u = e.site,
                    c = u.x,
                    d = u.y,
                    h = t.x - c,
                    f = t.y - d,
                    p = n.site,
                    g = p.x - c,
                    v = p.y - d,
                    m = 2 * (h * v - f * g),
                    y = h * h + f * f,
                    b = g * g + v * v,
                    x = { x: (v * y - f * b) / m + c, y: (h * b - g * y) / m + d };
                ui(n.edge, u, p, x), l.edge = si(u, t, null, x), n.edge = si(t, p, null, x), ni(e), ni(n)
            }
        }

        function Kn(t, e) {
            var n = t.site,
                i = n.x,
                r = n.y,
                o = r - e;
            if (!o) return i;
            var a = t.P;
            if (!a) return -(1 / 0);
            n = a.site;
            var s = n.x,
                l = n.y,
                u = l - e;
            if (!u) return s;
            var c = s - i,
                d = 1 / o - 1 / u,
                h = c / u;
            return d ? (-h + Math.sqrt(h * h - 2 * d * (c * c / (-2 * u) - l + u / 2 + r - o / 2))) / d + i : (i + s) / 2
        }

        function Gn(t, e) { var n = t.N; if (n) return Kn(n, e); var i = t.site; return i.y === e ? i.x : 1 / 0 }

        function Jn(t) { this.site = t, this.edges = [] }

        function Qn(t) {
            for (var e, n, i, r, o, a, s, l, u, c, d = t[0][0], h = t[1][0], f = t[0][1], p = t[1][1], g = pl, v = g.length; v--;)
                if (o = g[v], o && o.prepare())
                    for (s = o.edges, l = s.length, a = 0; a < l;) c = s[a].end(), i = c.x, r = c.y, u = s[++a % l].start(), e = u.x, n = u.y, (Ea(i - e) > Ua || Ea(r - n) > Ua) && (s.splice(a, 0, new ci(li(o.site, c, Ea(i - d) < Ua && p - r > Ua ? { x: d, y: Ea(e - d) < Ua ? n : p } : Ea(r - p) < Ua && h - i > Ua ? { x: Ea(n - p) < Ua ? e : h, y: p } : Ea(i - h) < Ua && r - f > Ua ? { x: h, y: Ea(e - h) < Ua ? n : f } : Ea(r - f) < Ua && i - d > Ua ? { x: Ea(n - f) < Ua ? e : d, y: f } : null), o.site, null)), ++l)
        }

        function ti(t, e) { return e.angle - t.angle }

        function ei() { hi(this), this.x = this.y = this.arc = this.site = this.cy = null }

        function ni(t) {
            var e = t.P,
                n = t.N;
            if (e && n) {
                var i = e.site,
                    r = t.site,
                    o = n.site;
                if (i !== o) {
                    var a = r.x,
                        s = r.y,
                        l = i.x - a,
                        u = i.y - s,
                        c = o.x - a,
                        d = o.y - s,
                        h = 2 * (l * d - u * c);
                    if (!(h >= -Va)) {
                        var f = l * l + u * u,
                            p = c * c + d * d,
                            g = (d * f - u * p) / h,
                            v = (l * p - c * f) / h,
                            d = v + s,
                            m = bl.pop() || new ei;
                        m.arc = t, m.site = r, m.x = g + a, m.y = d + Math.sqrt(g * g + v * v), m.cy = d, t.circle = m;
                        for (var y = null, b = ml._; b;)
                            if (m.y < b.y || m.y === b.y && m.x <= b.x) { if (!b.L) { y = b.P; break } b = b.L } else { if (!b.R) { y = b; break } b = b.R } ml.insert(y, m), y || (vl = m)
                    }
                }
            }
        }

        function ii(t) {
            var e = t.circle;
            e && (e.P || (vl = e.N), ml.remove(e), bl.push(e), hi(e), t.circle = null)
        }

        function ri(t) { for (var e, n = fl, i = Ge(t[0][0], t[0][1], t[1][0], t[1][1]), r = n.length; r--;) e = n[r], (!oi(e, t) || !i(e) || Ea(e.a.x - e.b.x) < Ua && Ea(e.a.y - e.b.y) < Ua) && (e.a = e.b = null, n.splice(r, 1)) }

        function oi(t, e) {
            var n = t.b;
            if (n) return !0;
            var i, r, o = t.a,
                a = e[0][0],
                s = e[1][0],
                l = e[0][1],
                u = e[1][1],
                c = t.l,
                d = t.r,
                h = c.x,
                f = c.y,
                p = d.x,
                g = d.y,
                v = (h + p) / 2,
                m = (f + g) / 2;
            if (g === f) {
                if (v < a || v >= s) return;
                if (h > p) {
                    if (o) { if (o.y >= u) return } else o = { x: v, y: l };
                    n = { x: v, y: u }
                } else {
                    if (o) { if (o.y < l) return } else o = { x: v, y: u };
                    n = { x: v, y: l }
                }
            } else if (i = (h - p) / (g - f), r = m - i * v, i < -1 || i > 1)
                if (h > p) {
                    if (o) { if (o.y >= u) return } else o = { x: (l - r) / i, y: l };
                    n = { x: (u - r) / i, y: u }
                } else {
                    if (o) { if (o.y < l) return } else o = { x: (u - r) / i, y: u };
                    n = { x: (l - r) / i, y: l }
                }
            else if (f < g) {
                if (o) { if (o.x >= s) return } else o = { x: a, y: i * a + r };
                n = { x: s, y: i * s + r }
            } else {
                if (o) { if (o.x < a) return } else o = { x: s, y: i * s + r };
                n = { x: a, y: i * a + r }
            }
            return t.a = o, t.b = n, !0
        }

        function ai(t, e) { this.l = t, this.r = e, this.a = this.b = null }

        function si(t, e, n, i) { var r = new ai(t, e); return fl.push(r), n && ui(r, t, e, n), i && ui(r, e, t, i), pl[t.i].edges.push(new ci(r, t, e)), pl[e.i].edges.push(new ci(r, e, t)), r }

        function li(t, e, n) { var i = new ai(t, null); return i.a = e, i.b = n, fl.push(i), i }

        function ui(t, e, n, i) { t.a || t.b ? t.l === n ? t.b = i : t.a = i : (t.a = i, t.l = e, t.r = n) }

        function ci(t, e, n) {
            var i = t.a,
                r = t.b;
            this.edge = t, this.site = e, this.angle = n ? Math.atan2(n.y - e.y, n.x - e.x) : t.l === e ? Math.atan2(r.x - i.x, i.y - r.y) : Math.atan2(i.x - r.x, r.y - i.y)
        }

        function di() { this._ = null }

        function hi(t) { t.U = t.C = t.L = t.R = t.P = t.N = null }

        function fi(t, e) {
            var n = e,
                i = e.R,
                r = n.U;
            r ? r.L === n ? r.L = i : r.R = i : t._ = i, i.U = r, n.U = i, n.R = i.L, n.R && (n.R.U = n), i.L = n
        }

        function pi(t, e) {
            var n = e,
                i = e.L,
                r = n.U;
            r ? r.L === n ? r.L = i : r.R = i : t._ = i, i.U = r, n.U = i, n.L = i.R, n.L && (n.L.U = n), i.R = n
        }

        function gi(t) { for (; t.L;) t = t.L; return t }

        function vi(t, e) {
            var n, i, r, o = t.sort(mi).pop();
            for (fl = [], pl = new Array(t.length), gl = new di, ml = new di;;)
                if (r = vl, o && (!r || o.y < r.y || o.y === r.y && o.x < r.x)) o.x === n && o.y === i || (pl[o.i] = new Jn(o), Zn(o), n = o.x, i = o.y), o = t.pop();
                else {
                    if (!r) break;
                    Xn(r.arc)
                } e && (ri(e), Qn(e));
            var a = { cells: pl, edges: fl };
            return gl = ml = fl = pl = null, a
        }

        function mi(t, e) { return e.y - t.y || e.x - t.x }

        function yi(t, e, n) { return (t.x - n.x) * (e.y - t.y) - (t.x - e.x) * (n.y - t.y) }

        function bi(t) { return t.x }

        function xi(t) { return t.y }

        function wi() { return { leaf: !0, nodes: [], point: null, x: null, y: null } }

        function ki(t, e, n, i, r, o) {
            if (!t(e, n, i, r, o)) {
                var a = .5 * (n + r),
                    s = .5 * (i + o),
                    l = e.nodes;
                l[0] && ki(t, l[0], n, i, a, s), l[1] && ki(t, l[1], a, i, r, s), l[2] && ki(t, l[2], n, s, a, o), l[3] && ki(t, l[3], a, s, r, o)
            }
        }

        function Si(t, e, n, i, r, o, a) {
            var s, l = 1 / 0;
            return function u(t, c, d, h, f) {
                if (!(c > o || d > a || h < i || f < r)) {
                    if (p = t.point) {
                        var p, g = e - t.x,
                            v = n - t.y,
                            m = g * g + v * v;
                        if (m < l) {
                            var y = Math.sqrt(l = m);
                            i = e - y, r = n - y, o = e + y, a = n + y, s = p
                        }
                    }
                    for (var b = t.nodes, x = .5 * (c + h), w = .5 * (d + f), k = e >= x, S = n >= w, _ = S << 1 | k, T = _ + 4; _ < T; ++_)
                        if (t = b[3 & _]) switch (3 & _) {
                            case 0:
                                u(t, c, d, x, w);
                                break;
                            case 1:
                                u(t, x, d, h, w);
                                break;
                            case 2:
                                u(t, c, w, x, f);
                                break;
                            case 3:
                                u(t, x, w, h, f)
                        }
                }
            }(t, i, r, o, a), s
        }

        function _i(t, e) {
            t = ma.rgb(t), e = ma.rgb(e);
            var n = t.r,
                i = t.g,
                r = t.b,
                o = e.r - n,
                a = e.g - i,
                s = e.b - r;
            return function(t) { return "#" + Et(Math.round(n + o * t)) + Et(Math.round(i + a * t)) + Et(Math.round(r + s * t)) }
        }

        function Ti(t, e) {
            var n, i = {},
                r = {};
            for (n in t) n in e ? i[n] = Ai(t[n], e[n]) : r[n] = t[n];
            for (n in e) n in t || (r[n] = e[n]);
            return function(t) { for (n in i) r[n] = i[n](t); return r }
        }

        function Ci(t, e) {
            return t = +t, e = +e,
                function(n) { return t * (1 - n) + e * n }
        }

        function Mi(t, e) {
            var n, i, r, o = wl.lastIndex = kl.lastIndex = 0,
                a = -1,
                s = [],
                l = [];
            for (t += "", e += "";
                (n = wl.exec(t)) && (i = kl.exec(e));)(r = i.index) > o && (r = e.slice(o, r), s[a] ? s[a] += r : s[++a] = r), (n = n[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, l.push({ i: a, x: Ci(n, i) })), o = kl.lastIndex;
            return o < e.length && (r = e.slice(o), s[a] ? s[a] += r : s[++a] = r), s.length < 2 ? l[0] ? (e = l[0].x, function(t) { return e(t) + "" }) : function() { return e } : (e = l.length, function(t) { for (var n, i = 0; i < e; ++i) s[(n = l[i]).i] = n.x(t); return s.join("") })
        }

        function Ai(t, e) { for (var n, i = ma.interpolators.length; --i >= 0 && !(n = ma.interpolators[i](t, e));); return n }

        function Ei(t, e) {
            var n, i = [],
                r = [],
                o = t.length,
                a = e.length,
                s = Math.min(t.length, e.length);
            for (n = 0; n < s; ++n) i.push(Ai(t[n], e[n]));
            for (; n < o; ++n) r[n] = t[n];
            for (; n < a; ++n) r[n] = e[n];
            return function(t) { for (n = 0; n < s; ++n) r[n] = i[n](t); return r }
        }

        function Pi(t) { return function(e) { return e <= 0 ? 0 : e >= 1 ? 1 : t(e) } }

        function Ii(t) { return function(e) { return 1 - t(1 - e) } }

        function zi(t) { return function(e) { return .5 * (e < .5 ? t(2 * e) : 2 - t(2 - 2 * e)) } }

        function Di(t) { return t * t }

        function Oi(t) { return t * t * t }

        function Li(t) {
            if (t <= 0) return 0;
            if (t >= 1) return 1;
            var e = t * t,
                n = e * t;
            return 4 * (t < .5 ? n : 3 * (t - e) + n - .75)
        }

        function $i(t) { return function(e) { return Math.pow(e, t) } }

        function Ni(t) { return 1 - Math.cos(t * Ga) }

        function Ri(t) { return Math.pow(2, 10 * (t - 1)) }

        function qi(t) { return 1 - Math.sqrt(1 - t * t) }

        function Fi(t, e) {
            var n;
            return arguments.length < 2 && (e = .45), arguments.length ? n = e / Za * Math.asin(1 / t) : (t = 1, n = e / 4),
                function(i) { return 1 + t * Math.pow(2, -10 * i) * Math.sin((i - n) * Za / e) }
        }

        function Hi(t) {
            return t || (t = 1.70158),
                function(e) { return e * e * ((t + 1) * e - t) }
        }

        function Bi(t) { return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375 }

        function Wi(t, e) {
            t = ma.hcl(t), e = ma.hcl(e);
            var n = t.h,
                i = t.c,
                r = t.l,
                o = e.h - n,
                a = e.c - i,
                s = e.l - r;
            return isNaN(a) && (a = 0, i = isNaN(i) ? e.c : i), isNaN(o) ? (o = 0, n = isNaN(n) ? e.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360),
                function(t) { return bt(n + o * t, i + a * t, r + s * t) + "" }
        }

        function ji(t, e) {
            t = ma.hsl(t), e = ma.hsl(e);
            var n = t.h,
                i = t.s,
                r = t.l,
                o = e.h - n,
                a = e.s - i,
                s = e.l - r;
            return isNaN(a) && (a = 0, i = isNaN(i) ? e.s : i), isNaN(o) ? (o = 0, n = isNaN(n) ? e.h : n) : o > 180 ? o -= 360 : o < -180 && (o += 360),
                function(t) { return mt(n + o * t, i + a * t, r + s * t) + "" }
        }

        function Yi(t, e) {
            t = ma.lab(t), e = ma.lab(e);
            var n = t.l,
                i = t.a,
                r = t.b,
                o = e.l - n,
                a = e.a - i,
                s = e.b - r;
            return function(t) { return wt(n + o * t, i + a * t, r + s * t) + "" }
        }

        function Ui(t, e) {
            return e -= t,
                function(n) { return Math.round(t + e * n) }
        }

        function Vi(t) {
            var e = [t.a, t.b],
                n = [t.c, t.d],
                i = Zi(e),
                r = Xi(e, n),
                o = Zi(Ki(n, e, -r)) || 0;
            e[0] * n[1] < n[0] * e[1] && (e[0] *= -1, e[1] *= -1, i *= -1, r *= -1), this.rotate = (i ? Math.atan2(e[1], e[0]) : Math.atan2(-n[0], n[1])) * Qa, this.translate = [t.e, t.f], this.scale = [i, o], this.skew = o ? Math.atan2(r, o) * Qa : 0
        }

        function Xi(t, e) { return t[0] * e[0] + t[1] * e[1] }

        function Zi(t) { var e = Math.sqrt(Xi(t, t)); return e && (t[0] /= e, t[1] /= e), e }

        function Ki(t, e, n) { return t[0] += n * e[0], t[1] += n * e[1], t }

        function Gi(t) { return t.length ? t.pop() + "," : "" }

        function Ji(t, e, n, i) {
            if (t[0] !== e[0] || t[1] !== e[1]) {
                var r = n.push("translate(", null, ",", null, ")");
                i.push({ i: r - 4, x: Ci(t[0], e[0]) }, { i: r - 2, x: Ci(t[1], e[1]) })
            } else(e[0] || e[1]) && n.push("translate(" + e + ")")
        }

        function Qi(t, e, n, i) { t !== e ? (t - e > 180 ? e += 360 : e - t > 180 && (t += 360), i.push({ i: n.push(Gi(n) + "rotate(", null, ")") - 2, x: Ci(t, e) })) : e && n.push(Gi(n) + "rotate(" + e + ")") }

        function tr(t, e, n, i) { t !== e ? i.push({ i: n.push(Gi(n) + "skewX(", null, ")") - 2, x: Ci(t, e) }) : e && n.push(Gi(n) + "skewX(" + e + ")") }

        function er(t, e, n, i) {
            if (t[0] !== e[0] || t[1] !== e[1]) {
                var r = n.push(Gi(n) + "scale(", null, ",", null, ")");
                i.push({ i: r - 4, x: Ci(t[0], e[0]) }, { i: r - 2, x: Ci(t[1], e[1]) })
            } else 1 === e[0] && 1 === e[1] || n.push(Gi(n) + "scale(" + e + ")")
        }

        function nr(t, e) {
            var n = [],
                i = [];
            return t = ma.transform(t), e = ma.transform(e), Ji(t.translate, e.translate, n, i), Qi(t.rotate, e.rotate, n, i), tr(t.skew, e.skew, n, i), er(t.scale, e.scale, n, i), t = e = null,
                function(t) { for (var e, r = -1, o = i.length; ++r < o;) n[(e = i[r]).i] = e.x(t); return n.join("") }
        }

        function ir(t, e) {
            return e = (e -= t = +t) || 1 / e,
                function(n) { return (n - t) / e }
        }

        function rr(t, e) {
            return e = (e -= t = +t) || 1 / e,
                function(n) { return Math.max(0, Math.min(1, (n - t) / e)) }
        }

        function or(t) { for (var e = t.source, n = t.target, i = sr(e, n), r = [e]; e !== i;) e = e.parent, r.push(e); for (var o = r.length; n !== i;) r.splice(o, 0, n), n = n.parent; return r }

        function ar(t) { for (var e = [], n = t.parent; null != n;) e.push(t), t = n, n = n.parent; return e.push(t), e }

        function sr(t, e) { if (t === e) return t; for (var n = ar(t), i = ar(e), r = n.pop(), o = i.pop(), a = null; r === o;) a = r, r = n.pop(), o = i.pop(); return a }

        function lr(t) { t.fixed |= 2 }

        function ur(t) { t.fixed &= -7 }

        function cr(t) { t.fixed |= 4, t.px = t.x, t.py = t.y }

        function dr(t) { t.fixed &= -5 }

        function hr(t, e, n) {
            var i = 0,
                r = 0;
            if (t.charge = 0, !t.leaf)
                for (var o, a = t.nodes, s = a.length, l = -1; ++l < s;) o = a[l], null != o && (hr(o, e, n), t.charge += o.charge, i += o.charge * o.cx, r += o.charge * o.cy);
            if (t.point) {
                t.leaf || (t.point.x += Math.random() - .5, t.point.y += Math.random() - .5);
                var u = e * n[t.point.index];
                t.charge += t.pointCharge = u, i += u * t.point.x, r += u * t.point.y
            }
            t.cx = i / t.charge, t.cy = r / t.charge
        }

        function fr(t, e) { return ma.rebind(t, e, "sort", "children", "value"), t.nodes = t, t.links = br, t }

        function pr(t, e) {
            for (var n = [t]; null != (t = n.pop());)
                if (e(t), (r = t.children) && (i = r.length))
                    for (var i, r; --i >= 0;) n.push(r[i])
        }

        function gr(t, e) {
            for (var n = [t], i = []; null != (t = n.pop());)
                if (i.push(t), (o = t.children) && (r = o.length))
                    for (var r, o, a = -1; ++a < r;) n.push(o[a]);
            for (; null != (t = i.pop());) e(t)
        }

        function vr(t) { return t.children }

        function mr(t) { return t.value }

        function yr(t, e) { return e.value - t.value }

        function br(t) { return ma.merge(t.map(function(t) { return (t.children || []).map(function(e) { return { source: t, target: e } }) })) }

        function xr(t) { return t.x }

        function wr(t) { return t.y }

        function kr(t, e, n) { t.y0 = e, t.y = n }

        function Sr(t) { return ma.range(t.length) }

        function _r(t) { for (var e = -1, n = t[0].length, i = []; ++e < n;) i[e] = 0; return i }

        function Tr(t) { for (var e, n = 1, i = 0, r = t[0][1], o = t.length; n < o; ++n)(e = t[n][1]) > r && (i = n, r = e); return i }

        function Cr(t) { return t.reduce(Mr, 0) }

        function Mr(t, e) { return t + e[1] }

        function Ar(t, e) { return Er(t, Math.ceil(Math.log(e.length) / Math.LN2 + 1)) }

        function Er(t, e) { for (var n = -1, i = +t[0], r = (t[1] - i) / e, o = []; ++n <= e;) o[n] = r * n + i; return o }

        function Pr(t) { return [ma.min(t), ma.max(t)] }

        function Ir(t, e) { return t.value - e.value }

        function zr(t, e) {
            var n = t._pack_next;
            t._pack_next = e, e._pack_prev = t, e._pack_next = n, n._pack_prev = e
        }

        function Dr(t, e) { t._pack_next = e, e._pack_prev = t }

        function Or(t, e) {
            var n = e.x - t.x,
                i = e.y - t.y,
                r = t.r + e.r;
            return .999 * r * r > n * n + i * i
        }

        function Lr(t) {
            function e(t) { c = Math.min(t.x - t.r, c), d = Math.max(t.x + t.r, d), h = Math.min(t.y - t.r, h), f = Math.max(t.y + t.r, f) }
            if ((n = t.children) && (u = n.length)) {
                var n, i, r, o, a, s, l, u, c = 1 / 0,
                    d = -(1 / 0),
                    h = 1 / 0,
                    f = -(1 / 0);
                if (n.forEach($r), i = n[0], i.x = -i.r, i.y = 0, e(i), u > 1 && (r = n[1], r.x = r.r, r.y = 0, e(r), u > 2))
                    for (o = n[2], qr(i, r, o), e(o), zr(i, o), i._pack_prev = o, zr(o, r), r = i._pack_next, a = 3; a < u; a++) {
                        qr(i, r, o = n[a]);
                        var p = 0,
                            g = 1,
                            v = 1;
                        for (s = r._pack_next; s !== r; s = s._pack_next, g++)
                            if (Or(s, o)) { p = 1; break } if (1 == p)
                            for (l = i._pack_prev; l !== s._pack_prev && !Or(l, o); l = l._pack_prev, v++);
                        p ? (g < v || g == v && r.r < i.r ? Dr(i, r = s) : Dr(i = l, r), a--) : (zr(i, o), r = o, e(o))
                    }
                var m = (c + d) / 2,
                    y = (h + f) / 2,
                    b = 0;
                for (a = 0; a < u; a++) o = n[a], o.x -= m, o.y -= y, b = Math.max(b, o.r + Math.sqrt(o.x * o.x + o.y * o.y));
                t.r = b, n.forEach(Nr)
            }
        }

        function $r(t) { t._pack_next = t._pack_prev = t }

        function Nr(t) { delete t._pack_next, delete t._pack_prev; }

        function Rr(t, e, n, i) {
            var r = t.children;
            if (t.x = e += i * t.x, t.y = n += i * t.y, t.r *= i, r)
                for (var o = -1, a = r.length; ++o < a;) Rr(r[o], e, n, i)
        }

        function qr(t, e, n) {
            var i = t.r + n.r,
                r = e.x - t.x,
                o = e.y - t.y;
            if (i && (r || o)) {
                var a = e.r + n.r,
                    s = r * r + o * o;
                a *= a, i *= i;
                var l = .5 + (i - a) / (2 * s),
                    u = Math.sqrt(Math.max(0, 2 * a * (i + s) - (i -= s) * i - a * a)) / (2 * s);
                n.x = t.x + l * r + u * o, n.y = t.y + l * o - u * r
            } else n.x = t.x + i, n.y = t.y
        }

        function Fr(t, e) { return t.parent == e.parent ? 1 : 2 }

        function Hr(t) { var e = t.children; return e.length ? e[0] : t.t }

        function Br(t) { var e, n = t.children; return (e = n.length) ? n[e - 1] : t.t }

        function Wr(t, e, n) {
            var i = n / (e.i - t.i);
            e.c -= i, e.s += n, t.c += i, e.z += n, e.m += n
        }

        function jr(t) { for (var e, n = 0, i = 0, r = t.children, o = r.length; --o >= 0;) e = r[o], e.z += n, e.m += n, n += e.s + (i += e.c) }

        function Yr(t, e, n) { return t.a.parent === e.parent ? t.a : n }

        function Ur(t) { return 1 + ma.max(t, function(t) { return t.y }) }

        function Vr(t) { return t.reduce(function(t, e) { return t + e.x }, 0) / t.length }

        function Xr(t) { var e = t.children; return e && e.length ? Xr(e[0]) : t }

        function Zr(t) { var e, n = t.children; return n && (e = n.length) ? Zr(n[e - 1]) : t }

        function Kr(t) { return { x: t.x, y: t.y, dx: t.dx, dy: t.dy } }

        function Gr(t, e) {
            var n = t.x + e[3],
                i = t.y + e[0],
                r = t.dx - e[1] - e[3],
                o = t.dy - e[0] - e[2];
            return r < 0 && (n += r / 2, r = 0), o < 0 && (i += o / 2, o = 0), { x: n, y: i, dx: r, dy: o }
        }

        function Jr(t) {
            var e = t[0],
                n = t[t.length - 1];
            return e < n ? [e, n] : [n, e]
        }

        function Qr(t) { return t.rangeExtent ? t.rangeExtent() : Jr(t.range()) }

        function to(t, e, n, i) {
            var r = n(t[0], t[1]),
                o = i(e[0], e[1]);
            return function(t) { return o(r(t)) }
        }

        function eo(t, e) {
            var n, i = 0,
                r = t.length - 1,
                o = t[i],
                a = t[r];
            return a < o && (n = i, i = r, r = n, n = o, o = a, a = n), t[i] = e.floor(o), t[r] = e.ceil(a), t
        }

        function no(t) { return t ? { floor: function(e) { return Math.floor(e / t) * t }, ceil: function(e) { return Math.ceil(e / t) * t } } : Dl }

        function io(t, e, n, i) {
            var r = [],
                o = [],
                a = 0,
                s = Math.min(t.length, e.length) - 1;
            for (t[s] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++a <= s;) r.push(n(t[a - 1], t[a])), o.push(i(e[a - 1], e[a]));
            return function(e) { var n = ma.bisect(t, e, 1, s) - 1; return o[n](r[n](e)) }
        }

        function ro(t, e, n, i) {
            function r() {
                var r = Math.min(t.length, e.length) > 2 ? io : to,
                    l = i ? rr : ir;
                return a = r(t, e, l, n), s = r(e, t, l, Ai), o
            }

            function o(t) { return a(t) }
            var a, s;
            return o.invert = function(t) { return s(t) }, o.domain = function(e) { return arguments.length ? (t = e.map(Number), r()) : t }, o.range = function(t) { return arguments.length ? (e = t, r()) : e }, o.rangeRound = function(t) { return o.range(t).interpolate(Ui) }, o.clamp = function(t) { return arguments.length ? (i = t, r()) : i }, o.interpolate = function(t) { return arguments.length ? (n = t, r()) : n }, o.ticks = function(e) { return lo(t, e) }, o.tickFormat = function(e, n) { return uo(t, e, n) }, o.nice = function(e) { return ao(t, e), r() }, o.copy = function() { return ro(t, e, n, i) }, r()
        }

        function oo(t, e) { return ma.rebind(t, e, "range", "rangeRound", "interpolate", "clamp") }

        function ao(t, e) { return eo(t, no(so(t, e)[2])), eo(t, no(so(t, e)[2])), t }

        function so(t, e) {
            null == e && (e = 10);
            var n = Jr(t),
                i = n[1] - n[0],
                r = Math.pow(10, Math.floor(Math.log(i / e) / Math.LN10)),
                o = e / i * r;
            return o <= .15 ? r *= 10 : o <= .35 ? r *= 5 : o <= .75 && (r *= 2), n[0] = Math.ceil(n[0] / r) * r, n[1] = Math.floor(n[1] / r) * r + .5 * r, n[2] = r, n
        }

        function lo(t, e) { return ma.range.apply(ma, so(t, e)) }

        function uo(t, e, n) {
            var i = so(t, e);
            if (n) {
                var r = ws.exec(n);
                if (r.shift(), "s" === r[8]) {
                    var o = ma.formatPrefix(Math.max(Ea(i[0]), Ea(i[1])));
                    return r[7] || (r[7] = "." + co(o.scale(i[2]))), r[8] = "f", n = ma.format(r.join("")),
                        function(t) { return n(o.scale(t)) + o.symbol }
                }
                r[7] || (r[7] = "." + ho(r[8], i)), n = r.join("")
            } else n = ",." + co(i[2]) + "f";
            return ma.format(n)
        }

        function co(t) { return -Math.floor(Math.log(t) / Math.LN10 + .01) }

        function ho(t, e) { var n = co(e[2]); return t in Ol ? Math.abs(n - co(Math.max(Ea(e[0]), Ea(e[1])))) + +("e" !== t) : n - 2 * ("%" === t) }

        function fo(t, e, n, i) {
            function r(t) { return (n ? Math.log(t < 0 ? 0 : t) : -Math.log(t > 0 ? 0 : -t)) / Math.log(e) }

            function o(t) { return n ? Math.pow(e, t) : -Math.pow(e, -t) }

            function a(e) { return t(r(e)) }
            return a.invert = function(e) { return o(t.invert(e)) }, a.domain = function(e) { return arguments.length ? (n = e[0] >= 0, t.domain((i = e.map(Number)).map(r)), a) : i }, a.base = function(n) { return arguments.length ? (e = +n, t.domain(i.map(r)), a) : e }, a.nice = function() { var e = eo(i.map(r), n ? Math : $l); return t.domain(e), i = e.map(o), a }, a.ticks = function() {
                var t = Jr(i),
                    a = [],
                    s = t[0],
                    l = t[1],
                    u = Math.floor(r(s)),
                    c = Math.ceil(r(l)),
                    d = e % 1 ? 2 : e;
                if (isFinite(c - u)) {
                    if (n) {
                        for (; u < c; u++)
                            for (var h = 1; h < d; h++) a.push(o(u) * h);
                        a.push(o(u))
                    } else
                        for (a.push(o(u)); u++ < c;)
                            for (var h = d - 1; h > 0; h--) a.push(o(u) * h);
                    for (u = 0; a[u] < s; u++);
                    for (c = a.length; a[c - 1] > l; c--);
                    a = a.slice(u, c)
                }
                return a
            }, a.tickFormat = function(t, n) {
                if (!arguments.length) return Ll;
                arguments.length < 2 ? n = Ll : "function" != typeof n && (n = ma.format(n));
                var i = Math.max(1, e * t / a.ticks().length);
                return function(t) { var a = t / o(Math.round(r(t))); return a * e < e - .5 && (a *= e), a <= i ? n(t) : "" }
            }, a.copy = function() { return fo(t.copy(), e, n, i) }, oo(a, t)
        }

        function po(t, e, n) {
            function i(e) { return t(r(e)) }
            var r = go(e),
                o = go(1 / e);
            return i.invert = function(e) { return o(t.invert(e)) }, i.domain = function(e) { return arguments.length ? (t.domain((n = e.map(Number)).map(r)), i) : n }, i.ticks = function(t) { return lo(n, t) }, i.tickFormat = function(t, e) { return uo(n, t, e) }, i.nice = function(t) { return i.domain(ao(n, t)) }, i.exponent = function(a) { return arguments.length ? (r = go(e = a), o = go(1 / e), t.domain(n.map(r)), i) : e }, i.copy = function() { return po(t.copy(), e, n) }, oo(i, t)
        }

        function go(t) { return function(e) { return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t) } }

        function vo(t, e) {
            function n(n) { return o[((r.get(n) || ("range" === e.t ? r.set(n, t.push(n)) : NaN)) - 1) % o.length] }

            function i(e, n) { return ma.range(t.length).map(function(t) { return e + n * t }) }
            var r, o, a;
            return n.domain = function(i) {
                if (!arguments.length) return t;
                t = [], r = new y;
                for (var o, a = -1, s = i.length; ++a < s;) r.has(o = i[a]) || r.set(o, t.push(o));
                return n[e.t].apply(n, e.a)
            }, n.range = function(t) { return arguments.length ? (o = t, a = 0, e = { t: "range", a: arguments }, n) : o }, n.rangePoints = function(r, s) {
                arguments.length < 2 && (s = 0);
                var l = r[0],
                    u = r[1],
                    c = t.length < 2 ? (l = (l + u) / 2, 0) : (u - l) / (t.length - 1 + s);
                return o = i(l + c * s / 2, c), a = 0, e = { t: "rangePoints", a: arguments }, n
            }, n.rangeRoundPoints = function(r, s) {
                arguments.length < 2 && (s = 0);
                var l = r[0],
                    u = r[1],
                    c = t.length < 2 ? (l = u = Math.round((l + u) / 2), 0) : (u - l) / (t.length - 1 + s) | 0;
                return o = i(l + Math.round(c * s / 2 + (u - l - (t.length - 1 + s) * c) / 2), c), a = 0, e = { t: "rangeRoundPoints", a: arguments }, n
            }, n.rangeBands = function(r, s, l) {
                arguments.length < 2 && (s = 0), arguments.length < 3 && (l = s);
                var u = r[1] < r[0],
                    c = r[u - 0],
                    d = r[1 - u],
                    h = (d - c) / (t.length - s + 2 * l);
                return o = i(c + h * l, h), u && o.reverse(), a = h * (1 - s), e = { t: "rangeBands", a: arguments }, n
            }, n.rangeRoundBands = function(r, s, l) {
                arguments.length < 2 && (s = 0), arguments.length < 3 && (l = s);
                var u = r[1] < r[0],
                    c = r[u - 0],
                    d = r[1 - u],
                    h = Math.floor((d - c) / (t.length - s + 2 * l));
                return o = i(c + Math.round((d - c - (t.length - s) * h) / 2), h), u && o.reverse(), a = Math.round(h * (1 - s)), e = { t: "rangeRoundBands", a: arguments }, n
            }, n.rangeBand = function() { return a }, n.rangeExtent = function() { return Jr(e.a[0]) }, n.copy = function() { return vo(t, e) }, n.domain(t)
        }

        function mo(t, e) {
            function n() {
                var n = 0,
                    o = e.length;
                for (r = []; ++n < o;) r[n - 1] = ma.quantile(t, n / o);
                return i
            }

            function i(t) { if (!isNaN(t = +t)) return e[ma.bisect(r, t)] }
            var r;
            return i.domain = function(e) { return arguments.length ? (t = e.map(c).filter(h).sort(l), n()) : t }, i.range = function(t) { return arguments.length ? (e = t, n()) : e }, i.quantiles = function() { return r }, i.invertExtent = function(n) { return n = e.indexOf(n), n < 0 ? [NaN, NaN] : [n > 0 ? r[n - 1] : t[0], n < r.length ? r[n] : t[t.length - 1]] }, i.copy = function() { return mo(t, e) }, n()
        }

        function yo(t, e, n) {
            function i(e) { return n[Math.max(0, Math.min(a, Math.floor(o * (e - t))))] }

            function r() { return o = n.length / (e - t), a = n.length - 1, i }
            var o, a;
            return i.domain = function(n) { return arguments.length ? (t = +n[0], e = +n[n.length - 1], r()) : [t, e] }, i.range = function(t) { return arguments.length ? (n = t, r()) : n }, i.invertExtent = function(e) { return e = n.indexOf(e), e = e < 0 ? NaN : e / o + t, [e, e + 1 / o] }, i.copy = function() { return yo(t, e, n) }, r()
        }

        function bo(t, e) {
            function n(n) { if (n <= n) return e[ma.bisect(t, n)] }
            return n.domain = function(e) { return arguments.length ? (t = e, n) : t }, n.range = function(t) { return arguments.length ? (e = t, n) : e }, n.invertExtent = function(n) { return n = e.indexOf(n), [t[n - 1], t[n]] }, n.copy = function() { return bo(t, e) }, n
        }

        function xo(t) {
            function e(t) { return +t }
            return e.invert = e, e.domain = e.range = function(n) { return arguments.length ? (t = n.map(e), e) : t }, e.ticks = function(e) { return lo(t, e) }, e.tickFormat = function(e, n) { return uo(t, e, n) }, e.copy = function() { return xo(t) }, e
        }

        function wo() { return 0 }

        function ko(t) { return t.innerRadius }

        function So(t) { return t.outerRadius }

        function _o(t) { return t.startAngle }

        function To(t) { return t.endAngle }

        function Co(t) { return t && t.padAngle }

        function Mo(t, e, n, i) { return (t - n) * e - (e - i) * t > 0 ? 0 : 1 }

        function Ao(t, e, n, i, r) {
            var o = t[0] - e[0],
                a = t[1] - e[1],
                s = (r ? i : -i) / Math.sqrt(o * o + a * a),
                l = s * a,
                u = -s * o,
                c = t[0] + l,
                d = t[1] + u,
                h = e[0] + l,
                f = e[1] + u,
                p = (c + h) / 2,
                g = (d + f) / 2,
                v = h - c,
                m = f - d,
                y = v * v + m * m,
                b = n - i,
                x = c * f - h * d,
                w = (m < 0 ? -1 : 1) * Math.sqrt(Math.max(0, b * b * y - x * x)),
                k = (x * m - v * w) / y,
                S = (-x * v - m * w) / y,
                _ = (x * m + v * w) / y,
                T = (-x * v + m * w) / y,
                C = k - p,
                M = S - g,
                A = _ - p,
                E = T - g;
            return C * C + M * M > A * A + E * E && (k = _, S = T), [
                [k - l, S - u],
                [k * n / b, S * n / b]
            ]
        }

        function Eo(t) {
            function e(e) {
                function a() { u.push("M", o(t(c), s)) }
                for (var l, u = [], c = [], d = -1, h = e.length, f = Lt(n), p = Lt(i); ++d < h;) r.call(this, l = e[d], d) ? c.push([+f.call(this, l, d), +p.call(this, l, d)]) : c.length && (a(), c = []);
                return c.length && a(), u.length ? u.join("") : null
            }
            var n = Rn,
                i = qn,
                r = Re,
                o = Po,
                a = o.key,
                s = .7;
            return e.x = function(t) { return arguments.length ? (n = t, e) : n }, e.y = function(t) { return arguments.length ? (i = t, e) : i }, e.defined = function(t) { return arguments.length ? (r = t, e) : r }, e.interpolate = function(t) { return arguments.length ? (a = "function" == typeof t ? o = t : (o = Bl.get(t) || Po).key, e) : a }, e.tension = function(t) { return arguments.length ? (s = t, e) : s }, e
        }

        function Po(t) { return t.length > 1 ? t.join("L") : t + "Z" }

        function Io(t) { return t.join("L") + "Z" }

        function zo(t) { for (var e = 0, n = t.length, i = t[0], r = [i[0], ",", i[1]]; ++e < n;) r.push("H", (i[0] + (i = t[e])[0]) / 2, "V", i[1]); return n > 1 && r.push("H", i[0]), r.join("") }

        function Do(t) { for (var e = 0, n = t.length, i = t[0], r = [i[0], ",", i[1]]; ++e < n;) r.push("V", (i = t[e])[1], "H", i[0]); return r.join("") }

        function Oo(t) { for (var e = 0, n = t.length, i = t[0], r = [i[0], ",", i[1]]; ++e < n;) r.push("H", (i = t[e])[0], "V", i[1]); return r.join("") }

        function Lo(t, e) { return t.length < 4 ? Po(t) : t[1] + Ro(t.slice(1, -1), qo(t, e)) }

        function $o(t, e) { return t.length < 3 ? Io(t) : t[0] + Ro((t.push(t[0]), t), qo([t[t.length - 2]].concat(t, [t[1]]), e)) }

        function No(t, e) { return t.length < 3 ? Po(t) : t[0] + Ro(t, qo(t, e)) }

        function Ro(t, e) {
            if (e.length < 1 || t.length != e.length && t.length != e.length + 2) return Po(t);
            var n = t.length != e.length,
                i = "",
                r = t[0],
                o = t[1],
                a = e[0],
                s = a,
                l = 1;
            if (n && (i += "Q" + (o[0] - 2 * a[0] / 3) + "," + (o[1] - 2 * a[1] / 3) + "," + o[0] + "," + o[1], r = t[1], l = 2), e.length > 1) { s = e[1], o = t[l], l++, i += "C" + (r[0] + a[0]) + "," + (r[1] + a[1]) + "," + (o[0] - s[0]) + "," + (o[1] - s[1]) + "," + o[0] + "," + o[1]; for (var u = 2; u < e.length; u++, l++) o = t[l], s = e[u], i += "S" + (o[0] - s[0]) + "," + (o[1] - s[1]) + "," + o[0] + "," + o[1] }
            if (n) {
                var c = t[l];
                i += "Q" + (o[0] + 2 * s[0] / 3) + "," + (o[1] + 2 * s[1] / 3) + "," + c[0] + "," + c[1]
            }
            return i
        }

        function qo(t, e) { for (var n, i = [], r = (1 - e) / 2, o = t[0], a = t[1], s = 1, l = t.length; ++s < l;) n = o, o = a, a = t[s], i.push([r * (a[0] - n[0]), r * (a[1] - n[1])]); return i }

        function Fo(t) {
            if (t.length < 3) return Po(t);
            var e = 1,
                n = t.length,
                i = t[0],
                r = i[0],
                o = i[1],
                a = [r, r, r, (i = t[1])[0]],
                s = [o, o, o, i[1]],
                l = [r, ",", o, "L", jo(Yl, a), ",", jo(Yl, s)];
            for (t.push(t[n - 1]); ++e <= n;) i = t[e], a.shift(), a.push(i[0]), s.shift(), s.push(i[1]), Yo(l, a, s);
            return t.pop(), l.push("L", i), l.join("")
        }

        function Ho(t) { if (t.length < 4) return Po(t); for (var e, n = [], i = -1, r = t.length, o = [0], a = [0]; ++i < 3;) e = t[i], o.push(e[0]), a.push(e[1]); for (n.push(jo(Yl, o) + "," + jo(Yl, a)), --i; ++i < r;) e = t[i], o.shift(), o.push(e[0]), a.shift(), a.push(e[1]), Yo(n, o, a); return n.join("") }

        function Bo(t) { for (var e, n, i = -1, r = t.length, o = r + 4, a = [], s = []; ++i < 4;) n = t[i % r], a.push(n[0]), s.push(n[1]); for (e = [jo(Yl, a), ",", jo(Yl, s)], --i; ++i < o;) n = t[i % r], a.shift(), a.push(n[0]), s.shift(), s.push(n[1]), Yo(e, a, s); return e.join("") }

        function Wo(t, e) {
            var n = t.length - 1;
            if (n)
                for (var i, r, o = t[0][0], a = t[0][1], s = t[n][0] - o, l = t[n][1] - a, u = -1; ++u <= n;) i = t[u], r = u / n, i[0] = e * i[0] + (1 - e) * (o + r * s), i[1] = e * i[1] + (1 - e) * (a + r * l);
            return Fo(t)
        }

        function jo(t, e) { return t[0] * e[0] + t[1] * e[1] + t[2] * e[2] + t[3] * e[3] }

        function Yo(t, e, n) { t.push("C", jo(Wl, e), ",", jo(Wl, n), ",", jo(jl, e), ",", jo(jl, n), ",", jo(Yl, e), ",", jo(Yl, n)) }

        function Uo(t, e) { return (e[1] - t[1]) / (e[0] - t[0]) }

        function Vo(t) { for (var e = 0, n = t.length - 1, i = [], r = t[0], o = t[1], a = i[0] = Uo(r, o); ++e < n;) i[e] = (a + (a = Uo(r = o, o = t[e + 1]))) / 2; return i[e] = a, i }

        function Xo(t) { for (var e, n, i, r, o = [], a = Vo(t), s = -1, l = t.length - 1; ++s < l;) e = Uo(t[s], t[s + 1]), Ea(e) < Ua ? a[s] = a[s + 1] = 0 : (n = a[s] / e, i = a[s + 1] / e, r = n * n + i * i, r > 9 && (r = 3 * e / Math.sqrt(r), a[s] = r * n, a[s + 1] = r * i)); for (s = -1; ++s <= l;) r = (t[Math.min(l, s + 1)][0] - t[Math.max(0, s - 1)][0]) / (6 * (1 + a[s] * a[s])), o.push([r || 0, a[s] * r || 0]); return o }

        function Zo(t) { return t.length < 3 ? Po(t) : t[0] + Ro(t, Xo(t)) }

        function Ko(t) { for (var e, n, i, r = -1, o = t.length; ++r < o;) e = t[r], n = e[0], i = e[1] - Ga, e[0] = n * Math.cos(i), e[1] = n * Math.sin(i); return t }

        function Go(t) {
            function e(e) {
                function l() { g.push("M", s(t(m), d), c, u(t(v.reverse()), d), "Z") }
                for (var h, f, p, g = [], v = [], m = [], y = -1, b = e.length, x = Lt(n), w = Lt(r), k = n === i ? function() { return f } : Lt(i), S = r === o ? function() { return p } : Lt(o); ++y < b;) a.call(this, h = e[y], y) ? (v.push([f = +x.call(this, h, y), p = +w.call(this, h, y)]), m.push([+k.call(this, h, y), +S.call(this, h, y)])) : v.length && (l(), v = [], m = []);
                return v.length && l(), g.length ? g.join("") : null
            }
            var n = Rn,
                i = Rn,
                r = 0,
                o = qn,
                a = Re,
                s = Po,
                l = s.key,
                u = s,
                c = "L",
                d = .7;
            return e.x = function(t) { return arguments.length ? (n = i = t, e) : i }, e.x0 = function(t) { return arguments.length ? (n = t, e) : n }, e.x1 = function(t) { return arguments.length ? (i = t, e) : i }, e.y = function(t) { return arguments.length ? (r = o = t, e) : o }, e.y0 = function(t) { return arguments.length ? (r = t, e) : r }, e.y1 = function(t) { return arguments.length ? (o = t, e) : o }, e.defined = function(t) { return arguments.length ? (a = t, e) : a }, e.interpolate = function(t) { return arguments.length ? (l = "function" == typeof t ? s = t : (s = Bl.get(t) || Po).key, u = s.reverse || s, c = s.closed ? "M" : "L", e) : l }, e.tension = function(t) { return arguments.length ? (d = t, e) : d }, e
        }

        function Jo(t) { return t.radius }

        function Qo(t) { return [t.x, t.y] }

        function ta(t) {
            return function() {
                var e = t.apply(this, arguments),
                    n = e[0],
                    i = e[1] - Ga;
                return [n * Math.cos(i), n * Math.sin(i)]
            }
        }

        function ea() { return 64 }

        function na() { return "circle" }

        function ia(t) { var e = Math.sqrt(t / Xa); return "M0," + e + "A" + e + "," + e + " 0 1,1 0," + -e + "A" + e + "," + e + " 0 1,1 0," + e + "Z" }

        function ra(t) {
            return function() {
                var e, n, i;
                (e = this[t]) && (i = e[n = e.active]) && (i.timer.c = null, i.timer.t = NaN, --e.count ? delete e[n] : delete this[t], e.active += .5, i.event && i.event.interrupt.call(this, this.__data__, i.index))
            }
        }

        function oa(t, e, n) { return Oa(t, Jl), t.namespace = e, t.id = n, t }

        function aa(t, e, n, i) {
            var r = t.id,
                o = t.namespace;
            return J(t, "function" == typeof n ? function(t, a, s) { t[o][r].tween.set(e, i(n.call(t, t.__data__, a, s))) } : (n = i(n), function(t) { t[o][r].tween.set(e, n) }))
        }

        function sa(t) {
            return null == t && (t = ""),
                function() { this.textContent = t }
        }

        function la(t) { return null == t ? "__transition__" : "__transition_" + t + "__" }

        function ua(t, e, n, i, r) {
            function o(t) { var e = p.delay; return u.t = e + l, e <= t ? a(t - e) : void(u.c = a) }

            function a(n) {
                var r = f.active,
                    o = f[r];
                o && (o.timer.c = null, o.timer.t = NaN, --f.count, delete f[r], o.event && o.event.interrupt.call(t, t.__data__, o.index));
                for (var a in f)
                    if (+a < i) {
                        var g = f[a];
                        g.timer.c = null, g.timer.t = NaN, --f.count, delete f[a]
                    } u.c = s, Ft(function() { return u.c && s(n || 1) && (u.c = null, u.t = NaN), 1 }, 0, l), f.active = i, p.event && p.event.start.call(t, t.__data__, e), h = [], p.tween.forEach(function(n, i) {
                    (i = i.call(t, t.__data__, e)) && h.push(i)
                }), d = p.ease, c = p.duration
            }

            function s(r) { for (var o = r / c, a = d(o), s = h.length; s > 0;) h[--s].call(t, a); if (o >= 1) return p.event && p.event.end.call(t, t.__data__, e), --f.count ? delete f[i] : delete t[n], 1 }
            var l, u, c, d, h, f = t[n] || (t[n] = { active: 0, count: 0 }),
                p = f[i];
            p || (l = r.time, u = Ft(o, 0, l), p = f[i] = { tween: new y, time: l, timer: u, delay: r.delay, duration: r.duration, ease: r.ease, index: e }, r = null, ++f.count)
        }

        function ca(t, e, n) { t.attr("transform", function(t) { var i = e(t); return "translate(" + (isFinite(i) ? i : n(t)) + ",0)" }) }

        function da(t, e, n) { t.attr("transform", function(t) { var i = e(t); return "translate(0," + (isFinite(i) ? i : n(t)) + ")" }) }

        function ha(t) { return t.toISOString() }

        function fa(t, e, n) {
            function i(e) { return t(e) }

            function r(t, n) {
                var i = t[1] - t[0],
                    r = i / n,
                    o = ma.bisect(su, r);
                return o == su.length ? [e.year, so(t.map(function(t) { return t / 31536e6 }), n)[2]] : o ? e[r / su[o - 1] < su[o] / r ? o - 1 : o] : [cu, so(t, n)[2]]
            }
            return i.invert = function(e) { return pa(t.invert(e)) }, i.domain = function(e) { return arguments.length ? (t.domain(e), i) : t.domain().map(pa) }, i.nice = function(t, e) {
                function n(n) { return !isNaN(n) && !t.range(n, pa(+n + 1), e).length }
                var o = i.domain(),
                    a = Jr(o),
                    s = null == t ? r(a, 10) : "number" == typeof t && r(a, t);
                return s && (t = s[0], e = s[1]), i.domain(eo(o, e > 1 ? { floor: function(e) { for (; n(e = t.floor(e));) e = pa(e - 1); return e }, ceil: function(e) { for (; n(e = t.ceil(e));) e = pa(+e + 1); return e } } : t))
            }, i.ticks = function(t, e) {
                var n = Jr(i.domain()),
                    o = null == t ? r(n, 10) : "number" == typeof t ? r(n, t) : !t.range && [{ range: t }, e];
                return o && (t = o[0], e = o[1]), t.range(n[0], pa(+n[1] + 1), e < 1 ? 1 : e)
            }, i.tickFormat = function() { return n }, i.copy = function() { return fa(t.copy(), e, n) }, oo(i, t)
        }

        function pa(t) { return new Date(t) }

        function ga(t) { return JSON.parse(t.responseText) }

        function va(t) { var e = xa.createRange(); return e.selectNode(xa.body), e.createContextualFragment(t.responseText) }
        var ma = { version: "3.5.17" },
            ya = [].slice,
            ba = function(t) { return ya.call(t) },
            xa = this.document;
        if (xa) try { ba(xa.documentElement.childNodes)[0].nodeType } catch (wa) { ba = function(t) { for (var e = t.length, n = new Array(e); e--;) n[e] = t[e]; return n } }
        if (Date.now || (Date.now = function() { return +new Date }), xa) try { xa.createElement("DIV").style.setProperty("opacity", 0, "") } catch (ka) {
            var Sa = this.Element.prototype,
                _a = Sa.setAttribute,
                Ta = Sa.setAttributeNS,
                Ca = this.CSSStyleDeclaration.prototype,
                Ma = Ca.setProperty;
            Sa.setAttribute = function(t, e) { _a.call(this, t, e + "") }, Sa.setAttributeNS = function(t, e, n) { Ta.call(this, t, e, n + "") }, Ca.setProperty = function(t, e, n) { Ma.call(this, t, e + "", n) }
        }
        ma.ascending = l, ma.descending = function(t, e) { return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN }, ma.min = function(t, e) {
            var n, i, r = -1,
                o = t.length;
            if (1 === arguments.length) {
                for (; ++r < o;)
                    if (null != (i = t[r]) && i >= i) { n = i; break } for (; ++r < o;) null != (i = t[r]) && n > i && (n = i)
            } else {
                for (; ++r < o;)
                    if (null != (i = e.call(t, t[r], r)) && i >= i) { n = i; break } for (; ++r < o;) null != (i = e.call(t, t[r], r)) && n > i && (n = i)
            }
            return n
        }, ma.max = function(t, e) {
            var n, i, r = -1,
                o = t.length;
            if (1 === arguments.length) {
                for (; ++r < o;)
                    if (null != (i = t[r]) && i >= i) { n = i; break } for (; ++r < o;) null != (i = t[r]) && i > n && (n = i)
            } else {
                for (; ++r < o;)
                    if (null != (i = e.call(t, t[r], r)) && i >= i) { n = i; break } for (; ++r < o;) null != (i = e.call(t, t[r], r)) && i > n && (n = i)
            }
            return n
        }, ma.extent = function(t, e) {
            var n, i, r, o = -1,
                a = t.length;
            if (1 === arguments.length) {
                for (; ++o < a;)
                    if (null != (i = t[o]) && i >= i) { n = r = i; break } for (; ++o < a;) null != (i = t[o]) && (n > i && (n = i), r < i && (r = i))
            } else {
                for (; ++o < a;)
                    if (null != (i = e.call(t, t[o], o)) && i >= i) { n = r = i; break } for (; ++o < a;) null != (i = e.call(t, t[o], o)) && (n > i && (n = i), r < i && (r = i))
            }
            return [n, r]
        }, ma.sum = function(t, e) {
            var n, i = 0,
                r = t.length,
                o = -1;
            if (1 === arguments.length)
                for (; ++o < r;) h(n = +t[o]) && (i += n);
            else
                for (; ++o < r;) h(n = +e.call(t, t[o], o)) && (i += n);
            return i
        }, ma.mean = function(t, e) {
            var n, i = 0,
                r = t.length,
                o = -1,
                a = r;
            if (1 === arguments.length)
                for (; ++o < r;) h(n = c(t[o])) ? i += n : --a;
            else
                for (; ++o < r;) h(n = c(e.call(t, t[o], o))) ? i += n : --a;
            if (a) return i / a
        }, ma.quantile = function(t, e) {
            var n = (t.length - 1) * e + 1,
                i = Math.floor(n),
                r = +t[i - 1],
                o = n - i;
            return o ? r + o * (t[i] - r) : r
        }, ma.median = function(t, e) {
            var n, i = [],
                r = t.length,
                o = -1;
            if (1 === arguments.length)
                for (; ++o < r;) h(n = c(t[o])) && i.push(n);
            else
                for (; ++o < r;) h(n = c(e.call(t, t[o], o))) && i.push(n);
            if (i.length) return ma.quantile(i.sort(l), .5)
        }, ma.variance = function(t, e) {
            var n, i, r = t.length,
                o = 0,
                a = 0,
                s = -1,
                l = 0;
            if (1 === arguments.length)
                for (; ++s < r;) h(n = c(t[s])) && (i = n - o, o += i / ++l, a += i * (n - o));
            else
                for (; ++s < r;) h(n = c(e.call(t, t[s], s))) && (i = n - o, o += i / ++l, a += i * (n - o));
            if (l > 1) return a / (l - 1)
        }, ma.deviation = function() { var t = ma.variance.apply(this, arguments); return t ? Math.sqrt(t) : t };
        var Aa = p(l);
        ma.bisectLeft = Aa.left, ma.bisect = ma.bisectRight = Aa.right, ma.bisector = function(t) { return p(1 === t.length ? function(e, n) { return l(t(e), n) } : t) }, ma.shuffle = function(t, e, n) {
            (o = arguments.length) < 3 && (n = t.length, o < 2 && (e = 0));
            for (var i, r, o = n - e; o;) r = Math.random() * o-- | 0, i = t[o + e], t[o + e] = t[r + e], t[r + e] = i;
            return t
        }, ma.permute = function(t, e) { for (var n = e.length, i = new Array(n); n--;) i[n] = t[e[n]]; return i }, ma.pairs = function(t) { for (var e, n = 0, i = t.length - 1, r = t[0], o = new Array(i < 0 ? 0 : i); n < i;) o[n] = [e = r, r = t[++n]]; return o }, ma.transpose = function(t) {
            if (!(r = t.length)) return [];
            for (var e = -1, n = ma.min(t, g), i = new Array(n); ++e < n;)
                for (var r, o = -1, a = i[e] = new Array(r); ++o < r;) a[o] = t[o][e];
            return i
        }, ma.zip = function() { return ma.transpose(arguments) }, ma.keys = function(t) { var e = []; for (var n in t) e.push(n); return e }, ma.values = function(t) { var e = []; for (var n in t) e.push(t[n]); return e }, ma.entries = function(t) { var e = []; for (var n in t) e.push({ key: n, value: t[n] }); return e }, ma.merge = function(t) {
            for (var e, n, i, r = t.length, o = -1, a = 0; ++o < r;) a += t[o].length;
            for (n = new Array(a); --r >= 0;)
                for (i = t[r], e = i.length; --e >= 0;) n[--a] = i[e];
            return n
        };
        var Ea = Math.abs;
        ma.range = function(t, e, n) {
            if (arguments.length < 3 && (n = 1, arguments.length < 2 && (e = t, t = 0)), (e - t) / n === 1 / 0) throw new Error("infinite range");
            var i, r = [],
                o = v(Ea(n)),
                a = -1;
            if (t *= o, e *= o, n *= o, n < 0)
                for (;
                    (i = t + n * ++a) > e;) r.push(i / o);
            else
                for (;
                    (i = t + n * ++a) < e;) r.push(i / o);
            return r
        }, ma.map = function(t, e) {
            var n = new y;
            if (t instanceof y) t.forEach(function(t, e) { n.set(t, e) });
            else if (Array.isArray(t)) {
                var i, r = -1,
                    o = t.length;
                if (1 === arguments.length)
                    for (; ++r < o;) n.set(r, t[r]);
                else
                    for (; ++r < o;) n.set(e.call(t, i = t[r], r), i)
            } else
                for (var a in t) n.set(a, t[a]);
            return n
        };
        var Pa = "__proto__",
            Ia = "\0";
        m(y, { has: w, get: function(t) { return this._[b(t)] }, set: function(t, e) { return this._[b(t)] = e }, remove: k, keys: S, values: function fu() { var fu = []; for (var t in this._) fu.push(this._[t]); return fu }, entries: function pu() { var pu = []; for (var t in this._) pu.push({ key: x(t), value: this._[t] }); return pu }, size: _, empty: T, forEach: function(t) { for (var e in this._) t.call(this, x(e), this._[e]) } }), ma.nest = function() {
            function t(e, a, s) { if (s >= o.length) return i ? i.call(r, a) : n ? a.sort(n) : a; for (var l, u, c, d, h = -1, f = a.length, p = o[s++], g = new y; ++h < f;)(d = g.get(l = p(u = a[h]))) ? d.push(u) : g.set(l, [u]); return e ? (u = e(), c = function(n, i) { u.set(n, t(e, i, s)) }) : (u = {}, c = function(n, i) { u[n] = t(e, i, s) }), g.forEach(c), u }

            function e(t, n) {
                if (n >= o.length) return t;
                var i = [],
                    r = a[n++];
                return t.forEach(function(t, r) { i.push({ key: t, values: e(r, n) }) }), r ? i.sort(function(t, e) { return r(t.key, e.key) }) : i
            }
            var n, i, r = {},
                o = [],
                a = [];
            return r.map = function(e, n) { return t(n, e, 0) }, r.entries = function(n) { return e(t(ma.map, n, 0), 0) }, r.key = function(t) { return o.push(t), r }, r.sortKeys = function(t) { return a[o.length - 1] = t, r }, r.sortValues = function(t) { return n = t, r }, r.rollup = function(t) { return i = t, r }, r
        }, ma.set = function(t) {
            var e = new C;
            if (t)
                for (var n = 0, i = t.length; n < i; ++n) e.add(t[n]);
            return e
        }, m(C, { has: w, add: function(t) { return this._[b(t += "")] = !0, t }, remove: k, values: S, size: _, empty: T, forEach: function(t) { for (var e in this._) t.call(this, x(e)) } }), ma.behavior = {}, ma.rebind = function(t, e) { for (var n, i = 1, r = arguments.length; ++i < r;) t[n = arguments[i]] = A(t, e, e[n]); return t };
        var za = ["webkit", "ms", "moz", "Moz", "o", "O"];
        ma.dispatch = function() { for (var t = new I, e = -1, n = arguments.length; ++e < n;) t[arguments[e]] = z(t); return t }, I.prototype.on = function(t, e) {
            var n = t.indexOf("."),
                i = "";
            if (n >= 0 && (i = t.slice(n + 1), t = t.slice(0, n)), t) return arguments.length < 2 ? this[t].on(i) : this[t].on(i, e);
            if (2 === arguments.length) {
                if (null == e)
                    for (t in this) this.hasOwnProperty(t) && this[t].on(i, null);
                return this
            }
        }, ma.event = null, ma.requote = function(t) { return t.replace(Da, "\\$&") };
        var Da = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g,
            Oa = {}.__proto__ ? function(t, e) { t.__proto__ = e } : function(t, e) { for (var n in e) t[n] = e[n] },
            La = function(t, e) { return e.querySelector(t) },
            $a = function(t, e) { return e.querySelectorAll(t) },
            Na = function(t, e) { var n = t.matches || t[E(t, "matchesSelector")]; return (Na = function(t, e) { return n.call(t, e) })(t, e) };
        "function" == typeof Sizzle && (La = function(t, e) { return Sizzle(t, e)[0] || null }, $a = Sizzle, Na = Sizzle.matchesSelector), ma.selection = function() { return ma.select(xa.documentElement) };
        var Ra = ma.selection.prototype = [];
        Ra.select = function(t) {
            var e, n, i, r, o = [];
            t = N(t);
            for (var a = -1, s = this.length; ++a < s;) { o.push(e = []), e.parentNode = (i = this[a]).parentNode; for (var l = -1, u = i.length; ++l < u;)(r = i[l]) ? (e.push(n = t.call(r, r.__data__, l, a)), n && "__data__" in r && (n.__data__ = r.__data__)) : e.push(null) }
            return $(o)
        }, Ra.selectAll = function(t) {
            var e, n, i = [];
            t = R(t);
            for (var r = -1, o = this.length; ++r < o;)
                for (var a = this[r], s = -1, l = a.length; ++s < l;)(n = a[s]) && (i.push(e = ba(t.call(n, n.__data__, s, r))), e.parentNode = n);
            return $(i)
        };
        var qa = "http://www.w3.org/1999/xhtml",
            Fa = { svg: "http://www.w3.org/2000/svg", xhtml: qa, xlink: "http://www.w3.org/1999/xlink", xml: "http://www.w3.org/XML/1998/namespace", xmlns: "http://www.w3.org/2000/xmlns/" };
        ma.ns = {
            prefix: Fa,
            qualify: function(t) {
                var e = t.indexOf(":"),
                    n = t;
                return e >= 0 && "xmlns" !== (n = t.slice(0, e)) && (t = t.slice(e + 1)), Fa.hasOwnProperty(n) ? { space: Fa[n], local: t } : t
            }
        }, Ra.attr = function(t, e) { if (arguments.length < 2) { if ("string" == typeof t) { var n = this.node(); return t = ma.ns.qualify(t), t.local ? n.getAttributeNS(t.space, t.local) : n.getAttribute(t) } for (e in t) this.each(q(e, t[e])); return this } return this.each(q(t, e)) }, Ra.classed = function(t, e) {
            if (arguments.length < 2) {
                if ("string" == typeof t) {
                    var n = this.node(),
                        i = (t = B(t)).length,
                        r = -1;
                    if (e = n.classList) {
                        for (; ++r < i;)
                            if (!e.contains(t[r])) return !1
                    } else
                        for (e = n.getAttribute("class"); ++r < i;)
                            if (!H(t[r]).test(e)) return !1;
                    return !0
                }
                for (e in t) this.each(W(e, t[e]));
                return this
            }
            return this.each(W(t, e))
        }, Ra.style = function(t, e, n) { var i = arguments.length; if (i < 3) { if ("string" != typeof t) { i < 2 && (e = ""); for (n in t) this.each(Y(n, t[n], e)); return this } if (i < 2) { var r = this.node(); return a(r).getComputedStyle(r, null).getPropertyValue(t) } n = "" } return this.each(Y(t, e, n)) }, Ra.property = function(t, e) { if (arguments.length < 2) { if ("string" == typeof t) return this.node()[t]; for (e in t) this.each(U(e, t[e])); return this } return this.each(U(t, e)) }, Ra.text = function(t) {
            return arguments.length ? this.each("function" == typeof t ? function() {
                var e = t.apply(this, arguments);
                this.textContent = null == e ? "" : e
            } : null == t ? function() { this.textContent = "" } : function() { this.textContent = t }) : this.node().textContent
        }, Ra.html = function(t) {
            return arguments.length ? this.each("function" == typeof t ? function() {
                var e = t.apply(this, arguments);
                this.innerHTML = null == e ? "" : e
            } : null == t ? function() { this.innerHTML = "" } : function() { this.innerHTML = t }) : this.node().innerHTML
        }, Ra.append = function(t) { return t = V(t), this.select(function() { return this.appendChild(t.apply(this, arguments)) }) }, Ra.insert = function(t, e) { return t = V(t), e = N(e), this.select(function() { return this.insertBefore(t.apply(this, arguments), e.apply(this, arguments) || null) }) }, Ra.remove = function() { return this.each(X) }, Ra.data = function(t, e) {
            function n(t, n) {
                var i, r, o, a = t.length,
                    c = n.length,
                    d = Math.min(a, c),
                    h = new Array(c),
                    f = new Array(c),
                    p = new Array(a);
                if (e) {
                    var g, v = new y,
                        m = new Array(a);
                    for (i = -1; ++i < a;)(r = t[i]) && (v.has(g = e.call(r, r.__data__, i)) ? p[i] = r : v.set(g, r), m[i] = g);
                    for (i = -1; ++i < c;)(r = v.get(g = e.call(n, o = n[i], i))) ? r !== !0 && (h[i] = r, r.__data__ = o) : f[i] = Z(o), v.set(g, !0);
                    for (i = -1; ++i < a;) i in m && v.get(m[i]) !== !0 && (p[i] = t[i])
                } else { for (i = -1; ++i < d;) r = t[i], o = n[i], r ? (r.__data__ = o, h[i] = r) : f[i] = Z(o); for (; i < c; ++i) f[i] = Z(n[i]); for (; i < a; ++i) p[i] = t[i] } f.update = h, f.parentNode = h.parentNode = p.parentNode = t.parentNode, s.push(f), l.push(h), u.push(p)
            }
            var i, r, o = -1,
                a = this.length;
            if (!arguments.length) { for (t = new Array(a = (i = this[0]).length); ++o < a;)(r = i[o]) && (t[o] = r.__data__); return t }
            var s = Q([]),
                l = $([]),
                u = $([]);
            if ("function" == typeof t)
                for (; ++o < a;) n(i = this[o], t.call(i, i.parentNode.__data__, o));
            else
                for (; ++o < a;) n(i = this[o], t);
            return l.enter = function() { return s }, l.exit = function() { return u }, l
        }, Ra.datum = function(t) { return arguments.length ? this.property("__data__", t) : this.property("__data__") }, Ra.filter = function(t) { var e, n, i, r = []; "function" != typeof t && (t = K(t)); for (var o = 0, a = this.length; o < a; o++) { r.push(e = []), e.parentNode = (n = this[o]).parentNode; for (var s = 0, l = n.length; s < l; s++)(i = n[s]) && t.call(i, i.__data__, s, o) && e.push(i) } return $(r) }, Ra.order = function() {
            for (var t = -1, e = this.length; ++t < e;)
                for (var n, i = this[t], r = i.length - 1, o = i[r]; --r >= 0;)(n = i[r]) && (o && o !== n.nextSibling && o.parentNode.insertBefore(n, o), o = n);
            return this
        }, Ra.sort = function(t) { t = G.apply(this, arguments); for (var e = -1, n = this.length; ++e < n;) this[e].sort(t); return this.order() }, Ra.each = function(t) { return J(this, function(e, n, i) { t.call(e, e.__data__, n, i) }) }, Ra.call = function(t) { var e = ba(arguments); return t.apply(e[0] = this, e), this }, Ra.empty = function() { return !this.node() }, Ra.node = function() {
            for (var t = 0, e = this.length; t < e; t++)
                for (var n = this[t], i = 0, r = n.length; i < r; i++) { var o = n[i]; if (o) return o }
            return null
        }, Ra.size = function() { var t = 0; return J(this, function() {++t }), t };
        var Ha = [];
        ma.selection.enter = Q, ma.selection.enter.prototype = Ha, Ha.append = Ra.append, Ha.empty = Ra.empty, Ha.node = Ra.node, Ha.call = Ra.call, Ha.size = Ra.size, Ha.select = function(t) { for (var e, n, i, r, o, a = [], s = -1, l = this.length; ++s < l;) { i = (r = this[s]).update, a.push(e = []), e.parentNode = r.parentNode; for (var u = -1, c = r.length; ++u < c;)(o = r[u]) ? (e.push(i[u] = n = t.call(r.parentNode, o.__data__, u, s)), n.__data__ = o.__data__) : e.push(null) } return $(a) }, Ha.insert = function(t, e) { return arguments.length < 2 && (e = tt(this)), Ra.insert.call(this, t, e) }, ma.select = function(t) { var e; return "string" == typeof t ? (e = [La(t, xa)], e.parentNode = xa.documentElement) : (e = [t], e.parentNode = i(t)), $([e]) }, ma.selectAll = function(t) { var e; return "string" == typeof t ? (e = ba($a(t, xa)), e.parentNode = xa.documentElement) : (e = ba(t), e.parentNode = null), $([e]) }, Ra.on = function(t, e, n) {
            var i = arguments.length;
            if (i < 3) {
                if ("string" != typeof t) { i < 2 && (e = !1); for (n in t) this.each(et(n, t[n], e)); return this }
                if (i < 2) return (i = this.node()["__on" + t]) && i._;
                n = !1
            }
            return this.each(et(t, e, n))
        };
        var Ba = ma.map({ mouseenter: "mouseover", mouseleave: "mouseout" });
        xa && Ba.forEach(function(t) { "on" + t in xa && Ba.remove(t) });
        var Wa, ja = 0;
        ma.mouse = function(t) { return ot(t, O()) };
        var Ya = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
        ma.touch = function(t, e, n) {
            if (arguments.length < 3 && (n = e, e = O().changedTouches), e)
                for (var i, r = 0, o = e.length; r < o; ++r)
                    if ((i = e[r]).identifier === n) return ot(t, i)
        }, ma.behavior.drag = function() {
            function t() { this.on("mousedown.drag", r).on("touchstart.drag", o) }

            function e(t, e, r, o, a) {
                return function() {
                    function s() {
                        var t, n, i = e(h, g);
                        i && (t = i[0] - b[0], n = i[1] - b[1], p |= t | n, b = i, f({ type: "drag", x: i[0] + u[0], y: i[1] + u[1], dx: t, dy: n }))
                    }

                    function l() { e(h, g) && (m.on(o + v, null).on(a + v, null), y(p), f({ type: "dragend" })) }
                    var u, c = this,
                        d = ma.event.target.correspondingElement || ma.event.target,
                        h = c.parentNode,
                        f = n.of(c, arguments),
                        p = 0,
                        g = t(),
                        v = ".drag" + (null == g ? "" : "-" + g),
                        m = ma.select(r(d)).on(o + v, s).on(a + v, l),
                        y = rt(d),
                        b = e(h, g);
                    i ? (u = i.apply(c, arguments), u = [u.x - b[0], u.y - b[1]]) : u = [0, 0], f({ type: "dragstart" })
                }
            }
            var n = L(t, "drag", "dragstart", "dragend"),
                i = null,
                r = e(P, ma.mouse, a, "mousemove", "mouseup"),
                o = e(at, ma.touch, M, "touchmove", "touchend");
            return t.origin = function(e) { return arguments.length ? (i = e, t) : i }, ma.rebind(t, n, "on")
        }, ma.touches = function(t, e) { return arguments.length < 2 && (e = O().touches), e ? ba(e).map(function(e) { var n = ot(t, e); return n.identifier = e.identifier, n }) : [] };
        var Ua = 1e-6,
            Va = Ua * Ua,
            Xa = Math.PI,
            Za = 2 * Xa,
            Ka = Za - Ua,
            Ga = Xa / 2,
            Ja = Xa / 180,
            Qa = 180 / Xa,
            ts = Math.SQRT2,
            es = 2,
            ns = 4;
        ma.interpolateZoom = function(t, e) {
            var n, i, r = t[0],
                o = t[1],
                a = t[2],
                s = e[0],
                l = e[1],
                u = e[2],
                c = s - r,
                d = l - o,
                h = c * c + d * d;
            if (h < Va) i = Math.log(u / a) / ts, n = function(t) { return [r + t * c, o + t * d, a * Math.exp(ts * t * i)] };
            else {
                var f = Math.sqrt(h),
                    p = (u * u - a * a + ns * h) / (2 * a * es * f),
                    g = (u * u - a * a - ns * h) / (2 * u * es * f),
                    v = Math.log(Math.sqrt(p * p + 1) - p),
                    m = Math.log(Math.sqrt(g * g + 1) - g);
                i = (m - v) / ts, n = function(t) {
                    var e = t * i,
                        n = ht(v),
                        s = a / (es * f) * (n * ft(ts * e + v) - dt(v));
                    return [r + s * c, o + s * d, a * n / ht(ts * e + v)]
                }
            }
            return n.duration = 1e3 * i, n
        }, ma.behavior.zoom = function() {
            function t(t) { t.on(E, d).on(rs + ".zoom", f).on("dblclick.zoom", p).on(z, h) }

            function e(t) { return [(t[0] - _.x) / _.k, (t[1] - _.y) / _.k] }

            function n(t) { return [t[0] * _.k + _.x, t[1] * _.k + _.y] }

            function i(t) { _.k = Math.max(C[0], Math.min(C[1], t)) }

            function r(t, e) { e = n(e), _.x += t[0] - e[0], _.y += t[1] - e[1] }

            function o(e, n, o, a) { e.__chart__ = { x: _.x, y: _.y, k: _.k }, i(Math.pow(2, a)), r(v = n, o), e = ma.select(e), M > 0 && (e = e.transition().duration(M)), e.call(t.event) }

            function s() { w && w.domain(x.range().map(function(t) { return (t - _.x) / _.k }).map(x.invert)), S && S.domain(k.range().map(function(t) { return (t - _.y) / _.k }).map(k.invert)) }

            function l(t) { A++ || t({ type: "zoomstart" }) }

            function u(t) { s(), t({ type: "zoom", scale: _.k, translate: [_.x, _.y] }) }

            function c(t) {--A || (t({ type: "zoomend" }), v = null) }

            function d() {
                function t() { s = 1, r(ma.mouse(i), h), u(o) }

                function n() { d.on(P, null).on(I, null), f(s), c(o) }
                var i = this,
                    o = O.of(i, arguments),
                    s = 0,
                    d = ma.select(a(i)).on(P, t).on(I, n),
                    h = e(ma.mouse(i)),
                    f = rt(i);
                Gl.call(i), l(o)
            }

            function h() {
                function t() { var t = ma.touches(p); return f = _.k, t.forEach(function(t) { t.identifier in v && (v[t.identifier] = e(t)) }), t }

                function n() {
                    var e = ma.event.target;
                    ma.select(e).on(x, a).on(w, s), k.push(e);
                    for (var n = ma.event.changedTouches, i = 0, r = n.length; i < r; ++i) v[n[i].identifier] = null;
                    var l = t(),
                        u = Date.now();
                    if (1 === l.length) {
                        if (u - b < 500) {
                            var c = l[0];
                            o(p, c, v[c.identifier], Math.floor(Math.log(_.k) / Math.LN2) + 1), D()
                        }
                        b = u
                    } else if (l.length > 1) {
                        var c = l[0],
                            d = l[1],
                            h = c[0] - d[0],
                            f = c[1] - d[1];
                        m = h * h + f * f
                    }
                }

                function a() {
                    var t, e, n, o, a = ma.touches(p);
                    Gl.call(p);
                    for (var s = 0, l = a.length; s < l; ++s, o = null)
                        if (n = a[s], o = v[n.identifier]) {
                            if (e) break;
                            t = n, e = o
                        } if (o) {
                        var c = (c = n[0] - t[0]) * c + (c = n[1] - t[1]) * c,
                            d = m && Math.sqrt(c / m);
                        t = [(t[0] + n[0]) / 2, (t[1] + n[1]) / 2], e = [(e[0] + o[0]) / 2, (e[1] + o[1]) / 2], i(d * f)
                    }
                    b = null, r(t, e), u(g)
                }

                function s() { if (ma.event.touches.length) { for (var e = ma.event.changedTouches, n = 0, i = e.length; n < i; ++n) delete v[e[n].identifier]; for (var r in v) return void t() } ma.selectAll(k).on(y, null), S.on(E, d).on(z, h), T(), c(g) }
                var f, p = this,
                    g = O.of(p, arguments),
                    v = {},
                    m = 0,
                    y = ".zoom-" + ma.event.changedTouches[0].identifier,
                    x = "touchmove" + y,
                    w = "touchend" + y,
                    k = [],
                    S = ma.select(p),
                    T = rt(p);
                n(), l(g), S.on(E, null).on(z, n)
            }

            function f() {
                var t = O.of(this, arguments);
                y ? clearTimeout(y) : (Gl.call(this), g = e(v = m || ma.mouse(this)), l(t)), y = setTimeout(function() { y = null, c(t) }, 50), D(), i(Math.pow(2, .002 * is()) * _.k), r(v, g), u(t)
            }

            function p() {
                var t = ma.mouse(this),
                    n = Math.log(_.k) / Math.LN2;
                o(this, t, e(t), ma.event.shiftKey ? Math.ceil(n) - 1 : Math.floor(n) + 1)
            }
            var g, v, m, y, b, x, w, k, S, _ = { x: 0, y: 0, k: 1 },
                T = [960, 500],
                C = os,
                M = 250,
                A = 0,
                E = "mousedown.zoom",
                P = "mousemove.zoom",
                I = "mouseup.zoom",
                z = "touchstart.zoom",
                O = L(t, "zoomstart", "zoom", "zoomend");
            return rs || (rs = "onwheel" in xa ? (is = function() { return -ma.event.deltaY * (ma.event.deltaMode ? 120 : 1) }, "wheel") : "onmousewheel" in xa ? (is = function() { return ma.event.wheelDelta }, "mousewheel") : (is = function() { return -ma.event.detail }, "MozMousePixelScroll")), t.event = function(t) {
                t.each(function() {
                    var t = O.of(this, arguments),
                        e = _;
                    Zl ? ma.select(this).transition().each("start.zoom", function() { _ = this.__chart__ || { x: 0, y: 0, k: 1 }, l(t) }).tween("zoom:zoom", function() {
                        var n = T[0],
                            i = T[1],
                            r = v ? v[0] : n / 2,
                            o = v ? v[1] : i / 2,
                            a = ma.interpolateZoom([(r - _.x) / _.k, (o - _.y) / _.k, n / _.k], [(r - e.x) / e.k, (o - e.y) / e.k, n / e.k]);
                        return function(e) {
                            var i = a(e),
                                s = n / i[2];
                            this.__chart__ = _ = { x: r - i[0] * s, y: o - i[1] * s, k: s }, u(t)
                        }
                    }).each("interrupt.zoom", function() { c(t) }).each("end.zoom", function() { c(t) }) : (this.__chart__ = _, l(t), u(t), c(t))
                })
            }, t.translate = function(e) { return arguments.length ? (_ = { x: +e[0], y: +e[1], k: _.k }, s(), t) : [_.x, _.y] }, t.scale = function(e) { return arguments.length ? (_ = { x: _.x, y: _.y, k: null }, i(+e), s(), t) : _.k }, t.scaleExtent = function(e) { return arguments.length ? (C = null == e ? os : [+e[0], +e[1]], t) : C }, t.center = function(e) { return arguments.length ? (m = e && [+e[0], +e[1]], t) : m }, t.size = function(e) { return arguments.length ? (T = e && [+e[0], +e[1]], t) : T }, t.duration = function(e) { return arguments.length ? (M = +e, t) : M }, t.x = function(e) { return arguments.length ? (w = e, x = e.copy(), _ = { x: 0, y: 0, k: 1 }, t) : w }, t.y = function(e) { return arguments.length ? (S = e, k = e.copy(), _ = { x: 0, y: 0, k: 1 }, t) : S }, ma.rebind(t, O, "on")
        };
        var is, rs, os = [0, 1 / 0];
        ma.color = gt, gt.prototype.toString = function() { return this.rgb() + "" }, ma.hsl = vt;
        var as = vt.prototype = new gt;
        as.brighter = function(t) { return t = Math.pow(.7, arguments.length ? t : 1), new vt(this.h, this.s, this.l / t) }, as.darker = function(t) { return t = Math.pow(.7, arguments.length ? t : 1), new vt(this.h, this.s, t * this.l) }, as.rgb = function() { return mt(this.h, this.s, this.l) }, ma.hcl = yt;
        var ss = yt.prototype = new gt;
        ss.brighter = function(t) { return new yt(this.h, this.c, Math.min(100, this.l + ls * (arguments.length ? t : 1))) }, ss.darker = function(t) { return new yt(this.h, this.c, Math.max(0, this.l - ls * (arguments.length ? t : 1))) }, ss.rgb = function() { return bt(this.h, this.c, this.l).rgb() }, ma.lab = xt;
        var ls = 18,
            us = .95047,
            cs = 1,
            ds = 1.08883,
            hs = xt.prototype = new gt;
        hs.brighter = function(t) { return new xt(Math.min(100, this.l + ls * (arguments.length ? t : 1)), this.a, this.b) }, hs.darker = function(t) { return new xt(Math.max(0, this.l - ls * (arguments.length ? t : 1)), this.a, this.b) }, hs.rgb = function() { return wt(this.l, this.a, this.b) }, ma.rgb = Ct;
        var fs = Ct.prototype = new gt;
        fs.brighter = function(t) {
            t = Math.pow(.7, arguments.length ? t : 1);
            var e = this.r,
                n = this.g,
                i = this.b,
                r = 30;
            return e || n || i ? (e && e < r && (e = r), n && n < r && (n = r), i && i < r && (i = r), new Ct(Math.min(255, e / t), Math.min(255, n / t), Math.min(255, i / t))) : new Ct(r, r, r)
        }, fs.darker = function(t) { return t = Math.pow(.7, arguments.length ? t : 1), new Ct(t * this.r, t * this.g, t * this.b) }, fs.hsl = function() { return It(this.r, this.g, this.b) }, fs.toString = function() { return "#" + Et(this.r) + Et(this.g) + Et(this.b) };
        var ps = ma.map({ aliceblue: 15792383, antiquewhite: 16444375, aqua: 65535, aquamarine: 8388564, azure: 15794175, beige: 16119260, bisque: 16770244, black: 0, blanchedalmond: 16772045, blue: 255, blueviolet: 9055202, brown: 10824234, burlywood: 14596231, cadetblue: 6266528, chartreuse: 8388352, chocolate: 13789470, coral: 16744272, cornflowerblue: 6591981, cornsilk: 16775388, crimson: 14423100, cyan: 65535, darkblue: 139, darkcyan: 35723, darkgoldenrod: 12092939, darkgray: 11119017, darkgreen: 25600, darkgrey: 11119017, darkkhaki: 12433259, darkmagenta: 9109643, darkolivegreen: 5597999, darkorange: 16747520, darkorchid: 10040012, darkred: 9109504, darksalmon: 15308410, darkseagreen: 9419919, darkslateblue: 4734347, darkslategray: 3100495, darkslategrey: 3100495, darkturquoise: 52945, darkviolet: 9699539, deeppink: 16716947, deepskyblue: 49151, dimgray: 6908265, dimgrey: 6908265, dodgerblue: 2003199, firebrick: 11674146, floralwhite: 16775920, forestgreen: 2263842, fuchsia: 16711935, gainsboro: 14474460, ghostwhite: 16316671, gold: 16766720, goldenrod: 14329120, gray: 8421504, green: 32768, greenyellow: 11403055, grey: 8421504, honeydew: 15794160, hotpink: 16738740, indianred: 13458524, indigo: 4915330, ivory: 16777200, khaki: 15787660, lavender: 15132410, lavenderblush: 16773365, lawngreen: 8190976, lemonchiffon: 16775885, lightblue: 11393254, lightcoral: 15761536, lightcyan: 14745599, lightgoldenrodyellow: 16448210, lightgray: 13882323, lightgreen: 9498256, lightgrey: 13882323, lightpink: 16758465, lightsalmon: 16752762, lightseagreen: 2142890, lightskyblue: 8900346, lightslategray: 7833753, lightslategrey: 7833753, lightsteelblue: 11584734, lightyellow: 16777184, lime: 65280, limegreen: 3329330, linen: 16445670, magenta: 16711935, maroon: 8388608, mediumaquamarine: 6737322, mediumblue: 205, mediumorchid: 12211667, mediumpurple: 9662683, mediumseagreen: 3978097, mediumslateblue: 8087790, mediumspringgreen: 64154, mediumturquoise: 4772300, mediumvioletred: 13047173, midnightblue: 1644912, mintcream: 16121850, mistyrose: 16770273, moccasin: 16770229, navajowhite: 16768685, navy: 128, oldlace: 16643558, olive: 8421376, olivedrab: 7048739, orange: 16753920, orangered: 16729344, orchid: 14315734, palegoldenrod: 15657130, palegreen: 10025880, paleturquoise: 11529966, palevioletred: 14381203, papayawhip: 16773077, peachpuff: 16767673, peru: 13468991, pink: 16761035, plum: 14524637, powderblue: 11591910, purple: 8388736, rebeccapurple: 6697881, red: 16711680, rosybrown: 12357519, royalblue: 4286945, saddlebrown: 9127187, salmon: 16416882, sandybrown: 16032864, seagreen: 3050327, seashell: 16774638, sienna: 10506797, silver: 12632256, skyblue: 8900331, slateblue: 6970061, slategray: 7372944, slategrey: 7372944, snow: 16775930, springgreen: 65407, steelblue: 4620980, tan: 13808780, teal: 32896, thistle: 14204888, tomato: 16737095, turquoise: 4251856, violet: 15631086, wheat: 16113331, white: 16777215, whitesmoke: 16119285, yellow: 16776960, yellowgreen: 10145074 });
        ps.forEach(function(t, e) { ps.set(t, Mt(e)) }), ma.functor = Lt, ma.xhr = $t(M), ma.dsv = function(t, e) {
            function n(t, n, o) { arguments.length < 3 && (o = n, n = null); var a = Nt(t, e, null == n ? i : r(n), o); return a.row = function(t) { return arguments.length ? a.response(null == (n = t) ? i : r(t)) : n }, a }

            function i(t) { return n.parse(t.responseText) }

            function r(t) { return function(e) { return n.parse(e.responseText, t) } }

            function o(e) { return e.map(a).join(t) }

            function a(t) { return s.test(t) ? '"' + t.replace(/\"/g, '""') + '"' : t }
            var s = new RegExp('["' + t + "\n]"),
                l = t.charCodeAt(0);
            return n.parse = function(t, e) {
                var i;
                return n.parseRows(t, function(t, n) {
                    if (i) return i(t, n - 1);
                    var r = new Function("d", "return {" + t.map(function(t, e) { return (0, u.default)(t) + ": d[" + e + "]" }).join(",") + "}");
                    i = e ? function(t, n) { return e(r(t), n) } : r
                })
            }, n.parseRows = function(t, e) {
                function n() {
                    if (c >= u) return a;
                    if (r) return r = !1, o;
                    var e = c;
                    if (34 === t.charCodeAt(e)) {
                        for (var n = e; n++ < u;)
                            if (34 === t.charCodeAt(n)) { if (34 !== t.charCodeAt(n + 1)) break;++n } c = n + 2;
                        var i = t.charCodeAt(n + 1);
                        return 13 === i ? (r = !0, 10 === t.charCodeAt(n + 2) && ++c) : 10 === i && (r = !0), t.slice(e + 1, n).replace(/""/g, '"')
                    }
                    for (; c < u;) {
                        var i = t.charCodeAt(c++),
                            s = 1;
                        if (10 === i) r = !0;
                        else if (13 === i) r = !0, 10 === t.charCodeAt(c) && (++c, ++s);
                        else if (i !== l) continue;
                        return t.slice(e, c - s)
                    }
                    return t.slice(e)
                }
                for (var i, r, o = {}, a = {}, s = [], u = t.length, c = 0, d = 0;
                    (i = n()) !== a;) {
                    for (var h = []; i !== o && i !== a;) h.push(i), i = n();
                    e && null == (h = e(h, d++)) || s.push(h)
                }
                return s
            }, n.format = function(e) {
                if (Array.isArray(e[0])) return n.formatRows(e);
                var i = new C,
                    r = [];
                return e.forEach(function(t) { for (var e in t) i.has(e) || r.push(i.add(e)) }), [r.map(a).join(t)].concat(e.map(function(e) { return r.map(function(t) { return a(e[t]) }).join(t) })).join("\n")
            }, n.formatRows = function(t) { return t.map(o).join("\n") }, n
        }, ma.csv = ma.dsv(",", "text/csv"), ma.tsv = ma.dsv("\t", "text/tab-separated-values");
        var gs, vs, ms, ys, bs = this[E(this, "requestAnimationFrame")] || function(t) { setTimeout(t, 17) };
        ma.timer = function() { Ft.apply(this, arguments) }, ma.timer.flush = function() { Bt(), Wt() }, ma.round = function(t, e) { return e ? Math.round(t * (e = Math.pow(10, e))) / e : Math.round(t) };
        var xs = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(Yt);
        ma.formatPrefix = function(t, e) { var n = 0; return (t = +t) && (t < 0 && (t *= -1), e && (t = ma.round(t, jt(t, e))), n = 1 + Math.floor(1e-12 + Math.log(t) / Math.LN10), n = Math.max(-24, Math.min(24, 3 * Math.floor((n - 1) / 3)))), xs[8 + n / 3] };
        var ws = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i,
            ks = ma.map({ b: function(t) { return t.toString(2) }, c: function(t) { return String.fromCharCode(t) }, o: function(t) { return t.toString(8) }, x: function(t) { return t.toString(16) }, X: function(t) { return t.toString(16).toUpperCase() }, g: function(t, e) { return t.toPrecision(e) }, e: function(t, e) { return t.toExponential(e) }, f: function(t, e) { return t.toFixed(e) }, r: function(t, e) { return (t = ma.round(t, jt(t, e))).toFixed(Math.max(0, Math.min(20, jt(t * (1 + 1e-15), e)))) } }),
            Ss = ma.time = {},
            _s = Date;
        Xt.prototype = { getDate: function() { return this._.getUTCDate() }, getDay: function() { return this._.getUTCDay() }, getFullYear: function() { return this._.getUTCFullYear() }, getHours: function() { return this._.getUTCHours() }, getMilliseconds: function() { return this._.getUTCMilliseconds() }, getMinutes: function() { return this._.getUTCMinutes() }, getMonth: function() { return this._.getUTCMonth() }, getSeconds: function() { return this._.getUTCSeconds() }, getTime: function() { return this._.getTime() }, getTimezoneOffset: function() { return 0 }, valueOf: function() { return this._.valueOf() }, setDate: function() { Ts.setUTCDate.apply(this._, arguments) }, setDay: function() { Ts.setUTCDay.apply(this._, arguments) }, setFullYear: function() { Ts.setUTCFullYear.apply(this._, arguments) }, setHours: function() { Ts.setUTCHours.apply(this._, arguments) }, setMilliseconds: function() { Ts.setUTCMilliseconds.apply(this._, arguments) }, setMinutes: function() { Ts.setUTCMinutes.apply(this._, arguments) }, setMonth: function() { Ts.setUTCMonth.apply(this._, arguments) }, setSeconds: function() { Ts.setUTCSeconds.apply(this._, arguments) }, setTime: function() { Ts.setTime.apply(this._, arguments) } };
        var Ts = Date.prototype;
        Ss.year = Zt(function(t) { return t = Ss.day(t), t.setMonth(0, 1), t }, function(t, e) { t.setFullYear(t.getFullYear() + e) }, function(t) { return t.getFullYear() }), Ss.years = Ss.year.range, Ss.years.utc = Ss.year.utc.range, Ss.day = Zt(function(t) { var e = new _s(2e3, 0); return e.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), e }, function(t, e) { t.setDate(t.getDate() + e) }, function(t) { return t.getDate() - 1 }), Ss.days = Ss.day.range, Ss.days.utc = Ss.day.utc.range, Ss.dayOfYear = function(t) { var e = Ss.year(t); return Math.floor((t - e - 6e4 * (t.getTimezoneOffset() - e.getTimezoneOffset())) / 864e5) }, ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function(t, e) {
            e = 7 - e;
            var n = Ss[t] = Zt(function(t) { return (t = Ss.day(t)).setDate(t.getDate() - (t.getDay() + e) % 7), t }, function(t, e) { t.setDate(t.getDate() + 7 * Math.floor(e)) }, function(t) { var n = Ss.year(t).getDay(); return Math.floor((Ss.dayOfYear(t) + (n + e) % 7) / 7) - (n !== e) });
            Ss[t + "s"] = n.range, Ss[t + "s"].utc = n.utc.range, Ss[t + "OfYear"] = function(t) { var n = Ss.year(t).getDay(); return Math.floor((Ss.dayOfYear(t) + (n + e) % 7) / 7) }
        }), Ss.week = Ss.sunday, Ss.weeks = Ss.sunday.range, Ss.weeks.utc = Ss.sunday.utc.range, Ss.weekOfYear = Ss.sundayOfYear;
        var Cs = { "-": "", _: " ", 0: "0" },
            Ms = /^\s*\d+/,
            As = /^%/;
        ma.locale = function(t) { return { numberFormat: Ut(t), timeFormat: Gt(t) } };
        var Es = ma.locale({ decimal: ".", thousands: ",", grouping: [3], currency: ["$", ""], dateTime: "%a %b %e %X %Y", date: "%m/%d/%Y", time: "%H:%M:%S", periods: ["AM", "PM"], days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] });
        ma.format = Es.numberFormat, ma.geo = {}, ye.prototype = { s: 0, t: 0, add: function(t) { be(t, this.t, Ps), be(Ps.s, this.s, this), this.s ? this.t += Ps.t : this.s = Ps.t }, reset: function() { this.s = this.t = 0 }, valueOf: function() { return this.s } };
        var Ps = new ye;
        ma.geo.stream = function(t, e) { t && Is.hasOwnProperty(t.type) ? Is[t.type](t, e) : xe(t, e) };
        var Is = { Feature: function(t, e) { xe(t.geometry, e) }, FeatureCollection: function(t, e) { for (var n = t.features, i = -1, r = n.length; ++i < r;) xe(n[i].geometry, e) } },
            zs = { Sphere: function(t, e) { e.sphere() }, Point: function(t, e) { t = t.coordinates, e.point(t[0], t[1], t[2]) }, MultiPoint: function(t, e) { for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) t = n[i], e.point(t[0], t[1], t[2]) }, LineString: function(t, e) { we(t.coordinates, e, 0) }, MultiLineString: function(t, e) { for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) we(n[i], e, 0) }, Polygon: function(t, e) { ke(t.coordinates, e) }, MultiPolygon: function(t, e) { for (var n = t.coordinates, i = -1, r = n.length; ++i < r;) ke(n[i], e) }, GeometryCollection: function(t, e) { for (var n = t.geometries, i = -1, r = n.length; ++i < r;) xe(n[i], e) } };
        ma.geo.area = function(t) { return Ds = 0, ma.geo.stream(t, Ls), Ds };
        var Ds, Os = new ye,
            Ls = {
                sphere: function() { Ds += 4 * Xa },
                point: P,
                lineStart: P,
                lineEnd: P,
                polygonStart: function() { Os.reset(), Ls.lineStart = Se },
                polygonEnd: function() {
                    var t = 2 * Os;
                    Ds += t < 0 ? 4 * Xa + t : t, Ls.lineStart = Ls.lineEnd = Ls.point = P
                }
            };
        ma.geo.bounds = function() {
            function t(t, e) { b.push(x = [c = t, h = t]), e < d && (d = e), e > f && (f = e) }

            function e(e, n) {
                var i = _e([e * Ja, n * Ja]);
                if (m) {
                    var r = Ce(m, i),
                        o = [r[1], -r[0], 0],
                        a = Ce(o, r);
                    Ee(a), a = Pe(a);
                    var l = e - p,
                        u = l > 0 ? 1 : -1,
                        g = a[0] * Qa * u,
                        v = Ea(l) > 180;
                    if (v ^ (u * p < g && g < u * e)) {
                        var y = a[1] * Qa;
                        y > f && (f = y)
                    } else if (g = (g + 360) % 360 - 180, v ^ (u * p < g && g < u * e)) {
                        var y = -a[1] * Qa;
                        y < d && (d = y)
                    } else n < d && (d = n), n > f && (f = n);
                    v ? e < p ? s(c, e) > s(c, h) && (h = e) : s(e, h) > s(c, h) && (c = e) : h >= c ? (e < c && (c = e), e > h && (h = e)) : e > p ? s(c, e) > s(c, h) && (h = e) : s(e, h) > s(c, h) && (c = e)
                } else t(e, n);
                m = i, p = e
            }

            function n() { w.point = e }

            function i() { x[0] = c, x[1] = h, w.point = t, m = null }

            function r(t, n) {
                if (m) {
                    var i = t - p;
                    y += Ea(i) > 180 ? i + (i > 0 ? 360 : -360) : i
                } else g = t, v = n;
                Ls.point(t, n), e(t, n)
            }

            function o() { Ls.lineStart() }

            function a() { r(g, v), Ls.lineEnd(), Ea(y) > Ua && (c = -(h = 180)), x[0] = c, x[1] = h, m = null }

            function s(t, e) { return (e -= t) < 0 ? e + 360 : e }

            function l(t, e) { return t[0] - e[0] }

            function u(t, e) { return e[0] <= e[1] ? e[0] <= t && t <= e[1] : t < e[0] || e[1] < t }
            var c, d, h, f, p, g, v, m, y, b, x, w = { point: t, lineStart: n, lineEnd: i, polygonStart: function() { w.point = r, w.lineStart = o, w.lineEnd = a, y = 0, Ls.polygonStart() }, polygonEnd: function() { Ls.polygonEnd(), w.point = t, w.lineStart = n, w.lineEnd = i, Os < 0 ? (c = -(h = 180), d = -(f = 90)) : y > Ua ? f = 90 : y < -Ua && (d = -90), x[0] = c, x[1] = h } };
            return function(t) {
                f = h = -(c = d = 1 / 0), b = [], ma.geo.stream(t, w);
                var e = b.length;
                if (e) { b.sort(l); for (var n, i = 1, r = b[0], o = [r]; i < e; ++i) n = b[i], u(n[0], r) || u(n[1], r) ? (s(r[0], n[1]) > s(r[0], r[1]) && (r[1] = n[1]), s(n[0], r[1]) > s(r[0], r[1]) && (r[0] = n[0])) : o.push(r = n); for (var a, n, p = -(1 / 0), e = o.length - 1, i = 0, r = o[e]; i <= e; r = n, ++i) n = o[i], (a = s(r[1], n[0])) > p && (p = a, c = n[0], h = r[1]) }
                return b = x = null, c === 1 / 0 || d === 1 / 0 ? [
                    [NaN, NaN],
                    [NaN, NaN]
                ] : [
                    [c, d],
                    [h, f]
                ]
            }
        }(), ma.geo.centroid = function(t) {
            $s = Ns = Rs = qs = Fs = Hs = Bs = Ws = js = Ys = Us = 0, ma.geo.stream(t, Vs);
            var e = js,
                n = Ys,
                i = Us,
                r = e * e + n * n + i * i;
            return r < Va && (e = Hs, n = Bs, i = Ws, Ns < Ua && (e = Rs, n = qs, i = Fs), r = e * e + n * n + i * i, r < Va) ? [NaN, NaN] : [Math.atan2(n, e) * Qa, ct(i / Math.sqrt(r)) * Qa]
        };
        var $s, Ns, Rs, qs, Fs, Hs, Bs, Ws, js, Ys, Us, Vs = { sphere: P, point: ze, lineStart: Oe, lineEnd: Le, polygonStart: function() { Vs.lineStart = $e }, polygonEnd: function() { Vs.lineStart = Oe } },
            Xs = Be(Re, Ue, Xe, [-Xa, -Xa / 2]),
            Zs = 1e9;
        ma.geo.clipExtent = function() {
            var t, e, n, i, r, o, a = {
                stream: function(t) { return r && (r.valid = !1), r = o(t), r.valid = !0, r },
                extent: function(s) {
                    return arguments.length ? (o = Je(t = +s[0][0], e = +s[0][1], n = +s[1][0], i = +s[1][1]), r && (r.valid = !1, r = null), a) : [
                        [t, e],
                        [n, i]
                    ]
                }
            };
            return a.extent([
                [0, 0],
                [960, 500]
            ])
        }, (ma.geo.conicEqualArea = function() { return Qe(tn) }).raw = tn, ma.geo.albers = function() { return ma.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070) }, ma.geo.albersUsa = function() {
            function t(t) {
                var o = t[0],
                    a = t[1];
                return e = null, n(o, a), e || (i(o, a), e) || r(o, a), e
            }
            var e, n, i, r, o = ma.geo.albers(),
                a = ma.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]),
                s = ma.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]),
                l = { point: function(t, n) { e = [t, n] } };
            return t.invert = function(t) {
                var e = o.scale(),
                    n = o.translate(),
                    i = (t[0] - n[0]) / e,
                    r = (t[1] - n[1]) / e;
                return (r >= .12 && r < .234 && i >= -.425 && i < -.214 ? a : r >= .166 && r < .234 && i >= -.214 && i < -.115 ? s : o).invert(t)
            }, t.stream = function(t) {
                var e = o.stream(t),
                    n = a.stream(t),
                    i = s.stream(t);
                return { point: function(t, r) { e.point(t, r), n.point(t, r), i.point(t, r) }, sphere: function() { e.sphere(), n.sphere(), i.sphere() }, lineStart: function() { e.lineStart(), n.lineStart(), i.lineStart() }, lineEnd: function() { e.lineEnd(), n.lineEnd(), i.lineEnd() }, polygonStart: function() { e.polygonStart(), n.polygonStart(), i.polygonStart() }, polygonEnd: function() { e.polygonEnd(), n.polygonEnd(), i.polygonEnd() } }
            }, t.precision = function(e) { return arguments.length ? (o.precision(e), a.precision(e), s.precision(e), t) : o.precision() }, t.scale = function(e) { return arguments.length ? (o.scale(e), a.scale(.35 * e), s.scale(e), t.translate(o.translate())) : o.scale() }, t.translate = function(e) {
                if (!arguments.length) return o.translate();
                var u = o.scale(),
                    c = +e[0],
                    d = +e[1];
                return n = o.translate(e).clipExtent([
                    [c - .455 * u, d - .238 * u],
                    [c + .455 * u, d + .238 * u]
                ]).stream(l).point, i = a.translate([c - .307 * u, d + .201 * u]).clipExtent([
                    [c - .425 * u + Ua, d + .12 * u + Ua],
                    [c - .214 * u - Ua, d + .234 * u - Ua]
                ]).stream(l).point, r = s.translate([c - .205 * u, d + .212 * u]).clipExtent([
                    [c - .214 * u + Ua, d + .166 * u + Ua],
                    [c - .115 * u - Ua, d + .234 * u - Ua]
                ]).stream(l).point, t
            }, t.scale(1070)
        };
        var Ks, Gs, Js, Qs, tl, el, nl = { point: P, lineStart: P, lineEnd: P, polygonStart: function() { Gs = 0, nl.lineStart = en }, polygonEnd: function() { nl.lineStart = nl.lineEnd = nl.point = P, Ks += Ea(Gs / 2) } },
            il = { point: nn, lineStart: P, lineEnd: P, polygonStart: P, polygonEnd: P },
            rl = { point: an, lineStart: sn, lineEnd: ln, polygonStart: function() { rl.lineStart = un }, polygonEnd: function() { rl.point = an, rl.lineStart = sn, rl.lineEnd = ln } };
        ma.geo.path = function() {
            function t(t) { return t && ("function" == typeof s && o.pointRadius(+s.apply(this, arguments)), a && a.valid || (a = r(o)), ma.geo.stream(t, a)), o.result() }

            function e() { return a = null, t }
            var n, i, r, o, a, s = 4.5;
            return t.area = function(t) { return Ks = 0, ma.geo.stream(t, r(nl)), Ks }, t.centroid = function(t) { return Rs = qs = Fs = Hs = Bs = Ws = js = Ys = Us = 0, ma.geo.stream(t, r(rl)), Us ? [js / Us, Ys / Us] : Ws ? [Hs / Ws, Bs / Ws] : Fs ? [Rs / Fs, qs / Fs] : [NaN, NaN] }, t.bounds = function(t) {
                return tl = el = -(Js = Qs = 1 / 0), ma.geo.stream(t, r(il)), [
                    [Js, Qs],
                    [tl, el]
                ]
            }, t.projection = function(t) { return arguments.length ? (r = (n = t) ? t.stream || hn(t) : M, e()) : n }, t.context = function(t) { return arguments.length ? (o = null == (i = t) ? new rn : new cn(t), "function" != typeof s && o.pointRadius(s), e()) : i }, t.pointRadius = function(e) { return arguments.length ? (s = "function" == typeof e ? e : (o.pointRadius(+e), +e), t) : s }, t.projection(ma.geo.albersUsa()).context(null)
        }, ma.geo.transform = function(t) { return { stream: function(e) { var n = new fn(e); for (var i in t) n[i] = t[i]; return n } } }, fn.prototype = { point: function(t, e) { this.stream.point(t, e) }, sphere: function() { this.stream.sphere() }, lineStart: function() { this.stream.lineStart() }, lineEnd: function() { this.stream.lineEnd() }, polygonStart: function() { this.stream.polygonStart() }, polygonEnd: function() { this.stream.polygonEnd() } }, ma.geo.projection = gn, ma.geo.projectionMutator = vn, (ma.geo.equirectangular = function() { return gn(yn) }).raw = yn.invert = yn, ma.geo.rotation = function(t) {
            function e(e) { return e = t(e[0] * Ja, e[1] * Ja), e[0] *= Qa, e[1] *= Qa, e }
            return t = xn(t[0] % 360 * Ja, t[1] * Ja, t.length > 2 ? t[2] * Ja : 0), e.invert = function(e) { return e = t.invert(e[0] * Ja, e[1] * Ja), e[0] *= Qa, e[1] *= Qa, e }, e
        }, bn.invert = yn, ma.geo.circle = function() {
            function t() {
                var t = "function" == typeof i ? i.apply(this, arguments) : i,
                    e = xn(-t[0] * Ja, -t[1] * Ja, 0).invert,
                    r = [];
                return n(null, null, 1, { point: function(t, n) { r.push(t = e(t, n)), t[0] *= Qa, t[1] *= Qa } }), { type: "Polygon", coordinates: [r] }
            }
            var e, n, i = [0, 0],
                r = 6;
            return t.origin = function(e) { return arguments.length ? (i = e, t) : i }, t.angle = function(i) { return arguments.length ? (n = _n((e = +i) * Ja, r * Ja), t) : e }, t.precision = function(i) { return arguments.length ? (n = _n(e * Ja, (r = +i) * Ja), t) : r }, t.angle(90)
        }, ma.geo.distance = function(t, e) {
            var n, i = (e[0] - t[0]) * Ja,
                r = t[1] * Ja,
                o = e[1] * Ja,
                a = Math.sin(i),
                s = Math.cos(i),
                l = Math.sin(r),
                u = Math.cos(r),
                c = Math.sin(o),
                d = Math.cos(o);
            return Math.atan2(Math.sqrt((n = d * a) * n + (n = u * c - l * d * s) * n), l * c + u * d * s)
        }, ma.geo.graticule = function() {
            function t() { return { type: "MultiLineString", coordinates: e() } }

            function e() { return ma.range(Math.ceil(o / v) * v, r, v).map(h).concat(ma.range(Math.ceil(u / m) * m, l, m).map(f)).concat(ma.range(Math.ceil(i / p) * p, n, p).filter(function(t) { return Ea(t % v) > Ua }).map(c)).concat(ma.range(Math.ceil(s / g) * g, a, g).filter(function(t) { return Ea(t % m) > Ua }).map(d)) }
            var n, i, r, o, a, s, l, u, c, d, h, f, p = 10,
                g = p,
                v = 90,
                m = 360,
                y = 2.5;
            return t.lines = function() { return e().map(function(t) { return { type: "LineString", coordinates: t } }) }, t.outline = function() { return { type: "Polygon", coordinates: [h(o).concat(f(l).slice(1), h(r).reverse().slice(1), f(u).reverse().slice(1))] } }, t.extent = function(e) { return arguments.length ? t.majorExtent(e).minorExtent(e) : t.minorExtent() }, t.majorExtent = function(e) {
                return arguments.length ? (o = +e[0][0], r = +e[1][0], u = +e[0][1], l = +e[1][1], o > r && (e = o, o = r, r = e), u > l && (e = u, u = l, l = e), t.precision(y)) : [
                    [o, u],
                    [r, l]
                ]
            }, t.minorExtent = function(e) {
                return arguments.length ? (i = +e[0][0], n = +e[1][0], s = +e[0][1], a = +e[1][1], i > n && (e = i, i = n, n = e), s > a && (e = s, s = a, a = e), t.precision(y)) : [
                    [i, s],
                    [n, a]
                ]
            }, t.step = function(e) { return arguments.length ? t.majorStep(e).minorStep(e) : t.minorStep() }, t.majorStep = function(e) { return arguments.length ? (v = +e[0], m = +e[1], t) : [v, m] }, t.minorStep = function(e) { return arguments.length ? (p = +e[0], g = +e[1], t) : [p, g] }, t.precision = function(e) { return arguments.length ? (y = +e, c = Cn(s, a, 90), d = Mn(i, n, y), h = Cn(u, l, 90), f = Mn(o, r, y), t) : y }, t.majorExtent([
                [-180, -90 + Ua],
                [180, 90 - Ua]
            ]).minorExtent([
                [-180, -80 - Ua],
                [180, 80 + Ua]
            ])
        }, ma.geo.greatArc = function() {
            function t() { return { type: "LineString", coordinates: [e || i.apply(this, arguments), n || r.apply(this, arguments)] } }
            var e, n, i = An,
                r = En;
            return t.distance = function() { return ma.geo.distance(e || i.apply(this, arguments), n || r.apply(this, arguments)) }, t.source = function(n) { return arguments.length ? (i = n, e = "function" == typeof n ? null : n, t) : i }, t.target = function(e) { return arguments.length ? (r = e, n = "function" == typeof e ? null : e, t) : r }, t.precision = function() { return arguments.length ? t : 0 }, t
        }, ma.geo.interpolate = function(t, e) { return Pn(t[0] * Ja, t[1] * Ja, e[0] * Ja, e[1] * Ja) }, ma.geo.length = function(t) { return ol = 0, ma.geo.stream(t, al), ol };
        var ol, al = { sphere: P, point: P, lineStart: In, lineEnd: P, polygonStart: P, polygonEnd: P },
            sl = zn(function(t) { return Math.sqrt(2 / (1 + t)) }, function(t) { return 2 * Math.asin(t / 2) });
        (ma.geo.azimuthalEqualArea = function() { return gn(sl) }).raw = sl;
        var ll = zn(function(t) { var e = Math.acos(t); return e && e / Math.sin(e) }, M);
        (ma.geo.azimuthalEquidistant = function() { return gn(ll) }).raw = ll, (ma.geo.conicConformal = function() { return Qe(Dn) }).raw = Dn, (ma.geo.conicEquidistant = function() { return Qe(On) }).raw = On;
        var ul = zn(function(t) { return 1 / t }, Math.atan);
        (ma.geo.gnomonic = function() { return gn(ul) }).raw = ul, Ln.invert = function(t, e) { return [t, 2 * Math.atan(Math.exp(e)) - Ga] }, (ma.geo.mercator = function() { return $n(Ln) }).raw = Ln;
        var cl = zn(function() { return 1 }, Math.asin);
        (ma.geo.orthographic = function() { return gn(cl) }).raw = cl;
        var dl = zn(function(t) { return 1 / (1 + t) }, function(t) { return 2 * Math.atan(t) });
        (ma.geo.stereographic = function() { return gn(dl) }).raw = dl, Nn.invert = function(t, e) { return [-e, 2 * Math.atan(Math.exp(t)) - Ga] }, (ma.geo.transverseMercator = function() {
            var t = $n(Nn),
                e = t.center,
                n = t.rotate;
            return t.center = function(t) { return t ? e([-t[1], t[0]]) : (t = e(), [t[1], -t[0]]) }, t.rotate = function(t) { return t ? n([t[0], t[1], t.length > 2 ? t[2] + 90 : 90]) : (t = n(), [t[0], t[1], t[2] - 90]) }, n([0, 0, 90])
        }).raw = Nn, ma.geom = {}, ma.geom.hull = function(t) {
            function e(t) {
                if (t.length < 3) return [];
                var e, r = Lt(n),
                    o = Lt(i),
                    a = t.length,
                    s = [],
                    l = [];
                for (e = 0; e < a; e++) s.push([+r.call(this, t[e], e), +o.call(this, t[e], e), e]);
                for (s.sort(Hn), e = 0; e < a; e++) l.push([s[e][0], -s[e][1]]);
                var u = Fn(s),
                    c = Fn(l),
                    d = c[0] === u[0],
                    h = c[c.length - 1] === u[u.length - 1],
                    f = [];
                for (e = u.length - 1; e >= 0; --e) f.push(t[s[u[e]][2]]);
                for (e = +d; e < c.length - h; ++e) f.push(t[s[c[e]][2]]);
                return f
            }
            var n = Rn,
                i = qn;
            return arguments.length ? e(t) : (e.x = function(t) { return arguments.length ? (n = t, e) : n }, e.y = function(t) { return arguments.length ? (i = t, e) : i }, e)
        }, ma.geom.polygon = function(t) { return Oa(t, hl), t };
        var hl = ma.geom.polygon.prototype = [];
        hl.area = function() { for (var t, e = -1, n = this.length, i = this[n - 1], r = 0; ++e < n;) t = i, i = this[e], r += t[1] * i[0] - t[0] * i[1]; return .5 * r }, hl.centroid = function(t) {
            var e, n, i = -1,
                r = this.length,
                o = 0,
                a = 0,
                s = this[r - 1];
            for (arguments.length || (t = -1 / (6 * this.area())); ++i < r;) e = s, s = this[i], n = e[0] * s[1] - s[0] * e[1], o += (e[0] + s[0]) * n, a += (e[1] + s[1]) * n;
            return [o * t, a * t]
        }, hl.clip = function(t) {
            for (var e, n, i, r, o, a, s = jn(t), l = -1, u = this.length - jn(this), c = this[u - 1]; ++l < u;) {
                for (e = t.slice(), t.length = 0, r = this[l], o = e[(i = e.length - s) - 1], n = -1; ++n < i;) a = e[n], Bn(a, c, r) ? (Bn(o, c, r) || t.push(Wn(o, a, c, r)), t.push(a)) : Bn(o, c, r) && t.push(Wn(o, a, c, r)), o = a;
                s && t.push(t[0]), c = r
            }
            return t
        };
        var fl, pl, gl, vl, ml, yl = [],
            bl = [];
        Jn.prototype.prepare = function() { for (var t, e = this.edges, n = e.length; n--;) t = e[n].edge, t.b && t.a || e.splice(n, 1); return e.sort(ti), e.length }, ci.prototype = { start: function() { return this.edge.l === this.site ? this.edge.a : this.edge.b }, end: function() { return this.edge.l === this.site ? this.edge.b : this.edge.a } }, di.prototype = {
            insert: function(t, e) {
                var n, i, r;
                if (t) {
                    if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
                        for (t = t.R; t.L;) t = t.L;
                        t.L = e
                    } else t.R = e;
                    n = t
                } else this._ ? (t = gi(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);
                for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;) i = n.U, n === i.L ? (r = i.R, r && r.C ? (n.C = r.C = !1, i.C = !0, t = i) : (t === n.R && (fi(this, n), t = n, n = t.U), n.C = !1, i.C = !0, pi(this, i))) : (r = i.L, r && r.C ? (n.C = r.C = !1, i.C = !0, t = i) : (t === n.L && (pi(this, n), t = n, n = t.U), n.C = !1, i.C = !0, fi(this, i))), n = t.U;
                this._.C = !1
            },
            remove: function(t) {
                t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
                var e, n, i, r = t.U,
                    o = t.L,
                    a = t.R;
                if (n = o ? a ? gi(a) : o : a, r ? r.L === t ? r.L = n : r.R = n : this._ = n, o && a ? (i = n.C, n.C = t.C, n.L = o, o.U = n, n !== a ? (r = n.U, n.U = t.U, t = n.R, r.L = t, n.R = a, a.U = n) : (n.U = r, r = n, t = n.R)) : (i = t.C, t = n), t && (t.U = r), !i) {
                    if (t && t.C) return void(t.C = !1);
                    do { if (t === this._) break; if (t === r.L) { if (e = r.R, e.C && (e.C = !1, r.C = !0, fi(this, r), e = r.R), e.L && e.L.C || e.R && e.R.C) { e.R && e.R.C || (e.L.C = !1, e.C = !0, pi(this, e), e = r.R), e.C = r.C, r.C = e.R.C = !1, fi(this, r), t = this._; break } } else if (e = r.L, e.C && (e.C = !1, r.C = !0, pi(this, r), e = r.L), e.L && e.L.C || e.R && e.R.C) { e.L && e.L.C || (e.R.C = !1, e.C = !0, fi(this, e), e = r.L), e.C = r.C, r.C = e.L.C = !1, pi(this, r), t = this._; break } e.C = !0, t = r, r = r.U } while (!t.C);
                    t && (t.C = !1)
                }
            }
        }, ma.geom.voronoi = function(t) {
            function e(t) {
                var e = new Array(t.length),
                    i = s[0][0],
                    r = s[0][1],
                    o = s[1][0],
                    a = s[1][1];
                return vi(n(t), s).cells.forEach(function(n, s) {
                    var l = n.edges,
                        u = n.site,
                        c = e[s] = l.length ? l.map(function(t) { var e = t.start(); return [e.x, e.y] }) : u.x >= i && u.x <= o && u.y >= r && u.y <= a ? [
                            [i, a],
                            [o, a],
                            [o, r],
                            [i, r]
                        ] : [];
                    c.point = t[s]
                }), e
            }

            function n(t) { return t.map(function(t, e) { return { x: Math.round(o(t, e) / Ua) * Ua, y: Math.round(a(t, e) / Ua) * Ua, i: e } }) }
            var i = Rn,
                r = qn,
                o = i,
                a = r,
                s = xl;
            return t ? e(t) : (e.links = function(t) { return vi(n(t)).edges.filter(function(t) { return t.l && t.r }).map(function(e) { return { source: t[e.l.i], target: t[e.r.i] } }) }, e.triangles = function(t) { var e = []; return vi(n(t)).cells.forEach(function(n, i) { for (var r, o, a = n.site, s = n.edges.sort(ti), l = -1, u = s.length, c = s[u - 1].edge, d = c.l === a ? c.r : c.l; ++l < u;) r = c, o = d, c = s[l].edge, d = c.l === a ? c.r : c.l, i < o.i && i < d.i && yi(a, o, d) < 0 && e.push([t[i], t[o.i], t[d.i]]) }), e }, e.x = function(t) { return arguments.length ? (o = Lt(i = t), e) : i }, e.y = function(t) { return arguments.length ? (a = Lt(r = t), e) : r }, e.clipExtent = function(t) { return arguments.length ? (s = null == t ? xl : t, e) : s === xl ? null : s }, e.size = function(t) {
                return arguments.length ? e.clipExtent(t && [
                    [0, 0], t
                ]) : s === xl ? null : s && s[1]
            }, e)
        };
        var xl = [
            [-1e6, -1e6],
            [1e6, 1e6]
        ];
        ma.geom.delaunay = function(t) { return ma.geom.voronoi().triangles(t) }, ma.geom.quadtree = function(t, e, n, i, r) {
            function o(t) {
                function o(t, e, n, i, r, o, a, s) {
                    if (!isNaN(n) && !isNaN(i))
                        if (t.leaf) {
                            var l = t.x,
                                c = t.y;
                            if (null != l)
                                if (Ea(l - n) + Ea(c - i) < .01) u(t, e, n, i, r, o, a, s);
                                else {
                                    var d = t.point;
                                    t.x = t.y = t.point = null, u(t, d, l, c, r, o, a, s), u(t, e, n, i, r, o, a, s)
                                }
                            else t.x = n, t.y = i, t.point = e
                        } else u(t, e, n, i, r, o, a, s)
                }

                function u(t, e, n, i, r, a, s, l) {
                    var u = .5 * (r + s),
                        c = .5 * (a + l),
                        d = n >= u,
                        h = i >= c,
                        f = h << 1 | d;
                    t.leaf = !1, t = t.nodes[f] || (t.nodes[f] = wi()), d ? r = u : s = u, h ? a = c : l = c, o(t, e, n, i, r, a, s, l)
                }
                var c, d, h, f, p, g, v, m, y, b = Lt(s),
                    x = Lt(l);
                if (null != e) g = e, v = n, m = i, y = r;
                else if (m = y = -(g = v = 1 / 0), d = [], h = [], p = t.length, a)
                    for (f = 0; f < p; ++f) c = t[f], c.x < g && (g = c.x), c.y < v && (v = c.y), c.x > m && (m = c.x), c.y > y && (y = c.y), d.push(c.x), h.push(c.y);
                else
                    for (f = 0; f < p; ++f) {
                        var w = +b(c = t[f], f),
                            k = +x(c, f);
                        w < g && (g = w), k < v && (v = k), w > m && (m = w), k > y && (y = k), d.push(w), h.push(k)
                    }
                var S = m - g,
                    _ = y - v;
                S > _ ? y = v + S : m = g + _;
                var T = wi();
                if (T.add = function(t) { o(T, t, +b(t, ++f), +x(t, f), g, v, m, y) }, T.visit = function(t) { ki(t, T, g, v, m, y) }, T.find = function(t) { return Si(T, t[0], t[1], g, v, m, y) }, f = -1, null == e) { for (; ++f < p;) o(T, t[f], d[f], h[f], g, v, m, y);--f } else t.forEach(T.add);
                return d = h = t = c = null, T
            }
            var a, s = Rn,
                l = qn;
            return (a = arguments.length) ? (s = bi, l = xi, 3 === a && (r = n, i = e, n = e = 0), o(t)) : (o.x = function(t) { return arguments.length ? (s = t, o) : s }, o.y = function(t) { return arguments.length ? (l = t, o) : l }, o.extent = function(t) {
                return arguments.length ? (null == t ? e = n = i = r = null : (e = +t[0][0], n = +t[0][1], i = +t[1][0], r = +t[1][1]), o) : null == e ? null : [
                    [e, n],
                    [i, r]
                ]
            }, o.size = function(t) { return arguments.length ? (null == t ? e = n = i = r = null : (e = n = 0, i = +t[0], r = +t[1]), o) : null == e ? null : [i - e, r - n] }, o)
        }, ma.interpolateRgb = _i, ma.interpolateObject = Ti, ma.interpolateNumber = Ci, ma.interpolateString = Mi;
        var wl = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
            kl = new RegExp(wl.source, "g");
        ma.interpolate = Ai, ma.interpolators = [function(t, e) { var n = "undefined" == typeof e ? "undefined" : (0, s.default)(e); return ("string" === n ? ps.has(e.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(e) ? _i : Mi : e instanceof gt ? _i : Array.isArray(e) ? Ei : "object" === n && isNaN(e) ? Ti : Ci)(t, e) }], ma.interpolateArray = Ei;
        var Sl = function() { return M },
            _l = ma.map({ linear: Sl, poly: $i, quad: function() { return Di }, cubic: function() { return Oi }, sin: function() { return Ni }, exp: function() { return Ri }, circle: function() { return qi }, elastic: Fi, back: Hi, bounce: function() { return Bi } }),
            Tl = ma.map({ "in": M, out: Ii, "in-out": zi, "out-in": function(t) { return zi(Ii(t)) } });
        ma.ease = function(t) {
            var e = t.indexOf("-"),
                n = e >= 0 ? t.slice(0, e) : t,
                i = e >= 0 ? t.slice(e + 1) : "in";
            return n = _l.get(n) || Sl, i = Tl.get(i) || M, Pi(i(n.apply(null, ya.call(arguments, 1))))
        }, ma.interpolateHcl = Wi, ma.interpolateHsl = ji, ma.interpolateLab = Yi, ma.interpolateRound = Ui, ma.transform = function(t) { var e = xa.createElementNS(ma.ns.prefix.svg, "g"); return (ma.transform = function(t) { if (null != t) { e.setAttribute("transform", t); var n = e.transform.baseVal.consolidate() } return new Vi(n ? n.matrix : Cl) })(t) }, Vi.prototype.toString = function() { return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")" };
        var Cl = { a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 };
        ma.interpolateTransform = nr, ma.layout = {}, ma.layout.bundle = function() { return function(t) { for (var e = [], n = -1, i = t.length; ++n < i;) e.push(or(t[n])); return e } }, ma.layout.chord = function() {
            function t() {
                var t, u, d, h, f, p = {},
                    g = [],
                    v = ma.range(o),
                    m = [];
                for (n = [], i = [], t = 0, h = -1; ++h < o;) {
                    for (u = 0, f = -1; ++f < o;) u += r[h][f];
                    g.push(u), m.push(ma.range(o)), t += u
                }
                for (a && v.sort(function(t, e) { return a(g[t], g[e]) }), s && m.forEach(function(t, e) { t.sort(function(t, n) { return s(r[e][t], r[e][n]) }) }), t = (Za - c * o) / t, u = 0, h = -1; ++h < o;) {
                    for (d = u, f = -1; ++f < o;) {
                        var y = v[h],
                            b = m[y][f],
                            x = r[y][b],
                            w = u,
                            k = u += x * t;
                        p[y + "-" + b] = { index: y, subindex: b, startAngle: w, endAngle: k, value: x }
                    }
                    i[y] = { index: y, startAngle: d, endAngle: u, value: g[y] }, u += c
                }
                for (h = -1; ++h < o;)
                    for (f = h - 1; ++f < o;) {
                        var S = p[h + "-" + f],
                            _ = p[f + "-" + h];
                        (S.value || _.value) && n.push(S.value < _.value ? { source: _, target: S } : { source: S, target: _ })
                    }
                l && e()
            }

            function e() { n.sort(function(t, e) { return l((t.source.value + t.target.value) / 2, (e.source.value + e.target.value) / 2) }) }
            var n, i, r, o, a, s, l, u = {},
                c = 0;
            return u.matrix = function(t) { return arguments.length ? (o = (r = t) && r.length, n = i = null, u) : r }, u.padding = function(t) { return arguments.length ? (c = t, n = i = null, u) : c }, u.sortGroups = function(t) { return arguments.length ? (a = t, n = i = null, u) : a }, u.sortSubgroups = function(t) { return arguments.length ? (s = t, n = null, u) : s }, u.sortChords = function(t) { return arguments.length ? (l = t, n && e(), u) : l }, u.chords = function() { return n || t(), n }, u.groups = function() { return i || t(), i }, u
        }, ma.layout.force = function() {
            function t(t) {
                return function(e, n, i, r) {
                    if (e.point !== t) {
                        var o = e.cx - t.x,
                            a = e.cy - t.y,
                            s = r - n,
                            l = o * o + a * a;
                        if (s * s / m < l) {
                            if (l < g) {
                                var u = e.charge / l;
                                t.px -= o * u, t.py -= a * u
                            }
                            return !0
                        }
                        if (e.point && l && l < g) {
                            var u = e.pointCharge / l;
                            t.px -= o * u, t.py -= a * u
                        }
                    }
                    return !e.charge
                }
            }

            function e(t) { t.px = ma.event.x, t.py = ma.event.y, l.resume() }
            var n, i, r, o, a, s, l = {},
                u = ma.dispatch("start", "tick", "end"),
                c = [1, 1],
                d = .9,
                h = Ml,
                f = Al,
                p = -30,
                g = El,
                v = .1,
                m = .64,
                y = [],
                b = [];
            return l.tick = function() {
                if ((r *= .99) < .005) return n = null, u.end({ type: "end", alpha: r = 0 }), !0;
                var e, i, l, h, f, g, m, x, w, k = y.length,
                    S = b.length;
                for (i = 0; i < S; ++i) l = b[i], h = l.source, f = l.target, x = f.x - h.x, w = f.y - h.y, (g = x * x + w * w) && (g = r * a[i] * ((g = Math.sqrt(g)) - o[i]) / g, x *= g, w *= g, f.x -= x * (m = h.weight + f.weight ? h.weight / (h.weight + f.weight) : .5), f.y -= w * m, h.x += x * (m = 1 - m), h.y += w * m);
                if ((m = r * v) && (x = c[0] / 2, w = c[1] / 2, i = -1, m))
                    for (; ++i < k;) l = y[i], l.x += (x - l.x) * m, l.y += (w - l.y) * m;
                if (p)
                    for (hr(e = ma.geom.quadtree(y), r, s), i = -1; ++i < k;)(l = y[i]).fixed || e.visit(t(l));
                for (i = -1; ++i < k;) l = y[i], l.fixed ? (l.x = l.px, l.y = l.py) : (l.x -= (l.px - (l.px = l.x)) * d, l.y -= (l.py - (l.py = l.y)) * d);
                u.tick({ type: "tick", alpha: r })
            }, l.nodes = function(t) { return arguments.length ? (y = t, l) : y }, l.links = function(t) { return arguments.length ? (b = t, l) : b }, l.size = function(t) { return arguments.length ? (c = t, l) : c }, l.linkDistance = function(t) { return arguments.length ? (h = "function" == typeof t ? t : +t, l) : h }, l.distance = l.linkDistance, l.linkStrength = function(t) { return arguments.length ? (f = "function" == typeof t ? t : +t, l) : f }, l.friction = function(t) { return arguments.length ? (d = +t, l) : d }, l.charge = function(t) { return arguments.length ? (p = "function" == typeof t ? t : +t, l) : p }, l.chargeDistance = function(t) { return arguments.length ? (g = t * t, l) : Math.sqrt(g) }, l.gravity = function(t) { return arguments.length ? (v = +t, l) : v }, l.theta = function(t) { return arguments.length ? (m = t * t, l) : Math.sqrt(m) }, l.alpha = function(t) { return arguments.length ? (t = +t, r ? t > 0 ? r = t : (n.c = null, n.t = NaN, n = null, u.end({ type: "end", alpha: r = 0 })) : t > 0 && (u.start({ type: "start", alpha: r = t }), n = Ft(l.tick)), l) : r }, l.start = function() {
                function t(t, i) {
                    if (!n) {
                        for (n = new Array(r), l = 0; l < r; ++l) n[l] = [];
                        for (l = 0; l < u; ++l) {
                            var o = b[l];
                            n[o.source.index].push(o.target), n[o.target.index].push(o.source)
                        }
                    }
                    for (var a, s = n[e], l = -1, c = s.length; ++l < c;)
                        if (!isNaN(a = s[l][t])) return a;
                    return Math.random() * i
                }
                var e, n, i, r = y.length,
                    u = b.length,
                    d = c[0],
                    g = c[1];
                for (e = 0; e < r; ++e)(i = y[e]).index = e, i.weight = 0;
                for (e = 0; e < u; ++e) i = b[e], "number" == typeof i.source && (i.source = y[i.source]), "number" == typeof i.target && (i.target = y[i.target]), ++i.source.weight, ++i.target.weight;
                for (e = 0; e < r; ++e) i = y[e], isNaN(i.x) && (i.x = t("x", d)), isNaN(i.y) && (i.y = t("y", g)), isNaN(i.px) && (i.px = i.x), isNaN(i.py) && (i.py = i.y);
                if (o = [], "function" == typeof h)
                    for (e = 0; e < u; ++e) o[e] = +h.call(this, b[e], e);
                else
                    for (e = 0; e < u; ++e) o[e] = h;
                if (a = [], "function" == typeof f)
                    for (e = 0; e < u; ++e) a[e] = +f.call(this, b[e], e);
                else
                    for (e = 0; e < u; ++e) a[e] = f;
                if (s = [], "function" == typeof p)
                    for (e = 0; e < r; ++e) s[e] = +p.call(this, y[e], e);
                else
                    for (e = 0; e < r; ++e) s[e] = p;
                return l.resume()
            }, l.resume = function() { return l.alpha(.1) }, l.stop = function() { return l.alpha(0) }, l.drag = function() { return i || (i = ma.behavior.drag().origin(M).on("dragstart.force", lr).on("drag.force", e).on("dragend.force", ur)), arguments.length ? void this.on("mouseover.force", cr).on("mouseout.force", dr).call(i) : i }, ma.rebind(l, u, "on")
        };
        var Ml = 20,
            Al = 1,
            El = 1 / 0;
        ma.layout.hierarchy = function() {
            function t(r) {
                var o, a = [r],
                    s = [];
                for (r.depth = 0; null != (o = a.pop());)
                    if (s.push(o), (u = n.call(t, o, o.depth)) && (l = u.length)) {
                        for (var l, u, c; --l >= 0;) a.push(c = u[l]), c.parent = o, c.depth = o.depth + 1;
                        i && (o.value = 0), o.children = u
                    } else i && (o.value = +i.call(t, o, o.depth) || 0), delete o.children;
                return gr(r, function(t) {
                    var n, r;
                    e && (n = t.children) && n.sort(e), i && (r = t.parent) && (r.value += t.value)
                }), s
            }
            var e = yr,
                n = vr,
                i = mr;
            return t.sort = function(n) { return arguments.length ? (e = n, t) : e }, t.children = function(e) { return arguments.length ? (n = e, t) : n }, t.value = function(e) { return arguments.length ? (i = e, t) : i }, t.revalue = function(e) {
                return i && (pr(e, function(t) { t.children && (t.value = 0) }), gr(e, function(e) {
                    var n;
                    e.children || (e.value = +i.call(t, e, e.depth) || 0), (n = e.parent) && (n.value += e.value)
                })), e
            }, t
        }, ma.layout.partition = function() {
            function t(e, n, i, r) { var o = e.children; if (e.x = n, e.y = e.depth * r, e.dx = i, e.dy = r, o && (a = o.length)) { var a, s, l, u = -1; for (i = e.value ? i / e.value : 0; ++u < a;) t(s = o[u], n, l = s.value * i, r), n += l } }

            function e(t) {
                var n = t.children,
                    i = 0;
                if (n && (r = n.length))
                    for (var r, o = -1; ++o < r;) i = Math.max(i, e(n[o]));
                return 1 + i
            }

            function n(n, o) { var a = i.call(this, n, o); return t(a[0], 0, r[0], r[1] / e(a[0])), a }
            var i = ma.layout.hierarchy(),
                r = [1, 1];
            return n.size = function(t) { return arguments.length ? (r = t, n) : r }, fr(n, i)
        }, ma.layout.pie = function() {
            function t(a) {
                var s, l = a.length,
                    u = a.map(function(n, i) { return +e.call(t, n, i) }),
                    c = +("function" == typeof i ? i.apply(this, arguments) : i),
                    d = ("function" == typeof r ? r.apply(this, arguments) : r) - c,
                    h = Math.min(Math.abs(d) / l, +("function" == typeof o ? o.apply(this, arguments) : o)),
                    f = h * (d < 0 ? -1 : 1),
                    p = ma.sum(u),
                    g = p ? (d - l * f) / p : 0,
                    v = ma.range(l),
                    m = [];
                return null != n && v.sort(n === Pl ? function(t, e) { return u[e] - u[t] } : function(t, e) { return n(a[t], a[e]) }), v.forEach(function(t) { m[t] = { data: a[t], value: s = u[t], startAngle: c, endAngle: c += s * g + f, padAngle: h } }), m
            }
            var e = Number,
                n = Pl,
                i = 0,
                r = Za,
                o = 0;
            return t.value = function(n) { return arguments.length ? (e = n, t) : e }, t.sort = function(e) { return arguments.length ? (n = e, t) : n }, t.startAngle = function(e) { return arguments.length ? (i = e, t) : i }, t.endAngle = function(e) { return arguments.length ? (r = e, t) : r }, t.padAngle = function(e) { return arguments.length ? (o = e, t) : o }, t
        };
        var Pl = {};
        ma.layout.stack = function() {
            function t(s, l) {
                if (!(h = s.length)) return s;
                var u = s.map(function(n, i) { return e.call(t, n, i) }),
                    c = u.map(function(e) { return e.map(function(e, n) { return [o.call(t, e, n), a.call(t, e, n)] }) }),
                    d = n.call(t, c, l);
                u = ma.permute(u, d), c = ma.permute(c, d);
                var h, f, p, g, v = i.call(t, c, l),
                    m = u[0].length;
                for (p = 0; p < m; ++p)
                    for (r.call(t, u[0][p], g = v[p], c[0][p][1]), f = 1; f < h; ++f) r.call(t, u[f][p], g += c[f - 1][p][1], c[f][p][1]);
                return s
            }
            var e = M,
                n = Sr,
                i = _r,
                r = kr,
                o = xr,
                a = wr;
            return t.values = function(n) { return arguments.length ? (e = n, t) : e }, t.order = function(e) { return arguments.length ? (n = "function" == typeof e ? e : Il.get(e) || Sr, t) : n }, t.offset = function(e) { return arguments.length ? (i = "function" == typeof e ? e : zl.get(e) || _r, t) : i }, t.x = function(e) { return arguments.length ? (o = e, t) : o }, t.y = function(e) { return arguments.length ? (a = e, t) : a }, t.out = function(e) { return arguments.length ? (r = e, t) : r }, t
        };
        var Il = ma.map({
                "inside-out": function(t) {
                    var e, n, i = t.length,
                        r = t.map(Tr),
                        o = t.map(Cr),
                        a = ma.range(i).sort(function(t, e) { return r[t] - r[e] }),
                        s = 0,
                        l = 0,
                        u = [],
                        c = [];
                    for (e = 0; e < i; ++e) n = a[e], s < l ? (s += o[n], u.push(n)) : (l += o[n], c.push(n));
                    return c.reverse().concat(u)
                },
                reverse: function(t) { return ma.range(t.length).reverse() },
                "default": Sr
            }),
            zl = ma.map({
                silhouette: function(t) {
                    var e, n, i, r = t.length,
                        o = t[0].length,
                        a = [],
                        s = 0,
                        l = [];
                    for (n = 0; n < o; ++n) {
                        for (e = 0, i = 0; e < r; e++) i += t[e][n][1];
                        i > s && (s = i), a.push(i)
                    }
                    for (n = 0; n < o; ++n) l[n] = (s - a[n]) / 2;
                    return l
                },
                wiggle: function(t) {
                    var e, n, i, r, o, a, s, l, u, c = t.length,
                        d = t[0],
                        h = d.length,
                        f = [];
                    for (f[0] = l = u = 0, n = 1; n < h; ++n) {
                        for (e = 0, r = 0; e < c; ++e) r += t[e][n][1];
                        for (e = 0, o = 0, s = d[n][0] - d[n - 1][0]; e < c; ++e) {
                            for (i = 0, a = (t[e][n][1] - t[e][n - 1][1]) / (2 * s); i < e; ++i) a += (t[i][n][1] - t[i][n - 1][1]) / s;
                            o += a * t[e][n][1]
                        }
                        f[n] = l -= r ? o / r * s : 0, l < u && (u = l)
                    }
                    for (n = 0; n < h; ++n) f[n] -= u;
                    return f
                },
                expand: function(t) {
                    var e, n, i, r = t.length,
                        o = t[0].length,
                        a = 1 / r,
                        s = [];
                    for (n = 0; n < o; ++n) {
                        for (e = 0, i = 0; e < r; e++) i += t[e][n][1];
                        if (i)
                            for (e = 0; e < r; e++) t[e][n][1] /= i;
                        else
                            for (e = 0; e < r; e++) t[e][n][1] = a
                    }
                    for (n = 0; n < o; ++n) s[n] = 0;
                    return s
                },
                zero: _r
            });
        ma.layout.histogram = function() {
            function t(t, o) {
                for (var a, s, l = [], u = t.map(n, this), c = i.call(this, u, o), d = r.call(this, c, u, o), o = -1, h = u.length, f = d.length - 1, p = e ? 1 : 1 / h; ++o < f;) a = l[o] = [], a.dx = d[o + 1] - (a.x = d[o]), a.y = 0;
                if (f > 0)
                    for (o = -1; ++o < h;) s = u[o], s >= c[0] && s <= c[1] && (a = l[ma.bisect(d, s, 1, f) - 1], a.y += p, a.push(t[o]));
                return l
            }
            var e = !0,
                n = Number,
                i = Pr,
                r = Ar;
            return t.value = function(e) { return arguments.length ? (n = e, t) : n }, t.range = function(e) { return arguments.length ? (i = Lt(e), t) : i }, t.bins = function(e) { return arguments.length ? (r = "number" == typeof e ? function(t) { return Er(t, e) } : Lt(e), t) : r }, t.frequency = function(n) { return arguments.length ? (e = !!n, t) : e }, t
        }, ma.layout.pack = function() {
            function t(t, o) {
                var a = n.call(this, t, o),
                    s = a[0],
                    l = r[0],
                    u = r[1],
                    c = null == e ? Math.sqrt : "function" == typeof e ? e : function() { return e };
                if (s.x = s.y = 0, gr(s, function(t) { t.r = +c(t.value) }), gr(s, Lr), i) {
                    var d = i * (e ? 1 : Math.max(2 * s.r / l, 2 * s.r / u)) / 2;
                    gr(s, function(t) { t.r += d }), gr(s, Lr), gr(s, function(t) { t.r -= d })
                }
                return Rr(s, l / 2, u / 2, e ? 1 : 1 / Math.max(2 * s.r / l, 2 * s.r / u)), a
            }
            var e, n = ma.layout.hierarchy().sort(Ir),
                i = 0,
                r = [1, 1];
            return t.size = function(e) { return arguments.length ? (r = e, t) : r }, t.radius = function(n) { return arguments.length ? (e = null == n || "function" == typeof n ? n : +n, t) : e }, t.padding = function(e) { return arguments.length ? (i = +e, t) : i }, fr(t, n)
        }, ma.layout.tree = function() {
            function t(t, r) {
                var c = a.call(this, t, r),
                    d = c[0],
                    h = e(d);
                if (gr(h, n), h.parent.m = -h.z, pr(h, i), u) pr(d, o);
                else {
                    var f = d,
                        p = d,
                        g = d;
                    pr(d, function(t) { t.x < f.x && (f = t), t.x > p.x && (p = t), t.depth > g.depth && (g = t) });
                    var v = s(f, p) / 2 - f.x,
                        m = l[0] / (p.x + s(p, f) / 2 + v),
                        y = l[1] / (g.depth || 1);
                    pr(d, function(t) { t.x = (t.x + v) * m, t.y = t.depth * y })
                }
                return c
            }

            function e(t) {
                for (var e, n = { A: null, children: [t] }, i = [n]; null != (e = i.pop());)
                    for (var r, o = e.children, a = 0, s = o.length; a < s; ++a) i.push((o[a] = r = { _: o[a], parent: e, children: (r = o[a].children) && r.slice() || [], A: null, a: null, z: 0, m: 0, c: 0, s: 0, t: null, i: a }).a = r);
                return n.children[0]
            }

            function n(t) {
                var e = t.children,
                    n = t.parent.children,
                    i = t.i ? n[t.i - 1] : null;
                if (e.length) {
                    jr(t);
                    var o = (e[0].z + e[e.length - 1].z) / 2;
                    i ? (t.z = i.z + s(t._, i._), t.m = t.z - o) : t.z = o
                } else i && (t.z = i.z + s(t._, i._));
                t.parent.A = r(t, i, t.parent.A || n[0])
            }

            function i(t) { t._.x = t.z + t.parent.m, t.m += t.parent.m }

            function r(t, e, n) {
                if (e) {
                    for (var i, r = t, o = t, a = e, l = r.parent.children[0], u = r.m, c = o.m, d = a.m, h = l.m; a = Br(a), r = Hr(r), a && r;) l = Hr(l), o = Br(o), o.a = t, i = a.z + d - r.z - u + s(a._, r._), i > 0 && (Wr(Yr(a, t, n), t, i), u += i, c += i), d += a.m, u += r.m, h += l.m, c += o.m;
                    a && !Br(o) && (o.t = a, o.m += d - c), r && !Hr(l) && (l.t = r, l.m += u - h, n = t)
                }
                return n
            }

            function o(t) { t.x *= l[0], t.y = t.depth * l[1] }
            var a = ma.layout.hierarchy().sort(null).value(null),
                s = Fr,
                l = [1, 1],
                u = null;
            return t.separation = function(e) { return arguments.length ? (s = e, t) : s }, t.size = function(e) { return arguments.length ? (u = null == (l = e) ? o : null, t) : u ? null : l }, t.nodeSize = function(e) { return arguments.length ? (u = null == (l = e) ? null : o, t) : u ? l : null }, fr(t, a)
        }, ma.layout.cluster = function() {
            function t(t, o) {
                var a, s = e.call(this, t, o),
                    l = s[0],
                    u = 0;
                gr(l, function(t) {
                    var e = t.children;
                    e && e.length ? (t.x = Vr(e), t.y = Ur(e)) : (t.x = a ? u += n(t, a) : 0, t.y = 0, a = t)
                });
                var c = Xr(l),
                    d = Zr(l),
                    h = c.x - n(c, d) / 2,
                    f = d.x + n(d, c) / 2;
                return gr(l, r ? function(t) { t.x = (t.x - l.x) * i[0], t.y = (l.y - t.y) * i[1] } : function(t) { t.x = (t.x - h) / (f - h) * i[0], t.y = (1 - (l.y ? t.y / l.y : 1)) * i[1] }), s
            }
            var e = ma.layout.hierarchy().sort(null).value(null),
                n = Fr,
                i = [1, 1],
                r = !1;
            return t.separation = function(e) { return arguments.length ? (n = e, t) : n }, t.size = function(e) { return arguments.length ? (r = null == (i = e), t) : r ? null : i }, t.nodeSize = function(e) { return arguments.length ? (r = null != (i = e), t) : r ? i : null }, fr(t, e)
        }, ma.layout.treemap = function() {
            function t(t, e) { for (var n, i, r = -1, o = t.length; ++r < o;) i = (n = t[r]).value * (e < 0 ? 0 : e), n.area = isNaN(i) || i <= 0 ? 0 : i }

            function e(n) {
                var o = n.children;
                if (o && o.length) {
                    var a, s, l, u = h(n),
                        c = [],
                        d = o.slice(),
                        f = 1 / 0,
                        g = "slice" === p ? u.dx : "dice" === p ? u.dy : "slice-dice" === p ? 1 & n.depth ? u.dy : u.dx : Math.min(u.dx, u.dy);
                    for (t(d, u.dx * u.dy / n.value), c.area = 0;
                        (l = d.length) > 0;) c.push(a = d[l - 1]), c.area += a.area, "squarify" !== p || (s = i(c, g)) <= f ? (d.pop(), f = s) : (c.area -= c.pop().area, r(c, g, u, !1), g = Math.min(u.dx, u.dy), c.length = c.area = 0, f = 1 / 0);
                    c.length && (r(c, g, u, !0), c.length = c.area = 0), o.forEach(e)
                }
            }

            function n(e) {
                var i = e.children;
                if (i && i.length) {
                    var o, a = h(e),
                        s = i.slice(),
                        l = [];
                    for (t(s, a.dx * a.dy / e.value), l.area = 0; o = s.pop();) l.push(o), l.area += o.area, null != o.z && (r(l, o.z ? a.dx : a.dy, a, !s.length), l.length = l.area = 0);
                    i.forEach(n)
                }
            }

            function i(t, e) { for (var n, i = t.area, r = 0, o = 1 / 0, a = -1, s = t.length; ++a < s;)(n = t[a].area) && (n < o && (o = n), n > r && (r = n)); return i *= i, e *= e, i ? Math.max(e * r * g / i, i / (e * o * g)) : 1 / 0 }

            function r(t, e, n, i) {
                var r, o = -1,
                    a = t.length,
                    s = n.x,
                    l = n.y,
                    c = e ? u(t.area / e) : 0;
                if (e == n.dx) {
                    for ((i || c > n.dy) && (c = n.dy); ++o < a;) r = t[o], r.x = s, r.y = l, r.dy = c, s += r.dx = Math.min(n.x + n.dx - s, c ? u(r.area / c) : 0);
                    r.z = !0, r.dx += n.x + n.dx - s, n.y += c, n.dy -= c
                } else {
                    for ((i || c > n.dx) && (c = n.dx); ++o < a;) r = t[o], r.x = s, r.y = l, r.dx = c, l += r.dy = Math.min(n.y + n.dy - l, c ? u(r.area / c) : 0);
                    r.z = !1, r.dy += n.y + n.dy - l, n.x += c, n.dx -= c
                }
            }

            function o(i) {
                var r = a || l(i),
                    o = r[0];
                return o.x = o.y = 0, o.value ? (o.dx = c[0], o.dy = c[1]) : o.dx = o.dy = 0, a && l.revalue(o), t([o], o.dx * o.dy / o.value), (a ? n : e)(o), f && (a = r), r
            }
            var a, l = ma.layout.hierarchy(),
                u = Math.round,
                c = [1, 1],
                d = null,
                h = Kr,
                f = !1,
                p = "squarify",
                g = .5 * (1 + Math.sqrt(5));
            return o.size = function(t) { return arguments.length ? (c = t, o) : c }, o.padding = function(t) {
                function e(e) { var n = t.call(o, e, e.depth); return null == n ? Kr(e) : Gr(e, "number" == typeof n ? [n, n, n, n] : n) }

                function n(e) { return Gr(e, t) }
                if (!arguments.length) return d;
                var i;
                return h = null == (d = t) ? Kr : "function" === (i = "undefined" == typeof t ? "undefined" : (0, s.default)(t)) ? e : "number" === i ? (t = [t, t, t, t], n) : n, o
            }, o.round = function(t) { return arguments.length ? (u = t ? Math.round : Number, o) : u != Number }, o.sticky = function(t) { return arguments.length ? (f = t, a = null, o) : f }, o.ratio = function(t) { return arguments.length ? (g = t, o) : g }, o.mode = function(t) { return arguments.length ? (p = t + "", o) : p }, fr(o, l)
        }, ma.random = {
            normal: function(t, e) {
                var n = arguments.length;
                return n < 2 && (e = 1), n < 1 && (t = 0),
                    function() {
                        var n, i, r;
                        do n = 2 * Math.random() - 1, i = 2 * Math.random() - 1, r = n * n + i * i; while (!r || r > 1);
                        return t + e * n * Math.sqrt(-2 * Math.log(r) / r)
                    }
            },
            logNormal: function() { var t = ma.random.normal.apply(ma, arguments); return function() { return Math.exp(t()) } },
            bates: function(t) { var e = ma.random.irwinHall(t); return function() { return e() / t } },
            irwinHall: function(t) { return function() { for (var e = 0, n = 0; n < t; n++) e += Math.random(); return e } }
        }, ma.scale = {};
        var Dl = { floor: M, ceil: M };
        ma.scale.linear = function() { return ro([0, 1], [0, 1], Ai, !1) };
        var Ol = { s: 1, g: 1, p: 1, r: 1, e: 1 };
        ma.scale.log = function() { return fo(ma.scale.linear().domain([0, 1]), 10, !0, [1, 10]) };
        var Ll = ma.format(".0e"),
            $l = { floor: function(t) { return -Math.ceil(-t) }, ceil: function(t) { return -Math.floor(-t) } };
        ma.scale.pow = function() { return po(ma.scale.linear(), 1, [0, 1]) }, ma.scale.sqrt = function() { return ma.scale.pow().exponent(.5) }, ma.scale.ordinal = function() {
            return vo([], {
                t: "range",
                a: [
                    []
                ]
            })
        }, ma.scale.category10 = function() { return ma.scale.ordinal().range(Nl) }, ma.scale.category20 = function() { return ma.scale.ordinal().range(Rl) }, ma.scale.category20b = function() { return ma.scale.ordinal().range(ql) }, ma.scale.category20c = function() { return ma.scale.ordinal().range(Fl) };
        var Nl = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(At),
            Rl = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(At),
            ql = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(At),
            Fl = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(At);
        ma.scale.quantile = function() { return mo([], []) }, ma.scale.quantize = function() { return yo(0, 1, [0, 1]) }, ma.scale.threshold = function() { return bo([.5], [0, 1]) }, ma.scale.identity = function() { return xo([0, 1]) }, ma.svg = {}, ma.svg.arc = function() {
            function t() {
                var t = Math.max(0, +n.apply(this, arguments)),
                    u = Math.max(0, +i.apply(this, arguments)),
                    c = a.apply(this, arguments) - Ga,
                    d = s.apply(this, arguments) - Ga,
                    h = Math.abs(d - c),
                    f = c > d ? 0 : 1;
                if (u < t && (p = u, u = t, t = p), h >= Ka) return e(u, f) + (t ? e(t, 1 - f) : "") + "Z";
                var p, g, v, m, y, b, x, w, k, S, _, T, C = 0,
                    M = 0,
                    A = [];
                if ((m = (+l.apply(this, arguments) || 0) / 2) && (v = o === Hl ? Math.sqrt(t * t + u * u) : +o.apply(this, arguments), f || (M *= -1), u && (M = ct(v / u * Math.sin(m))), t && (C = ct(v / t * Math.sin(m)))), u) {
                    y = u * Math.cos(c + M), b = u * Math.sin(c + M), x = u * Math.cos(d - M), w = u * Math.sin(d - M);
                    var E = Math.abs(d - c - 2 * M) <= Xa ? 0 : 1;
                    if (M && Mo(y, b, x, w) === f ^ E) {
                        var P = (c + d) / 2;
                        y = u * Math.cos(P), b = u * Math.sin(P), x = w = null
                    }
                } else y = b = 0;
                if (t) {
                    k = t * Math.cos(d - C), S = t * Math.sin(d - C), _ = t * Math.cos(c + C), T = t * Math.sin(c + C);
                    var I = Math.abs(c - d + 2 * C) <= Xa ? 0 : 1;
                    if (C && Mo(k, S, _, T) === 1 - f ^ I) {
                        var z = (c + d) / 2;
                        k = t * Math.cos(z), S = t * Math.sin(z), _ = T = null
                    }
                } else k = S = 0;
                if (h > Ua && (p = Math.min(Math.abs(u - t) / 2, +r.apply(this, arguments))) > .001) {
                    g = t < u ^ f ? 0 : 1;
                    var D = p,
                        O = p;
                    if (h < Xa) {
                        var L = null == _ ? [k, S] : null == x ? [y, b] : Wn([y, b], [_, T], [x, w], [k, S]),
                            $ = y - L[0],
                            N = b - L[1],
                            R = x - L[0],
                            q = w - L[1],
                            F = 1 / Math.sin(Math.acos(($ * R + N * q) / (Math.sqrt($ * $ + N * N) * Math.sqrt(R * R + q * q))) / 2),
                            H = Math.sqrt(L[0] * L[0] + L[1] * L[1]);
                        O = Math.min(p, (t - H) / (F - 1)), D = Math.min(p, (u - H) / (F + 1))
                    }
                    if (null != x) {
                        var B = Ao(null == _ ? [k, S] : [_, T], [y, b], u, D, f),
                            W = Ao([x, w], [k, S], u, D, f);
                        p === D ? A.push("M", B[0], "A", D, ",", D, " 0 0,", g, " ", B[1], "A", u, ",", u, " 0 ", 1 - f ^ Mo(B[1][0], B[1][1], W[1][0], W[1][1]), ",", f, " ", W[1], "A", D, ",", D, " 0 0,", g, " ", W[0]) : A.push("M", B[0], "A", D, ",", D, " 0 1,", g, " ", W[0])
                    } else A.push("M", y, ",", b);
                    if (null != _) {
                        var j = Ao([y, b], [_, T], t, -O, f),
                            Y = Ao([k, S], null == x ? [y, b] : [x, w], t, -O, f);
                        p === O ? A.push("L", Y[0], "A", O, ",", O, " 0 0,", g, " ", Y[1], "A", t, ",", t, " 0 ", f ^ Mo(Y[1][0], Y[1][1], j[1][0], j[1][1]), ",", 1 - f, " ", j[1], "A", O, ",", O, " 0 0,", g, " ", j[0]) : A.push("L", Y[0], "A", O, ",", O, " 0 0,", g, " ", j[0])
                    } else A.push("L", k, ",", S)
                } else A.push("M", y, ",", b), null != x && A.push("A", u, ",", u, " 0 ", E, ",", f, " ", x, ",", w), A.push("L", k, ",", S), null != _ && A.push("A", t, ",", t, " 0 ", I, ",", 1 - f, " ", _, ",", T);
                return A.push("Z"), A.join("")
            }

            function e(t, e) { return "M0," + t + "A" + t + "," + t + " 0 1," + e + " 0," + -t + "A" + t + "," + t + " 0 1," + e + " 0," + t }
            var n = ko,
                i = So,
                r = wo,
                o = Hl,
                a = _o,
                s = To,
                l = Co;
            return t.innerRadius = function(e) { return arguments.length ? (n = Lt(e), t) : n }, t.outerRadius = function(e) { return arguments.length ? (i = Lt(e), t) : i }, t.cornerRadius = function(e) { return arguments.length ? (r = Lt(e), t) : r }, t.padRadius = function(e) { return arguments.length ? (o = e == Hl ? Hl : Lt(e), t) : o }, t.startAngle = function(e) { return arguments.length ? (a = Lt(e), t) : a }, t.endAngle = function(e) { return arguments.length ? (s = Lt(e), t) : s }, t.padAngle = function(e) { return arguments.length ? (l = Lt(e), t) : l }, t.centroid = function() {
                var t = (+n.apply(this, arguments) + +i.apply(this, arguments)) / 2,
                    e = (+a.apply(this, arguments) + +s.apply(this, arguments)) / 2 - Ga;
                return [Math.cos(e) * t, Math.sin(e) * t]
            }, t
        };
        var Hl = "auto";
        ma.svg.line = function() { return Eo(M) };
        var Bl = ma.map({ linear: Po, "linear-closed": Io, step: zo, "step-before": Do, "step-after": Oo, basis: Fo, "basis-open": Ho, "basis-closed": Bo, bundle: Wo, cardinal: No, "cardinal-open": Lo, "cardinal-closed": $o, monotone: Zo });
        Bl.forEach(function(t, e) { e.key = t, e.closed = /-closed$/.test(t) });
        var Wl = [0, 2 / 3, 1 / 3, 0],
            jl = [0, 1 / 3, 2 / 3, 0],
            Yl = [0, 1 / 6, 2 / 3, 1 / 6];
        ma.svg.line.radial = function() { var t = Eo(Ko); return t.radius = t.x, delete t.x, t.angle = t.y, delete t.y, t }, Do.reverse = Oo, Oo.reverse = Do, ma.svg.area = function() { return Go(M) }, ma.svg.area.radial = function() { var t = Go(Ko); return t.radius = t.x, delete t.x, t.innerRadius = t.x0, delete t.x0, t.outerRadius = t.x1, delete t.x1, t.angle = t.y, delete t.y, t.startAngle = t.y0, delete t.y0, t.endAngle = t.y1, delete t.y1, t }, ma.svg.chord = function() {
            function t(t, s) {
                var l = e(this, o, t, s),
                    u = e(this, a, t, s);
                return "M" + l.p0 + i(l.r, l.p1, l.a1 - l.a0) + (n(l, u) ? r(l.r, l.p1, l.r, l.p0) : r(l.r, l.p1, u.r, u.p0) + i(u.r, u.p1, u.a1 - u.a0) + r(u.r, u.p1, l.r, l.p0)) + "Z"
            }

            function e(t, e, n, i) {
                var r = e.call(t, n, i),
                    o = s.call(t, r, i),
                    a = l.call(t, r, i) - Ga,
                    c = u.call(t, r, i) - Ga;
                return { r: o, a0: a, a1: c, p0: [o * Math.cos(a), o * Math.sin(a)], p1: [o * Math.cos(c), o * Math.sin(c)] }
            }

            function n(t, e) { return t.a0 == e.a0 && t.a1 == e.a1 }

            function i(t, e, n) { return "A" + t + "," + t + " 0 " + +(n > Xa) + ",1 " + e }

            function r(t, e, n, i) { return "Q 0,0 " + i }
            var o = An,
                a = En,
                s = Jo,
                l = _o,
                u = To;
            return t.radius = function(e) { return arguments.length ? (s = Lt(e), t) : s }, t.source = function(e) { return arguments.length ? (o = Lt(e), t) : o }, t.target = function(e) { return arguments.length ? (a = Lt(e), t) : a }, t.startAngle = function(e) { return arguments.length ? (l = Lt(e), t) : l }, t.endAngle = function(e) { return arguments.length ? (u = Lt(e), t) : u }, t
        }, ma.svg.diagonal = function() {
            function t(t, r) {
                var o = e.call(this, t, r),
                    a = n.call(this, t, r),
                    s = (o.y + a.y) / 2,
                    l = [o, { x: o.x, y: s }, { x: a.x, y: s }, a];
                return l = l.map(i), "M" + l[0] + "C" + l[1] + " " + l[2] + " " + l[3]
            }
            var e = An,
                n = En,
                i = Qo;
            return t.source = function(n) { return arguments.length ? (e = Lt(n), t) : e }, t.target = function(e) { return arguments.length ? (n = Lt(e), t) : n }, t.projection = function(e) { return arguments.length ? (i = e, t) : i }, t
        }, ma.svg.diagonal.radial = function() {
            var t = ma.svg.diagonal(),
                e = Qo,
                n = t.projection;
            return t.projection = function(t) { return arguments.length ? n(ta(e = t)) : e }, t
        }, ma.svg.symbol = function() {
            function t(t, i) { return (Ul.get(e.call(this, t, i)) || ia)(n.call(this, t, i)) }
            var e = na,
                n = ea;
            return t.type = function(n) { return arguments.length ? (e = Lt(n), t) : e }, t.size = function(e) { return arguments.length ? (n = Lt(e), t) : n }, t
        };
        var Ul = ma.map({
            circle: ia,
            cross: function(t) { var e = Math.sqrt(t / 5) / 2; return "M" + -3 * e + "," + -e + "H" + -e + "V" + -3 * e + "H" + e + "V" + -e + "H" + 3 * e + "V" + e + "H" + e + "V" + 3 * e + "H" + -e + "V" + e + "H" + -3 * e + "Z" },
            diamond: function(t) {
                var e = Math.sqrt(t / (2 * Xl)),
                    n = e * Xl;
                return "M0," + -e + "L" + n + ",0 0," + e + " " + -n + ",0Z"
            },
            square: function(t) { var e = Math.sqrt(t) / 2; return "M" + -e + "," + -e + "L" + e + "," + -e + " " + e + "," + e + " " + -e + "," + e + "Z" },
            "triangle-down": function(t) {
                var e = Math.sqrt(t / Vl),
                    n = e * Vl / 2;
                return "M0," + n + "L" + e + "," + -n + " " + -e + "," + -n + "Z"
            },
            "triangle-up": function(t) {
                var e = Math.sqrt(t / Vl),
                    n = e * Vl / 2;
                return "M0," + -n + "L" + e + "," + n + " " + -e + "," + n + "Z"
            }
        });
        ma.svg.symbolTypes = Ul.keys();
        var Vl = Math.sqrt(3),
            Xl = Math.tan(30 * Ja);
        Ra.transition = function(t) { for (var e, n, i = Zl || ++Ql, r = la(t), o = [], a = Kl || { time: Date.now(), ease: Li, delay: 0, duration: 250 }, s = -1, l = this.length; ++s < l;) { o.push(e = []); for (var u = this[s], c = -1, d = u.length; ++c < d;)(n = u[c]) && ua(n, c, r, i, a), e.push(n) } return oa(o, r, i) }, Ra.interrupt = function(t) { return this.each(null == t ? Gl : ra(la(t))) };
        var Zl, Kl, Gl = ra(la()),
            Jl = [],
            Ql = 0;
        Jl.call = Ra.call, Jl.empty = Ra.empty, Jl.node = Ra.node, Jl.size = Ra.size, ma.transition = function(t, e) { return t && t.transition ? Zl ? t.transition(e) : t : ma.selection().transition(t) }, ma.transition.prototype = Jl, Jl.select = function(t) {
            var e, n, i, r = this.id,
                o = this.namespace,
                a = [];
            t = N(t);
            for (var s = -1, l = this.length; ++s < l;) { a.push(e = []); for (var u = this[s], c = -1, d = u.length; ++c < d;)(i = u[c]) && (n = t.call(i, i.__data__, c, s)) ? ("__data__" in i && (n.__data__ = i.__data__), ua(n, c, o, r, i[o][r]), e.push(n)) : e.push(null) }
            return oa(a, o, r)
        }, Jl.selectAll = function(t) {
            var e, n, i, r, o, a = this.id,
                s = this.namespace,
                l = [];
            t = R(t);
            for (var u = -1, c = this.length; ++u < c;)
                for (var d = this[u], h = -1, f = d.length; ++h < f;)
                    if (i = d[h]) { o = i[s][a], n = t.call(i, i.__data__, h, u), l.push(e = []); for (var p = -1, g = n.length; ++p < g;)(r = n[p]) && ua(r, p, s, a, o), e.push(r) } return oa(l, s, a)
        }, Jl.filter = function(t) { var e, n, i, r = []; "function" != typeof t && (t = K(t)); for (var o = 0, a = this.length; o < a; o++) { r.push(e = []); for (var n = this[o], s = 0, l = n.length; s < l; s++)(i = n[s]) && t.call(i, i.__data__, s, o) && e.push(i) } return oa(r, this.namespace, this.id) }, Jl.tween = function(t, e) {
            var n = this.id,
                i = this.namespace;
            return arguments.length < 2 ? this.node()[i][n].tween.get(t) : J(this, null == e ? function(e) { e[i][n].tween.remove(t) } : function(r) { r[i][n].tween.set(t, e) })
        }, Jl.attr = function(t, e) {
            function n() { this.removeAttribute(s) }

            function i() { this.removeAttributeNS(s.space, s.local) }

            function r(t) { return null == t ? n : (t += "", function() { var e, n = this.getAttribute(s); return n !== t && (e = a(n, t), function(t) { this.setAttribute(s, e(t)) }) }) }

            function o(t) { return null == t ? i : (t += "", function() { var e, n = this.getAttributeNS(s.space, s.local); return n !== t && (e = a(n, t), function(t) { this.setAttributeNS(s.space, s.local, e(t)) }) }) }
            if (arguments.length < 2) { for (e in t) this.attr(e, t[e]); return this }
            var a = "transform" == t ? nr : Ai,
                s = ma.ns.qualify(t);
            return aa(this, "attr." + t, e, s.local ? o : r)
        }, Jl.attrTween = function(t, e) {
            function n(t, n) { var i = e.call(this, t, n, this.getAttribute(r)); return i && function(t) { this.setAttribute(r, i(t)) } }

            function i(t, n) { var i = e.call(this, t, n, this.getAttributeNS(r.space, r.local)); return i && function(t) { this.setAttributeNS(r.space, r.local, i(t)) } }
            var r = ma.ns.qualify(t);
            return this.tween("attr." + t, r.local ? i : n)
        }, Jl.style = function(t, e, n) {
            function i() { this.style.removeProperty(t) }

            function r(e) { return null == e ? i : (e += "", function() { var i, r = a(this).getComputedStyle(this, null).getPropertyValue(t); return r !== e && (i = Ai(r, e), function(e) { this.style.setProperty(t, i(e), n) }) }) }
            var o = arguments.length;
            if (o < 3) { if ("string" != typeof t) { o < 2 && (e = ""); for (n in t) this.style(n, t[n], e); return this } n = "" }
            return aa(this, "style." + t, e, r)
        }, Jl.styleTween = function(t, e, n) {
            function i(i, r) { var o = e.call(this, i, r, a(this).getComputedStyle(this, null).getPropertyValue(t)); return o && function(e) { this.style.setProperty(t, o(e), n) } }
            return arguments.length < 3 && (n = ""), this.tween("style." + t, i)
        }, Jl.text = function(t) { return aa(this, "text", t, sa) }, Jl.remove = function() {
            var t = this.namespace;
            return this.each("end.transition", function() {
                var e;
                this[t].count < 2 && (e = this.parentNode) && e.removeChild(this)
            })
        }, Jl.ease = function(t) {
            var e = this.id,
                n = this.namespace;
            return arguments.length < 1 ? this.node()[n][e].ease : ("function" != typeof t && (t = ma.ease.apply(ma, arguments)), J(this, function(i) { i[n][e].ease = t }))
        }, Jl.delay = function(t) {
            var e = this.id,
                n = this.namespace;
            return arguments.length < 1 ? this.node()[n][e].delay : J(this, "function" == typeof t ? function(i, r, o) { i[n][e].delay = +t.call(i, i.__data__, r, o) } : (t = +t, function(i) { i[n][e].delay = t }))
        }, Jl.duration = function(t) {
            var e = this.id,
                n = this.namespace;
            return arguments.length < 1 ? this.node()[n][e].duration : J(this, "function" == typeof t ? function(i, r, o) { i[n][e].duration = Math.max(1, t.call(i, i.__data__, r, o)) } : (t = Math.max(1, t), function(i) { i[n][e].duration = t }))
        }, Jl.each = function(t, e) {
            var n = this.id,
                i = this.namespace;
            if (arguments.length < 2) {
                var r = Kl,
                    o = Zl;
                try { Zl = n, J(this, function(e, r, o) { Kl = e[i][n], t.call(e, e.__data__, r, o) }) } finally { Kl = r, Zl = o }
            } else J(this, function(r) {
                var o = r[i][n];
                (o.event || (o.event = ma.dispatch("start", "end", "interrupt"))).on(t, e)
            });
            return this
        }, Jl.transition = function() { for (var t, e, n, i, r = this.id, o = ++Ql, a = this.namespace, s = [], l = 0, u = this.length; l < u; l++) { s.push(t = []); for (var e = this[l], c = 0, d = e.length; c < d; c++)(n = e[c]) && (i = n[a][r], ua(n, c, a, o, { time: i.time, ease: i.ease, delay: i.delay + i.duration, duration: i.duration })), t.push(n) } return oa(s, a, o) }, ma.svg.axis = function() {
            function t(t) {
                t.each(function() {
                    var t, u = ma.select(this),
                        c = this.__chart__ || n,
                        d = this.__chart__ = n.copy(),
                        h = null == l ? d.ticks ? d.ticks.apply(d, s) : d.domain() : l,
                        f = null == e ? d.tickFormat ? d.tickFormat.apply(d, s) : M : e,
                        p = u.selectAll(".tick").data(h, d),
                        g = p.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Ua),
                        v = ma.transition(p.exit()).style("opacity", Ua).remove(),
                        m = ma.transition(p.order()).style("opacity", 1),
                        y = Math.max(r, 0) + a,
                        b = Qr(d),
                        x = u.selectAll(".domain").data([0]),
                        w = (x.enter().append("path").attr("class", "domain"), ma.transition(x));
                    g.append("line"), g.append("text");
                    var k, S, _, T, C = g.select("line"),
                        A = m.select("line"),
                        E = p.select("text").text(f),
                        P = g.select("text"),
                        I = m.select("text"),
                        z = "top" === i || "left" === i ? -1 : 1;
                    if ("bottom" === i || "top" === i ? (t = ca, k = "x", _ = "y", S = "x2", T = "y2", E.attr("dy", z < 0 ? "0em" : ".71em").style("text-anchor", "middle"), w.attr("d", "M" + b[0] + "," + z * o + "V0H" + b[1] + "V" + z * o)) : (t = da, k = "y", _ = "x", S = "y2", T = "x2", E.attr("dy", ".32em").style("text-anchor", z < 0 ? "end" : "start"), w.attr("d", "M" + z * o + "," + b[0] + "H0V" + b[1] + "H" + z * o)), C.attr(T, z * r), P.attr(_, z * y), A.attr(S, 0).attr(T, z * r), I.attr(k, 0).attr(_, z * y), d.rangeBand) {
                        var D = d,
                            O = D.rangeBand() / 2;
                        c = d = function(t) { return D(t) + O }
                    } else c.rangeBand ? c = d : v.call(t, d, c);
                    g.call(t, c, d), m.call(t, d, d)
                })
            }
            var e, n = ma.scale.linear(),
                i = tu,
                r = 6,
                o = 6,
                a = 3,
                s = [10],
                l = null;
            return t.scale = function(e) { return arguments.length ? (n = e, t) : n }, t.orient = function(e) { return arguments.length ? (i = e in eu ? e + "" : tu, t) : i }, t.ticks = function() { return arguments.length ? (s = ba(arguments), t) : s }, t.tickValues = function(e) { return arguments.length ? (l = e, t) : l }, t.tickFormat = function(n) { return arguments.length ? (e = n, t) : e }, t.tickSize = function(e) { var n = arguments.length; return n ? (r = +e, o = +arguments[n - 1], t) : r }, t.innerTickSize = function(e) { return arguments.length ? (r = +e, t) : r }, t.outerTickSize = function(e) { return arguments.length ? (o = +e, t) : o }, t.tickPadding = function(e) { return arguments.length ? (a = +e, t) : a }, t.tickSubdivide = function() { return arguments.length && t }, t
        };
        var tu = "bottom",
            eu = { top: 1, right: 1, bottom: 1, left: 1 };
        ma.svg.brush = function() {
            function t(o) {
                o.each(function() {
                    var o = ma.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", r).on("touchstart.brush", r),
                        a = o.selectAll(".background").data([0]);
                    a.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), o.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                    var s = o.selectAll(".resize").data(g, M);
                    s.exit().remove(), s.enter().append("g").attr("class", function(t) { return "resize " + t }).style("cursor", function(t) { return nu[t] }).append("rect").attr("x", function(t) { return /[ew]$/.test(t) ? -3 : null }).attr("y", function(t) { return /^[ns]/.test(t) ? -3 : null }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), s.style("display", t.empty() ? "none" : null);
                    var l, d = ma.transition(o),
                        h = ma.transition(a);
                    u && (l = Qr(u), h.attr("x", l[0]).attr("width", l[1] - l[0]), n(d)), c && (l = Qr(c), h.attr("y", l[0]).attr("height", l[1] - l[0]), i(d)), e(d)
                })
            }

            function e(t) { t.selectAll(".resize").attr("transform", function(t) { return "translate(" + d[+/e$/.test(t)] + "," + h[+/^s/.test(t)] + ")" }) }

            function n(t) { t.select(".extent").attr("x", d[0]), t.selectAll(".extent,.n>rect,.s>rect").attr("width", d[1] - d[0]) }

            function i(t) { t.select(".extent").attr("y", h[0]), t.selectAll(".extent,.e>rect,.w>rect").attr("height", h[1] - h[0]) }

            function r() {
                function r() { 32 == ma.event.keyCode && (A || (b = null, P[0] -= d[1], P[1] -= h[1], A = 2), D()) }

                function g() { 32 == ma.event.keyCode && 2 == A && (P[0] += d[1], P[1] += h[1], A = 0, D()) }

                function v() {
                    var t = ma.mouse(w),
                        r = !1;
                    x && (t[0] += x[0], t[1] += x[1]), A || (ma.event.altKey ? (b || (b = [(d[0] + d[1]) / 2, (h[0] + h[1]) / 2]), P[0] = d[+(t[0] < b[0])], P[1] = h[+(t[1] < b[1])]) : b = null), C && m(t, u, 0) && (n(_), r = !0), M && m(t, c, 1) && (i(_), r = !0), r && (e(_), S({ type: "brush", mode: A ? "move" : "resize" }))
                }

                function m(t, e, n) {
                    var i, r, a = Qr(e),
                        l = a[0],
                        u = a[1],
                        c = P[n],
                        g = n ? h : d,
                        v = g[1] - g[0];
                    if (A && (l -= c, u -= v + c), i = (n ? p : f) ? Math.max(l, Math.min(u, t[n])) : t[n], A ? r = (i += c) + v : (b && (c = Math.max(l, Math.min(u, 2 * b[n] - i))), c < i ? (r = i, i = c) : r = c), g[0] != i || g[1] != r) return n ? s = null : o = null, g[0] = i, g[1] = r, !0
                }

                function y() { v(), _.style("pointer-events", "all").selectAll(".resize").style("display", t.empty() ? "none" : null), ma.select("body").style("cursor", null), I.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), E(), S({ type: "brushend" }) }
                var b, x, w = this,
                    k = ma.select(ma.event.target),
                    S = l.of(w, arguments),
                    _ = ma.select(w),
                    T = k.datum(),
                    C = !/^(n|s)$/.test(T) && u,
                    M = !/^(e|w)$/.test(T) && c,
                    A = k.classed("extent"),
                    E = rt(w),
                    P = ma.mouse(w),
                    I = ma.select(a(w)).on("keydown.brush", r).on("keyup.brush", g);
                if (ma.event.changedTouches ? I.on("touchmove.brush", v).on("touchend.brush", y) : I.on("mousemove.brush", v).on("mouseup.brush", y), _.interrupt().selectAll("*").interrupt(), A) P[0] = d[0] - P[0], P[1] = h[0] - P[1];
                else if (T) {
                    var z = +/w$/.test(T),
                        O = +/^n/.test(T);
                    x = [d[1 - z] - P[0], h[1 - O] - P[1]], P[0] = d[z], P[1] = h[O]
                } else ma.event.altKey && (b = P.slice());
                _.style("pointer-events", "none").selectAll(".resize").style("display", null), ma.select("body").style("cursor", k.style("cursor")), S({ type: "brushstart" }), v()
            }
            var o, s, l = L(t, "brushstart", "brush", "brushend"),
                u = null,
                c = null,
                d = [0, 0],
                h = [0, 0],
                f = !0,
                p = !0,
                g = iu[0];
            return t.event = function(t) {
                t.each(function() {
                    var t = l.of(this, arguments),
                        e = { x: d, y: h, i: o, j: s },
                        n = this.__chart__ || e;
                    this.__chart__ = e, Zl ? ma.select(this).transition().each("start.brush", function() { o = n.i, s = n.j, d = n.x, h = n.y, t({ type: "brushstart" }) }).tween("brush:brush", function() {
                        var n = Ei(d, e.x),
                            i = Ei(h, e.y);
                        return o = s = null,
                            function(r) { d = e.x = n(r), h = e.y = i(r), t({ type: "brush", mode: "resize" }) }
                    }).each("end.brush", function() { o = e.i, s = e.j, t({ type: "brush", mode: "resize" }), t({ type: "brushend" }) }) : (t({ type: "brushstart" }), t({ type: "brush", mode: "resize" }), t({ type: "brushend" }))
                })
            }, t.x = function(e) { return arguments.length ? (u = e, g = iu[!u << 1 | !c], t) : u }, t.y = function(e) { return arguments.length ? (c = e, g = iu[!u << 1 | !c], t) : c }, t.clamp = function(e) { return arguments.length ? (u && c ? (f = !!e[0], p = !!e[1]) : u ? f = !!e : c && (p = !!e), t) : u && c ? [f, p] : u ? f : c ? p : null }, t.extent = function(e) {
                var n, i, r, a, l;
                return arguments.length ? (u && (n = e[0], i = e[1], c && (n = n[0], i = i[0]), o = [n, i], u.invert && (n = u(n), i = u(i)), i < n && (l = n, n = i, i = l), n == d[0] && i == d[1] || (d = [n, i])), c && (r = e[0], a = e[1], u && (r = r[1], a = a[1]), s = [r, a], c.invert && (r = c(r), a = c(a)), a < r && (l = r, r = a, a = l), r == h[0] && a == h[1] || (h = [r, a])), t) : (u && (o ? (n = o[0], i = o[1]) : (n = d[0], i = d[1], u.invert && (n = u.invert(n), i = u.invert(i)), i < n && (l = n, n = i, i = l))), c && (s ? (r = s[0], a = s[1]) : (r = h[0], a = h[1], c.invert && (r = c.invert(r), a = c.invert(a)), a < r && (l = r, r = a, a = l))), u && c ? [
                    [n, r],
                    [i, a]
                ] : u ? [n, i] : c && [r, a])
            }, t.clear = function() { return t.empty() || (d = [0, 0], h = [0, 0], o = s = null), t }, t.empty = function() { return !!u && d[0] == d[1] || !!c && h[0] == h[1] }, ma.rebind(t, l, "on")
        };
        var nu = { n: "ns-resize", e: "ew-resize", s: "ns-resize", w: "ew-resize", nw: "nwse-resize", ne: "nesw-resize", se: "nwse-resize", sw: "nesw-resize" },
            iu = [
                ["n", "e", "s", "w", "nw", "ne", "se", "sw"],
                ["e", "w"],
                ["n", "s"],
                []
            ],
            ru = Ss.format = Es.timeFormat,
            ou = ru.utc,
            au = ou("%Y-%m-%dT%H:%M:%S.%LZ");
        ru.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? ha : au, ha.parse = function(t) { var e = new Date(t); return isNaN(e) ? null : e }, ha.toString = au.toString, Ss.second = Zt(function(t) { return new _s(1e3 * Math.floor(t / 1e3)) }, function(t, e) { t.setTime(t.getTime() + 1e3 * Math.floor(e)) }, function(t) { return t.getSeconds() }), Ss.seconds = Ss.second.range, Ss.seconds.utc = Ss.second.utc.range, Ss.minute = Zt(function(t) { return new _s(6e4 * Math.floor(t / 6e4)) }, function(t, e) { t.setTime(t.getTime() + 6e4 * Math.floor(e)) }, function(t) { return t.getMinutes() }), Ss.minutes = Ss.minute.range, Ss.minutes.utc = Ss.minute.utc.range, Ss.hour = Zt(function(t) { var e = t.getTimezoneOffset() / 60; return new _s(36e5 * (Math.floor(t / 36e5 - e) + e)) }, function(t, e) { t.setTime(t.getTime() + 36e5 * Math.floor(e)) }, function(t) { return t.getHours() }), Ss.hours = Ss.hour.range, Ss.hours.utc = Ss.hour.utc.range, Ss.month = Zt(function(t) { return t = Ss.day(t), t.setDate(1), t }, function(t, e) { t.setMonth(t.getMonth() + e) }, function(t) { return t.getMonth() }), Ss.months = Ss.month.range, Ss.months.utc = Ss.month.utc.range;
        var su = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6],
            lu = [
                [Ss.second, 1],
                [Ss.second, 5],
                [Ss.second, 15],
                [Ss.second, 30],
                [Ss.minute, 1],
                [Ss.minute, 5],
                [Ss.minute, 15],
                [Ss.minute, 30],
                [Ss.hour, 1],
                [Ss.hour, 3],
                [Ss.hour, 6],
                [Ss.hour, 12],
                [Ss.day, 1],
                [Ss.day, 2],
                [Ss.week, 1],
                [Ss.month, 1],
                [Ss.month, 3],
                [Ss.year, 1]
            ],
            uu = ru.multi([
                [".%L", function(t) { return t.getMilliseconds() }],
                [":%S", function(t) { return t.getSeconds() }],
                ["%I:%M", function(t) { return t.getMinutes() }],
                ["%I %p", function(t) { return t.getHours() }],
                ["%a %d", function(t) { return t.getDay() && 1 != t.getDate() }],
                ["%b %d", function(t) { return 1 != t.getDate() }],
                ["%B", function(t) { return t.getMonth() }],
                ["%Y", Re]
            ]),
            cu = { range: function(t, e, n) { return ma.range(Math.ceil(t / n) * n, +e, n).map(pa) }, floor: M, ceil: M };
        lu.year = Ss.year, Ss.scale = function() { return fa(ma.scale.linear(), lu, uu) };
        var du = lu.map(function(t) { return [t[0].utc, t[1]] }),
            hu = ou.multi([
                [".%L", function(t) { return t.getUTCMilliseconds() }],
                [":%S", function(t) { return t.getUTCSeconds() }],
                ["%I:%M", function(t) { return t.getUTCMinutes() }],
                ["%I %p", function(t) { return t.getUTCHours() }],
                ["%a %d", function(t) { return t.getUTCDay() && 1 != t.getUTCDate() }],
                ["%b %d", function(t) { return 1 != t.getUTCDate() }],
                ["%B", function(t) { return t.getUTCMonth() }],
                ["%Y", Re]
            ]);
        du.year = Ss.year.utc, Ss.scale.utc = function() { return fa(ma.scale.linear(), du, hu) }, ma.text = $t(function(t) { return t.responseText }), ma.json = function(t, e) { return Nt(t, "application/json", ga, e) }, ma.html = function(t, e) { return Nt(t, "text/html", va, e) }, ma.xml = $t(function(t) { return t.responseXML }), this.d3 = ma, r = ma, o = "function" == typeof r ? r.call(e, n, e, t) : r, !(void 0 !== o && (t.exports = o))
    }()
}, function(t, e, n) {
    "use strict";

    function i() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.base,
            i = void 0 === e ? n.p + "img/assets/sprite-" : e,
            r = t.name,
            o = void 0 === r ? "default" : r,
            a = t.extension,
            s = void 0 === a ? ".svg" : a,
            l = i + o + s,
            u = new XMLHttpRequest;
        u.open("GET", l, !0), u.onload = function(t) {
            if (200 !== u.status) return window.console.error(new Error("Sprite " + l + " was " + u.statusText));
            var e = document.createElement("div");
            e.style.display = "none", e.innerHTML = u.responseText, document.body.insertBefore(e, document.body.childNodes[0])
        }, u.send()
    }
    Object.defineProperty(e, "__esModule", { value: !0 }), e.default = i
}, function(t, e) {
    "use strict";
    ! function(t) {
        function e(t, e, n) { this.x = t, this.y = e, this.z = n }

        function n(t) { return t * t * t * (t * (6 * t - 15) + 10) }

        function i(t, e, n) { return (1 - n) * t + n * e }
        var r = t.noise = {};
        e.prototype.dot2 = function(t, e) { return this.x * t + this.y * e }, e.prototype.dot3 = function(t, e, n) { return this.x * t + this.y * e + this.z * n };
        var o = [new e(1, 1, 0), new e((-1), 1, 0), new e(1, (-1), 0), new e((-1), (-1), 0), new e(1, 0, 1), new e((-1), 0, 1), new e(1, 0, (-1)), new e((-1), 0, (-1)), new e(0, 1, 1), new e(0, (-1), 1), new e(0, 1, (-1)), new e(0, (-1), (-1))],
            a = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180],
            s = new Array(512),
            l = new Array(512);
        r.seed = function(t) {
            t > 0 && t < 1 && (t *= 65536), t = Math.floor(t), t < 256 && (t |= t << 8);
            for (var e = 0; e < 256; e++) {
                var n;
                n = 1 & e ? a[e] ^ 255 & t : a[e] ^ t >> 8 & 255, s[e] = s[e + 256] = n, l[e] = l[e + 256] = o[n % 12]
            }
        }, r.seed(0);
        var u = .5 * (Math.sqrt(3) - 1),
            c = (3 - Math.sqrt(3)) / 6,
            d = 1 / 3,
            h = 1 / 6;
        r.simplex2 = function(t, e) {
            var n, i, r, o, a, d = (t + e) * u,
                h = Math.floor(t + d),
                f = Math.floor(e + d),
                p = (h + f) * c,
                g = t - h + p,
                v = e - f + p;
            g > v ? (o = 1, a = 0) : (o = 0, a = 1);
            var m = g - o + c,
                y = v - a + c,
                b = g - 1 + 2 * c,
                x = v - 1 + 2 * c;
            h &= 255, f &= 255;
            var w = l[h + s[f]],
                k = l[h + o + s[f + a]],
                S = l[h + 1 + s[f + 1]],
                _ = .5 - g * g - v * v;
            _ < 0 ? n = 0 : (_ *= _, n = _ * _ * w.dot2(g, v));
            var T = .5 - m * m - y * y;
            T < 0 ? i = 0 : (T *= T, i = T * T * k.dot2(m, y));
            var C = .5 - b * b - x * x;
            return C < 0 ? r = 0 : (C *= C, r = C * C * S.dot2(b, x)), 70 * (n + i + r)
        }, r.simplex3 = function(t, e, n) {
            var i, r, o, a, u, c, f, p, g, v, m = (t + e + n) * d,
                y = Math.floor(t + m),
                b = Math.floor(e + m),
                x = Math.floor(n + m),
                w = (y + b + x) * h,
                k = t - y + w,
                S = e - b + w,
                _ = n - x + w;
            k >= S ? S >= _ ? (u = 1, c = 0, f = 0, p = 1, g = 1, v = 0) : k >= _ ? (u = 1, c = 0, f = 0, p = 1, g = 0, v = 1) : (u = 0, c = 0, f = 1, p = 1, g = 0, v = 1) : S < _ ? (u = 0, c = 0, f = 1, p = 0, g = 1, v = 1) : k < _ ? (u = 0, c = 1, f = 0, p = 0, g = 1, v = 1) : (u = 0, c = 1, f = 0, p = 1, g = 1, v = 0);
            var T = k - u + h,
                C = S - c + h,
                M = _ - f + h,
                A = k - p + 2 * h,
                E = S - g + 2 * h,
                P = _ - v + 2 * h,
                I = k - 1 + 3 * h,
                z = S - 1 + 3 * h,
                D = _ - 1 + 3 * h;
            y &= 255, b &= 255, x &= 255;
            var O = l[y + s[b + s[x]]],
                L = l[y + u + s[b + c + s[x + f]]],
                $ = l[y + p + s[b + g + s[x + v]]],
                N = l[y + 1 + s[b + 1 + s[x + 1]]],
                R = .6 - k * k - S * S - _ * _;
            R < 0 ? i = 0 : (R *= R, i = R * R * O.dot3(k, S, _));
            var q = .6 - T * T - C * C - M * M;
            q < 0 ? r = 0 : (q *= q, r = q * q * L.dot3(T, C, M));
            var F = .6 - A * A - E * E - P * P;
            F < 0 ? o = 0 : (F *= F, o = F * F * $.dot3(A, E, P));
            var H = .6 - I * I - z * z - D * D;
            return H < 0 ? a = 0 : (H *= H, a = H * H * N.dot3(I, z, D)), 32 * (i + r + o + a)
        }, r.perlin2 = function(t, e) {
            var r = Math.floor(t),
                o = Math.floor(e);
            t -= r, e -= o, r = 255 & r, o = 255 & o;
            var a = l[r + s[o]].dot2(t, e),
                u = l[r + s[o + 1]].dot2(t, e - 1),
                c = l[r + 1 + s[o]].dot2(t - 1, e),
                d = l[r + 1 + s[o + 1]].dot2(t - 1, e - 1),
                h = n(t);
            return i(i(a, c, h), i(u, d, h), n(e))
        }, r.perlin3 = function(t, e, r) {
            var o = Math.floor(t),
                a = Math.floor(e),
                u = Math.floor(r);
            t -= o, e -= a, r -= u, o = 255 & o, a = 255 & a, u = 255 & u;
            var c = l[o + s[a + s[u]]].dot3(t, e, r),
                d = l[o + s[a + s[u + 1]]].dot3(t, e, r - 1),
                h = l[o + s[a + 1 + s[u]]].dot3(t, e - 1, r),
                f = l[o + s[a + 1 + s[u + 1]]].dot3(t, e - 1, r - 1),
                p = l[o + 1 + s[a + s[u]]].dot3(t - 1, e, r),
                g = l[o + 1 + s[a + s[u + 1]]].dot3(t - 1, e, r - 1),
                v = l[o + 1 + s[a + 1 + s[u]]].dot3(t - 1, e - 1, r),
                m = l[o + 1 + s[a + 1 + s[u + 1]]].dot3(t - 1, e - 1, r - 1),
                y = n(t),
                b = n(e),
                x = n(r);
            return i(i(i(c, p, y), i(d, g, y), x), i(i(h, v, y), i(f, m, y), x), b)
        }
    }(window)
}, function(t, e, n) {
    "use strict";
    if ("undefined" == typeof SKIN) {
        var i = document.getElementsByTagName("script"),
            r = i[i.length - 1].getAttribute("src");
        try {
            var o = r.split("/");
            n.p = r.substr(0, r.indexOf(o[o.length - 2]) - 1)
        } catch (a) { n.p = "/" }
    } else n.p = SKIN
}, , , function(t, e, n) {
    "use strict";
    n(124), n(158), n(143), n(141), n(142), n(159), n(148), n(146), n(144), n(160), n(134), n(151), n(155), n(162), n(156), n(139), n(150), n(157), n(152), n(128), n(153), n(30), n(140), n(135), n(130), n(92), n(57), n(132), n(164), n(129), n(138), n(147), n(154), n(136), n(93), n(131), n(163), n(137), n(161), n(133), n(149)
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }
        var i = n(57),
            r = e(i),
            o = t("[data-hash]"),
            a = window.location.hash.replace(/#/, ""),
            s = t(".header"),
            l = function() { o.length && o.each(function(e, n) { a === t(n).data("hash") && (t(n).offset().top === s.innerHeight() ? t(".hero").length && window.innerWidth > 768 && t("body").addClass("scrolled") : t("html, body").animate({ scrollTop: t(n).offset().top - s.innerHeight() }, { duration: 0 }), (0, r.default)()) }) };
        l()
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }

        function i() {
            t("[data-banner-item]").hover(function(e) {
                var n = t(e.currentTarget);
                n.find("[data-banner-info]").stop().slideDown(400)
            }, function(e) {
                var n = t(e.currentTarget);
                n.find("[data-banner-info]").stop().slideUp(400)
            })
        }
        var r = n(30),
            o = e(r);
        window.innerWidth > 768 && !(0, o.default)() && i(), t(window).on("resize", function() { window.innerWidth > 768 && !(0, o.default)() && i() })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        
        function e() {
            i.each(function(e, n) {
                var i = t.trim(t(n).html());
                t(n).html(i).lettering("words"), t(n).addClass("rendered")
            })
        }
        n(90);
        var i = t("[data-animate-title]");
        e()
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".fixed-banner");
        t(".footer__back-to-top").on("click", function() { t("html, body").animate({ scrollTop: 0 }, 800), t("body").hasClass("scrolled") && t("body").removeClass("scrolled"), e.length && window.innerWidth > 1024 && setTimeout(function() { t("body").addClass("fixed-banner--visible") }, 800) })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }
        var i = n(30),
            r = e(i),
            o = -1;
        t(".banners").each(function(e, n) {
            var i = t(n).find(".banners__images-hover"),
                a = i.length,
                s = t(n).find(".banners__item");
            s.hover(function(e) {
                if (window.innerWidth > 768 && !(0, r.default)()) {
                    var i = t(e.currentTarget),
                        s = i.data("banner-id");
                    if (i.addClass("active"), i.find(".banners__body").stop().slideDown(400), t(n).find(".banners__images-wrapper").length) {
                        var l = t(".banners__images-hover[data-banner-id=" + s + "]");
                        t(".banners__images-hover").css("z-index", 0), i.index() > o ? (l.next().length && l.next().css("z-index", a - 2), l.prev().css("z-index", a - 1)) : i.index() < o && (l.next().css("z-index", a - 1), l.prev().length && l.prev().css("z-index", a - 2)), t(".banners__images-hover[data-banner-id=" + s + "]").css("z-index", a).hide().stop().fadeIn(300), t(".banners__image").stop().fadeOut(400), o = i.index()
                    }
                }
            }, function(e) {
                if (window.innerWidth > 768 && !(0, r.default)()) {
                    var i = t(e.currentTarget);
                    i.removeClass("active"), i.find(".banners__body").stop().slideUp(400), t(n).find(".banners__images-wrapper").length && t(".banners__image").stop().fadeIn(400)
                }
            })
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e() {
            var t = window.navigator.userAgent,
                e = t.indexOf("MSIE");
            return e > 0 ? parseInt(t.substring(e + 5, t.indexOf(".", e)), 10) : navigator.userAgent.match(/Trident\/7\./) ? 11 : 0
        }
        e() > 0 && t("html").addClass("is-ie")
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(e) {
            var n = t(".positions__results"),
                i = t(".positions__pagination"),
                r = t(".positions__status");
            r.html('<div class="loader">\n                <div class="loader__wrapper">\n\t\t\t\t\t<img src="' + SKIN + 'img/assets/loader2.gif" />\n                    <span>' + window.i18n.loader.loading + "...</span>\n                </div>\n            </div>"), n.empty(), i.empty(), t.ajax({ url:  URL + 'ajax/', data: { action: "load_careers", params: e }, type: "post", dataType: "json", success: function(t) { "success" === t.status && (n.html(t.response.careers), i.html(t.response.pagination.html)) }, error: function() {}, complete: function(t) { "success" === t.status ? r.html("") : (r.html(""), r.append(t.responseJSON.response)) } })
        }

        function n(n) {
            var i = t(".positions .pagination"),
                r = "undefined" == typeof n ? i.length ? i.data("currentPage") : 1 : n,
                o = { pageno: Math.max(1, r), posts_per_page: t(".positions__results").data("posts") };
            e(o)
        }
        t(".positions").delegate(".pagination__item a", "click", function(e) {
            e.preventDefault();
            var i = t(e.currentTarget).parent("li").data("pageno");
            n(i)
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e() { d.forEach(function(t) { for (var e = t, n = new Array(e.columns), i = 0; i < e.columns; i++) { n[i] = new Array(e.columns); for (var r = 0; r < e.rows; r++) n[i][r] = [0, 0] } e.field = n }) }

        function i() {
            d.forEach(function(t) {
                var e = t;
                e.ctx.fillStyle = e.color, e.ctx.fillRect(0, 0, e.width, e.height)
            })
        }

        function r() {
            d.forEach(function(n) {
                var r = n,
                    o = document.querySelector(r.pid),
                    a = t(o).parent(),
                    s = r.canvas.width = a.innerWidth(),
                    l = r.canvas.height = a.innerHeight();
                window.noise.seed(Math.random());
                var c = Math.floor(s / u) + 1,
                    d = Math.floor(l / u) + 1;
                r.width = s, r.height = l, r.columns = c, r.rows = d, i(), e()
            })
        }

        function o(t, e) {
            u = 80, c = 0;
            var n = document.querySelector(t),
                i = n.getContext("2d"),
                o = { pid: t, ctx: i, canvas: n, color: e };
            d.push(o), r(), window.addEventListener("resize", function() { r() })
        }

        function a() {
            d.forEach(function(t) {
                for (var e = t, n = 0; n < e.columns; n++)
                    for (var i = 0; i < e.rows; i++) {
                        var r = e.field[n][i][0],
                            o = e.field[n][i][1];
                        e.ctx.save(), e.ctx.translate(n * u, i * u), e.ctx.rotate(r), e.ctx.strokeStyle = "rgba(255,255,255,0.33)", e.ctx.beginPath(), e.ctx.moveTo(0, 0), e.ctx.lineTo(0, u * o), e.ctx.stroke(), e.ctx.restore()
                    }
            })
        }

        function s() {
            d.forEach(function(t) {
                for (var e = t, n = 0; n < e.columns; n++)
                    for (var i = 0; i < e.rows; i++) {
                        var r = window.noise.simplex3(n / 50, i / 50, c) * Math.PI * 2,
                            o = window.noise.simplex3(n / 100 + 4e4, i / 100 + 4e4, c);
                        e.field[n][i][0] = r, e.field[n][i][1] = o
                    }
            })
        }

        function l() { /*Canvas Rotating lines*/requestAnimationFrame(l), s(), c += .004, i(), a() } n(123);
        var u = void 0,
            c = void 0,
            d = [],
            h = { blue: "#13aec9", cyan: "#2e77ae", "light-blue": "#6696cc", orange: "#FF802B", green: "#143f3c" },
            f = t("[data-code-art]");
        f && f.each(function(e, n) {
            var i = t(n).data("code-art"),
                r = "#code-art-" + i,
                a = t(".values__title").eq(0).data("code-art-color"),
                s = t(n).data("code-art-color") ? h[t(n).data("code-art-color")] : h[a];
            o(r, s), l()
        }), t(".values__title").on("click", function(e) {
            var n = t(e.currentTarget),
                i = h[n.data("code-art-color")];
            d.forEach(function(t) { var e = t; "#code-art-values" === e.pid && (e.color = i) })
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
 }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        t(".footer__cookie-preferences").on("click", function() { window.CookieControl.open() })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".fixed-banner");
        t(window).on("load", function() { e.length && (window.innerWidth > 1024 ? setTimeout(function() { t("body").addClass("fixed-banner--visible") }, 100) : t("body").removeClass("fixed-banner--visible")) }), t(window).on("resize", function() { window.innerWidth < 1025 && t("body").removeClass("fixed-banner--visible") })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        t(".table__row--up").on("click", function(e) {
            var n = t(e.currentTarget).parent();
            n.hasClass("active") ? (n.removeClass("active"), n.find(".table__row--down").slideUp(300)) : (n.addClass("active"), n.find(".table__row--down").slideDown(300))
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        n(121), t(".bar-graph__category").on("click", function(e) {
            var n = t(e.currentTarget);
            n.parents(".bar-graph").find(".bar-graph__category").removeClass("active"), n.parents(".bar-graph").find(".bar-graph__block").removeClass("open"), n.parents(".bar-graph").find(".bar-graph__block").removeClass("animate"), n.addClass("active");
            var i = n.data("bar-graph-block");
            n.parents(".bar-graph").find(".bar-graph__block[data-bar-graph-block=" + i + "]").addClass("open"), setTimeout(function() { n.parents(".bar-graph").find(".bar-graph__block[data-bar-graph-block=" + i + "]").addClass("animate") }, 100)
        }), t(".bar-graph").each(function(e, n) { t(n).find(".bar-graph__category").eq(0).addClass("active"), t(n).find(".bar-graph__block").eq(0).addClass("open animate") });
        var e = 0;
        t("[data-fleet-count]").each(function(n, i) {
            var r = t(i).data("fleet-count");
            e = r > e ? r : e
        }), t("[data-fleet-count]").each(function(n, i) {
            var r = t(i).data("fleet-count");
            t(i).find(".bar-graph__subcategory-bar").css("width", r / e * 100 + "%")
        });
        var i = { "default": "#13aec9", blue: "#13aec9", cyan: "#2e77ae", "light-blue": "#6696cc", orange: "#FF802B", green: "#143f3c" },
            r = t("[data-sequences-sunburst]");
        r.each(function(e, n) {
            function r(t) { for (var e = [], n = t; n.parent;) e.unshift(n), n = n.parent; return e }

            function o(t) {
                d3.select(f + " .sequences-sunburst__label").text(""), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".1.3em").text(t.value), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".2em").text(t.name), 1 !== t.depth && t.name !== t.parent.name && d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".1.3em").text("[ " + t.parent.name + " ]"), d3.select(f + " .sequences-sunburst__explanation").style("visibility", "");
                var e = r(t);
                d3.selectAll(f + " path").style("opacity", .3), p.selectAll("path").filter(function(t) { return e.indexOf(t) >= 0 }).style("opacity", 1)
            }

            function a() { d3.select(f + " .sequences-sunburst__label").text(""), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".1.3em").text(t("" + f).data("count")), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".2em").text(window.i18n.graph.vessels), d3.selectAll(f + " path").on("mouseover", null), d3.selectAll(f + " path").transition().duration(1e3).style("opacity", 1).each("end", function() { d3.select(this).on("mouseover", o) }) }

            function s(e) {
                p.append("svg:circle").attr("r", d).style("opacity", 0);
                var n = g.nodes(e).filter(function(t) { return t.dx > .005 }),
                    r = p.data([e]).selectAll("path").data(n).enter().append("svg:path").attr("display", function(t) { return t.depth ? null : "none" }).attr("d", v).attr("fill-rule", "evenodd").style("fill", function(t) { return "default" === t.color ? i.default : i[t.color] }).style("opacity", 1).on("mouseover", o);
                d3.select("#container-" + h).on("mouseleave", a), d3.select(f + " .sequences-sunburst__label").text(""), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".1.3em").text(t("" + f).data("count")), d3.select(f + " .sequences-sunburst__label").append("text").attr("dy", ".2em").text(window.i18n.graph.vessels), d3.select(f + " .sequences-sunburst__explanation").style("visibility", "");
                r.node().__data__.value
            }
            var l = t(n).data("depth"),
                u = 300 + 12 * l,
                c = 300 + 12 * l,
                d = Math.min(u, c) / 2,
                h = t(n).data("sequences-sunburst"),
                f = "#sequences-sunburst__chart-" + h,
                p = d3.select(f).append("svg:svg").attr("width", u).attr("height", c).append("svg:g").attr("id", "container-" + h).attr("transform", "translate(" + u / 2 + "," + c / 2 + ")"),
                g = d3.layout.partition().size([2 * Math.PI, d * d]).value(function(t) { return t.size }),
                v = d3.svg.arc().startAngle(function(t) { return t.x }).endAngle(function(t) { return t.x + t.dx }).innerRadius(function(t) { return Math.sqrt(t.y) }).outerRadius(function(t) { return Math.sqrt(t.y + t.dy) }),
                m = JSON.parse(t("#sequences-sunburst__data-" + h).html());
            s(m)
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

          }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        n(315), t(document).ready(function() {
            var e = t(".hero-video__video");
            e.YTPlayer({
                fitToBackground: !0,
                videoId: e.data("video"),
                playerVars: { modestbranding: 0, autoplay: 1, showinfo: 0, wmode: "transparent", branding: 0, rel: 0, autohide: 1 },
                callback: function() {
                    var n = e.data("ytPlayer").player,
                        i = t(".hero-video__play"),
                        r = t(".hero-video__image"),
                        o = t(".hero-video__volume");
                    n.setPlaybackQuality("highres"), n.pauseVideo(), i.click(function() { n.playVideo(), i.addClass("hide"), r.addClass("hide") }), 1 === n.getPlayerState() ? (o.removeClass("eq--on"), o.addClass("eq--off"), n.mute()) : n.unMute(), o.on("click", function() { o.find(".eq").hasClass("eq--off") ? (o.find(".eq").removeClass("eq--off"), o.find(".eq").addClass("eq--on"), n.unMute()) : (o.find(".eq").removeClass("eq--on"), o.find(".eq").addClass("eq--off"), n.mute()) }), e.click(function() { 1 === n.getPlayerState() ? (n.pauseVideo(), o.find(".eq").hasClass("eq--on") && (o.find(".eq").removeClass("eq--on"), o.find(".eq").addClass("eq--off"))) : (r.addClass("hide"), n.playVideo(), o.find(".eq").hasClass("eq--off") && (o.find(".eq").removeClass("eq--off"), o.find(".eq").addClass("eq--on"))), i.toggleClass("hide") }), n.addEventListener("onStateChange", function(t) { 0 === t.data && (n.pauseVideo(), r.removeClass("hide"), i.toggleClass("hide")) })
                }
            })
        }), t(".hero").addClass("loaded")
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function n() { return window.innerWidth < 1025 || !1 } Object.defineProperty(e, "__esModule", { value: !0 }), e.default = n, t(window).on("resize", function() { n() })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }

        function i(e, n) {
            var i = new n.maps.LatLngBounds;
            if (t.each(e.markers, function(t, e) {
                    var r = new n.maps.LatLng(e.position.lat(), e.position.lng());
                    i.extend(r)
                }), 1 === e.markers.length) e.setCenter(i.getCenter());
            else {
                var r = n.maps.event.addListener(e, "zoom_changed", function() { n.maps.event.removeListener(r), e.setZoom(12) });
                e.fitBounds(i)
            }
        }
        var r = n(309),
            o = e(r),
            a = document.getElementById("map");
        "undefined" != typeof a && null !== a && (o.default.KEY = window.variables.mapApiKey, o.default.load(function(e) {
            var r = new e.maps.Map(a, { zoom: 12, mapTypeId: e.maps.MapTypeId.ROADMAP, streetViewControl: !1, mapTypeControl: !1, zoomControl: !0, draggable: !0, zoomControlOptions: { position: e.maps.ControlPosition.RIGHT_BOTTOM }, scrollwheel: !1, styles: n(145) });
            r.markers = [];
            var o = t(".map__item");
            o.length && (o.each(function(n, i) {
                var o = { map: r, position: new e.maps.LatLng(t(i).data("lat"), t(i).data("lng")), visible: !0, icon: SKIN + "img/assets/pin.png" },
                    a = new e.maps.Marker(o);
                r.markers.push(a)
            }), i(r, e)), e.maps.event.addDomListener(window, "resize", function() { var t = window.setTimeout(function() { i(r, e), window.clearTimeout(t) }, 100) })
        }))
    }).call(e, n(2))
}, function(t, e) {
    "use strict";
    t.exports = [{ featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 100 }, { color: "#7b94be" }, { lightness: 50 }] }, { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] }, { featureType: "administrative", elementType: "all", stylers: [{ visibility: "simplified" }] }, { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000045" }, { lightness: 20 }] }, { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000045" }, { lightness: 17 }, { weight: 1.2 }] }, { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#0f72da" }, { lightness: 20 }, { visibility: "on" }] }, { featureType: "landscape", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "landscape", elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] }, { featureType: "poi", elementType: "all", stylers: [{ visibility: "simplified" }] }, { featureType: "poi", elementType: "geometry", stylers: [{ color: "#0d62bb" }, { lightness: 21 }, { visibility: "off" }] }, { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "simplified" }] }, { featureType: "poi", elementType: "geometry.stroke", stylers: [{ visibility: "simplified" }] }, { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] }, { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] }, { featureType: "poi", elementType: "labels.icon", stylers: [{ visibility: "off" }] }, { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#539fff" }, { lightness: 17 }] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#ffffff" }] }, { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#000045" }, { lightness: 20 }] }, { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000045" }, { lightness: 25 }] }, { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ color: "#4995f7" }] }, { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#ffffff" }] }, { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#2f86ed" }, { lightness: 25 }] }, { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#f3f3f3" }] }, { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000045" }, { lightness: 19 }, { visibility: "on" }] }, { featureType: "transit.line", elementType: "all", stylers: [{ visibility: "simplified" }] }, { featureType: "transit.line", elementType: "geometry", stylers: [{ visibility: "on" }, { color: "#ffffff" }] }, { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#b7daff" }, { visibility: "simplified" }] }, { featureType: "transit.line", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] }, { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#4ca1fa" }] }, { featureType: "water", elementType: "geometry", stylers: [{ color: "#2181e7" }, { lightness: 17 }] }]
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".menu--footer .menu__item--has-children");
        e.on("click", function(n) {
            var i = t(n.currentTarget);
            window.innerWidth < 769 && (i.hasClass("open") ? (i.removeClass("open"), i.children(".menu__list--submenu").slideUp(300)) : (e.removeClass("open"), t(".menu--footer .menu__list--submenu").slideUp(300), i.addClass("open"), i.children(".menu__list--submenu").slideDown(300)))
        }), t(window).on("resize", function() { window.innerWidth > 768 && t(".menu--footer .menu__list--submenu").css("display", "") })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".menu--login"),
            n = e.find(".menu__item--has-children");
        n.on("click", function(e) {
            if (window.innerWidth < 1025) {
                var n = t(e.currentTarget);
                n.hasClass("triggered") ? (n.removeClass("triggered"), n.find("ul").slideUp(400)) : (n.addClass("triggered"), n.find("ul").slideDown(400))
            }
        }), t(window).on("resize", function() { window.innerWidth > 1024 && (n.removeClass("triggered"), n.find("ul").slideUp(0), n.find("ul").css("display", "")) })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }

        function i(t) { t.niceScroll({ autohidemode: !1, cursorborder: "none", touchbehavior: !0, cursordragontouch: !0, horizrailenabled: !1, cursorcolor: "#666666", background: "#f3f3f1", railoffset: { top: 0, left: 0 }, zindex: 5e3 }), t.getNiceScroll().resize() }

        function r() {
            var e = document.querySelector(".menu--main");
            if (e) {
                var n = new h.default(e);
                n.on("panright", function() {
                    var e = t(".active-list");
                    e.length && (k.removeClass("submenu-triggered"), t(".active-list").css({ opacity: 0, transform: "translateX(100%)" }), (0, c.default)() || (_.getNiceScroll().remove(), i(S)), t(".active-list").addClass("overflow-hidden"), S.removeClass("overflow-hidden"), t(".menu--main").find(".menu__list--wrapper").removeClass("active-list"))
                })
            }
        }

        function o() { f.find(".menu__item").each(function(e, n) { t(n).hasClass("menu__item--current") && t(n).parents().hasClass("menu__list--wrapper") && (k.hasClass("submenu-triggered") || (k.addClass("submenu-triggered"), t(n).parents(".menu__list--wrapper").css({ opacity: 1, transform: "translateX(-100%)" }), t(n).parents(".menu__list--wrapper").addClass("active-list"), (0, c.default)() || (S.getNiceScroll().remove(), i(t(n).find(".menu__list--wrapper"))), S.addClass("overflow-hidden"), t(n).parents(".menu__list--wrapper").removeClass("overflow-hidden"), setTimeout(function() { t(window).resize() }, 50))) }) }

        function a() {
            g.each(function(e, n) {
                t(n).hover(function(e) {
                    var n = t(e.currentTarget);
                    n.find(".menu__list--wrapper").addClass("submenu-open")
                }, function(e) {
                    var n = t(e.currentTarget);
                    n.find(".menu__list--wrapper").removeClass("submenu-open")
                })
            }), f.find(".menu__item").each(function(e, n) { t(n).hasClass("menu__item--current") && (t(n).parent().hasClass("menu__list--submenu") && t(n).parent().addClass("current-item-in-list"), t(n).parents(".menu__list--level-0").addClass("current-item-exists")) })
        }

        function s(t) {// m = t.find(".menu--line"), v = t.find(".menu__item--current"), v.parents("li").hasClass("menu__item--has-children") && (v = v.parents("li")), m.length && (0 === v.length ? m.css({ width: 0, left: t.find(".menu__list > .menu__item").eq(0).position().left + "px" }) : m.css({ width: v.find("a, span").width(), left: v.find("a, span").position().left + "px" })) 
    }

        function l(e) {
            e.find(".menu__list--level-0 > .menu__item").hover(function(n) {
                if (m = e.find(".menu--line")) {
                    var i = t(n.currentTarget);
                    m.css({ width: i.find("a, span").width(), left: i.find("a, span").position().left + "px" })
                }
            })
        }
        var u = n(30),
            c = e(u),
            d = n(89),
            h = e(d);
        n(91);
        var f = t(".menu--main"),
            p = t(".menu--secondary"),
            g = t(".menu--main .menu__item--has-children"),
            v = void 0,
            m = void 0,
            y = t(".header__burger"),
            b = t(".header__burger-text"),
            x = b.text(),
            w = t(".header__inner"),
            k = t("body"),
            S = t(".menu--main .menu__list--level-0"),
            _ = t(".menu--main .menu__list--wrapper");
        r(),  window.innerWidth > 1024 ? (a(), s(f), s(p), l(f), l(p), setTimeout(function() { t(".menu--line").removeClass("loading") }, 50)) : o(), t(document).mouseover(function(e) {
            if (window.innerWidth > 1024) {
                var n = t(".menu--main > .menu__list, .menu--main .menu__list--wrapper, .menu--secondary > .menu__list, .menu--line");
                n.is(e.target) || 0 !== n.has(e.target).length || (s(f), s(p))
            }
        }), t(window).resize(function() { window.innerWidth > 1024 ? (a(), s(f), s(p), l(f), l(p), f.find("ul").attr("style", ""), w.attr("style", ""), t(".header__holder").attr("style", ""), (0, c.default)() || (S.getNiceScroll().remove(), _.getNiceScroll().remove()), _.removeClass("overflow-hidden"), S.removeClass("overflow-hidden"), k.removeClass("submenu-triggered"), k.removeClass("menu-open"), k.removeClass("site__no-scroll"), t(".menu--main .menu__list--wrapper").removeClass("active-list"), t(".menu--main .menu__list--wrapper").attr("style", "")) : k.removeClass("menu-secondary--visible") }), y.on("click", function() { k.hasClass("menu-open") ? (k.removeClass("menu-open"), k.removeClass("site__no-scroll"), b.text(x), (0, c.default)() || (S.getNiceScroll().remove(), _.getNiceScroll().remove())) : (k.addClass("menu-open"), k.addClass("site__no-scroll"), b.text(b.data("close")), (0, c.default)() || i(k.hasClass("submenu-triggered") ? t(".menu--main .menu__item--current").parents(".menu__list--wrapper") : S)) }), t(".menu--main .menu__item--has-children > a").on("click", function(t) { t.preventDefault() }), t(".header").delegate(".menu--main .menu__item--has-children", "click", function(e) {
            if (window.innerWidth < 1025) {
                e.stopPropagation();
                var n = t(e.currentTarget);
                k.addClass("submenu-triggered"), n.find(".menu__list--wrapper").css({ opacity: 1, transform: "translateX(-100%)" }), n.find(".menu__list--wrapper").addClass("active-list"), (0, c.default)() || (S.getNiceScroll().remove(), i(n.find(".menu__list--wrapper"))), S.addClass("overflow-hidden"), _.removeClass("overflow-hidden"), setTimeout(function() { t(window).resize() }, 50)
            }
        }), t(".header__inner").on("click", function(e) {
            if (window.innerWidth < 1025 && k.hasClass("submenu-triggered")) {
                var n = t(".menu--main .menu__list--wrapper, .menu--login");
                n.is(e.target) || 0 !== n.has(e.target).length || (e.stopPropagation(), k.removeClass("submenu-triggered"), t(".active-list").css({ opacity: 0, transform: "translateX(100%)" }), (0, c.default)() || (_.getNiceScroll().remove(), i(S)), t(".active-list").addClass("overflow-hidden"), S.removeClass("overflow-hidden"), t(".menu--main .menu__list--wrapper").removeClass("active-list"))
            }
        });
        var T = 0;
        t(window).on("scroll", function(e) {
            if (window.innerWidth > 1024 && p.length) {
                var n = t(e.currentTarget),
                    i = n.scrollTop();
                k.hasClass("scrolled") || k.hasClass("no-hero") ? i > T ? k.hasClass("menu-secondary--visible") || k.addClass("menu-secondary--visible") : i < T && k.hasClass("menu-secondary--visible") && k.removeClass("menu-secondary--visible") : k.hasClass("scrolled") || k.hasClass("menu-secondary--visible") && k.removeClass("menu-secondary--visible"), T = i
            }
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".preloader");
        t(window).on("load", function() {  e.addClass("pre-hide") }), 
        e.length && setTimeout(function() { e.removeClass("loaded") }, 100)
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t(".promises__item"),
            n = t(".promises__content");
        t(".promises__title").on("click", function(i) {
            var r = t(i.currentTarget);
            r.parent().hasClass("open") ? (r.parent().removeClass("open"), r.parent().find(".promises__content").slideUp(300)) : (e.removeClass("open"), n.slideUp(300), r.parent().addClass("open"), r.parent().find(".promises__content").slideDown(300))
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        var e = t("[data-read-more]");
        e.on("click", function(e) {
            e.preventDefault();
            var n = t(e.currentTarget);
            n.parent().hasClass("read-more--triggered") ? (n.parent().removeClass("read-more--triggered"), n.parents(".text").find("[data-extra-content]").slideUp(400), n.html(window.i18n.read.more)) : (n.parent().addClass("read-more--triggered"), n.parents(".text").find("[data-extra-content]").slideDown(400), n.html(window.i18n.read.less))
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }

        function i(t) { l = !1, "down" === t ? (d.addClass("scrolled"), c.length && d.removeClass("fixed-banner--visible"), setTimeout(function() { l = !0, (0, o.default)(), (0, s.default)() }, 1e3)) : (d.removeClass("scrolled"), c.length && d.addClass("fixed-banner--visible")) } n(296);
        var r = n(57),
            o = e(r),
            a = n(93),
            s = e(a),
            l = !1,
            u = t(window).scrollTop(),
            c = t(".fixed-banner"),
            d = t("body");
        if (t(window).on("mousewheel", function(e) { t(".hero").length && window.innerWidth > 768 && (t(".site__main-body").css("transition", ""), 0 === u && (l || e.preventDefault(), e.deltaY === -1 && i("down"), 1 === e.deltaY && i("up")), u = t(window).scrollTop()) }), t(".hero").length)
            if (window.innerWidth > 768) {
                var h = t(window).innerHeight();
                t(".site__main-body").css({ transform: "translateY(" + h + "px) translateZ(0)", transition: "none" }), t(window).scrollTop() > 0 && (d.hasClass("scrolled") || (t(".site__main-body").css("transition", "none"), d.addClass("scrolled"), c.length && d.removeClass("fixed-banner--visible")))
            } else t(".site__main-body").css("transform", "");
        else d.addClass("no-hero");
        t(window).on("resize", function() {
            if (t(".hero").length)
                if (window.innerWidth > 768) {
                    var e = t(window).innerHeight();
                    t(".site__main-body").css("transform", "translateY(" + e + "px) translateZ(0)"), t(window).scrollTop() > window.innerHeight && (d.hasClass("scrolled") || (t(".site__main-body").css("transition", "none"), d.addClass("scrolled"), c.length && d.removeClass("fixed-banner--visible")))
                } else t(".site__main-body").css("transform", "")
        }), t("[data-scroll]").on("click", function() {
			$('body,html').animate({scrollTop:$(window).innerHeight()}, '1000');
            window.innerWidth > 768 && (t(".site__main-body").css("transition", ""), d.addClass("scrolled"), c.length && d.removeClass("fixed-banner--visible"), setTimeout(function() {
                (0, o.default)(), (0, s.default)()
            }, 1e3))
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }
        var i = n(30),
            r = e(i);
        n(91);
        var o = t("[data-scrollbar]");
        t(document).ready(function() {
            o.length && (o.each(function(e, n) {
                (0, r.default)() || (t(n).niceScroll({ autohidemode: !1, cursorborder: "none", touchbehavior: !0, cursordragontouch: !0, horizrailenabled: !1, cursorcolor: "#666666", background: "#f3f3f1", railoffset: { top: 0, left: -10 }, zindex: 5 }), t(n).getNiceScroll().resize())
            }), setTimeout(function() { t(window).resize() }, 100))
        }), t(window).on("resize", function() {
            (0, r.default)() && o.getNiceScroll().remove()
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        n(303), t("[data-select]").each(function(e, n) { t(n).select2({ width: "100%", minimumResultsForSearch: "Infinity" }) })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(t) { return t && t.__esModule ? t : { "default": t } }

        function i() { return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth }

        function r(t) { if (t.hammerTime !== !1) { var e = i(); return e > d ? t.hammerTime.get("swipe").set({ direction: u.default.DIRECTION_ALL }) : t.hammerTime.get("swipe").set({ direction: u.default.DIRECTION_HORIZONTAL }), e } }

        function o() {
            h = (0, s.default)(c, p), h.ready = function() {
                function e(e) { e >= i ? t("body").addClass("seq-init-touch") : t("body").removeClass("seq-init-touch") }

                function n(e) {
                    if (f) {
                        var n = h.currentStepId,
                            r = e.wheelDelta || -e.detail,
                            s = (new Date).getTime();
                        if (o < d) return;
                        if (s - a < g.quietPeriod + g.animationTime) return void e.preventDefault();
                        if (n === i && r < 0) return;
                        if (n === i && r > 0 && 0 !== t(window).scrollTop()) return;
                        e.preventDefault(), r < 0 ? h.next() : h.prev(), a = s
                    }
                }
                t("html, body").animate({ scrollTop: 0 }, 800);
                var i = h.noOfSteps,
                    o = void 0,
                    a = 0;
                o = r(h), h.throttledResize = function() { o = r(h) }, h.utils.addEvent(document, "mousewheel", n), h.utils.addEvent(document, "DOMMouseScroll", n), h.nextPhaseEnded = function(t) { e(t) }
            }
        }
        var a = n(313),
            s = e(a),
            l = n(89),
            u = e(l),
            c = document.getElementById("sequence"),
            d = 768,
            h = void 0,
            f = !1,
            p = { animateCanvas: !0, phaseThreshold: !1, preloader: !0, fadeStepWhenSkipped: !1, cycle: !1, swipeEvents: { left: function(t) { t.next() }, right: function(t) { t.prev() }, up: function(t) { t.next() }, down: function(t) { t.prev() } }, fallback: { speed: 300 } },
            g = { quietPeriod: 1e3, animationTime: 300 };
        "undefined" != typeof c && null !== c && (window.innerWidth > d && (o(), f = !0), t(window).on("resize", function() { window.innerWidth <= d ? f && (h.destroy(), h.utils.removeEvent(document, "mousewheel", scroll), h.utils.removeEvent(document, "DOMMouseScroll", scroll), f = !1) : f || (o(), f = !0) })), t(window).scroll(function() { 0 === t(window).scrollTop() && t("body").removeClass("seq-init-touch") })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
      }).call(e, n(2))
}, function(t, e, n) {
    "use strict";

    function i(t) { return t && t.__esModule ? t : { "default": t } }
    var r = n(122),
        o = i(r);
    (0, o.default)()
}, function(t, e, n) {
    (function(t) {
           }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";

        function e(e) {
            var n = t(".stories__results"),
                i = t(".stories__pagination"),
                r = t(".stories__status");
            r.html('<div class="loader">\n                <div class="loader__wrapper">\n\t\t\t\t\t<img src="' + SKIN + 'img/assets/loader2.gif" />\n                    <span>' + window.i18n.loader.loading + "...</span>\n                </div>\n            </div>"), n.empty(), i.empty(), t.ajax({ url:  URL + 'ajax/', data: { action: "load_stories", params: e }, type: "post", dataType: "json", success: function(t) { "success" === t.status && (n.html(t.response.stories), i.html(t.response.pagination.html)) }, error: function() {}, complete: function(t) { "success" === t.status ? r.html("") : (r.html(""), r.append(t.responseJSON.response)) } })
        }

        function n(n) {
            var i = t("#stories__select").val(),
                r = t(".stories__pagination .pagination"),
                o = "undefined" == typeof n ? r.length ? r.data("currentPage") : 1 : n,
                a = { pageno: Math.max(1, o), data: i, posts_per_page: t(".stories__results").data("posts") };
            e(a)
        }
        t("#stories__select").change(function() { n(1) }), t(".stories").delegate(".pagination__item a", "click", function(e) {
            e.preventDefault();
            var i = t(e.currentTarget).parent("li").data("pageno");
            n(i), t("html, body").animate({ scrollTop: t(".stories__container").offset().top - t(".header").innerHeight() }, 0)
        })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        t(".fixed-banner .join__cta").on("click", function() { try { window.gtag("event", "Clicked Top Notification Careers Button", { event_category: "Buttons", event_label: window.location.href }) } catch (t) {} }), t(".join-banner .join__cta").on("click", function() { try { window.gtag("event", "Clicked Inpage Careers Button", { event_category: "Buttons", event_label: window.location.href }) } catch (t) {} }), t(".info-block__cta[data-track]").on("click", function() { try { window.gtag("event", "Clicked Apply Here Bottom Button", { event_category: "Buttons", event_label: window.location.href }) } catch (t) {} }), t(".seafarers-login").on("click", function() { try { window.gtag("event", "Clicked Seafarers Login", { event_category: "Links", event_label: window.location.href }) } catch (t) {} }), t(".agents-login").on("click", function() { try { window.gtag("event", "Clicked Agents Login", { event_category: "Links", event_label: window.location.href }) } catch (t) {} })
    }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
         }).call(e, n(2))
}, function(t, e, n) {
    (function(t) {
        "use strict";
        n(311);
        var e = t("[data-video]");
        e.length > 0 && e.each(function(e, n) { t(n).magnificPopup({ delegate: "a", type: "iframe", iframe: { patterns: { youtube: { index: "youtube.com/", id: "v=", src: "//www.youtube.com/embed/%id%?rel=0&autoplay=1" } } } }) })
    }).call(e, n(2))
}, function(t, e, n) {
    "use strict";

    function i() { d = window.innerWidth, f = d / 2, u.width = d, u.height = h, g = Math.floor(d / 50), v = 0, m = .05, y = 0, b = .003, x = 0, w = .003, k = .66 * h, S = d + 10, _ = 40 }

    function r() { window.addEventListener("resize", i.bind(window)) }

    function o() {
        c.beginPath();
        for (var t = p.noise2D(x, 0) * _, e = 0; e <= g; e++) {
            v += m;
            var n = f - S / 2 + S / g * e,
                i = k + p.noise2D(v, y) * _ + t;
            c[0 === e ? "moveTo" : "lineTo"](n, i)
        }
        c.lineTo(d, h), c.lineTo(0, h), c.closePath(), c.fillStyle = "rgba(13, 33, 55, 0.8)", c.fill()
    }

    function a() { requestAnimationFrame(a), c.clearRect(0, 0, d, h), v = 0, o(), o(), o(), y += b, x += w }

    function s() { c = u.getContext("2d"), p = new l, r(), i(), a() }
    var l = n(314),
        u = void 0,
        c = void 0,
        d = void 0,
        h = 300,
        f = void 0,
        p = void 0,
        g = void 0,
        v = void 0,
        m = void 0,
        y = void 0,
        b = void 0,
        x = void 0,
        w = void 0,
        k = void 0,
        S = void 0,
        _ = void 0;
    u = document.querySelector("#waves"), u && s()
}, , , function(t, e, n) { t.exports = { "default": n(171), __esModule: !0 } }, , , function(t, e, n) {
    var i, i;
    ! function(e) { t.exports = e() }(function() {
        return function() {
            function t(e, n, r) {
                function o(s, l) {
                    if (!n[s]) {
                        if (!e[s]) { var u = "function" == typeof i && i; if (!l && u) return i(s, !0); if (a) return a(s, !0); var c = new Error("Cannot find module '" + s + "'"); throw c.code = "MODULE_NOT_FOUND", c }
                        var d = n[s] = { exports: {} };
                        e[s][0].call(d.exports, function(t) { var n = e[s][1][t]; return o(n ? n : t) }, d, d.exports, t, e, n, r)
                    }
                    return n[s].exports
                }
                for (var a = "function" == typeof i && i, s = 0; s < r.length; s++) o(r[s]);
                return o
            }
            return t
        }()({
            1: [function(t, e, n) {}, {}],
            2: [function(t, e, n) {
                function i(t) {
                    if (t) {
                        var e = /^#([a-fA-F0-9]{3})$/i,
                            n = /^#([a-fA-F0-9]{6})$/i,
                            i = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                            r = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                            o = /(\w+)/,
                            a = [0, 0, 0],
                            s = 1,
                            l = t.match(e);
                        if (l) { l = l[1]; for (var u = 0; u < a.length; u++) a[u] = parseInt(l[u] + l[u], 16) } else if (l = t.match(n)) { l = l[1]; for (var u = 0; u < a.length; u++) a[u] = parseInt(l.slice(2 * u, 2 * u + 2), 16) } else if (l = t.match(i)) {
                            for (var u = 0; u < a.length; u++) a[u] = parseInt(l[u + 1]);
                            s = parseFloat(l[4])
                        } else if (l = t.match(r)) {
                            for (var u = 0; u < a.length; u++) a[u] = Math.round(2.55 * parseFloat(l[u + 1]));
                            s = parseFloat(l[4])
                        } else if (l = t.match(o)) { if ("transparent" == l[1]) return [0, 0, 0, 0]; if (a = x[l[1]], !a) return }
                        for (var u = 0; u < a.length; u++) a[u] = y(a[u], 0, 255);
                        return s = s || 0 == s ? y(s, 0, 1) : 1, a[3] = s, a
                    }
                }

                function r(t) {
                    if (t) {
                        var e = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                            n = t.match(e);
                        if (n) {
                            var i = parseFloat(n[4]),
                                r = y(parseInt(n[1]), 0, 360),
                                o = y(parseFloat(n[2]), 0, 100),
                                a = y(parseFloat(n[3]), 0, 100),
                                s = y(isNaN(i) ? 1 : i, 0, 1);
                            return [r, o, a, s]
                        }
                    }
                }

                function o(t) {
                    if (t) {
                        var e = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                            n = t.match(e);
                        if (n) {
                            var i = parseFloat(n[4]),
                                r = y(parseInt(n[1]), 0, 360),
                                o = y(parseFloat(n[2]), 0, 100),
                                a = y(parseFloat(n[3]), 0, 100),
                                s = y(isNaN(i) ? 1 : i, 0, 1);
                            return [r, o, a, s]
                        }
                    }
                }

                function a(t) { var e = i(t); return e && e.slice(0, 3) }

                function s(t) { var e = r(t); return e && e.slice(0, 3) }

                function l(t) { var e = i(t); return e ? e[3] : (e = r(t)) ? e[3] : (e = o(t)) ? e[3] : void 0 }

                function u(t) { return "#" + b(t[0]) + b(t[1]) + b(t[2]) }

                function c(t, e) { return e < 1 || t[3] && t[3] < 1 ? d(t, e) : "rgb(" + t[0] + ", " + t[1] + ", " + t[2] + ")" }

                function d(t, e) { return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "rgba(" + t[0] + ", " + t[1] + ", " + t[2] + ", " + e + ")" }

                function h(t, e) {
                    if (e < 1 || t[3] && t[3] < 1) return f(t, e);
                    var n = Math.round(t[0] / 255 * 100),
                        i = Math.round(t[1] / 255 * 100),
                        r = Math.round(t[2] / 255 * 100);
                    return "rgb(" + n + "%, " + i + "%, " + r + "%)"
                }

                function f(t, e) {
                    var n = Math.round(t[0] / 255 * 100),
                        i = Math.round(t[1] / 255 * 100),
                        r = Math.round(t[2] / 255 * 100);
                    return "rgba(" + n + "%, " + i + "%, " + r + "%, " + (e || t[3] || 1) + ")"
                }

                function p(t, e) { return e < 1 || t[3] && t[3] < 1 ? g(t, e) : "hsl(" + t[0] + ", " + t[1] + "%, " + t[2] + "%)" }

                function g(t, e) { return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "hsla(" + t[0] + ", " + t[1] + "%, " + t[2] + "%, " + e + ")" }

                function v(t, e) { return void 0 === e && (e = void 0 !== t[3] ? t[3] : 1), "hwb(" + t[0] + ", " + t[1] + "%, " + t[2] + "%" + (void 0 !== e && 1 !== e ? ", " + e : "") + ")" }

                function m(t) { return w[t.slice(0, 3)] }

                function y(t, e, n) { return Math.min(Math.max(e, t), n) }

                function b(t) { var e = t.toString(16).toUpperCase(); return e.length < 2 ? "0" + e : e }
                var x = t(6);
                e.exports = { getRgba: i, getHsla: r, getRgb: a, getHsl: s, getHwb: o, getAlpha: l, hexString: u, rgbString: c, rgbaString: d, percentString: h, percentaString: f, hslString: p, hslaString: g, hwbString: v, keyword: m };
                var w = {};
                for (var k in x) w[x[k]] = k
            }, { 6: 6 }],
            3: [function(t, e, n) {
                var i = t(5),
                    r = t(2),
                    o = function(t) {
                        if (t instanceof o) return t;
                        if (!(this instanceof o)) return new o(t);
                        this.valid = !1, this.values = { rgb: [0, 0, 0], hsl: [0, 0, 0], hsv: [0, 0, 0], hwb: [0, 0, 0], cmyk: [0, 0, 0, 0], alpha: 1 };
                        var e;
                        "string" == typeof t ? (e = r.getRgba(t), e ? this.setValues("rgb", e) : (e = r.getHsla(t)) ? this.setValues("hsl", e) : (e = r.getHwb(t)) && this.setValues("hwb", e)) : "object" == typeof t && (e = t, void 0 !== e.r || void 0 !== e.red ? this.setValues("rgb", e) : void 0 !== e.l || void 0 !== e.lightness ? this.setValues("hsl", e) : void 0 !== e.v || void 0 !== e.value ? this.setValues("hsv", e) : void 0 !== e.w || void 0 !== e.whiteness ? this.setValues("hwb", e) : void 0 === e.c && void 0 === e.cyan || this.setValues("cmyk", e))
                    };
                o.prototype = {
                    isValid: function() { return this.valid },
                    rgb: function() { return this.setSpace("rgb", arguments) },
                    hsl: function() { return this.setSpace("hsl", arguments) },
                    hsv: function() { return this.setSpace("hsv", arguments) },
                    hwb: function() { return this.setSpace("hwb", arguments) },
                    cmyk: function() { return this.setSpace("cmyk", arguments) },
                    rgbArray: function() { return this.values.rgb },
                    hslArray: function() { return this.values.hsl },
                    hsvArray: function() { return this.values.hsv },
                    hwbArray: function() { var t = this.values; return 1 !== t.alpha ? t.hwb.concat([t.alpha]) : t.hwb },
                    cmykArray: function() { return this.values.cmyk },
                    rgbaArray: function() { var t = this.values; return t.rgb.concat([t.alpha]) },
                    hslaArray: function() { var t = this.values; return t.hsl.concat([t.alpha]) },
                    alpha: function(t) { return void 0 === t ? this.values.alpha : (this.setValues("alpha", t), this) },
                    red: function(t) { return this.setChannel("rgb", 0, t) },
                    green: function(t) { return this.setChannel("rgb", 1, t) },
                    blue: function(t) { return this.setChannel("rgb", 2, t) },
                    hue: function(t) { return t && (t %= 360, t = t < 0 ? 360 + t : t), this.setChannel("hsl", 0, t) },
                    saturation: function(t) { return this.setChannel("hsl", 1, t) },
                    lightness: function(t) { return this.setChannel("hsl", 2, t) },
                    saturationv: function(t) { return this.setChannel("hsv", 1, t) },
                    whiteness: function(t) { return this.setChannel("hwb", 1, t) },
                    blackness: function(t) { return this.setChannel("hwb", 2, t) },
                    value: function(t) { return this.setChannel("hsv", 2, t) },
                    cyan: function(t) { return this.setChannel("cmyk", 0, t) },
                    magenta: function(t) { return this.setChannel("cmyk", 1, t) },
                    yellow: function(t) { return this.setChannel("cmyk", 2, t) },
                    black: function(t) { return this.setChannel("cmyk", 3, t) },
                    hexString: function() { return r.hexString(this.values.rgb) },
                    rgbString: function() { return r.rgbString(this.values.rgb, this.values.alpha) },
                    rgbaString: function() { return r.rgbaString(this.values.rgb, this.values.alpha) },
                    percentString: function() { return r.percentString(this.values.rgb, this.values.alpha) },
                    hslString: function() { return r.hslString(this.values.hsl, this.values.alpha) },
                    hslaString: function() { return r.hslaString(this.values.hsl, this.values.alpha) },
                    hwbString: function() { return r.hwbString(this.values.hwb, this.values.alpha) },
                    keyword: function() { return r.keyword(this.values.rgb, this.values.alpha) },
                    rgbNumber: function() { var t = this.values.rgb; return t[0] << 16 | t[1] << 8 | t[2] },
                    luminosity: function() {
                        for (var t = this.values.rgb, e = [], n = 0; n < t.length; n++) {
                            var i = t[n] / 255;
                            e[n] = i <= .03928 ? i / 12.92 : Math.pow((i + .055) / 1.055, 2.4)
                        }
                        return .2126 * e[0] + .7152 * e[1] + .0722 * e[2]
                    },
                    contrast: function(t) {
                        var e = this.luminosity(),
                            n = t.luminosity();
                        return e > n ? (e + .05) / (n + .05) : (n + .05) / (e + .05)
                    },
                    level: function(t) { var e = this.contrast(t); return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "" },
                    dark: function() {
                        var t = this.values.rgb,
                            e = (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3;
                        return e < 128
                    },
                    light: function() { return !this.dark() },
                    negate: function() { for (var t = [], e = 0; e < 3; e++) t[e] = 255 - this.values.rgb[e]; return this.setValues("rgb", t), this },
                    lighten: function(t) { var e = this.values.hsl; return e[2] += e[2] * t, this.setValues("hsl", e), this },
                    darken: function(t) { var e = this.values.hsl; return e[2] -= e[2] * t, this.setValues("hsl", e), this },
                    saturate: function(t) { var e = this.values.hsl; return e[1] += e[1] * t, this.setValues("hsl", e), this },
                    desaturate: function(t) { var e = this.values.hsl; return e[1] -= e[1] * t, this.setValues("hsl", e), this },
                    whiten: function(t) { var e = this.values.hwb; return e[1] += e[1] * t, this.setValues("hwb", e), this },
                    blacken: function(t) { var e = this.values.hwb; return e[2] += e[2] * t, this.setValues("hwb", e), this },
                    greyscale: function() {
                        var t = this.values.rgb,
                            e = .3 * t[0] + .59 * t[1] + .11 * t[2];
                        return this.setValues("rgb", [e, e, e]), this
                    },
                    clearer: function(t) { var e = this.values.alpha; return this.setValues("alpha", e - e * t), this },
                    opaquer: function(t) { var e = this.values.alpha; return this.setValues("alpha", e + e * t), this },
                    rotate: function(t) {
                        var e = this.values.hsl,
                            n = (e[0] + t) % 360;
                        return e[0] = n < 0 ? 360 + n : n, this.setValues("hsl", e), this
                    },
                    mix: function(t, e) {
                        var n = this,
                            i = t,
                            r = void 0 === e ? .5 : e,
                            o = 2 * r - 1,
                            a = n.alpha() - i.alpha(),
                            s = ((o * a === -1 ? o : (o + a) / (1 + o * a)) + 1) / 2,
                            l = 1 - s;
                        return this.rgb(s * n.red() + l * i.red(), s * n.green() + l * i.green(), s * n.blue() + l * i.blue()).alpha(n.alpha() * r + i.alpha() * (1 - r))
                    },
                    toJSON: function() { return this.rgb() },
                    clone: function() {
                        var t, e, n = new o,
                            i = this.values,
                            r = n.values;
                        for (var a in i) i.hasOwnProperty(a) && (t = i[a], e = {}.toString.call(t), "[object Array]" === e ? r[a] = t.slice(0) : "[object Number]" === e && (r[a] = t));
                        return n
                    }
                }, o.prototype.spaces = { rgb: ["red", "green", "blue"], hsl: ["hue", "saturation", "lightness"], hsv: ["hue", "saturation", "value"], hwb: ["hue", "whiteness", "blackness"], cmyk: ["cyan", "magenta", "yellow", "black"] }, o.prototype.maxes = { rgb: [255, 255, 255], hsl: [360, 100, 100], hsv: [360, 100, 100], hwb: [360, 100, 100], cmyk: [100, 100, 100, 100] }, o.prototype.getValues = function(t) { for (var e = this.values, n = {}, i = 0; i < t.length; i++) n[t.charAt(i)] = e[t][i]; return 1 !== e.alpha && (n.a = e.alpha), n }, o.prototype.setValues = function(t, e) {
                    var n, r = this.values,
                        o = this.spaces,
                        a = this.maxes,
                        s = 1;
                    if (this.valid = !0, "alpha" === t) s = e;
                    else if (e.length) r[t] = e.slice(0, t.length), s = e[t.length];
                    else if (void 0 !== e[t.charAt(0)]) {
                        for (n = 0; n < t.length; n++) r[t][n] = e[t.charAt(n)];
                        s = e.a
                    } else if (void 0 !== e[o[t][0]]) {
                        var l = o[t];
                        for (n = 0; n < t.length; n++) r[t][n] = e[l[n]];
                        s = e.alpha
                    }
                    if (r.alpha = Math.max(0, Math.min(1, void 0 === s ? r.alpha : s)), "alpha" === t) return !1;
                    var u;
                    for (n = 0; n < t.length; n++) u = Math.max(0, Math.min(a[t][n], r[t][n])), r[t][n] = Math.round(u);
                    for (var c in o) c !== t && (r[c] = i[t][c](r[t]));
                    return !0
                }, o.prototype.setSpace = function(t, e) { var n = e[0]; return void 0 === n ? this.getValues(t) : ("number" == typeof n && (n = Array.prototype.slice.call(e)), this.setValues(t, n), this) }, o.prototype.setChannel = function(t, e, n) { var i = this.values[t]; return void 0 === n ? i[e] : n === i[e] ? this : (i[e] = n, this.setValues(t, i), this) }, "undefined" != typeof window && (window.Color = o), e.exports = o
            }, { 2: 2, 5: 5 }],
            4: [function(t, e, n) {
                function i(t) {
                    var e, n, i, r = t[0] / 255,
                        o = t[1] / 255,
                        a = t[2] / 255,
                        s = Math.min(r, o, a),
                        l = Math.max(r, o, a),
                        u = l - s;
                    return l == s ? e = 0 : r == l ? e = (o - a) / u : o == l ? e = 2 + (a - r) / u : a == l && (e = 4 + (r - o) / u), e = Math.min(60 * e, 360), e < 0 && (e += 360), i = (s + l) / 2, n = l == s ? 0 : i <= .5 ? u / (l + s) : u / (2 - l - s), [e, 100 * n, 100 * i]
                }

                function o(t) {
                    var e, n, i, r = t[0],
                        o = t[1],
                        a = t[2],
                        s = Math.min(r, o, a),
                        l = Math.max(r, o, a),
                        u = l - s;
                    return n = 0 == l ? 0 : u / l * 1e3 / 10, l == s ? e = 0 : r == l ? e = (o - a) / u : o == l ? e = 2 + (a - r) / u : a == l && (e = 4 + (r - o) / u), e = Math.min(60 * e, 360), e < 0 && (e += 360), i = l / 255 * 1e3 / 10, [e, n, i]
                }

                function a(t) {
                    var e = t[0],
                        n = t[1],
                        r = t[2],
                        o = i(t)[0],
                        a = 1 / 255 * Math.min(e, Math.min(n, r)),
                        r = 1 - 1 / 255 * Math.max(e, Math.max(n, r));
                    return [o, 100 * a, 100 * r]
                }

                function s(t) {
                    var e, n, i, r, o = t[0] / 255,
                        a = t[1] / 255,
                        s = t[2] / 255;
                    return r = Math.min(1 - o, 1 - a, 1 - s), e = (1 - o - r) / (1 - r) || 0, n = (1 - a - r) / (1 - r) || 0, i = (1 - s - r) / (1 - r) || 0, [100 * e, 100 * n, 100 * i, 100 * r]
                }

                function l(t) { return G[JSON.stringify(t)] }

                function u(t) {
                    var e = t[0] / 255,
                        n = t[1] / 255,
                        i = t[2] / 255;
                    e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92, n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92, i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92;
                    var r = .4124 * e + .3576 * n + .1805 * i,
                        o = .2126 * e + .7152 * n + .0722 * i,
                        a = .0193 * e + .1192 * n + .9505 * i;
                    return [100 * r, 100 * o, 100 * a]
                }

                function c(t) {
                    var e, n, i, r = u(t),
                        o = r[0],
                        a = r[1],
                        s = r[2];
                    return o /= 95.047, a /= 100, s /= 108.883, o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116, a = a > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, s = s > .008856 ? Math.pow(s, 1 / 3) : 7.787 * s + 16 / 116, e = 116 * a - 16, n = 500 * (o - a), i = 200 * (a - s), [e, n, i]
                }

                function d(t) { return R(c(t)) }

                function h(t) {
                    var e, n, i, r, o, a = t[0] / 360,
                        s = t[1] / 100,
                        l = t[2] / 100;
                    if (0 == s) return o = 255 * l, [o, o, o];
                    n = l < .5 ? l * (1 + s) : l + s - l * s, e = 2 * l - n, r = [0, 0, 0];
                    for (var u = 0; u < 3; u++) i = a + 1 / 3 * -(u - 1), i < 0 && i++, i > 1 && i--, o = 6 * i < 1 ? e + 6 * (n - e) * i : 2 * i < 1 ? n : 3 * i < 2 ? e + (n - e) * (2 / 3 - i) * 6 : e, r[u] = 255 * o;
                    return r
                }

                function f(t) {
                    var e, n, i = t[0],
                        r = t[1] / 100,
                        o = t[2] / 100;
                    return 0 === o ? [0, 0, 0] : (o *= 2, r *= o <= 1 ? o : 2 - o, n = (o + r) / 2, e = 2 * r / (o + r), [i, 100 * e, 100 * n])
                }

                function p(t) { return a(h(t)) }

                function v(t) { return s(h(t)) }

                function m(t) { return l(h(t)) }

                function y(t) {
                    var e = t[0] / 60,
                        n = t[1] / 100,
                        i = t[2] / 100,
                        r = Math.floor(e) % 6,
                        o = e - Math.floor(e),
                        a = 255 * i * (1 - n),
                        s = 255 * i * (1 - n * o),
                        l = 255 * i * (1 - n * (1 - o)),
                        i = 255 * i;
                    switch (r) {
                        case 0:
                            return [i, l, a];
                        case 1:
                            return [s, i, a];
                        case 2:
                            return [a, i, l];
                        case 3:
                            return [a, s, i];
                        case 4:
                            return [l, a, i];
                        case 5:
                            return [i, a, s]
                    }
                }

                function x(t) {
                    var e, n, i = t[0],
                        r = t[1] / 100,
                        o = t[2] / 100;
                    return n = (2 - r) * o, e = r * o, e /= n <= 1 ? n : 2 - n, e = e || 0, n /= 2, [i, 100 * e, 100 * n]
                }

                function w(t) { return a(y(t)) }

                function k(t) { return s(y(t)) }

                function S(t) { return l(y(t)) }

                function _(t) {
                    var e, n, i, o, a = t[0] / 360,
                        s = t[1] / 100,
                        l = t[2] / 100,
                        u = s + l;
                    switch (u > 1 && (s /= u, l /= u), e = Math.floor(6 * a), n = 1 - l, i = 6 * a - e, 0 != (1 & e) && (i = 1 - i), o = s + i * (n - s), e) {
                        default:
                        case 6:
                        case 0:
                            r = n, g = o, b = s;
                            break;
                        case 1:
                            r = o, g = n, b = s;
                            break;
                        case 2:
                            r = s, g = n, b = o;
                            break;
                        case 3:
                            r = s, g = o, b = n;
                            break;
                        case 4:
                            r = o, g = s, b = n;
                            break;
                        case 5:
                            r = n, g = s, b = o
                    }
                    return [255 * r, 255 * g, 255 * b]
                }

                function T(t) { return i(_(t)) }

                function C(t) { return o(_(t)) }

                function M(t) { return s(_(t)) }

                function A(t) { return l(_(t)) }

                function E(t) {
                    var e, n, i, r = t[0] / 100,
                        o = t[1] / 100,
                        a = t[2] / 100,
                        s = t[3] / 100;
                    return e = 1 - Math.min(1, r * (1 - s) + s), n = 1 - Math.min(1, o * (1 - s) + s), i = 1 - Math.min(1, a * (1 - s) + s), [255 * e, 255 * n, 255 * i]
                }

                function P(t) { return i(E(t)) }

                function I(t) { return o(E(t)) }

                function z(t) { return a(E(t)) }

                function D(t) { return l(E(t)) }

                function O(t) {
                    var e, n, i, r = t[0] / 100,
                        o = t[1] / 100,
                        a = t[2] / 100;
                    return e = 3.2406 * r + o * -1.5372 + a * -.4986, n = r * -.9689 + 1.8758 * o + .0415 * a, i = .0557 * r + o * -.204 + 1.057 * a, e = e > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : e = 12.92 * e, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : n = 12.92 * n, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : i = 12.92 * i, e = Math.min(Math.max(0, e), 1), n = Math.min(Math.max(0, n), 1), i = Math.min(Math.max(0, i), 1), [255 * e, 255 * n, 255 * i]
                }

                function L(t) {
                    var e, n, i, r = t[0],
                        o = t[1],
                        a = t[2];
                    return r /= 95.047, o /= 100, a /= 108.883, r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116, o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116, a = a > .008856 ? Math.pow(a, 1 / 3) : 7.787 * a + 16 / 116, e = 116 * o - 16, n = 500 * (r - o), i = 200 * (o - a), [e, n, i]
                }

                function $(t) { return R(L(t)) }

                function N(t) {
                    var e, n, i, r, o = t[0],
                        a = t[1],
                        s = t[2];
                    return o <= 8 ? (n = 100 * o / 903.3, r = 7.787 * (n / 100) + 16 / 116) : (n = 100 * Math.pow((o + 16) / 116, 3), r = Math.pow(n / 100, 1 / 3)), e = e / 95.047 <= .008856 ? e = 95.047 * (a / 500 + r - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + r, 3), i = i / 108.883 <= .008859 ? i = 108.883 * (r - s / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(r - s / 200, 3), [e, n, i]
                }

                function R(t) {
                    var e, n, i, r = t[0],
                        o = t[1],
                        a = t[2];
                    return e = Math.atan2(a, o), n = 360 * e / 2 / Math.PI, n < 0 && (n += 360), i = Math.sqrt(o * o + a * a), [r, i, n]
                }

                function q(t) { return O(N(t)) }

                function F(t) {
                    var e, n, i, r = t[0],
                        o = t[1],
                        a = t[2];
                    return i = a / 360 * 2 * Math.PI, e = o * Math.cos(i), n = o * Math.sin(i), [r, e, n]
                }

                function H(t) { return N(F(t)) }

                function B(t) { return q(F(t)) }

                function W(t) { return K[t] }

                function j(t) { return i(W(t)) }

                function Y(t) { return o(W(t)) }

                function U(t) { return a(W(t)) }

                function V(t) { return s(W(t)) }

                function X(t) { return c(W(t)) }

                function Z(t) { return u(W(t)) } e.exports = { rgb2hsl: i, rgb2hsv: o, rgb2hwb: a, rgb2cmyk: s, rgb2keyword: l, rgb2xyz: u, rgb2lab: c, rgb2lch: d, hsl2rgb: h, hsl2hsv: f, hsl2hwb: p, hsl2cmyk: v, hsl2keyword: m, hsv2rgb: y, hsv2hsl: x, hsv2hwb: w, hsv2cmyk: k, hsv2keyword: S, hwb2rgb: _, hwb2hsl: T, hwb2hsv: C, hwb2cmyk: M, hwb2keyword: A, cmyk2rgb: E, cmyk2hsl: P, cmyk2hsv: I, cmyk2hwb: z, cmyk2keyword: D, keyword2rgb: W, keyword2hsl: j, keyword2hsv: Y, keyword2hwb: U, keyword2cmyk: V, keyword2lab: X, keyword2xyz: Z, xyz2rgb: O, xyz2lab: L, xyz2lch: $, lab2xyz: N, lab2rgb: q, lab2lch: R, lch2lab: F, lch2xyz: H, lch2rgb: B };
                var K = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] },
                    G = {};
                for (var J in K) G[JSON.stringify(K[J])] = J
            }, {}],
            5: [function(t, e, n) {
                var i = t(4),
                    r = function() { return new u };
                for (var o in i) {
                    r[o + "Raw"] = function(t) { return function(e) { return "number" == typeof e && (e = Array.prototype.slice.call(arguments)), i[t](e) } }(o);
                    var a = /(\w+)2(\w+)/.exec(o),
                        s = a[1],
                        l = a[2];
                    r[s] = r[s] || {}, r[s][l] = r[o] = function(t) { return function(e) { "number" == typeof e && (e = Array.prototype.slice.call(arguments)); var n = i[t](e); if ("string" == typeof n || void 0 === n) return n; for (var r = 0; r < n.length; r++) n[r] = Math.round(n[r]); return n } }(o)
                }
                var u = function() { this.convs = {} };
                u.prototype.routeSpace = function(t, e) { var n = e[0]; return void 0 === n ? this.getValues(t) : ("number" == typeof n && (n = Array.prototype.slice.call(e)), this.setValues(t, n)) }, u.prototype.setValues = function(t, e) { return this.space = t, this.convs = {}, this.convs[t] = e, this }, u.prototype.getValues = function(t) {
                    var e = this.convs[t];
                    if (!e) {
                        var n = this.space,
                            i = this.convs[n];
                        e = r[n][t](i), this.convs[t] = e
                    }
                    return e
                }, ["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(t) { u.prototype[t] = function(e) { return this.routeSpace(t, arguments) } }), e.exports = r
            }, { 4: 4 }],
            6: [function(t, e, n) {
                "use strict";
                e.exports = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] }
            }, {}],
            7: [function(t, e, n) {
                var i = t(29)();
                i.helpers = t(45), t(27)(i), i.defaults = t(25), i.Element = t(26), i.elements = t(40), i.Interaction = t(28), i.layouts = t(30), i.platform = t(48), i.plugins = t(31), i.Ticks = t(34), t(22)(i), t(23)(i), t(24)(i), t(33)(i), t(32)(i), t(35)(i), t(55)(i), t(53)(i), t(54)(i), t(56)(i), t(57)(i), t(58)(i), t(15)(i), t(16)(i), t(17)(i), t(18)(i), t(19)(i), t(20)(i), t(21)(i), t(8)(i), t(9)(i), t(10)(i), t(11)(i), t(12)(i), t(13)(i), t(14)(i);
                var r = t(49);
                for (var o in r) r.hasOwnProperty(o) && i.plugins.register(r[o]);
                i.platform.initialize(), e.exports = i, "undefined" != typeof window && (window.Chart = i), i.Legend = r.legend._element, i.Title = r.title._element, i.pluginService = i.plugins, i.PluginBase = i.Element.extend({}), i.canvasHelpers = i.helpers.canvas, i.layoutService = i.layouts
            }, { 10: 10, 11: 11, 12: 12, 13: 13, 14: 14, 15: 15, 16: 16, 17: 17, 18: 18, 19: 19, 20: 20, 21: 21, 22: 22, 23: 23, 24: 24, 25: 25, 26: 26, 27: 27, 28: 28, 29: 29, 30: 30, 31: 31, 32: 32, 33: 33, 34: 34, 35: 35, 40: 40, 45: 45, 48: 48, 49: 49, 53: 53, 54: 54, 55: 55, 56: 56, 57: 57, 58: 58, 8: 8, 9: 9 }],
            8: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Bar = function(e, n) { return n.type = "bar", new t(e, n) } }
            }, {}],
            9: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Bubble = function(e, n) { return n.type = "bubble", new t(e, n) } }
            }, {}],
            10: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Doughnut = function(e, n) { return n.type = "doughnut", new t(e, n) } }
            }, {}],
            11: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Line = function(e, n) { return n.type = "line", new t(e, n) } }
            }, {}],
            12: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.PolarArea = function(e, n) { return n.type = "polarArea", new t(e, n) } }
            }, {}],
            13: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Radar = function(e, n) { return n.type = "radar", new t(e, n) } }
            }, {}],
            14: [function(t, e, n) {
                "use strict";
                e.exports = function(t) { t.Scatter = function(e, n) { return n.type = "scatter", new t(e, n) } }
            }, {}],
            15: [function(t, e, n) {
                "use strict";

                function i(t, e) {
                    var n, i, r, o, a = t.isHorizontal() ? t.width : t.height,
                        s = t.getTicks();
                    for (r = 1, o = e.length; r < o; ++r) a = Math.min(a, e[r] - e[r - 1]);
                    for (r = 0, o = s.length; r < o; ++r) i = t.getPixelForTick(r), a = r > 0 ? Math.min(a, i - n) : a, n = i;
                    return a
                }

                function r(t, e, n) {
                    var i, r, o = n.barThickness,
                        a = e.stackCount,
                        s = e.pixels[t];
                    return l.isNullOrUndef(o) ? (i = e.min * n.categoryPercentage, r = n.barPercentage) : (i = o * a, r = 1), { chunk: i / a, ratio: r, start: s - i / 2 }
                }

                function o(t, e, n) {
                    var i, r, o = e.pixels,
                        a = o[t],
                        s = t > 0 ? o[t - 1] : null,
                        l = t < o.length - 1 ? o[t + 1] : null,
                        u = n.categoryPercentage;
                    return null === s && (s = a - (null === l ? e.end - a : l - a)), null === l && (l = a + a - s), i = a - (a - s) / 2 * u, r = (l - s) / 2 * u, { chunk: r / e.stackCount, ratio: n.barPercentage, start: i }
                }
                var a = t(25),
                    s = t(40),
                    l = t(45);
                a._set("bar", { hover: { mode: "label" }, scales: { xAxes: [{ type: "category", categoryPercentage: .8, barPercentage: .9, offset: !0, gridLines: { offsetGridLines: !0 } }], yAxes: [{ type: "linear" }] } }), a._set("horizontalBar", { hover: { mode: "index", axis: "y" }, scales: { xAxes: [{ type: "linear", position: "bottom" }], yAxes: [{ position: "left", type: "category", categoryPercentage: .8, barPercentage: .9, offset: !0, gridLines: { offsetGridLines: !0 } }] }, elements: { rectangle: { borderSkipped: "left" } }, tooltips: { callbacks: { title: function(t, e) { var n = ""; return t.length > 0 && (t[0].yLabel ? n = t[0].yLabel : e.labels.length > 0 && t[0].index < e.labels.length && (n = e.labels[t[0].index])), n }, label: function(t, e) { var n = e.datasets[t.datasetIndex].label || ""; return n + ": " + t.xLabel } }, mode: "index", axis: "y" } }), e.exports = function(t) {
                    t.controllers.bar = t.DatasetController.extend({
                        dataElementType: s.Rectangle,
                        initialize: function() {
                            var e, n = this;
                            t.DatasetController.prototype.initialize.apply(n, arguments), e = n.getMeta(), e.stack = n.getDataset().stack, e.bar = !0
                        },
                        update: function(t) {
                            var e, n, i = this,
                                r = i.getMeta().data;
                            for (i._ruler = i.getRuler(), e = 0, n = r.length; e < n; ++e) i.updateElement(r[e], e, t)
                        },
                        updateElement: function(t, e, n) {
                            var i = this,
                                r = i.chart,
                                o = i.getMeta(),
                                a = i.getDataset(),
                                s = t.custom || {},
                                u = r.options.elements.rectangle;
                            t._xScale = i.getScaleForId(o.xAxisID), t._yScale = i.getScaleForId(o.yAxisID), t._datasetIndex = i.index, t._index = e, t._model = { datasetLabel: a.label, label: r.data.labels[e], borderSkipped: s.borderSkipped ? s.borderSkipped : u.borderSkipped, backgroundColor: s.backgroundColor ? s.backgroundColor : l.valueAtIndexOrDefault(a.backgroundColor, e, u.backgroundColor), borderColor: s.borderColor ? s.borderColor : l.valueAtIndexOrDefault(a.borderColor, e, u.borderColor), borderWidth: s.borderWidth ? s.borderWidth : l.valueAtIndexOrDefault(a.borderWidth, e, u.borderWidth) }, i.updateElementGeometry(t, e, n), t.pivot()
                        },
                        updateElementGeometry: function(t, e, n) {
                            var i = this,
                                r = t._model,
                                o = i.getValueScale(),
                                a = o.getBasePixel(),
                                s = o.isHorizontal(),
                                l = i._ruler || i.getRuler(),
                                u = i.calculateBarValuePixels(i.index, e),
                                c = i.calculateBarIndexPixels(i.index, e, l);
                            r.horizontal = s, r.base = n ? a : u.base, r.x = s ? n ? a : u.head : c.center, r.y = s ? c.center : n ? a : u.head, r.height = s ? c.size : void 0, r.width = s ? void 0 : c.size
                        },
                        getValueScaleId: function() { return this.getMeta().yAxisID },
                        getIndexScaleId: function() { return this.getMeta().xAxisID },
                        getValueScale: function() { return this.getScaleForId(this.getValueScaleId()) },
                        getIndexScale: function() { return this.getScaleForId(this.getIndexScaleId()) },
                        _getStacks: function(t) {
                            var e, n, i = this,
                                r = i.chart,
                                o = i.getIndexScale(),
                                a = o.options.stacked,
                                s = void 0 === t ? r.data.datasets.length : t + 1,
                                l = [];
                            for (e = 0; e < s; ++e) n = r.getDatasetMeta(e), n.bar && r.isDatasetVisible(e) && (a === !1 || a === !0 && l.indexOf(n.stack) === -1 || void 0 === a && (void 0 === n.stack || l.indexOf(n.stack) === -1)) && l.push(n.stack);
                            return l
                        },
                        getStackCount: function() { return this._getStacks().length },
                        getStackIndex: function(t, e) {
                            var n = this._getStacks(t),
                                i = void 0 !== e ? n.indexOf(e) : -1;
                            return i === -1 ? n.length - 1 : i
                        },
                        getRuler: function() {
                            var t, e, n, r = this,
                                o = r.getIndexScale(),
                                a = r.getStackCount(),
                                s = r.index,
                                u = o.isHorizontal(),
                                c = u ? o.left : o.top,
                                d = c + (u ? o.width : o.height),
                                h = [];
                            for (t = 0, e = r.getMeta().data.length; t < e; ++t) h.push(o.getPixelForValue(null, t, s));
                            return n = l.isNullOrUndef(o.options.barThickness) ? i(o, h) : -1, { min: n, pixels: h, start: c, end: d, stackCount: a, scale: o }
                        },
                        calculateBarValuePixels: function(t, e) {
                            var n, i, r, o, a, s, l = this,
                                u = l.chart,
                                c = l.getMeta(),
                                d = l.getValueScale(),
                                h = u.data.datasets,
                                f = d.getRightValue(h[t].data[e]),
                                p = d.options.stacked,
                                g = c.stack,
                                v = 0;
                            if (p || void 0 === p && void 0 !== g)
                                for (n = 0; n < t; ++n) i = u.getDatasetMeta(n), i.bar && i.stack === g && i.controller.getValueScaleId() === d.id && u.isDatasetVisible(n) && (r = d.getRightValue(h[n].data[e]), (f < 0 && r < 0 || f >= 0 && r > 0) && (v += r));
                            return o = d.getPixelForValue(v), a = d.getPixelForValue(v + f), s = (a - o) / 2, { size: s, base: o, head: a, center: a + s / 2 }
                        },
                        calculateBarIndexPixels: function(t, e, n) {
                            var i = this,
                                a = n.scale.options,
                                s = "flex" === a.barThickness ? o(e, n, a) : r(e, n, a),
                                u = i.getStackIndex(t, i.getMeta().stack),
                                c = s.start + s.chunk * u + s.chunk / 2,
                                d = Math.min(l.valueOrDefault(a.maxBarThickness, 1 / 0), s.chunk * s.ratio);
                            return { base: c - d / 2, head: c + d / 2, center: c, size: d }
                        },
                        draw: function() {
                            var t = this,
                                e = t.chart,
                                n = t.getValueScale(),
                                i = t.getMeta().data,
                                r = t.getDataset(),
                                o = i.length,
                                a = 0;
                            for (l.canvas.clipArea(e.ctx, e.chartArea); a < o; ++a) isNaN(n.getRightValue(r.data[a])) || i[a].draw();
                            l.canvas.unclipArea(e.ctx)
                        },
                        setHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t._index,
                                i = t.custom || {},
                                r = t._model;
                            r.backgroundColor = i.hoverBackgroundColor ? i.hoverBackgroundColor : l.valueAtIndexOrDefault(e.hoverBackgroundColor, n, l.getHoverColor(r.backgroundColor)), r.borderColor = i.hoverBorderColor ? i.hoverBorderColor : l.valueAtIndexOrDefault(e.hoverBorderColor, n, l.getHoverColor(r.borderColor)), r.borderWidth = i.hoverBorderWidth ? i.hoverBorderWidth : l.valueAtIndexOrDefault(e.hoverBorderWidth, n, r.borderWidth)
                        },
                        removeHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t._index,
                                i = t.custom || {},
                                r = t._model,
                                o = this.chart.options.elements.rectangle;
                            r.backgroundColor = i.backgroundColor ? i.backgroundColor : l.valueAtIndexOrDefault(e.backgroundColor, n, o.backgroundColor), r.borderColor = i.borderColor ? i.borderColor : l.valueAtIndexOrDefault(e.borderColor, n, o.borderColor), r.borderWidth = i.borderWidth ? i.borderWidth : l.valueAtIndexOrDefault(e.borderWidth, n, o.borderWidth)
                        }
                    }), t.controllers.horizontalBar = t.controllers.bar.extend({ getValueScaleId: function() { return this.getMeta().xAxisID }, getIndexScaleId: function() { return this.getMeta().yAxisID } })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            16: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(40),
                    o = t(45);
                i._set("bubble", {
                    hover: { mode: "single" },
                    scales: { xAxes: [{ type: "linear", position: "bottom", id: "x-axis-0" }], yAxes: [{ type: "linear", position: "left", id: "y-axis-0" }] },
                    tooltips: {
                        callbacks: {
                            title: function() { return "" },
                            label: function(t, e) {
                                var n = e.datasets[t.datasetIndex].label || "",
                                    i = e.datasets[t.datasetIndex].data[t.index];
                                return n + ": (" + t.xLabel + ", " + t.yLabel + ", " + i.r + ")"
                            }
                        }
                    }
                }), e.exports = function(t) {
                    t.controllers.bubble = t.DatasetController.extend({
                        dataElementType: r.Point,
                        update: function(t) {
                            var e = this,
                                n = e.getMeta(),
                                i = n.data;
                            o.each(i, function(n, i) { e.updateElement(n, i, t) })
                        },
                        updateElement: function(t, e, n) {
                            var i = this,
                                r = i.getMeta(),
                                o = t.custom || {},
                                a = i.getScaleForId(r.xAxisID),
                                s = i.getScaleForId(r.yAxisID),
                                l = i._resolveElementOptions(t, e),
                                u = i.getDataset().data[e],
                                c = i.index,
                                d = n ? a.getPixelForDecimal(.5) : a.getPixelForValue("object" == typeof u ? u : NaN, e, c),
                                h = n ? s.getBasePixel() : s.getPixelForValue(u, e, c);
                            t._xScale = a, t._yScale = s, t._options = l, t._datasetIndex = c, t._index = e, t._model = { backgroundColor: l.backgroundColor, borderColor: l.borderColor, borderWidth: l.borderWidth, hitRadius: l.hitRadius, pointStyle: l.pointStyle, radius: n ? 0 : l.radius, skip: o.skip || isNaN(d) || isNaN(h), x: d, y: h }, t.pivot()
                        },
                        setHoverStyle: function(t) {
                            var e = t._model,
                                n = t._options;
                            e.backgroundColor = o.valueOrDefault(n.hoverBackgroundColor, o.getHoverColor(n.backgroundColor)), e.borderColor = o.valueOrDefault(n.hoverBorderColor, o.getHoverColor(n.borderColor)), e.borderWidth = o.valueOrDefault(n.hoverBorderWidth, n.borderWidth), e.radius = n.radius + n.hoverRadius
                        },
                        removeHoverStyle: function(t) {
                            var e = t._model,
                                n = t._options;
                            e.backgroundColor = n.backgroundColor, e.borderColor = n.borderColor, e.borderWidth = n.borderWidth, e.radius = n.radius
                        },
                        _resolveElementOptions: function(t, e) {
                            var n, i, r, a = this,
                                s = a.chart,
                                l = s.data.datasets,
                                u = l[a.index],
                                c = t.custom || {},
                                d = s.options.elements.point,
                                h = o.options.resolve,
                                f = u.data[e],
                                p = {},
                                g = { chart: s, dataIndex: e, dataset: u, datasetIndex: a.index },
                                v = ["backgroundColor", "borderColor", "borderWidth", "hoverBackgroundColor", "hoverBorderColor", "hoverBorderWidth", "hoverRadius", "hitRadius", "pointStyle"];
                            for (n = 0, i = v.length; n < i; ++n) r = v[n], p[r] = h([c[r], u[r], d[r]], g, e);
                            return p.radius = h([c.radius, f ? f.r : void 0, u.radius, d.radius], g, e), p
                        }
                    })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            17: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(40),
                    o = t(45);
                i._set("doughnut", {
                    animation: { animateRotate: !0, animateScale: !1 },
                    hover: { mode: "single" },
                    legendCallback: function(t) {
                        var e = [];
                        e.push('<ul class="' + t.id + '-legend">');
                        var n = t.data,
                            i = n.datasets,
                            r = n.labels;
                        if (i.length)
                            for (var o = 0; o < i[0].data.length; ++o) e.push('<li><span style="background-color:' + i[0].backgroundColor[o] + '"></span>'), r[o] && e.push(r[o]), e.push("</li>");
                        return e.push("</ul>"), e.join("")
                    },
                    legend: {
                        labels: {
                            generateLabels: function(t) {
                                var e = t.data;
                                return e.labels.length && e.datasets.length ? e.labels.map(function(n, i) {
                                    var r = t.getDatasetMeta(0),
                                        a = e.datasets[0],
                                        s = r.data[i],
                                        l = s && s.custom || {},
                                        u = o.valueAtIndexOrDefault,
                                        c = t.options.elements.arc,
                                        d = l.backgroundColor ? l.backgroundColor : u(a.backgroundColor, i, c.backgroundColor),
                                        h = l.borderColor ? l.borderColor : u(a.borderColor, i, c.borderColor),
                                        f = l.borderWidth ? l.borderWidth : u(a.borderWidth, i, c.borderWidth);
                                    return { text: n, fillStyle: d, strokeStyle: h, lineWidth: f, hidden: isNaN(a.data[i]) || r.data[i].hidden, index: i }
                                }) : []
                            }
                        },
                        onClick: function(t, e) {
                            var n, i, r, o = e.index,
                                a = this.chart;
                            for (n = 0, i = (a.data.datasets || []).length; n < i; ++n) r = a.getDatasetMeta(n), r.data[o] && (r.data[o].hidden = !r.data[o].hidden);
                            a.update()
                        }
                    },
                    cutoutPercentage: 50,
                    rotation: Math.PI * -.5,
                    circumference: 2 * Math.PI,
                    tooltips: {
                        callbacks: {
                            title: function() { return "" },
                            label: function(t, e) {
                                var n = e.labels[t.index],
                                    i = ": " + e.datasets[t.datasetIndex].data[t.index];
                                return o.isArray(n) ? (n = n.slice(), n[0] += i) : n += i, n
                            }
                        }
                    }
                }), i._set("pie", o.clone(i.doughnut)), i._set("pie", { cutoutPercentage: 0 }), e.exports = function(t) {
                    t.controllers.doughnut = t.controllers.pie = t.DatasetController.extend({
                        dataElementType: r.Arc,
                        linkScales: o.noop,
                        getRingIndex: function(t) { for (var e = 0, n = 0; n < t; ++n) this.chart.isDatasetVisible(n) && ++e; return e },
                        update: function(t) {
                            var e = this,
                                n = e.chart,
                                i = n.chartArea,
                                r = n.options,
                                a = r.elements.arc,
                                s = i.right - i.left - a.borderWidth,
                                l = i.bottom - i.top - a.borderWidth,
                                u = Math.min(s, l),
                                c = { x: 0, y: 0 },
                                d = e.getMeta(),
                                h = r.cutoutPercentage,
                                f = r.circumference;
                            if (f < 2 * Math.PI) {
                                var p = r.rotation % (2 * Math.PI);
                                p += 2 * Math.PI * (p >= Math.PI ? -1 : p < -Math.PI ? 1 : 0);
                                var g = p + f,
                                    v = { x: Math.cos(p), y: Math.sin(p) },
                                    m = { x: Math.cos(g), y: Math.sin(g) },
                                    y = p <= 0 && g >= 0 || p <= 2 * Math.PI && 2 * Math.PI <= g,
                                    b = p <= .5 * Math.PI && .5 * Math.PI <= g || p <= 2.5 * Math.PI && 2.5 * Math.PI <= g,
                                    x = p <= -Math.PI && -Math.PI <= g || p <= Math.PI && Math.PI <= g,
                                    w = p <= .5 * -Math.PI && .5 * -Math.PI <= g || p <= 1.5 * Math.PI && 1.5 * Math.PI <= g,
                                    k = h / 100,
                                    S = { x: x ? -1 : Math.min(v.x * (v.x < 0 ? 1 : k), m.x * (m.x < 0 ? 1 : k)), y: w ? -1 : Math.min(v.y * (v.y < 0 ? 1 : k), m.y * (m.y < 0 ? 1 : k)) },
                                    _ = { x: y ? 1 : Math.max(v.x * (v.x > 0 ? 1 : k), m.x * (m.x > 0 ? 1 : k)), y: b ? 1 : Math.max(v.y * (v.y > 0 ? 1 : k), m.y * (m.y > 0 ? 1 : k)) },
                                    T = { width: .5 * (_.x - S.x), height: .5 * (_.y - S.y) };
                                u = Math.min(s / T.width, l / T.height), c = { x: (_.x + S.x) * -.5, y: (_.y + S.y) * -.5 }
                            }
                            n.borderWidth = e.getMaxBorderWidth(d.data), n.outerRadius = Math.max((u - n.borderWidth) / 2, 0), n.innerRadius = Math.max(h ? n.outerRadius / 100 * h : 0, 0), n.radiusLength = (n.outerRadius - n.innerRadius) / n.getVisibleDatasetCount(), n.offsetX = c.x * n.outerRadius, n.offsetY = c.y * n.outerRadius, d.total = e.calculateTotal(), e.outerRadius = n.outerRadius - n.radiusLength * e.getRingIndex(e.index), e.innerRadius = Math.max(e.outerRadius - n.radiusLength, 0), o.each(d.data, function(n, i) { e.updateElement(n, i, t) })
                        },
                        updateElement: function(t, e, n) {
                            var i = this,
                                r = i.chart,
                                a = r.chartArea,
                                s = r.options,
                                l = s.animation,
                                u = (a.left + a.right) / 2,
                                c = (a.top + a.bottom) / 2,
                                d = s.rotation,
                                h = s.rotation,
                                f = i.getDataset(),
                                p = n && l.animateRotate ? 0 : t.hidden ? 0 : i.calculateCircumference(f.data[e]) * (s.circumference / (2 * Math.PI)),
                                g = n && l.animateScale ? 0 : i.innerRadius,
                                v = n && l.animateScale ? 0 : i.outerRadius,
                                m = o.valueAtIndexOrDefault;
                            o.extend(t, { _datasetIndex: i.index, _index: e, _model: { x: u + r.offsetX, y: c + r.offsetY, startAngle: d, endAngle: h, circumference: p, outerRadius: v, innerRadius: g, label: m(f.label, e, r.data.labels[e]) } });
                            var y = t._model;
                            this.removeHoverStyle(t), n && l.animateRotate || (0 === e ? y.startAngle = s.rotation : y.startAngle = i.getMeta().data[e - 1]._model.endAngle, y.endAngle = y.startAngle + y.circumference), t.pivot()
                        },
                        removeHoverStyle: function(e) { t.DatasetController.prototype.removeHoverStyle.call(this, e, this.chart.options.elements.arc) },
                        calculateTotal: function() {
                            var t, e = this.getDataset(),
                                n = this.getMeta(),
                                i = 0;
                            return o.each(n.data, function(n, r) { t = e.data[r], isNaN(t) || n.hidden || (i += Math.abs(t)) }), i
                        },
                        calculateCircumference: function(t) { var e = this.getMeta().total; return e > 0 && !isNaN(t) ? 2 * Math.PI * (Math.abs(t) / e) : 0 },
                        getMaxBorderWidth: function(t) { for (var e, n, i = 0, r = this.index, o = t.length, a = 0; a < o; a++) e = t[a]._model ? t[a]._model.borderWidth : 0, n = t[a]._chart ? t[a]._chart.config.data.datasets[r].hoverBorderWidth : 0, i = e > i ? e : i, i = n > i ? n : i; return i }
                    })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            18: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(40),
                    o = t(45);
                i._set("line", { showLines: !0, spanGaps: !1, hover: { mode: "label" }, scales: { xAxes: [{ type: "category", id: "x-axis-0" }], yAxes: [{ type: "linear", id: "y-axis-0" }] } }), e.exports = function(t) {
                    function e(t, e) { return o.valueOrDefault(t.showLine, e.showLines) } t.controllers.line = t.DatasetController.extend({
                        datasetElementType: r.Line,
                        dataElementType: r.Point,
                        update: function(t) {
                            var n, i, r, a = this,
                                s = a.getMeta(),
                                l = s.dataset,
                                u = s.data || [],
                                c = a.chart.options,
                                d = c.elements.line,
                                h = a.getScaleForId(s.yAxisID),
                                f = a.getDataset(),
                                p = e(f, c);
                            for (p && (r = l.custom || {}, void 0 !== f.tension && void 0 === f.lineTension && (f.lineTension = f.tension), l._scale = h, l._datasetIndex = a.index, l._children = u, l._model = { spanGaps: f.spanGaps ? f.spanGaps : c.spanGaps, tension: r.tension ? r.tension : o.valueOrDefault(f.lineTension, d.tension), backgroundColor: r.backgroundColor ? r.backgroundColor : f.backgroundColor || d.backgroundColor, borderWidth: r.borderWidth ? r.borderWidth : f.borderWidth || d.borderWidth, borderColor: r.borderColor ? r.borderColor : f.borderColor || d.borderColor, borderCapStyle: r.borderCapStyle ? r.borderCapStyle : f.borderCapStyle || d.borderCapStyle, borderDash: r.borderDash ? r.borderDash : f.borderDash || d.borderDash, borderDashOffset: r.borderDashOffset ? r.borderDashOffset : f.borderDashOffset || d.borderDashOffset, borderJoinStyle: r.borderJoinStyle ? r.borderJoinStyle : f.borderJoinStyle || d.borderJoinStyle, fill: r.fill ? r.fill : void 0 !== f.fill ? f.fill : d.fill, steppedLine: r.steppedLine ? r.steppedLine : o.valueOrDefault(f.steppedLine, d.stepped), cubicInterpolationMode: r.cubicInterpolationMode ? r.cubicInterpolationMode : o.valueOrDefault(f.cubicInterpolationMode, d.cubicInterpolationMode) }, l.pivot()), n = 0, i = u.length; n < i; ++n) a.updateElement(u[n], n, t);
                            for (p && 0 !== l._model.tension && a.updateBezierControlPoints(), n = 0, i = u.length; n < i; ++n) u[n].pivot()
                        },
                        getPointBackgroundColor: function(t, e) {
                            var n = this.chart.options.elements.point.backgroundColor,
                                i = this.getDataset(),
                                r = t.custom || {};
                            return r.backgroundColor ? n = r.backgroundColor : i.pointBackgroundColor ? n = o.valueAtIndexOrDefault(i.pointBackgroundColor, e, n) : i.backgroundColor && (n = i.backgroundColor), n
                        },
                        getPointBorderColor: function(t, e) {
                            var n = this.chart.options.elements.point.borderColor,
                                i = this.getDataset(),
                                r = t.custom || {};
                            return r.borderColor ? n = r.borderColor : i.pointBorderColor ? n = o.valueAtIndexOrDefault(i.pointBorderColor, e, n) : i.borderColor && (n = i.borderColor), n
                        },
                        getPointBorderWidth: function(t, e) {
                            var n = this.chart.options.elements.point.borderWidth,
                                i = this.getDataset(),
                                r = t.custom || {};
                            return isNaN(r.borderWidth) ? !isNaN(i.pointBorderWidth) || o.isArray(i.pointBorderWidth) ? n = o.valueAtIndexOrDefault(i.pointBorderWidth, e, n) : isNaN(i.borderWidth) || (n = i.borderWidth) : n = r.borderWidth, n
                        },
                        updateElement: function(t, e, n) {
                            var i, r, a = this,
                                s = a.getMeta(),
                                l = t.custom || {},
                                u = a.getDataset(),
                                c = a.index,
                                d = u.data[e],
                                h = a.getScaleForId(s.yAxisID),
                                f = a.getScaleForId(s.xAxisID),
                                p = a.chart.options.elements.point;
                            void 0 !== u.radius && void 0 === u.pointRadius && (u.pointRadius = u.radius), void 0 !== u.hitRadius && void 0 === u.pointHitRadius && (u.pointHitRadius = u.hitRadius), i = f.getPixelForValue("object" == typeof d ? d : NaN, e, c), r = n ? h.getBasePixel() : a.calculatePointY(d, e, c), t._xScale = f, t._yScale = h, t._datasetIndex = c, t._index = e, t._model = { x: i, y: r, skip: l.skip || isNaN(i) || isNaN(r), radius: l.radius || o.valueAtIndexOrDefault(u.pointRadius, e, p.radius), pointStyle: l.pointStyle || o.valueAtIndexOrDefault(u.pointStyle, e, p.pointStyle), backgroundColor: a.getPointBackgroundColor(t, e), borderColor: a.getPointBorderColor(t, e), borderWidth: a.getPointBorderWidth(t, e), tension: s.dataset._model ? s.dataset._model.tension : 0, steppedLine: !!s.dataset._model && s.dataset._model.steppedLine, hitRadius: l.hitRadius || o.valueAtIndexOrDefault(u.pointHitRadius, e, p.hitRadius) }
                        },
                        calculatePointY: function(t, e, n) {
                            var i, r, o, a = this,
                                s = a.chart,
                                l = a.getMeta(),
                                u = a.getScaleForId(l.yAxisID),
                                c = 0,
                                d = 0;
                            if (u.options.stacked) {
                                for (i = 0; i < n; i++)
                                    if (r = s.data.datasets[i], o = s.getDatasetMeta(i), "line" === o.type && o.yAxisID === u.id && s.isDatasetVisible(i)) {
                                        var h = Number(u.getRightValue(r.data[e]));
                                        h < 0 ? d += h || 0 : c += h || 0
                                    } var f = Number(u.getRightValue(t));
                                return f < 0 ? u.getPixelForValue(d + f) : u.getPixelForValue(c + f)
                            }
                            return u.getPixelForValue(t)
                        },
                        updateBezierControlPoints: function() {
                            function t(t, e, n) { return Math.max(Math.min(t, n), e) }
                            var e, n, i, r, a, s = this,
                                l = s.getMeta(),
                                u = s.chart.chartArea,
                                c = l.data || [];
                            if (l.dataset._model.spanGaps && (c = c.filter(function(t) { return !t._model.skip })), "monotone" === l.dataset._model.cubicInterpolationMode) o.splineCurveMonotone(c);
                            else
                                for (e = 0, n = c.length; e < n; ++e) i = c[e], r = i._model, a = o.splineCurve(o.previousItem(c, e)._model, r, o.nextItem(c, e)._model, l.dataset._model.tension), r.controlPointPreviousX = a.previous.x, r.controlPointPreviousY = a.previous.y, r.controlPointNextX = a.next.x, r.controlPointNextY = a.next.y;
                            if (s.chart.options.elements.line.capBezierPoints)
                                for (e = 0, n = c.length; e < n; ++e) r = c[e]._model, r.controlPointPreviousX = t(r.controlPointPreviousX, u.left, u.right), r.controlPointPreviousY = t(r.controlPointPreviousY, u.top, u.bottom), r.controlPointNextX = t(r.controlPointNextX, u.left, u.right), r.controlPointNextY = t(r.controlPointNextY, u.top, u.bottom)
                        },
                        draw: function() {
                            var t = this,
                                n = t.chart,
                                i = t.getMeta(),
                                r = i.data || [],
                                a = n.chartArea,
                                s = r.length,
                                l = 0;
                            for (o.canvas.clipArea(n.ctx, a), e(t.getDataset(), n.options) && i.dataset.draw(), o.canvas.unclipArea(n.ctx); l < s; ++l) r[l].draw(a)
                        },
                        setHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t._index,
                                i = t.custom || {},
                                r = t._model;
                            r.radius = i.hoverRadius || o.valueAtIndexOrDefault(e.pointHoverRadius, n, this.chart.options.elements.point.hoverRadius), r.backgroundColor = i.hoverBackgroundColor || o.valueAtIndexOrDefault(e.pointHoverBackgroundColor, n, o.getHoverColor(r.backgroundColor)), r.borderColor = i.hoverBorderColor || o.valueAtIndexOrDefault(e.pointHoverBorderColor, n, o.getHoverColor(r.borderColor)), r.borderWidth = i.hoverBorderWidth || o.valueAtIndexOrDefault(e.pointHoverBorderWidth, n, r.borderWidth)
                        },
                        removeHoverStyle: function(t) {
                            var e = this,
                                n = e.chart.data.datasets[t._datasetIndex],
                                i = t._index,
                                r = t.custom || {},
                                a = t._model;
                            void 0 !== n.radius && void 0 === n.pointRadius && (n.pointRadius = n.radius), a.radius = r.radius || o.valueAtIndexOrDefault(n.pointRadius, i, e.chart.options.elements.point.radius), a.backgroundColor = e.getPointBackgroundColor(t, i), a.borderColor = e.getPointBorderColor(t, i), a.borderWidth = e.getPointBorderWidth(t, i)
                        }
                    })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            19: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(40),
                    o = t(45);
                i._set("polarArea", {
                    scale: { type: "radialLinear", angleLines: { display: !1 }, gridLines: { circular: !0 }, pointLabels: { display: !1 }, ticks: { beginAtZero: !0 } },
                    animation: { animateRotate: !0, animateScale: !0 },
                    startAngle: -.5 * Math.PI,
                    legendCallback: function(t) {
                        var e = [];
                        e.push('<ul class="' + t.id + '-legend">');
                        var n = t.data,
                            i = n.datasets,
                            r = n.labels;
                        if (i.length)
                            for (var o = 0; o < i[0].data.length; ++o) e.push('<li><span style="background-color:' + i[0].backgroundColor[o] + '"></span>'), r[o] && e.push(r[o]), e.push("</li>");
                        return e.push("</ul>"), e.join("")
                    },
                    legend: {
                        labels: {
                            generateLabels: function(t) {
                                var e = t.data;
                                return e.labels.length && e.datasets.length ? e.labels.map(function(n, i) {
                                    var r = t.getDatasetMeta(0),
                                        a = e.datasets[0],
                                        s = r.data[i],
                                        l = s.custom || {},
                                        u = o.valueAtIndexOrDefault,
                                        c = t.options.elements.arc,
                                        d = l.backgroundColor ? l.backgroundColor : u(a.backgroundColor, i, c.backgroundColor),
                                        h = l.borderColor ? l.borderColor : u(a.borderColor, i, c.borderColor),
                                        f = l.borderWidth ? l.borderWidth : u(a.borderWidth, i, c.borderWidth);
                                    return { text: n, fillStyle: d, strokeStyle: h, lineWidth: f, hidden: isNaN(a.data[i]) || r.data[i].hidden, index: i }
                                }) : []
                            }
                        },
                        onClick: function(t, e) {
                            var n, i, r, o = e.index,
                                a = this.chart;
                            for (n = 0, i = (a.data.datasets || []).length; n < i; ++n) r = a.getDatasetMeta(n), r.data[o].hidden = !r.data[o].hidden;
                            a.update()
                        }
                    },
                    tooltips: { callbacks: { title: function() { return "" }, label: function(t, e) { return e.labels[t.index] + ": " + t.yLabel } } }
                }), e.exports = function(t) {
                    t.controllers.polarArea = t.DatasetController.extend({
                        dataElementType: r.Arc,
                        linkScales: o.noop,
                        update: function(t) {
                            var e = this,
                                n = e.chart,
                                i = n.chartArea,
                                r = e.getMeta(),
                                a = n.options,
                                s = a.elements.arc,
                                l = Math.min(i.right - i.left, i.bottom - i.top);
                            n.outerRadius = Math.max((l - s.borderWidth / 2) / 2, 0), n.innerRadius = Math.max(a.cutoutPercentage ? n.outerRadius / 100 * a.cutoutPercentage : 1, 0), n.radiusLength = (n.outerRadius - n.innerRadius) / n.getVisibleDatasetCount(), e.outerRadius = n.outerRadius - n.radiusLength * e.index, e.innerRadius = e.outerRadius - n.radiusLength, r.count = e.countVisibleElements(), o.each(r.data, function(n, i) { e.updateElement(n, i, t) })
                        },
                        updateElement: function(t, e, n) {
                            for (var i = this, r = i.chart, a = i.getDataset(), s = r.options, l = s.animation, u = r.scale, c = r.data.labels, d = i.calculateCircumference(a.data[e]), h = u.xCenter, f = u.yCenter, p = 0, g = i.getMeta(), v = 0; v < e; ++v) isNaN(a.data[v]) || g.data[v].hidden || ++p;
                            var m = s.startAngle,
                                y = t.hidden ? 0 : u.getDistanceFromCenterForValue(a.data[e]),
                                b = m + d * p,
                                x = b + (t.hidden ? 0 : d),
                                w = l.animateScale ? 0 : u.getDistanceFromCenterForValue(a.data[e]);
                            o.extend(t, { _datasetIndex: i.index, _index: e, _scale: u, _model: { x: h, y: f, innerRadius: 0, outerRadius: n ? w : y, startAngle: n && l.animateRotate ? m : b, endAngle: n && l.animateRotate ? m : x, label: o.valueAtIndexOrDefault(c, e, c[e]) } }), i.removeHoverStyle(t), t.pivot()
                        },
                        removeHoverStyle: function(e) { t.DatasetController.prototype.removeHoverStyle.call(this, e, this.chart.options.elements.arc) },
                        countVisibleElements: function() {
                            var t = this.getDataset(),
                                e = this.getMeta(),
                                n = 0;
                            return o.each(e.data, function(e, i) { isNaN(t.data[i]) || e.hidden || n++ }), n
                        },
                        calculateCircumference: function(t) { var e = this.getMeta().count; return e > 0 && !isNaN(t) ? 2 * Math.PI / e : 0 }
                    })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            20: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(40),
                    o = t(45);
                i._set("radar", { scale: { type: "radialLinear" }, elements: { line: { tension: 0 } } }), e.exports = function(t) {
                    t.controllers.radar = t.DatasetController.extend({
                        datasetElementType: r.Line,
                        dataElementType: r.Point,
                        linkScales: o.noop,
                        update: function(t) {
                            var e = this,
                                n = e.getMeta(),
                                i = n.dataset,
                                r = n.data,
                                a = i.custom || {},
                                s = e.getDataset(),
                                l = e.chart.options.elements.line,
                                u = e.chart.scale;
                            void 0 !== s.tension && void 0 === s.lineTension && (s.lineTension = s.tension), o.extend(n.dataset, { _datasetIndex: e.index, _scale: u, _children: r, _loop: !0, _model: { tension: a.tension ? a.tension : o.valueOrDefault(s.lineTension, l.tension), backgroundColor: a.backgroundColor ? a.backgroundColor : s.backgroundColor || l.backgroundColor, borderWidth: a.borderWidth ? a.borderWidth : s.borderWidth || l.borderWidth, borderColor: a.borderColor ? a.borderColor : s.borderColor || l.borderColor, fill: a.fill ? a.fill : void 0 !== s.fill ? s.fill : l.fill, borderCapStyle: a.borderCapStyle ? a.borderCapStyle : s.borderCapStyle || l.borderCapStyle, borderDash: a.borderDash ? a.borderDash : s.borderDash || l.borderDash, borderDashOffset: a.borderDashOffset ? a.borderDashOffset : s.borderDashOffset || l.borderDashOffset, borderJoinStyle: a.borderJoinStyle ? a.borderJoinStyle : s.borderJoinStyle || l.borderJoinStyle } }), n.dataset.pivot(), o.each(r, function(n, i) { e.updateElement(n, i, t) }, e), e.updateBezierControlPoints()
                        },
                        updateElement: function(t, e, n) {
                            var i = this,
                                r = t.custom || {},
                                a = i.getDataset(),
                                s = i.chart.scale,
                                l = i.chart.options.elements.point,
                                u = s.getPointPositionForValue(e, a.data[e]);
                            void 0 !== a.radius && void 0 === a.pointRadius && (a.pointRadius = a.radius), void 0 !== a.hitRadius && void 0 === a.pointHitRadius && (a.pointHitRadius = a.hitRadius), o.extend(t, { _datasetIndex: i.index, _index: e, _scale: s, _model: { x: n ? s.xCenter : u.x, y: n ? s.yCenter : u.y, tension: r.tension ? r.tension : o.valueOrDefault(a.lineTension, i.chart.options.elements.line.tension), radius: r.radius ? r.radius : o.valueAtIndexOrDefault(a.pointRadius, e, l.radius), backgroundColor: r.backgroundColor ? r.backgroundColor : o.valueAtIndexOrDefault(a.pointBackgroundColor, e, l.backgroundColor), borderColor: r.borderColor ? r.borderColor : o.valueAtIndexOrDefault(a.pointBorderColor, e, l.borderColor), borderWidth: r.borderWidth ? r.borderWidth : o.valueAtIndexOrDefault(a.pointBorderWidth, e, l.borderWidth), pointStyle: r.pointStyle ? r.pointStyle : o.valueAtIndexOrDefault(a.pointStyle, e, l.pointStyle), hitRadius: r.hitRadius ? r.hitRadius : o.valueAtIndexOrDefault(a.pointHitRadius, e, l.hitRadius) } }), t._model.skip = r.skip ? r.skip : isNaN(t._model.x) || isNaN(t._model.y)
                        },
                        updateBezierControlPoints: function() {
                            var t = this.chart.chartArea,
                                e = this.getMeta();
                            o.each(e.data, function(n, i) {
                                var r = n._model,
                                    a = o.splineCurve(o.previousItem(e.data, i, !0)._model, r, o.nextItem(e.data, i, !0)._model, r.tension);
                                r.controlPointPreviousX = Math.max(Math.min(a.previous.x, t.right), t.left), r.controlPointPreviousY = Math.max(Math.min(a.previous.y, t.bottom), t.top), r.controlPointNextX = Math.max(Math.min(a.next.x, t.right), t.left), r.controlPointNextY = Math.max(Math.min(a.next.y, t.bottom), t.top), n.pivot()
                            })
                        },
                        setHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t.custom || {},
                                i = t._index,
                                r = t._model;
                            r.radius = n.hoverRadius ? n.hoverRadius : o.valueAtIndexOrDefault(e.pointHoverRadius, i, this.chart.options.elements.point.hoverRadius), r.backgroundColor = n.hoverBackgroundColor ? n.hoverBackgroundColor : o.valueAtIndexOrDefault(e.pointHoverBackgroundColor, i, o.getHoverColor(r.backgroundColor)), r.borderColor = n.hoverBorderColor ? n.hoverBorderColor : o.valueAtIndexOrDefault(e.pointHoverBorderColor, i, o.getHoverColor(r.borderColor)), r.borderWidth = n.hoverBorderWidth ? n.hoverBorderWidth : o.valueAtIndexOrDefault(e.pointHoverBorderWidth, i, r.borderWidth)
                        },
                        removeHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t.custom || {},
                                i = t._index,
                                r = t._model,
                                a = this.chart.options.elements.point;
                            r.radius = n.radius ? n.radius : o.valueAtIndexOrDefault(e.pointRadius, i, a.radius), r.backgroundColor = n.backgroundColor ? n.backgroundColor : o.valueAtIndexOrDefault(e.pointBackgroundColor, i, a.backgroundColor), r.borderColor = n.borderColor ? n.borderColor : o.valueAtIndexOrDefault(e.pointBorderColor, i, a.borderColor), r.borderWidth = n.borderWidth ? n.borderWidth : o.valueAtIndexOrDefault(e.pointBorderWidth, i, a.borderWidth)
                        }
                    })
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            21: [function(t, e, n) {
                "use strict";
                var i = t(25);
                i._set("scatter", { hover: { mode: "single" }, scales: { xAxes: [{ id: "x-axis-1", type: "linear", position: "bottom" }], yAxes: [{ id: "y-axis-1", type: "linear", position: "left" }] }, showLines: !1, tooltips: { callbacks: { title: function() { return "" }, label: function(t) { return "(" + t.xLabel + ", " + t.yLabel + ")" } } } }), e.exports = function(t) { t.controllers.scatter = t.controllers.line }
            }, { 25: 25 }],
            22: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(26),
                    o = t(45);
                i._set("global", { animation: { duration: 1e3, easing: "easeOutQuart", onProgress: o.noop, onComplete: o.noop } }), e.exports = function(t) {
                    t.Animation = r.extend({ chart: null, currentStep: 0, numSteps: 60, easing: "", render: null, onAnimationProgress: null, onAnimationComplete: null }), t.animationService = {
                        frameDuration: 17,
                        animations: [],
                        dropFrames: 0,
                        request: null,
                        addAnimation: function(t, e, n, i) {
                            var r, o, a = this.animations;
                            for (e.chart = t, i || (t.animating = !0), r = 0, o = a.length; r < o; ++r)
                                if (a[r].chart === t) return void(a[r] = e);
                            a.push(e), 1 === a.length && this.requestAnimationFrame()
                        },
                        cancelAnimation: function(t) {
                            var e = o.findIndex(this.animations, function(e) { return e.chart === t });
                            e !== -1 && (this.animations.splice(e, 1), t.animating = !1)
                        },
                        requestAnimationFrame: function() {
                            var t = this;
                            null === t.request && (t.request = o.requestAnimFrame.call(window, function() { t.request = null, t.startDigest() }))
                        },
                        startDigest: function() {
                            var t = this,
                                e = Date.now(),
                                n = 0;
                            t.dropFrames > 1 && (n = Math.floor(t.dropFrames), t.dropFrames = t.dropFrames % 1), t.advance(1 + n);
                            var i = Date.now();
                            t.dropFrames += (i - e) / t.frameDuration, t.animations.length > 0 && t.requestAnimationFrame()
                        },
                        advance: function(t) { for (var e, n, i = this.animations, r = 0; r < i.length;) e = i[r], n = e.chart, e.currentStep = (e.currentStep || 0) + t, e.currentStep = Math.min(e.currentStep, e.numSteps), o.callback(e.render, [n, e], n), o.callback(e.onAnimationProgress, [e], n), e.currentStep >= e.numSteps ? (o.callback(e.onAnimationComplete, [e], n), n.animating = !1, i.splice(r, 1)) : ++r }
                    }, Object.defineProperty(t.Animation.prototype, "animationObject", { get: function() { return this } }), Object.defineProperty(t.Animation.prototype, "chartInstance", { get: function() { return this.chart }, set: function(t) { this.chart = t } })
                }
            }, { 25: 25, 26: 26, 45: 45 }],
            23: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(45),
                    o = t(28),
                    a = t(30),
                    s = t(48),
                    l = t(31);
                e.exports = function(t) {
                    function e(t) { t = t || {}; var e = t.data = t.data || {}; return e.datasets = e.datasets || [], e.labels = e.labels || [], t.options = r.configMerge(i.global, i[t.type], t.options || {}), t }

                    function n(e) {
                        var n = e.options;
                        r.each(e.scales, function(t) { a.removeBox(e, t) }), n = r.configMerge(t.defaults.global, t.defaults[e.config.type], n), e.options = e.config.options = n, e.ensureScalesHaveIDs(), e.buildOrUpdateScales(), e.tooltip._options = n.tooltips, e.tooltip.initialize()
                    }

                    function u(t) { return "top" === t || "bottom" === t } t.types = {}, t.instances = {}, t.controllers = {}, r.extend(t.prototype, {
                        construct: function(n, i) {
                            var o = this;
                            i = e(i);
                            var a = s.acquireContext(n, i),
                                l = a && a.canvas,
                                u = l && l.height,
                                c = l && l.width;
                            o.id = r.uid(), o.ctx = a, o.canvas = l, o.config = i, o.width = c, o.height = u, o.aspectRatio = u ? c / u : null, o.options = i.options, o._bufferedRender = !1, o.chart = o, o.controller = o, t.instances[o.id] = o, Object.defineProperty(o, "data", { get: function() { return o.config.data }, set: function(t) { o.config.data = t } }), a && l && (o.initialize(), o.update())
                        },
                        initialize: function() { var t = this; return l.notify(t, "beforeInit"), r.retinaScale(t, t.options.devicePixelRatio), t.bindEvents(), t.options.responsive && t.resize(!0), t.ensureScalesHaveIDs(), t.buildOrUpdateScales(), t.initToolTip(), l.notify(t, "afterInit"), t },
                        clear: function() { return r.canvas.clear(this), this },
                        stop: function() { return t.animationService.cancelAnimation(this), this },
                        resize: function(t) {
                            var e = this,
                                n = e.options,
                                i = e.canvas,
                                o = n.maintainAspectRatio && e.aspectRatio || null,
                                a = Math.max(0, Math.floor(r.getMaximumWidth(i))),
                                s = Math.max(0, Math.floor(o ? a / o : r.getMaximumHeight(i)));
                            if ((e.width !== a || e.height !== s) && (i.width = e.width = a, i.height = e.height = s, i.style.width = a + "px", i.style.height = s + "px", r.retinaScale(e, n.devicePixelRatio), !t)) {
                                var u = { width: a, height: s };
                                l.notify(e, "resize", [u]), e.options.onResize && e.options.onResize(e, u), e.stop(), e.update(e.options.responsiveAnimationDuration)
                            }
                        },
                        ensureScalesHaveIDs: function() {
                            var t = this.options,
                                e = t.scales || {},
                                n = t.scale;
                            r.each(e.xAxes, function(t, e) { t.id = t.id || "x-axis-" + e }), r.each(e.yAxes, function(t, e) { t.id = t.id || "y-axis-" + e }), n && (n.id = n.id || "scale")
                        },
                        buildOrUpdateScales: function() {
                            var e = this,
                                n = e.options,
                                i = e.scales || {},
                                o = [],
                                a = Object.keys(i).reduce(function(t, e) { return t[e] = !1, t }, {});
                            n.scales && (o = o.concat((n.scales.xAxes || []).map(function(t) { return { options: t, dtype: "category", dposition: "bottom" } }), (n.scales.yAxes || []).map(function(t) { return { options: t, dtype: "linear", dposition: "left" } }))), n.scale && o.push({ options: n.scale, dtype: "radialLinear", isDefault: !0, dposition: "chartArea" }), r.each(o, function(n) {
                                var o = n.options,
                                    s = o.id,
                                    l = r.valueOrDefault(o.type, n.dtype);
                                u(o.position) !== u(n.dposition) && (o.position = n.dposition), a[s] = !0;
                                var c = null;
                                if (s in i && i[s].type === l) c = i[s], c.options = o, c.ctx = e.ctx, c.chart = e;
                                else {
                                    var d = t.scaleService.getScaleConstructor(l);
                                    if (!d) return;
                                    c = new d({ id: s, type: l, options: o, ctx: e.ctx, chart: e }), i[c.id] = c
                                }
                                c.mergeTicksOptions(), n.isDefault && (e.scale = c)
                            }), r.each(a, function(t, e) { t || delete i[e] }), e.scales = i, t.scaleService.addScalesToLayout(this)
                        },
                        buildOrUpdateControllers: function() {
                            var e = this,
                                n = [],
                                i = [];
                            return r.each(e.data.datasets, function(r, o) {
                                var a = e.getDatasetMeta(o),
                                    s = r.type || e.config.type;
                                if (a.type && a.type !== s && (e.destroyDatasetMeta(o), a = e.getDatasetMeta(o)), a.type = s, n.push(a.type), a.controller) a.controller.updateIndex(o), a.controller.linkScales();
                                else {
                                    var l = t.controllers[a.type];
                                    if (void 0 === l) throw new Error('"' + a.type + '" is not a chart type.');
                                    a.controller = new l(e, o), i.push(a.controller)
                                }
                            }, e), i
                        },
                        resetElements: function() {
                            var t = this;
                            r.each(t.data.datasets, function(e, n) { t.getDatasetMeta(n).controller.reset() }, t)
                        },
                        reset: function() { this.resetElements(), this.tooltip.initialize() },
                        update: function(t) {
                            var e = this;
                            if (t && "object" == typeof t || (t = { duration: t, lazy: arguments[1] }), n(e), l._invalidate(e), l.notify(e, "beforeUpdate") !== !1) {
                                e.tooltip._data = e.data;
                                var i = e.buildOrUpdateControllers();
                                r.each(e.data.datasets, function(t, n) { e.getDatasetMeta(n).controller.buildOrUpdateElements() }, e), e.updateLayout(), e.options.animation && e.options.animation.duration && r.each(i, function(t) { t.reset() }), e.updateDatasets(), e.tooltip.initialize(), e.lastActive = [], l.notify(e, "afterUpdate"), e._bufferedRender ? e._bufferedRequest = { duration: t.duration, easing: t.easing, lazy: t.lazy } : e.render(t)
                            }
                        },
                        updateLayout: function() {
                            var t = this;
                            l.notify(t, "beforeLayout") !== !1 && (a.update(this, this.width, this.height), l.notify(t, "afterScaleUpdate"), l.notify(t, "afterLayout"))
                        },
                        updateDatasets: function() {
                            var t = this;
                            if (l.notify(t, "beforeDatasetsUpdate") !== !1) {
                                for (var e = 0, n = t.data.datasets.length; e < n; ++e) t.updateDataset(e);
                                l.notify(t, "afterDatasetsUpdate")
                            }
                        },
                        updateDataset: function(t) {
                            var e = this,
                                n = e.getDatasetMeta(t),
                                i = { meta: n, index: t };
                            l.notify(e, "beforeDatasetUpdate", [i]) !== !1 && (n.controller.update(), l.notify(e, "afterDatasetUpdate", [i]))
                        },
                        render: function(e) {
                            var n = this;
                            e && "object" == typeof e || (e = { duration: e, lazy: arguments[1] });
                            var i = e.duration,
                                o = e.lazy;
                            if (l.notify(n, "beforeRender") !== !1) {
                                var a = n.options.animation,
                                    s = function(t) { l.notify(n, "afterRender"), r.callback(a && a.onComplete, [t], n) };
                                if (a && ("undefined" != typeof i && 0 !== i || "undefined" == typeof i && 0 !== a.duration)) {
                                    var u = new t.Animation({
                                        numSteps: (i || a.duration) / 16.66,
                                        easing: e.easing || a.easing,
                                        render: function(t, e) {
                                            var n = r.easing.effects[e.easing],
                                                i = e.currentStep,
                                                o = i / e.numSteps;
                                            t.draw(n(o), o, i)
                                        },
                                        onAnimationProgress: a.onProgress,
                                        onAnimationComplete: s
                                    });
                                    t.animationService.addAnimation(n, u, i, o)
                                } else n.draw(), s(new t.Animation({ numSteps: 0, chart: n }));
                                return n
                            }
                        },
                        draw: function(t) {
                            var e = this;
                            e.clear(), r.isNullOrUndef(t) && (t = 1), e.transition(t), l.notify(e, "beforeDraw", [t]) !== !1 && (r.each(e.boxes, function(t) { t.draw(e.chartArea) }, e), e.scale && e.scale.draw(), e.drawDatasets(t), e._drawTooltip(t), l.notify(e, "afterDraw", [t]))
                        },
                        transition: function(t) {
                            for (var e = this, n = 0, i = (e.data.datasets || []).length; n < i; ++n) e.isDatasetVisible(n) && e.getDatasetMeta(n).controller.transition(t);
                            e.tooltip.transition(t)
                        },
                        drawDatasets: function(t) {
                            var e = this;
                            if (l.notify(e, "beforeDatasetsDraw", [t]) !== !1) {
                                for (var n = (e.data.datasets || []).length - 1; n >= 0; --n) e.isDatasetVisible(n) && e.drawDataset(n, t);
                                l.notify(e, "afterDatasetsDraw", [t])
                            }
                        },
                        drawDataset: function(t, e) {
                            var n = this,
                                i = n.getDatasetMeta(t),
                                r = { meta: i, index: t, easingValue: e };
                            l.notify(n, "beforeDatasetDraw", [r]) !== !1 && (i.controller.draw(e), l.notify(n, "afterDatasetDraw", [r]))
                        },
                        _drawTooltip: function(t) {
                            var e = this,
                                n = e.tooltip,
                                i = { tooltip: n, easingValue: t };
                            l.notify(e, "beforeTooltipDraw", [i]) !== !1 && (n.draw(), l.notify(e, "afterTooltipDraw", [i]))
                        },
                        getElementAtEvent: function(t) { return o.modes.single(this, t) },
                        getElementsAtEvent: function(t) { return o.modes.label(this, t, { intersect: !0 }) },
                        getElementsAtXAxis: function(t) { return o.modes["x-axis"](this, t, { intersect: !0 }) },
                        getElementsAtEventForMode: function(t, e, n) { var i = o.modes[e]; return "function" == typeof i ? i(this, t, n) : [] },
                        getDatasetAtEvent: function(t) { return o.modes.dataset(this, t, { intersect: !0 }) },
                        getDatasetMeta: function(t) {
                            var e = this,
                                n = e.data.datasets[t];
                            n._meta || (n._meta = {});
                            var i = n._meta[e.id];
                            return i || (i = n._meta[e.id] = { type: null, data: [], dataset: null, controller: null, hidden: null, xAxisID: null, yAxisID: null }), i
                        },
                        getVisibleDatasetCount: function() { for (var t = 0, e = 0, n = this.data.datasets.length; e < n; ++e) this.isDatasetVisible(e) && t++; return t },
                        isDatasetVisible: function(t) { var e = this.getDatasetMeta(t); return "boolean" == typeof e.hidden ? !e.hidden : !this.data.datasets[t].hidden },
                        generateLegend: function() { return this.options.legendCallback(this) },
                        destroyDatasetMeta: function(t) {
                            var e = this.id,
                                n = this.data.datasets[t],
                                i = n._meta && n._meta[e];
                            i && (i.controller.destroy(), delete n._meta[e])
                        },
                        destroy: function() {
                            var e, n, i = this,
                                o = i.canvas;
                            for (i.stop(), e = 0, n = i.data.datasets.length; e < n; ++e) i.destroyDatasetMeta(e);
                            o && (i.unbindEvents(), r.canvas.clear(i), s.releaseContext(i.ctx), i.canvas = null, i.ctx = null), l.notify(i, "destroy"), delete t.instances[i.id]
                        },
                        toBase64Image: function() { return this.canvas.toDataURL.apply(this.canvas, arguments) },
                        initToolTip: function() {
                            var e = this;
                            e.tooltip = new t.Tooltip({ _chart: e, _chartInstance: e, _data: e.data, _options: e.options.tooltips }, e)
                        },
                        bindEvents: function() {
                            var t = this,
                                e = t._listeners = {},
                                n = function() { t.eventHandler.apply(t, arguments) };
                            r.each(t.options.events, function(i) { s.addEventListener(t, i, n), e[i] = n }), t.options.responsive && (n = function() { t.resize() }, s.addEventListener(t, "resize", n), e.resize = n)
                        },
                        unbindEvents: function() {
                            var t = this,
                                e = t._listeners;
                            e && (delete t._listeners, r.each(e, function(e, n) { s.removeEventListener(t, n, e) }))
                        },
                        updateHoverStyle: function(t, e, n) { var i, r, o, a = n ? "setHoverStyle" : "removeHoverStyle"; for (r = 0, o = t.length; r < o; ++r) i = t[r], i && this.getDatasetMeta(i._datasetIndex).controller[a](i) },
                        eventHandler: function(t) {
                            var e = this,
                                n = e.tooltip;
                            if (l.notify(e, "beforeEvent", [t]) !== !1) {
                                e._bufferedRender = !0, e._bufferedRequest = null;
                                var i = e.handleEvent(t);
                                n && (i = n._start ? n.handleEvent(t) : i | n.handleEvent(t)), l.notify(e, "afterEvent", [t]);
                                var r = e._bufferedRequest;
                                return r ? e.render(r) : i && !e.animating && (e.stop(), e.render(e.options.hover.animationDuration, !0)), e._bufferedRender = !1, e._bufferedRequest = null, e
                            }
                        },
                        handleEvent: function(t) {
                            var e = this,
                                n = e.options || {},
                                i = n.hover,
                                o = !1;
                            return e.lastActive = e.lastActive || [], "mouseout" === t.type ? e.active = [] : e.active = e.getElementsAtEventForMode(t, i.mode, i), r.callback(n.onHover || n.hover.onHover, [t.native, e.active], e), "mouseup" !== t.type && "click" !== t.type || n.onClick && n.onClick.call(e, t.native, e.active), e.lastActive.length && e.updateHoverStyle(e.lastActive, i.mode, !1), e.active.length && i.mode && e.updateHoverStyle(e.active, i.mode, !0), o = !r.arrayEquals(e.active, e.lastActive), e.lastActive = e.active, o
                        }
                    }), t.Controller = t
                }
            }, { 25: 25, 28: 28, 30: 30, 31: 31, 45: 45, 48: 48 }],
            24: [function(t, e, n) {
                "use strict";
                var i = t(45);
                e.exports = function(t) {
                    function e(t, e) {
                        return t._chartjs ? void t._chartjs.listeners.push(e) : (Object.defineProperty(t, "_chartjs", { configurable: !0, enumerable: !1, value: { listeners: [e] } }), void r.forEach(function(e) {
                            var n = "onData" + e.charAt(0).toUpperCase() + e.slice(1),
                                r = t[e];
                            Object.defineProperty(t, e, {
                                configurable: !0,
                                enumerable: !1,
                                value: function() {
                                    var e = Array.prototype.slice.call(arguments),
                                        o = r.apply(this, e);
                                    return i.each(t._chartjs.listeners, function(t) { "function" == typeof t[n] && t[n].apply(t, e) }), o
                                }
                            })
                        }))
                    }

                    function n(t, e) {
                        var n = t._chartjs;
                        if (n) {
                            var i = n.listeners,
                                o = i.indexOf(e);
                            o !== -1 && i.splice(o, 1), i.length > 0 || (r.forEach(function(e) { delete t[e] }), delete t._chartjs)
                        }
                    }
                    var r = ["push", "pop", "shift", "splice", "unshift"];
                    t.DatasetController = function(t, e) { this.initialize(t, e) }, i.extend(t.DatasetController.prototype, {
                        datasetElementType: null,
                        dataElementType: null,
                        initialize: function(t, e) {
                            var n = this;
                            n.chart = t, n.index = e, n.linkScales(), n.addElements()
                        },
                        updateIndex: function(t) { this.index = t },
                        linkScales: function() {
                            var t = this,
                                e = t.getMeta(),
                                n = t.getDataset();
                            null !== e.xAxisID && e.xAxisID in t.chart.scales || (e.xAxisID = n.xAxisID || t.chart.options.scales.xAxes[0].id), null !== e.yAxisID && e.yAxisID in t.chart.scales || (e.yAxisID = n.yAxisID || t.chart.options.scales.yAxes[0].id)
                        },
                        getDataset: function() { return this.chart.data.datasets[this.index] },
                        getMeta: function() { return this.chart.getDatasetMeta(this.index) },
                        getScaleForId: function(t) { return this.chart.scales[t] },
                        reset: function() { this.update(!0) },
                        destroy: function() { this._data && n(this._data, this) },
                        createMetaDataset: function() {
                            var t = this,
                                e = t.datasetElementType;
                            return e && new e({ _chart: t.chart, _datasetIndex: t.index })
                        },
                        createMetaData: function(t) {
                            var e = this,
                                n = e.dataElementType;
                            return n && new n({ _chart: e.chart, _datasetIndex: e.index, _index: t })
                        },
                        addElements: function() {
                            var t, e, n = this,
                                i = n.getMeta(),
                                r = n.getDataset().data || [],
                                o = i.data;
                            for (t = 0, e = r.length; t < e; ++t) o[t] = o[t] || n.createMetaData(t);
                            i.dataset = i.dataset || n.createMetaDataset()
                        },
                        addElementAndReset: function(t) {
                            var e = this.createMetaData(t);
                            this.getMeta().data.splice(t, 0, e), this.updateElement(e, t, !0)
                        },
                        buildOrUpdateElements: function() {
                            var t = this,
                                i = t.getDataset(),
                                r = i.data || (i.data = []);
                            t._data !== r && (t._data && n(t._data, t), e(r, t), t._data = r), t.resyncElements()
                        },
                        update: i.noop,
                        transition: function(t) {
                            for (var e = this.getMeta(), n = e.data || [], i = n.length, r = 0; r < i; ++r) n[r].transition(t);
                            e.dataset && e.dataset.transition(t)
                        },
                        draw: function() {
                            var t = this.getMeta(),
                                e = t.data || [],
                                n = e.length,
                                i = 0;
                            for (t.dataset && t.dataset.draw(); i < n; ++i) e[i].draw()
                        },
                        removeHoverStyle: function(t, e) {
                            var n = this.chart.data.datasets[t._datasetIndex],
                                r = t._index,
                                o = t.custom || {},
                                a = i.valueAtIndexOrDefault,
                                s = t._model;
                            s.backgroundColor = o.backgroundColor ? o.backgroundColor : a(n.backgroundColor, r, e.backgroundColor), s.borderColor = o.borderColor ? o.borderColor : a(n.borderColor, r, e.borderColor), s.borderWidth = o.borderWidth ? o.borderWidth : a(n.borderWidth, r, e.borderWidth)
                        },
                        setHoverStyle: function(t) {
                            var e = this.chart.data.datasets[t._datasetIndex],
                                n = t._index,
                                r = t.custom || {},
                                o = i.valueAtIndexOrDefault,
                                a = i.getHoverColor,
                                s = t._model;
                            s.backgroundColor = r.hoverBackgroundColor ? r.hoverBackgroundColor : o(e.hoverBackgroundColor, n, a(s.backgroundColor)), s.borderColor = r.hoverBorderColor ? r.hoverBorderColor : o(e.hoverBorderColor, n, a(s.borderColor)), s.borderWidth = r.hoverBorderWidth ? r.hoverBorderWidth : o(e.hoverBorderWidth, n, s.borderWidth)
                        },
                        resyncElements: function() {
                            var t = this,
                                e = t.getMeta(),
                                n = t.getDataset().data,
                                i = e.data.length,
                                r = n.length;
                            r < i ? e.data.splice(r, i - r) : r > i && t.insertElements(i, r - i)
                        },
                        insertElements: function(t, e) { for (var n = 0; n < e; ++n) this.addElementAndReset(t + n) },
                        onDataPush: function() { this.insertElements(this.getDataset().data.length - 1, arguments.length) },
                        onDataPop: function() { this.getMeta().data.pop() },
                        onDataShift: function() { this.getMeta().data.shift() },
                        onDataSplice: function(t, e) { this.getMeta().data.splice(t, e), this.insertElements(t, arguments.length - 2) },
                        onDataUnshift: function() { this.insertElements(0, arguments.length) }
                    }), t.DatasetController.extend = i.inherits
                }
            }, { 45: 45 }],
            25: [function(t, e, n) {
                "use strict";
                var i = t(45);
                e.exports = { _set: function(t, e) { return i.merge(this[t] || (this[t] = {}), e) } }
            }, { 45: 45 }],
            26: [function(t, e, n) {
                "use strict";

                function i(t, e, n, i) {
                    var o, a, s, l, u, c, d, h, f, p = Object.keys(n);
                    for (o = 0, a = p.length; o < a; ++o)
                        if (s = p[o], c = n[s], e.hasOwnProperty(s) || (e[s] = c), l = e[s], l !== c && "_" !== s[0]) {
                            if (t.hasOwnProperty(s) || (t[s] = l), u = t[s], d = typeof c, d === typeof u)
                                if ("string" === d) { if (h = r(u), h.valid && (f = r(c), f.valid)) { e[s] = f.mix(h, i).rgbString(); continue } } else if ("number" === d && isFinite(u) && isFinite(c)) { e[s] = u + (c - u) * i; continue } e[s] = c
                        }
                }
                var r = t(3),
                    o = t(45),
                    a = function(t) { o.extend(this, t), this.initialize.apply(this, arguments) };
                o.extend(a.prototype, {
                    initialize: function() { this.hidden = !1 },
                    pivot: function() { var t = this; return t._view || (t._view = o.clone(t._model)), t._start = {}, t },
                    transition: function(t) {
                        var e = this,
                            n = e._model,
                            r = e._start,
                            o = e._view;
                        return n && 1 !== t ? (o || (o = e._view = {}), r || (r = e._start = {}), i(r, o, n, t), e) : (e._view = n, e._start = null, e)
                    },
                    tooltipPosition: function() { return { x: this._model.x, y: this._model.y } },
                    hasValue: function() { return o.isNumber(this._model.x) && o.isNumber(this._model.y) }
                }), a.extend = o.inherits, e.exports = a
            }, { 3: 3, 45: 45 }],
            27: [function(t, e, n) {
                "use strict";
                var i = t(3),
                    r = t(25),
                    o = t(45);
                e.exports = function(t) {
                    function e(t, e, n) { var i; return "string" == typeof t ? (i = parseInt(t, 10), t.indexOf("%") !== -1 && (i = i / 100 * e.parentNode[n])) : i = t, i }

                    function n(t) { return void 0 !== t && null !== t && "none" !== t }

                    function a(t, i, r) {
                        var o = document.defaultView,
                            a = t.parentNode,
                            s = o.getComputedStyle(t)[i],
                            l = o.getComputedStyle(a)[i],
                            u = n(s),
                            c = n(l),
                            d = Number.POSITIVE_INFINITY;
                        return u || c ? Math.min(u ? e(s, t, r) : d, c ? e(l, a, r) : d) : "none"
                    }
                    o.configMerge = function() {
                        return o.merge(o.clone(arguments[0]), [].slice.call(arguments, 1), {
                            merger: function(e, n, i, r) {
                                var a = n[e] || {},
                                    s = i[e];
                                "scales" === e ? n[e] = o.scaleMerge(a, s) : "scale" === e ? n[e] = o.merge(a, [t.scaleService.getScaleDefaults(s.type), s]) : o._merger(e, n, i, r)
                            }
                        })
                    }, o.scaleMerge = function() { return o.merge(o.clone(arguments[0]), [].slice.call(arguments, 1), { merger: function(e, n, i, r) { if ("xAxes" === e || "yAxes" === e) { var a, s, l, u = i[e].length; for (n[e] || (n[e] = []), a = 0; a < u; ++a) l = i[e][a], s = o.valueOrDefault(l.type, "xAxes" === e ? "category" : "linear"), a >= n[e].length && n[e].push({}), !n[e][a].type || l.type && l.type !== n[e][a].type ? o.merge(n[e][a], [t.scaleService.getScaleDefaults(s), l]) : o.merge(n[e][a], l) } else o._merger(e, n, i, r) } }) }, o.where = function(t, e) { if (o.isArray(t) && Array.prototype.filter) return t.filter(e); var n = []; return o.each(t, function(t) { e(t) && n.push(t) }), n }, o.findIndex = Array.prototype.findIndex ? function(t, e, n) { return t.findIndex(e, n) } : function(t, e, n) {
                        n = void 0 === n ? t : n;
                        for (var i = 0, r = t.length; i < r; ++i)
                            if (e.call(n, t[i], i, t)) return i;
                        return -1
                    }, o.findNextWhere = function(t, e, n) { o.isNullOrUndef(n) && (n = -1); for (var i = n + 1; i < t.length; i++) { var r = t[i]; if (e(r)) return r } }, o.findPreviousWhere = function(t, e, n) { o.isNullOrUndef(n) && (n = t.length); for (var i = n - 1; i >= 0; i--) { var r = t[i]; if (e(r)) return r } }, o.isNumber = function(t) { return !isNaN(parseFloat(t)) && isFinite(t) }, o.almostEquals = function(t, e, n) { return Math.abs(t - e) < n }, o.almostWhole = function(t, e) { var n = Math.round(t); return n - e < t && n + e > t }, o.max = function(t) { return t.reduce(function(t, e) { return isNaN(e) ? t : Math.max(t, e) }, Number.NEGATIVE_INFINITY) }, o.min = function(t) { return t.reduce(function(t, e) { return isNaN(e) ? t : Math.min(t, e) }, Number.POSITIVE_INFINITY) }, o.sign = Math.sign ? function(t) { return Math.sign(t) } : function(t) { return t = +t, 0 === t || isNaN(t) ? t : t > 0 ? 1 : -1 }, o.log10 = Math.log10 ? function(t) { return Math.log10(t) } : function(t) {
                        var e = Math.log(t) * Math.LOG10E,
                            n = Math.round(e),
                            i = t === Math.pow(10, n);
                        return i ? n : e
                    }, o.toRadians = function(t) { return t * (Math.PI / 180) }, o.toDegrees = function(t) { return t * (180 / Math.PI) }, o.getAngleFromPoint = function(t, e) {
                        var n = e.x - t.x,
                            i = e.y - t.y,
                            r = Math.sqrt(n * n + i * i),
                            o = Math.atan2(i, n);
                        return o < -.5 * Math.PI && (o += 2 * Math.PI), { angle: o, distance: r }
                    }, o.distanceBetweenPoints = function(t, e) { return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)) }, o.aliasPixel = function(t) { return t % 2 === 0 ? 0 : .5 }, o.splineCurve = function(t, e, n, i) {
                        var r = t.skip ? e : t,
                            o = e,
                            a = n.skip ? e : n,
                            s = Math.sqrt(Math.pow(o.x - r.x, 2) + Math.pow(o.y - r.y, 2)),
                            l = Math.sqrt(Math.pow(a.x - o.x, 2) + Math.pow(a.y - o.y, 2)),
                            u = s / (s + l),
                            c = l / (s + l);
                        u = isNaN(u) ? 0 : u, c = isNaN(c) ? 0 : c;
                        var d = i * u,
                            h = i * c;
                        return { previous: { x: o.x - d * (a.x - r.x), y: o.y - d * (a.y - r.y) }, next: { x: o.x + h * (a.x - r.x), y: o.y + h * (a.y - r.y) } }
                    }, o.EPSILON = Number.EPSILON || 1e-14, o.splineCurveMonotone = function(t) {
                        var e, n, i, r, a = (t || []).map(function(t) { return { model: t._model, deltaK: 0, mK: 0 } }),
                            s = a.length;
                        for (e = 0; e < s; ++e)
                            if (i = a[e], !i.model.skip) {
                                if (n = e > 0 ? a[e - 1] : null, r = e < s - 1 ? a[e + 1] : null, r && !r.model.skip) {
                                    var l = r.model.x - i.model.x;
                                    i.deltaK = 0 !== l ? (r.model.y - i.model.y) / l : 0
                                }!n || n.model.skip ? i.mK = i.deltaK : !r || r.model.skip ? i.mK = n.deltaK : this.sign(n.deltaK) !== this.sign(i.deltaK) ? i.mK = 0 : i.mK = (n.deltaK + i.deltaK) / 2
                            } var u, c, d, h;
                        for (e = 0; e < s - 1; ++e) i = a[e], r = a[e + 1], i.model.skip || r.model.skip || (o.almostEquals(i.deltaK, 0, this.EPSILON) ? i.mK = r.mK = 0 : (u = i.mK / i.deltaK, c = r.mK / i.deltaK, h = Math.pow(u, 2) + Math.pow(c, 2), h <= 9 || (d = 3 / Math.sqrt(h), i.mK = u * d * i.deltaK, r.mK = c * d * i.deltaK)));
                        var f;
                        for (e = 0; e < s; ++e) i = a[e], i.model.skip || (n = e > 0 ? a[e - 1] : null, r = e < s - 1 ? a[e + 1] : null, n && !n.model.skip && (f = (i.model.x - n.model.x) / 3, i.model.controlPointPreviousX = i.model.x - f, i.model.controlPointPreviousY = i.model.y - f * i.mK), r && !r.model.skip && (f = (r.model.x - i.model.x) / 3, i.model.controlPointNextX = i.model.x + f, i.model.controlPointNextY = i.model.y + f * i.mK))
                    }, o.nextItem = function(t, e, n) { return n ? e >= t.length - 1 ? t[0] : t[e + 1] : e >= t.length - 1 ? t[t.length - 1] : t[e + 1] }, o.previousItem = function(t, e, n) { return n ? e <= 0 ? t[t.length - 1] : t[e - 1] : e <= 0 ? t[0] : t[e - 1] }, o.niceNum = function(t, e) {
                        var n, i = Math.floor(o.log10(t)),
                            r = t / Math.pow(10, i);
                        return n = e ? r < 1.5 ? 1 : r < 3 ? 2 : r < 7 ? 5 : 10 : r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10, n * Math.pow(10, i)
                    }, o.requestAnimFrame = function() { return "undefined" == typeof window ? function(t) { t() } : window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(t) { return window.setTimeout(t, 1e3 / 60) } }(), o.getRelativePosition = function(t, e) {
                        var n, i, r = t.originalEvent || t,
                            a = t.currentTarget || t.srcElement,
                            s = a.getBoundingClientRect(),
                            l = r.touches;
                        l && l.length > 0 ? (n = l[0].clientX, i = l[0].clientY) : (n = r.clientX, i = r.clientY);
                        var u = parseFloat(o.getStyle(a, "padding-left")),
                            c = parseFloat(o.getStyle(a, "padding-top")),
                            d = parseFloat(o.getStyle(a, "padding-right")),
                            h = parseFloat(o.getStyle(a, "padding-bottom")),
                            f = s.right - s.left - u - d,
                            p = s.bottom - s.top - c - h;
                        return n = Math.round((n - s.left - u) / f * a.width / e.currentDevicePixelRatio), i = Math.round((i - s.top - c) / p * a.height / e.currentDevicePixelRatio), { x: n, y: i }
                    }, o.getConstraintWidth = function(t) { return a(t, "max-width", "clientWidth") }, o.getConstraintHeight = function(t) { return a(t, "max-height", "clientHeight") }, o.getMaximumWidth = function(t) {
                        var e = t.parentNode;
                        if (!e) return t.clientWidth;
                        var n = parseInt(o.getStyle(e, "padding-left"), 10),
                            i = parseInt(o.getStyle(e, "padding-right"), 10),
                            r = e.clientWidth - n - i,
                            a = o.getConstraintWidth(t);
                        return isNaN(a) ? r : Math.min(r, a)
                    }, o.getMaximumHeight = function(t) {
                        var e = t.parentNode;
                        if (!e) return t.clientHeight;
                        var n = parseInt(o.getStyle(e, "padding-top"), 10),
                            i = parseInt(o.getStyle(e, "padding-bottom"), 10),
                            r = e.clientHeight - n - i,
                            a = o.getConstraintHeight(t);
                        return isNaN(a) ? r : Math.min(r, a)
                    }, o.getStyle = function(t, e) { return t.currentStyle ? t.currentStyle[e] : document.defaultView.getComputedStyle(t, null).getPropertyValue(e) }, o.retinaScale = function(t, e) {
                        var n = t.currentDevicePixelRatio = e || window.devicePixelRatio || 1;
                        if (1 !== n) {
                            var i = t.canvas,
                                r = t.height,
                                o = t.width;
                            i.height = r * n, i.width = o * n, t.ctx.scale(n, n), i.style.height || i.style.width || (i.style.height = r + "px", i.style.width = o + "px")
                        }
                    }, o.fontString = function(t, e, n) { return e + " " + t + "px " + n }, o.longestText = function(t, e, n, i) {
                        i = i || {};
                        var r = i.data = i.data || {},
                            a = i.garbageCollect = i.garbageCollect || [];
                        i.font !== e && (r = i.data = {}, a = i.garbageCollect = [], i.font = e), t.font = e;
                        var s = 0;
                        o.each(n, function(e) { void 0 !== e && null !== e && o.isArray(e) !== !0 ? s = o.measureText(t, r, a, s, e) : o.isArray(e) && o.each(e, function(e) { void 0 === e || null === e || o.isArray(e) || (s = o.measureText(t, r, a, s, e)) }) });
                        var l = a.length / 2;
                        if (l > n.length) {
                            for (var u = 0; u < l; u++) delete r[a[u]];
                            a.splice(0, l)
                        }
                        return s
                    }, o.measureText = function(t, e, n, i, r) { var o = e[r]; return o || (o = e[r] = t.measureText(r).width, n.push(r)), o > i && (i = o), i }, o.numberOfLabelLines = function(t) { var e = 1; return o.each(t, function(t) { o.isArray(t) && t.length > e && (e = t.length) }), e }, o.color = i ? function(t) { return t instanceof CanvasGradient && (t = r.global.defaultColor), i(t) } : function(t) { return t }, o.getHoverColor = function(t) { return t instanceof CanvasPattern ? t : o.color(t).saturate(.5).darken(.1).rgbString() }
                }
            }, { 25: 25, 3: 3, 45: 45 }],
            28: [function(t, e, n) {
                "use strict";

                function i(t, e) { return t.native ? { x: t.x, y: t.y } : u.getRelativePosition(t, e) }

                function r(t, e) {
                    var n, i, r, o, a, s = t.data.datasets;
                    for (i = 0, o = s.length; i < o; ++i)
                        if (t.isDatasetVisible(i))
                            for (n = t.getDatasetMeta(i), r = 0, a = n.data.length; r < a; ++r) {
                                var l = n.data[r];
                                l._view.skip || e(l)
                            }
                }

                function o(t, e) { var n = []; return r(t, function(t) { t.inRange(e.x, e.y) && n.push(t) }), n }

                function a(t, e, n, i) {
                    var o = Number.POSITIVE_INFINITY,
                        a = [];
                    return r(t, function(t) {
                        if (!n || t.inRange(e.x, e.y)) {
                            var r = t.getCenterPoint(),
                                s = i(e, r);
                            s < o ? (a = [t], o = s) : s === o && a.push(t)
                        }
                    }), a
                }

                function s(t) {
                    var e = t.indexOf("x") !== -1,
                        n = t.indexOf("y") !== -1;
                    return function(t, i) {
                        var r = e ? Math.abs(t.x - i.x) : 0,
                            o = n ? Math.abs(t.y - i.y) : 0;
                        return Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2))
                    }
                }

                function l(t, e, n) {
                    var r = i(e, t);
                    n.axis = n.axis || "x";
                    var l = s(n.axis),
                        u = n.intersect ? o(t, r) : a(t, r, !1, l),
                        c = [];
                    return u.length ? (t.data.datasets.forEach(function(e, n) {
                        if (t.isDatasetVisible(n)) {
                            var i = t.getDatasetMeta(n),
                                r = i.data[u[0]._index];
                            r && !r._view.skip && c.push(r)
                        }
                    }), c) : []
                }
                var u = t(45);
                e.exports = {
                    modes: {
                        single: function(t, e) {
                            var n = i(e, t),
                                o = [];
                            return r(t, function(t) { if (t.inRange(n.x, n.y)) return o.push(t), o }), o.slice(0, 1)
                        },
                        label: l,
                        index: l,
                        dataset: function(t, e, n) {
                            var r = i(e, t);
                            n.axis = n.axis || "xy";
                            var l = s(n.axis),
                                u = n.intersect ? o(t, r) : a(t, r, !1, l);
                            return u.length > 0 && (u = t.getDatasetMeta(u[0]._datasetIndex).data), u
                        },
                        "x-axis": function(t, e) { return l(t, e, { intersect: !1 }) },
                        point: function(t, e) { var n = i(e, t); return o(t, n) },
                        nearest: function(t, e, n) {
                            var r = i(e, t);
                            n.axis = n.axis || "xy";
                            var o = s(n.axis),
                                l = a(t, r, n.intersect, o);
                            return l.length > 1 && l.sort(function(t, e) {
                                var n = t.getArea(),
                                    i = e.getArea(),
                                    r = n - i;
                                return 0 === r && (r = t._datasetIndex - e._datasetIndex), r
                            }), l.slice(0, 1)
                        },
                        x: function(t, e, n) {
                            var o = i(e, t),
                                a = [],
                                s = !1;
                            return r(t, function(t) { t.inXRange(o.x) && a.push(t), t.inRange(o.x, o.y) && (s = !0) }), n.intersect && !s && (a = []), a
                        },
                        y: function(t, e, n) {
                            var o = i(e, t),
                                a = [],
                                s = !1;
                            return r(t, function(t) { t.inYRange(o.y) && a.push(t), t.inRange(o.x, o.y) && (s = !0) }), n.intersect && !s && (a = []), a
                        }
                    }
                }
            }, { 45: 45 }],
            29: [function(t, e, n) {
                "use strict";
                var i = t(25);
                i._set("global", { responsive: !0, responsiveAnimationDuration: 0, maintainAspectRatio: !0, events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"], hover: { onHover: null, mode: "nearest", intersect: !0, animationDuration: 400 }, onClick: null, defaultColor: "rgba(0,0,0,0.1)", defaultFontColor: "#666", defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif", defaultFontSize: 12, defaultFontStyle: "normal", showLines: !0, elements: {}, layout: { padding: { top: 0, right: 0, bottom: 0, left: 0 } } }), e.exports = function() { var t = function(t, e) { return this.construct(t, e), this }; return t.Chart = t, t }
            }, { 25: 25 }],
            30: [function(t, e, n) {
                "use strict";

                function i(t, e) { return o.where(t, function(t) { return t.position === e }) }

                function r(t, e) {
                    t.forEach(function(t, e) { return t._tmpIndex_ = e, t }), t.sort(function(t, n) {
                        var i = e ? n : t,
                            r = e ? t : n;
                        return i.weight === r.weight ? i._tmpIndex_ - r._tmpIndex_ : i.weight - r.weight
                    }), t.forEach(function(t) { delete t._tmpIndex_ })
                }
                var o = t(45);
                e.exports = {
                    defaults: {},
                    addBox: function(t, e) { t.boxes || (t.boxes = []), e.fullWidth = e.fullWidth || !1, e.position = e.position || "top", e.weight = e.weight || 0, t.boxes.push(e) },
                    removeBox: function(t, e) {
                        var n = t.boxes ? t.boxes.indexOf(e) : -1;
                        n !== -1 && t.boxes.splice(n, 1)
                    },
                    configure: function(t, e, n) { for (var i, r = ["fullWidth", "position", "weight"], o = r.length, a = 0; a < o; ++a) i = r[a], n.hasOwnProperty(i) && (e[i] = n[i]) },
                    update: function(t, e, n) {
                        function a(t) {
                            var e, n = t.isHorizontal();
                            n ? (e = t.update(t.fullWidth ? w : M, C), A -= e.height) : (e = t.update(T, A), M -= e.width), E.push({ horizontal: n, minSize: e, box: t })
                        }

                        function s(t) {
                            var e = o.findNextWhere(E, function(e) { return e.box === t });
                            if (e)
                                if (t.isHorizontal()) {
                                    var n = { left: Math.max(O, P), right: Math.max(L, I), top: 0, bottom: 0 };
                                    t.update(t.fullWidth ? w : M, k / 2, n)
                                } else t.update(e.minSize.width, A)
                        }

                        function l(t) {
                            var e = o.findNextWhere(E, function(e) { return e.box === t }),
                                n = { left: 0, right: 0, top: $, bottom: N };
                            e && t.update(e.minSize.width, A, n)
                        }

                        function u(t) { t.isHorizontal() ? (t.left = t.fullWidth ? h : O, t.right = t.fullWidth ? e - f : O + M, t.top = W, t.bottom = W + t.height, W = t.bottom) : (t.left = B, t.right = B + t.width, t.top = $, t.bottom = $ + A, B = t.right) }
                        if (t) {
                            var c = t.options.layout || {},
                                d = o.options.toPadding(c.padding),
                                h = d.left,
                                f = d.right,
                                p = d.top,
                                g = d.bottom,
                                v = i(t.boxes, "left"),
                                m = i(t.boxes, "right"),
                                y = i(t.boxes, "top"),
                                b = i(t.boxes, "bottom"),
                                x = i(t.boxes, "chartArea");
                            r(v, !0), r(m, !1), r(y, !0), r(b, !1);
                            var w = e - h - f,
                                k = n - p - g,
                                S = w / 2,
                                _ = k / 2,
                                T = (e - S) / (v.length + m.length),
                                C = (n - _) / (y.length + b.length),
                                M = w,
                                A = k,
                                E = [];
                            o.each(v.concat(m, y, b), a);
                            var P = 0,
                                I = 0,
                                z = 0,
                                D = 0;
                            o.each(y.concat(b), function(t) {
                                if (t.getPadding) {
                                    var e = t.getPadding();
                                    P = Math.max(P, e.left), I = Math.max(I, e.right)
                                }
                            }), o.each(v.concat(m), function(t) {
                                if (t.getPadding) {
                                    var e = t.getPadding();
                                    z = Math.max(z, e.top), D = Math.max(D, e.bottom)
                                }
                            });
                            var O = h,
                                L = f,
                                $ = p,
                                N = g;
                            o.each(v.concat(m), s), o.each(v, function(t) { O += t.width }), o.each(m, function(t) { L += t.width }), o.each(y.concat(b), s), o.each(y, function(t) { $ += t.height }), o.each(b, function(t) { N += t.height }), o.each(v.concat(m), l), O = h, L = f, $ = p, N = g, o.each(v, function(t) { O += t.width }), o.each(m, function(t) { L += t.width }), o.each(y, function(t) { $ += t.height }), o.each(b, function(t) { N += t.height });
                            var R = Math.max(P - O, 0);
                            O += R, L += Math.max(I - L, 0);
                            var q = Math.max(z - $, 0);
                            $ += q, N += Math.max(D - N, 0);
                            var F = n - $ - N,
                                H = e - O - L;
                            H === M && F === A || (o.each(v, function(t) { t.height = F }), o.each(m, function(t) { t.height = F }), o.each(y, function(t) { t.fullWidth || (t.width = H) }), o.each(b, function(t) { t.fullWidth || (t.width = H) }), A = F, M = H);
                            var B = h + R,
                                W = p + q;
                            o.each(v.concat(y), u), B += M, W += A, o.each(m, u), o.each(b, u), t.chartArea = { left: O, top: $, right: O + M, bottom: $ + A }, o.each(x, function(e) { e.left = t.chartArea.left, e.top = t.chartArea.top, e.right = t.chartArea.right, e.bottom = t.chartArea.bottom, e.update(M, A) })
                        }
                    }
                }
            }, { 45: 45 }],
            31: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(45);
                i._set("global", { plugins: {} }), e.exports = {
                    _plugins: [],
                    _cacheId: 0,
                    register: function(t) {
                        var e = this._plugins;
                        [].concat(t).forEach(function(t) { e.indexOf(t) === -1 && e.push(t) }), this._cacheId++
                    },
                    unregister: function(t) {
                        var e = this._plugins;
                        [].concat(t).forEach(function(t) {
                            var n = e.indexOf(t);
                            n !== -1 && e.splice(n, 1)
                        }), this._cacheId++
                    },
                    clear: function() { this._plugins = [], this._cacheId++ },
                    count: function() { return this._plugins.length },
                    getAll: function() { return this._plugins },
                    notify: function(t, e, n) {
                        var i, r, o, a, s, l = this.descriptors(t),
                            u = l.length;
                        for (i = 0; i < u; ++i)
                            if (r = l[i], o = r.plugin, s = o[e], "function" == typeof s && (a = [t].concat(n || []), a.push(r.options), s.apply(o, a) === !1)) return !1;
                        return !0
                    },
                    descriptors: function(t) {
                        var e = t.$plugins || (t.$plugins = {});
                        if (e.id === this._cacheId) return e.descriptors;
                        var n = [],
                            o = [],
                            a = t && t.config || {},
                            s = a.options && a.options.plugins || {};
                        return this._plugins.concat(a.plugins || []).forEach(function(t) {
                            var e = n.indexOf(t);
                            if (e === -1) {
                                var a = t.id,
                                    l = s[a];
                                l !== !1 && (l === !0 && (l = r.clone(i.global.plugins[a])), n.push(t), o.push({ plugin: t, options: l || {} }))
                            }
                        }), e.descriptors = o, e.id = this._cacheId, o
                    },
                    _invalidate: function(t) { delete t.$plugins }
                }
            }, { 25: 25, 45: 45 }],
            32: [function(t, e, n) {
                "use strict";

                function i(t) { var e, n, i = []; for (e = 0, n = t.length; e < n; ++e) i.push(t[e].label); return i }

                function r(t, e, n) { var i = t.getPixelForTick(e); return n && (i -= 0 === e ? (t.getPixelForTick(1) - i) / 2 : (i - t.getPixelForTick(e - 1)) / 2), i }
                var o = t(25),
                    a = t(26),
                    s = t(45),
                    l = t(34);
                o._set("scale", { display: !0, position: "left", offset: !1, gridLines: { display: !0, color: "rgba(0, 0, 0, 0.1)", lineWidth: 1, drawBorder: !0, drawOnChartArea: !0, drawTicks: !0, tickMarkLength: 10, zeroLineWidth: 1, zeroLineColor: "rgba(0,0,0,0.25)", zeroLineBorderDash: [], zeroLineBorderDashOffset: 0, offsetGridLines: !1, borderDash: [], borderDashOffset: 0 }, scaleLabel: { display: !1, labelString: "", lineHeight: 1.2, padding: { top: 4, bottom: 4 } }, ticks: { beginAtZero: !1, minRotation: 0, maxRotation: 50, mirror: !1, padding: 0, reverse: !1, display: !0, autoSkip: !0, autoSkipPadding: 0, labelOffset: 0, callback: l.formatters.values, minor: {}, major: {} } }), e.exports = function(t) {
                    function e(t, e, n) { return s.isArray(e) ? s.longestText(t, n, e) : t.measureText(e).width }

                    function n(t) {
                        var e = s.valueOrDefault,
                            n = o.global,
                            i = e(t.fontSize, n.defaultFontSize),
                            r = e(t.fontStyle, n.defaultFontStyle),
                            a = e(t.fontFamily, n.defaultFontFamily);
                        return { size: i, style: r, family: a, font: s.fontString(i, r, a) }
                    }

                    function l(t) { return s.options.toLineHeight(s.valueOrDefault(t.lineHeight, 1.2), s.valueOrDefault(t.fontSize, o.global.defaultFontSize)) } t.Scale = a.extend({
                        getPadding: function() { var t = this; return { left: t.paddingLeft || 0, top: t.paddingTop || 0, right: t.paddingRight || 0, bottom: t.paddingBottom || 0 } },
                        getTicks: function() { return this._ticks },
                        mergeTicksOptions: function() {
                            var t = this.options.ticks;
                            t.minor === !1 && (t.minor = { display: !1 }), t.major === !1 && (t.major = { display: !1 });
                            for (var e in t) "major" !== e && "minor" !== e && ("undefined" == typeof t.minor[e] && (t.minor[e] = t[e]), "undefined" == typeof t.major[e] && (t.major[e] = t[e]))
                        },
                        beforeUpdate: function() { s.callback(this.options.beforeUpdate, [this]) },
                        update: function(t, e, n) { var i, r, o, a, l, u, c = this; for (c.beforeUpdate(), c.maxWidth = t, c.maxHeight = e, c.margins = s.extend({ left: 0, right: 0, top: 0, bottom: 0 }, n), c.longestTextCache = c.longestTextCache || {}, c.beforeSetDimensions(), c.setDimensions(), c.afterSetDimensions(), c.beforeDataLimits(), c.determineDataLimits(), c.afterDataLimits(), c.beforeBuildTicks(), l = c.buildTicks() || [], c.afterBuildTicks(), c.beforeTickToLabelConversion(), o = c.convertTicksToLabels(l) || c.ticks, c.afterTickToLabelConversion(), c.ticks = o, i = 0, r = o.length; i < r; ++i) a = o[i], u = l[i], u ? u.label = a : l.push(u = { label: a, major: !1 }); return c._ticks = l, c.beforeCalculateTickRotation(), c.calculateTickRotation(), c.afterCalculateTickRotation(), c.beforeFit(), c.fit(), c.afterFit(), c.afterUpdate(), c.minSize },
                        afterUpdate: function() { s.callback(this.options.afterUpdate, [this]) },
                        beforeSetDimensions: function() { s.callback(this.options.beforeSetDimensions, [this]) },
                        setDimensions: function() {
                            var t = this;
                            t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0
                        },
                        afterSetDimensions: function() { s.callback(this.options.afterSetDimensions, [this]) },
                        beforeDataLimits: function() { s.callback(this.options.beforeDataLimits, [this]) },
                        determineDataLimits: s.noop,
                        afterDataLimits: function() { s.callback(this.options.afterDataLimits, [this]) },
                        beforeBuildTicks: function() { s.callback(this.options.beforeBuildTicks, [this]) },
                        buildTicks: s.noop,
                        afterBuildTicks: function() { s.callback(this.options.afterBuildTicks, [this]) },
                        beforeTickToLabelConversion: function() { s.callback(this.options.beforeTickToLabelConversion, [this]) },
                        convertTicksToLabels: function() {
                            var t = this,
                                e = t.options.ticks;
                            t.ticks = t.ticks.map(e.userCallback || e.callback, this)
                        },
                        afterTickToLabelConversion: function() { s.callback(this.options.afterTickToLabelConversion, [this]) },
                        beforeCalculateTickRotation: function() { s.callback(this.options.beforeCalculateTickRotation, [this]) },
                        calculateTickRotation: function() {
                            var t = this,
                                e = t.ctx,
                                r = t.options.ticks,
                                o = i(t._ticks),
                                a = n(r);
                            e.font = a.font;
                            var l = r.minRotation || 0;
                            if (o.length && t.options.display && t.isHorizontal())
                                for (var u, c, d = s.longestText(e, a.font, o, t.longestTextCache), h = d, f = t.getPixelForTick(1) - t.getPixelForTick(0) - 6; h > f && l < r.maxRotation;) { var p = s.toRadians(l); if (u = Math.cos(p), c = Math.sin(p), c * d > t.maxHeight) { l--; break } l++, h = u * d } t.labelRotation = l
                        },
                        afterCalculateTickRotation: function() { s.callback(this.options.afterCalculateTickRotation, [this]) },
                        beforeFit: function() { s.callback(this.options.beforeFit, [this]) },
                        fit: function() {
                            var t = this,
                                r = t.minSize = { width: 0, height: 0 },
                                o = i(t._ticks),
                                a = t.options,
                                u = a.ticks,
                                c = a.scaleLabel,
                                d = a.gridLines,
                                h = a.display,
                                f = t.isHorizontal(),
                                p = n(u),
                                g = a.gridLines.tickMarkLength;
                            if (f ? r.width = t.isFullWidth() ? t.maxWidth - t.margins.left - t.margins.right : t.maxWidth : r.width = h && d.drawTicks ? g : 0, f ? r.height = h && d.drawTicks ? g : 0 : r.height = t.maxHeight, c.display && h) {
                                var v = l(c),
                                    m = s.options.toPadding(c.padding),
                                    y = v + m.height;
                                f ? r.height += y : r.width += y
                            }
                            if (u.display && h) {
                                var b = s.longestText(t.ctx, p.font, o, t.longestTextCache),
                                    x = s.numberOfLabelLines(o),
                                    w = .5 * p.size,
                                    k = t.options.ticks.padding;
                                if (f) {
                                    t.longestLabelWidth = b;
                                    var S = s.toRadians(t.labelRotation),
                                        _ = Math.cos(S),
                                        T = Math.sin(S),
                                        C = T * b + p.size * x + w * (x - 1) + w;
                                    r.height = Math.min(t.maxHeight, r.height + C + k), t.ctx.font = p.font;
                                    var M = e(t.ctx, o[0], p.font),
                                        A = e(t.ctx, o[o.length - 1], p.font);
                                    0 !== t.labelRotation ? (t.paddingLeft = "bottom" === a.position ? _ * M + 3 : _ * w + 3, t.paddingRight = "bottom" === a.position ? _ * w + 3 : _ * A + 3) : (t.paddingLeft = M / 2 + 3, t.paddingRight = A / 2 + 3)
                                } else u.mirror ? b = 0 : b += k + w, r.width = Math.min(t.maxWidth, r.width + b), t.paddingTop = p.size / 2, t.paddingBottom = p.size / 2
                            }
                            t.handleMargins(), t.width = r.width, t.height = r.height
                        },
                        handleMargins: function() {
                            var t = this;
                            t.margins && (t.paddingLeft = Math.max(t.paddingLeft - t.margins.left, 0), t.paddingTop = Math.max(t.paddingTop - t.margins.top, 0), t.paddingRight = Math.max(t.paddingRight - t.margins.right, 0), t.paddingBottom = Math.max(t.paddingBottom - t.margins.bottom, 0))
                        },
                        afterFit: function() { s.callback(this.options.afterFit, [this]) },
                        isHorizontal: function() { return "top" === this.options.position || "bottom" === this.options.position },
                        isFullWidth: function() { return this.options.fullWidth },
                        getRightValue: function(t) {
                            if (s.isNullOrUndef(t)) return NaN;
                            if ("number" == typeof t && !isFinite(t)) return NaN;
                            if (t)
                                if (this.isHorizontal()) { if (void 0 !== t.x) return this.getRightValue(t.x) } else if (void 0 !== t.y) return this.getRightValue(t.y);
                            return t
                        },
                        getLabelForIndex: s.noop,
                        getPixelForValue: s.noop,
                        getValueForPixel: s.noop,
                        getPixelForTick: function(t) {
                            var e = this,
                                n = e.options.offset;
                            if (e.isHorizontal()) {
                                var i = e.width - (e.paddingLeft + e.paddingRight),
                                    r = i / Math.max(e._ticks.length - (n ? 0 : 1), 1),
                                    o = r * t + e.paddingLeft;
                                n && (o += r / 2);
                                var a = e.left + Math.round(o);
                                return a += e.isFullWidth() ? e.margins.left : 0
                            }
                            var s = e.height - (e.paddingTop + e.paddingBottom);
                            return e.top + t * (s / (e._ticks.length - 1))
                        },
                        getPixelForDecimal: function(t) {
                            var e = this;
                            if (e.isHorizontal()) {
                                var n = e.width - (e.paddingLeft + e.paddingRight),
                                    i = n * t + e.paddingLeft,
                                    r = e.left + Math.round(i);
                                return r += e.isFullWidth() ? e.margins.left : 0
                            }
                            return e.top + t * e.height
                        },
                        getBasePixel: function() { return this.getPixelForValue(this.getBaseValue()) },
                        getBaseValue: function() {
                            var t = this,
                                e = t.min,
                                n = t.max;
                            return t.beginAtZero ? 0 : e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0
                        },
                        _autoSkip: function(t) {
                            var e, n, i, r, o, a = this,
                                l = a.isHorizontal(),
                                u = a.options.ticks.minor,
                                c = t.length,
                                d = s.toRadians(a.labelRotation),
                                h = Math.cos(d),
                                f = a.longestLabelWidth * h,
                                p = [];
                            for (u.maxTicksLimit && (o = u.maxTicksLimit), l && (e = !1, (f + u.autoSkipPadding) * c > a.width - (a.paddingLeft + a.paddingRight) && (e = 1 + Math.floor((f + u.autoSkipPadding) * c / (a.width - (a.paddingLeft + a.paddingRight)))), o && c > o && (e = Math.max(e, Math.floor(c / o)))), n = 0; n < c; n++) i = t[n], r = e > 1 && n % e > 0 || n % e === 0 && n + e >= c, r && n !== c - 1 && delete i.label, p.push(i);
                            return p
                        },
                        draw: function(t) {
                            var e = this,
                                i = e.options;
                            if (i.display) {
                                var a = e.ctx,
                                    u = o.global,
                                    c = i.ticks.minor,
                                    d = i.ticks.major || c,
                                    h = i.gridLines,
                                    f = i.scaleLabel,
                                    p = 0 !== e.labelRotation,
                                    g = e.isHorizontal(),
                                    v = c.autoSkip ? e._autoSkip(e.getTicks()) : e.getTicks(),
                                    m = s.valueOrDefault(c.fontColor, u.defaultFontColor),
                                    y = n(c),
                                    b = s.valueOrDefault(d.fontColor, u.defaultFontColor),
                                    x = n(d),
                                    w = h.drawTicks ? h.tickMarkLength : 0,
                                    k = s.valueOrDefault(f.fontColor, u.defaultFontColor),
                                    S = n(f),
                                    _ = s.options.toPadding(f.padding),
                                    T = s.toRadians(e.labelRotation),
                                    C = [],
                                    M = e.options.gridLines.lineWidth,
                                    A = "right" === i.position ? e.right : e.right - M - w,
                                    E = "right" === i.position ? e.right + w : e.right,
                                    P = "bottom" === i.position ? e.top + M : e.bottom - w - M,
                                    I = "bottom" === i.position ? e.top + M + w : e.bottom + M;
                                if (s.each(v, function(n, o) {
                                        if (!s.isNullOrUndef(n.label)) {
                                            var a, l, d, f, m = n.label;
                                            o === e.zeroLineIndex && i.offset === h.offsetGridLines ? (a = h.zeroLineWidth, l = h.zeroLineColor, d = h.zeroLineBorderDash, f = h.zeroLineBorderDashOffset) : (a = s.valueAtIndexOrDefault(h.lineWidth, o), l = s.valueAtIndexOrDefault(h.color, o), d = s.valueOrDefault(h.borderDash, u.borderDash), f = s.valueOrDefault(h.borderDashOffset, u.borderDashOffset));
                                            var y, b, x, k, S, _, z, D, O, L, $ = "middle",
                                                N = "middle",
                                                R = c.padding;
                                            if (g) {
                                                var q = w + R;
                                                "bottom" === i.position ? (N = p ? "middle" : "top", $ = p ? "right" : "center", L = e.top + q) : (N = p ? "middle" : "bottom", $ = p ? "left" : "center", L = e.bottom - q);
                                                var F = r(e, o, h.offsetGridLines && v.length > 1);
                                                F < e.left && (l = "rgba(0,0,0,0)"), F += s.aliasPixel(a), O = e.getPixelForTick(o) + c.labelOffset, y = x = S = z = F, b = P, k = I, _ = t.top, D = t.bottom + M
                                            } else {
                                                var H, B = "left" === i.position;
                                                c.mirror ? ($ = B ? "left" : "right", H = R) : ($ = B ? "right" : "left", H = w + R), O = B ? e.right - H : e.left + H;
                                                var W = r(e, o, h.offsetGridLines && v.length > 1);
                                                W < e.top && (l = "rgba(0,0,0,0)"), W += s.aliasPixel(a), L = e.getPixelForTick(o) + c.labelOffset, y = A, x = E, S = t.left, z = t.right + M, b = k = _ = D = W
                                            }
                                            C.push({ tx1: y, ty1: b, tx2: x, ty2: k, x1: S, y1: _, x2: z, y2: D, labelX: O, labelY: L, glWidth: a, glColor: l, glBorderDash: d, glBorderDashOffset: f, rotation: -1 * T, label: m, major: n.major, textBaseline: N, textAlign: $ })
                                        }
                                    }), s.each(C, function(t) {
                                        if (h.display && (a.save(), a.lineWidth = t.glWidth, a.strokeStyle = t.glColor, a.setLineDash && (a.setLineDash(t.glBorderDash), a.lineDashOffset = t.glBorderDashOffset), a.beginPath(), h.drawTicks && (a.moveTo(t.tx1, t.ty1), a.lineTo(t.tx2, t.ty2)), h.drawOnChartArea && (a.moveTo(t.x1, t.y1), a.lineTo(t.x2, t.y2)), a.stroke(), a.restore()), c.display) {
                                            a.save(), a.translate(t.labelX, t.labelY), a.rotate(t.rotation), a.font = t.major ? x.font : y.font, a.fillStyle = t.major ? b : m, a.textBaseline = t.textBaseline, a.textAlign = t.textAlign;
                                            var n = t.label;
                                            if (s.isArray(n))
                                                for (var i = n.length, r = 1.5 * y.size, o = e.isHorizontal() ? 0 : -r * (i - 1) / 2, l = 0; l < i; ++l) a.fillText("" + n[l], 0, o), o += r;
                                            else a.fillText(n, 0, 0);
                                            a.restore()
                                        }
                                    }), f.display) {
                                    var z, D, O = 0,
                                        L = l(f) / 2;
                                    if (g) z = e.left + (e.right - e.left) / 2, D = "bottom" === i.position ? e.bottom - L - _.bottom : e.top + L + _.top;
                                    else {
                                        var $ = "left" === i.position;
                                        z = $ ? e.left + L + _.top : e.right - L - _.top, D = e.top + (e.bottom - e.top) / 2, O = $ ? -.5 * Math.PI : .5 * Math.PI
                                    }
                                    a.save(), a.translate(z, D), a.rotate(O), a.textAlign = "center", a.textBaseline = "middle", a.fillStyle = k, a.font = S.font, a.fillText(f.labelString, 0, 0), a.restore()
                                }
                                if (h.drawBorder) {
                                    a.lineWidth = s.valueAtIndexOrDefault(h.lineWidth, 0), a.strokeStyle = s.valueAtIndexOrDefault(h.color, 0);
                                    var N = e.left,
                                        R = e.right + M,
                                        q = e.top,
                                        F = e.bottom + M,
                                        H = s.aliasPixel(a.lineWidth);
                                    g ? (q = F = "top" === i.position ? e.bottom : e.top, q += H, F += H) : (N = R = "left" === i.position ? e.right : e.left, N += H, R += H), a.beginPath(), a.moveTo(N, q), a.lineTo(R, F), a.stroke()
                                }
                            }
                        }
                    })
                }
            }, { 25: 25, 26: 26, 34: 34, 45: 45 }],
            33: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(45),
                    o = t(30);
                e.exports = function(t) {
                    t.scaleService = {
                        constructors: {},
                        defaults: {},
                        registerScaleType: function(t, e, n) { this.constructors[t] = e, this.defaults[t] = r.clone(n) },
                        getScaleConstructor: function(t) { return this.constructors.hasOwnProperty(t) ? this.constructors[t] : void 0 },
                        getScaleDefaults: function(t) { return this.defaults.hasOwnProperty(t) ? r.merge({}, [i.scale, this.defaults[t]]) : {} },
                        updateScaleDefaults: function(t, e) {
                            var n = this;
                            n.defaults.hasOwnProperty(t) && (n.defaults[t] = r.extend(n.defaults[t], e))
                        },
                        addScalesToLayout: function(t) { r.each(t.scales, function(e) { e.fullWidth = e.options.fullWidth, e.position = e.options.position, e.weight = e.options.weight, o.addBox(t, e) }) }
                    }
                }
            }, { 25: 25, 30: 30, 45: 45 }],
            34: [function(t, e, n) {
                "use strict";
                var i = t(45);
                e.exports = {
                    formatters: {
                        values: function(t) { return i.isArray(t) ? t : "" + t },
                        linear: function(t, e, n) {
                            var r = n.length > 3 ? n[2] - n[1] : n[1] - n[0];
                            Math.abs(r) > 1 && t !== Math.floor(t) && (r = t - Math.floor(t));
                            var o = i.log10(Math.abs(r)),
                                a = "";
                            if (0 !== t) {
                                var s = -1 * Math.floor(o);
                                s = Math.max(Math.min(s, 20), 0), a = t.toFixed(s)
                            } else a = "0";
                            return a
                        },
                        logarithmic: function(t, e, n) { var r = t / Math.pow(10, Math.floor(i.log10(t))); return 0 === t ? "0" : 1 === r || 2 === r || 5 === r || 0 === e || e === n.length - 1 ? t.toExponential() : "" }
                    }
                }
            }, { 45: 45 }],
            35: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(26),
                    o = t(45);
                i._set("global", {
                    tooltips: {
                        enabled: !0,
                        custom: null,
                        mode: "nearest",
                        position: "average",
                        intersect: !0,
                        backgroundColor: "rgba(0,0,0,0.8)",
                        titleFontStyle: "bold",
                        titleSpacing: 2,
                        titleMarginBottom: 6,
                        titleFontColor: "#fff",
                        titleAlign: "left",
                        bodySpacing: 2,
                        bodyFontColor: "#fff",
                        bodyAlign: "left",
                        footerFontStyle: "bold",
                        footerSpacing: 2,
                        footerMarginTop: 6,
                        footerFontColor: "#fff",
                        footerAlign: "left",
                        yPadding: 6,
                        xPadding: 6,
                        caretPadding: 2,
                        caretSize: 5,
                        cornerRadius: 6,
                        multiKeyBackground: "#fff",
                        displayColors: !0,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 0,
                        callbacks: {
                            beforeTitle: o.noop,
                            title: function(t, e) {
                                var n = "",
                                    i = e.labels,
                                    r = i ? i.length : 0;
                                if (t.length > 0) {
                                    var o = t[0];
                                    o.xLabel ? n = o.xLabel : r > 0 && o.index < r && (n = i[o.index])
                                }
                                return n
                            },
                            afterTitle: o.noop,
                            beforeBody: o.noop,
                            beforeLabel: o.noop,
                            label: function(t, e) { var n = e.datasets[t.datasetIndex].label || ""; return n && (n += ": "), n += t.yLabel },
                            labelColor: function(t, e) {
                                var n = e.getDatasetMeta(t.datasetIndex),
                                    i = n.data[t.index],
                                    r = i._view;
                                return { borderColor: r.borderColor, backgroundColor: r.backgroundColor }
                            },
                            labelTextColor: function() { return this._options.bodyFontColor },
                            afterLabel: o.noop,
                            afterBody: o.noop,
                            beforeFooter: o.noop,
                            footer: o.noop,
                            afterFooter: o.noop
                        }
                    }
                }), e.exports = function(t) {
                    function e(t, e) { var n = o.color(t); return n.alpha(e * n.alpha()).rgbaString() }

                    function n(t, e) { return e && (o.isArray(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t }

                    function a(t) {
                        var e = t._xScale,
                            n = t._yScale || t._scale,
                            i = t._index,
                            r = t._datasetIndex;
                        return { xLabel: e ? e.getLabelForIndex(i, r) : "", yLabel: n ? n.getLabelForIndex(i, r) : "", index: i, datasetIndex: r, x: t._model.x, y: t._model.y }
                    }

                    function s(t) {
                        var e = i.global,
                            n = o.valueOrDefault;
                        return { xPadding: t.xPadding, yPadding: t.yPadding, xAlign: t.xAlign, yAlign: t.yAlign, bodyFontColor: t.bodyFontColor, _bodyFontFamily: n(t.bodyFontFamily, e.defaultFontFamily), _bodyFontStyle: n(t.bodyFontStyle, e.defaultFontStyle), _bodyAlign: t.bodyAlign, bodyFontSize: n(t.bodyFontSize, e.defaultFontSize), bodySpacing: t.bodySpacing, titleFontColor: t.titleFontColor, _titleFontFamily: n(t.titleFontFamily, e.defaultFontFamily), _titleFontStyle: n(t.titleFontStyle, e.defaultFontStyle), titleFontSize: n(t.titleFontSize, e.defaultFontSize), _titleAlign: t.titleAlign, titleSpacing: t.titleSpacing, titleMarginBottom: t.titleMarginBottom, footerFontColor: t.footerFontColor, _footerFontFamily: n(t.footerFontFamily, e.defaultFontFamily), _footerFontStyle: n(t.footerFontStyle, e.defaultFontStyle), footerFontSize: n(t.footerFontSize, e.defaultFontSize), _footerAlign: t.footerAlign, footerSpacing: t.footerSpacing, footerMarginTop: t.footerMarginTop, caretSize: t.caretSize, cornerRadius: t.cornerRadius, backgroundColor: t.backgroundColor, opacity: 0, legendColorBackground: t.multiKeyBackground, displayColors: t.displayColors, borderColor: t.borderColor, borderWidth: t.borderWidth }
                    }

                    function l(t, e) {
                        var n = t._chart.ctx,
                            i = 2 * e.yPadding,
                            r = 0,
                            a = e.body,
                            s = a.reduce(function(t, e) { return t + e.before.length + e.lines.length + e.after.length }, 0);
                        s += e.beforeBody.length + e.afterBody.length;
                        var l = e.title.length,
                            u = e.footer.length,
                            c = e.titleFontSize,
                            d = e.bodyFontSize,
                            h = e.footerFontSize;
                        i += l * c, i += l ? (l - 1) * e.titleSpacing : 0, i += l ? e.titleMarginBottom : 0, i += s * d, i += s ? (s - 1) * e.bodySpacing : 0, i += u ? e.footerMarginTop : 0, i += u * h, i += u ? (u - 1) * e.footerSpacing : 0;
                        var f = 0,
                            p = function(t) { r = Math.max(r, n.measureText(t).width + f) };
                        return n.font = o.fontString(c, e._titleFontStyle, e._titleFontFamily), o.each(e.title, p), n.font = o.fontString(d, e._bodyFontStyle, e._bodyFontFamily), o.each(e.beforeBody.concat(e.afterBody), p), f = e.displayColors ? d + 2 : 0, o.each(a, function(t) { o.each(t.before, p), o.each(t.lines, p), o.each(t.after, p) }), f = 0, n.font = o.fontString(h, e._footerFontStyle, e._footerFontFamily), o.each(e.footer, p), r += 2 * e.xPadding, { width: r, height: i }
                    }

                    function u(t, e) {
                        var n = t._model,
                            i = t._chart,
                            r = t._chart.chartArea,
                            o = "center",
                            a = "center";
                        n.y < e.height ? a = "top" : n.y > i.height - e.height && (a = "bottom");
                        var s, l, u, c, d, h = (r.left + r.right) / 2,
                            f = (r.top + r.bottom) / 2;
                        "center" === a ? (s = function(t) { return t <= h }, l = function(t) { return t > h }) : (s = function(t) { return t <= e.width / 2 }, l = function(t) { return t >= i.width - e.width / 2 }), u = function(t) { return t + e.width + n.caretSize + n.caretPadding > i.width }, c = function(t) { return t - e.width - n.caretSize - n.caretPadding < 0 }, d = function(t) { return t <= f ? "top" : "bottom" }, s(n.x) ? (o = "left", u(n.x) && (o = "center", a = d(n.y))) : l(n.x) && (o = "right", c(n.x) && (o = "center", a = d(n.y)));
                        var p = t._options;
                        return { xAlign: p.xAlign ? p.xAlign : o, yAlign: p.yAlign ? p.yAlign : a }
                    }

                    function c(t, e, n, i) {
                        var r = t.x,
                            o = t.y,
                            a = t.caretSize,
                            s = t.caretPadding,
                            l = t.cornerRadius,
                            u = n.xAlign,
                            c = n.yAlign,
                            d = a + s,
                            h = l + s;
                        return "right" === u ? r -= e.width : "center" === u && (r -= e.width / 2, r + e.width > i.width && (r = i.width - e.width), r < 0 && (r = 0)), "top" === c ? o += d : o -= "bottom" === c ? e.height + d : e.height / 2, "center" === c ? "left" === u ? r += d : "right" === u && (r -= d) : "left" === u ? r -= h : "right" === u && (r += h), { x: r, y: o }
                    }
                    t.Tooltip = r.extend({
                        initialize: function() { this._model = s(this._options), this._lastActive = [] },
                        getTitle: function() {
                            var t = this,
                                e = t._options,
                                i = e.callbacks,
                                r = i.beforeTitle.apply(t, arguments),
                                o = i.title.apply(t, arguments),
                                a = i.afterTitle.apply(t, arguments),
                                s = [];
                            return s = n(s, r), s = n(s, o), s = n(s, a)
                        },
                        getBeforeBody: function() { var t = this._options.callbacks.beforeBody.apply(this, arguments); return o.isArray(t) ? t : void 0 !== t ? [t] : [] },
                        getBody: function(t, e) {
                            var i = this,
                                r = i._options.callbacks,
                                a = [];
                            return o.each(t, function(t) {
                                var o = { before: [], lines: [], after: [] };
                                n(o.before, r.beforeLabel.call(i, t, e)), n(o.lines, r.label.call(i, t, e)), n(o.after, r.afterLabel.call(i, t, e)), a.push(o)
                            }), a
                        },
                        getAfterBody: function() { var t = this._options.callbacks.afterBody.apply(this, arguments); return o.isArray(t) ? t : void 0 !== t ? [t] : [] },
                        getFooter: function() {
                            var t = this,
                                e = t._options.callbacks,
                                i = e.beforeFooter.apply(t, arguments),
                                r = e.footer.apply(t, arguments),
                                o = e.afterFooter.apply(t, arguments),
                                a = [];
                            return a = n(a, i), a = n(a, r), a = n(a, o)
                        },
                        update: function(e) {
                            var n, i, r = this,
                                d = r._options,
                                h = r._model,
                                f = r._model = s(d),
                                p = r._active,
                                g = r._data,
                                v = { xAlign: h.xAlign, yAlign: h.yAlign },
                                m = { x: h.x, y: h.y },
                                y = { width: h.width, height: h.height },
                                b = { x: h.caretX, y: h.caretY };
                            if (p.length) {
                                f.opacity = 1;
                                var x = [],
                                    w = [];
                                b = t.Tooltip.positioners[d.position].call(r, p, r._eventPosition);
                                var k = [];
                                for (n = 0, i = p.length; n < i; ++n) k.push(a(p[n]));
                                d.filter && (k = k.filter(function(t) { return d.filter(t, g) })), d.itemSort && (k = k.sort(function(t, e) { return d.itemSort(t, e, g) })), o.each(k, function(t) { x.push(d.callbacks.labelColor.call(r, t, r._chart)), w.push(d.callbacks.labelTextColor.call(r, t, r._chart)) }), f.title = r.getTitle(k, g), f.beforeBody = r.getBeforeBody(k, g), f.body = r.getBody(k, g), f.afterBody = r.getAfterBody(k, g), f.footer = r.getFooter(k, g), f.x = Math.round(b.x), f.y = Math.round(b.y), f.caretPadding = d.caretPadding, f.labelColors = x, f.labelTextColors = w, f.dataPoints = k, y = l(this, f), v = u(this, y), m = c(f, y, v, r._chart)
                            } else f.opacity = 0;
                            return f.xAlign = v.xAlign, f.yAlign = v.yAlign, f.x = m.x, f.y = m.y, f.width = y.width, f.height = y.height, f.caretX = b.x, f.caretY = b.y, r._model = f, e && d.custom && d.custom.call(r, f), r
                        },
                        drawCaret: function(t, e) {
                            var n = this._chart.ctx,
                                i = this._view,
                                r = this.getCaretPosition(t, e, i);
                            n.lineTo(r.x1, r.y1), n.lineTo(r.x2, r.y2), n.lineTo(r.x3, r.y3)
                        },
                        getCaretPosition: function(t, e, n) {
                            var i, r, o, a, s, l, u = n.caretSize,
                                c = n.cornerRadius,
                                d = n.xAlign,
                                h = n.yAlign,
                                f = t.x,
                                p = t.y,
                                g = e.width,
                                v = e.height;
                            if ("center" === h) s = p + v / 2, "left" === d ? (i = f, r = i - u, o = i, a = s + u, l = s - u) : (i = f + g, r = i + u, o = i, a = s - u, l = s + u);
                            else if ("left" === d ? (r = f + c + u, i = r - u, o = r + u) : "right" === d ? (r = f + g - c - u, i = r - u, o = r + u) : (r = n.caretX, i = r - u, o = r + u), "top" === h) a = p, s = a - u, l = a;
                            else {
                                a = p + v, s = a + u, l = a;
                                var m = o;
                                o = i, i = m
                            }
                            return { x1: i, x2: r, x3: o, y1: a, y2: s, y3: l }
                        },
                        drawTitle: function(t, n, i, r) {
                            var a = n.title;
                            if (a.length) {
                                i.textAlign = n._titleAlign, i.textBaseline = "top";
                                var s = n.titleFontSize,
                                    l = n.titleSpacing;
                                i.fillStyle = e(n.titleFontColor, r), i.font = o.fontString(s, n._titleFontStyle, n._titleFontFamily);
                                var u, c;
                                for (u = 0, c = a.length; u < c; ++u) i.fillText(a[u], t.x, t.y), t.y += s + l, u + 1 === a.length && (t.y += n.titleMarginBottom - l)
                            }
                        },
                        drawBody: function(t, n, i, r) {
                            var a = n.bodyFontSize,
                                s = n.bodySpacing,
                                l = n.body;
                            i.textAlign = n._bodyAlign, i.textBaseline = "top", i.font = o.fontString(a, n._bodyFontStyle, n._bodyFontFamily);
                            var u = 0,
                                c = function(e) { i.fillText(e, t.x + u, t.y), t.y += a + s };
                            i.fillStyle = e(n.bodyFontColor, r), o.each(n.beforeBody, c);
                            var d = n.displayColors;
                            u = d ? a + 2 : 0, o.each(l, function(s, l) {
                                var u = e(n.labelTextColors[l], r);
                                i.fillStyle = u, o.each(s.before, c), o.each(s.lines, function(o) { d && (i.fillStyle = e(n.legendColorBackground, r), i.fillRect(t.x, t.y, a, a), i.lineWidth = 1, i.strokeStyle = e(n.labelColors[l].borderColor, r), i.strokeRect(t.x, t.y, a, a), i.fillStyle = e(n.labelColors[l].backgroundColor, r), i.fillRect(t.x + 1, t.y + 1, a - 2, a - 2), i.fillStyle = u), c(o) }), o.each(s.after, c)
                            }), u = 0, o.each(n.afterBody, c), t.y -= s
                        },
                        drawFooter: function(t, n, i, r) {
                            var a = n.footer;
                            a.length && (t.y += n.footerMarginTop, i.textAlign = n._footerAlign, i.textBaseline = "top", i.fillStyle = e(n.footerFontColor, r), i.font = o.fontString(n.footerFontSize, n._footerFontStyle, n._footerFontFamily), o.each(a, function(e) { i.fillText(e, t.x, t.y), t.y += n.footerFontSize + n.footerSpacing }))
                        },
                        drawBackground: function(t, n, i, r, o) {
                            i.fillStyle = e(n.backgroundColor, o), i.strokeStyle = e(n.borderColor, o), i.lineWidth = n.borderWidth;
                            var a = n.xAlign,
                                s = n.yAlign,
                                l = t.x,
                                u = t.y,
                                c = r.width,
                                d = r.height,
                                h = n.cornerRadius;
                            i.beginPath(), i.moveTo(l + h, u), "top" === s && this.drawCaret(t, r), i.lineTo(l + c - h, u), i.quadraticCurveTo(l + c, u, l + c, u + h), "center" === s && "right" === a && this.drawCaret(t, r), i.lineTo(l + c, u + d - h), i.quadraticCurveTo(l + c, u + d, l + c - h, u + d), "bottom" === s && this.drawCaret(t, r), i.lineTo(l + h, u + d), i.quadraticCurveTo(l, u + d, l, u + d - h), "center" === s && "left" === a && this.drawCaret(t, r), i.lineTo(l, u + h), i.quadraticCurveTo(l, u, l + h, u), i.closePath(), i.fill(), n.borderWidth > 0 && i.stroke()
                        },
                        draw: function() {
                            var t = this._chart.ctx,
                                e = this._view;
                            if (0 !== e.opacity) {
                                var n = { width: e.width, height: e.height },
                                    i = { x: e.x, y: e.y },
                                    r = Math.abs(e.opacity < .001) ? 0 : e.opacity,
                                    o = e.title.length || e.beforeBody.length || e.body.length || e.afterBody.length || e.footer.length;
                                this._options.enabled && o && (this.drawBackground(i, e, t, n, r), i.x += e.xPadding, i.y += e.yPadding, this.drawTitle(i, e, t, r), this.drawBody(i, e, t, r), this.drawFooter(i, e, t, r))
                            }
                        },
                        handleEvent: function(t) {
                            var e = this,
                                n = e._options,
                                i = !1;
                            return e._lastActive = e._lastActive || [], "mouseout" === t.type ? e._active = [] : e._active = e._chart.getElementsAtEventForMode(t, n.mode, n), i = !o.arrayEquals(e._active, e._lastActive), i && (e._lastActive = e._active, (n.enabled || n.custom) && (e._eventPosition = { x: t.x, y: t.y }, e.update(!0), e.pivot())), i
                        }
                    }), t.Tooltip.positioners = {
                        average: function(t) {
                            if (!t.length) return !1;
                            var e, n, i = 0,
                                r = 0,
                                o = 0;
                            for (e = 0, n = t.length; e < n; ++e) {
                                var a = t[e];
                                if (a && a.hasValue()) {
                                    var s = a.tooltipPosition();
                                    i += s.x, r += s.y, ++o
                                }
                            }
                            return { x: Math.round(i / o), y: Math.round(r / o) }
                        },
                        nearest: function(t, e) {
                            var n, i, r, a = e.x,
                                s = e.y,
                                l = Number.POSITIVE_INFINITY;
                            for (n = 0, i = t.length; n < i; ++n) {
                                var u = t[n];
                                if (u && u.hasValue()) {
                                    var c = u.getCenterPoint(),
                                        d = o.distanceBetweenPoints(e, c);
                                    d < l && (l = d, r = u)
                                }
                            }
                            if (r) {
                                var h = r.tooltipPosition();
                                a = h.x, s = h.y
                            }
                            return { x: a, y: s }
                        }
                    }
                }
            }, { 25: 25, 26: 26, 45: 45 }],
            36: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(26),
                    o = t(45);
                i._set("global", { elements: { arc: { backgroundColor: i.global.defaultColor, borderColor: "#fff", borderWidth: 2 } } }), e.exports = r.extend({
                    inLabelRange: function(t) { var e = this._view; return !!e && Math.pow(t - e.x, 2) < Math.pow(e.radius + e.hoverRadius, 2) },
                    inRange: function(t, e) {
                        var n = this._view;
                        if (n) {
                            for (var i = o.getAngleFromPoint(n, { x: t, y: e }), r = i.angle, a = i.distance, s = n.startAngle, l = n.endAngle; l < s;) l += 2 * Math.PI;
                            for (; r > l;) r -= 2 * Math.PI;
                            for (; r < s;) r += 2 * Math.PI;
                            var u = r >= s && r <= l,
                                c = a >= n.innerRadius && a <= n.outerRadius;
                            return u && c
                        }
                        return !1
                    },
                    getCenterPoint: function() {
                        var t = this._view,
                            e = (t.startAngle + t.endAngle) / 2,
                            n = (t.innerRadius + t.outerRadius) / 2;
                        return { x: t.x + Math.cos(e) * n, y: t.y + Math.sin(e) * n }
                    },
                    getArea: function() { var t = this._view; return Math.PI * ((t.endAngle - t.startAngle) / (2 * Math.PI)) * (Math.pow(t.outerRadius, 2) - Math.pow(t.innerRadius, 2)) },
                    tooltipPosition: function() {
                        var t = this._view,
                            e = t.startAngle + (t.endAngle - t.startAngle) / 2,
                            n = (t.outerRadius - t.innerRadius) / 2 + t.innerRadius;
                        return { x: t.x + Math.cos(e) * n, y: t.y + Math.sin(e) * n }
                    },
                    draw: function() {
                        var t = this._chart.ctx,
                            e = this._view,
                            n = e.startAngle,
                            i = e.endAngle;
                        t.beginPath(), t.arc(e.x, e.y, e.outerRadius, n, i), t.arc(e.x, e.y, e.innerRadius, i, n, !0), t.closePath(), t.strokeStyle = e.borderColor, t.lineWidth = e.borderWidth, t.fillStyle = e.backgroundColor, t.fill(), t.lineJoin = "bevel", e.borderWidth && t.stroke()
                    }
                })
            }, { 25: 25, 26: 26, 45: 45 }],
            37: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(26),
                    o = t(45),
                    a = i.global;
                i._set("global", { elements: { line: { tension: .4, backgroundColor: a.defaultColor, borderWidth: 3, borderColor: a.defaultColor, borderCapStyle: "butt", borderDash: [], borderDashOffset: 0, borderJoinStyle: "miter", capBezierPoints: !0, fill: !0 } } }), e.exports = r.extend({
                    draw: function() {
                        var t, e, n, i, r = this,
                            s = r._view,
                            l = r._chart.ctx,
                            u = s.spanGaps,
                            c = r._children.slice(),
                            d = a.elements.line,
                            h = -1;
                        for (r._loop && c.length && c.push(c[0]), l.save(), l.lineCap = s.borderCapStyle || d.borderCapStyle, l.setLineDash && l.setLineDash(s.borderDash || d.borderDash), l.lineDashOffset = s.borderDashOffset || d.borderDashOffset, l.lineJoin = s.borderJoinStyle || d.borderJoinStyle, l.lineWidth = s.borderWidth || d.borderWidth, l.strokeStyle = s.borderColor || a.defaultColor, l.beginPath(), h = -1, t = 0; t < c.length; ++t) e = c[t], n = o.previousItem(c, t), i = e._view, 0 === t ? i.skip || (l.moveTo(i.x, i.y), h = t) : (n = h === -1 ? n : c[h], i.skip || (h !== t - 1 && !u || h === -1 ? l.moveTo(i.x, i.y) : o.canvas.lineTo(l, n._view, e._view), h = t));
                        l.stroke(), l.restore()
                    }
                })
            }, { 25: 25, 26: 26, 45: 45 }],
            38: [function(t, e, n) {
                "use strict";

                function i(t) { var e = this._view; return !!e && Math.abs(t - e.x) < e.radius + e.hitRadius }

                function r(t) { var e = this._view; return !!e && Math.abs(t - e.y) < e.radius + e.hitRadius }
                var o = t(25),
                    a = t(26),
                    s = t(45),
                    l = o.global.defaultColor;
                o._set("global", { elements: { point: { radius: 3, pointStyle: "circle", backgroundColor: l, borderColor: l, borderWidth: 1, hitRadius: 1, hoverRadius: 4, hoverBorderWidth: 1 } } }), e.exports = a.extend({
                    inRange: function(t, e) { var n = this._view; return !!n && Math.pow(t - n.x, 2) + Math.pow(e - n.y, 2) < Math.pow(n.hitRadius + n.radius, 2) },
                    inLabelRange: i,
                    inXRange: i,
                    inYRange: r,
                    getCenterPoint: function() { var t = this._view; return { x: t.x, y: t.y } },
                    getArea: function() { return Math.PI * Math.pow(this._view.radius, 2) },
                    tooltipPosition: function() { var t = this._view; return { x: t.x, y: t.y, padding: t.radius + t.borderWidth } },
                    draw: function(t) {
                        var e = this._view,
                            n = this._model,
                            i = this._chart.ctx,
                            r = e.pointStyle,
                            a = e.radius,
                            u = e.x,
                            c = e.y,
                            d = s.color,
                            h = 1.01,
                            f = 0;
                        e.skip || (i.strokeStyle = e.borderColor || l, i.lineWidth = s.valueOrDefault(e.borderWidth, o.global.elements.point.borderWidth), i.fillStyle = e.backgroundColor || l, void 0 !== t && (n.x < t.left || t.right * h < n.x || n.y < t.top || t.bottom * h < n.y) && (n.x < t.left ? f = (u - n.x) / (t.left - n.x) : t.right * h < n.x ? f = (n.x - u) / (n.x - t.right) : n.y < t.top ? f = (c - n.y) / (t.top - n.y) : t.bottom * h < n.y && (f = (n.y - c) / (n.y - t.bottom)), f = Math.round(100 * f) / 100, i.strokeStyle = d(i.strokeStyle).alpha(f).rgbString(), i.fillStyle = d(i.fillStyle).alpha(f).rgbString()), s.canvas.drawPoint(i, r, a, u, c))
                    }
                })
            }, { 25: 25, 26: 26, 45: 45 }],
            39: [function(t, e, n) {
                "use strict";

                function i(t) { return void 0 !== t._view.width }

                function r(t) {
                    var e, n, r, o, a = t._view;
                    if (i(t)) {
                        var s = a.width / 2;
                        e = a.x - s, n = a.x + s, r = Math.min(a.y, a.base), o = Math.max(a.y, a.base)
                    } else {
                        var l = a.height / 2;
                        e = Math.min(a.x, a.base), n = Math.max(a.x, a.base), r = a.y - l, o = a.y + l
                    }
                    return { left: e, top: r, right: n, bottom: o }
                }
                var o = t(25),
                    a = t(26);
                o._set("global", { elements: { rectangle: { backgroundColor: o.global.defaultColor, borderColor: o.global.defaultColor, borderSkipped: "bottom", borderWidth: 0 } } }), e.exports = a.extend({
                    draw: function() {
                        function t(t) { return m[(b + t) % 4] }
                        var e, n, i, r, o, a, s, l = this._chart.ctx,
                            u = this._view,
                            c = u.borderWidth;
                        if (u.horizontal ? (e = u.base, n = u.x, i = u.y - u.height / 2, r = u.y + u.height / 2, o = n > e ? 1 : -1, a = 1, s = u.borderSkipped || "left") : (e = u.x - u.width / 2, n = u.x + u.width / 2, i = u.y, r = u.base, o = 1, a = r > i ? 1 : -1, s = u.borderSkipped || "bottom"), c) {
                            var d = Math.min(Math.abs(e - n), Math.abs(i - r));
                            c = c > d ? d : c;
                            var h = c / 2,
                                f = e + ("left" !== s ? h * o : 0),
                                p = n + ("right" !== s ? -h * o : 0),
                                g = i + ("top" !== s ? h * a : 0),
                                v = r + ("bottom" !== s ? -h * a : 0);
                            f !== p && (i = g, r = v), g !== v && (e = f, n = p)
                        }
                        l.beginPath(), l.fillStyle = u.backgroundColor, l.strokeStyle = u.borderColor, l.lineWidth = c;
                        var m = [
                                [e, r],
                                [e, i],
                                [n, i],
                                [n, r]
                            ],
                            y = ["bottom", "left", "top", "right"],
                            b = y.indexOf(s, 0);
                        b === -1 && (b = 0);
                        var x = t(0);
                        l.moveTo(x[0], x[1]);
                        for (var w = 1; w < 4; w++) x = t(w), l.lineTo(x[0], x[1]);
                        l.fill(), c && l.stroke()
                    },
                    height: function() { var t = this._view; return t.base - t.y },
                    inRange: function(t, e) {
                        var n = !1;
                        if (this._view) {
                            var i = r(this);
                            n = t >= i.left && t <= i.right && e >= i.top && e <= i.bottom
                        }
                        return n
                    },
                    inLabelRange: function(t, e) {
                        var n = this;
                        if (!n._view) return !1;
                        var o = !1,
                            a = r(n);
                        return o = i(n) ? t >= a.left && t <= a.right : e >= a.top && e <= a.bottom
                    },
                    inXRange: function(t) { var e = r(this); return t >= e.left && t <= e.right },
                    inYRange: function(t) { var e = r(this); return t >= e.top && t <= e.bottom },
                    getCenterPoint: function() { var t, e, n = this._view; return i(this) ? (t = n.x, e = (n.y + n.base) / 2) : (t = (n.x + n.base) / 2, e = n.y), { x: t, y: e } },
                    getArea: function() { var t = this._view; return t.width * Math.abs(t.y - t.base) },
                    tooltipPosition: function() { var t = this._view; return { x: t.x, y: t.y } }
                })
            }, { 25: 25, 26: 26 }],
            40: [function(t, e, n) {
                "use strict";
                e.exports = {}, e.exports.Arc = t(36), e.exports.Line = t(37), e.exports.Point = t(38), e.exports.Rectangle = t(39)
            }, { 36: 36, 37: 37, 38: 38, 39: 39 }],
            41: [function(t, e, n) {
                "use strict";
                var i = t(42),
                    n = e.exports = {
                        clear: function(t) { t.ctx.clearRect(0, 0, t.width, t.height) },
                        roundedRect: function(t, e, n, i, r, o) {
                            if (o) {
                                var a = Math.min(o, i / 2),
                                    s = Math.min(o, r / 2);
                                t.moveTo(e + a, n), t.lineTo(e + i - a, n), t.quadraticCurveTo(e + i, n, e + i, n + s), t.lineTo(e + i, n + r - s), t.quadraticCurveTo(e + i, n + r, e + i - a, n + r), t.lineTo(e + a, n + r), t.quadraticCurveTo(e, n + r, e, n + r - s), t.lineTo(e, n + s), t.quadraticCurveTo(e, n, e + a, n)
                            } else t.rect(e, n, i, r)
                        },
                        drawPoint: function(t, e, n, i, r) {
                            var o, a, s, l, u, c;
                            if (e && "object" == typeof e && (o = e.toString(), "[object HTMLImageElement]" === o || "[object HTMLCanvasElement]" === o)) return void t.drawImage(e, i - e.width / 2, r - e.height / 2, e.width, e.height);
                            if (!(isNaN(n) || n <= 0)) {
                                switch (e) {
                                    default:
                                        t.beginPath(), t.arc(i, r, n, 0, 2 * Math.PI), t.closePath(), t.fill();
                                        break;
                                    case "triangle":
                                        t.beginPath(), a = 3 * n / Math.sqrt(3), u = a * Math.sqrt(3) / 2, t.moveTo(i - a / 2, r + u / 3), t.lineTo(i + a / 2, r + u / 3), t.lineTo(i, r - 2 * u / 3), t.closePath(), t.fill();
                                        break;
                                    case "rect":
                                        c = 1 / Math.SQRT2 * n, t.beginPath(), t.fillRect(i - c, r - c, 2 * c, 2 * c), t.strokeRect(i - c, r - c, 2 * c, 2 * c);
                                        break;
                                    case "rectRounded":
                                        var d = n / Math.SQRT2,
                                            h = i - d,
                                            f = r - d,
                                            p = Math.SQRT2 * n;
                                        t.beginPath(), this.roundedRect(t, h, f, p, p, n / 2), t.closePath(), t.fill();
                                        break;
                                    case "rectRot":
                                        c = 1 / Math.SQRT2 * n, t.beginPath(), t.moveTo(i - c, r), t.lineTo(i, r + c), t.lineTo(i + c, r), t.lineTo(i, r - c), t.closePath(), t.fill();
                                        break;
                                    case "cross":
                                        t.beginPath(), t.moveTo(i, r + n), t.lineTo(i, r - n), t.moveTo(i - n, r), t.lineTo(i + n, r), t.closePath();
                                        break;
                                    case "crossRot":
                                        t.beginPath(), s = Math.cos(Math.PI / 4) * n, l = Math.sin(Math.PI / 4) * n, t.moveTo(i - s, r - l), t.lineTo(i + s, r + l), t.moveTo(i - s, r + l), t.lineTo(i + s, r - l), t.closePath();
                                        break;
                                    case "star":
                                        t.beginPath(), t.moveTo(i, r + n), t.lineTo(i, r - n), t.moveTo(i - n, r), t.lineTo(i + n, r), s = Math.cos(Math.PI / 4) * n, l = Math.sin(Math.PI / 4) * n, t.moveTo(i - s, r - l), t.lineTo(i + s, r + l), t.moveTo(i - s, r + l), t.lineTo(i + s, r - l), t.closePath();
                                        break;
                                    case "line":
                                        t.beginPath(), t.moveTo(i - n, r), t.lineTo(i + n, r), t.closePath();
                                        break;
                                    case "dash":
                                        t.beginPath(), t.moveTo(i, r), t.lineTo(i + n, r), t.closePath()
                                }
                                t.stroke()
                            }
                        },
                        clipArea: function(t, e) { t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip() },
                        unclipArea: function(t) { t.restore() },
                        lineTo: function(t, e, n, i) { return n.steppedLine ? ("after" === n.steppedLine && !i || "after" !== n.steppedLine && i ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y), void t.lineTo(n.x, n.y)) : n.tension ? void t.bezierCurveTo(i ? e.controlPointPreviousX : e.controlPointNextX, i ? e.controlPointPreviousY : e.controlPointNextY, i ? n.controlPointNextX : n.controlPointPreviousX, i ? n.controlPointNextY : n.controlPointPreviousY, n.x, n.y) : void t.lineTo(n.x, n.y) }
                    };
                i.clear = n.clear, i.drawRoundedRectangle = function(t) { t.beginPath(), n.roundedRect.apply(n, arguments), t.closePath() }
            }, { 42: 42 }],
            42: [function(t, e, n) {
                "use strict";
                var i = {
                    noop: function() {},
                    uid: function() { var t = 0; return function() { return t++ } }(),
                    isNullOrUndef: function(t) { return null === t || "undefined" == typeof t },
                    isArray: Array.isArray ? Array.isArray : function(t) { return "[object Array]" === Object.prototype.toString.call(t) },
                    isObject: function(t) { return null !== t && "[object Object]" === Object.prototype.toString.call(t) },
                    valueOrDefault: function(t, e) { return "undefined" == typeof t ? e : t },
                    valueAtIndexOrDefault: function(t, e, n) { return i.valueOrDefault(i.isArray(t) ? t[e] : t, n) },
                    callback: function(t, e, n) { if (t && "function" == typeof t.call) return t.apply(n, e) },
                    each: function(t, e, n, r) {
                        var o, a, s;
                        if (i.isArray(t))
                            if (a = t.length, r)
                                for (o = a - 1; o >= 0; o--) e.call(n, t[o], o);
                            else
                                for (o = 0; o < a; o++) e.call(n, t[o], o);
                        else if (i.isObject(t))
                            for (s = Object.keys(t), a = s.length, o = 0; o < a; o++) e.call(n, t[s[o]], s[o])
                    },
                    arrayEquals: function(t, e) {
                        var n, r, o, a;
                        if (!t || !e || t.length !== e.length) return !1;
                        for (n = 0, r = t.length; n < r; ++n)
                            if (o = t[n], a = e[n], o instanceof Array && a instanceof Array) { if (!i.arrayEquals(o, a)) return !1 } else if (o !== a) return !1;
                        return !0
                    },
                    clone: function(t) { if (i.isArray(t)) return t.map(i.clone); if (i.isObject(t)) { for (var e = {}, n = Object.keys(t), r = n.length, o = 0; o < r; ++o) e[n[o]] = i.clone(t[n[o]]); return e } return t },
                    _merger: function(t, e, n, r) {
                        var o = e[t],
                            a = n[t];
                        i.isObject(o) && i.isObject(a) ? i.merge(o, a, r) : e[t] = i.clone(a)
                    },
                    _mergerIf: function(t, e, n) {
                        var r = e[t],
                            o = n[t];
                        i.isObject(r) && i.isObject(o) ? i.mergeIf(r, o) : e.hasOwnProperty(t) || (e[t] = i.clone(o))
                    },
                    merge: function(t, e, n) {
                        var r, o, a, s, l, u = i.isArray(e) ? e : [e],
                            c = u.length;
                        if (!i.isObject(t)) return t;
                        for (n = n || {}, r = n.merger || i._merger, o = 0; o < c; ++o)
                            if (e = u[o], i.isObject(e))
                                for (a = Object.keys(e), l = 0, s = a.length; l < s; ++l) r(a[l], t, e, n);
                        return t
                    },
                    mergeIf: function(t, e) { return i.merge(t, e, { merger: i._mergerIf }) },
                    extend: function(t) { for (var e = function(e, n) { t[n] = e }, n = 1, r = arguments.length; n < r; ++n) i.each(arguments[n], e); return t },
                    inherits: function(t) {
                        var e = this,
                            n = t && t.hasOwnProperty("constructor") ? t.constructor : function() { return e.apply(this, arguments) },
                            r = function() { this.constructor = n };
                        return r.prototype = e.prototype, n.prototype = new r, n.extend = i.inherits, t && i.extend(n.prototype, t), n.__super__ = e.prototype, n
                    }
                };
                e.exports = i, i.callCallback = i.callback, i.indexOf = function(t, e, n) { return Array.prototype.indexOf.call(t, e, n) }, i.getValueOrDefault = i.valueOrDefault, i.getValueAtIndexOrDefault = i.valueAtIndexOrDefault
            }, {}],
            43: [function(t, e, n) {
                "use strict";
                var i = t(42),
                    r = {
                        linear: function(t) { return t },
                        easeInQuad: function(t) { return t * t },
                        easeOutQuad: function(t) { return -t * (t - 2) },
                        easeInOutQuad: function(t) { return (t /= .5) < 1 ? .5 * t * t : -.5 * (--t * (t - 2) - 1) },
                        easeInCubic: function(t) { return t * t * t },
                        easeOutCubic: function(t) { return (t -= 1) * t * t + 1 },
                        easeInOutCubic: function(t) { return (t /= .5) < 1 ? .5 * t * t * t : .5 * ((t -= 2) * t * t + 2) },
                        easeInQuart: function(t) { return t * t * t * t },
                        easeOutQuart: function(t) { return -((t -= 1) * t * t * t - 1) },
                        easeInOutQuart: function(t) { return (t /= .5) < 1 ? .5 * t * t * t * t : -.5 * ((t -= 2) * t * t * t - 2) },
                        easeInQuint: function(t) { return t * t * t * t * t },
                        easeOutQuint: function(t) { return (t -= 1) * t * t * t * t + 1 },
                        easeInOutQuint: function(t) { return (t /= .5) < 1 ? .5 * t * t * t * t * t : .5 * ((t -= 2) * t * t * t * t + 2) },
                        easeInSine: function(t) { return -Math.cos(t * (Math.PI / 2)) + 1 },
                        easeOutSine: function(t) { return Math.sin(t * (Math.PI / 2)) },
                        easeInOutSine: function(t) { return -.5 * (Math.cos(Math.PI * t) - 1) },
                        easeInExpo: function(t) { return 0 === t ? 0 : Math.pow(2, 10 * (t - 1)) },
                        easeOutExpo: function(t) { return 1 === t ? 1 : -Math.pow(2, -10 * t) + 1 },
                        easeInOutExpo: function(t) { return 0 === t ? 0 : 1 === t ? 1 : (t /= .5) < 1 ? .5 * Math.pow(2, 10 * (t - 1)) : .5 * (-Math.pow(2, -10 * --t) + 2) },
                        easeInCirc: function(t) { return t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1) },
                        easeOutCirc: function(t) { return Math.sqrt(1 - (t -= 1) * t) },
                        easeInOutCirc: function(t) { return (t /= .5) < 1 ? -.5 * (Math.sqrt(1 - t * t) - 1) : .5 * (Math.sqrt(1 - (t -= 2) * t) + 1) },
                        easeInElastic: function(t) {
                            var e = 1.70158,
                                n = 0,
                                i = 1;
                            return 0 === t ? 0 : 1 === t ? 1 : (n || (n = .3), i < 1 ? (i = 1, e = n / 4) : e = n / (2 * Math.PI) * Math.asin(1 / i), -(i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n)))
                        },
                        easeOutElastic: function(t) {
                            var e = 1.70158,
                                n = 0,
                                i = 1;
                            return 0 === t ? 0 : 1 === t ? 1 : (n || (n = .3), i < 1 ? (i = 1, e = n / 4) : e = n / (2 * Math.PI) * Math.asin(1 / i), i * Math.pow(2, -10 * t) * Math.sin((t - e) * (2 * Math.PI) / n) + 1)
                        },
                        easeInOutElastic: function(t) {
                            var e = 1.70158,
                                n = 0,
                                i = 1;
                            return 0 === t ? 0 : 2 === (t /= .5) ? 1 : (n || (n = .45), i < 1 ? (i = 1, e = n / 4) : e = n / (2 * Math.PI) * Math.asin(1 / i), t < 1 ? -.5 * (i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n)) : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - e) * (2 * Math.PI) / n) * .5 + 1)
                        },
                        easeInBack: function(t) { var e = 1.70158; return t * t * ((e + 1) * t - e) },
                        easeOutBack: function(t) { var e = 1.70158; return (t -= 1) * t * ((e + 1) * t + e) + 1 },
                        easeInOutBack: function(t) { var e = 1.70158; return (t /= .5) < 1 ? .5 * (t * t * (((e *= 1.525) + 1) * t - e)) : .5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2) },
                        easeInBounce: function(t) { return 1 - r.easeOutBounce(1 - t) },
                        easeOutBounce: function(t) { return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375 },
                        easeInOutBounce: function(t) { return t < .5 ? .5 * r.easeInBounce(2 * t) : .5 * r.easeOutBounce(2 * t - 1) + .5 }
                    };
                e.exports = { effects: r }, i.easingEffects = r
            }, { 42: 42 }],
            44: [function(t, e, n) {
                "use strict";
                var i = t(42);
                e.exports = {
                    toLineHeight: function(t, e) {
                        var n = ("" + t).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
                        if (!n || "normal" === n[1]) return 1.2 * e;
                        switch (t = +n[2], n[3]) {
                            case "px":
                                return t;
                            case "%":
                                t /= 100
                        }
                        return e * t
                    },
                    toPadding: function(t) { var e, n, r, o; return i.isObject(t) ? (e = +t.top || 0, n = +t.right || 0, r = +t.bottom || 0, o = +t.left || 0) : e = n = r = o = +t || 0, { top: e, right: n, bottom: r, left: o, height: e + r, width: o + n } },
                    resolve: function(t, e, n) {
                        var r, o, a;
                        for (r = 0, o = t.length; r < o; ++r)
                            if (a = t[r], void 0 !== a && (void 0 !== e && "function" == typeof a && (a = a(e)), void 0 !== n && i.isArray(a) && (a = a[n]), void 0 !== a)) return a
                    }
                }
            }, { 42: 42 }],
            45: [function(t, e, n) {
                "use strict";
                e.exports = t(42), e.exports.easing = t(43), e.exports.canvas = t(41), e.exports.options = t(44)
            }, { 41: 41, 42: 42, 43: 43, 44: 44 }],
            46: [function(t, e, n) { e.exports = { acquireContext: function(t) { return t && t.canvas && (t = t.canvas), t && t.getContext("2d") || null } } }, {}],
            47: [function(t, e, n) {
                "use strict";

                function i(t, e) {
                    var n = v.getStyle(t, e),
                        i = n && n.match(/^(\d+)(\.\d+)?px$/);
                    return i ? Number(i[1]) : void 0
                }

                function r(t, e) {
                    var n = t.style,
                        r = t.getAttribute("height"),
                        o = t.getAttribute("width");
                    if (t[m] = { initial: { height: r, width: o, style: { display: n.display, height: n.height, width: n.width } } }, n.display = n.display || "block", null === o || "" === o) {
                        var a = i(t, "width");
                        void 0 !== a && (t.width = a)
                    }
                    if (null === r || "" === r)
                        if ("" === t.style.height) t.height = t.width / (e.options.aspectRatio || 2);
                        else {
                            var s = i(t, "height");
                            void 0 !== a && (t.height = s)
                        } return t
                }

                function o(t, e, n) { t.addEventListener(e, n, _) }

                function a(t, e, n) { t.removeEventListener(e, n, _) }

                function s(t, e, n, i, r) { return { type: t, chart: e, "native": r || null, x: void 0 !== n ? n : null, y: void 0 !== i ? i : null } }

                function l(t, e) {
                    var n = k[t.type] || t.type,
                        i = v.getRelativePosition(t, e);
                    return s(n, e, i.x, i.y, t)
                }

                function u(t, e) {
                    var n = !1,
                        i = [];
                    return function() { i = Array.prototype.slice.call(arguments), e = e || this, n || (n = !0, v.requestAnimFrame.call(window, function() { n = !1, t.apply(e, i) })) }
                }

                function c(t) {
                    var e = document.createElement("div"),
                        n = y + "size-monitor",
                        i = 1e6,
                        r = "position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;";
                    e.style.cssText = r, e.className = n, e.innerHTML = '<div class="' + n + '-expand" style="' + r + '"><div style="position:absolute;width:' + i + "px;height:" + i + 'px;left:0;top:0"></div></div><div class="' + n + '-shrink" style="' + r + '"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div>';
                    var a = e.childNodes[0],
                        s = e.childNodes[1];
                    e._reset = function() { a.scrollLeft = i, a.scrollTop = i, s.scrollLeft = i, s.scrollTop = i };
                    var l = function() { e._reset(), t() };
                    return o(a, "scroll", l.bind(a, "expand")), o(s, "scroll", l.bind(s, "shrink")), e
                }

                function d(t, e) {
                    var n = t[m] || (t[m] = {}),
                        i = n.renderProxy = function(t) { t.animationName === x && e() };
                    v.each(w, function(e) { o(t, e, i) }), n.reflow = !!t.offsetParent, t.classList.add(b)
                }

                function h(t) {
                    var e = t[m] || {},
                        n = e.renderProxy;
                    n && (v.each(w, function(e) { a(t, e, n) }), delete e.renderProxy), t.classList.remove(b)
                }

                function f(t, e, n) {
                    var i = t[m] || (t[m] = {}),
                        r = i.resizer = c(u(function() { if (i.resizer) return e(s("resize", n)) }));
                    d(t, function() {
                        if (i.resizer) {
                            var e = t.parentNode;
                            e && e !== r.parentNode && e.insertBefore(r, e.firstChild), r._reset()
                        }
                    })
                }

                function p(t) {
                    var e = t[m] || {},
                        n = e.resizer;
                    delete e.resizer, h(t), n && n.parentNode && n.parentNode.removeChild(n)
                }

                function g(t, e) {
                    var n = t._style || document.createElement("style");
                    t._style || (t._style = n, e = "/* Chart.js */\n" + e, n.setAttribute("type", "text/css"), document.getElementsByTagName("head")[0].appendChild(n)), n.appendChild(document.createTextNode(e))
                }
                var v = t(45),
                    m = "$chartjs",
                    y = "chartjs-",
                    b = y + "render-monitor",
                    x = y + "render-animation",
                    w = ["animationstart", "webkitAnimationStart"],
                    k = { touchstart: "mousedown", touchmove: "mousemove", touchend: "mouseup", pointerenter: "mouseenter", pointerdown: "mousedown", pointermove: "mousemove", pointerup: "mouseup", pointerleave: "mouseout", pointerout: "mouseout" },
                    S = function() {
                        var t = !1;
                        try {
                            var e = Object.defineProperty({}, "passive", { get: function() { t = !0 } });
                            window.addEventListener("e", null, e)
                        } catch (n) {}
                        return t
                    }(),
                    _ = !!S && { passive: !0 };
                e.exports = {
                    _enabled: "undefined" != typeof window && "undefined" != typeof document,
                    initialize: function() {
                        var t = "from{opacity:0.99}to{opacity:1}";
                        g(this, "@-webkit-keyframes " + x + "{" + t + "}@keyframes " + x + "{" + t + "}." + b + "{-webkit-animation:" + x + " 0.001s;animation:" + x + " 0.001s;}")
                    },
                    acquireContext: function(t, e) { "string" == typeof t ? t = document.getElementById(t) : t.length && (t = t[0]), t && t.canvas && (t = t.canvas); var n = t && t.getContext && t.getContext("2d"); return n && n.canvas === t ? (r(t, e), n) : null },
                    releaseContext: function(t) {
                        var e = t.canvas;
                        if (e[m]) {
                            var n = e[m].initial;
                            ["height", "width"].forEach(function(t) {
                                var i = n[t];
                                v.isNullOrUndef(i) ? e.removeAttribute(t) : e.setAttribute(t, i)
                            }), v.each(n.style || {}, function(t, n) { e.style[n] = t }), e.width = e.width, delete e[m]
                        }
                    },
                    addEventListener: function(t, e, n) {
                        var i = t.canvas;
                        if ("resize" === e) return void f(i, n, t);
                        var r = n[m] || (n[m] = {}),
                            a = r.proxies || (r.proxies = {}),
                            s = a[t.id + "_" + e] = function(e) { n(l(e, t)) };
                        o(i, e, s)
                    },
                    removeEventListener: function(t, e, n) {
                        var i = t.canvas;
                        if ("resize" === e) return void p(i, n);
                        var r = n[m] || {},
                            o = r.proxies || {},
                            s = o[t.id + "_" + e];
                        s && a(i, e, s)
                    }
                }, v.addEvent = o, v.removeEvent = a
            }, { 45: 45 }],
            48: [function(t, e, n) {
                "use strict";
                var i = t(45),
                    r = t(46),
                    o = t(47),
                    a = o._enabled ? o : r;
                e.exports = i.extend({ initialize: function() {}, acquireContext: function() {}, releaseContext: function() {}, addEventListener: function() {}, removeEventListener: function() {} }, a)
            }, { 45: 45, 46: 46, 47: 47 }],
            49: [function(t, e, n) {
                "use strict";
                e.exports = {}, e.exports.filler = t(50), e.exports.legend = t(51), e.exports.title = t(52)
            }, { 50: 50, 51: 51, 52: 52 }],
            50: [function(t, e, n) {
                "use strict";

                function i(t, e, n) {
                    var i, r = t._model || {},
                        o = r.fill;
                    if (void 0 === o && (o = !!r.backgroundColor), o === !1 || null === o) return !1;
                    if (o === !0) return "origin";
                    if (i = parseFloat(o, 10), isFinite(i) && Math.floor(i) === i) return "-" !== o[0] && "+" !== o[0] || (i = e + i), !(i === e || i < 0 || i >= n) && i;
                    switch (o) {
                        case "bottom":
                            return "start";
                        case "top":
                            return "end";
                        case "zero":
                            return "origin";
                        case "origin":
                        case "start":
                        case "end":
                            return o;
                        default:
                            return !1
                    }
                }

                function r(t) {
                    var e, n = t.el._model || {},
                        i = t.el._scale || {},
                        r = t.fill,
                        o = null;
                    if (isFinite(r)) return null;
                    if ("start" === r ? o = void 0 === n.scaleBottom ? i.bottom : n.scaleBottom : "end" === r ? o = void 0 === n.scaleTop ? i.top : n.scaleTop : void 0 !== n.scaleZero ? o = n.scaleZero : i.getBasePosition ? o = i.getBasePosition() : i.getBasePixel && (o = i.getBasePixel()), void 0 !== o && null !== o) { if (void 0 !== o.x && void 0 !== o.y) return o; if ("number" == typeof o && isFinite(o)) return e = i.isHorizontal(), { x: e ? o : null, y: e ? null : o } }
                    return null
                }

                function o(t, e, n) {
                    var i, r = t[e],
                        o = r.fill,
                        a = [e];
                    if (!n) return o;
                    for (; o !== !1 && a.indexOf(o) === -1;) {
                        if (!isFinite(o)) return o;
                        if (i = t[o], !i) return !1;
                        if (i.visible) return o;
                        a.push(o), o = i.fill
                    }
                    return !1
                }

                function a(t) {
                    var e = t.fill,
                        n = "dataset";
                    return e === !1 ? null : (isFinite(e) || (n = "boundary"), f[n](t))
                }

                function s(t) { return t && !t.skip }

                function l(t, e, n, i, r) { var o; if (i && r) { for (t.moveTo(e[0].x, e[0].y), o = 1; o < i; ++o) h.canvas.lineTo(t, e[o - 1], e[o]); for (t.lineTo(n[r - 1].x, n[r - 1].y), o = r - 1; o > 0; --o) h.canvas.lineTo(t, n[o], n[o - 1], !0) } }

                function u(t, e, n, i, r, o) {
                    var a, u, c, d, h, f, p, g = e.length,
                        v = i.spanGaps,
                        m = [],
                        y = [],
                        b = 0,
                        x = 0;
                    for (t.beginPath(), a = 0, u = g + !!o; a < u; ++a) c = a % g, d = e[c]._view, h = n(d, c, i), f = s(d), p = s(h), f && p ? (b = m.push(d), x = y.push(h)) : b && x && (v ? (f && m.push(d), p && y.push(h)) : (l(t, m, y, b, x), b = x = 0, m = [], y = []));
                    l(t, m, y, b, x), t.closePath(), t.fillStyle = r, t.fill()
                }
                var c = t(25),
                    d = t(40),
                    h = t(45);
                c._set("global", { plugins: { filler: { propagate: !0 } } });
                var f = {
                    dataset: function(t) {
                        var e = t.fill,
                            n = t.chart,
                            i = n.getDatasetMeta(e),
                            r = i && n.isDatasetVisible(e),
                            o = r && i.dataset._children || [],
                            a = o.length || 0;
                        return a ? function(t, e) { return e < a && o[e]._view || null } : null
                    },
                    boundary: function(t) {
                        var e = t.boundary,
                            n = e ? e.x : null,
                            i = e ? e.y : null;
                        return function(t) { return { x: null === n ? t.x : n, y: null === i ? t.y : i } }
                    }
                };
                e.exports = {
                    id: "filler",
                    afterDatasetsUpdate: function(t, e) {
                        var n, s, l, u, c = (t.data.datasets || []).length,
                            h = e.propagate,
                            f = [];
                        for (s = 0; s < c; ++s) n = t.getDatasetMeta(s), l = n.dataset, u = null, l && l._model && l instanceof d.Line && (u = { visible: t.isDatasetVisible(s), fill: i(l, s, c), chart: t, el: l }), n.$filler = u, f.push(u);
                        for (s = 0; s < c; ++s) u = f[s], u && (u.fill = o(f, s, h), u.boundary = r(u), u.mapper = a(u))
                    },
                    beforeDatasetDraw: function(t, e) {
                        var n = e.meta.$filler;
                        if (n) {
                            var i = t.ctx,
                                r = n.el,
                                o = r._view,
                                a = r._children || [],
                                s = n.mapper,
                                l = o.backgroundColor || c.global.defaultColor;
                            s && l && a.length && (h.canvas.clipArea(i, t.chartArea), u(i, a, s, o, l, r._loop), h.canvas.unclipArea(i))
                        }
                    }
                }
            }, { 25: 25, 40: 40, 45: 45 }],
            51: [function(t, e, n) {
                "use strict";

                function i(t, e) { return t.usePointStyle ? e * Math.SQRT2 : t.boxWidth }

                function r(t, e) {
                    var n = new c({ ctx: t.ctx, options: e, chart: t });
                    l.configure(t, n, e), l.addBox(t, n), t.legend = n
                }
                var o = t(25),
                    a = t(26),
                    s = t(45),
                    l = t(30),
                    u = s.noop;
                o._set("global", {
                    legend: {
                        display: !0,
                        position: "top",
                        fullWidth: !0,
                        reverse: !1,
                        weight: 1e3,
                        onClick: function(t, e) {
                            var n = e.datasetIndex,
                                i = this.chart,
                                r = i.getDatasetMeta(n);
                            r.hidden = null === r.hidden ? !i.data.datasets[n].hidden : null, i.update()
                        },
                        onHover: null,
                        labels: { boxWidth: 40, padding: 10, generateLabels: function(t) { var e = t.data; return s.isArray(e.datasets) ? e.datasets.map(function(e, n) { return { text: e.label, fillStyle: s.isArray(e.backgroundColor) ? e.backgroundColor[0] : e.backgroundColor, hidden: !t.isDatasetVisible(n), lineCap: e.borderCapStyle, lineDash: e.borderDash, lineDashOffset: e.borderDashOffset, lineJoin: e.borderJoinStyle, lineWidth: e.borderWidth, strokeStyle: e.borderColor, pointStyle: e.pointStyle, datasetIndex: n } }, this) : [] } }
                    },
                    legendCallback: function(t) {
                        var e = [];
                        e.push('<ul class="' + t.id + '-legend">');
                        for (var n = 0; n < t.data.datasets.length; n++) e.push('<li><span style="background-color:' + t.data.datasets[n].backgroundColor + '"></span>'), t.data.datasets[n].label && e.push(t.data.datasets[n].label), e.push("</li>");
                        return e.push("</ul>"), e.join("")
                    }
                });
                var c = a.extend({
                    initialize: function(t) { s.extend(this, t), this.legendHitBoxes = [], this.doughnutMode = !1 },
                    beforeUpdate: u,
                    update: function(t, e, n) { var i = this; return i.beforeUpdate(), i.maxWidth = t, i.maxHeight = e, i.margins = n, i.beforeSetDimensions(), i.setDimensions(), i.afterSetDimensions(), i.beforeBuildLabels(), i.buildLabels(), i.afterBuildLabels(), i.beforeFit(), i.fit(), i.afterFit(), i.afterUpdate(), i.minSize },
                    afterUpdate: u,
                    beforeSetDimensions: u,
                    setDimensions: function() {
                        var t = this;
                        t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = { width: 0, height: 0 }
                    },
                    afterSetDimensions: u,
                    beforeBuildLabels: u,
                    buildLabels: function() {
                        var t = this,
                            e = t.options.labels || {},
                            n = s.callback(e.generateLabels, [t.chart], t) || [];
                        e.filter && (n = n.filter(function(n) { return e.filter(n, t.chart.data) })), t.options.reverse && n.reverse(), t.legendItems = n
                    },
                    afterBuildLabels: u,
                    beforeFit: u,
                    fit: function() {
                        var t = this,
                            e = t.options,
                            n = e.labels,
                            r = e.display,
                            a = t.ctx,
                            l = o.global,
                            u = s.valueOrDefault,
                            c = u(n.fontSize, l.defaultFontSize),
                            d = u(n.fontStyle, l.defaultFontStyle),
                            h = u(n.fontFamily, l.defaultFontFamily),
                            f = s.fontString(c, d, h),
                            p = t.legendHitBoxes = [],
                            g = t.minSize,
                            v = t.isHorizontal();
                        if (v ? (g.width = t.maxWidth, g.height = r ? 10 : 0) : (g.width = r ? 10 : 0, g.height = t.maxHeight), r)
                            if (a.font = f, v) {
                                var m = t.lineWidths = [0],
                                    y = t.legendItems.length ? c + n.padding : 0;
                                a.textAlign = "left", a.textBaseline = "top", s.each(t.legendItems, function(e, r) {
                                    var o = i(n, c),
                                        s = o + c / 2 + a.measureText(e.text).width;
                                    m[m.length - 1] + s + n.padding >= t.width && (y += c + n.padding, m[m.length] = t.left), p[r] = { left: 0, top: 0, width: s, height: c }, m[m.length - 1] += s + n.padding
                                }), g.height += y
                            } else {
                                var b = n.padding,
                                    x = t.columnWidths = [],
                                    w = n.padding,
                                    k = 0,
                                    S = 0,
                                    _ = c + b;
                                s.each(t.legendItems, function(t, e) {
                                    var r = i(n, c),
                                        o = r + c / 2 + a.measureText(t.text).width;
                                    S + _ > g.height && (w += k + n.padding, x.push(k), k = 0, S = 0), k = Math.max(k, o), S += _, p[e] = { left: 0, top: 0, width: o, height: c }
                                }), w += k, x.push(k), g.width += w
                            } t.width = g.width, t.height = g.height
                    },
                    afterFit: u,
                    isHorizontal: function() { return "top" === this.options.position || "bottom" === this.options.position },
                    draw: function() {
                        var t = this,
                            e = t.options,
                            n = e.labels,
                            r = o.global,
                            a = r.elements.line,
                            l = t.width,
                            u = t.lineWidths;
                        if (e.display) {
                            var c, d = t.ctx,
                                h = s.valueOrDefault,
                                f = h(n.fontColor, r.defaultFontColor),
                                p = h(n.fontSize, r.defaultFontSize),
                                g = h(n.fontStyle, r.defaultFontStyle),
                                v = h(n.fontFamily, r.defaultFontFamily),
                                m = s.fontString(p, g, v);
                            d.textAlign = "left", d.textBaseline = "middle", d.lineWidth = .5, d.strokeStyle = f, d.fillStyle = f, d.font = m;
                            var y = i(n, p),
                                b = t.legendHitBoxes,
                                x = function(t, n, i) {
                                    if (!(isNaN(y) || y <= 0)) {
                                        d.save(), d.fillStyle = h(i.fillStyle, r.defaultColor), d.lineCap = h(i.lineCap, a.borderCapStyle), d.lineDashOffset = h(i.lineDashOffset, a.borderDashOffset), d.lineJoin = h(i.lineJoin, a.borderJoinStyle), d.lineWidth = h(i.lineWidth, a.borderWidth), d.strokeStyle = h(i.strokeStyle, r.defaultColor);
                                        var o = 0 === h(i.lineWidth, a.borderWidth);
                                        if (d.setLineDash && d.setLineDash(h(i.lineDash, a.borderDash)), e.labels && e.labels.usePointStyle) {
                                            var l = p * Math.SQRT2 / 2,
                                                u = l / Math.SQRT2,
                                                c = t + u,
                                                f = n + u;
                                            s.canvas.drawPoint(d, i.pointStyle, l, c, f)
                                        } else o || d.strokeRect(t, n, y, p), d.fillRect(t, n, y, p);
                                        d.restore()
                                    }
                                },
                                w = function(t, e, n, i) {
                                    var r = p / 2,
                                        o = y + r + t,
                                        a = e + r;
                                    d.fillText(n.text, o, a), n.hidden && (d.beginPath(), d.lineWidth = 2, d.moveTo(o, a), d.lineTo(o + i, a), d.stroke())
                                },
                                k = t.isHorizontal();
                            c = k ? { x: t.left + (l - u[0]) / 2, y: t.top + n.padding, line: 0 } : { x: t.left + n.padding, y: t.top + n.padding, line: 0 };
                            var S = p + n.padding;
                            s.each(t.legendItems, function(e, i) {
                                var r = d.measureText(e.text).width,
                                    o = y + p / 2 + r,
                                    a = c.x,
                                    s = c.y;
                                k ? a + o >= l && (s = c.y += S, c.line++, a = c.x = t.left + (l - u[c.line]) / 2) : s + S > t.bottom && (a = c.x = a + t.columnWidths[c.line] + n.padding, s = c.y = t.top + n.padding, c.line++), x(a, s, e), b[i].left = a, b[i].top = s, w(a, s, e, r), k ? c.x += o + n.padding : c.y += S
                            })
                        }
                    },
                    handleEvent: function(t) {
                        var e = this,
                            n = e.options,
                            i = "mouseup" === t.type ? "click" : t.type,
                            r = !1;
                        if ("mousemove" === i) { if (!n.onHover) return } else { if ("click" !== i) return; if (!n.onClick) return }
                        var o = t.x,
                            a = t.y;
                        if (o >= e.left && o <= e.right && a >= e.top && a <= e.bottom)
                            for (var s = e.legendHitBoxes, l = 0; l < s.length; ++l) { var u = s[l]; if (o >= u.left && o <= u.left + u.width && a >= u.top && a <= u.top + u.height) { if ("click" === i) { n.onClick.call(e, t.native, e.legendItems[l]), r = !0; break } if ("mousemove" === i) { n.onHover.call(e, t.native, e.legendItems[l]), r = !0; break } } }
                        return r
                    }
                });
                e.exports = {
                    id: "legend",
                    _element: c,
                    beforeInit: function(t) {
                        var e = t.options.legend;
                        e && r(t, e)
                    },
                    beforeUpdate: function(t) {
                        var e = t.options.legend,
                            n = t.legend;
                        e ? (s.mergeIf(e, o.global.legend), n ? (l.configure(t, n, e), n.options = e) : r(t, e)) : n && (l.removeBox(t, n), delete t.legend)
                    },
                    afterEvent: function(t, e) {
                        var n = t.legend;
                        n && n.handleEvent(e)
                    }
                }
            }, { 25: 25, 26: 26, 30: 30, 45: 45 }],
            52: [function(t, e, n) {
                "use strict";

                function i(t, e) {
                    var n = new u({ ctx: t.ctx, options: e, chart: t });
                    s.configure(t, n, e), s.addBox(t, n), t.titleBlock = n
                }
                var r = t(25),
                    o = t(26),
                    a = t(45),
                    s = t(30),
                    l = a.noop;
                r._set("global", { title: { display: !1, fontStyle: "bold", fullWidth: !0, lineHeight: 1.2, padding: 10, position: "top", text: "", weight: 2e3 } });
                var u = o.extend({
                    initialize: function(t) {
                        var e = this;
                        a.extend(e, t), e.legendHitBoxes = []
                    },
                    beforeUpdate: l,
                    update: function(t, e, n) { var i = this; return i.beforeUpdate(), i.maxWidth = t, i.maxHeight = e, i.margins = n, i.beforeSetDimensions(), i.setDimensions(), i.afterSetDimensions(), i.beforeBuildLabels(), i.buildLabels(), i.afterBuildLabels(), i.beforeFit(), i.fit(), i.afterFit(), i.afterUpdate(), i.minSize },
                    afterUpdate: l,
                    beforeSetDimensions: l,
                    setDimensions: function() {
                        var t = this;
                        t.isHorizontal() ? (t.width = t.maxWidth, t.left = 0, t.right = t.width) : (t.height = t.maxHeight, t.top = 0, t.bottom = t.height), t.paddingLeft = 0, t.paddingTop = 0, t.paddingRight = 0, t.paddingBottom = 0, t.minSize = { width: 0, height: 0 }
                    },
                    afterSetDimensions: l,
                    beforeBuildLabels: l,
                    buildLabels: l,
                    afterBuildLabels: l,
                    beforeFit: l,
                    fit: function() {
                        var t = this,
                            e = a.valueOrDefault,
                            n = t.options,
                            i = n.display,
                            o = e(n.fontSize, r.global.defaultFontSize),
                            s = t.minSize,
                            l = a.isArray(n.text) ? n.text.length : 1,
                            u = a.options.toLineHeight(n.lineHeight, o),
                            c = i ? l * u + 2 * n.padding : 0;
                        t.isHorizontal() ? (s.width = t.maxWidth, s.height = c) : (s.width = c, s.height = t.maxHeight), t.width = s.width, t.height = s.height
                    },
                    afterFit: l,
                    isHorizontal: function() { var t = this.options.position; return "top" === t || "bottom" === t },
                    draw: function() {
                        var t = this,
                            e = t.ctx,
                            n = a.valueOrDefault,
                            i = t.options,
                            o = r.global;
                        if (i.display) {
                            var s, l, u, c = n(i.fontSize, o.defaultFontSize),
                                d = n(i.fontStyle, o.defaultFontStyle),
                                h = n(i.fontFamily, o.defaultFontFamily),
                                f = a.fontString(c, d, h),
                                p = a.options.toLineHeight(i.lineHeight, c),
                                g = p / 2 + i.padding,
                                v = 0,
                                m = t.top,
                                y = t.left,
                                b = t.bottom,
                                x = t.right;
                            e.fillStyle = n(i.fontColor, o.defaultFontColor), e.font = f, t.isHorizontal() ? (l = y + (x - y) / 2, u = m + g, s = x - y) : (l = "left" === i.position ? y + g : x - g, u = m + (b - m) / 2, s = b - m, v = Math.PI * ("left" === i.position ? -.5 : .5)), e.save(), e.translate(l, u), e.rotate(v), e.textAlign = "center", e.textBaseline = "middle";
                            var w = i.text;
                            if (a.isArray(w))
                                for (var k = 0, S = 0; S < w.length; ++S) e.fillText(w[S], 0, k, s), k += p;
                            else e.fillText(w, 0, 0, s);
                            e.restore()
                        }
                    }
                });
                e.exports = {
                    id: "title",
                    _element: u,
                    beforeInit: function(t) {
                        var e = t.options.title;
                        e && i(t, e)
                    },
                    beforeUpdate: function(t) {
                        var e = t.options.title,
                            n = t.titleBlock;
                        e ? (a.mergeIf(e, r.global.title), n ? (s.configure(t, n, e), n.options = e) : i(t, e)) : n && (s.removeBox(t, n), delete t.titleBlock)
                    }
                }
            }, { 25: 25, 26: 26, 30: 30, 45: 45 }],
            53: [function(t, e, n) {
                "use strict";
                e.exports = function(t) {
                    var e = { position: "bottom" },
                        n = t.Scale.extend({
                            getLabels: function() { var t = this.chart.data; return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels },
                            determineDataLimits: function() {
                                var t = this,
                                    e = t.getLabels();
                                t.minIndex = 0, t.maxIndex = e.length - 1;
                                var n;
                                void 0 !== t.options.ticks.min && (n = e.indexOf(t.options.ticks.min), t.minIndex = n !== -1 ? n : t.minIndex), void 0 !== t.options.ticks.max && (n = e.indexOf(t.options.ticks.max), t.maxIndex = n !== -1 ? n : t.maxIndex), t.min = e[t.minIndex], t.max = e[t.maxIndex]
                            },
                            buildTicks: function() {
                                var t = this,
                                    e = t.getLabels();
                                t.ticks = 0 === t.minIndex && t.maxIndex === e.length - 1 ? e : e.slice(t.minIndex, t.maxIndex + 1)
                            },
                            getLabelForIndex: function(t, e) {
                                var n = this,
                                    i = n.chart.data,
                                    r = n.isHorizontal();
                                return i.yLabels && !r ? n.getRightValue(i.datasets[e].data[t]) : n.ticks[t - n.minIndex]
                            },
                            getPixelForValue: function(t, e) {
                                var n, i = this,
                                    r = i.options.offset,
                                    o = Math.max(i.maxIndex + 1 - i.minIndex - (r ? 0 : 1), 1);
                                if (void 0 !== t && null !== t && (n = i.isHorizontal() ? t.x : t.y), void 0 !== n || void 0 !== t && isNaN(e)) {
                                    var a = i.getLabels();
                                    t = n || t;
                                    var s = a.indexOf(t);
                                    e = s !== -1 ? s : e
                                }
                                if (i.isHorizontal()) {
                                    var l = i.width / o,
                                        u = l * (e - i.minIndex);
                                    return r && (u += l / 2), i.left + Math.round(u)
                                }
                                var c = i.height / o,
                                    d = c * (e - i.minIndex);
                                return r && (d += c / 2), i.top + Math.round(d)
                            },
                            getPixelForTick: function(t) { return this.getPixelForValue(this.ticks[t], t + this.minIndex, null) },
                            getValueForPixel: function(t) {
                                var e, n = this,
                                    i = n.options.offset,
                                    r = Math.max(n._ticks.length - (i ? 0 : 1), 1),
                                    o = n.isHorizontal(),
                                    a = (o ? n.width : n.height) / r;
                                return t -= o ? n.left : n.top, i && (t -= a / 2), e = t <= 0 ? 0 : Math.round(t / a), e + n.minIndex
                            },
                            getBasePixel: function() { return this.bottom }
                        });
                    t.scaleService.registerScaleType("category", n, e)
                }
            }, {}],
            54: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(45),
                    o = t(34);
                e.exports = function(t) {
                    var e = { position: "left", ticks: { callback: o.formatters.linear } },
                        n = t.LinearScaleBase.extend({
                            determineDataLimits: function() {
                                function t(t) { return s ? t.xAxisID === e.id : t.yAxisID === e.id }
                                var e = this,
                                    n = e.options,
                                    i = e.chart,
                                    o = i.data,
                                    a = o.datasets,
                                    s = e.isHorizontal(),
                                    l = 0,
                                    u = 1;
                                e.min = null, e.max = null;
                                var c = n.stacked;
                                if (void 0 === c && r.each(a, function(e, n) {
                                        if (!c) {
                                            var r = i.getDatasetMeta(n);
                                            i.isDatasetVisible(n) && t(r) && void 0 !== r.stack && (c = !0)
                                        }
                                    }), n.stacked || c) {
                                    var d = {};
                                    r.each(a, function(o, a) {
                                        var s = i.getDatasetMeta(a),
                                            l = [s.type, void 0 === n.stacked && void 0 === s.stack ? a : "", s.stack].join(".");
                                        void 0 === d[l] && (d[l] = { positiveValues: [], negativeValues: [] });
                                        var u = d[l].positiveValues,
                                            c = d[l].negativeValues;
                                        i.isDatasetVisible(a) && t(s) && r.each(o.data, function(t, i) {
                                            var r = +e.getRightValue(t);
                                            isNaN(r) || s.data[i].hidden || (u[i] = u[i] || 0, c[i] = c[i] || 0, n.relativePoints ? u[i] = 100 : r < 0 ? c[i] += r : u[i] += r)
                                        })
                                    }), r.each(d, function(t) {
                                        var n = t.positiveValues.concat(t.negativeValues),
                                            i = r.min(n),
                                            o = r.max(n);
                                        e.min = null === e.min ? i : Math.min(e.min, i), e.max = null === e.max ? o : Math.max(e.max, o)
                                    })
                                } else r.each(a, function(n, o) {
                                    var a = i.getDatasetMeta(o);
                                    i.isDatasetVisible(o) && t(a) && r.each(n.data, function(t, n) {
                                        var i = +e.getRightValue(t);
                                        isNaN(i) || a.data[n].hidden || (null === e.min ? e.min = i : i < e.min && (e.min = i), null === e.max ? e.max = i : i > e.max && (e.max = i))
                                    })
                                });
                                e.min = isFinite(e.min) && !isNaN(e.min) ? e.min : l, e.max = isFinite(e.max) && !isNaN(e.max) ? e.max : u, this.handleTickRangeOptions()
                            },
                            getTickLimit: function() {
                                var t, e = this,
                                    n = e.options.ticks;
                                if (e.isHorizontal()) t = Math.min(n.maxTicksLimit ? n.maxTicksLimit : 11, Math.ceil(e.width / 50));
                                else {
                                    var o = r.valueOrDefault(n.fontSize, i.global.defaultFontSize);
                                    t = Math.min(n.maxTicksLimit ? n.maxTicksLimit : 11, Math.ceil(e.height / (2 * o)))
                                }
                                return t
                            },
                            handleDirectionalChanges: function() { this.isHorizontal() || this.ticks.reverse() },
                            getLabelForIndex: function(t, e) { return +this.getRightValue(this.chart.data.datasets[e].data[t]) },
                            getPixelForValue: function(t) {
                                var e, n = this,
                                    i = n.start,
                                    r = +n.getRightValue(t),
                                    o = n.end - i;
                                return e = n.isHorizontal() ? n.left + n.width / o * (r - i) : n.bottom - n.height / o * (r - i)
                            },
                            getValueForPixel: function(t) {
                                var e = this,
                                    n = e.isHorizontal(),
                                    i = n ? e.width : e.height,
                                    r = (n ? t - e.left : e.bottom - t) / i;
                                return e.start + (e.end - e.start) * r
                            },
                            getPixelForTick: function(t) { return this.getPixelForValue(this.ticksAsNumbers[t]) }
                        });
                    t.scaleService.registerScaleType("linear", n, e)
                }
            }, { 25: 25, 34: 34, 45: 45 }],
            55: [function(t, e, n) {
                "use strict";

                function i(t, e) {
                    var n, i = [];
                    if (t.stepSize && t.stepSize > 0) n = t.stepSize;
                    else {
                        var o = r.niceNum(e.max - e.min, !1);
                        n = r.niceNum(o / (t.maxTicks - 1), !0)
                    }
                    var a = Math.floor(e.min / n) * n,
                        s = Math.ceil(e.max / n) * n;
                    t.min && t.max && t.stepSize && r.almostWhole((t.max - t.min) / t.stepSize, n / 1e3) && (a = t.min, s = t.max);
                    var l = (s - a) / n;
                    l = r.almostEquals(l, Math.round(l), n / 1e3) ? Math.round(l) : Math.ceil(l);
                    var u = 1;
                    n < 1 && (u = Math.pow(10, n.toString().length - 2), a = Math.round(a * u) / u, s = Math.round(s * u) / u), i.push(void 0 !== t.min ? t.min : a);
                    for (var c = 1; c < l; ++c) i.push(Math.round((a + c * n) * u) / u);
                    return i.push(void 0 !== t.max ? t.max : s), i
                }
                var r = t(45);
                e.exports = function(t) {
                    var e = r.noop;
                    t.LinearScaleBase = t.Scale.extend({
                        getRightValue: function(e) { return "string" == typeof e ? +e : t.Scale.prototype.getRightValue.call(this, e) },
                        handleTickRangeOptions: function() {
                            var t = this,
                                e = t.options,
                                n = e.ticks;
                            if (n.beginAtZero) {
                                var i = r.sign(t.min),
                                    o = r.sign(t.max);
                                i < 0 && o < 0 ? t.max = 0 : i > 0 && o > 0 && (t.min = 0)
                            }
                            var a = void 0 !== n.min || void 0 !== n.suggestedMin,
                                s = void 0 !== n.max || void 0 !== n.suggestedMax;
                            void 0 !== n.min ? t.min = n.min : void 0 !== n.suggestedMin && (null === t.min ? t.min = n.suggestedMin : t.min = Math.min(t.min, n.suggestedMin)), void 0 !== n.max ? t.max = n.max : void 0 !== n.suggestedMax && (null === t.max ? t.max = n.suggestedMax : t.max = Math.max(t.max, n.suggestedMax)), a !== s && t.min >= t.max && (a ? t.max = t.min + 1 : t.min = t.max - 1), t.min === t.max && (t.max++, n.beginAtZero || t.min--)
                        },
                        getTickLimit: e,
                        handleDirectionalChanges: e,
                        buildTicks: function() {
                            var t = this,
                                e = t.options,
                                n = e.ticks,
                                o = t.getTickLimit();
                            o = Math.max(2, o);
                            var a = { maxTicks: o, min: n.min, max: n.max, stepSize: r.valueOrDefault(n.fixedStepSize, n.stepSize) },
                                s = t.ticks = i(a, t);
                            t.handleDirectionalChanges(), t.max = r.max(s), t.min = r.min(s), n.reverse ? (s.reverse(), t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max)
                        },
                        convertTicksToLabels: function() {
                            var e = this;
                            e.ticksAsNumbers = e.ticks.slice(), e.zeroLineIndex = e.ticks.indexOf(0), t.Scale.prototype.convertTicksToLabels.call(e)
                        }
                    })
                }
            }, { 45: 45 }],
            56: [function(t, e, n) {
                "use strict";

                function i(t, e) {
                    var n, i, o = [],
                        a = r.valueOrDefault,
                        s = a(t.min, Math.pow(10, Math.floor(r.log10(e.min)))),
                        l = Math.floor(r.log10(e.max)),
                        u = Math.ceil(e.max / Math.pow(10, l));
                    0 === s ? (n = Math.floor(r.log10(e.minNotZero)), i = Math.floor(e.minNotZero / Math.pow(10, n)), o.push(s), s = i * Math.pow(10, n)) : (n = Math.floor(r.log10(s)), i = Math.floor(s / Math.pow(10, n)));
                    var c = n < 0 ? Math.pow(10, Math.abs(n)) : 1;
                    do o.push(s), ++i, 10 === i && (i = 1, ++n, c = n >= 0 ? 1 : c), s = Math.round(i * Math.pow(10, n) * c) / c; while (n < l || n === l && i < u);
                    var d = a(t.max, s);
                    return o.push(d), o
                }
                var r = t(45),
                    o = t(34);
                e.exports = function(t) {
                    var e = { position: "left", ticks: { callback: o.formatters.logarithmic } },
                        n = t.Scale.extend({
                            determineDataLimits: function() {
                                function t(t) { return s ? t.xAxisID === e.id : t.yAxisID === e.id }
                                var e = this,
                                    n = e.options,
                                    i = e.chart,
                                    o = i.data,
                                    a = o.datasets,
                                    s = e.isHorizontal();
                                e.min = null, e.max = null, e.minNotZero = null;
                                var l = n.stacked;
                                if (void 0 === l && r.each(a, function(e, n) {
                                        if (!l) {
                                            var r = i.getDatasetMeta(n);
                                            i.isDatasetVisible(n) && t(r) && void 0 !== r.stack && (l = !0)
                                        }
                                    }), n.stacked || l) {
                                    var u = {};
                                    r.each(a, function(o, a) {
                                        var s = i.getDatasetMeta(a),
                                            l = [s.type, void 0 === n.stacked && void 0 === s.stack ? a : "", s.stack].join(".");
                                        i.isDatasetVisible(a) && t(s) && (void 0 === u[l] && (u[l] = []), r.each(o.data, function(t, n) {
                                            var i = u[l],
                                                r = +e.getRightValue(t);
                                            isNaN(r) || s.data[n].hidden || r < 0 || (i[n] = i[n] || 0, i[n] += r)
                                        }))
                                    }), r.each(u, function(t) {
                                        if (t.length > 0) {
                                            var n = r.min(t),
                                                i = r.max(t);
                                            e.min = null === e.min ? n : Math.min(e.min, n), e.max = null === e.max ? i : Math.max(e.max, i)
                                        }
                                    })
                                } else r.each(a, function(n, o) {
                                    var a = i.getDatasetMeta(o);
                                    i.isDatasetVisible(o) && t(a) && r.each(n.data, function(t, n) {
                                        var i = +e.getRightValue(t);
                                        isNaN(i) || a.data[n].hidden || i < 0 || (null === e.min ? e.min = i : i < e.min && (e.min = i), null === e.max ? e.max = i : i > e.max && (e.max = i), 0 !== i && (null === e.minNotZero || i < e.minNotZero) && (e.minNotZero = i))
                                    })
                                });
                                this.handleTickRangeOptions()
                            },
                            handleTickRangeOptions: function() {
                                var t = this,
                                    e = t.options,
                                    n = e.ticks,
                                    i = r.valueOrDefault,
                                    o = 1,
                                    a = 10;
                                t.min = i(n.min, t.min), t.max = i(n.max, t.max), t.min === t.max && (0 !== t.min && null !== t.min ? (t.min = Math.pow(10, Math.floor(r.log10(t.min)) - 1), t.max = Math.pow(10, Math.floor(r.log10(t.max)) + 1)) : (t.min = o, t.max = a)), null === t.min && (t.min = Math.pow(10, Math.floor(r.log10(t.max)) - 1)), null === t.max && (t.max = 0 !== t.min ? Math.pow(10, Math.floor(r.log10(t.min)) + 1) : a), null === t.minNotZero && (t.min > 0 ? t.minNotZero = t.min : t.max < 1 ? t.minNotZero = Math.pow(10, Math.floor(r.log10(t.max))) : t.minNotZero = o)
                            },
                            buildTicks: function() {
                                var t = this,
                                    e = t.options,
                                    n = e.ticks,
                                    o = !t.isHorizontal(),
                                    a = { min: n.min, max: n.max },
                                    s = t.ticks = i(a, t);
                                t.max = r.max(s), t.min = r.min(s), n.reverse ? (o = !o, t.start = t.max, t.end = t.min) : (t.start = t.min, t.end = t.max), o && s.reverse()
                            },
                            convertTicksToLabels: function() { this.tickValues = this.ticks.slice(), t.Scale.prototype.convertTicksToLabels.call(this) },
                            getLabelForIndex: function(t, e) { return +this.getRightValue(this.chart.data.datasets[e].data[t]) },
                            getPixelForTick: function(t) { return this.getPixelForValue(this.tickValues[t]) },
                            _getFirstTickValue: function(t) {
                                var e = Math.floor(r.log10(t)),
                                    n = Math.floor(t / Math.pow(10, e));
                                return n * Math.pow(10, e)
                            },
                            getPixelForValue: function(e) {
                                var n, i, o, a, s, l = this,
                                    u = l.options.ticks.reverse,
                                    c = r.log10,
                                    d = l._getFirstTickValue(l.minNotZero),
                                    h = 0;
                                return e = +l.getRightValue(e), u ? (o = l.end, a = l.start, s = -1) : (o = l.start, a = l.end, s = 1), l.isHorizontal() ? (n = l.width, i = u ? l.right : l.left) : (n = l.height, s *= -1, i = u ? l.top : l.bottom), e !== o && (0 === o && (h = r.getValueOrDefault(l.options.ticks.fontSize, t.defaults.global.defaultFontSize), n -= h, o = d), 0 !== e && (h += n / (c(a) - c(o)) * (c(e) - c(o))), i += s * h), i
                            },
                            getValueForPixel: function(e) {
                                var n, i, o, a, s = this,
                                    l = s.options.ticks.reverse,
                                    u = r.log10,
                                    c = s._getFirstTickValue(s.minNotZero);
                                if (l ? (i = s.end, o = s.start) : (i = s.start, o = s.end), s.isHorizontal() ? (n = s.width, a = l ? s.right - e : e - s.left) : (n = s.height, a = l ? e - s.top : s.bottom - e), a !== i) {
                                    if (0 === i) {
                                        var d = r.getValueOrDefault(s.options.ticks.fontSize, t.defaults.global.defaultFontSize);
                                        a -= d, n -= d, i = c
                                    }
                                    a *= u(o) - u(i), a /= n, a = Math.pow(10, u(i) + a)
                                }
                                return a
                            }
                        });
                    t.scaleService.registerScaleType("logarithmic", n, e)
                }
            }, { 34: 34, 45: 45 }],
            57: [function(t, e, n) {
                "use strict";
                var i = t(25),
                    r = t(45),
                    o = t(34);
                e.exports = function(t) {
                    function e(t) { var e = t.options; return e.angleLines.display || e.pointLabels.display ? t.chart.data.labels.length : 0 }

                    function n(t) {
                        var e = t.options.pointLabels,
                            n = r.valueOrDefault(e.fontSize, v.defaultFontSize),
                            i = r.valueOrDefault(e.fontStyle, v.defaultFontStyle),
                            o = r.valueOrDefault(e.fontFamily, v.defaultFontFamily),
                            a = r.fontString(n, i, o);
                        return { size: n, style: i, family: o, font: a }
                    }

                    function a(t, e, n) { return r.isArray(n) ? { w: r.longestText(t, t.font, n), h: n.length * e + 1.5 * (n.length - 1) * e } : { w: t.measureText(n).width, h: e } }

                    function s(t, e, n, i, r) { return t === i || t === r ? { start: e - n / 2, end: e + n / 2 } : t < i || t > r ? { start: e - n - 5, end: e } : { start: e, end: e + n + 5 } }

                    function l(t) {
                        var i, o, l, u = n(t),
                            c = Math.min(t.height / 2, t.width / 2),
                            d = { r: t.width, l: 0, t: t.height, b: 0 },
                            h = {};
                        t.ctx.font = u.font, t._pointLabelSizes = [];
                        var f = e(t);
                        for (i = 0; i < f; i++) {
                            l = t.getPointPosition(i, c), o = a(t.ctx, u.size, t.pointLabels[i] || ""), t._pointLabelSizes[i] = o;
                            var p = t.getIndexAngle(i),
                                g = r.toDegrees(p) % 360,
                                v = s(g, l.x, o.w, 0, 180),
                                m = s(g, l.y, o.h, 90, 270);
                            v.start < d.l && (d.l = v.start, h.l = p), v.end > d.r && (d.r = v.end, h.r = p), m.start < d.t && (d.t = m.start, h.t = p), m.end > d.b && (d.b = m.end, h.b = p)
                        }
                        t.setReductions(c, d, h)
                    }

                    function u(t) {
                        var e = Math.min(t.height / 2, t.width / 2);
                        t.drawingArea = Math.round(e), t.setCenterPoint(0, 0, 0, 0)
                    }

                    function c(t) { return 0 === t || 180 === t ? "center" : t < 180 ? "left" : "right" }

                    function d(t, e, n, i) {
                        if (r.isArray(e))
                            for (var o = n.y, a = 1.5 * i, s = 0; s < e.length; ++s) t.fillText(e[s], n.x, o), o += a;
                        else t.fillText(e, n.x, n.y)
                    }

                    function h(t, e, n) { 90 === t || 270 === t ? n.y -= e.h / 2 : (t > 270 || t < 90) && (n.y -= e.h) }

                    function f(t) {
                        var i = t.ctx,
                            o = t.options,
                            a = o.angleLines,
                            s = o.pointLabels;
                        i.lineWidth = a.lineWidth, i.strokeStyle = a.color;
                        var l = t.getDistanceFromCenterForValue(o.ticks.reverse ? t.min : t.max),
                            u = n(t);
                        i.textBaseline = "top";
                        for (var f = e(t) - 1; f >= 0; f--) {
                            if (a.display) {
                                var p = t.getPointPosition(f, l);
                                i.beginPath(), i.moveTo(t.xCenter, t.yCenter), i.lineTo(p.x, p.y), i.stroke(), i.closePath()
                            }
                            if (s.display) {
                                var g = t.getPointPosition(f, l + 5),
                                    m = r.valueAtIndexOrDefault(s.fontColor, f, v.defaultFontColor);
                                i.font = u.font, i.fillStyle = m;
                                var y = t.getIndexAngle(f),
                                    b = r.toDegrees(y);
                                i.textAlign = c(b), h(b, t._pointLabelSizes[f], g), d(i, t.pointLabels[f] || "", g, u.size)
                            }
                        }
                    }

                    function p(t, n, i, o) {
                        var a = t.ctx;
                        if (a.strokeStyle = r.valueAtIndexOrDefault(n.color, o - 1), a.lineWidth = r.valueAtIndexOrDefault(n.lineWidth, o - 1), t.options.gridLines.circular) a.beginPath(), a.arc(t.xCenter, t.yCenter, i, 0, 2 * Math.PI), a.closePath(), a.stroke();
                        else {
                            var s = e(t);
                            if (0 === s) return;
                            a.beginPath();
                            var l = t.getPointPosition(0, i);
                            a.moveTo(l.x, l.y);
                            for (var u = 1; u < s; u++) l = t.getPointPosition(u, i), a.lineTo(l.x, l.y);
                            a.closePath(), a.stroke()
                        }
                    }

                    function g(t) { return r.isNumber(t) ? t : 0 }
                    var v = i.global,
                        m = { display: !0, animate: !0, position: "chartArea", angleLines: { display: !0, color: "rgba(0, 0, 0, 0.1)", lineWidth: 1 }, gridLines: { circular: !1 }, ticks: { showLabelBackdrop: !0, backdropColor: "rgba(255,255,255,0.75)", backdropPaddingY: 2, backdropPaddingX: 2, callback: o.formatters.linear }, pointLabels: { display: !0, fontSize: 10, callback: function(t) { return t } } },
                        y = t.LinearScaleBase.extend({
                            setDimensions: function() {
                                var t = this,
                                    e = t.options,
                                    n = e.ticks;
                                t.width = t.maxWidth, t.height = t.maxHeight, t.xCenter = Math.round(t.width / 2), t.yCenter = Math.round(t.height / 2);
                                var i = r.min([t.height, t.width]),
                                    o = r.valueOrDefault(n.fontSize, v.defaultFontSize);
                                t.drawingArea = e.display ? i / 2 - (o / 2 + n.backdropPaddingY) : i / 2
                            },
                            determineDataLimits: function() {
                                var t = this,
                                    e = t.chart,
                                    n = Number.POSITIVE_INFINITY,
                                    i = Number.NEGATIVE_INFINITY;
                                r.each(e.data.datasets, function(o, a) {
                                    if (e.isDatasetVisible(a)) {
                                        var s = e.getDatasetMeta(a);
                                        r.each(o.data, function(e, r) {
                                            var o = +t.getRightValue(e);
                                            isNaN(o) || s.data[r].hidden || (n = Math.min(o, n), i = Math.max(o, i))
                                        })
                                    }
                                }), t.min = n === Number.POSITIVE_INFINITY ? 0 : n, t.max = i === Number.NEGATIVE_INFINITY ? 0 : i, t.handleTickRangeOptions()
                            },
                            getTickLimit: function() {
                                var t = this.options.ticks,
                                    e = r.valueOrDefault(t.fontSize, v.defaultFontSize);
                                return Math.min(t.maxTicksLimit ? t.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * e)))
                            },
                            convertTicksToLabels: function() {
                                var e = this;
                                t.LinearScaleBase.prototype.convertTicksToLabels.call(e), e.pointLabels = e.chart.data.labels.map(e.options.pointLabels.callback, e)
                            },
                            getLabelForIndex: function(t, e) { return +this.getRightValue(this.chart.data.datasets[e].data[t]) },
                            fit: function() { this.options.pointLabels.display ? l(this) : u(this) },
                            setReductions: function(t, e, n) {
                                var i = this,
                                    r = e.l / Math.sin(n.l),
                                    o = Math.max(e.r - i.width, 0) / Math.sin(n.r),
                                    a = -e.t / Math.cos(n.t),
                                    s = -Math.max(e.b - i.height, 0) / Math.cos(n.b);
                                r = g(r), o = g(o), a = g(a), s = g(s), i.drawingArea = Math.min(Math.round(t - (r + o) / 2), Math.round(t - (a + s) / 2)), i.setCenterPoint(r, o, a, s)
                            },
                            setCenterPoint: function(t, e, n, i) {
                                var r = this,
                                    o = r.width - e - r.drawingArea,
                                    a = t + r.drawingArea,
                                    s = n + r.drawingArea,
                                    l = r.height - i - r.drawingArea;
                                r.xCenter = Math.round((a + o) / 2 + r.left), r.yCenter = Math.round((s + l) / 2 + r.top)
                            },
                            getIndexAngle: function(t) {
                                var n = 2 * Math.PI / e(this),
                                    i = this.chart.options && this.chart.options.startAngle ? this.chart.options.startAngle : 0,
                                    r = i * Math.PI * 2 / 360;
                                return t * n + r
                            },
                            getDistanceFromCenterForValue: function(t) { var e = this; if (null === t) return 0; var n = e.drawingArea / (e.max - e.min); return e.options.ticks.reverse ? (e.max - t) * n : (t - e.min) * n },
                            getPointPosition: function(t, e) {
                                var n = this,
                                    i = n.getIndexAngle(t) - Math.PI / 2;
                                return { x: Math.round(Math.cos(i) * e) + n.xCenter, y: Math.round(Math.sin(i) * e) + n.yCenter }
                            },
                            getPointPositionForValue: function(t, e) { return this.getPointPosition(t, this.getDistanceFromCenterForValue(e)) },
                            getBasePosition: function() {
                                var t = this,
                                    e = t.min,
                                    n = t.max;
                                return t.getPointPositionForValue(0, t.beginAtZero ? 0 : e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0)
                            },
                            draw: function() {
                                var t = this,
                                    e = t.options,
                                    n = e.gridLines,
                                    i = e.ticks,
                                    o = r.valueOrDefault;
                                if (e.display) {
                                    var a = t.ctx,
                                        s = this.getIndexAngle(0),
                                        l = o(i.fontSize, v.defaultFontSize),
                                        u = o(i.fontStyle, v.defaultFontStyle),
                                        c = o(i.fontFamily, v.defaultFontFamily),
                                        d = r.fontString(l, u, c);
                                    r.each(t.ticks, function(e, r) {
                                        if (r > 0 || i.reverse) {
                                            var u = t.getDistanceFromCenterForValue(t.ticksAsNumbers[r]);
                                            if (n.display && 0 !== r && p(t, n, u, r), i.display) {
                                                var c = o(i.fontColor, v.defaultFontColor);
                                                if (a.font = d, a.save(), a.translate(t.xCenter, t.yCenter), a.rotate(s), i.showLabelBackdrop) {
                                                    var h = a.measureText(e).width;
                                                    a.fillStyle = i.backdropColor, a.fillRect(-h / 2 - i.backdropPaddingX, -u - l / 2 - i.backdropPaddingY, h + 2 * i.backdropPaddingX, l + 2 * i.backdropPaddingY)
                                                }
                                                a.textAlign = "center", a.textBaseline = "middle", a.fillStyle = c, a.fillText(e, 0, -u), a.restore()
                                            }
                                        }
                                    }), (e.angleLines.display || e.pointLabels.display) && f(t)
                                }
                            }
                        });
                    t.scaleService.registerScaleType("radialLinear", y, m)
                }
            }, { 25: 25, 34: 34, 45: 45 }],
            58: [function(t, e, n) {
                "use strict";

                function i(t, e) { return t - e }

                function r(t) {
                    var e, n, i, r = {},
                        o = [];
                    for (e = 0, n = t.length; e < n; ++e) i = t[e], r[i] || (r[i] = !0, o.push(i));
                    return o
                }

                function o(t, e, n, i) {
                    if ("linear" === i || !t.length) return [{ time: e, pos: 0 }, { time: n, pos: 1 }];
                    var r, o, a, s, l, u = [],
                        c = [e];
                    for (r = 0, o = t.length; r < o; ++r) s = t[r], s > e && s < n && c.push(s);
                    for (c.push(n), r = 0, o = c.length; r < o; ++r) l = c[r + 1], a = c[r - 1], s = c[r], void 0 !== a && void 0 !== l && Math.round((l + a) / 2) === s || u.push({ time: s, pos: r / (o - 1) });
                    return u
                }

                function a(t, e, n) {
                    for (var i, r, o, a = 0, s = t.length - 1; a >= 0 && a <= s;) {
                        if (i = a + s >> 1, r = t[i - 1] || null, o = t[i], !r) return { lo: null, hi: o };
                        if (o[e] < n) a = i + 1;
                        else {
                            if (!(r[e] > n)) return { lo: r, hi: o };
                            s = i - 1
                        }
                    }
                    return { lo: o, hi: null }
                }

                function s(t, e, n, i) {
                    var r = a(t, e, n),
                        o = r.lo ? r.hi ? r.lo : t[t.length - 2] : t[0],
                        s = r.lo ? r.hi ? r.hi : t[t.length - 1] : t[1],
                        l = s[e] - o[e],
                        u = l ? (n - o[e]) / l : 0,
                        c = (s[i] - o[i]) * u;
                    return o[i] + c
                }

                function l(t, e) {
                    var n = e.parser,
                        i = e.parser || e.format;
                    return "function" == typeof n ? n(t) : "string" == typeof t && "string" == typeof i ? y(t, i) : (t instanceof y || (t = y(t)), t.isValid() ? t : "function" == typeof i ? i(t) : t)
                }

                function u(t, e) {
                    if (x.isNullOrUndef(t)) return null;
                    var n = e.options.time,
                        i = l(e.getRightValue(t), n);
                    return i.isValid() ? (n.round && i.startOf(n.round), i.valueOf()) : null
                }

                function c(t, e, n, i) {
                    var r, o, a, s = e - t,
                        l = S[n],
                        u = l.size,
                        c = l.steps;
                    if (!c) return Math.ceil(s / (i * u));
                    for (r = 0, o = c.length; r < o && (a = c[r], !(Math.ceil(s / (u * a)) <= i)); ++r);
                    return a
                }

                function d(t, e, n, i) {
                    var r, o, a, s = _.length;
                    for (r = _.indexOf(t); r < s - 1; ++r)
                        if (o = S[_[r]], a = o.steps ? o.steps[o.steps.length - 1] : k, o.common && Math.ceil((n - e) / (a * o.size)) <= i) return _[r];
                    return _[s - 1]
                }

                function h(t, e, n, i) {
                    var r, o, a = y.duration(y(i).diff(y(n))),
                        s = _.length;
                    for (r = s - 1; r >= _.indexOf(e); r--)
                        if (o = _[r], S[o].common && a.as(o) >= t.length) return o;
                    return _[e ? _.indexOf(e) : 0]
                }

                function f(t) {
                    for (var e = _.indexOf(t) + 1, n = _.length; e < n; ++e)
                        if (S[_[e]].common) return _[e]
                }

                function p(t, e, n, i) {
                    var r, o = i.time,
                        a = o.unit || d(o.minUnit, t, e, n),
                        s = f(a),
                        l = x.valueOrDefault(o.stepSize, o.unitStepSize),
                        u = "week" === a && o.isoWeekday,
                        h = i.ticks.major.enabled,
                        p = S[a],
                        g = y(t),
                        v = y(e),
                        m = [];
                    for (l || (l = c(t, e, a, n)), u && (g = g.isoWeekday(u), v = v.isoWeekday(u)), g = g.startOf(u ? "day" : a), v = v.startOf(u ? "day" : a), v < e && v.add(1, a), r = y(g), h && s && !u && !o.round && (r.startOf(s), r.add(~~((g - r) / (p.size * l)) * l, a)); r < v; r.add(l, a)) m.push(+r);
                    return m.push(+r), m
                }

                function g(t, e, n, i, r) {
                    var o, a, l = 0,
                        u = 0;
                    return r.offset && e.length && (r.time.min || (o = e.length > 1 ? e[1] : i, a = e[0], l = (s(t, "time", o, "pos") - s(t, "time", a, "pos")) / 2), r.time.max || (o = e[e.length - 1], a = e.length > 1 ? e[e.length - 2] : n, u = (s(t, "time", o, "pos") - s(t, "time", a, "pos")) / 2)), { left: l, right: u }
                }

                function v(t, e) { var n, i, r, o, a = []; for (n = 0, i = t.length; n < i; ++n) r = t[n], o = !!e && r === +y(r).startOf(e), a.push({ value: r, major: o }); return a }

                function m(t, e) {
                    var n, i, r, o = t.length;
                    for (n = 0; n < o; n++) {
                        if (i = l(t[n], e), 0 !== i.millisecond()) return "MMM D, YYYY h:mm:ss.SSS a";
                        0 === i.second() && 0 === i.minute() && 0 === i.hour() || (r = !0)
                    }
                    return r ? "MMM D, YYYY h:mm:ss a" : "MMM D, YYYY"
                }
                var y = t(1);
                y = "function" == typeof y ? y : window.moment;
                var b = t(25),
                    x = t(45),
                    w = Number.MIN_SAFE_INTEGER || -9007199254740991,
                    k = Number.MAX_SAFE_INTEGER || 9007199254740991,
                    S = { millisecond: { common: !0, size: 1, steps: [1, 2, 5, 10, 20, 50, 100, 250, 500] }, second: { common: !0, size: 1e3, steps: [1, 2, 5, 10, 30] }, minute: { common: !0, size: 6e4, steps: [1, 2, 5, 10, 30] }, hour: { common: !0, size: 36e5, steps: [1, 2, 3, 6, 12] }, day: { common: !0, size: 864e5, steps: [1, 2, 5] }, week: { common: !1, size: 6048e5, steps: [1, 2, 3, 4] }, month: { common: !0, size: 2628e6, steps: [1, 2, 3] }, quarter: { common: !1, size: 7884e6, steps: [1, 2, 3, 4] }, year: { common: !0, size: 3154e7 } },
                    _ = Object.keys(S);
                e.exports = function(t) {
                    var e = { position: "bottom", distribution: "linear", bounds: "data", time: { parser: !1, format: !1, unit: !1, round: !1, displayFormat: !1, isoWeekday: !1, minUnit: "millisecond", displayFormats: { millisecond: "h:mm:ss.SSS a", second: "h:mm:ss a", minute: "h:mm a", hour: "hA", day: "MMM D", week: "ll", month: "MMM YYYY", quarter: "[Q]Q - YYYY", year: "YYYY" } }, ticks: { autoSkip: !1, source: "auto", major: { enabled: !1 } } },
                        n = t.Scale.extend({
                            initialize: function() {
                                if (!y) throw new Error("Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com");
                                this.mergeTicksOptions(), t.Scale.prototype.initialize.call(this)
                            },
                            update: function() {
                                var e = this,
                                    n = e.options;
                                return n.time && n.time.format, t.Scale.prototype.update.apply(e, arguments)
                            },
                            getRightValue: function(e) { return e && void 0 !== e.t && (e = e.t), t.Scale.prototype.getRightValue.call(this, e) },
                            determineDataLimits: function() {
                                var t, e, n, o, a, s, l = this,
                                    c = l.chart,
                                    d = l.options.time,
                                    h = d.unit || "day",
                                    f = k,
                                    p = w,
                                    g = [],
                                    v = [],
                                    m = [];
                                for (t = 0, n = c.data.labels.length; t < n; ++t) m.push(u(c.data.labels[t], l));
                                for (t = 0, n = (c.data.datasets || []).length; t < n; ++t)
                                    if (c.isDatasetVisible(t))
                                        if (a = c.data.datasets[t].data, x.isObject(a[0]))
                                            for (v[t] = [], e = 0, o = a.length; e < o; ++e) s = u(a[e], l), g.push(s), v[t][e] = s;
                                        else g.push.apply(g, m), v[t] = m.slice(0);
                                else v[t] = [];
                                m.length && (m = r(m).sort(i), f = Math.min(f, m[0]), p = Math.max(p, m[m.length - 1])), g.length && (g = r(g).sort(i), f = Math.min(f, g[0]), p = Math.max(p, g[g.length - 1])), f = u(d.min, l) || f, p = u(d.max, l) || p, f = f === k ? +y().startOf(h) : f, p = p === w ? +y().endOf(h) + 1 : p, l.min = Math.min(f, p), l.max = Math.max(f + 1, p), l._horizontal = l.isHorizontal(), l._table = [], l._timestamps = { data: g, datasets: v, labels: m }
                            },
                            buildTicks: function() {
                                var t, e, n, i = this,
                                    r = i.min,
                                    a = i.max,
                                    s = i.options,
                                    l = s.time,
                                    c = [],
                                    d = [];
                                switch (s.ticks.source) {
                                    case "data":
                                        c = i._timestamps.data;
                                        break;
                                    case "labels":
                                        c = i._timestamps.labels;
                                        break;
                                    case "auto":
                                    default:
                                        c = p(r, a, i.getLabelCapacity(r), s)
                                }
                                for ("ticks" === s.bounds && c.length && (r = c[0], a = c[c.length - 1]), r = u(l.min, i) || r, a = u(l.max, i) || a, t = 0, e = c.length; t < e; ++t) n = c[t], n >= r && n <= a && d.push(n);
                                return i.min = r, i.max = a, i._unit = l.unit || h(d, l.minUnit, i.min, i.max), i._majorUnit = f(i._unit), i._table = o(i._timestamps.data, r, a, s.distribution), i._offsets = g(i._table, d, r, a, s), i._labelFormat = m(i._timestamps.data, l), v(d, i._majorUnit)
                            },
                            getLabelForIndex: function(t, e) {
                                var n = this,
                                    i = n.chart.data,
                                    r = n.options.time,
                                    o = i.labels && t < i.labels.length ? i.labels[t] : "",
                                    a = i.datasets[e].data[t];
                                return x.isObject(a) && (o = n.getRightValue(a)), r.tooltipFormat ? l(o, r).format(r.tooltipFormat) : "string" == typeof o ? o : l(o, r).format(n._labelFormat)
                            },
                            tickFormatFunction: function(t, e, n, i) {
                                var r = this,
                                    o = r.options,
                                    a = t.valueOf(),
                                    s = o.time.displayFormats,
                                    l = s[r._unit],
                                    u = r._majorUnit,
                                    c = s[u],
                                    d = t.clone().startOf(u).valueOf(),
                                    h = o.ticks.major,
                                    f = h.enabled && u && c && a === d,
                                    p = t.format(i ? i : f ? c : l),
                                    g = f ? h : o.ticks.minor,
                                    v = x.valueOrDefault(g.callback, g.userCallback);
                                return v ? v(p, e, n) : p
                            },
                            convertTicksToLabels: function(t) { var e, n, i = []; for (e = 0, n = t.length; e < n; ++e) i.push(this.tickFormatFunction(y(t[e].value), e, t)); return i },
                            getPixelForOffset: function(t) {
                                var e = this,
                                    n = e._horizontal ? e.width : e.height,
                                    i = e._horizontal ? e.left : e.top,
                                    r = s(e._table, "time", t, "pos");
                                return i + n * (e._offsets.left + r) / (e._offsets.left + 1 + e._offsets.right)
                            },
                            getPixelForValue: function(t, e, n) {
                                var i = this,
                                    r = null;
                                if (void 0 !== e && void 0 !== n && (r = i._timestamps.datasets[n][e]), null === r && (r = u(t, i)), null !== r) return i.getPixelForOffset(r)
                            },
                            getPixelForTick: function(t) { var e = this.getTicks(); return t >= 0 && t < e.length ? this.getPixelForOffset(e[t].value) : null },
                            getValueForPixel: function(t) {
                                var e = this,
                                    n = e._horizontal ? e.width : e.height,
                                    i = e._horizontal ? e.left : e.top,
                                    r = (n ? (t - i) / n : 0) * (e._offsets.left + 1 + e._offsets.left) - e._offsets.right,
                                    o = s(e._table, "pos", r, "time");
                                return y(o)
                            },
                            getLabelWidth: function(t) {
                                var e = this,
                                    n = e.options.ticks,
                                    i = e.ctx.measureText(t).width,
                                    r = x.toRadians(n.maxRotation),
                                    o = Math.cos(r),
                                    a = Math.sin(r),
                                    s = x.valueOrDefault(n.fontSize, b.global.defaultFontSize);
                                return i * o + s * a
                            },
                            getLabelCapacity: function(t) {
                                var e = this,
                                    n = e.options.time.displayFormats.millisecond,
                                    i = e.tickFormatFunction(y(t), 0, [], n),
                                    r = e.getLabelWidth(i),
                                    o = e.isHorizontal() ? e.width : e.height,
                                    a = Math.floor(o / r);
                                return a > 0 ? a : 1
                            }
                        });
                    t.scaleService.registerScaleType("time", n, e)
                }
            }, { 1: 1, 25: 25, 45: 45 }]
        }, {}, [7])(7)
    })
}, function(t, e, n) {
    var i = n(20);
    t.exports = function(t) { return (i.JSON && i.JSON.stringify || JSON.stringify).apply(JSON, arguments) }
}, , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , , function(t, e, n) {
    var i, r;
    ! function(o, a) { i = a, r = "function" == typeof i ? i.call(e, n, e, t) : i, !(void 0 !== r && (t.exports = r)) }("undefined" != typeof window ? window : this, function() {
        "use strict";

        function t() {}
        var e = t.prototype;
        return e.on = function(t, e) {
            if (t && e) {
                var n = this._events = this._events || {},
                    i = n[t] = n[t] || [];
                return i.indexOf(e) == -1 && i.push(e), this
            }
        }, e.once = function(t, e) {
            if (t && e) {
                this.on(t, e);
                var n = this._onceEvents = this._onceEvents || {},
                    i = n[t] = n[t] || {};
                return i[e] = !0, this
            }
        }, e.off = function(t, e) { var n = this._events && this._events[t]; if (n && n.length) { var i = n.indexOf(e); return i != -1 && n.splice(i, 1), this } }, e.emitEvent = function(t, e) {
            var n = this._events && this._events[t];
            if (n && n.length) {
                n = n.slice(0), e = e || [];
                for (var i = this._onceEvents && this._onceEvents[t], r = 0; r < n.length; r++) {
                    var o = n[r],
                        a = i && i[o];
                    a && (this.off(t, o), delete i[o]), o.apply(this, e)
                }
                return this
            }
        }, e.allOff = function() { delete this._events, delete this._onceEvents }, t
    })
}, function(t, e, n) {
    var i, r;
    ! function(o, a) {
        if (null === o) throw new Error("Google-maps package can be used only in browser");
        i = a, r = "function" == typeof i ? i.call(e, n, e, t) : i, !(void 0 !== r && (t.exports = r))
    }("undefined" != typeof window ? window : null, function() {
        "use strict";
        var t = "3.31",
            e = null,
            n = null,
            i = !1,
            r = [],
            o = [],
            a = null,
            s = {};
        s.URL = "https://maps.googleapis.com/maps/api/js", s.KEY = null, s.LIBRARIES = [], s.CLIENT = null, s.CHANNEL = null, s.LANGUAGE = null, s.REGION = null, s.VERSION = t, s.WINDOW_CALLBACK_NAME = "__google_maps_api_provider_initializator__", s._googleMockApiObject = {}, s.load = function(t) { null === n ? i === !0 ? t && r.push(t) : (i = !0, window[s.WINDOW_CALLBACK_NAME] = function() { l(t) }, s.createLoader()) : t && t(n) }, s.createLoader = function() { e = document.createElement("script"), e.type = "text/javascript", e.src = s.createUrl(), document.body.appendChild(e) }, s.isLoaded = function() { return null !== n }, s.createUrl = function() { var t = s.URL; return t += "?callback=" + s.WINDOW_CALLBACK_NAME, s.KEY && (t += "&key=" + s.KEY), s.LIBRARIES.length > 0 && (t += "&libraries=" + s.LIBRARIES.join(",")), s.CLIENT && (t += "&client=" + s.CLIENT), s.CHANNEL && (t += "&channel=" + s.CHANNEL), s.LANGUAGE && (t += "&language=" + s.LANGUAGE), s.REGION && (t += "&region=" + s.REGION), s.VERSION && (t += "&v=" + s.VERSION), t }, s.release = function(l) {
            var u = function() { s.KEY = null, s.LIBRARIES = [], s.CLIENT = null, s.CHANNEL = null, s.LANGUAGE = null, s.REGION = null, s.VERSION = t, n = null, i = !1, r = [], o = [], "undefined" != typeof window.google && delete window.google, "undefined" != typeof window[s.WINDOW_CALLBACK_NAME] && delete window[s.WINDOW_CALLBACK_NAME], null !== a && (s.createLoader = a, a = null), null !== e && (e.parentElement.removeChild(e), e = null), l && l() };
            i ? s.load(function() { u() }) : u()
        }, s.onLoad = function(t) { o.push(t) }, s.makeMock = function() { a = s.createLoader, s.createLoader = function() { window.google = s._googleMockApiObject, window[s.WINDOW_CALLBACK_NAME]() } };
        var l = function(t) {
            var e;
            for (i = !1, null === n && (n = window.google), e = 0; e < o.length; e++) o[e](n);
            for (t && t(n), e = 0; e < r.length; e++) r[e](n);
            r = []
        };
        return s
    })
}, function(t, e, n) {
    var i;
    ! function(r, o, a, s) {
        "use strict";

        function l(t, e, n) { return setTimeout(f(t, n), e) }

        function u(t, e, n) { return !!Array.isArray(t) && (c(t, n[e], n), !0) }

        function c(t, e, n) {
            var i;
            if (t)
                if (t.forEach) t.forEach(e, n);
                else if (t.length !== s)
                for (i = 0; i < t.length;) e.call(n, t[i], i, t), i++;
            else
                for (i in t) t.hasOwnProperty(i) && e.call(n, t[i], i, t)
        }

        function d(t, e, n) {
            var i = "DEPRECATED METHOD: " + e + "\n" + n + " AT \n";
            return function() {
                var e = new Error("get-stack-trace"),
                    n = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
                    o = r.console && (r.console.warn || r.console.log);
                return o && o.call(r.console, i, n), t.apply(this, arguments)
            }
        }

        function h(t, e, n) {
            var i, r = e.prototype;
            i = t.prototype = Object.create(r), i.constructor = t, i._super = r, n && gt(i, n)
        }

        function f(t, e) { return function() { return t.apply(e, arguments) } }

        function p(t, e) { return typeof t == yt ? t.apply(e ? e[0] || s : s, e) : t }

        function g(t, e) { return t === s ? e : t }

        function v(t, e, n) { c(x(e), function(e) { t.addEventListener(e, n, !1) }) }

        function m(t, e, n) { c(x(e), function(e) { t.removeEventListener(e, n, !1) }) }

        function y(t, e) {
            for (; t;) {
                if (t == e) return !0;
                t = t.parentNode
            }
            return !1
        }

        function b(t, e) { return t.indexOf(e) > -1 }

        function x(t) { return t.trim().split(/\s+/g) }

        function w(t, e, n) {
            if (t.indexOf && !n) return t.indexOf(e);
            for (var i = 0; i < t.length;) {
                if (n && t[i][n] == e || !n && t[i] === e) return i;
                i++
            }
            return -1
        }

        function k(t) { return Array.prototype.slice.call(t, 0) }

        function S(t, e, n) {
            for (var i = [], r = [], o = 0; o < t.length;) {
                var a = e ? t[o][e] : t[o];
                w(r, a) < 0 && i.push(t[o]), r[o] = a, o++
            }
            return n && (i = e ? i.sort(function(t, n) { return t[e] > n[e] }) : i.sort()), i
        }

        function _(t, e) {
            for (var n, i, r = e[0].toUpperCase() + e.slice(1), o = 0; o < vt.length;) {
                if (n = vt[o], i = n ? n + r : e, i in t) return i;
                o++
            }
            return s
        }

        function T() { return _t++ }

        function C(t) { var e = t.ownerDocument || t; return e.defaultView || e.parentWindow || r }

        function M(t, e) {
            var n = this;
            this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function(e) { p(t.options.enable, [t]) && n.handler(e) }, this.init()
        }

        function A(t) { var e, n = t.options.inputClass; return new(e = n ? n : Mt ? B : At ? Y : Ct ? V : H)(t, E) }

        function E(t, e, n) {
            var i = n.pointers.length,
                r = n.changedPointers.length,
                o = e & Ot && i - r === 0,
                a = e & ($t | Nt) && i - r === 0;
            n.isFirst = !!o, n.isFinal = !!a, o && (t.session = {}), n.eventType = e, P(t, n), t.emit("hammer.input", n), t.recognize(n), t.session.prevInput = n
        }

        function P(t, e) {
            var n = t.session,
                i = e.pointers,
                r = i.length;
            n.firstInput || (n.firstInput = D(e)), r > 1 && !n.firstMultiple ? n.firstMultiple = D(e) : 1 === r && (n.firstMultiple = !1);
            var o = n.firstInput,
                a = n.firstMultiple,
                s = a ? a.center : o.center,
                l = e.center = O(i);
            e.timeStamp = wt(), e.deltaTime = e.timeStamp - o.timeStamp, e.angle = R(s, l), e.distance = N(s, l), I(n, e), e.offsetDirection = $(e.deltaX, e.deltaY);
            var u = L(e.deltaTime, e.deltaX, e.deltaY);
            e.overallVelocityX = u.x, e.overallVelocityY = u.y, e.overallVelocity = xt(u.x) > xt(u.y) ? u.x : u.y, e.scale = a ? F(a.pointers, i) : 1, e.rotation = a ? q(a.pointers, i) : 0, e.maxPointers = n.prevInput ? e.pointers.length > n.prevInput.maxPointers ? e.pointers.length : n.prevInput.maxPointers : e.pointers.length, z(n, e);
            var c = t.element;
            y(e.srcEvent.target, c) && (c = e.srcEvent.target), e.target = c
        }

        function I(t, e) {
            var n = e.center,
                i = t.offsetDelta || {},
                r = t.prevDelta || {},
                o = t.prevInput || {};
            e.eventType !== Ot && o.eventType !== $t || (r = t.prevDelta = { x: o.deltaX || 0, y: o.deltaY || 0 }, i = t.offsetDelta = { x: n.x, y: n.y }), e.deltaX = r.x + (n.x - i.x), e.deltaY = r.y + (n.y - i.y)
        }

        function z(t, e) {
            var n, i, r, o, a = t.lastInterval || e,
                l = e.timeStamp - a.timeStamp;
            if (e.eventType != Nt && (l > Dt || a.velocity === s)) {
                var u = e.deltaX - a.deltaX,
                    c = e.deltaY - a.deltaY,
                    d = L(l, u, c);
                i = d.x, r = d.y, n = xt(d.x) > xt(d.y) ? d.x : d.y, o = $(u, c), t.lastInterval = e
            } else n = a.velocity, i = a.velocityX, r = a.velocityY, o = a.direction;
            e.velocity = n, e.velocityX = i, e.velocityY = r, e.direction = o
        }

        function D(t) { for (var e = [], n = 0; n < t.pointers.length;) e[n] = { clientX: bt(t.pointers[n].clientX), clientY: bt(t.pointers[n].clientY) }, n++; return { timeStamp: wt(), pointers: e, center: O(e), deltaX: t.deltaX, deltaY: t.deltaY } }

        function O(t) { var e = t.length; if (1 === e) return { x: bt(t[0].clientX), y: bt(t[0].clientY) }; for (var n = 0, i = 0, r = 0; r < e;) n += t[r].clientX, i += t[r].clientY, r++; return { x: bt(n / e), y: bt(i / e) } }

        function L(t, e, n) { return { x: e / t || 0, y: n / t || 0 } }

        function $(t, e) { return t === e ? Rt : xt(t) >= xt(e) ? t < 0 ? qt : Ft : e < 0 ? Ht : Bt }

        function N(t, e, n) {
            n || (n = Ut);
            var i = e[n[0]] - t[n[0]],
                r = e[n[1]] - t[n[1]];
            return Math.sqrt(i * i + r * r)
        }

        function R(t, e, n) {
            n || (n = Ut);
            var i = e[n[0]] - t[n[0]],
                r = e[n[1]] - t[n[1]];
            return 180 * Math.atan2(r, i) / Math.PI
        }

        function q(t, e) { return R(e[1], e[0], Vt) + R(t[1], t[0], Vt) }

        function F(t, e) { return N(e[0], e[1], Vt) / N(t[0], t[1], Vt) }

        function H() { this.evEl = Zt, this.evWin = Kt, this.pressed = !1, M.apply(this, arguments) }

        function B() { this.evEl = Qt, this.evWin = te, M.apply(this, arguments), this.store = this.manager.session.pointerEvents = [] }

        function W() { this.evTarget = ne, this.evWin = ie, this.started = !1, M.apply(this, arguments) }

        function j(t, e) {
            var n = k(t.touches),
                i = k(t.changedTouches);
            return e & ($t | Nt) && (n = S(n.concat(i), "identifier", !0)), [n, i]
        }

        function Y() { this.evTarget = oe, this.targetIds = {}, M.apply(this, arguments) }

        function U(t, e) {
            var n = k(t.touches),
                i = this.targetIds;
            if (e & (Ot | Lt) && 1 === n.length) return i[n[0].identifier] = !0, [n, n];
            var r, o, a = k(t.changedTouches),
                s = [],
                l = this.target;
            if (o = n.filter(function(t) { return y(t.target, l) }), e === Ot)
                for (r = 0; r < o.length;) i[o[r].identifier] = !0, r++;
            for (r = 0; r < a.length;) i[a[r].identifier] && s.push(a[r]), e & ($t | Nt) && delete i[a[r].identifier], r++;
            return s.length ? [S(o.concat(s), "identifier", !0), s] : void 0
        }

        function V() {
            M.apply(this, arguments);
            var t = f(this.handler, this);
            this.touch = new Y(this.manager, t), this.mouse = new H(this.manager, t), this.primaryTouch = null, this.lastTouches = []
        }

        function X(t, e) { t & Ot ? (this.primaryTouch = e.changedPointers[0].identifier, Z.call(this, e)) : t & ($t | Nt) && Z.call(this, e) }

        function Z(t) {
            var e = t.changedPointers[0];
            if (e.identifier === this.primaryTouch) {
                var n = { x: e.clientX, y: e.clientY };
                this.lastTouches.push(n);
                var i = this.lastTouches,
                    r = function() {
                        var t = i.indexOf(n);
                        t > -1 && i.splice(t, 1)
                    };
                setTimeout(r, ae)
            }
        }

        function K(t) {
            for (var e = t.srcEvent.clientX, n = t.srcEvent.clientY, i = 0; i < this.lastTouches.length; i++) {
                var r = this.lastTouches[i],
                    o = Math.abs(e - r.x),
                    a = Math.abs(n - r.y);
                if (o <= se && a <= se) return !0
            }
            return !1
        }

        function G(t, e) { this.manager = t, this.set(e) }

        function J(t) {
            if (b(t, fe)) return fe;
            var e = b(t, pe),
                n = b(t, ge);
            return e && n ? fe : e || n ? e ? pe : ge : b(t, he) ? he : de
        }

        function Q() {
            if (!ue) return !1;
            var t = {},
                e = r.CSS && r.CSS.supports;
            return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(n) { t[n] = !e || r.CSS.supports("touch-action", n) }), t
        }

        function tt(t) { this.options = gt({}, this.defaults, t || {}), this.id = T(), this.manager = null, this.options.enable = g(this.options.enable, !0), this.state = me, this.simultaneous = {}, this.requireFail = [] }

        function et(t) { return t & ke ? "cancel" : t & xe ? "end" : t & be ? "move" : t & ye ? "start" : "" }

        function nt(t) { return t == Bt ? "down" : t == Ht ? "up" : t == qt ? "left" : t == Ft ? "right" : "" }

        function it(t, e) { var n = e.manager; return n ? n.get(t) : t }

        function rt() { tt.apply(this, arguments) }

        function ot() { rt.apply(this, arguments), this.pX = null, this.pY = null }

        function at() { rt.apply(this, arguments) }

        function st() { tt.apply(this, arguments), this._timer = null, this._input = null }

        function lt() { rt.apply(this, arguments) }

        function ut() { rt.apply(this, arguments) }

        function ct() { tt.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0 }

        function dt(t, e) { return e = e || {}, e.recognizers = g(e.recognizers, dt.defaults.preset), new ht(t, e) }

        function ht(t, e) {
            this.options = gt({}, dt.defaults, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = A(this), this.touchAction = new G(this, this.options.touchAction), ft(this, !0), c(this.options.recognizers, function(t) {
                var e = this.add(new t[0](t[1]));
                t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3])
            }, this)
        }

        function ft(t, e) {
            var n = t.element;
            if (n.style) {
                var i;
                c(t.options.cssProps, function(r, o) { i = _(n.style, o), e ? (t.oldCssProps[i] = n.style[i], n.style[i] = r) : n.style[i] = t.oldCssProps[i] || "" }), e || (t.oldCssProps = {})
            }
        }

        function pt(t, e) {
            var n = o.createEvent("Event");
            n.initEvent(t, !0, !0), n.gesture = e, e.target.dispatchEvent(n)
        }
        var gt, vt = ["", "webkit", "Moz", "MS", "ms", "o"],
            mt = o.createElement("div"),
            yt = "function",
            bt = Math.round,
            xt = Math.abs,
            wt = Date.now;
        gt = "function" != typeof Object.assign ? function(t) {
            if (t === s || null === t) throw new TypeError("Cannot convert undefined or null to object");
            for (var e = Object(t), n = 1; n < arguments.length; n++) {
                var i = arguments[n];
                if (i !== s && null !== i)
                    for (var r in i) i.hasOwnProperty(r) && (e[r] = i[r])
            }
            return e
        } : Object.assign;
        var kt = d(function(t, e, n) { for (var i = Object.keys(e), r = 0; r < i.length;)(!n || n && t[i[r]] === s) && (t[i[r]] = e[i[r]]), r++; return t }, "extend", "Use `assign`."),
            St = d(function(t, e) { return kt(t, e, !0) }, "merge", "Use `assign`."),
            _t = 1,
            Tt = /mobile|tablet|ip(ad|hone|od)|android/i,
            Ct = "ontouchstart" in r,
            Mt = _(r, "PointerEvent") !== s,
            At = Ct && Tt.test(navigator.userAgent),
            Et = "touch",
            Pt = "pen",
            It = "mouse",
            zt = "kinect",
            Dt = 25,
            Ot = 1,
            Lt = 2,
            $t = 4,
            Nt = 8,
            Rt = 1,
            qt = 2,
            Ft = 4,
            Ht = 8,
            Bt = 16,
            Wt = qt | Ft,
            jt = Ht | Bt,
            Yt = Wt | jt,
            Ut = ["x", "y"],
            Vt = ["clientX", "clientY"];
        M.prototype = { handler: function() {}, init: function() { this.evEl && v(this.element, this.evEl, this.domHandler), this.evTarget && v(this.target, this.evTarget, this.domHandler), this.evWin && v(C(this.element), this.evWin, this.domHandler) }, destroy: function() { this.evEl && m(this.element, this.evEl, this.domHandler), this.evTarget && m(this.target, this.evTarget, this.domHandler), this.evWin && m(C(this.element), this.evWin, this.domHandler) } };
        var Xt = { mousedown: Ot, mousemove: Lt, mouseup: $t },
            Zt = "mousedown",
            Kt = "mousemove mouseup";
        h(H, M, {
            handler: function(t) {
                var e = Xt[t.type];
                e & Ot && 0 === t.button && (this.pressed = !0), e & Lt && 1 !== t.which && (e = $t), this.pressed && (e & $t && (this.pressed = !1), this.callback(this.manager, e, { pointers: [t], changedPointers: [t], pointerType: It, srcEvent: t }))
            }
        });
        var Gt = { pointerdown: Ot, pointermove: Lt, pointerup: $t, pointercancel: Nt, pointerout: Nt },
            Jt = { 2: Et, 3: Pt, 4: It, 5: zt },
            Qt = "pointerdown",
            te = "pointermove pointerup pointercancel";
        r.MSPointerEvent && !r.PointerEvent && (Qt = "MSPointerDown", te = "MSPointerMove MSPointerUp MSPointerCancel"), h(B, M, {
            handler: function(t) {
                var e = this.store,
                    n = !1,
                    i = t.type.toLowerCase().replace("ms", ""),
                    r = Gt[i],
                    o = Jt[t.pointerType] || t.pointerType,
                    a = o == Et,
                    s = w(e, t.pointerId, "pointerId");
                r & Ot && (0 === t.button || a) ? s < 0 && (e.push(t), s = e.length - 1) : r & ($t | Nt) && (n = !0), s < 0 || (e[s] = t, this.callback(this.manager, r, { pointers: e, changedPointers: [t], pointerType: o, srcEvent: t }), n && e.splice(s, 1))
            }
        });
        var ee = { touchstart: Ot, touchmove: Lt, touchend: $t, touchcancel: Nt },
            ne = "touchstart",
            ie = "touchstart touchmove touchend touchcancel";
        h(W, M, {
            handler: function(t) {
                var e = ee[t.type];
                if (e === Ot && (this.started = !0), this.started) {
                    var n = j.call(this, t, e);
                    e & ($t | Nt) && n[0].length - n[1].length === 0 && (this.started = !1), this.callback(this.manager, e, { pointers: n[0], changedPointers: n[1], pointerType: Et, srcEvent: t })
                }
            }
        });
        var re = { touchstart: Ot, touchmove: Lt, touchend: $t, touchcancel: Nt },
            oe = "touchstart touchmove touchend touchcancel";
        h(Y, M, {
            handler: function(t) {
                var e = re[t.type],
                    n = U.call(this, t, e);
                n && this.callback(this.manager, e, { pointers: n[0], changedPointers: n[1], pointerType: Et, srcEvent: t })
            }
        });
        var ae = 2500,
            se = 25;
        h(V, M, {
            handler: function(t, e, n) {
                var i = n.pointerType == Et,
                    r = n.pointerType == It;
                if (!(r && n.sourceCapabilities && n.sourceCapabilities.firesTouchEvents)) {
                    if (i) X.call(this, e, n);
                    else if (r && K.call(this, n)) return;
                    this.callback(t, e, n)
                }
            },
            destroy: function() { this.touch.destroy(), this.mouse.destroy() }
        });
        var le = _(mt.style, "touchAction"),
            ue = le !== s,
            ce = "compute",
            de = "auto",
            he = "manipulation",
            fe = "none",
            pe = "pan-x",
            ge = "pan-y",
            ve = Q();
        G.prototype = {
            set: function(t) { t == ce && (t = this.compute()), ue && this.manager.element.style && ve[t] && (this.manager.element.style[le] = t), this.actions = t.toLowerCase().trim() },
            update: function() { this.set(this.manager.options.touchAction) },
            compute: function() { var t = []; return c(this.manager.recognizers, function(e) { p(e.options.enable, [e]) && (t = t.concat(e.getTouchAction())) }), J(t.join(" ")) },
            preventDefaults: function(t) {
                var e = t.srcEvent,
                    n = t.offsetDirection;
                if (this.manager.session.prevented) return void e.preventDefault();
                var i = this.actions,
                    r = b(i, fe) && !ve[fe],
                    o = b(i, ge) && !ve[ge],
                    a = b(i, pe) && !ve[pe];
                if (r) {
                    var s = 1 === t.pointers.length,
                        l = t.distance < 2,
                        u = t.deltaTime < 250;
                    if (s && l && u) return
                }
                return a && o ? void 0 : r || o && n & Wt || a && n & jt ? this.preventSrc(e) : void 0
            },
            preventSrc: function(t) { this.manager.session.prevented = !0, t.preventDefault() }
        };
        var me = 1,
            ye = 2,
            be = 4,
            xe = 8,
            we = xe,
            ke = 16,
            Se = 32;
        tt.prototype = {
            defaults: {},
            set: function(t) { return gt(this.options, t), this.manager && this.manager.touchAction.update(), this },
            recognizeWith: function(t) { if (u(t, "recognizeWith", this)) return this; var e = this.simultaneous; return t = it(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this },
            dropRecognizeWith: function(t) { return u(t, "dropRecognizeWith", this) ? this : (t = it(t, this), delete this.simultaneous[t.id], this) },
            requireFailure: function(t) { if (u(t, "requireFailure", this)) return this; var e = this.requireFail; return t = it(t, this), w(e, t) === -1 && (e.push(t), t.requireFailure(this)), this },
            dropRequireFailure: function(t) {
                if (u(t, "dropRequireFailure", this)) return this;
                t = it(t, this);
                var e = w(this.requireFail, t);
                return e > -1 && this.requireFail.splice(e, 1), this
            },
            hasRequireFailures: function() { return this.requireFail.length > 0 },
            canRecognizeWith: function(t) { return !!this.simultaneous[t.id] },
            emit: function(t) {
                function e(e) { n.manager.emit(e, t) }
                var n = this,
                    i = this.state;
                i < xe && e(n.options.event + et(i)), e(n.options.event), t.additionalEvent && e(t.additionalEvent), i >= xe && e(n.options.event + et(i))
            },
            tryEmit: function(t) { return this.canEmit() ? this.emit(t) : void(this.state = Se) },
            canEmit: function() {
                for (var t = 0; t < this.requireFail.length;) {
                    if (!(this.requireFail[t].state & (Se | me))) return !1;
                    t++
                }
                return !0
            },
            recognize: function(t) { var e = gt({}, t); return p(this.options.enable, [this, e]) ? (this.state & (we | ke | Se) && (this.state = me), this.state = this.process(e), void(this.state & (ye | be | xe | ke) && this.tryEmit(e))) : (this.reset(), void(this.state = Se)) },
            process: function(t) {},
            getTouchAction: function() {},
            reset: function() {}
        }, h(rt, tt, {
            defaults: { pointers: 1 },
            attrTest: function(t) { var e = this.options.pointers; return 0 === e || t.pointers.length === e },
            process: function(t) {
                var e = this.state,
                    n = t.eventType,
                    i = e & (ye | be),
                    r = this.attrTest(t);
                return i && (n & Nt || !r) ? e | ke : i || r ? n & $t ? e | xe : e & ye ? e | be : ye : Se
            }
        }), h(ot, rt, {
            defaults: { event: "pan", threshold: 10, pointers: 1, direction: Yt },
            getTouchAction: function() {
                var t = this.options.direction,
                    e = [];
                return t & Wt && e.push(ge), t & jt && e.push(pe), e
            },
            directionTest: function(t) {
                var e = this.options,
                    n = !0,
                    i = t.distance,
                    r = t.direction,
                    o = t.deltaX,
                    a = t.deltaY;
                return r & e.direction || (e.direction & Wt ? (r = 0 === o ? Rt : o < 0 ? qt : Ft, n = o != this.pX, i = Math.abs(t.deltaX)) : (r = 0 === a ? Rt : a < 0 ? Ht : Bt, n = a != this.pY, i = Math.abs(t.deltaY))), t.direction = r, n && i > e.threshold && r & e.direction
            },
            attrTest: function(t) { return rt.prototype.attrTest.call(this, t) && (this.state & ye || !(this.state & ye) && this.directionTest(t)) },
            emit: function(t) {
                this.pX = t.deltaX, this.pY = t.deltaY;
                var e = nt(t.direction);
                e && (t.additionalEvent = this.options.event + e), this._super.emit.call(this, t)
            }
        }), h(at, rt, {
            defaults: { event: "pinch", threshold: 0, pointers: 2 },
            getTouchAction: function() { return [fe] },
            attrTest: function(t) { return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & ye) },
            emit: function(t) {
                if (1 !== t.scale) {
                    var e = t.scale < 1 ? "in" : "out";
                    t.additionalEvent = this.options.event + e
                }
                this._super.emit.call(this, t)
            }
        }), h(st, tt, {
            defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
            getTouchAction: function() { return [de] },
            process: function(t) {
                var e = this.options,
                    n = t.pointers.length === e.pointers,
                    i = t.distance < e.threshold,
                    r = t.deltaTime > e.time;
                if (this._input = t, !i || !n || t.eventType & ($t | Nt) && !r) this.reset();
                else if (t.eventType & Ot) this.reset(), this._timer = l(function() { this.state = we, this.tryEmit() }, e.time, this);
                else if (t.eventType & $t) return we;
                return Se
            },
            reset: function() { clearTimeout(this._timer) },
            emit: function(t) { this.state === we && (t && t.eventType & $t ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = wt(), this.manager.emit(this.options.event, this._input))) }
        }), h(lt, rt, { defaults: { event: "rotate", threshold: 0, pointers: 2 }, getTouchAction: function() { return [fe] }, attrTest: function(t) { return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & ye) } }), h(ut, rt, {
            defaults: { event: "swipe", threshold: 10, velocity: .3, direction: Wt | jt, pointers: 1 },
            getTouchAction: function() { return ot.prototype.getTouchAction.call(this) },
            attrTest: function(t) { var e, n = this.options.direction; return n & (Wt | jt) ? e = t.overallVelocity : n & Wt ? e = t.overallVelocityX : n & jt && (e = t.overallVelocityY), this._super.attrTest.call(this, t) && n & t.offsetDirection && t.distance > this.options.threshold && t.maxPointers == this.options.pointers && xt(e) > this.options.velocity && t.eventType & $t },
            emit: function(t) {
                var e = nt(t.offsetDirection);
                e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t)
            }
        }), h(ct, tt, {
            defaults: { event: "tap", pointers: 1, taps: 1, interval: 300, time: 250, threshold: 9, posThreshold: 10 },
            getTouchAction: function() { return [he] },
            process: function(t) {
                var e = this.options,
                    n = t.pointers.length === e.pointers,
                    i = t.distance < e.threshold,
                    r = t.deltaTime < e.time;
                if (this.reset(), t.eventType & Ot && 0 === this.count) return this.failTimeout();
                if (i && r && n) {
                    if (t.eventType != $t) return this.failTimeout();
                    var o = !this.pTime || t.timeStamp - this.pTime < e.interval,
                        a = !this.pCenter || N(this.pCenter, t.center) < e.posThreshold;
                    this.pTime = t.timeStamp, this.pCenter = t.center, a && o ? this.count += 1 : this.count = 1, this._input = t;
                    var s = this.count % e.taps;
                    if (0 === s) return this.hasRequireFailures() ? (this._timer = l(function() { this.state = we, this.tryEmit() }, e.interval, this), ye) : we
                }
                return Se
            },
            failTimeout: function() { return this._timer = l(function() { this.state = Se }, this.options.interval, this), Se },
            reset: function() { clearTimeout(this._timer) },
            emit: function() { this.state == we && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input)) }
        }), dt.VERSION = "2.0.7", dt.defaults = {
            domEvents: !1,
            touchAction: ce,
            enable: !0,
            inputTarget: null,
            inputClass: null,
            preset: [
                [lt, { enable: !1 }],
                [at, { enable: !1 },
                    ["rotate"]
                ],
                [ut, { direction: Wt }],
                [ot, { direction: Wt },
                    ["swipe"]
                ],
                [ct],
                [ct, { event: "doubletap", taps: 2 },
                    ["tap"]
                ],
                [st]
            ],
            cssProps: { userSelect: "none", touchSelect: "none", touchCallout: "none", contentZooming: "none", userDrag: "none", tapHighlightColor: "rgba(0,0,0,0)" }
        };
        var _e = 1,
            Te = 2;
        ht.prototype = {
            set: function(t) { return gt(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this },
            stop: function(t) { this.session.stopped = t ? Te : _e },
            recognize: function(t) {
                var e = this.session;
                if (!e.stopped) {
                    this.touchAction.preventDefaults(t);
                    var n, i = this.recognizers,
                        r = e.curRecognizer;
                    (!r || r && r.state & we) && (r = e.curRecognizer = null);
                    for (var o = 0; o < i.length;) n = i[o], e.stopped === Te || r && n != r && !n.canRecognizeWith(r) ? n.reset() : n.recognize(t), !r && n.state & (ye | be | xe) && (r = e.curRecognizer = n), o++
                }
            },
            get: function(t) {
                if (t instanceof tt) return t;
                for (var e = this.recognizers, n = 0; n < e.length; n++)
                    if (e[n].options.event == t) return e[n];
                return null
            },
            add: function(t) { if (u(t, "add", this)) return this; var e = this.get(t.options.event); return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t },
            remove: function(t) {
                if (u(t, "remove", this)) return this;
                if (t = this.get(t)) {
                    var e = this.recognizers,
                        n = w(e, t);
                    n !== -1 && (e.splice(n, 1), this.touchAction.update())
                }
                return this
            },
            on: function(t, e) { if (t !== s && e !== s) { var n = this.handlers; return c(x(t), function(t) { n[t] = n[t] || [], n[t].push(e) }), this } },
            off: function(t, e) { if (t !== s) { var n = this.handlers; return c(x(t), function(t) { e ? n[t] && n[t].splice(w(n[t], e), 1) : delete n[t] }), this } },
            emit: function(t, e) { this.options.domEvents && pt(t, e); var n = this.handlers[t] && this.handlers[t].slice(); if (n && n.length) { e.type = t, e.preventDefault = function() { e.srcEvent.preventDefault() }; for (var i = 0; i < n.length;) n[i](e), i++ } },
            destroy: function() { this.element && ft(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null }
        }, gt(dt, { INPUT_START: Ot, INPUT_MOVE: Lt, INPUT_END: $t, INPUT_CANCEL: Nt, STATE_POSSIBLE: me, STATE_BEGAN: ye, STATE_CHANGED: be, STATE_ENDED: xe, STATE_RECOGNIZED: we, STATE_CANCELLED: ke, STATE_FAILED: Se, DIRECTION_NONE: Rt, DIRECTION_LEFT: qt, DIRECTION_RIGHT: Ft, DIRECTION_UP: Ht, DIRECTION_DOWN: Bt, DIRECTION_HORIZONTAL: Wt, DIRECTION_VERTICAL: jt, DIRECTION_ALL: Yt, Manager: ht, Input: M, TouchAction: G, TouchInput: Y, MouseInput: H, PointerEventInput: B, TouchMouseInput: V, SingleTouchInput: W, Recognizer: tt, AttrRecognizer: rt, Tap: ct, Pan: ot, Swipe: ut, Pinch: at, Rotate: lt, Press: st, on: v, off: m, each: c, merge: St, extend: kt, assign: gt, inherit: h, bindFn: f, prefixed: _ });
        var Ce = "undefined" != typeof r ? r : "undefined" != typeof self ? self : {};
        Ce.Hammer = dt, i = function() { return dt }.call(e, n, e, t), !(i !== s && (t.exports = i))
    }(window, document, "Hammer")
}, function(t, e, n) {
    var i, r;
    ! function(o, a) {
        "use strict";
        i = [n(292)], r = function(t) { return a(o, t) }.apply(e, i), !(void 0 !== r && (t.exports = r))
    }("undefined" != typeof window ? window : this, function(t, e) {
        "use strict";

        function n(t, e) { for (var n in e) t[n] = e[n]; return t }

        function i(t) { if (Array.isArray(t)) return t; var e = "object" == typeof t && "number" == typeof t.length; return e ? u.call(t) : [t] }

        function r(t, e, o) { if (!(this instanceof r)) return new r(t, e, o); var a = t; return "string" == typeof t && (a = document.querySelectorAll(t)), a ? (this.elements = i(a), this.options = n({}, this.options), "function" == typeof e ? o = e : n(this.options, e), o && this.on("always", o), this.getImages(), s && (this.jqDeferred = new s.Deferred), void setTimeout(this.check.bind(this))) : void l.error("Bad element for imagesLoaded " + (a || t)) }

        function o(t) { this.img = t }

        function a(t, e) { this.url = t, this.element = e, this.img = new Image }
        var s = t.jQuery,
            l = t.console,
            u = Array.prototype.slice;
        r.prototype = Object.create(e.prototype), r.prototype.options = {}, r.prototype.getImages = function() { this.images = [], this.elements.forEach(this.addElementImages, this) }, r.prototype.addElementImages = function(t) {
            "IMG" == t.nodeName && this.addImage(t), this.options.background === !0 && this.addElementBackgroundImages(t);
            var e = t.nodeType;
            if (e && c[e]) {
                for (var n = t.querySelectorAll("img"), i = 0; i < n.length; i++) {
                    var r = n[i];
                    this.addImage(r)
                }
                if ("string" == typeof this.options.background) {
                    var o = t.querySelectorAll(this.options.background);
                    for (i = 0; i < o.length; i++) {
                        var a = o[i];
                        this.addElementBackgroundImages(a)
                    }
                }
            }
        };
        var c = { 1: !0, 9: !0, 11: !0 };
        return r.prototype.addElementBackgroundImages = function(t) {
            var e = getComputedStyle(t);
            if (e)
                for (var n = /url\((['"])?(.*?)\1\)/gi, i = n.exec(e.backgroundImage); null !== i;) {
                    var r = i && i[2];
                    r && this.addBackground(r, t), i = n.exec(e.backgroundImage)
                }
        }, r.prototype.addImage = function(t) {
            var e = new o(t);
            this.images.push(e)
        }, r.prototype.addBackground = function(t, e) {
            var n = new a(t, e);
            this.images.push(n)
        }, r.prototype.check = function() {
            function t(t, n, i) { setTimeout(function() { e.progress(t, n, i) }) }
            var e = this;
            return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(e) { e.once("progress", t), e.check() }) : void this.complete()
        }, r.prototype.progress = function(t, e, n) { this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, e]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && l && l.log("progress: " + n, t, e) }, r.prototype.complete = function() {
            var t = this.hasAnyBroken ? "fail" : "done";
            if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
                var e = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[e](this)
            }
        }, o.prototype = Object.create(e.prototype), o.prototype.check = function() { var t = this.getIsImageComplete(); return t ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void(this.proxyImage.src = this.img.src)) }, o.prototype.getIsImageComplete = function() { return this.img.complete && this.img.naturalWidth }, o.prototype.confirm = function(t, e) { this.isLoaded = t, this.emitEvent("progress", [this, this.img, e]) }, o.prototype.handleEvent = function(t) {
            var e = "on" + t.type;
            this[e] && this[e](t)
        }, o.prototype.onload = function() { this.confirm(!0, "onload"), this.unbindEvents() }, o.prototype.onerror = function() { this.confirm(!1, "onerror"), this.unbindEvents() }, o.prototype.unbindEvents = function() { this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this) }, a.prototype = Object.create(o.prototype), a.prototype.check = function() {
            this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
            var t = this.getIsImageComplete();
            t && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
        }, a.prototype.unbindEvents = function() { this.img.removeEventListener("load", this), this.img.removeEventListener("error", this) }, a.prototype.confirm = function(t, e) { this.isLoaded = t, this.emitEvent("progress", [this, this.element, e]) }, r.makeJQueryPlugin = function(e) { e = e || t.jQuery, e && (s = e, s.fn.imagesLoaded = function(t, e) { var n = new r(this, t, e); return n.jqDeferred.promise(s(this)) }) }, r.makeJQueryPlugin(), r
    })
}, function(t, e, n) {
    var i, r, o;
    ! function(a) { r = [n(2)], i = a, o = "function" == typeof i ? i.apply(e, r) : i, !(void 0 !== o && (t.exports = o)) }(function(t) {
        function e(e) {
            var a = e || window.event,
                s = l.call(arguments, 1),
                u = 0,
                d = 0,
                h = 0,
                f = 0,
                p = 0,
                g = 0;
            if (e = t.event.fix(a), e.type = "mousewheel", "detail" in a && (h = a.detail * -1), "wheelDelta" in a && (h = a.wheelDelta), "wheelDeltaY" in a && (h = a.wheelDeltaY), "wheelDeltaX" in a && (d = a.wheelDeltaX * -1), "axis" in a && a.axis === a.HORIZONTAL_AXIS && (d = h * -1, h = 0), u = 0 === h ? d : h, "deltaY" in a && (h = a.deltaY * -1, u = h), "deltaX" in a && (d = a.deltaX, 0 === h && (u = d * -1)), 0 !== h || 0 !== d) {
                if (1 === a.deltaMode) {
                    var v = t.data(this, "mousewheel-line-height");
                    u *= v, h *= v, d *= v
                } else if (2 === a.deltaMode) {
                    var m = t.data(this, "mousewheel-page-height");
                    u *= m, h *= m, d *= m
                }
                if (f = Math.max(Math.abs(h), Math.abs(d)), (!o || f < o) && (o = f, i(a, f) && (o /= 40)), i(a, f) && (u /= 40, d /= 40, h /= 40), u = Math[u >= 1 ? "floor" : "ceil"](u / o), d = Math[d >= 1 ? "floor" : "ceil"](d / o), h = Math[h >= 1 ? "floor" : "ceil"](h / o), c.settings.normalizeOffset && this.getBoundingClientRect) {
                    var y = this.getBoundingClientRect();
                    p = e.clientX - y.left, g = e.clientY - y.top
                }
                return e.deltaX = d, e.deltaY = h, e.deltaFactor = o, e.offsetX = p, e.offsetY = g, e.deltaMode = 0, s.unshift(e, u, d, h), r && clearTimeout(r), r = setTimeout(n, 200), (t.event.dispatch || t.event.handle).apply(this, s)
            }
        }

        function n() { o = null }

        function i(t, e) { return c.settings.adjustOldDeltas && "mousewheel" === t.type && e % 120 === 0 }
        var r, o, a = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
            s = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
            l = Array.prototype.slice;
        if (t.event.fixHooks)
            for (var u = a.length; u;) t.event.fixHooks[a[--u]] = t.event.mouseHooks;
        var c = t.event.special.mousewheel = {
            version: "3.1.12",
            setup: function() {
                if (this.addEventListener)
                    for (var n = s.length; n;) this.addEventListener(s[--n], e, !1);
                else this.onmousewheel = e;
                t.data(this, "mousewheel-line-height", c.getLineHeight(this)), t.data(this, "mousewheel-page-height", c.getPageHeight(this))
            },
            teardown: function() {
                if (this.removeEventListener)
                    for (var n = s.length; n;) this.removeEventListener(s[--n], e, !1);
                else this.onmousewheel = null;
                t.removeData(this, "mousewheel-line-height"), t.removeData(this, "mousewheel-page-height")
            },
            getLineHeight: function(e) {
                var n = t(e),
                    i = n["offsetParent" in t.fn ? "offsetParent" : "parent"]();
                return i.length || (i = t("body")), parseInt(i.css("fontSize"), 10) || parseInt(n.css("fontSize"), 10) || 16
            },
            getPageHeight: function(e) { return t(e).height() },
            settings: { adjustOldDeltas: !0, normalizeOffset: !0 }
        };
        t.fn.extend({ mousewheel: function(t) { return t ? this.bind("mousewheel", t) : this.trigger("mousewheel") }, unmousewheel: function(t) { return this.unbind("mousewheel", t) } })
    })
}, function(t, e, n) {
    var i, r;
    (function() {
        var o = [].indexOf || function(t) {
                for (var e = 0, n = this.length; e < n; e++)
                    if (e in this && this[e] === t) return e;
                return -1
            },
            a = [].slice;
        ! function(o, a) { return i = [n(2)], r = function(t) { return a(t, o) }.apply(e, i), !(void 0 !== r && (t.exports = r)) }(window, function(t, e) {
            var n, i, r, s, l, u, c, d, h, f, p, g, v, m, y, b;
            return n = t(e), d = o.call(e, "ontouchstart") >= 0, s = { horizontal: {}, vertical: {} }, l = 1, c = {}, u = "waypoints-context-id", p = "resize.waypoints", g = "scroll.waypoints", v = 1, m = "waypoints-waypoint-ids", y = "waypoint", b = "waypoints", i = function() {
                function n(n) {
                    var i = this;
                    this.$element = n, this.element = n[0], this.didResize = !1, this.didScroll = !1, this.id = "context" + l++, this.oldScroll = { x: n.scrollLeft(), y: n.scrollTop() }, this.waypoints = { horizontal: {}, vertical: {} }, this.element[u] = this.id, c[this.id] = this, n.bind(g, function() { var n; if (!i.didScroll && !d) return i.didScroll = !0, n = function() { return i.doScroll(), i.didScroll = !1 }, e.setTimeout(n, t[b].settings.scrollThrottle) }), n.bind(p, function() { var n; if (!i.didResize) return i.didResize = !0, n = function() { return t[b]("refresh"), i.didResize = !1 }, e.setTimeout(n, t[b].settings.resizeThrottle) })
                }
                return n.prototype.doScroll = function() { var e, n = this; return e = { horizontal: { newScroll: this.$element.scrollLeft(), oldScroll: this.oldScroll.x, forward: "right", backward: "left" }, vertical: { newScroll: this.$element.scrollTop(), oldScroll: this.oldScroll.y, forward: "down", backward: "up" } }, !d || e.vertical.oldScroll && e.vertical.newScroll || t[b]("refresh"), t.each(e, function(e, i) { var r, o, a; return a = [], o = i.newScroll > i.oldScroll, r = o ? i.forward : i.backward, t.each(n.waypoints[e], function(t, e) { var n, r; return i.oldScroll < (n = e.offset) && n <= i.newScroll ? a.push(e) : i.newScroll < (r = e.offset) && r <= i.oldScroll ? a.push(e) : void 0 }), a.sort(function(t, e) { return t.offset - e.offset }), o || a.reverse(), t.each(a, function(t, e) { if (e.options.continuous || t === a.length - 1) return e.trigger([r]) }) }), this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll } }, n.prototype.refresh = function() { var e, n, i, r = this; return i = t.isWindow(this.element), n = this.$element.offset(), this.doScroll(), e = { horizontal: { contextOffset: i ? 0 : n.left, contextScroll: i ? 0 : this.oldScroll.x, contextDimension: this.$element.width(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left" }, vertical: { contextOffset: i ? 0 : n.top, contextScroll: i ? 0 : this.oldScroll.y, contextDimension: i ? t[b]("viewportHeight") : this.$element.height(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top" } }, t.each(e, function(e, n) { return t.each(r.waypoints[e], function(e, i) { var r, o, a, s, l; if (r = i.options.offset, a = i.offset, o = t.isWindow(i.element) ? 0 : i.$element.offset()[n.offsetProp], t.isFunction(r) ? r = r.apply(i.element) : "string" == typeof r && (r = parseFloat(r), i.options.offset.indexOf("%") > -1 && (r = Math.ceil(n.contextDimension * r / 100))), i.offset = o - n.contextOffset + n.contextScroll - r, (!i.options.onlyOnScroll || null == a) && i.enabled) return null !== a && a < (s = n.oldScroll) && s <= i.offset ? i.trigger([n.backward]) : null !== a && a > (l = n.oldScroll) && l >= i.offset ? i.trigger([n.forward]) : null === a && n.oldScroll >= i.offset ? i.trigger([n.forward]) : void 0 }) }) }, n.prototype.checkEmpty = function() { if (t.isEmptyObject(this.waypoints.horizontal) && t.isEmptyObject(this.waypoints.vertical)) return this.$element.unbind([p, g].join(" ")), delete c[this.id] }, n
            }(), r = function() {
                function e(e, n, i) { var r, o; "bottom-in-view" === i.offset && (i.offset = function() { var e; return e = t[b]("viewportHeight"), t.isWindow(n.element) || (e = n.$element.height()), e - t(this).outerHeight() }), this.$element = e, this.element = e[0], this.axis = i.horizontal ? "horizontal" : "vertical", this.callback = i.handler, this.context = n, this.enabled = i.enabled, this.id = "waypoints" + v++, this.offset = null, this.options = i, n.waypoints[this.axis][this.id] = this, s[this.axis][this.id] = this, r = null != (o = this.element[m]) ? o : [], r.push(this.id), this.element[m] = r }
                return e.prototype.trigger = function(t) { if (this.enabled) return null != this.callback && this.callback.apply(this.element, t), this.options.triggerOnce ? this.destroy() : void 0 }, e.prototype.disable = function() { return this.enabled = !1 }, e.prototype.enable = function() { return this.context.refresh(), this.enabled = !0 }, e.prototype.destroy = function() { return delete s[this.axis][this.id], delete this.context.waypoints[this.axis][this.id], this.context.checkEmpty() }, e.getWaypointsByElement = function(e) { var n, i; return (i = e[m]) ? (n = t.extend({}, s.horizontal, s.vertical), t.map(i, function(t) { return n[t] })) : [] }, e
            }(), f = { init: function(e, n) { var o; return n = t.extend({}, t.fn[y].defaults, n), null == (o = n.handler) && (n.handler = e), this.each(function() { var e, o, a, s; return e = t(this), a = null != (s = n.context) ? s : t.fn[y].defaults.context, t.isWindow(a) || (a = e.closest(a)), a = t(a), o = c[a[0][u]], o || (o = new i(a)), new r(e, o, n) }), t[b]("refresh"), this }, disable: function() { return f._invoke.call(this, "disable") }, enable: function() { return f._invoke.call(this, "enable") }, destroy: function() { return f._invoke.call(this, "destroy") }, prev: function(t, e) { return f._traverse.call(this, t, e, function(t, e, n) { if (e > 0) return t.push(n[e - 1]) }) }, next: function(t, e) { return f._traverse.call(this, t, e, function(t, e, n) { if (e < n.length - 1) return t.push(n[e + 1]) }) }, _traverse: function(n, i, r) { var o, a; return null == n && (n = "vertical"), null == i && (i = e), a = h.aggregate(i), o = [], this.each(function() { var e; return e = t.inArray(this, a[n]), r(o, e, a[n]) }), this.pushStack(o) }, _invoke: function(e) { return this.each(function() { var n; return n = r.getWaypointsByElement(this), t.each(n, function(t, n) { return n[e](), !0 }) }), this } }, t.fn[y] = function() { var e, n; return n = arguments[0], e = 2 <= arguments.length ? a.call(arguments, 1) : [], f[n] ? f[n].apply(this, e) : t.isFunction(n) ? f.init.apply(this, arguments) : t.isPlainObject(n) ? f.init.apply(this, [null, n]) : n ? t.error("The " + n + " method does not exist in jQuery Waypoints.") : t.error("jQuery Waypoints needs a callback function or handler option.") }, t.fn[y].defaults = { context: e, continuous: !0, enabled: !0, horizontal: !1, offset: 0, triggerOnce: !1 }, h = { refresh: function() { return t.each(c, function(t, e) { return e.refresh() }) }, viewportHeight: function() { var t; return null != (t = e.innerHeight) ? t : n.height() }, aggregate: function(e) { var n, i, r; return n = s, e && (n = null != (r = c[t(e)[0][u]]) ? r.waypoints : void 0), n ? (i = { horizontal: [], vertical: [] }, t.each(i, function(e, r) { return t.each(n[e], function(t, e) { return r.push(e) }), r.sort(function(t, e) { return t.offset - e.offset }), i[e] = t.map(r, function(t) { return t.element }), i[e] = t.unique(i[e]) }), i) : [] }, above: function(t) { return null == t && (t = e), h._filter(t, "vertical", function(t, e) { return e.offset <= t.oldScroll.y }) }, below: function(t) { return null == t && (t = e), h._filter(t, "vertical", function(t, e) { return e.offset > t.oldScroll.y }) }, left: function(t) { return null == t && (t = e), h._filter(t, "horizontal", function(t, e) { return e.offset <= t.oldScroll.x }) }, right: function(t) { return null == t && (t = e), h._filter(t, "horizontal", function(t, e) { return e.offset > t.oldScroll.x }) }, enable: function() { return h._invoke("enable") }, disable: function() { return h._invoke("disable") }, destroy: function() { return h._invoke("destroy") }, extendFn: function(t, e) { return f[t] = e }, _invoke: function(e) { var n; return n = t.extend({}, s.vertical, s.horizontal), t.each(n, function(t, n) { return n[e](), !0 }) }, _filter: function(e, n, i) { var r, o; return (r = c[t(e)[0][u]]) ? (o = [], t.each(r.waypoints[n], function(t, e) { if (i(r, e)) return o.push(e) }), o.sort(function(t, e) { return t.offset - e.offset }), t.map(o, function(t) { return t.element })) : [] } }, t[b] = function() { var t, e; return e = arguments[0], t = 2 <= arguments.length ? a.call(arguments, 1) : [], h[e] ? h[e].apply(null, t) : h.aggregate.call(null, e) }, t[b].settings = { resizeThrottle: 100, scrollThrottle: 30 }, n.on("load.waypoints", function() { return t[b]("refresh") })
        })
    }).call(this)
}, , , function(t, e, n) {
    var i, r, o;
    ! function(a) { r = [n(2)], i = a, o = "function" == typeof i ? i.apply(e, r) : i, !(void 0 !== o && (t.exports = o)) }(function(t) {
        var e, n, i, r, o, a, s = "Close",
            l = "BeforeClose",
            u = "AfterClose",
            c = "BeforeAppend",
            d = "MarkupParse",
            h = "Open",
            f = "Change",
            p = "mfp",
            g = "." + p,
            v = "mfp-ready",
            m = "mfp-removing",
            y = "mfp-prevent-close",
            b = function() {},
            x = !!window.jQuery,
            w = t(window),
            k = function(t, n) { e.ev.on(p + t + g, n) },
            S = function(e, n, i, r) { var o = document.createElement("div"); return o.className = "mfp-" + e, i && (o.innerHTML = i), r ? n && n.appendChild(o) : (o = t(o), n && o.appendTo(n)), o },
            _ = function(n, i) { e.ev.triggerHandler(p + n, i), e.st.callbacks && (n = n.charAt(0).toLowerCase() + n.slice(1), e.st.callbacks[n] && e.st.callbacks[n].apply(e, t.isArray(i) ? i : [i])) },
            T = function(n) { return n === a && e.currTemplate.closeBtn || (e.currTemplate.closeBtn = t(e.st.closeMarkup.replace("%title%", e.st.tClose)), a = n), e.currTemplate.closeBtn },
            C = function() { t.magnificPopup.instance || (e = new b, e.init(), t.magnificPopup.instance = e) },
            M = function() {
                var t = document.createElement("p").style,
                    e = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== t.transition) return !0;
                for (; e.length;)
                    if (e.pop() + "Transition" in t) return !0;
                return !1
            };
        b.prototype = {
            constructor: b,
            init: function() {
                var n = navigator.appVersion;
                e.isLowIE = e.isIE8 = document.all && !document.addEventListener, e.isAndroid = /android/gi.test(n), e.isIOS = /iphone|ipad|ipod/gi.test(n), e.supportsTransition = M(), e.probablyMobile = e.isAndroid || e.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), i = t(document), e.popupsCache = {}
            },
            open: function(n) {
                var r;
                if (n.isObj === !1) {
                    e.items = n.items.toArray(), e.index = 0;
                    var a, s = n.items;
                    for (r = 0; r < s.length; r++)
                        if (a = s[r], a.parsed && (a = a.el[0]), a === n.el[0]) { e.index = r; break }
                } else e.items = t.isArray(n.items) ? n.items : [n.items], e.index = n.index || 0;
                if (e.isOpen) return void e.updateItemHTML();
                e.types = [], o = "", n.mainEl && n.mainEl.length ? e.ev = n.mainEl.eq(0) : e.ev = i, n.key ? (e.popupsCache[n.key] || (e.popupsCache[n.key] = {}), e.currTemplate = e.popupsCache[n.key]) : e.currTemplate = {}, e.st = t.extend(!0, {}, t.magnificPopup.defaults, n), e.fixedContentPos = "auto" === e.st.fixedContentPos ? !e.probablyMobile : e.st.fixedContentPos, e.st.modal && (e.st.closeOnContentClick = !1, e.st.closeOnBgClick = !1, e.st.showCloseBtn = !1, e.st.enableEscapeKey = !1), e.bgOverlay || (e.bgOverlay = S("bg").on("click" + g, function() { e.close() }), e.wrap = S("wrap").attr("tabindex", -1).on("click" + g, function(t) { e._checkIfClose(t.target) && e.close() }), e.container = S("container", e.wrap)), e.contentContainer = S("content"), e.st.preloader && (e.preloader = S("preloader", e.container, e.st.tLoading));
                var l = t.magnificPopup.modules;
                for (r = 0; r < l.length; r++) {
                    var u = l[r];
                    u = u.charAt(0).toUpperCase() + u.slice(1), e["init" + u].call(e)
                }
                _("BeforeOpen"), e.st.showCloseBtn && (e.st.closeBtnInside ? (k(d, function(t, e, n, i) { n.close_replaceWith = T(i.type) }), o += " mfp-close-btn-in") : e.wrap.append(T())), e.st.alignTop && (o += " mfp-align-top"), e.fixedContentPos ? e.wrap.css({ overflow: e.st.overflowY, overflowX: "hidden", overflowY: e.st.overflowY }) : e.wrap.css({ top: w.scrollTop(), position: "absolute" }), (e.st.fixedBgPos === !1 || "auto" === e.st.fixedBgPos && !e.fixedContentPos) && e.bgOverlay.css({ height: i.height(), position: "absolute" }), e.st.enableEscapeKey && i.on("keyup" + g, function(t) { 27 === t.keyCode && e.close() }), w.on("resize" + g, function() { e.updateSize() }), e.st.closeOnContentClick || (o += " mfp-auto-cursor"), o && e.wrap.addClass(o);
                var c = e.wH = w.height(),
                    f = {};
                if (e.fixedContentPos && e._hasScrollBar(c)) {
                    var p = e._getScrollbarSize();
                    p && (f.marginRight = p)
                }
                e.fixedContentPos && (e.isIE7 ? t("body, html").css("overflow", "hidden") : f.overflow = "hidden");
                var m = e.st.mainClass;
                return e.isIE7 && (m += " mfp-ie7"), m && e._addClassToMFP(m), e.updateItemHTML(), _("BuildControls"), t("html").css(f), e.bgOverlay.add(e.wrap).prependTo(e.st.prependTo || t(document.body)), e._lastFocusedEl = document.activeElement, setTimeout(function() { e.content ? (e._addClassToMFP(v), e._setFocus()) : e.bgOverlay.addClass(v), i.on("focusin" + g, e._onFocusIn) }, 16), e.isOpen = !0, e.updateSize(c), _(h), n
            },
            close: function() { e.isOpen && (_(l), e.isOpen = !1, e.st.removalDelay && !e.isLowIE && e.supportsTransition ? (e._addClassToMFP(m), setTimeout(function() { e._close() }, e.st.removalDelay)) : e._close()) },
            _close: function() {
                _(s);
                var n = m + " " + v + " ";
                if (e.bgOverlay.detach(), e.wrap.detach(), e.container.empty(), e.st.mainClass && (n += e.st.mainClass + " "), e._removeClassFromMFP(n), e.fixedContentPos) {
                    var r = { marginRight: "" };
                    e.isIE7 ? t("body, html").css("overflow", "") : r.overflow = "", t("html").css(r)
                }
                i.off("keyup" + g + " focusin" + g), e.ev.off(g), e.wrap.attr("class", "mfp-wrap").removeAttr("style"), e.bgOverlay.attr("class", "mfp-bg"), e.container.attr("class", "mfp-container"), !e.st.showCloseBtn || e.st.closeBtnInside && e.currTemplate[e.currItem.type] !== !0 || e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach(), e.st.autoFocusLast && e._lastFocusedEl && t(e._lastFocusedEl).focus(), e.currItem = null, e.content = null, e.currTemplate = null, e.prevHeight = 0, _(u)
            },
            updateSize: function(t) {
                if (e.isIOS) {
                    var n = document.documentElement.clientWidth / window.innerWidth,
                        i = window.innerHeight * n;
                    e.wrap.css("height", i), e.wH = i
                } else e.wH = t || w.height();
                e.fixedContentPos || e.wrap.css("height", e.wH), _("Resize")
            },
            updateItemHTML: function() {
                var n = e.items[e.index];
                e.contentContainer.detach(), e.content && e.content.detach(), n.parsed || (n = e.parseEl(e.index));
                var i = n.type;
                if (_("BeforeChange", [e.currItem ? e.currItem.type : "", i]), e.currItem = n, !e.currTemplate[i]) {
                    var o = !!e.st[i] && e.st[i].markup;
                    _("FirstMarkupParse", o), o ? e.currTemplate[i] = t(o) : e.currTemplate[i] = !0
                }
                r && r !== n.type && e.container.removeClass("mfp-" + r + "-holder");
                var a = e["get" + i.charAt(0).toUpperCase() + i.slice(1)](n, e.currTemplate[i]);
                e.appendContent(a, i), n.preloaded = !0, _(f, n), r = n.type, e.container.prepend(e.contentContainer), _("AfterChange")
            },
            appendContent: function(t, n) { e.content = t, t ? e.st.showCloseBtn && e.st.closeBtnInside && e.currTemplate[n] === !0 ? e.content.find(".mfp-close").length || e.content.append(T()) : e.content = t : e.content = "", _(c), e.container.addClass("mfp-" + n + "-holder"), e.contentContainer.append(e.content) },
            parseEl: function(n) {
                var i, r = e.items[n];
                if (r.tagName ? r = { el: t(r) } : (i = r.type, r = { data: r, src: r.src }), r.el) {
                    for (var o = e.types, a = 0; a < o.length; a++)
                        if (r.el.hasClass("mfp-" + o[a])) { i = o[a]; break } r.src = r.el.attr("data-mfp-src"), r.src || (r.src = r.el.attr("href"))
                }
                return r.type = i || e.st.type || "inline", r.index = n, r.parsed = !0, e.items[n] = r, _("ElementParse", r), e.items[n]
            },
            addGroup: function(t, n) {
                var i = function(i) { i.mfpEl = this, e._openClick(i, t, n) };
                n || (n = {});
                var r = "click.magnificPopup";
                n.mainEl = t, n.items ? (n.isObj = !0, t.off(r).on(r, i)) : (n.isObj = !1, n.delegate ? t.off(r).on(r, n.delegate, i) : (n.items = t, t.off(r).on(r, i)))
            },
            _openClick: function(n, i, r) {
                var o = void 0 !== r.midClick ? r.midClick : t.magnificPopup.defaults.midClick;
                if (o || !(2 === n.which || n.ctrlKey || n.metaKey || n.altKey || n.shiftKey)) {
                    var a = void 0 !== r.disableOn ? r.disableOn : t.magnificPopup.defaults.disableOn;
                    if (a)
                        if (t.isFunction(a)) { if (!a.call(e)) return !0 } else if (w.width() < a) return !0;
                    n.type && (n.preventDefault(), e.isOpen && n.stopPropagation()), r.el = t(n.mfpEl), r.delegate && (r.items = i.find(r.delegate)), e.open(r)
                }
            },
            updateStatus: function(t, i) {
                if (e.preloader) {
                    n !== t && e.container.removeClass("mfp-s-" + n), i || "loading" !== t || (i = e.st.tLoading);
                    var r = { status: t, text: i };
                    _("UpdateStatus", r), t = r.status, i = r.text, e.preloader.html(i), e.preloader.find("a").on("click", function(t) { t.stopImmediatePropagation() }), e.container.addClass("mfp-s-" + t), n = t
                }
            },
            _checkIfClose: function(n) {
                if (!t(n).hasClass(y)) {
                    var i = e.st.closeOnContentClick,
                        r = e.st.closeOnBgClick;
                    if (i && r) return !0;
                    if (!e.content || t(n).hasClass("mfp-close") || e.preloader && n === e.preloader[0]) return !0;
                    if (n === e.content[0] || t.contains(e.content[0], n)) { if (i) return !0 } else if (r && t.contains(document, n)) return !0;
                    return !1
                }
            },
            _addClassToMFP: function(t) { e.bgOverlay.addClass(t), e.wrap.addClass(t) },
            _removeClassFromMFP: function(t) { this.bgOverlay.removeClass(t), e.wrap.removeClass(t) },
            _hasScrollBar: function(t) { return (e.isIE7 ? i.height() : document.body.scrollHeight) > (t || w.height()) },
            _setFocus: function() {
                (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus()
            },
            _onFocusIn: function(n) { if (n.target !== e.wrap[0] && !t.contains(e.wrap[0], n.target)) return e._setFocus(), !1 },
            _parseMarkup: function(e, n, i) {
                var r;
                i.data && (n = t.extend(i.data, n)), _(d, [e, n, i]), t.each(n, function(n, i) { if (void 0 === i || i === !1) return !0; if (r = n.split("_"), r.length > 1) { var o = e.find(g + "-" + r[0]); if (o.length > 0) { var a = r[1]; "replaceWith" === a ? o[0] !== i[0] && o.replaceWith(i) : "img" === a ? o.is("img") ? o.attr("src", i) : o.replaceWith(t("<img>").attr("src", i).attr("class", o.attr("class"))) : o.attr(r[1], i) } } else e.find(g + "-" + n).html(i) })
            },
            _getScrollbarSize: function() {
                if (void 0 === e.scrollbarSize) {
                    var t = document.createElement("div");
                    t.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), e.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)
                }
                return e.scrollbarSize
            }
        }, t.magnificPopup = { instance: null, proto: b.prototype, modules: [], open: function(e, n) { return C(), e = e ? t.extend(!0, {}, e) : {}, e.isObj = !0, e.index = n || 0, this.instance.open(e); }, close: function() { return t.magnificPopup.instance && t.magnificPopup.instance.close() }, registerModule: function(e, n) { n.options && (t.magnificPopup.defaults[e] = n.options), t.extend(this.proto, n.proto), this.modules.push(e) }, defaults: { disableOn: 0, key: null, midClick: !1, mainClass: "", preloader: !0, focus: "", closeOnContentClick: !1, closeOnBgClick: !0, closeBtnInside: !0, showCloseBtn: !0, enableEscapeKey: !0, modal: !1, alignTop: !1, removalDelay: 0, prependTo: null, fixedContentPos: "auto", fixedBgPos: "auto", overflowY: "auto", closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>', tClose: "Close (Esc)", tLoading: "Loading...", autoFocusLast: !0 } }, t.fn.magnificPopup = function(n) {
            C();
            var i = t(this);
            if ("string" == typeof n)
                if ("open" === n) {
                    var r, o = x ? i.data("magnificPopup") : i[0].magnificPopup,
                        a = parseInt(arguments[1], 10) || 0;
                    o.items ? r = o.items[a] : (r = i, o.delegate && (r = r.find(o.delegate)), r = r.eq(a)), e._openClick({ mfpEl: r }, i, o)
                } else e.isOpen && e[n].apply(e, Array.prototype.slice.call(arguments, 1));
            else n = t.extend(!0, {}, n), x ? i.data("magnificPopup", n) : i[0].magnificPopup = n, e.addGroup(i, n);
            return i
        };
        var A, E, P, I = "inline",
            z = function() { P && (E.after(P.addClass(A)).detach(), P = null) };
        t.magnificPopup.registerModule(I, {
            options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
            proto: {
                initInline: function() { e.types.push(I), k(s + "." + I, function() { z() }) },
                getInline: function(n, i) {
                    if (z(), n.src) {
                        var r = e.st.inline,
                            o = t(n.src);
                        if (o.length) {
                            var a = o[0].parentNode;
                            a && a.tagName && (E || (A = r.hiddenClass, E = S(A), A = "mfp-" + A), P = o.after(E).detach().removeClass(A)), e.updateStatus("ready")
                        } else e.updateStatus("error", r.tNotFound), o = t("<div>");
                        return n.inlineElement = o, o
                    }
                    return e.updateStatus("ready"), e._parseMarkup(i, {}, n), i
                }
            }
        });
        var D, O = "ajax",
            L = function() { D && t(document.body).removeClass(D) },
            $ = function() { L(), e.req && e.req.abort() };
        t.magnificPopup.registerModule(O, {
            options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' },
            proto: {
                initAjax: function() { e.types.push(O), D = e.st.ajax.cursor, k(s + "." + O, $), k("BeforeChange." + O, $) },
                getAjax: function(n) {
                    D && t(document.body).addClass(D), e.updateStatus("loading");
                    var i = t.extend({
                        url: n.src,
                        success: function(i, r, o) {
                            var a = { data: i, xhr: o };
                            _("ParseAjax", a), e.appendContent(t(a.data), O), n.finished = !0, L(), e._setFocus(), setTimeout(function() { e.wrap.addClass(v) }, 16), e.updateStatus("ready"), _("AjaxContentAdded")
                        },
                        error: function() { L(), n.finished = n.loadError = !0, e.updateStatus("error", e.st.ajax.tError.replace("%url%", n.src)) }
                    }, e.st.ajax.settings);
                    return e.req = t.ajax(i), ""
                }
            }
        });
        var N, R = function(n) { if (n.data && void 0 !== n.data.title) return n.data.title; var i = e.st.image.titleSrc; if (i) { if (t.isFunction(i)) return i.call(e, n); if (n.el) return n.el.attr(i) || "" } return "" };
        t.magnificPopup.registerModule("image", {
            options: { markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>', cursor: "mfp-zoom-out-cur", titleSrc: "title", verticalFit: !0, tError: '<a href="%url%">The image</a> could not be loaded.' },
            proto: {
                initImage: function() {
                    var n = e.st.image,
                        i = ".image";
                    e.types.push("image"), k(h + i, function() { "image" === e.currItem.type && n.cursor && t(document.body).addClass(n.cursor) }), k(s + i, function() { n.cursor && t(document.body).removeClass(n.cursor), w.off("resize" + g) }), k("Resize" + i, e.resizeImage), e.isLowIE && k("AfterChange", e.resizeImage)
                },
                resizeImage: function() {
                    var t = e.currItem;
                    if (t && t.img && e.st.image.verticalFit) {
                        var n = 0;
                        e.isLowIE && (n = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)), t.img.css("max-height", e.wH - n)
                    }
                },
                _onImageHasSize: function(t) { t.img && (t.hasSize = !0, N && clearInterval(N), t.isCheckingImgSize = !1, _("ImageHasSize", t), t.imgHidden && (e.content && e.content.removeClass("mfp-loading"), t.imgHidden = !1)) },
                findImageSize: function(t) {
                    var n = 0,
                        i = t.img[0],
                        r = function(o) { N && clearInterval(N), N = setInterval(function() { return i.naturalWidth > 0 ? void e._onImageHasSize(t) : (n > 200 && clearInterval(N), n++, void(3 === n ? r(10) : 40 === n ? r(50) : 100 === n && r(500))) }, o) };
                    r(1)
                },
                getImage: function(n, i) {
                    var r = 0,
                        o = function() { n && (n.img[0].complete ? (n.img.off(".mfploader"), n === e.currItem && (e._onImageHasSize(n), e.updateStatus("ready")), n.hasSize = !0, n.loaded = !0, _("ImageLoadComplete")) : (r++, r < 200 ? setTimeout(o, 100) : a())) },
                        a = function() { n && (n.img.off(".mfploader"), n === e.currItem && (e._onImageHasSize(n), e.updateStatus("error", s.tError.replace("%url%", n.src))), n.hasSize = !0, n.loaded = !0, n.loadError = !0) },
                        s = e.st.image,
                        l = i.find(".mfp-img");
                    if (l.length) {
                        var u = document.createElement("img");
                        u.className = "mfp-img", n.el && n.el.find("img").length && (u.alt = n.el.find("img").attr("alt")), n.img = t(u).on("load.mfploader", o).on("error.mfploader", a), u.src = n.src, l.is("img") && (n.img = n.img.clone()), u = n.img[0], u.naturalWidth > 0 ? n.hasSize = !0 : u.width || (n.hasSize = !1)
                    }
                    return e._parseMarkup(i, { title: R(n), img_replaceWith: n.img }, n), e.resizeImage(), n.hasSize ? (N && clearInterval(N), n.loadError ? (i.addClass("mfp-loading"), e.updateStatus("error", s.tError.replace("%url%", n.src))) : (i.removeClass("mfp-loading"), e.updateStatus("ready")), i) : (e.updateStatus("loading"), n.loading = !0, n.hasSize || (n.imgHidden = !0, i.addClass("mfp-loading"), e.findImageSize(n)), i)
                }
            }
        });
        var q, F = function() { return void 0 === q && (q = void 0 !== document.createElement("p").style.MozTransform), q };
        t.magnificPopup.registerModule("zoom", {
            options: { enabled: !1, easing: "ease-in-out", duration: 300, opener: function(t) { return t.is("img") ? t : t.find("img") } },
            proto: {
                initZoom: function() {
                    var t, n = e.st.zoom,
                        i = ".zoom";
                    if (n.enabled && e.supportsTransition) {
                        var r, o, a = n.duration,
                            u = function(t) {
                                var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                    i = "all " + n.duration / 1e3 + "s " + n.easing,
                                    r = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                                    o = "transition";
                                return r["-webkit-" + o] = r["-moz-" + o] = r["-o-" + o] = r[o] = i, e.css(r), e
                            },
                            c = function() { e.content.css("visibility", "visible") };
                        k("BuildControls" + i, function() {
                            if (e._allowZoom()) {
                                if (clearTimeout(r), e.content.css("visibility", "hidden"), t = e._getItemToZoom(), !t) return void c();
                                o = u(t), o.css(e._getOffset()), e.wrap.append(o), r = setTimeout(function() { o.css(e._getOffset(!0)), r = setTimeout(function() { c(), setTimeout(function() { o.remove(), t = o = null, _("ZoomAnimationEnded") }, 16) }, a) }, 16)
                            }
                        }), k(l + i, function() {
                            if (e._allowZoom()) {
                                if (clearTimeout(r), e.st.removalDelay = a, !t) {
                                    if (t = e._getItemToZoom(), !t) return;
                                    o = u(t)
                                }
                                o.css(e._getOffset(!0)), e.wrap.append(o), e.content.css("visibility", "hidden"), setTimeout(function() { o.css(e._getOffset()) }, 16)
                            }
                        }), k(s + i, function() { e._allowZoom() && (c(), o && o.remove(), t = null) })
                    }
                },
                _allowZoom: function() { return "image" === e.currItem.type },
                _getItemToZoom: function() { return !!e.currItem.hasSize && e.currItem.img },
                _getOffset: function(n) {
                    var i;
                    i = n ? e.currItem.img : e.st.zoom.opener(e.currItem.el || e.currItem);
                    var r = i.offset(),
                        o = parseInt(i.css("padding-top"), 10),
                        a = parseInt(i.css("padding-bottom"), 10);
                    r.top -= t(window).scrollTop() - o;
                    var s = { width: i.width(), height: (x ? i.innerHeight() : i[0].offsetHeight) - a - o };
                    return F() ? s["-moz-transform"] = s.transform = "translate(" + r.left + "px," + r.top + "px)" : (s.left = r.left, s.top = r.top), s
                }
            }
        });
        var H = "iframe",
            B = "//about:blank",
            W = function(t) {
                if (e.currTemplate[H]) {
                    var n = e.currTemplate[H].find("iframe");
                    n.length && (t || (n[0].src = B), e.isIE8 && n.css("display", t ? "block" : "none"))
                }
            };
        t.magnificPopup.registerModule(H, {
            options: { markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>', srcAction: "iframe_src", patterns: { youtube: { index: "youtube.com", id: "v=", src: "//www.youtube.com/embed/%id%?autoplay=1" }, vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" }, gmaps: { index: "//maps.google.", src: "%id%&output=embed" } } },
            proto: {
                initIframe: function() { e.types.push(H), k("BeforeChange", function(t, e, n) { e !== n && (e === H ? W() : n === H && W(!0)) }), k(s + "." + H, function() { W() }) },
                getIframe: function(n, i) {
                    var r = n.src,
                        o = e.st.iframe;
                    t.each(o.patterns, function() { if (r.indexOf(this.index) > -1) return this.id && (r = "string" == typeof this.id ? r.substr(r.lastIndexOf(this.id) + this.id.length, r.length) : this.id.call(this, r)), r = this.src.replace("%id%", r), !1 });
                    var a = {};
                    return o.srcAction && (a[o.srcAction] = r), e._parseMarkup(i, a, n), e.updateStatus("ready"), i
                }
            }
        });
        var j = function(t) { var n = e.items.length; return t > n - 1 ? t - n : t < 0 ? n + t : t },
            Y = function(t, e, n) { return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, n) };
        t.magnificPopup.registerModule("gallery", {
            options: { enabled: !1, arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', preload: [0, 2], navigateByImgClick: !0, arrows: !0, tPrev: "Previous (Left arrow key)", tNext: "Next (Right arrow key)", tCounter: "%curr% of %total%" },
            proto: {
                initGallery: function() {
                    var n = e.st.gallery,
                        r = ".mfp-gallery";
                    return e.direction = !0, !(!n || !n.enabled) && (o += " mfp-gallery", k(h + r, function() { n.navigateByImgClick && e.wrap.on("click" + r, ".mfp-img", function() { if (e.items.length > 1) return e.next(), !1 }), i.on("keydown" + r, function(t) { 37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next() }) }), k("UpdateStatus" + r, function(t, n) { n.text && (n.text = Y(n.text, e.currItem.index, e.items.length)) }), k(d + r, function(t, i, r, o) {
                        var a = e.items.length;
                        r.counter = a > 1 ? Y(n.tCounter, o.index, a) : ""
                    }), k("BuildControls" + r, function() {
                        if (e.items.length > 1 && n.arrows && !e.arrowLeft) {
                            var i = n.arrowMarkup,
                                r = e.arrowLeft = t(i.replace(/%title%/gi, n.tPrev).replace(/%dir%/gi, "left")).addClass(y),
                                o = e.arrowRight = t(i.replace(/%title%/gi, n.tNext).replace(/%dir%/gi, "right")).addClass(y);
                            r.click(function() { e.prev() }), o.click(function() { e.next() }), e.container.append(r.add(o))
                        }
                    }), k(f + r, function() { e._preloadTimeout && clearTimeout(e._preloadTimeout), e._preloadTimeout = setTimeout(function() { e.preloadNearbyImages(), e._preloadTimeout = null }, 16) }), void k(s + r, function() { i.off(r), e.wrap.off("click" + r), e.arrowRight = e.arrowLeft = null }))
                },
                next: function() { e.direction = !0, e.index = j(e.index + 1), e.updateItemHTML() },
                prev: function() { e.direction = !1, e.index = j(e.index - 1), e.updateItemHTML() },
                goTo: function(t) { e.direction = t >= e.index, e.index = t, e.updateItemHTML() },
                preloadNearbyImages: function() {
                    var t, n = e.st.gallery.preload,
                        i = Math.min(n[0], e.items.length),
                        r = Math.min(n[1], e.items.length);
                    for (t = 1; t <= (e.direction ? r : i); t++) e._preloadItem(e.index + t);
                    for (t = 1; t <= (e.direction ? i : r); t++) e._preloadItem(e.index - t)
                },
                _preloadItem: function(n) {
                    if (n = j(n), !e.items[n].preloaded) {
                        var i = e.items[n];
                        i.parsed || (i = e.parseEl(n)), _("LazyLoad", i), "image" === i.type && (i.img = t('<img class="mfp-img" />').on("load.mfploader", function() { i.hasSize = !0 }).on("error.mfploader", function() { i.hasSize = !0, i.loadError = !0, _("LazyLoadError", i) }).attr("src", i.src)), i.preloaded = !0
                    }
                }
            }
        });
        var U = "retina";
        t.magnificPopup.registerModule(U, {
            options: { replaceSrc: function(t) { return t.src.replace(/\.\w+$/, function(t) { return "@2x" + t }) }, ratio: 1 },
            proto: {
                initRetina: function() {
                    if (window.devicePixelRatio > 1) {
                        var t = e.st.retina,
                            n = t.ratio;
                        n = isNaN(n) ? n() : n, n > 1 && (k("ImageHasSize." + U, function(t, e) { e.img.css({ "max-width": e.img[0].naturalWidth / n, width: "100%" }) }), k("ElementParse." + U, function(e, i) { i.src = t.replaceSrc(i, n) }))
                    }
                }
            }
        }), C()
    })
}, , , function(t, e, n) {
    var i, r, o;
    (function(a) {
        ! function(a) { r = [n(2)], i = a, o = "function" == typeof i ? i.apply(e, r) : i, !(void 0 !== o && (t.exports = o)) }(function(t) {
            var e = function() {
                    if (t && t.fn && t.fn.select2 && t.fn.select2.amd) var e = t.fn.select2.amd;
                    var e;
                    return function() {
                        if (!e || !e.requirejs) {
                            e ? n = e : e = {};
                            var t, n, i;
                            ! function(e) {
                                function r(t, e) { return w.call(t, e) }

                                function o(t, e) {
                                    var n, i, r, o, a, s, l, u, c, d, h, f, p = e && e.split("/"),
                                        g = b.map,
                                        v = g && g["*"] || {};
                                    if (t) {
                                        for (t = t.split("/"), a = t.length - 1, b.nodeIdCompat && S.test(t[a]) && (t[a] = t[a].replace(S, "")), "." === t[0].charAt(0) && p && (f = p.slice(0, p.length - 1), t = f.concat(t)), c = 0; c < t.length; c++)
                                            if (h = t[c], "." === h) t.splice(c, 1), c -= 1;
                                            else if (".." === h) {
                                            if (0 === c || 1 === c && ".." === t[2] || ".." === t[c - 1]) continue;
                                            c > 0 && (t.splice(c - 1, 2), c -= 2)
                                        }
                                        t = t.join("/")
                                    }
                                    if ((p || v) && g) {
                                        for (n = t.split("/"), c = n.length; c > 0; c -= 1) {
                                            if (i = n.slice(0, c).join("/"), p)
                                                for (d = p.length; d > 0; d -= 1)
                                                    if (r = g[p.slice(0, d).join("/")], r && (r = r[i])) { o = r, s = c; break } if (o) break;
                                            !l && v && v[i] && (l = v[i], u = c)
                                        }!o && l && (o = l, s = u), o && (n.splice(0, s, o), t = n.join("/"))
                                    }
                                    return t
                                }

                                function a(t, n) { return function() { var i = k.call(arguments, 0); return "string" != typeof i[0] && 1 === i.length && i.push(null), p.apply(e, i.concat([t, n])) } }

                                function s(t) { return function(e) { return o(e, t) } }

                                function l(t) { return function(e) { m[t] = e } }

                                function u(t) {
                                    if (r(y, t)) {
                                        var n = y[t];
                                        delete y[t], x[t] = !0, f.apply(e, n)
                                    }
                                    if (!r(m, t) && !r(x, t)) throw new Error("No " + t);
                                    return m[t]
                                }

                                function c(t) { var e, n = t ? t.indexOf("!") : -1; return n > -1 && (e = t.substring(0, n), t = t.substring(n + 1, t.length)), [e, t] }

                                function d(t) { return t ? c(t) : [] }

                                function h(t) { return function() { return b && b.config && b.config[t] || {} } }
                                var f, p, g, v, m = {},
                                    y = {},
                                    b = {},
                                    x = {},
                                    w = Object.prototype.hasOwnProperty,
                                    k = [].slice,
                                    S = /\.js$/;
                                g = function(t, e) {
                                    var n, i = c(t),
                                        r = i[0],
                                        a = e[1];
                                    return t = i[1], r && (r = o(r, a), n = u(r)), r ? t = n && n.normalize ? n.normalize(t, s(a)) : o(t, a) : (t = o(t, a), i = c(t), r = i[0], t = i[1], r && (n = u(r))), { f: r ? r + "!" + t : t, n: t, pr: r, p: n }
                                }, v = { require: function(t) { return a(t) }, exports: function(t) { var e = m[t]; return "undefined" != typeof e ? e : m[t] = {} }, module: function(t) { return { id: t, uri: "", exports: m[t], config: h(t) } } }, f = function(t, n, i, o) {
                                    var s, c, h, f, p, b, w, k = [],
                                        S = typeof i;
                                    if (o = o || t, b = d(o), "undefined" === S || "function" === S) {
                                        for (n = !n.length && i.length ? ["require", "exports", "module"] : n, p = 0; p < n.length; p += 1)
                                            if (f = g(n[p], b), c = f.f, "require" === c) k[p] = v.require(t);
                                            else if ("exports" === c) k[p] = v.exports(t), w = !0;
                                        else if ("module" === c) s = k[p] = v.module(t);
                                        else if (r(m, c) || r(y, c) || r(x, c)) k[p] = u(c);
                                        else {
                                            if (!f.p) throw new Error(t + " missing " + c);
                                            f.p.load(f.n, a(o, !0), l(c), {}), k[p] = m[c]
                                        }
                                        h = i ? i.apply(m[t], k) : void 0, t && (s && s.exports !== e && s.exports !== m[t] ? m[t] = s.exports : h === e && w || (m[t] = h))
                                    } else t && (m[t] = i)
                                }, t = n = p = function(t, n, i, r, o) {
                                    if ("string" == typeof t) return v[t] ? v[t](n) : u(g(t, d(n)).f);
                                    if (!t.splice) {
                                        if (b = t, b.deps && p(b.deps, b.callback), !n) return;
                                        n.splice ? (t = n, n = i, i = null) : t = e
                                    }
                                    return n = n || function() {}, "function" == typeof i && (i = r, r = o), r ? f(e, t, n, i) : setTimeout(function() { f(e, t, n, i) }, 4), p
                                }, p.config = function(t) { return p(t) }, t._defined = m, i = function(t, e, n) {
                                    if ("string" != typeof t) throw new Error("See almond README: incorrect module build, no module name");
                                    e.splice || (n = e, e = []), r(m, t) || r(y, t) || (y[t] = [t, e, n])
                                }, i.amd = { jQuery: !0 }
                            }(), e.requirejs = t, e.require = n, e.define = i
                        }
                    }(), e.define("almond", function() {}), e.define("jquery", [], function() { var e = t || a; return null == e && console && console.error, e }), e.define("select2/utils", ["jquery"], function(t) {
                        function e(t) {
                            var e = t.prototype,
                                n = [];
                            for (var i in e) { var r = e[i]; "function" == typeof r && "constructor" !== i && n.push(i) }
                            return n
                        }
                        var n = {};
                        n.Extend = function(t, e) {
                            function n() { this.constructor = t }
                            var i = {}.hasOwnProperty;
                            for (var r in e) i.call(e, r) && (t[r] = e[r]);
                            return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t
                        }, n.Decorate = function(t, n) {
                            function i() {
                                var e = Array.prototype.unshift,
                                    i = n.prototype.constructor.length,
                                    r = t.prototype.constructor;
                                i > 0 && (e.call(arguments, t.prototype.constructor), r = n.prototype.constructor), r.apply(this, arguments)
                            }

                            function r() { this.constructor = i }
                            var o = e(n),
                                a = e(t);
                            n.displayName = t.displayName, i.prototype = new r;
                            for (var s = 0; s < a.length; s++) {
                                var l = a[s];
                                i.prototype[l] = t.prototype[l]
                            }
                            for (var u = (function(t) {
                                    var e = function() {};
                                    t in i.prototype && (e = i.prototype[t]);
                                    var r = n.prototype[t];
                                    return function() { var t = Array.prototype.unshift; return t.call(arguments, e), r.apply(this, arguments) }
                                }), c = 0; c < o.length; c++) {
                                var d = o[c];
                                i.prototype[d] = u(d)
                            }
                            return i
                        };
                        var i = function() { this.listeners = {} };
                        return i.prototype.on = function(t, e) { this.listeners = this.listeners || {}, t in this.listeners ? this.listeners[t].push(e) : this.listeners[t] = [e] }, i.prototype.trigger = function(t) {
                            var e = Array.prototype.slice,
                                n = e.call(arguments, 1);
                            this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), n[0]._type = t, t in this.listeners && this.invoke(this.listeners[t], e.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
                        }, i.prototype.invoke = function(t, e) { for (var n = 0, i = t.length; n < i; n++) t[n].apply(this, e) }, n.Observable = i, n.generateChars = function(t) {
                            for (var e = "", n = 0; n < t; n++) {
                                var i = Math.floor(36 * Math.random());
                                e += i.toString(36)
                            }
                            return e
                        }, n.bind = function(t, e) { return function() { t.apply(e, arguments) } }, n._convertData = function(t) {
                            for (var e in t) {
                                var n = e.split("-"),
                                    i = t;
                                if (1 !== n.length) {
                                    for (var r = 0; r < n.length; r++) {
                                        var o = n[r];
                                        o = o.substring(0, 1).toLowerCase() + o.substring(1), o in i || (i[o] = {}), r == n.length - 1 && (i[o] = t[e]), i = i[o]
                                    }
                                    delete t[e]
                                }
                            }
                            return t
                        }, n.hasScroll = function(e, n) {
                            var i = t(n),
                                r = n.style.overflowX,
                                o = n.style.overflowY;
                            return (r !== o || "hidden" !== o && "visible" !== o) && ("scroll" === r || "scroll" === o || (i.innerHeight() < n.scrollHeight || i.innerWidth() < n.scrollWidth))
                        }, n.escapeMarkup = function(t) { var e = { "\\": "&#92;", "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#47;" }; return "string" != typeof t ? t : String(t).replace(/[&<>"'\/\\]/g, function(t) { return e[t] }) }, n.appendMany = function(e, n) {
                            if ("1.7" === t.fn.jquery.substr(0, 3)) {
                                var i = t();
                                t.map(n, function(t) { i = i.add(t) }), n = i
                            }
                            e.append(n)
                        }, n
                    }), e.define("select2/results", ["jquery", "./utils"], function(t, e) {
                        function n(t, e, i) { this.$element = t, this.data = i, this.options = e, n.__super__.constructor.call(this) }
                        return e.Extend(n, e.Observable), n.prototype.render = function() { var e = t('<ul class="select2-results__options" role="tree"></ul>'); return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e, e }, n.prototype.clear = function() { this.$results.empty() }, n.prototype.displayMessage = function(e) {
                            var n = this.options.get("escapeMarkup");
                            this.clear(), this.hideLoading();
                            var i = t('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),
                                r = this.options.get("translations").get(e.message);
                            i.append(n(r(e.args))), i[0].className += " select2-results__message", this.$results.append(i)
                        }, n.prototype.hideMessages = function() { this.$results.find(".select2-results__message").remove() }, n.prototype.append = function(t) {
                            this.hideLoading();
                            var e = [];
                            if (null == t.results || 0 === t.results.length) return void(0 === this.$results.children().length && this.trigger("results:message", { message: "noResults" }));
                            t.results = this.sort(t.results);
                            for (var n = 0; n < t.results.length; n++) {
                                var i = t.results[n],
                                    r = this.option(i);
                                e.push(r)
                            }
                            this.$results.append(e)
                        }, n.prototype.position = function(t, e) {
                            var n = e.find(".select2-results");
                            n.append(t)
                        }, n.prototype.sort = function(t) { var e = this.options.get("sorter"); return e(t) }, n.prototype.highlightFirstItem = function() {
                            var t = this.$results.find(".select2-results__option[aria-selected]"),
                                e = t.filter("[aria-selected=true]");
                            e.length > 0 ? e.first().trigger("mouseenter") : t.first().trigger("mouseenter"), this.ensureHighlightVisible()
                        }, n.prototype.setClasses = function() {
                            var e = this;
                            this.data.current(function(n) {
                                var i = t.map(n, function(t) { return t.id.toString() }),
                                    r = e.$results.find(".select2-results__option[aria-selected]");
                                r.each(function() {
                                    var e = t(this),
                                        n = t.data(this, "data"),
                                        r = "" + n.id;
                                    null != n.element && n.element.selected || null == n.element && t.inArray(r, i) > -1 ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
                                })
                            })
                        }, n.prototype.showLoading = function(t) {
                            this.hideLoading();
                            var e = this.options.get("translations").get("searching"),
                                n = { disabled: !0, loading: !0, text: e(t) },
                                i = this.option(n);
                            i.className += " loading-results", this.$results.prepend(i)
                        }, n.prototype.hideLoading = function() { this.$results.find(".loading-results").remove() }, n.prototype.option = function(e) {
                            var n = document.createElement("li");
                            n.className = "select2-results__option";
                            var i = { role: "treeitem", "aria-selected": "false" };
                            e.disabled && (delete i["aria-selected"], i["aria-disabled"] = "true"), null == e.id && delete i["aria-selected"], null != e._resultId && (n.id = e._resultId), e.title && (n.title = e.title), e.children && (i.role = "group", i["aria-label"] = e.text, delete i["aria-selected"]);
                            for (var r in i) {
                                var o = i[r];
                                n.setAttribute(r, o)
                            }
                            if (e.children) {
                                var a = t(n),
                                    s = document.createElement("strong");
                                s.className = "select2-results__group";
                                t(s);
                                this.template(e, s);
                                for (var l = [], u = 0; u < e.children.length; u++) {
                                    var c = e.children[u],
                                        d = this.option(c);
                                    l.push(d)
                                }
                                var h = t("<ul></ul>", { "class": "select2-results__options select2-results__options--nested" });
                                h.append(l), a.append(s), a.append(h)
                            } else this.template(e, n);
                            return t.data(n, "data", e), n
                        }, n.prototype.bind = function(e, n) {
                            var i = this,
                                r = e.id + "-results";
                            this.$results.attr("id", r), e.on("results:all", function(t) { i.clear(), i.append(t.data), e.isOpen() && (i.setClasses(), i.highlightFirstItem()) }), e.on("results:append", function(t) { i.append(t.data), e.isOpen() && i.setClasses() }), e.on("query", function(t) { i.hideMessages(), i.showLoading(t) }), e.on("select", function() { e.isOpen() && (i.setClasses(), i.highlightFirstItem()) }), e.on("unselect", function() { e.isOpen() && (i.setClasses(), i.highlightFirstItem()) }), e.on("open", function() { i.$results.attr("aria-expanded", "true"), i.$results.attr("aria-hidden", "false"), i.setClasses(), i.ensureHighlightVisible() }), e.on("close", function() { i.$results.attr("aria-expanded", "false"), i.$results.attr("aria-hidden", "true"), i.$results.removeAttr("aria-activedescendant") }), e.on("results:toggle", function() {
                                var t = i.getHighlightedResults();
                                0 !== t.length && t.trigger("mouseup")
                            }), e.on("results:select", function() { var t = i.getHighlightedResults(); if (0 !== t.length) { var e = t.data("data"); "true" == t.attr("aria-selected") ? i.trigger("close", {}) : i.trigger("select", { data: e }) } }), e.on("results:previous", function() {
                                var t = i.getHighlightedResults(),
                                    e = i.$results.find("[aria-selected]"),
                                    n = e.index(t);
                                if (0 !== n) {
                                    var r = n - 1;
                                    0 === t.length && (r = 0);
                                    var o = e.eq(r);
                                    o.trigger("mouseenter");
                                    var a = i.$results.offset().top,
                                        s = o.offset().top,
                                        l = i.$results.scrollTop() + (s - a);
                                    0 === r ? i.$results.scrollTop(0) : s - a < 0 && i.$results.scrollTop(l)
                                }
                            }), e.on("results:next", function() {
                                var t = i.getHighlightedResults(),
                                    e = i.$results.find("[aria-selected]"),
                                    n = e.index(t),
                                    r = n + 1;
                                if (!(r >= e.length)) {
                                    var o = e.eq(r);
                                    o.trigger("mouseenter");
                                    var a = i.$results.offset().top + i.$results.outerHeight(!1),
                                        s = o.offset().top + o.outerHeight(!1),
                                        l = i.$results.scrollTop() + s - a;
                                    0 === r ? i.$results.scrollTop(0) : s > a && i.$results.scrollTop(l)
                                }
                            }), e.on("results:focus", function(t) { t.element.addClass("select2-results__option--highlighted") }), e.on("results:message", function(t) { i.displayMessage(t) }), t.fn.mousewheel && this.$results.on("mousewheel", function(t) {
                                var e = i.$results.scrollTop(),
                                    n = i.$results.get(0).scrollHeight - e + t.deltaY,
                                    r = t.deltaY > 0 && e - t.deltaY <= 0,
                                    o = t.deltaY < 0 && n <= i.$results.height();
                                r ? (i.$results.scrollTop(0), t.preventDefault(), t.stopPropagation()) : o && (i.$results.scrollTop(i.$results.get(0).scrollHeight - i.$results.height()), t.preventDefault(), t.stopPropagation())
                            }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
                                var n = t(this),
                                    r = n.data("data");
                                return "true" === n.attr("aria-selected") ? void(i.options.get("multiple") ? i.trigger("unselect", { originalEvent: e, data: r }) : i.trigger("close", {})) : void i.trigger("select", { originalEvent: e, data: r })
                            }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
                                var n = t(this).data("data");
                                i.getHighlightedResults().removeClass("select2-results__option--highlighted"), i.trigger("results:focus", { data: n, element: t(this) })
                            })
                        }, n.prototype.getHighlightedResults = function() { var t = this.$results.find(".select2-results__option--highlighted"); return t }, n.prototype.destroy = function() { this.$results.remove() }, n.prototype.ensureHighlightVisible = function() {
                            var t = this.getHighlightedResults();
                            if (0 !== t.length) {
                                var e = this.$results.find("[aria-selected]"),
                                    n = e.index(t),
                                    i = this.$results.offset().top,
                                    r = t.offset().top,
                                    o = this.$results.scrollTop() + (r - i),
                                    a = r - i;
                                o -= 2 * t.outerHeight(!1), n <= 2 ? this.$results.scrollTop(0) : (a > this.$results.outerHeight() || a < 0) && this.$results.scrollTop(o)
                            }
                        }, n.prototype.template = function(e, n) {
                            var i = this.options.get("templateResult"),
                                r = this.options.get("escapeMarkup"),
                                o = i(e, n);
                            null == o ? n.style.display = "none" : "string" == typeof o ? n.innerHTML = r(o) : t(n).append(o)
                        }, n
                    }), e.define("select2/keys", [], function() { var t = { BACKSPACE: 8, TAB: 9, ENTER: 13, SHIFT: 16, CTRL: 17, ALT: 18, ESC: 27, SPACE: 32, PAGE_UP: 33, PAGE_DOWN: 34, END: 35, HOME: 36, LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40, DELETE: 46 }; return t }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(t, e, n) {
                        function i(t, e) { this.$element = t, this.options = e, i.__super__.constructor.call(this) }
                        return e.Extend(i, e.Observable), i.prototype.render = function() { var e = t('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>'); return this._tabindex = 0, null != this.$element.data("old-tabindex") ? this._tabindex = this.$element.data("old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), this.$selection = e, e }, i.prototype.bind = function(t, e) {
                            var i = this,
                                r = (t.id + "-container", t.id + "-results");
                            this.container = t, this.$selection.on("focus", function(t) { i.trigger("focus", t) }), this.$selection.on("blur", function(t) { i._handleBlur(t) }), this.$selection.on("keydown", function(t) { i.trigger("keypress", t), t.which === n.SPACE && t.preventDefault() }), t.on("results:focus", function(t) { i.$selection.attr("aria-activedescendant", t.data._resultId) }), t.on("selection:update", function(t) { i.update(t.data) }), t.on("open", function() { i.$selection.attr("aria-expanded", "true"), i.$selection.attr("aria-owns", r), i._attachCloseHandler(t) }), t.on("close", function() { i.$selection.attr("aria-expanded", "false"), i.$selection.removeAttr("aria-activedescendant"), i.$selection.removeAttr("aria-owns"), i.$selection.focus(), i._detachCloseHandler(t) }), t.on("enable", function() { i.$selection.attr("tabindex", i._tabindex) }), t.on("disable", function() { i.$selection.attr("tabindex", "-1") })
                        }, i.prototype._handleBlur = function(e) {
                            var n = this;
                            window.setTimeout(function() { document.activeElement == n.$selection[0] || t.contains(n.$selection[0], document.activeElement) || n.trigger("blur", e) }, 1)
                        }, i.prototype._attachCloseHandler = function(e) {
                            t(document.body).on("mousedown.select2." + e.id, function(e) {
                                var n = t(e.target),
                                    i = n.closest(".select2"),
                                    r = t(".select2.select2-container--open");
                                r.each(function() {
                                    var e = t(this);
                                    if (this != i[0]) {
                                        var n = e.data("element");
                                        n.select2("close")
                                    }
                                })
                            })
                        }, i.prototype._detachCloseHandler = function(e) { t(document.body).off("mousedown.select2." + e.id) }, i.prototype.position = function(t, e) {
                            var n = e.find(".selection");
                            n.append(t)
                        }, i.prototype.destroy = function() { this._detachCloseHandler(this.container) }, i.prototype.update = function(t) { throw new Error("The `update` method must be defined in child classes.") }, i
                    }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(t, e, n, i) {
                        function r() { r.__super__.constructor.apply(this, arguments) }
                        return n.Extend(r, e), r.prototype.render = function() { var t = r.__super__.render.call(this); return t.addClass("select2-selection--single"), t.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), t }, r.prototype.bind = function(t, e) {
                            var n = this;
                            r.__super__.bind.apply(this, arguments);
                            var i = t.id + "-container";
                            this.$selection.find(".select2-selection__rendered").attr("id", i), this.$selection.attr("aria-labelledby", i), this.$selection.on("mousedown", function(t) { 1 === t.which && n.trigger("toggle", { originalEvent: t }) }), this.$selection.on("focus", function(t) {}), this.$selection.on("blur", function(t) {}), t.on("focus", function(e) { t.isOpen() || n.$selection.focus() }), t.on("selection:update", function(t) { n.update(t.data) })
                        }, r.prototype.clear = function() { this.$selection.find(".select2-selection__rendered").empty() }, r.prototype.display = function(t, e) {
                            var n = this.options.get("templateSelection"),
                                i = this.options.get("escapeMarkup");
                            return i(n(t, e))
                        }, r.prototype.selectionContainer = function() { return t("<span></span>") }, r.prototype.update = function(t) {
                            if (0 === t.length) return void this.clear();
                            var e = t[0],
                                n = this.$selection.find(".select2-selection__rendered"),
                                i = this.display(e, n);
                            n.empty().append(i), n.prop("title", e.title || e.text)
                        }, r
                    }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(t, e, n) {
                        function i(t, e) { i.__super__.constructor.apply(this, arguments) }
                        return n.Extend(i, e), i.prototype.render = function() { var t = i.__super__.render.call(this); return t.addClass("select2-selection--multiple"), t.html('<ul class="select2-selection__rendered"></ul>'), t }, i.prototype.bind = function(e, n) {
                            var r = this;
                            i.__super__.bind.apply(this, arguments), this.$selection.on("click", function(t) { r.trigger("toggle", { originalEvent: t }) }), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
                                if (!r.options.get("disabled")) {
                                    var n = t(this),
                                        i = n.parent(),
                                        o = i.data("data");
                                    r.trigger("unselect", { originalEvent: e, data: o })
                                }
                            })
                        }, i.prototype.clear = function() { this.$selection.find(".select2-selection__rendered").empty() }, i.prototype.display = function(t, e) {
                            var n = this.options.get("templateSelection"),
                                i = this.options.get("escapeMarkup");
                            return i(n(t, e))
                        }, i.prototype.selectionContainer = function() { var e = t('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>'); return e }, i.prototype.update = function(t) {
                            if (this.clear(), 0 !== t.length) {
                                for (var e = [], i = 0; i < t.length; i++) {
                                    var r = t[i],
                                        o = this.selectionContainer(),
                                        a = this.display(r, o);
                                    o.append(a), o.prop("title", r.title || r.text), o.data("data", r), e.push(o)
                                }
                                var s = this.$selection.find(".select2-selection__rendered");
                                n.appendMany(s, e)
                            }
                        }, i
                    }), e.define("select2/selection/placeholder", ["../utils"], function(t) {
                        function e(t, e, n) { this.placeholder = this.normalizePlaceholder(n.get("placeholder")), t.call(this, e, n) }
                        return e.prototype.normalizePlaceholder = function(t, e) { return "string" == typeof e && (e = { id: "", text: e }), e }, e.prototype.createPlaceholder = function(t, e) { var n = this.selectionContainer(); return n.html(this.display(e)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n }, e.prototype.update = function(t, e) {
                            var n = 1 == e.length && e[0].id != this.placeholder.id,
                                i = e.length > 1;
                            if (i || n) return t.call(this, e);
                            this.clear();
                            var r = this.createPlaceholder(this.placeholder);
                            this.$selection.find(".select2-selection__rendered").append(r)
                        }, e
                    }), e.define("select2/selection/allowClear", ["jquery", "../keys"], function(t, e) {
                        function n() {}
                        return n.prototype.bind = function(t, e, n) {
                            var i = this;
                            t.call(this, e, n), null == this.placeholder && this.options.get("debug") && window.console && console.error, this.$selection.on("mousedown", ".select2-selection__clear", function(t) { i._handleClear(t) }), e.on("keypress", function(t) { i._handleKeyboardClear(t, e) })
                        }, n.prototype._handleClear = function(t, e) { if (!this.options.get("disabled")) { var n = this.$selection.find(".select2-selection__clear"); if (0 !== n.length) { e.stopPropagation(); for (var i = n.data("data"), r = 0; r < i.length; r++) { var o = { data: i[r] }; if (this.trigger("unselect", o), o.prevented) return } this.$element.val(this.placeholder.id).trigger("change"), this.trigger("toggle", {}) } } }, n.prototype._handleKeyboardClear = function(t, n, i) { i.isOpen() || n.which != e.DELETE && n.which != e.BACKSPACE || this._handleClear(n) }, n.prototype.update = function(e, n) {
                            if (e.call(this, n), !(this.$selection.find(".select2-selection__placeholder").length > 0 || 0 === n.length)) {
                                var i = t('<span class="select2-selection__clear">&times;</span>');
                                i.data("data", n), this.$selection.find(".select2-selection__rendered").prepend(i)
                            }
                        }, n
                    }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(t, e, n) {
                        function i(t, e, n) { t.call(this, e, n) }
                        return i.prototype.render = function(e) {
                            var n = t('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');
                            this.$searchContainer = n, this.$search = n.find("input");
                            var i = e.call(this);
                            return this._transferTabIndex(), i
                        }, i.prototype.bind = function(t, e, i) {
                            var r = this;
                            t.call(this, e, i), e.on("open", function() { r.$search.trigger("focus") }), e.on("close", function() { r.$search.val(""), r.$search.removeAttr("aria-activedescendant"), r.$search.trigger("focus") }), e.on("enable", function() { r.$search.prop("disabled", !1), r._transferTabIndex() }), e.on("disable", function() { r.$search.prop("disabled", !0) }), e.on("focus", function(t) { r.$search.trigger("focus"); }), e.on("results:focus", function(t) { r.$search.attr("aria-activedescendant", t.id) }), this.$selection.on("focusin", ".select2-search--inline", function(t) { r.trigger("focus", t) }), this.$selection.on("focusout", ".select2-search--inline", function(t) { r._handleBlur(t) }), this.$selection.on("keydown", ".select2-search--inline", function(t) {
                                t.stopPropagation(), r.trigger("keypress", t), r._keyUpPrevented = t.isDefaultPrevented();
                                var e = t.which;
                                if (e === n.BACKSPACE && "" === r.$search.val()) {
                                    var i = r.$searchContainer.prev(".select2-selection__choice");
                                    if (i.length > 0) {
                                        var o = i.data("data");
                                        r.searchRemoveChoice(o), t.preventDefault()
                                    }
                                }
                            });
                            var o = document.documentMode,
                                a = o && o <= 11;
                            this.$selection.on("input.searchcheck", ".select2-search--inline", function(t) { return a ? void r.$selection.off("input.search input.searchcheck") : void r.$selection.off("keyup.search") }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(t) {
                                if (a && "input" === t.type) return void r.$selection.off("input.search input.searchcheck");
                                var e = t.which;
                                e != n.SHIFT && e != n.CTRL && e != n.ALT && e != n.TAB && r.handleSearch(t)
                            })
                        }, i.prototype._transferTabIndex = function(t) { this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1") }, i.prototype.createPlaceholder = function(t, e) { this.$search.attr("placeholder", e.text) }, i.prototype.update = function(t, e) {
                            var n = this.$search[0] == document.activeElement;
                            this.$search.attr("placeholder", ""), t.call(this, e), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.focus()
                        }, i.prototype.handleSearch = function() {
                            if (this.resizeSearch(), !this._keyUpPrevented) {
                                var t = this.$search.val();
                                this.trigger("query", { term: t })
                            }
                            this._keyUpPrevented = !1
                        }, i.prototype.searchRemoveChoice = function(t, e) { this.trigger("unselect", { data: e }), this.$search.val(e.text), this.handleSearch() }, i.prototype.resizeSearch = function() {
                            this.$search.css("width", "25px");
                            var t = "";
                            if ("" !== this.$search.attr("placeholder")) t = this.$selection.find(".select2-selection__rendered").innerWidth();
                            else {
                                var e = this.$search.val().length + 1;
                                t = .75 * e + "em"
                            }
                            this.$search.css("width", t)
                        }, i
                    }), e.define("select2/selection/eventRelay", ["jquery"], function(t) {
                        function e() {}
                        return e.prototype.bind = function(e, n, i) {
                            var r = this,
                                o = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting"],
                                a = ["opening", "closing", "selecting", "unselecting"];
                            e.call(this, n, i), n.on("*", function(e, n) {
                                if (t.inArray(e, o) !== -1) {
                                    n = n || {};
                                    var i = t.Event("select2:" + e, { params: n });
                                    r.$element.trigger(i), t.inArray(e, a) !== -1 && (n.prevented = i.isDefaultPrevented())
                                }
                            })
                        }, e
                    }), e.define("select2/translation", ["jquery", "require"], function(t, e) {
                        function n(t) { this.dict = t || {} }
                        return n.prototype.all = function() { return this.dict }, n.prototype.get = function(t) { return this.dict[t] }, n.prototype.extend = function(e) { this.dict = t.extend({}, e.all(), this.dict) }, n._cache = {}, n.loadPath = function(t) {
                            if (!(t in n._cache)) {
                                var i = e(t);
                                n._cache[t] = i
                            }
                            return new n(n._cache[t])
                        }, n
                    }), e.define("select2/diacritics", [], function() { var t = { "Ⓐ": "A", "Ａ": "A", "À": "A", "Á": "A", "Â": "A", "Ầ": "A", "Ấ": "A", "Ẫ": "A", "Ẩ": "A", "Ã": "A", "Ā": "A", "Ă": "A", "Ằ": "A", "Ắ": "A", "Ẵ": "A", "Ẳ": "A", "Ȧ": "A", "Ǡ": "A", "Ä": "A", "Ǟ": "A", "Ả": "A", "Å": "A", "Ǻ": "A", "Ǎ": "A", "Ȁ": "A", "Ȃ": "A", "Ạ": "A", "Ậ": "A", "Ặ": "A", "Ḁ": "A", "Ą": "A", "Ⱥ": "A", "Ɐ": "A", "Ꜳ": "AA", "Æ": "AE", "Ǽ": "AE", "Ǣ": "AE", "Ꜵ": "AO", "Ꜷ": "AU", "Ꜹ": "AV", "Ꜻ": "AV", "Ꜽ": "AY", "Ⓑ": "B", "Ｂ": "B", "Ḃ": "B", "Ḅ": "B", "Ḇ": "B", "Ƀ": "B", "Ƃ": "B", "Ɓ": "B", "Ⓒ": "C", "Ｃ": "C", "Ć": "C", "Ĉ": "C", "Ċ": "C", "Č": "C", "Ç": "C", "Ḉ": "C", "Ƈ": "C", "Ȼ": "C", "Ꜿ": "C", "Ⓓ": "D", "Ｄ": "D", "Ḋ": "D", "Ď": "D", "Ḍ": "D", "Ḑ": "D", "Ḓ": "D", "Ḏ": "D", "Đ": "D", "Ƌ": "D", "Ɗ": "D", "Ɖ": "D", "Ꝺ": "D", "Ǳ": "DZ", "Ǆ": "DZ", "ǲ": "Dz", "ǅ": "Dz", "Ⓔ": "E", "Ｅ": "E", "È": "E", "É": "E", "Ê": "E", "Ề": "E", "Ế": "E", "Ễ": "E", "Ể": "E", "Ẽ": "E", "Ē": "E", "Ḕ": "E", "Ḗ": "E", "Ĕ": "E", "Ė": "E", "Ë": "E", "Ẻ": "E", "Ě": "E", "Ȅ": "E", "Ȇ": "E", "Ẹ": "E", "Ệ": "E", "Ȩ": "E", "Ḝ": "E", "Ę": "E", "Ḙ": "E", "Ḛ": "E", "Ɛ": "E", "Ǝ": "E", "Ⓕ": "F", "Ｆ": "F", "Ḟ": "F", "Ƒ": "F", "Ꝼ": "F", "Ⓖ": "G", "Ｇ": "G", "Ǵ": "G", "Ĝ": "G", "Ḡ": "G", "Ğ": "G", "Ġ": "G", "Ǧ": "G", "Ģ": "G", "Ǥ": "G", "Ɠ": "G", "Ꞡ": "G", "Ᵹ": "G", "Ꝿ": "G", "Ⓗ": "H", "Ｈ": "H", "Ĥ": "H", "Ḣ": "H", "Ḧ": "H", "Ȟ": "H", "Ḥ": "H", "Ḩ": "H", "Ḫ": "H", "Ħ": "H", "Ⱨ": "H", "Ⱶ": "H", "Ɥ": "H", "Ⓘ": "I", "Ｉ": "I", "Ì": "I", "Í": "I", "Î": "I", "Ĩ": "I", "Ī": "I", "Ĭ": "I", "İ": "I", "Ï": "I", "Ḯ": "I", "Ỉ": "I", "Ǐ": "I", "Ȉ": "I", "Ȋ": "I", "Ị": "I", "Į": "I", "Ḭ": "I", "Ɨ": "I", "Ⓙ": "J", "Ｊ": "J", "Ĵ": "J", "Ɉ": "J", "Ⓚ": "K", "Ｋ": "K", "Ḱ": "K", "Ǩ": "K", "Ḳ": "K", "Ķ": "K", "Ḵ": "K", "Ƙ": "K", "Ⱪ": "K", "Ꝁ": "K", "Ꝃ": "K", "Ꝅ": "K", "Ꞣ": "K", "Ⓛ": "L", "Ｌ": "L", "Ŀ": "L", "Ĺ": "L", "Ľ": "L", "Ḷ": "L", "Ḹ": "L", "Ļ": "L", "Ḽ": "L", "Ḻ": "L", "Ł": "L", "Ƚ": "L", "Ɫ": "L", "Ⱡ": "L", "Ꝉ": "L", "Ꝇ": "L", "Ꞁ": "L", "Ǉ": "LJ", "ǈ": "Lj", "Ⓜ": "M", "Ｍ": "M", "Ḿ": "M", "Ṁ": "M", "Ṃ": "M", "Ɱ": "M", "Ɯ": "M", "Ⓝ": "N", "Ｎ": "N", "Ǹ": "N", "Ń": "N", "Ñ": "N", "Ṅ": "N", "Ň": "N", "Ṇ": "N", "Ņ": "N", "Ṋ": "N", "Ṉ": "N", "Ƞ": "N", "Ɲ": "N", "Ꞑ": "N", "Ꞥ": "N", "Ǌ": "NJ", "ǋ": "Nj", "Ⓞ": "O", "Ｏ": "O", "Ò": "O", "Ó": "O", "Ô": "O", "Ồ": "O", "Ố": "O", "Ỗ": "O", "Ổ": "O", "Õ": "O", "Ṍ": "O", "Ȭ": "O", "Ṏ": "O", "Ō": "O", "Ṑ": "O", "Ṓ": "O", "Ŏ": "O", "Ȯ": "O", "Ȱ": "O", "Ö": "O", "Ȫ": "O", "Ỏ": "O", "Ő": "O", "Ǒ": "O", "Ȍ": "O", "Ȏ": "O", "Ơ": "O", "Ờ": "O", "Ớ": "O", "Ỡ": "O", "Ở": "O", "Ợ": "O", "Ọ": "O", "Ộ": "O", "Ǫ": "O", "Ǭ": "O", "Ø": "O", "Ǿ": "O", "Ɔ": "O", "Ɵ": "O", "Ꝋ": "O", "Ꝍ": "O", "Ƣ": "OI", "Ꝏ": "OO", "Ȣ": "OU", "Ⓟ": "P", "Ｐ": "P", "Ṕ": "P", "Ṗ": "P", "Ƥ": "P", "Ᵽ": "P", "Ꝑ": "P", "Ꝓ": "P", "Ꝕ": "P", "Ⓠ": "Q", "Ｑ": "Q", "Ꝗ": "Q", "Ꝙ": "Q", "Ɋ": "Q", "Ⓡ": "R", "Ｒ": "R", "Ŕ": "R", "Ṙ": "R", "Ř": "R", "Ȑ": "R", "Ȓ": "R", "Ṛ": "R", "Ṝ": "R", "Ŗ": "R", "Ṟ": "R", "Ɍ": "R", "Ɽ": "R", "Ꝛ": "R", "Ꞧ": "R", "Ꞃ": "R", "Ⓢ": "S", "Ｓ": "S", "ẞ": "S", "Ś": "S", "Ṥ": "S", "Ŝ": "S", "Ṡ": "S", "Š": "S", "Ṧ": "S", "Ṣ": "S", "Ṩ": "S", "Ș": "S", "Ş": "S", "Ȿ": "S", "Ꞩ": "S", "Ꞅ": "S", "Ⓣ": "T", "Ｔ": "T", "Ṫ": "T", "Ť": "T", "Ṭ": "T", "Ț": "T", "Ţ": "T", "Ṱ": "T", "Ṯ": "T", "Ŧ": "T", "Ƭ": "T", "Ʈ": "T", "Ⱦ": "T", "Ꞇ": "T", "Ꜩ": "TZ", "Ⓤ": "U", "Ｕ": "U", "Ù": "U", "Ú": "U", "Û": "U", "Ũ": "U", "Ṹ": "U", "Ū": "U", "Ṻ": "U", "Ŭ": "U", "Ü": "U", "Ǜ": "U", "Ǘ": "U", "Ǖ": "U", "Ǚ": "U", "Ủ": "U", "Ů": "U", "Ű": "U", "Ǔ": "U", "Ȕ": "U", "Ȗ": "U", "Ư": "U", "Ừ": "U", "Ứ": "U", "Ữ": "U", "Ử": "U", "Ự": "U", "Ụ": "U", "Ṳ": "U", "Ų": "U", "Ṷ": "U", "Ṵ": "U", "Ʉ": "U", "Ⓥ": "V", "Ｖ": "V", "Ṽ": "V", "Ṿ": "V", "Ʋ": "V", "Ꝟ": "V", "Ʌ": "V", "Ꝡ": "VY", "Ⓦ": "W", "Ｗ": "W", "Ẁ": "W", "Ẃ": "W", "Ŵ": "W", "Ẇ": "W", "Ẅ": "W", "Ẉ": "W", "Ⱳ": "W", "Ⓧ": "X", "Ｘ": "X", "Ẋ": "X", "Ẍ": "X", "Ⓨ": "Y", "Ｙ": "Y", "Ỳ": "Y", "Ý": "Y", "Ŷ": "Y", "Ỹ": "Y", "Ȳ": "Y", "Ẏ": "Y", "Ÿ": "Y", "Ỷ": "Y", "Ỵ": "Y", "Ƴ": "Y", "Ɏ": "Y", "Ỿ": "Y", "Ⓩ": "Z", "Ｚ": "Z", "Ź": "Z", "Ẑ": "Z", "Ż": "Z", "Ž": "Z", "Ẓ": "Z", "Ẕ": "Z", "Ƶ": "Z", "Ȥ": "Z", "Ɀ": "Z", "Ⱬ": "Z", "Ꝣ": "Z", "ⓐ": "a", "ａ": "a", "ẚ": "a", "à": "a", "á": "a", "â": "a", "ầ": "a", "ấ": "a", "ẫ": "a", "ẩ": "a", "ã": "a", "ā": "a", "ă": "a", "ằ": "a", "ắ": "a", "ẵ": "a", "ẳ": "a", "ȧ": "a", "ǡ": "a", "ä": "a", "ǟ": "a", "ả": "a", "å": "a", "ǻ": "a", "ǎ": "a", "ȁ": "a", "ȃ": "a", "ạ": "a", "ậ": "a", "ặ": "a", "ḁ": "a", "ą": "a", "ⱥ": "a", "ɐ": "a", "ꜳ": "aa", "æ": "ae", "ǽ": "ae", "ǣ": "ae", "ꜵ": "ao", "ꜷ": "au", "ꜹ": "av", "ꜻ": "av", "ꜽ": "ay", "ⓑ": "b", "ｂ": "b", "ḃ": "b", "ḅ": "b", "ḇ": "b", "ƀ": "b", "ƃ": "b", "ɓ": "b", "ⓒ": "c", "ｃ": "c", "ć": "c", "ĉ": "c", "ċ": "c", "č": "c", "ç": "c", "ḉ": "c", "ƈ": "c", "ȼ": "c", "ꜿ": "c", "ↄ": "c", "ⓓ": "d", "ｄ": "d", "ḋ": "d", "ď": "d", "ḍ": "d", "ḑ": "d", "ḓ": "d", "ḏ": "d", "đ": "d", "ƌ": "d", "ɖ": "d", "ɗ": "d", "ꝺ": "d", "ǳ": "dz", "ǆ": "dz", "ⓔ": "e", "ｅ": "e", "è": "e", "é": "e", "ê": "e", "ề": "e", "ế": "e", "ễ": "e", "ể": "e", "ẽ": "e", "ē": "e", "ḕ": "e", "ḗ": "e", "ĕ": "e", "ė": "e", "ë": "e", "ẻ": "e", "ě": "e", "ȅ": "e", "ȇ": "e", "ẹ": "e", "ệ": "e", "ȩ": "e", "ḝ": "e", "ę": "e", "ḙ": "e", "ḛ": "e", "ɇ": "e", "ɛ": "e", "ǝ": "e", "ⓕ": "f", "ｆ": "f", "ḟ": "f", "ƒ": "f", "ꝼ": "f", "ⓖ": "g", "ｇ": "g", "ǵ": "g", "ĝ": "g", "ḡ": "g", "ğ": "g", "ġ": "g", "ǧ": "g", "ģ": "g", "ǥ": "g", "ɠ": "g", "ꞡ": "g", "ᵹ": "g", "ꝿ": "g", "ⓗ": "h", "ｈ": "h", "ĥ": "h", "ḣ": "h", "ḧ": "h", "ȟ": "h", "ḥ": "h", "ḩ": "h", "ḫ": "h", "ẖ": "h", "ħ": "h", "ⱨ": "h", "ⱶ": "h", "ɥ": "h", "ƕ": "hv", "ⓘ": "i", "ｉ": "i", "ì": "i", "í": "i", "î": "i", "ĩ": "i", "ī": "i", "ĭ": "i", "ï": "i", "ḯ": "i", "ỉ": "i", "ǐ": "i", "ȉ": "i", "ȋ": "i", "ị": "i", "į": "i", "ḭ": "i", "ɨ": "i", "ı": "i", "ⓙ": "j", "ｊ": "j", "ĵ": "j", "ǰ": "j", "ɉ": "j", "ⓚ": "k", "ｋ": "k", "ḱ": "k", "ǩ": "k", "ḳ": "k", "ķ": "k", "ḵ": "k", "ƙ": "k", "ⱪ": "k", "ꝁ": "k", "ꝃ": "k", "ꝅ": "k", "ꞣ": "k", "ⓛ": "l", "ｌ": "l", "ŀ": "l", "ĺ": "l", "ľ": "l", "ḷ": "l", "ḹ": "l", "ļ": "l", "ḽ": "l", "ḻ": "l", "ſ": "l", "ł": "l", "ƚ": "l", "ɫ": "l", "ⱡ": "l", "ꝉ": "l", "ꞁ": "l", "ꝇ": "l", "ǉ": "lj", "ⓜ": "m", "ｍ": "m", "ḿ": "m", "ṁ": "m", "ṃ": "m", "ɱ": "m", "ɯ": "m", "ⓝ": "n", "ｎ": "n", "ǹ": "n", "ń": "n", "ñ": "n", "ṅ": "n", "ň": "n", "ṇ": "n", "ņ": "n", "ṋ": "n", "ṉ": "n", "ƞ": "n", "ɲ": "n", "ŉ": "n", "ꞑ": "n", "ꞥ": "n", "ǌ": "nj", "ⓞ": "o", "ｏ": "o", "ò": "o", "ó": "o", "ô": "o", "ồ": "o", "ố": "o", "ỗ": "o", "ổ": "o", "õ": "o", "ṍ": "o", "ȭ": "o", "ṏ": "o", "ō": "o", "ṑ": "o", "ṓ": "o", "ŏ": "o", "ȯ": "o", "ȱ": "o", "ö": "o", "ȫ": "o", "ỏ": "o", "ő": "o", "ǒ": "o", "ȍ": "o", "ȏ": "o", "ơ": "o", "ờ": "o", "ớ": "o", "ỡ": "o", "ở": "o", "ợ": "o", "ọ": "o", "ộ": "o", "ǫ": "o", "ǭ": "o", "ø": "o", "ǿ": "o", "ɔ": "o", "ꝋ": "o", "ꝍ": "o", "ɵ": "o", "ƣ": "oi", "ȣ": "ou", "ꝏ": "oo", "ⓟ": "p", "ｐ": "p", "ṕ": "p", "ṗ": "p", "ƥ": "p", "ᵽ": "p", "ꝑ": "p", "ꝓ": "p", "ꝕ": "p", "ⓠ": "q", "ｑ": "q", "ɋ": "q", "ꝗ": "q", "ꝙ": "q", "ⓡ": "r", "ｒ": "r", "ŕ": "r", "ṙ": "r", "ř": "r", "ȑ": "r", "ȓ": "r", "ṛ": "r", "ṝ": "r", "ŗ": "r", "ṟ": "r", "ɍ": "r", "ɽ": "r", "ꝛ": "r", "ꞧ": "r", "ꞃ": "r", "ⓢ": "s", "ｓ": "s", "ß": "s", "ś": "s", "ṥ": "s", "ŝ": "s", "ṡ": "s", "š": "s", "ṧ": "s", "ṣ": "s", "ṩ": "s", "ș": "s", "ş": "s", "ȿ": "s", "ꞩ": "s", "ꞅ": "s", "ẛ": "s", "ⓣ": "t", "ｔ": "t", "ṫ": "t", "ẗ": "t", "ť": "t", "ṭ": "t", "ț": "t", "ţ": "t", "ṱ": "t", "ṯ": "t", "ŧ": "t", "ƭ": "t", "ʈ": "t", "ⱦ": "t", "ꞇ": "t", "ꜩ": "tz", "ⓤ": "u", "ｕ": "u", "ù": "u", "ú": "u", "û": "u", "ũ": "u", "ṹ": "u", "ū": "u", "ṻ": "u", "ŭ": "u", "ü": "u", "ǜ": "u", "ǘ": "u", "ǖ": "u", "ǚ": "u", "ủ": "u", "ů": "u", "ű": "u", "ǔ": "u", "ȕ": "u", "ȗ": "u", "ư": "u", "ừ": "u", "ứ": "u", "ữ": "u", "ử": "u", "ự": "u", "ụ": "u", "ṳ": "u", "ų": "u", "ṷ": "u", "ṵ": "u", "ʉ": "u", "ⓥ": "v", "ｖ": "v", "ṽ": "v", "ṿ": "v", "ʋ": "v", "ꝟ": "v", "ʌ": "v", "ꝡ": "vy", "ⓦ": "w", "ｗ": "w", "ẁ": "w", "ẃ": "w", "ŵ": "w", "ẇ": "w", "ẅ": "w", "ẘ": "w", "ẉ": "w", "ⱳ": "w", "ⓧ": "x", "ｘ": "x", "ẋ": "x", "ẍ": "x", "ⓨ": "y", "ｙ": "y", "ỳ": "y", "ý": "y", "ŷ": "y", "ỹ": "y", "ȳ": "y", "ẏ": "y", "ÿ": "y", "ỷ": "y", "ẙ": "y", "ỵ": "y", "ƴ": "y", "ɏ": "y", "ỿ": "y", "ⓩ": "z", "ｚ": "z", "ź": "z", "ẑ": "z", "ż": "z", "ž": "z", "ẓ": "z", "ẕ": "z", "ƶ": "z", "ȥ": "z", "ɀ": "z", "ⱬ": "z", "ꝣ": "z", "Ά": "Α", "Έ": "Ε", "Ή": "Η", "Ί": "Ι", "Ϊ": "Ι", "Ό": "Ο", "Ύ": "Υ", "Ϋ": "Υ", "Ώ": "Ω", "ά": "α", "έ": "ε", "ή": "η", "ί": "ι", "ϊ": "ι", "ΐ": "ι", "ό": "ο", "ύ": "υ", "ϋ": "υ", "ΰ": "υ", "ω": "ω", "ς": "σ" }; return t }), e.define("select2/data/base", ["../utils"], function(t) {
                        function e(t, n) { e.__super__.constructor.call(this) }
                        return t.Extend(e, t.Observable), e.prototype.current = function(t) { throw new Error("The `current` method must be defined in child classes.") }, e.prototype.query = function(t, e) { throw new Error("The `query` method must be defined in child classes.") }, e.prototype.bind = function(t, e) {}, e.prototype.destroy = function() {}, e.prototype.generateResultId = function(e, n) { var i = e.id + "-result-"; return i += t.generateChars(4), i += null != n.id ? "-" + n.id.toString() : "-" + t.generateChars(4) }, e
                    }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(t, e, n) {
                        function i(t, e) { this.$element = t, this.options = e, i.__super__.constructor.call(this) }
                        return e.Extend(i, t), i.prototype.current = function(t) {
                            var e = [],
                                i = this;
                            this.$element.find(":selected").each(function() {
                                var t = n(this),
                                    r = i.item(t);
                                e.push(r)
                            }), t(e)
                        }, i.prototype.select = function(t) {
                            var e = this;
                            if (t.selected = !0, n(t.element).is("option")) return t.element.selected = !0, void this.$element.trigger("change");
                            if (this.$element.prop("multiple")) this.current(function(i) {
                                var r = [];
                                t = [t], t.push.apply(t, i);
                                for (var o = 0; o < t.length; o++) {
                                    var a = t[o].id;
                                    n.inArray(a, r) === -1 && r.push(a)
                                }
                                e.$element.val(r), e.$element.trigger("change")
                            });
                            else {
                                var i = t.id;
                                this.$element.val(i), this.$element.trigger("change")
                            }
                        }, i.prototype.unselect = function(t) {
                            var e = this;
                            if (this.$element.prop("multiple")) return t.selected = !1, n(t.element).is("option") ? (t.element.selected = !1, void this.$element.trigger("change")) : void this.current(function(i) {
                                for (var r = [], o = 0; o < i.length; o++) {
                                    var a = i[o].id;
                                    a !== t.id && n.inArray(a, r) === -1 && r.push(a)
                                }
                                e.$element.val(r), e.$element.trigger("change")
                            })
                        }, i.prototype.bind = function(t, e) {
                            var n = this;
                            this.container = t, t.on("select", function(t) { n.select(t.data) }), t.on("unselect", function(t) { n.unselect(t.data) })
                        }, i.prototype.destroy = function() { this.$element.find("*").each(function() { n.removeData(this, "data") }) }, i.prototype.query = function(t, e) {
                            var i = [],
                                r = this,
                                o = this.$element.children();
                            o.each(function() {
                                var e = n(this);
                                if (e.is("option") || e.is("optgroup")) {
                                    var o = r.item(e),
                                        a = r.matches(t, o);
                                    null !== a && i.push(a)
                                }
                            }), e({ results: i })
                        }, i.prototype.addOptions = function(t) { e.appendMany(this.$element, t) }, i.prototype.option = function(t) {
                            var e;
                            t.children ? (e = document.createElement("optgroup"), e.label = t.text) : (e = document.createElement("option"), void 0 !== e.textContent ? e.textContent = t.text : e.innerText = t.text), void 0 !== t.id && (e.value = t.id), t.disabled && (e.disabled = !0), t.selected && (e.selected = !0), t.title && (e.title = t.title);
                            var i = n(e),
                                r = this._normalizeItem(t);
                            return r.element = e, n.data(e, "data", r), i
                        }, i.prototype.item = function(t) {
                            var e = {};
                            if (e = n.data(t[0], "data"), null != e) return e;
                            if (t.is("option")) e = { id: t.val(), text: t.text(), disabled: t.prop("disabled"), selected: t.prop("selected"), title: t.prop("title") };
                            else if (t.is("optgroup")) {
                                e = { text: t.prop("label"), children: [], title: t.prop("title") };
                                for (var i = t.children("option"), r = [], o = 0; o < i.length; o++) {
                                    var a = n(i[o]),
                                        s = this.item(a);
                                    r.push(s)
                                }
                                e.children = r
                            }
                            return e = this._normalizeItem(e), e.element = t[0], n.data(t[0], "data", e), e
                        }, i.prototype._normalizeItem = function(t) { n.isPlainObject(t) || (t = { id: t, text: t }), t = n.extend({}, { text: "" }, t); var e = { selected: !1, disabled: !1 }; return null != t.id && (t.id = t.id.toString()), null != t.text && (t.text = t.text.toString()), null == t._resultId && t.id && null != this.container && (t._resultId = this.generateResultId(this.container, t)), n.extend({}, e, t) }, i.prototype.matches = function(t, e) { var n = this.options.get("matcher"); return n(t, e) }, i
                    }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(t, e, n) {
                        function i(t, e) {
                            var n = e.get("data") || [];
                            i.__super__.constructor.call(this, t, e), this.addOptions(this.convertToOptions(n))
                        }
                        return e.Extend(i, t), i.prototype.select = function(t) {
                            var e = this.$element.find("option").filter(function(e, n) { return n.value == t.id.toString() });
                            0 === e.length && (e = this.option(t), this.addOptions(e)), i.__super__.select.call(this, t)
                        }, i.prototype.convertToOptions = function(t) {
                            function i(t) { return function() { return n(this).val() == t.id } }
                            for (var r = this, o = this.$element.find("option"), a = o.map(function() { return r.item(n(this)).id }).get(), s = [], l = 0; l < t.length; l++) {
                                var u = this._normalizeItem(t[l]);
                                if (n.inArray(u.id, a) >= 0) {
                                    var c = o.filter(i(u)),
                                        d = this.item(c),
                                        h = n.extend(!0, {}, u, d),
                                        f = this.option(h);
                                    c.replaceWith(f)
                                } else {
                                    var p = this.option(u);
                                    if (u.children) {
                                        var g = this.convertToOptions(u.children);
                                        e.appendMany(p, g)
                                    }
                                    s.push(p)
                                }
                            }
                            return s
                        }, i
                    }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(t, e, n) {
                        function i(t, e) { this.ajaxOptions = this._applyDefaults(e.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), i.__super__.constructor.call(this, t, e) }
                        return e.Extend(i, t), i.prototype._applyDefaults = function(t) { var e = { data: function(t) { return n.extend({}, t, { q: t.term }) }, transport: function(t, e, i) { var r = n.ajax(t); return r.then(e), r.fail(i), r } }; return n.extend({}, e, t, !0) }, i.prototype.processResults = function(t) { return t }, i.prototype.query = function(t, e) {
                            function i() {
                                var i = o.transport(o, function(i) {
                                    var o = r.processResults(i, t);
                                    r.options.get("debug") && window.console && console.error && (!o || !o.results || !n.isArray(o.results)), e(o)
                                }, function() { i.status && "0" === i.status || r.trigger("results:message", { message: "errorLoading" }) });
                                r._request = i
                            }
                            var r = this;
                            null != this._request && (n.isFunction(this._request.abort) && this._request.abort(), this._request = null);
                            var o = n.extend({ type: "GET" }, this.ajaxOptions);
                            "function" == typeof o.url && (o.url = o.url.call(this.$element, t)), "function" == typeof o.data && (o.data = o.data.call(this.$element, t)), this.ajaxOptions.delay && null != t.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(i, this.ajaxOptions.delay)) : i()
                        }, i
                    }), e.define("select2/data/tags", ["jquery"], function(t) {
                        function e(e, n, i) {
                            var r = i.get("tags"),
                                o = i.get("createTag");
                            void 0 !== o && (this.createTag = o);
                            var a = i.get("insertTag");
                            if (void 0 !== a && (this.insertTag = a), e.call(this, n, i), t.isArray(r))
                                for (var s = 0; s < r.length; s++) {
                                    var l = r[s],
                                        u = this._normalizeItem(l),
                                        c = this.option(u);
                                    this.$element.append(c)
                                }
                        }
                        return e.prototype.query = function(t, e, n) {
                            function i(t, o) {
                                for (var a = t.results, s = 0; s < a.length; s++) {
                                    var l = a[s],
                                        u = null != l.children && !i({ results: l.children }, !0),
                                        c = (l.text || "").toUpperCase(),
                                        d = (e.term || "").toUpperCase(),
                                        h = c === d;
                                    if (h || u) return !o && (t.data = a, void n(t))
                                }
                                if (o) return !0;
                                var f = r.createTag(e);
                                if (null != f) {
                                    var p = r.option(f);
                                    p.attr("data-select2-tag", !0), r.addOptions([p]), r.insertTag(a, f)
                                }
                                t.results = a, n(t)
                            }
                            var r = this;
                            return this._removeOldTags(), null == e.term || null != e.page ? void t.call(this, e, n) : void t.call(this, e, i)
                        }, e.prototype.createTag = function(e, n) { var i = t.trim(n.term); return "" === i ? null : { id: i, text: i } }, e.prototype.insertTag = function(t, e, n) { e.unshift(n) }, e.prototype._removeOldTags = function(e) {
                            var n = (this._lastTag, this.$element.find("option[data-select2-tag]"));
                            n.each(function() { this.selected || t(this).remove() })
                        }, e
                    }), e.define("select2/data/tokenizer", ["jquery"], function(t) {
                        function e(t, e, n) {
                            var i = n.get("tokenizer");
                            void 0 !== i && (this.tokenizer = i), t.call(this, e, n)
                        }
                        return e.prototype.bind = function(t, e, n) { t.call(this, e, n), this.$search = e.dropdown.$search || e.selection.$search || n.find(".select2-search__field") }, e.prototype.query = function(e, n, i) {
                            function r(e) {
                                var n = a._normalizeItem(e),
                                    i = a.$element.find("option").filter(function() { return t(this).val() === n.id });
                                if (!i.length) {
                                    var r = a.option(n);
                                    r.attr("data-select2-tag", !0), a._removeOldTags(), a.addOptions([r])
                                }
                                o(n)
                            }

                            function o(t) { a.trigger("select", { data: t }) }
                            var a = this;
                            n.term = n.term || "";
                            var s = this.tokenizer(n, this.options, r);
                            s.term !== n.term && (this.$search.length && (this.$search.val(s.term), this.$search.focus()), n.term = s.term), e.call(this, n, i)
                        }, e.prototype.tokenizer = function(e, n, i, r) {
                            for (var o = i.get("tokenSeparators") || [], a = n.term, s = 0, l = this.createTag || function(t) { return { id: t.term, text: t.term } }; s < a.length;) {
                                var u = a[s];
                                if (t.inArray(u, o) !== -1) {
                                    var c = a.substr(0, s),
                                        d = t.extend({}, n, { term: c }),
                                        h = l(d);
                                    null != h ? (r(h), a = a.substr(s + 1) || "", s = 0) : s++
                                } else s++
                            }
                            return { term: a }
                        }, e
                    }), e.define("select2/data/minimumInputLength", [], function() {
                        function t(t, e, n) { this.minimumInputLength = n.get("minimumInputLength"), t.call(this, e, n) }
                        return t.prototype.query = function(t, e, n) { return e.term = e.term || "", e.term.length < this.minimumInputLength ? void this.trigger("results:message", { message: "inputTooShort", args: { minimum: this.minimumInputLength, input: e.term, params: e } }) : void t.call(this, e, n) }, t
                    }), e.define("select2/data/maximumInputLength", [], function() {
                        function t(t, e, n) { this.maximumInputLength = n.get("maximumInputLength"), t.call(this, e, n) }
                        return t.prototype.query = function(t, e, n) { return e.term = e.term || "", this.maximumInputLength > 0 && e.term.length > this.maximumInputLength ? void this.trigger("results:message", { message: "inputTooLong", args: { maximum: this.maximumInputLength, input: e.term, params: e } }) : void t.call(this, e, n) }, t
                    }), e.define("select2/data/maximumSelectionLength", [], function() {
                        function t(t, e, n) { this.maximumSelectionLength = n.get("maximumSelectionLength"), t.call(this, e, n) }
                        return t.prototype.query = function(t, e, n) {
                            var i = this;
                            this.current(function(r) { var o = null != r ? r.length : 0; return i.maximumSelectionLength > 0 && o >= i.maximumSelectionLength ? void i.trigger("results:message", { message: "maximumSelected", args: { maximum: i.maximumSelectionLength } }) : void t.call(i, e, n) })
                        }, t
                    }), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
                        function n(t, e) { this.$element = t, this.options = e, n.__super__.constructor.call(this) }
                        return e.Extend(n, e.Observable), n.prototype.render = function() { var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>'); return e.attr("dir", this.options.get("dir")), this.$dropdown = e, e }, n.prototype.bind = function() {}, n.prototype.position = function(t, e) {}, n.prototype.destroy = function() { this.$dropdown.remove() }, n
                    }), e.define("select2/dropdown/search", ["jquery", "../utils"], function(t, e) {
                        function n() {}
                        return n.prototype.render = function(e) {
                            var n = e.call(this),
                                i = t('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" /></span>');
                            return this.$searchContainer = i, this.$search = i.find("input"), n.prepend(i), n
                        }, n.prototype.bind = function(e, n, i) {
                            var r = this;
                            e.call(this, n, i), this.$search.on("keydown", function(t) { r.trigger("keypress", t), r._keyUpPrevented = t.isDefaultPrevented() }), this.$search.on("input", function(e) { t(this).off("keyup") }), this.$search.on("keyup input", function(t) { r.handleSearch(t) }), n.on("open", function() { r.$search.attr("tabindex", 0), r.$search.focus(), window.setTimeout(function() { r.$search.focus() }, 0) }), n.on("close", function() { r.$search.attr("tabindex", -1), r.$search.val("") }), n.on("focus", function() { n.isOpen() || r.$search.focus() }), n.on("results:all", function(t) {
                                if (null == t.query.term || "" === t.query.term) {
                                    var e = r.showSearch(t);
                                    e ? r.$searchContainer.removeClass("select2-search--hide") : r.$searchContainer.addClass("select2-search--hide")
                                }
                            })
                        }, n.prototype.handleSearch = function(t) {
                            if (!this._keyUpPrevented) {
                                var e = this.$search.val();
                                this.trigger("query", { term: e })
                            }
                            this._keyUpPrevented = !1
                        }, n.prototype.showSearch = function(t, e) { return !0 }, n
                    }), e.define("select2/dropdown/hidePlaceholder", [], function() {
                        function t(t, e, n, i) { this.placeholder = this.normalizePlaceholder(n.get("placeholder")), t.call(this, e, n, i) }
                        return t.prototype.append = function(t, e) { e.results = this.removePlaceholder(e.results), t.call(this, e) }, t.prototype.normalizePlaceholder = function(t, e) { return "string" == typeof e && (e = { id: "", text: e }), e }, t.prototype.removePlaceholder = function(t, e) {
                            for (var n = e.slice(0), i = e.length - 1; i >= 0; i--) {
                                var r = e[i];
                                this.placeholder.id === r.id && n.splice(i, 1)
                            }
                            return n
                        }, t
                    }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(t) {
                        function e(t, e, n, i) { this.lastParams = {}, t.call(this, e, n, i), this.$loadingMore = this.createLoadingMore(), this.loading = !1 }
                        return e.prototype.append = function(t, e) { this.$loadingMore.remove(), this.loading = !1, t.call(this, e), this.showLoadingMore(e) && this.$results.append(this.$loadingMore) }, e.prototype.bind = function(e, n, i) {
                            var r = this;
                            e.call(this, n, i), n.on("query", function(t) { r.lastParams = t, r.loading = !0 }), n.on("query:append", function(t) { r.lastParams = t, r.loading = !0 }), this.$results.on("scroll", function() {
                                var e = t.contains(document.documentElement, r.$loadingMore[0]);
                                if (!r.loading && e) {
                                    var n = r.$results.offset().top + r.$results.outerHeight(!1),
                                        i = r.$loadingMore.offset().top + r.$loadingMore.outerHeight(!1);
                                    n + 50 >= i && r.loadMore()
                                }
                            })
                        }, e.prototype.loadMore = function() {
                            this.loading = !0;
                            var e = t.extend({}, { page: 1 }, this.lastParams);
                            e.page++, this.trigger("query:append", e)
                        }, e.prototype.showLoadingMore = function(t, e) { return e.pagination && e.pagination.more }, e.prototype.createLoadingMore = function() {
                            var e = t('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),
                                n = this.options.get("translations").get("loadingMore");
                            return e.html(n(this.lastParams)), e
                        }, e
                    }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(t, e) {
                        function n(e, n, i) { this.$dropdownParent = i.get("dropdownParent") || t(document.body), e.call(this, n, i) }
                        return n.prototype.bind = function(t, e, n) {
                            var i = this,
                                r = !1;
                            t.call(this, e, n), e.on("open", function() { i._showDropdown(), i._attachPositioningHandler(e), r || (r = !0, e.on("results:all", function() { i._positionDropdown(), i._resizeDropdown() }), e.on("results:append", function() { i._positionDropdown(), i._resizeDropdown() })) }), e.on("close", function() { i._hideDropdown(), i._detachPositioningHandler(e) }), this.$dropdownContainer.on("mousedown", function(t) { t.stopPropagation() })
                        }, n.prototype.destroy = function(t) { t.call(this), this.$dropdownContainer.remove() }, n.prototype.position = function(t, e, n) { e.attr("class", n.attr("class")), e.removeClass("select2"), e.addClass("select2-container--open"), e.css({ position: "absolute", top: -999999 }), this.$container = n }, n.prototype.render = function(e) {
                            var n = t("<span></span>"),
                                i = e.call(this);
                            return n.append(i), this.$dropdownContainer = n, n
                        }, n.prototype._hideDropdown = function(t) { this.$dropdownContainer.detach() }, n.prototype._attachPositioningHandler = function(n, i) {
                            var r = this,
                                o = "scroll.select2." + i.id,
                                a = "resize.select2." + i.id,
                                s = "orientationchange.select2." + i.id,
                                l = this.$container.parents().filter(e.hasScroll);
                            l.each(function() { t(this).data("select2-scroll-position", { x: t(this).scrollLeft(), y: t(this).scrollTop() }) }), l.on(o, function(e) {
                                var n = t(this).data("select2-scroll-position");
                                t(this).scrollTop(n.y)
                            }), t(window).on(o + " " + a + " " + s, function(t) { r._positionDropdown(), r._resizeDropdown() })
                        }, n.prototype._detachPositioningHandler = function(n, i) {
                            var r = "scroll.select2." + i.id,
                                o = "resize.select2." + i.id,
                                a = "orientationchange.select2." + i.id,
                                s = this.$container.parents().filter(e.hasScroll);
                            s.off(r), t(window).off(r + " " + o + " " + a)
                        }, n.prototype._positionDropdown = function() {
                            var e = t(window),
                                n = this.$dropdown.hasClass("select2-dropdown--above"),
                                i = this.$dropdown.hasClass("select2-dropdown--below"),
                                r = null,
                                o = this.$container.offset();
                            o.bottom = o.top + this.$container.outerHeight(!1);
                            var a = { height: this.$container.outerHeight(!1) };
                            a.top = o.top, a.bottom = o.top + a.height;
                            var s = { height: this.$dropdown.outerHeight(!1) },
                                l = { top: e.scrollTop(), bottom: e.scrollTop() + e.height() },
                                u = l.top < o.top - s.height,
                                c = l.bottom > o.bottom + s.height,
                                d = { left: o.left, top: a.bottom },
                                h = this.$dropdownParent;
                            "static" === h.css("position") && (h = h.offsetParent());
                            var f = h.offset();
                            d.top -= f.top, d.left -= f.left, n || i || (r = "below"), c || !u || n ? !u && c && n && (r = "below") : r = "above", ("above" == r || n && "below" !== r) && (d.top = a.top - f.top - s.height), null != r && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + r), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + r)), this.$dropdownContainer.css(d)
                        }, n.prototype._resizeDropdown = function() {
                            var t = { width: this.$container.outerWidth(!1) + "px" };
                            this.options.get("dropdownAutoWidth") && (t.minWidth = t.width, t.position = "relative", t.width = "auto"), this.$dropdown.css(t)
                        }, n.prototype._showDropdown = function(t) { this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown() }, n
                    }), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
                        function t(e) {
                            for (var n = 0, i = 0; i < e.length; i++) {
                                var r = e[i];
                                r.children ? n += t(r.children) : n++
                            }
                            return n
                        }

                        function e(t, e, n, i) { this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), t.call(this, e, n, i) }
                        return e.prototype.showSearch = function(e, n) { return !(t(n.data.results) < this.minimumResultsForSearch) && e.call(this, n) }, e
                    }), e.define("select2/dropdown/selectOnClose", [], function() {
                        function t() {}
                        return t.prototype.bind = function(t, e, n) {
                            var i = this;
                            t.call(this, e, n), e.on("close", function(t) { i._handleSelectOnClose(t) })
                        }, t.prototype._handleSelectOnClose = function(t, e) {
                            if (e && null != e.originalSelect2Event) { var n = e.originalSelect2Event; if ("select" === n._type || "unselect" === n._type) return }
                            var i = this.getHighlightedResults();
                            if (!(i.length < 1)) {
                                var r = i.data("data");
                                null != r.element && r.element.selected || null == r.element && r.selected || this.trigger("select", { data: r })
                            }
                        }, t
                    }), e.define("select2/dropdown/closeOnSelect", [], function() {
                        function t() {}
                        return t.prototype.bind = function(t, e, n) {
                            var i = this;
                            t.call(this, e, n), e.on("select", function(t) { i._selectTriggered(t) }), e.on("unselect", function(t) { i._selectTriggered(t) })
                        }, t.prototype._selectTriggered = function(t, e) {
                            var n = e.originalEvent;
                            n && n.ctrlKey || this.trigger("close", { originalEvent: n, originalSelect2Event: e })
                        }, t
                    }), e.define("select2/i18n/en", [], function() {
                        return {
                            errorLoading: function() { return "The results could not be loaded." },
                            inputTooLong: function(t) {
                                var e = t.input.length - t.maximum,
                                    n = "Please delete " + e + " character";
                                return 1 != e && (n += "s"), n
                            },
                            inputTooShort: function(t) {
                                var e = t.minimum - t.input.length,
                                    n = "Please enter " + e + " or more characters";
                                return n
                            },
                            loadingMore: function() { return "Loading more results…" },
                            maximumSelected: function(t) { var e = "You can only select " + t.maximum + " item"; return 1 != t.maximum && (e += "s"), e },
                            noResults: function() { return "No results found" },
                            searching: function() { return "Searching…" }
                        }
                    }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(t, e, n, i, r, o, a, s, l, u, c, d, h, f, p, g, v, m, y, b, x, w, k, S, _, T, C, M, A) {
                        function E() { this.reset() } E.prototype.apply = function(d) {
                            if (d = t.extend(!0, {}, this.defaults, d), null == d.dataAdapter) {
                                if (null != d.ajax ? d.dataAdapter = p : null != d.data ? d.dataAdapter = f : d.dataAdapter = h, d.minimumInputLength > 0 && (d.dataAdapter = u.Decorate(d.dataAdapter, m)), d.maximumInputLength > 0 && (d.dataAdapter = u.Decorate(d.dataAdapter, y)), d.maximumSelectionLength > 0 && (d.dataAdapter = u.Decorate(d.dataAdapter, b)), d.tags && (d.dataAdapter = u.Decorate(d.dataAdapter, g)), null == d.tokenSeparators && null == d.tokenizer || (d.dataAdapter = u.Decorate(d.dataAdapter, v)), null != d.query) {
                                    var A = e(d.amdBase + "compat/query");
                                    d.dataAdapter = u.Decorate(d.dataAdapter, A)
                                }
                                if (null != d.initSelection) {
                                    var E = e(d.amdBase + "compat/initSelection");
                                    d.dataAdapter = u.Decorate(d.dataAdapter, E)
                                }
                            }
                            if (null == d.resultsAdapter && (d.resultsAdapter = n, null != d.ajax && (d.resultsAdapter = u.Decorate(d.resultsAdapter, S)), null != d.placeholder && (d.resultsAdapter = u.Decorate(d.resultsAdapter, k)), d.selectOnClose && (d.resultsAdapter = u.Decorate(d.resultsAdapter, C))), null == d.dropdownAdapter) {
                                if (d.multiple) d.dropdownAdapter = x;
                                else {
                                    var P = u.Decorate(x, w);
                                    d.dropdownAdapter = P
                                }
                                if (0 !== d.minimumResultsForSearch && (d.dropdownAdapter = u.Decorate(d.dropdownAdapter, T)), d.closeOnSelect && (d.dropdownAdapter = u.Decorate(d.dropdownAdapter, M)), null != d.dropdownCssClass || null != d.dropdownCss || null != d.adaptDropdownCssClass) {
                                    var I = e(d.amdBase + "compat/dropdownCss");
                                    d.dropdownAdapter = u.Decorate(d.dropdownAdapter, I)
                                }
                                d.dropdownAdapter = u.Decorate(d.dropdownAdapter, _)
                            }
                            if (null == d.selectionAdapter) {
                                if (d.multiple ? d.selectionAdapter = r : d.selectionAdapter = i, null != d.placeholder && (d.selectionAdapter = u.Decorate(d.selectionAdapter, o)), d.allowClear && (d.selectionAdapter = u.Decorate(d.selectionAdapter, a)), d.multiple && (d.selectionAdapter = u.Decorate(d.selectionAdapter, s)), null != d.containerCssClass || null != d.containerCss || null != d.adaptContainerCssClass) {
                                    var z = e(d.amdBase + "compat/containerCss");
                                    d.selectionAdapter = u.Decorate(d.selectionAdapter, z)
                                }
                                d.selectionAdapter = u.Decorate(d.selectionAdapter, l)
                            }
                            if ("string" == typeof d.language)
                                if (d.language.indexOf("-") > 0) {
                                    var D = d.language.split("-"),
                                        O = D[0];
                                    d.language = [d.language, O]
                                } else d.language = [d.language];
                            if (t.isArray(d.language)) {
                                var L = new c;
                                d.language.push("en");
                                for (var $ = d.language, N = 0; N < $.length; N++) {
                                    var R = $[N],
                                        q = {};
                                    try { q = c.loadPath(R) } catch (F) { try { R = this.defaults.amdLanguageBase + R, q = c.loadPath(R) } catch (H) { d.debug && window.console && console.warn; continue } } L.extend(q)
                                }
                                d.translations = L
                            } else {
                                var B = c.loadPath(this.defaults.amdLanguageBase + "en"),
                                    W = new c(d.language);
                                W.extend(B), d.translations = W
                            }
                            return d
                        }, E.prototype.reset = function() {
                            function e(t) {
                                function e(t) { return d[t] || t }
                                return t.replace(/[^\u0000-\u007E]/g, e)
                            }

                            function n(i, r) {
                                if ("" === t.trim(i.term)) return r;
                                if (r.children && r.children.length > 0) {
                                    for (var o = t.extend(!0, {}, r), a = r.children.length - 1; a >= 0; a--) {
                                        var s = r.children[a],
                                            l = n(i, s);
                                        null == l && o.children.splice(a, 1)
                                    }
                                    return o.children.length > 0 ? o : n(i, o)
                                }
                                var u = e(r.text).toUpperCase(),
                                    c = e(i.term).toUpperCase();
                                return u.indexOf(c) > -1 ? r : null
                            }
                            this.defaults = { amdBase: "./", amdLanguageBase: "./i18n/", closeOnSelect: !0, debug: !1, dropdownAutoWidth: !1, escapeMarkup: u.escapeMarkup, language: A, matcher: n, minimumInputLength: 0, maximumInputLength: 0, maximumSelectionLength: 0, minimumResultsForSearch: 0, selectOnClose: !1, sorter: function(t) { return t }, templateResult: function(t) { return t.text }, templateSelection: function(t) { return t.text }, theme: "default", width: "resolve" }
                        }, E.prototype.set = function(e, n) {
                            var i = t.camelCase(e),
                                r = {};
                            r[i] = n;
                            var o = u._convertData(r);
                            t.extend(this.defaults, o)
                        };
                        var P = new E;
                        return P
                    }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(t, e, n, i) {
                        function r(e, r) {
                            if (this.options = e, null != r && this.fromElement(r), this.options = n.apply(this.options), r && r.is("input")) {
                                var o = t(this.get("amdBase") + "compat/inputData");
                                this.options.dataAdapter = i.Decorate(this.options.dataAdapter, o)
                            }
                        }
                        return r.prototype.fromElement = function(t) {
                            var n = ["select2"];
                            null == this.options.multiple && (this.options.multiple = t.prop("multiple")), null == this.options.disabled && (this.options.disabled = t.prop("disabled")), null == this.options.language && (t.prop("lang") ? this.options.language = t.prop("lang").toLowerCase() : t.closest("[lang]").prop("lang") && (this.options.language = t.closest("[lang]").prop("lang"))), null == this.options.dir && (t.prop("dir") ? this.options.dir = t.prop("dir") : t.closest("[dir]").prop("dir") ? this.options.dir = t.closest("[dir]").prop("dir") : this.options.dir = "ltr"), t.prop("disabled", this.options.disabled), t.prop("multiple", this.options.multiple), t.data("select2Tags") && (this.options.debug && window.console && console.warn, t.data("data", t.data("select2Tags")), t.data("tags", !0)), t.data("ajaxUrl") && (this.options.debug && window.console && console.warn, t.attr("ajax--url", t.data("ajaxUrl")), t.data("ajax--url", t.data("ajaxUrl")));
                            var r = {};
                            r = e.fn.jquery && "1." == e.fn.jquery.substr(0, 2) && t[0].dataset ? e.extend(!0, {}, t[0].dataset, t.data()) : t.data();
                            var o = e.extend(!0, {}, r);
                            o = i._convertData(o);
                            for (var a in o) e.inArray(a, n) > -1 || (e.isPlainObject(this.options[a]) ? e.extend(this.options[a], o[a]) : this.options[a] = o[a]);
                            return this
                        }, r.prototype.get = function(t) { return this.options[t] }, r.prototype.set = function(t, e) { this.options[t] = e }, r
                    }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(t, e, n, i) {
                        var r = function(t, n) {
                            null != t.data("select2") && t.data("select2").destroy(), this.$element = t, this.id = this._generateId(t), n = n || {}, this.options = new e(n, t), r.__super__.constructor.call(this);
                            var i = t.attr("tabindex") || 0;
                            t.data("old-tabindex", i), t.attr("tabindex", "-1");
                            var o = this.options.get("dataAdapter");
                            this.dataAdapter = new o(t, this.options);
                            var a = this.render();
                            this._placeContainer(a);
                            var s = this.options.get("selectionAdapter");
                            this.selection = new s(t, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, a);
                            var l = this.options.get("dropdownAdapter");
                            this.dropdown = new l(t, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, a);
                            var u = this.options.get("resultsAdapter");
                            this.results = new u(t, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
                            var c = this;
                            this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(t) { c.trigger("selection:update", { data: t }) }), t.addClass("select2-hidden-accessible"), t.attr("aria-hidden", "true"), this._syncAttributes(), t.data("select2", this)
                        };
                        return n.Extend(r, n.Observable), r.prototype._generateId = function(t) { var e = ""; return e = null != t.attr("id") ? t.attr("id") : null != t.attr("name") ? t.attr("name") + "-" + n.generateChars(2) : n.generateChars(4), e = e.replace(/(:|\.|\[|\]|,)/g, ""), e = "select2-" + e }, r.prototype._placeContainer = function(t) {
                            t.insertAfter(this.$element);
                            var e = this._resolveWidth(this.$element, this.options.get("width"));
                            null != e && t.css("width", e)
                        }, r.prototype._resolveWidth = function(t, e) {
                            var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                            if ("resolve" == e) { var i = this._resolveWidth(t, "style"); return null != i ? i : this._resolveWidth(t, "element") }
                            if ("element" == e) { var r = t.outerWidth(!1); return r <= 0 ? "auto" : r + "px" }
                            if ("style" == e) {
                                var o = t.attr("style");
                                if ("string" != typeof o) return null;
                                for (var a = o.split(";"), s = 0, l = a.length; s < l; s += 1) {
                                    var u = a[s].replace(/\s/g, ""),
                                        c = u.match(n);
                                    if (null !== c && c.length >= 1) return c[1]
                                }
                                return null
                            }
                            return e
                        }, r.prototype._bindAdapters = function() { this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container) }, r.prototype._registerDomEvents = function() {
                            var e = this;
                            this.$element.on("change.select2", function() { e.dataAdapter.current(function(t) { e.trigger("selection:update", { data: t }) }) }), this.$element.on("focus.select2", function(t) { e.trigger("focus", t) }), this._syncA = n.bind(this._syncAttributes, this), this._syncS = n.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                            var i = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                            null != i ? (this._observer = new i(function(n) { t.each(n, e._syncA), t.each(n, e._syncS) }), this._observer.observe(this.$element[0], { attributes: !0, childList: !0, subtree: !1 })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", e._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", e._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", e._syncS, !1))
                        }, r.prototype._registerDataEvents = function() {
                            var t = this;
                            this.dataAdapter.on("*", function(e, n) { t.trigger(e, n) })
                        }, r.prototype._registerSelectionEvents = function() {
                            var e = this,
                                n = ["toggle", "focus"];
                            this.selection.on("toggle", function() { e.toggleDropdown() }), this.selection.on("focus", function(t) { e.focus(t) }), this.selection.on("*", function(i, r) { t.inArray(i, n) === -1 && e.trigger(i, r) })
                        }, r.prototype._registerDropdownEvents = function() {
                            var t = this;
                            this.dropdown.on("*", function(e, n) { t.trigger(e, n) })
                        }, r.prototype._registerResultsEvents = function() {
                            var t = this;
                            this.results.on("*", function(e, n) { t.trigger(e, n) })
                        }, r.prototype._registerEvents = function() {
                            var t = this;
                            this.on("open", function() { t.$container.addClass("select2-container--open") }), this.on("close", function() { t.$container.removeClass("select2-container--open") }), this.on("enable", function() { t.$container.removeClass("select2-container--disabled") }), this.on("disable", function() { t.$container.addClass("select2-container--disabled") }), this.on("blur", function() { t.$container.removeClass("select2-container--focus") }), this.on("query", function(e) { t.isOpen() || t.trigger("open", {}), this.dataAdapter.query(e, function(n) { t.trigger("results:all", { data: n, query: e }) }) }), this.on("query:append", function(e) { this.dataAdapter.query(e, function(n) { t.trigger("results:append", { data: n, query: e }) }) }), this.on("keypress", function(e) {
                                var n = e.which;
                                t.isOpen() ? n === i.ESC || n === i.TAB || n === i.UP && e.altKey ? (t.close(), e.preventDefault()) : n === i.ENTER ? (t.trigger("results:select", {}), e.preventDefault()) : n === i.SPACE && e.ctrlKey ? (t.trigger("results:toggle", {}), e.preventDefault()) : n === i.UP ? (t.trigger("results:previous", {}), e.preventDefault()) : n === i.DOWN && (t.trigger("results:next", {}), e.preventDefault()) : (n === i.ENTER || n === i.SPACE || n === i.DOWN && e.altKey) && (t.open(), e.preventDefault())
                            })
                        }, r.prototype._syncAttributes = function() { this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {}) }, r.prototype._syncSubtree = function(t, e) {
                            var n = !1,
                                i = this;
                            if (!t || !t.target || "OPTION" === t.target.nodeName || "OPTGROUP" === t.target.nodeName) {
                                if (e)
                                    if (e.addedNodes && e.addedNodes.length > 0)
                                        for (var r = 0; r < e.addedNodes.length; r++) {
                                            var o = e.addedNodes[r];
                                            o.selected && (n = !0)
                                        } else e.removedNodes && e.removedNodes.length > 0 && (n = !0);
                                    else n = !0;
                                n && this.dataAdapter.current(function(t) { i.trigger("selection:update", { data: t }) })
                            }
                        }, r.prototype.trigger = function(t, e) {
                            var n = r.__super__.trigger,
                                i = { open: "opening", close: "closing", select: "selecting", unselect: "unselecting" };
                            if (void 0 === e && (e = {}), t in i) {
                                var o = i[t],
                                    a = { prevented: !1, name: t, args: e };
                                if (n.call(this, o, a), a.prevented) return void(e.prevented = !0)
                            }
                            n.call(this, t, e)
                        }, r.prototype.toggleDropdown = function() { this.options.get("disabled") || (this.isOpen() ? this.close() : this.open()) }, r.prototype.open = function() { this.isOpen() || this.trigger("query", {}) }, r.prototype.close = function() { this.isOpen() && this.trigger("close", {}) }, r.prototype.isOpen = function() { return this.$container.hasClass("select2-container--open") }, r.prototype.hasFocus = function() { return this.$container.hasClass("select2-container--focus") }, r.prototype.focus = function(t) { this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {})) }, r.prototype.enable = function(t) {
                            this.options.get("debug") && window.console && console.warn, null != t && 0 !== t.length || (t = [!0]);
                            var e = !t[0];
                            this.$element.prop("disabled", e)
                        }, r.prototype.data = function() { this.options.get("debug") && arguments.length > 0 && window.console && console.warn; var t = []; return this.dataAdapter.current(function(e) { t = e }), t }, r.prototype.val = function(e) {
                            if (this.options.get("debug") && window.console && console.warn, null == e || 0 === e.length) return this.$element.val();
                            var n = e[0];
                            t.isArray(n) && (n = t.map(n, function(t) { return t.toString() })), this.$element.val(n).trigger("change")
                        }, r.prototype.destroy = function() { this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", this.$element.data("old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null }, r.prototype.render = function() { var e = t('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>'); return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), e.data("element", this.$element), e }, r
                    }), e.define("jquery-mousewheel", ["jquery"], function(t) { return t }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults"], function(t, e, n, i) {
                        if (null == t.fn.select2) {
                            var r = ["open", "close", "destroy"];
                            t.fn.select2 = function(e) {
                                if (e = e || {}, "object" == typeof e) return this.each(function() {
                                    var i = t.extend(!0, {}, e);
                                    new n(t(this), i)
                                }), this;
                                if ("string" == typeof e) {
                                    var i, o = Array.prototype.slice.call(arguments, 1);
                                    return this.each(function() {
                                        var n = t(this).data("select2");
                                        null == n && window.console && console.error, i = n[e].apply(n, o)
                                    }), t.inArray(e, r) > -1 ? this : i
                                }
                                throw new Error("Invalid arguments for Select2: " + e)
                            }
                        }
                        return null == t.fn.select2.defaults && (t.fn.select2.defaults = i), n
                    }), { define: e.define, require: e.require }
                }(),
                n = e.require("jquery.select2");
            return t.fn.select2.amd = e, n
        })
    }).call(e, n(2))
}, function(t, e, n) {
    function i(t, e) {
        "use strict";
        var n = [],
            i = 0,
            r = function(r, o) {
                function a(t) { return "[object Array]" === Object.prototype.toString.call(t) }

                function s(t, e) { for (var n in e) t[n] = e[n]; return t }

                function l(t, e) { var n; return t.currentStyle ? n = t.currentStyle[e] : document.defaultView && document.defaultView.getComputedStyle && (n = document.defaultView.getComputedStyle(t, "")[e]), n }

                function u(t, e, n) { if (t.addEventListener) return t.addEventListener(e, n, !1), n; if (t.attachEvent) { var i = function() { n.call(t) }; return t.attachEvent("on" + e, i), i } }

                function c(t, e, n) { t.addEventListener ? t.removeEventListener(e, n, !1) : t.detachEvent && t.detachEvent("on" + e, n) }

                function d(t) { var e, n; return n = t.indexOf("ms") > -1 ? 1 : 1e3, e = "0s" == t ? 0 : parseFloat(t.replace("s", "")) * n }

                function h(t, e) { return void 0 !== t ? new RegExp("(\\s|^)" + e + "(\\s|$)").test(t.className) : void 0 }

                function f(t, e) { var n, i, r; for (a(t) === !1 && (i = 1, t = [t]), i = t.length, r = 0; i > r; r++) n = t[r], h(n, e) === !1 && (n.className += (n.className ? " " : "") + e) }

                function p(t, e) { var n, i, r; for (a(t) === !1 ? (i = 1, t = [t]) : i = t.length, r = 0; i > r; r++) n = t[r], h(n, e) === !0 && (n.className = n.className.replace(new RegExp("(\\s|^)" + e + "(\\s|$)"), " ").replace(/^\s+|\s+$/g, "")) }

                function g(t, e) {
                    var n = t.getBoundingClientRect(),
                        i = !1;
                    return e.clientX >= n.left && e.clientX <= n.right && e.clientY >= n.top && e.clientY <= n.bottom && (i = !0), i
                }

                function v(t, e, n) {
                    if ("BODY" === e.nodeName) return !1;
                    if (t !== e) return n = e, v(t, e.parentNode, n);
                    if (void 0 !== n)
                        for (var i = n, r = t.getElementsByTagName(i.nodeName), o = r.length; o--;)
                            if (i === r[o]) return o + 1
                }

                function m(t) {
                    var n = 0,
                        i = e.DIRECTION_NONE;
                    return (void 0 !== t.left || void 0 !== t.right) && (n += 1), (void 0 !== t.up || void 0 !== t.down) && (n += 2), 1 === n ? i = e.DIRECTION_HORIZONTAL : 2 === n ? i = e.DIRECTION_VERTICAL : 3 === n && (i = e.DIRECTION_ALL), i
                }

                function y(t, e) {
                    var n = "seq-",
                        i = "no-touch";
                    e.touch === !0 && (i = "touch"), f(t, n + i)
                }
                var b = r.getAttribute("data-seq-enabled");
                if (null !== b) return n[b];
                r.setAttribute("data-seq-enabled", i), i++;
                var x = { startingStepId: 1, startingStepAnimatesIn: !1, cycle: !0, phaseThreshold: !0, reverseWhenNavigatingBackwards: !1, moveActiveStepToTop: !0, animateCanvas: !0, animateCanvasDuration: 250, autoPlay: !1, autoPlayInterval: 5e3, autoPlayDelay: null, autoPlayDirection: 1, autoPlayButton: !0, autoPlayPauseOnHover: !0, navigationSkip: !0, navigationSkipThreshold: 250, fadeStepWhenSkipped: !0, fadeStepTime: 500, ignorePhaseThresholdWhenSkipped: !1, preventReverseSkipping: !1, nextButton: !0, prevButton: !0, pagination: !0, preloader: !1, preloadTheseSteps: [1], preloadTheseImages: [], hideStepsUntilPreloaded: !1, pausePreloader: !1, keyNavigation: !1, numericKeysGoToSteps: !1, keyEvents: { left: function(t) { t.prev() }, right: function(t) { t.next() } }, swipeNavigation: !0, swipeEvents: { left: function(t) { t.next() }, right: function(t) { t.prev() }, up: void 0, down: void 0 }, swipeHammerOptions: {}, hashTags: !1, hashDataAttribute: !1, hashChangesOnFirstStep: !1, fallback: { speed: 500 } },
                    w = 50,
                    k = 100,
                    S = { animation: { WebkitAnimation: "-webkit-", animation: "" } },
                    _ = function(t, e, n) {
                        function i(t) { m.cssText = t }

                        function r(t, e) { return typeof t === e }

                        function o(t, e) { return !!~("" + t).indexOf(e) }

                        function a(t, e) { for (var i in t) { var r = t[i]; if (!o(r, "-") && m[r] !== n) return "pfx" != e || r } return !1 }

                        function s(t, e, i) { for (var o in t) { var a = e[t[o]]; if (a !== n) return i === !1 ? t[o] : r(a, "function") ? a.bind(i || e) : a } return !1 }

                        function l(t, e, n) {
                            var i = t.charAt(0).toUpperCase() + t.slice(1),
                                o = (t + " " + x.join(i + " ") + i).split(" ");
                            return r(e, "string") || r(e, "undefined") ? a(o, e) : (o = (t + " " + w.join(i + " ") + i).split(" "), s(o, e, n))
                        }
                        var u, c, d, h = "2.8.3",
                            f = {},
                            p = e.documentElement,
                            g = "modernizr",
                            v = e.createElement(g),
                            m = v.style,
                            y = ({}.toString, " -webkit- -moz- -o- -ms- ".split(" ")),
                            b = "Webkit Moz O ms",
                            x = b.split(" "),
                            w = b.toLowerCase().split(" "),
                            k = { svg: "http://www.w3.org/2000/svg" },
                            S = {},
                            _ = [],
                            T = _.slice,
                            C = function(t, n, i, r) {
                                var o, a, s, l, u = e.createElement("div"),
                                    c = e.body,
                                    d = c || e.createElement("body");
                                if (parseInt(i, 10))
                                    for (; i--;) s = e.createElement("div"), s.id = r ? r[i] : g + (i + 1), u.appendChild(s);
                                return o = ["&#173;", '<style id="s', g, '">', t, "</style>"].join(""), u.id = g, (c ? u : d).innerHTML += o, d.appendChild(u), c || (d.style.background = "", d.style.overflow = "hidden", l = p.style.overflow, p.style.overflow = "hidden", p.appendChild(d)), a = n(u, t), c ? u.parentNode.removeChild(u) : (d.parentNode.removeChild(d), p.style.overflow = l), !!a
                            },
                            M = {}.hasOwnProperty;
                        d = r(M, "undefined") || r(M.call, "undefined") ? function(t, e) { return e in t && r(t.constructor.prototype[e], "undefined") } : function(t, e) { return M.call(t, e) }, Function.prototype.bind || (Function.prototype.bind = function(t) {
                            var e = this;
                            if ("function" != typeof e) throw new TypeError;
                            var n = T.call(arguments, 1),
                                i = function() {
                                    if (this instanceof i) {
                                        var r = function() {};
                                        r.prototype = e.prototype;
                                        var o = new r,
                                            a = e.apply(o, n.concat(T.call(arguments)));
                                        return Object(a) === a ? a : o
                                    }
                                    return e.apply(t, n.concat(T.call(arguments)))
                                };
                            return i
                        }), S.touch = function() { var n; return "ontouchstart" in t || t.DocumentTouch && e instanceof DocumentTouch ? n = !0 : C(["@media (", y.join("touch-enabled),("), g, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function(t) { n = 9 === t.offsetTop }), n }, S.cssanimations = function() { return l("animationName") }, S.csstransforms = function() { return !!l("transform") }, S.csstransitions = function() { return l("transition") }, S.svg = function() { return !!e.createElementNS && !!e.createElementNS(k.svg, "svg").createSVGRect };
                        for (var A in S) d(S, A) && (c = A.toLowerCase(), f[c] = S[A](), _.push((f[c] ? "" : "no-") + c));
                        return f.addTest = function(t, e) {
                            if ("object" == typeof t)
                                for (var i in t) d(t, i) && f.addTest(i, t[i]);
                            else {
                                if (t = t.toLowerCase(), f[t] !== n) return f;
                                e = "function" == typeof e ? e() : e, "undefined" != typeof enableClasses && enableClasses && (p.className += " " + (e ? "" : "no-") + t), f[t] = e
                            }
                            return f
                        }, i(""), v = u = null, f._version = h, f._prefixes = y, f._domPrefixes = w, f._cssomPrefixes = x, f.testProp = function(t) { return a([t]) }, f.testAllProps = l, f.testStyles = C, f.prefixed = function(t, e, n) { return e ? l(t, e, n) : l(t, "pfx") }, f
                    }(window, window.document);
                Array.prototype.indexOf || (Array.prototype.indexOf = function(t, e) {
                    if (void 0 === this || null === this) throw new TypeError('"this" is null or not defined');
                    var n = this.length >>> 0;
                    for (e = +e || 0, Math.abs(e) === 1 / 0 && (e = 0), 0 > e && (e += n, 0 > e && (e = 0)); n > e; e++)
                        if (this[e] === t) return e;
                    return -1
                });
                var T, C;
                "undefined" != typeof document.hidden ? (T = "hidden", C = "visibilitychange") : "undefined" != typeof document.mozHidden ? (T = "mozHidden", C = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (T = "msHidden", C = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (T = "webkitHidden", C = "webkitvisibilitychange");
                var M = { modernizr: _ };
                return M.ui = { defaultElements: { nextButton: "seq-next", prevButton: "seq-prev", autoPlayButton: "seq-autoplay", pagination: "seq-pagination", preloader: "seq-preloader" }, getElements: function(t, e) { var n, i, r, o, a, s = []; for (i = document.querySelectorAll(e === !0 ? "." + this.defaultElements[t] : e), r = i.length, a = 0; r > a; a++) n = i[a], o = n.getAttribute("rel"), (null === o || o === M.$container.getAttribute("id")) && s.push(n); return s }, show: function(t, e) { M.propertySupport.transitions === !0 ? (t.style[_.prefixed("transitionDuration")] = e + "ms", t.style[_.prefixed("transitionProperty")] = "opacity, " + _.prefixed("transform"), t.style.opacity = 1) : M.animationFallback.animate(t, "opacity", "", 0, 1, e) }, hide: function(t, e, n) { M.propertySupport.transitions === !0 ? (t.style[_.prefixed("transitionDuration")] = e + "ms", t.style[_.prefixed("transitionProperty")] = "opacity, " + _.prefixed("transform"), t.style.opacity = 0) : M.animationFallback.animate(t, "opacity", "", 1, 0, e), void 0 !== n && (M.hideTimer = setTimeout(function() { n() }, e)) } }, M.autoPlay = {
                    init: function() { M.isAutoPlayPaused = !1, M.isAutoPlaying = !1 },
                    getDelay: function(t, e, n) {
                        switch (t) {
                            case !0:
                                t = null === e ? n : e;
                                break;
                            case !1:
                            case void 0:
                                t = 0
                        }
                        return t
                    },
                    start: function(t, e) { if (M.isAutoPlaying === !0 || M.isReady === !1) return !1; var n = M.options; return t = this.getDelay(t, n.autoPlayDelay, n.autoPlayInterval), void 0 === e && M.started(M), f(M.$container, "seq-autoplaying"), f(M.$autoPlay, "seq-autoplaying"), n.autoPlay = !0, M.isAutoPlaying = !0, M.isAnimating === !1 && (M.autoPlayTimer = setTimeout(function() { 1 === n.autoPlayDirection ? M.next() : M.prev() }, t)), !0 },
                    stop: function() { return M.options.autoPlay === !0 && M.isAutoPlaying === !0 && (M.options.autoPlay = !1, M.isAutoPlaying = !1, clearTimeout(M.autoPlayTimer), p(M.$container, "seq-autoplaying"), p(M.$autoPlay, "seq-autoplaying"), M.stopped(M), !0) },
                    unpause: function() { return M.isAutoPlayPaused === !0 && (M.isAutoPlayPaused = !1, this.start(!0), !0) },
                    pause: function() { return M.options.autoPlay === !0 && (M.isAutoPlayPaused = !0, this.stop(), !0) }
                }, M.canvas = {
                    init: function() { void 0 !== M.$screen && (M.$screen.style.height = "100%", M.$screen.style.width = "100%"), M.canvas.getTransformProperties() },
                    getSteps: function(t) {
                        var e, n, i, r = [],
                            o = t.children,
                            a = o.length;
                        for (M.stepProperties = {}, i = 0; a > i; i++) n = o[i], e = i + 1, r.push(n), M.stepProperties[e] = {}, M.stepProperties[e].isActive = !1;
                        return r
                    },
                    getTransformProperties: function() { var t, e, n, i; for (t = 0; t < M.noOfSteps; t++) e = M.$steps[t], n = t + 1, i = { seqX: 0, seqY: 0, seqZ: 0 }, i.seqX += -1 * e.offsetLeft, i.seqY += -1 * e.offsetTop, M.stepProperties[n].canvasTransform = i },
                    move: function(t, e) { if (M.options.animateCanvas === !0) { var n, i = 0; return e === !0 && M.firstRun === !1 && (i = M.options.animateCanvasDuration), M.isFallbackMode === !1 && (n = M.stepProperties[t].canvasTransform, M.$canvas.style[_.prefixed("transitionDuration")] = i + "ms", M.$canvas.style[_.prefixed("transform")] = "translateX(" + n.seqX + "px) translateY(" + n.seqY + "px) translateZ(" + n.seqZ + "px) "), !0 } return !1 },
                    removeNoJsClass: function() {
                        if (M.isFallbackMode !== !0)
                            for (var t = 0; t < M.$steps.length; t++) {
                                var e = M.$steps[t];
                                if (h(e, "seq-in") === !0) {
                                    var n = t + 1;
                                    M.animation.resetInheritedSpeed(n), p(e, "seq-in")
                                }
                            }
                    }
                }, M.animation = {
                    getPhaseProperties: function(t) {
                        var e, n, i, r, o = M.$steps[t - 1],
                            a = o.querySelectorAll("*[data-seq]"),
                            s = o.querySelectorAll("*"),
                            u = s.length,
                            c = [],
                            h = [],
                            f = [],
                            p = [],
                            g = [],
                            v = [];
                        for (n = 0; u > n; n++) e = s[n], i = d(l(e, _.prefixed("transitionDuration"))), r = d(l(e, _.prefixed("transitionDelay"))), p.push(i), g.push(r), v.push(i + r), null !== e.getAttribute("data-seq") && (c.push(i), h.push(r), f.push(i + r));
                        var m = Math.max.apply(Math, p),
                            y = Math.max.apply(Math, g),
                            b = Math.max.apply(Math, v),
                            x = Math.max.apply(Math, c),
                            w = Math.max.apply(Math, h),
                            k = Math.max.apply(Math, f);
                        return { stepId: t, stepElement: o, children: s, animatedChildren: a, watchedTimings: { maxDuration: x, maxDelay: w, maxTotal: k }, timings: { maxDuration: m, maxDelay: y, maxTotal: b } }
                    },
                    getPhaseThreshold: function(t, e, n, i) { var r = 0; return n === !0 && M.options.ignorePhaseThresholdWhenSkipped === !0 && (t = !0), void 0 === t && (e === !0 ? r = i : e !== !1 && (r = e)), r },
                    getReversePhaseDelay: function(t, e, n, i, r) {
                        var o = 0,
                            a = 0,
                            s = 0;
                        return n === !0 || i !== !1 && r !== !1 || (o = t - e, o > 0 ? s = o : 0 > o && (a = Math.abs(o))), { next: s, current: a }
                    },
                    moveActiveStepToTop: function(t, e) {
                        if (M.options.moveActiveStepToTop === !0) {
                            var n = M.$steps[M.prevStepId - 1],
                                i = M.noOfSteps - 1;
                            n.style.zIndex = 1, t.style.zIndex = i, e.style.zIndex = M.noOfSteps
                        }
                        return null
                    },
                    manageNavigationSkip: function(t, e) {
                        if (M.isFallbackMode !== !0) {
                            var n, i, r, o, a;
                            if (M.ui.show(e, 0), M.options.navigationSkip === !0) {
                                if (M.navigationSkipThresholdActive = !0, 0 !== M.phasesAnimating && (clearTimeout(M.phaseThresholdTimer), clearTimeout(M.nextPhaseStartedTimer), M.options.fadeStepWhenSkipped === !0))
                                    for (n = 1; n <= M.noOfSteps; n++) i = M.stepProperties[n], i.isActive === !0 && n !== t && (r = M.$steps[n - 1], o = n, a = {}, a.id = o, a.element = r, M.phasesSkipped.push(a), M.animation.stepSkipped(r));
                                M.navigationSkipThresholdTimer = setTimeout(function() { M.navigationSkipThresholdActive = !1 }, M.options.navigationSkipThreshold)
                            }
                        }
                    },
                    stepSkipped: function(t) { M.ui.hide(t, M.options.fadeStepTime, function() {}) },
                    changeStep: function(t) {
                        var e = "seq-step" + t;
                        if (void 0 !== M.currentStepId) {
                            var n = "seq-step" + M.currentStepId;
                            f(M.$container, e), p(M.$container, n)
                        } else f(M.$container, e)
                    },
                    reverseProperties: function(t, e, n, i) {
                        var r, o, a, s, u, c, h, f, p, g = this,
                            v = t.children,
                            m = v.length,
                            y = t.timings,
                            b = [],
                            x = [];
                        for (o = 0; m > o; o++) r = v[o], u = d(l(r, _.prefixed("transitionDuration"))), c = d(l(r, _.prefixed("transitionDelay"))), h = u + c, c = y.maxTotal - h, i !== !0 && (c += e), h = u + c, b.push(h), null !== r.getAttribute("data-seq") && x.push(h), a = l(r, _.prefixed("transitionTimingFunction")), s = g.reverseTimingFunction(a), r.style[_.prefixed("transition")] = u + "ms " + c + "ms " + s;
                        return f = Math.max.apply(Math, b), p = Math.max.apply(Math, x), setTimeout(function() { g.domDelay(function() { for (o = 0; m > o; o++) r = v[o], r.style[_.prefixed("transition")] = "" }) }, f + n), p
                    },
                    forward: function(t, e, n, i, r) {
                        var o, a, s, l = this;
                        M.firstRun === !1 && l.currentPhaseStarted(M.currentStepId), p(n, "seq-out"), l.domDelay(function() { o = l.startAnimateOut(M.currentStepId, e, 1), a = o.watchedTimings.maxTotal, s = l.getPhaseThreshold(i, M.options.phaseThreshold, M.isAnimating, a), M.isAnimating = !0, l.startAnimateIn(t, a, n, s, r) })
                    },
                    reverse: function(t, e, n, i, r) {
                        var o, a, s, l, u, c = this,
                            d = 0;
                        f(n, "seq-out"), c.domDelay(function() { a = c.getPhaseProperties(M.currentStepId, "current"), s = c.getPhaseProperties(t, "next"), d = c.getPhaseThreshold(i, M.options.phaseThreshold, M.isAnimating, a.timings.maxTotal), o = c.getReversePhaseDelay(a.timings.maxTotal, s.timings.maxTotal, M.options.phaseThreshold, M.options.ignorePhaseThresholdWhenSkipped, M.isAnimating), l = c.reverseProperties(a, o.current, 0, i), u = c.reverseProperties(s, o.next, d, i), c.startAnimateOut(M.currentStepId, e, -1, l), M.isAnimating = !0, M.firstRun === !1 && c.currentPhaseStarted(M.currentStepId), c.startAnimateIn(t, l, n, d, r, u) })
                    },
                    startAnimateIn: function(t, e, n, i, r, o) {
                        var a, s, l = this;
                        M.prevStepId = M.currentStepId, M.currentStepId = t, M.firstRun === !0 && M.pagination.update(), M.firstRun === !1 || M.options.startingStepAnimatesIn === !0 ? (M.stepProperties[t].isActive = !0, M.nextPhaseStartedTimer = setTimeout(function() { l.nextPhaseStarted(t, r) }, i), M.phaseThresholdTimer = setTimeout(function() { f(n, "seq-in"), p(n, "seq-out"), void 0 === o && (a = M.animation.getPhaseProperties(t, "next"), o = a.watchedTimings.maxTotal), l.phaseEnded(t, "next", o, l.nextPhaseEnded), s = l.getStepDuration(e, o, M.options.phaseThreshold), M.stepEndedTimer = setTimeout(function() { M.animation.stepEnded(t) }, s) }, i)) : (l.resetInheritedSpeed(t), M.phasesAnimating = 0, M.isAnimating = !1, M.options.autoPlay === !0 && M.autoPlay.start(!0), f(n, "seq-in"), p(n, "seq-out")), M.firstRun = !1
                    },
                    startAnimateOut: function(t, e, n, i) { var r, o = this; return 1 === n ? (p(e, "seq-in"), f(e, "seq-out"), r = o.getPhaseProperties(t, "current"), i = r.watchedTimings.maxTotal) : p(e, "seq-in"), M.firstRun === !1 && (M.stepProperties[t].isActive = !0, o.phaseEnded(t, "current", i, o.currentPhaseEnded)), r },
                    getStepDuration: function(t, e, n) {
                        var i;
                        switch (n) {
                            case !0:
                                i = e;
                                break;
                            case !1:
                                i = t >= e ? t : e;
                                break;
                            default:
                                i = t >= e + n ? t - n : e
                        }
                        return i
                    },
                    currentPhaseStarted: function(t) { M.phasesAnimating++, M.currentPhaseStarted(t, M) },
                    currentPhaseEnded: function(t) { M.currentPhaseEnded(t, M) },
                    nextPhaseStarted: function(t, e) { M.phasesAnimating++, void 0 === e && M.hashTags.update(), M.pagination.update(), M.nextPhaseStarted(t, M) },
                    nextPhaseEnded: function(t) { M.nextPhaseEnded(t, M) },
                    phaseEnded: function(t, e, n, i) {
                        var r;
                        r = function(t) { M.stepProperties[t].isActive = !1, M.phasesAnimating--, i(t) }, "current" === e ? M.currentPhaseEndedTimer = setTimeout(function() { r(t) }, n) : M.nextPhaseEndedTimer = setTimeout(function() { r(t) }, n)
                    },
                    stepEnded: function(t) { M.isAnimating = !1, M.isAutoPlaying = !1, M.options.autoPlay === !0 && M.autoPlay.start(!0, !0), M.animationEnded(t, M) },
                    reversePhase: function(t) { var e = { "seq-out": "seq-in", "seq-in": "seq-out" }; return e[t] },
                    domDelay: function(t) { setTimeout(function() { t() }, w) },
                    reverseTimingFunction: function(t) { if ("" === t || void 0 === t) return t; var e, n, i, r, o = { linear: "cubic-bezier(0.0,0.0,1.0,1.0)", ease: "cubic-bezier(0.25, 0.1, 0.25, 1.0)", "ease-in": "cubic-bezier(0.42, 0.0, 1.0, 1.0)", "ease-in-out": "cubic-bezier(0.42, 0.0, 0.58, 1.0)", "ease-out": "cubic-bezier(0.0, 0.0, 0.58, 1.0)" }; for (t.indexOf("cubic-bezier") < 0 && (t = t.split(",")[0], t = o[t]), e = t.replace("cubic-bezier(", "").replace(")", "").split(","), n = e.length, r = 0; n > r; r++) e[r] = parseFloat(e[r]); return i = [1 - e[2], 1 - e[3], 1 - e[0], 1 - e[1]], t = "cubic-bezier(" + i + ")" },
                    resetInheritedSpeed: function(t) {
                        if (M.isFallbackMode !== !0) {
                            var e, n, i = M.$steps[t - 1].querySelectorAll("*"),
                                r = i.length;
                            for (n = 0; r > n; n++) e = i[n], e.style[_.prefixed("transition")] = "0ms 0ms";
                            M.animation.domDelay(function() { for (n = 0; r > n; n++) e = i[n], e.style[_.prefixed("transition")] = "" })
                        }
                    },
                    getDirection: function(t, e, n, i, r, o, a) { var s = 1; return s = void 0 !== e ? e : o === !0 || r === !0 ? a === !0 && 1 === t && n === i ? 1 : n > t ? -1 : 1 : 1 },
                    requiresFallbackMode: function(t) {
                        var e = t.transitions,
                            n = !1;
                        return e === !1 && (n = !0), n
                    },
                    getPropertySupport: function() {
                        var t = !1,
                            e = !1;
                        return _.csstransitions === !0 && (t = !0), _.cssanimations === !0 && (e = !0), { transitions: t, animations: e }
                    }
                }, M.animationFallback = {
                    animate: function(t, e, n, i, r, o, a) {
                        if (t !== !1) {
                            var s = (new Date).getTime(),
                                l = setInterval(function() {
                                    var u = Math.min(1, ((new Date).getTime() - s) / o);
                                    t.style[e] = i + u * (r - i) + n, 1 === u && (void 0 !== a && a(), clearInterval(l))
                                }, 25);
                            t.style[e] = i + n
                        }
                    },
                    setupCanvas: function() {
                        var t, e, n;
                        if (M.isFallbackMode === !0)
                            for (f(M.$container, "seq-fallback"), void 0 !== M.$screen && (M.$screen.style.overflow = "hidden", M.$screen.style.width = "100%", M.$screen.style.height = "100%"), M.$canvas.style.width = "100%", M.$canvas.style.height = "100%", this.canvasWidth = M.$canvas.offsetWidth, t = 0; t < M.noOfSteps; t++) e = M.$steps[t], n = t + 1, f(e, "seq-in"), e.style.width = "100%", e.style.height = "100%", e.style.position = "absolute", e.style.whiteSpace = "normal", e.style.left = "100%"
                    },
                    moveCanvas: function(t, e, n, i) {
                        if (i === !0) {
                            var r = 0,
                                o = -100,
                                a = 100,
                                s = 0; - 1 === n && (o = 100, a = -100), this.animate(e, "left", "%", r, o, M.options.fallback.speed), this.animate(t, "left", "%", a, s, M.options.fallback.speed)
                        } else e.style.left = "-100%", t.style.left = "0"
                    },
                    goTo: function(t, e, n, i, r, o, a) { M.prevStepId = M.currentStepId, M.currentStepId = t, void 0 === a && M.hashTags.update(), M.pagination.update(), M.firstRun === !1 ? (this.moveCanvas(r, n, o, !0), M.isAnimating = !0, M.animationStarted(M.currentStepId, M), M.stepEndedTimer = setTimeout(function() { M.animation.stepEnded(M.currentStepId) }, M.options.fallback.speed)) : (this.moveCanvas(r, n, o, !1), M.firstRun = !1, M.options.autoPlay === !0 && M.autoPlay.start(!0)) }
                }, M.pagination = {
                    getLinks: function(t) {
                        var e, n, i = t.childNodes,
                            r = i.length,
                            o = [];
                        for (n = 0; r > n; n++) e = i[n], 1 === e.nodeType && o.push(e);
                        return o
                    },
                    update: function() {
                        if (void 0 !== M.$pagination.elements) {
                            var t, e, n, i, r = M.currentStepId - 1,
                                o = M.$pagination.elements.length;
                            if (void 0 !== M.$pagination.currentLinks)
                                for (i = M.$pagination.currentLinks.length, t = 0; i > t; t++) n = M.$pagination.currentLinks[t], p(n, "seq-current");
                            for (M.$pagination.currentLinks = [], e = 0; o > e; e++) n = M.$pagination.links[e][r], M.$pagination.currentLinks.push(n), f(n, "seq-current")
                        }
                        return M.$pagination.currentLinks
                    }
                }, M.hashTags = {
                    init: function(t) {
                        if (M.options.hashTags === !0) {
                            var e, n;
                            M.hasPushstate = !(!window.history || !history.pushState), n = location.hash.replace("#!", ""), M.stepHashTags = this.getStepHashTags(), "" !== n && (M.currentHashTag = n, e = this.hasCorrespondingStep(M.currentHashTag), e > -1 && (t = e + 1))
                        }
                        return t
                    },
                    hasCorrespondingStep: function(t) {
                        var e = -1,
                            n = M.stepHashTags.indexOf(t);
                        return n > -1 && (e = n), e
                    },
                    getStepHashTags: function() { var t, e, n = []; for (t = 0; t < M.noOfSteps; t++) e = M.options.hashDataAttribute === !1 ? M.$steps[t].id : M.$steps[t].getAttribute("data-seq-hashtag"), n.push(e); return n },
                    update: function() {
                        if (M.options.hashTags === !0 && M.firstRun === !1 || M.options.hashTags === !0 && M.firstRun === !0 && M.options.hashChangesOnFirstStep === !0) {
                            var t = M.currentStepId - 1;
                            M.currentHashTag = M.stepHashTags[t], "" !== M.currentHashtag && (M.hasPushstate === !0 ? history.pushState(null, null, "#!" + M.currentHashTag) : location.hash = "#!" + M.currentHashTag)
                        }
                    },
                    setupEvent: function() {
                        if ("onhashchange" in window) { if (window.addEventListener) return window.addHashChange = function(t, e) { window.addEventListener("hashchange", t, e) }, void(window.removeHashChange = function(t) { window.removeEventListener("hashchange", t) }); if (window.attachEvent) return window.addHashChange = function(t) { window.attachEvent("onhashchange", t) }, void(window.removeHashChange = function(t) { window.detachEvent("onhashchange", t) }) }
                        var t = [],
                            e = location.href;
                        window.addHashChange = function(e, n) { "function" == typeof e && t[n ? "unshift" : "push"](e) }, window.removeHashChange = function(e) { for (var n = t.length - 1; n >= 0; n--) t[n] === e && t.splice(n, 1) }, setInterval(function() {
                            var n = location.href;
                            if (e !== n) {
                                var i = e;
                                e = n;
                                for (var r = 0; r < t.length; r++) t[r].call(window, { type: "hashchange", newURL: n, oldURL: i })
                            }
                        }, 100)
                    }
                }, M.preload = {
                    defaultHtml: '<svg width="39" height="16" viewBox="0 0 39 16" xmlns="http://www.w3.org/2000/svg" class="seq-preload-indicator"><title>Sequence.js Preloading Indicator</title><desc>Three orange dots increasing in size from left to right</desc><g fill="#F96D38"><path class="seq-preload-circle seq-preload-circle-1" d="M3.999 12.012c2.209 0 3.999-1.791 3.999-3.999s-1.79-3.999-3.999-3.999-3.999 1.791-3.999 3.999 1.79 3.999 3.999 3.999z"/><path class="seq-preload-circle seq-preload-circle-2" d="M15.996 13.468c3.018 0 5.465-2.447 5.465-5.466 0-3.018-2.447-5.465-5.465-5.465-3.019 0-5.466 2.447-5.466 5.465 0 3.019 2.447 5.466 5.466 5.466z"/><path class="seq-preload-circle seq-preload-circle-3" d="M31.322 15.334c4.049 0 7.332-3.282 7.332-7.332 0-4.049-3.282-7.332-7.332-7.332s-7.332 3.283-7.332 7.332c0 4.05 3.283 7.332 7.332 7.332z"/></g></svg>',
                    fallbackHtml: '<div class="seq-preload-indicator seq-preload-indicator-fallback"><div class="seq-preload-circle seq-preload-circle-1"></div><div class="seq-preload-circle seq-preload-circle-2"></div><div class="seq-preload-circle seq-preload-circle-3"></div></div>',
                    defaultStyles: "@" + S.animation[_.prefixed("animation")] + "keyframes seq-preloader {50% {opacity: 1;}100% {opacity: 0;}}.seq-preloader {background: white;visibility: visible;opacity: 1;position: absolute;z-index: 9999;height: 100%;width: 100%;top: 0;left: 0;right: 0;bottom: 0;} .seq-preloader.seq-preloaded {opacity: 0;visibility: hidden;" + _.prefixed("transition") + ": visibility 0s .5s, opacity .5s;}.seq-preload-indicator {overflow: visible;position: relative;top: 50%;left: 50%;-webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);}.seq-preload-circle {display: inline-block;height: 12px;width: 12px;fill: #F96D38;opacity: 0;" + S.animation[_.prefixed("animation")] + "animation: seq-preloader 1.25s infinite;}.seq-preload-circle-2 {" + S.animation[_.prefixed("animation")] + "animation-delay: .15s;}.seq-preload-circle-3 {" + S.animation[_.prefixed("animation")] + "animation-delay: .3s;}.seq-preload-indicator-fallback{width: 42px;margin-left: -21px;overflow: visible;}.seq-preload-indicator-fallback .seq-preload-circle {width: 8px; height:8px;background-color: #F96D38;border-radius: 100%; opacity: 1;display: inline-block; vertical-align: middle;}.seq-preload-indicator-fallback .seq-preload-circle-2{margin-left: 3px; margin-right: 3px; width: 12px; height: 12px;}.seq-preload-indicator-fallback .seq-preload-circle-3{width: 16px; height: 16px;}",
                    init: function(e) { if (M.options.preloader !== !1) { var n, i, r, o, a, s, l = this; return f(M.$container, "seq-preloading"), M.$preloader = M.ui.getElements("preloader", M.options.preloader), l.append(), l.addStyles(), l.toggleStepsVisibility("hide"), n = l.getImagesToPreload(M.options.preloadTheseSteps), i = l.getImagesToPreload(M.options.preloadTheseImages, !0), r = n.concat(i), o = t(r), o.on("always", function() { l.complete(e) }), a = 1, o.on("progress", function(t, e) { s = e.isLoaded ? "loaded" : "broken", M.preloadProgress(s, e.img.src, a++, r.length, M) }), !0 } return !1 },
                    complete: function(t) { M.preloaded(M), M.options.pausePreloader !== !0 && (this.toggleStepsVisibility("show"), p(M.$container, "seq-preloading"), f(M.$container, "seq-preloaded"), f(M.$preloader[0], "seq-preloaded"), void 0 !== this.preloadIndicatorTimer && clearInterval(this.preloadIndicatorTimer), (_.prefixed("animation") === !1 || _.svg === !1) && (M.$preloader[0].style.display = "none"), void 0 !== t && t()) },
                    addStyles: function() {
                        if (M.options.preloader === !0) {
                            var t = document.head || document.getElementsByTagName("head")[0];
                            if (this.styleElement = document.createElement("style"), this.styleElement.type = "text/css", this.styleElement.styleSheet ? this.styleElement.styleSheet.cssText = this.defaultStyles : this.styleElement.appendChild(document.createTextNode(this.defaultStyles)), t.appendChild(this.styleElement), _.prefixed("animation") === !1 || _.svg === !1) {
                                var e = M.$preloader[0].firstChild,
                                    n = function() { e.style.visibility = "hidden", preloadFlashTime = 1e3, setTimeout(function() { e.style.visibility = "visible" }, 500) };
                                n(), this.preloadIndicatorTimer = setInterval(function() { n() }, 1e3)
                            }
                            return !0
                        }
                        return !1
                    },
                    removeStyles: function() { this.styleElement.parentNode.removeChild(this.styleElement) },
                    getImagesToPreload: function(t, e) {
                        var n = [];
                        if (a(t) === !0) {
                            var i, r, o, s, l, u, c, d, h = t.length;
                            if (e !== !0)
                                for (i = 0; h > i; i++)
                                    for (o = M.$steps[i], s = o.getElementsByTagName("img"), l = s.length, r = 0; l > r; r++) u = s[r], n.push(u);
                            else
                                for (c = [], i = 0; h > i; i++) d = t[i], c[i] = new Image, c[i].src = d, n.push(c[i])
                        }
                        return n
                    },
                    append: function() { return M.options.preloader === !0 && (M.$preloader = document.createElement("div"), M.$preloader.className = "seq-preloader", M.$preloader = [M.$preloader], M.$preloader[0].innerHTML = _.prefixed("animation") !== !1 && _.svg === !0 ? M.preload.defaultHtml : M.preload.fallbackHtml, M.$container.insertBefore(M.$preloader[0], null), !0) },
                    toggleStepsVisibility: function(t) { if (M.options.hideStepsUntilPreloaded === !0) { var e, n; for (e = 0; e < M.noOfSteps; e++) n = M.$steps[e], "hide" === t ? M.ui.hide(n, 0) : M.ui.show(n, 0); return !0 } return !1 }
                }, M.manageEvents = {
                    list: { load: [], click: [], touchstart: [], mousemove: [], mouseleave: [], hammer: [], keyup: [], hashchange: [], resize: [] },
                    init: function() { return M.manageEvents.list[C] = [], M.options.hashTags === !0 && this.add.hashChange(), M.options.swipeNavigation === !0 ? this.add.swipeNavigation() : M.hammerTime = !1, M.options.keyNavigation === !0 && this.add.keyNavigation(), this.add.resizeThrottle(), this.add.pageVisibility(), M.options.nextButton !== !1 && (M.$next = M.ui.getElements("nextButton", M.options.nextButton), this.add.button(M.$next, "nav", M.next)), M.options.prevButton !== !1 && (M.$prev = M.ui.getElements("prevButton", M.options.prevButton), this.add.button(M.$prev, "nav", M.prev)), M.options.autoPlayButton !== !1 && (M.$autoPlay = M.ui.getElements("autoPlayButton", M.options.autoPlayButton), this.add.button(M.$autoPlay, "nav", M.toggleAutoPlay)), this.add.stopOnHover(), M.options.pagination !== !1 && (M.$pagination = {}, M.$pagination.relatedElementId = i, M.$pagination.links = [], M.$pagination.elements = M.ui.getElements("pagination", M.options.pagination), this.add.button(M.$pagination.elements, "pagination")), null },
                    removeAll: function(t) { var e, n; for (e in t) t.hasOwnProperty(e) === !0 && (n = t[e], this.remove(e)); return null },
                    remove: function(t) {
                        var e = M.manageEvents.list[t],
                            n = e.length;
                        switch (t) {
                            case "hashchange":
                                M.options.hashTags === !0 && removeHashChange(e[0].handler);
                                break;
                            case "hammer":
                                if (M.manageEvents.list.hammer.length > 0 && void 0 !== document.querySelectorAll) {
                                    var i = M.manageEvents.list.hammer[0].handler;
                                    M.hammerTime.off("swipe", [i])
                                }
                                break;
                            default:
                                for (var r = 0; n > r; r++) {
                                    var o = e[r];
                                    c(o.element, t, o.handler)
                                }
                        }
                    },
                    add: {
                        hashChange: function() {
                            M.hashTags.setupEvent();
                            var t = function(t) {
                                var e, n;
                                e = t.newURL || location.href, e = e.split("#!")[1], M.currentHashTag !== e && (n = M.stepHashTags.indexOf(e) + 1, M.currentHashTag = e, M.goTo(n, void 0, void 0, !0))
                            };
                            return addHashChange(t), M.manageEvents.list.hashchange.push({ element: window, handler: t }), M.manageEvents.list.hashchange
                        },
                        button: function(t, e, n) {
                            var i, r, o, a, s, l, c, d = t.length;
                            switch (e) {
                                case "nav":
                                    o = function(t) { i = u(t, "click", function(t) { t || (t = window.event), t.preventDefault ? t.preventDefault() : t.returnValue = !1, n() }) };
                                    break;
                                case "pagination":
                                    o = function(t, e) {
                                        i = u(t, "click", function(t) {
                                            t || (t = window.event), t.preventDefault ? t.preventDefault() : t.returnValue = !1;
                                            var e = t.target || t.srcElement;
                                            a = this, l = v(a, e), M.goTo(l)
                                        }), M.$pagination.links.push(M.pagination.getLinks(t, e))
                                    }
                            }
                            for (c = 0; d > c; c++) r = t[c], s = r.getAttribute("rel"), s === M.$container.id && null === r.getAttribute("data-seq-button") ? (r.setAttribute("data-seq-button", !0), o(r, s)) : null === s && null === r.getAttribute("data-seq-button") && o(r, s), M.manageEvents.list.click.push({ element: r, handler: i });
                            return M.manageEvents.list.click
                        },
                        stopOnHover: function() { var t, e; return M.isMouseOver = !1, t = u(M.$container, "touchstart", function() { M.isTouched = !0 }), M.manageEvents.list.touchstart.push({ element: M.$container, handler: t }), e = u(M.$container, "mousemove", function(t) { return t = t || window.event, M.isTouched === !0 ? void(M.isTouched = !1) : void(g(M.$container, t) === !0 ? (M.options.autoPlayPauseOnHover === !0 && M.isMouseOver === !1 && M.autoPlay.pause(), M.isMouseOver = !0) : (M.options.autoPlayPauseOnHover === !0 && M.isMouseOver === !0 && M.autoPlay.unpause(), M.isMouseOver = !1)) }), M.manageEvents.list.mousemove.push({ element: M.$container, handler: e }), e = u(M.$container, "mouseleave", function() { M.options.autoPlayPauseOnHover === !0 && M.autoPlay.unpause(), M.isMouseOver = !1 }), M.manageEvents.list.mouseleave.push({ element: M.$container, handler: e }), null },
                        swipeNavigation: function() {
                            if (void 0 === window.addEventListener) return void(M.hammerTime = !1);
                            var t, n;
                            "function" == typeof e && (n = function(t) {
                                switch (t.direction) {
                                    case 2:
                                        M.options.swipeEvents.left(M);
                                        break;
                                    case 4:
                                        M.options.swipeEvents.right(M);
                                        break;
                                    case 8:
                                        M.options.swipeEvents.up(M);
                                        break;
                                    case 16:
                                        M.options.swipeEvents.down(M)
                                }
                            }, M.hammerTime = new e(M.$container).on("swipe", n), M.hammerTime.get("swipe").set(M.options.swipeHammerOptions), t = m(M.options.swipeEvents), M.hammerTime.get("swipe").set({ direction: t }), M.manageEvents.list.hammer.push({ element: M.$container, handler: n }))
                        },
                        keyNavigation: function() {
                            var t = u(document, "keyup", function(t) {
                                t || (t = window.event);
                                var e = parseInt(String.fromCharCode(t.keyCode));
                                switch (e > 0 && e <= M.noOfSteps && M.options.numericKeysGoToSteps && M.goTo(e), t.keyCode) {
                                    case 37:
                                        M.options.keyEvents.left(M);
                                        break;
                                    case 39:
                                        M.options.keyEvents.right(M)
                                }
                            });
                            M.manageEvents.list.keyup.push({ element: document, handler: t })
                        },
                        resizeThrottle: function() {
                            function t() { setTimeout(function() { M.canvas.getTransformProperties(), M.propertySupport.transitions === !0 && M.canvas.move(M.currentStepId, !1) }, 500), M.throttledResize(M) }
                            var e, n;
                            n = u(window, "resize", function() { clearTimeout(e), e = setTimeout(t, k) }), M.manageEvents.list.resize.push({ element: window, handler: n })
                        },
                        pageVisibility: function() {
                            var t = u(document, C, function() { document[T] ? M.autoPlay.pause() : M.autoPlay.unpause() }, !1);
                            M.manageEvents.list[C].push({ element: document, handler: t })
                        }
                    }
                }, M.init = function(e) {
                    var n, i, r, a;
                    M.options = s(x, o), M.isAnimating = !1, M.isReady = !1, M.$container = e, M.$screen = M.$container.querySelectorAll(".seq-screen")[0], M.$canvas = M.$container.querySelectorAll(".seq-canvas")[0], M.$steps = M.canvas.getSteps(M.$canvas), M.noOfSteps = M.$steps.length, M.phasesAnimating = 0, M.phasesSkipped = [], y(M.$container, _), n = M.options.startingStepId, f(M.$container, "seq-active"), M.propertySupport = M.animation.getPropertySupport(), M.isFallbackMode = M.animation.requiresFallbackMode(M.propertySupport), M.canvas.init(n), M.canvas.removeNoJsClass(M), M.manageEvents.init(), M.autoPlay.init(), M.firstRun = !0, n = M.hashTags.init(n), 1 === M.options.autoPlayDirection ? (r = n - 1, M.prevStepId = 1 > r ? M.noOfSteps : r) : (r = n + 1, M.prevStepId = r > M.noOfSteps ? 1 : r), M.currentStepId = M.prevStepId, i = M.prevStepId, M.animationFallback.setupCanvas(n), a = function() { M.animation.domDelay(function() { M.animation.domDelay(function() { M.animation.resetInheritedSpeed(i) }), M.isReady = !0, M.ready(M), M.goTo(n, M.options.autoPlayDirection, !0) }) }, M.options.preloader !== !1 && void 0 !== document.querySelectorAll && "function" == typeof t ? M.preload.init(function() { a() }) : a()
                }, M.destroy = function() { var t, e, n; for (M.autoPlay.stop(), clearTimeout(M.autoPlayTimer), clearTimeout(M.phaseThresholdTimer), clearTimeout(M.stepEndedTimer), clearTimeout(M.currentPhaseEndedTimer), clearTimeout(M.nextPhaseStartedTimer), clearTimeout(M.nextPhaseEndedTimer), clearTimeout(M.fadeStepTimer), clearTimeout(M.hideTimer), clearTimeout(M.navigationSkipThresholdTimer), M.manageEvents.removeAll(M.manageEvents.list), p(M.$pagination.currentLinks, "seq-current"), p(M.$container, "seq-step" + M.currentStepId), p(M.$container, "seq-active"), M.$container.removeAttribute("style"), void 0 !== M.$screen && M.$screen.removeAttribute("style"), M.$canvas.removeAttribute("style"), t = 0; t < M.noOfSteps; t++) e = M.$steps[t], e.removeAttribute("style"), M.animation.resetInheritedSpeed(t + 1), p(e, "seq-in"), p(e, "seq-out"); return n = M.$steps[M.options.startingStepId - 1], M.animation.resetInheritedSpeed(M.options.startingStepId), f(n, "seq-in"), r.removeAttribute("data-seq-enabled"), M.destroyed(M), M = null }, M.next = function() { var t = M.currentStepId + 1; return !(t > M.noOfSteps && M.options.cycle === !1) && (t > M.noOfSteps && (t = 1), M.goTo(t), t) }, M.prev = function() { var t, e = M.currentStepId - 1; return !(1 > e && M.options.cycle === !1) && (1 > e && (e = M.noOfSteps), M.options.reverseWhenNavigatingBackwards === !0 && (t = -1), M.goTo(e, t), e) }, M.toggleAutoPlay = function(t) { return M.isAutoPlaying === !1 ? M.start(t) : M.stop(), M.isAutoPlaying }, M.stop = function() { M.autoPlay.stop() }, M.start = function(t) { M.autoPlay.start(t) }, M.goTo = function(t, e, n, i) { if (e = M.animation.getDirection(t, e, M.currentStepId, M.noOfSteps, M.isFallbackMode, M.options.reverseWhenNavigatingBackwards, M.options.cycle), void 0 === t || 1 > t || t > M.noOfSteps || t === M.currentStepId || M.options.navigationSkip === !1 && M.isAnimating === !0 || M.options.navigationSkip === !0 && M.navigationSkipThresholdActive === !0 && void 0 === i || M.isFallbackMode === !0 && M.isAnimating === !0 && void 0 === i || M.options.preventReverseSkipping === !0 && M.direction !== e && M.isAnimating === !0) return !1; var r, o; return clearTimeout(M.autoPlayTimer), M.direction = e, 1 === e ? p(M.$container, "seq-reversed") : f(M.$container, "seq-reversed"), r = M.$steps[M.currentStepId - 1], o = M.$steps[t - 1], M.animation.moveActiveStepToTop(r, o), M.animation.changeStep(t), M.isFallbackMode === !1 ? (M.animation.resetInheritedSpeed(t), (M.firstRun === !1 || M.firstRun === !0 && M.options.startingStepAnimatesIn === !0) && M.animationStarted(t, M), M.canvas.move(t, !0), M.animation.manageNavigationSkip(t, o), 1 === e ? M.animation.forward(t, r, o, n, i) : M.animation.reverse(t, r, o, n, i)) : M.animationFallback.goTo(t, M.currentStepId, r, t, o, e, i), !0 }, M.started = function() {}, M.stopped = function() {}, M.animationStarted = function() {}, M.animationEnded = function() {}, M.currentPhaseStarted = function() {}, M.currentPhaseEnded = function() {}, M.nextPhaseStarted = function() {}, M.nextPhaseEnded = function() {}, M.throttledResize = function() {}, M.preloaded = function() {}, M.preloadProgress = function() {}, M.ready = function() {}, M.destroyed = function() {}, M.utils = { addClass: f, removeClass: p, addEvent: u, removeEvent: c }, M.init(r), n.push(M), M
            };
        return r
    }
    var r, o, a;
    o = [n(310), n(89)], r = i, a = "function" == typeof r ? r.apply(e, o) : r, !(void 0 !== a && (t.exports = a))
}, function(t, e, n) {
    var i;
    ! function() {
        "use strict";

        function r(t) {
            var e;
            e = "function" == typeof t ? t : t ? a(t) : Math.random, this.p = o(e), this.perm = new Uint8Array(512), this.permMod12 = new Uint8Array(512);
            for (var n = 0; n < 512; n++) this.perm[n] = this.p[255 & n], this.permMod12[n] = this.perm[n] % 12
        }

        function o(t) {
            var e, n = new Uint8Array(256);
            for (e = 0; e < 256; e++) n[e] = e;
            for (e = 0; e < 255; e++) {
                var i = e + ~~(t() * (256 - e)),
                    r = n[e];
                n[e] = n[i], n[i] = r
            }
            return n
        }

        function a() {
            var t = 0,
                e = 0,
                n = 0,
                i = 1,
                r = s();
            t = r(" "), e = r(" "), n = r(" ");
            for (var o = 0; o < arguments.length; o++) t -= r(arguments[o]), t < 0 && (t += 1), e -= r(arguments[o]), e < 0 && (e += 1), n -= r(arguments[o]), n < 0 && (n += 1);
            return r = null,
                function() { var r = 2091639 * t + 2.3283064365386963e-10 * i; return t = e, e = n, n = r - (i = 0 | r) }
        }

        function s() {
            var t = 4022871197;
            return function(e) {
                e = e.toString();
                for (var n = 0; n < e.length; n++) {
                    t += e.charCodeAt(n);
                    var i = .02519603282416938 * t;
                    t = i >>> 0, i -= t, i *= t, t = i >>> 0, i -= t, t += 4294967296 * i
                }
                return 2.3283064365386963e-10 * (t >>> 0)
            }
        }
        var l = .5 * (Math.sqrt(3) - 1),
            u = (3 - Math.sqrt(3)) / 6,
            c = 1 / 3,
            d = 1 / 6,
            h = (Math.sqrt(5) - 1) / 4,
            f = (5 - Math.sqrt(5)) / 20;
        r.prototype = {
            grad3: new Float32Array([1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1, 0, 1, 0, 1, -1, 0, 1, 1, 0, -1, -1, 0, -1, 0, 1, 1, 0, -1, 1, 0, 1, -1, 0, -1, -1]),
            grad4: new Float32Array([0, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 1, 0, 1, 1, 1, 0, 1, -1, 1, 0, -1, 1, 1, 0, -1, -1, -1, 0, 1, 1, -1, 0, 1, -1, -1, 0, -1, 1, -1, 0, -1, -1, 1, 1, 0, 1, 1, 1, 0, -1, 1, -1, 0, 1, 1, -1, 0, -1, -1, 1, 0, 1, -1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, -1, 1, 1, 1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, -1, 0, -1, 1, 1, 0, -1, 1, -1, 0, -1, -1, 1, 0, -1, -1, -1, 0]),
            noise2D: function(t, e) {
                var n, i, r = this.permMod12,
                    o = this.perm,
                    a = this.grad3,
                    s = 0,
                    c = 0,
                    d = 0,
                    h = (t + e) * l,
                    f = Math.floor(t + h),
                    p = Math.floor(e + h),
                    g = (f + p) * u,
                    v = f - g,
                    m = p - g,
                    y = t - v,
                    b = e - m;
                y > b ? (n = 1, i = 0) : (n = 0, i = 1);
                var x = y - n + u,
                    w = b - i + u,
                    k = y - 1 + 2 * u,
                    S = b - 1 + 2 * u,
                    _ = 255 & f,
                    T = 255 & p,
                    C = .5 - y * y - b * b;
                if (C >= 0) {
                    var M = 3 * r[_ + o[T]];
                    C *= C, s = C * C * (a[M] * y + a[M + 1] * b)
                }
                var A = .5 - x * x - w * w;
                if (A >= 0) {
                    var E = 3 * r[_ + n + o[T + i]];
                    A *= A, c = A * A * (a[E] * x + a[E + 1] * w)
                }
                var P = .5 - k * k - S * S;
                if (P >= 0) {
                    var I = 3 * r[_ + 1 + o[T + 1]];
                    P *= P, d = P * P * (a[I] * k + a[I + 1] * S)
                }
                return 70 * (s + c + d)
            },
            noise3D: function(t, e, n) {
                var i, r, o, a, s, l, u, h, f, p, g = this.permMod12,
                    v = this.perm,
                    m = this.grad3,
                    y = (t + e + n) * c,
                    b = Math.floor(t + y),
                    x = Math.floor(e + y),
                    w = Math.floor(n + y),
                    k = (b + x + w) * d,
                    S = b - k,
                    _ = x - k,
                    T = w - k,
                    C = t - S,
                    M = e - _,
                    A = n - T;
                C >= M ? M >= A ? (s = 1, l = 0, u = 0, h = 1, f = 1, p = 0) : C >= A ? (s = 1, l = 0, u = 0, h = 1, f = 0, p = 1) : (s = 0, l = 0, u = 1, h = 1, f = 0, p = 1) : M < A ? (s = 0, l = 0, u = 1, h = 0, f = 1, p = 1) : C < A ? (s = 0, l = 1, u = 0, h = 0, f = 1, p = 1) : (s = 0, l = 1, u = 0, h = 1, f = 1, p = 0);
                var E = C - s + d,
                    P = M - l + d,
                    I = A - u + d,
                    z = C - h + 2 * d,
                    D = M - f + 2 * d,
                    O = A - p + 2 * d,
                    L = C - 1 + 3 * d,
                    $ = M - 1 + 3 * d,
                    N = A - 1 + 3 * d,
                    R = 255 & b,
                    q = 255 & x,
                    F = 255 & w,
                    H = .6 - C * C - M * M - A * A;
                if (H < 0) i = 0;
                else {
                    var B = 3 * g[R + v[q + v[F]]];
                    H *= H, i = H * H * (m[B] * C + m[B + 1] * M + m[B + 2] * A)
                }
                var W = .6 - E * E - P * P - I * I;
                if (W < 0) r = 0;
                else {
                    var j = 3 * g[R + s + v[q + l + v[F + u]]];
                    W *= W, r = W * W * (m[j] * E + m[j + 1] * P + m[j + 2] * I)
                }
                var Y = .6 - z * z - D * D - O * O;
                if (Y < 0) o = 0;
                else {
                    var U = 3 * g[R + h + v[q + f + v[F + p]]];
                    Y *= Y, o = Y * Y * (m[U] * z + m[U + 1] * D + m[U + 2] * O)
                }
                var V = .6 - L * L - $ * $ - N * N;
                if (V < 0) a = 0;
                else {
                    var X = 3 * g[R + 1 + v[q + 1 + v[F + 1]]];
                    V *= V, a = V * V * (m[X] * L + m[X + 1] * $ + m[X + 2] * N)
                }
                return 32 * (i + r + o + a)
            },
            noise4D: function(t, e, n, i) {
                var r, o, a, s, l, u = this.perm,
                    c = this.grad4,
                    d = (t + e + n + i) * h,
                    p = Math.floor(t + d),
                    g = Math.floor(e + d),
                    v = Math.floor(n + d),
                    m = Math.floor(i + d),
                    y = (p + g + v + m) * f,
                    b = p - y,
                    x = g - y,
                    w = v - y,
                    k = m - y,
                    S = t - b,
                    _ = e - x,
                    T = n - w,
                    C = i - k,
                    M = 0,
                    A = 0,
                    E = 0,
                    P = 0;
                S > _ ? M++ : A++, S > T ? M++ : E++, S > C ? M++ : P++, _ > T ? A++ : E++, _ > C ? A++ : P++, T > C ? E++ : P++;
                var I, z, D, O, L, $, N, R, q, F, H, B;
                I = M >= 3 ? 1 : 0, z = A >= 3 ? 1 : 0, D = E >= 3 ? 1 : 0, O = P >= 3 ? 1 : 0, L = M >= 2 ? 1 : 0, $ = A >= 2 ? 1 : 0, N = E >= 2 ? 1 : 0, R = P >= 2 ? 1 : 0, q = M >= 1 ? 1 : 0, F = A >= 1 ? 1 : 0, H = E >= 1 ? 1 : 0, B = P >= 1 ? 1 : 0;
                var W = S - I + f,
                    j = _ - z + f,
                    Y = T - D + f,
                    U = C - O + f,
                    V = S - L + 2 * f,
                    X = _ - $ + 2 * f,
                    Z = T - N + 2 * f,
                    K = C - R + 2 * f,
                    G = S - q + 3 * f,
                    J = _ - F + 3 * f,
                    Q = T - H + 3 * f,
                    tt = C - B + 3 * f,
                    et = S - 1 + 4 * f,
                    nt = _ - 1 + 4 * f,
                    it = T - 1 + 4 * f,
                    rt = C - 1 + 4 * f,
                    ot = 255 & p,
                    at = 255 & g,
                    st = 255 & v,
                    lt = 255 & m,
                    ut = .6 - S * S - _ * _ - T * T - C * C;
                if (ut < 0) r = 0;
                else {
                    var ct = u[ot + u[at + u[st + u[lt]]]] % 32 * 4;
                    ut *= ut, r = ut * ut * (c[ct] * S + c[ct + 1] * _ + c[ct + 2] * T + c[ct + 3] * C)
                }
                var dt = .6 - W * W - j * j - Y * Y - U * U;
                if (dt < 0) o = 0;
                else {
                    var ht = u[ot + I + u[at + z + u[st + D + u[lt + O]]]] % 32 * 4;
                    dt *= dt, o = dt * dt * (c[ht] * W + c[ht + 1] * j + c[ht + 2] * Y + c[ht + 3] * U)
                }
                var ft = .6 - V * V - X * X - Z * Z - K * K;
                if (ft < 0) a = 0;
                else {
                    var pt = u[ot + L + u[at + $ + u[st + N + u[lt + R]]]] % 32 * 4;
                    ft *= ft, a = ft * ft * (c[pt] * V + c[pt + 1] * X + c[pt + 2] * Z + c[pt + 3] * K)
                }
                var gt = .6 - G * G - J * J - Q * Q - tt * tt;
                if (gt < 0) s = 0;
                else {
                    var vt = u[ot + q + u[at + F + u[st + H + u[lt + B]]]] % 32 * 4;
                    gt *= gt, s = gt * gt * (c[vt] * G + c[vt + 1] * J + c[vt + 2] * Q + c[vt + 3] * tt)
                }
                var mt = .6 - et * et - nt * nt - it * it - rt * rt;
                if (mt < 0) l = 0;
                else {
                    var yt = u[ot + 1 + u[at + 1 + u[st + 1 + u[lt + 1]]]] % 32 * 4;
                    mt *= mt, l = mt * mt * (c[yt] * et + c[yt + 1] * nt + c[yt + 2] * it + c[yt + 3] * rt)
                }
                return 27 * (r + o + a + s + l)
            }
        }, r._buildPermutationTable = o, i = function() { return r }.call(e, n, e, t), !(void 0 !== i && (t.exports = i)), e.SimplexNoise = r, t.exports = r
    }()
}, function(t, e, n) {
    var i, r, o;
    
}, , function(t, e, n) { t.exports = n(170) }, function(t, e, n) { t.exports = n(293) }, function(t, e, n) { t.exports = n(295) }, function(t, e, n) { t.exports = n(300) }, , function(t, e, n) { t.exports = n(304) }, function(t, e, n) { t.exports = n(305) }, function(t, e, n) { t.exports = n(120) }]);